module.exports = [
	{
		"hoverRegion": [
			{
				"points": [
					-16.85,
					11.68,
					-16.57,
					11.57,
					-16.4,
					11.71,
					-15.84,
					11.62,
					-15.58,
					11.88,
					-15.2,
					11.95,
					-15.11,
					12.05,
					-14.39,
					12.24,
					-14.04,
					12.25,
					-13.76,
					12.41,
					-13.37,
					12.43,
					-12.94,
					12.85,
					-12.75,
					12.86,
					-12.49,
					13.14,
					-12.47,
					13.33,
					-12.18,
					13.55,
					-11.78,
					13.68,
					-11.03,
					13.75,
					-10.77,
					13.61,
					-10.67,
					13.64,
					-10.04,
					13.22,
					-9.38,
					13.05,
					-9.09,
					12.88,
					-8.71,
					13.13,
					-8.66,
					13.28,
					-8.39,
					13.27,
					-7.31,
					12.75,
					-7.01,
					12.71,
					-6.72,
					12.47,
					-6.14,
					12.18,
					-5.99,
					12.25,
					-5.67,
					12.03,
					-5.07,
					11.91,
					-4.85,
					11.73,
					-4.61,
					11.68,
					-3.52,
					10.56,
					-3.26,
					10.42,
					-2.48,
					9.54,
					-1.92,
					9.16,
					-1.68,
					9.12,
					-0.66,
					8.59,
					-0.53,
					8.65,
					-0.64,
					8.83,
					-0.56,
					8.9,
					-0.57,
					9.04,
					-0.42,
					9.15,
					-0.01,
					9.23,
					0.52,
					9.2,
					0.72,
					9.3,
					0.89,
					9.19,
					1.03,
					9.32,
					1.19,
					9.26,
					1.94,
					9.69,
					2.53,
					9.71,
					3.06,
					9.85,
					3.77,
					9.44,
					3.85,
					9.15,
					4.03,
					8.88,
					4.41,
					8.79,
					4.4,
					8.48,
					4.51,
					8.39,
					4.43,
					8.29,
					4.27,
					7.22,
					4.18,
					6.03,
					4.41,
					5.66,
					4.84,
					5.35,
					5.35,
					5.21,
					5.89,
					4.83,
					6.2,
					4.47,
					6.32,
					3.82,
					6.12,
					1.63,
					6.21,
					1.51,
					6.35,
					1.64,
					6.63,
					1.47,
					6.99,
					1.44,
					7.09,
					1.53,
					7.5,
					1.56,
					9.01,
					1.51,
					9.49,
					1.24,
					9.94,
					1.24,
					10.31,
					0.68,
					10.49,
					0.67,
					11.04,
					0.81,
					11.35,
					1.07,
					11.39,
					1.26,
					11.57,
					1.4,
					11.5,
					1.63,
					11.53,
					1.97,
					11.87,
					2.28,
					12.32,
					1.95,
					12.54,
					2.11,
					12.6,
					2,
					12.5,
					1.87,
					12.52,
					1.53,
					13,
					0.89,
					13.45,
					0.92,
					13.64,
					0.52,
					14.08,
					0.26,
					14.28,
					0.25,
					14.48,
					0.06,
					15.01,
					0.12,
					15.09,
					0.22,
					15.08,
					0.92,
					15.37,
					1.31,
					15.47,
					2.62,
					15.45,
					3.42,
					15.57,
					3.47,
					15.77,
					3.79,
					16.33,
					3.96,
					16.95,
					3.97,
					17.05,
					4.13,
					19,
					4.13,
					18.87,
					3.26,
					19.14,
					2.99,
					19.42,
					3.15,
					19.73,
					3.12,
					19.95,
					2.38,
					20.14,
					2.19,
					20.1,
					2.06,
					20.21,
					1.72,
					20.49,
					1.54,
					20.65,
					1.09,
					21.05,
					1.05,
					21.74,
					-0.05,
					21.91,
					-0.21,
					25.37,
					-5.62,
					27.25,
					-8.77,
					28.81,
					-8.73,
					29.72,
					-7.18,
					29.7,
					-6.59,
					29.8,
					-6.49,
					29.81,
					-6.12,
					30.07,
					-5.24,
					30.22,
					-5.09,
					30.73,
					-4.87,
					31,
					-3.79,
					31.24,
					-3.91,
					31.41,
					-3.87,
					31.46,
					-3.75,
					31.67,
					-3.74,
					31.85,
					-2.98,
					32.02,
					-3.04,
					32.2,
					-2.92,
					32.28,
					-2.28,
					32.23,
					-1.33,
					32.38,
					-1.34,
					32.51,
					-1.19,
					32.67,
					-1.46,
					32.92,
					-1.64,
					33.05,
					-1.61,
					33.24,
					-1.77,
					33.56,
					-1.71,
					33.68,
					-1.84,
					34.08,
					-1.76,
					34.38,
					-1.89,
					34.48,
					-1.84,
					34.61,
					-1.95,
					34.72,
					-1.9,
					34.98,
					-2.28,
					35.12,
					-2.3,
					35.23,
					-1.8,
					35.41,
					-1.43,
					35.84,
					-1.15,
					35.84,
					-0.65,
					36.02,
					-0.36,
					35.92,
					-0.12,
					36.3,
					0.3,
					36.59,
					1.04,
					36.75,
					2.32,
					36.7,
					2.53,
					36.92,
					2.94,
					36.88,
					3.47,
					37.03,
					3.9,
					37,
					4.79,
					36.76,
					5.3,
					36.93,
					5.67,
					37.01,
					6.13,
					37.19,
					6.4,
					36.99,
					6.92,
					37.02,
					7.07,
					37.15,
					7.08,
					37.19,
					7.23,
					37.08,
					7.81,
					36.97,
					7.89,
					37.09,
					8.81,
					37.35,
					9.19,
					37.45,
					9.73,
					37.27,
					10.34,
					37.06,
					10.31,
					36.85,
					10.45,
					37.06,
					10.71,
					37.24,
					10.76,
					37.12,
					11.16,
					36.77,
					11.2,
					36.38,
					10.89,
					36.28,
					10.63,
					36.14,
					10.59,
					35.9,
					10.73,
					35.82,
					10.9,
					35.91,
					11.08,
					35.84,
					11.14,
					35.38,
					11.15,
					35.19,
					11.26,
					34.78,
					10.96,
					34.94,
					11.26,
					34.87,
					11.43,
					34.72,
					11.44,
					34.51,
					11.06,
					34.65,
					10.86,
					34.15,
					10.14,
					33.95,
					10.22,
					33.75,
					10.51,
					33.79,
					10.64,
					34,
					10.73,
					33.92,
					11.12,
					33.81,
					11.16,
					33.71,
					11.09,
					33.6,
					11.21,
					33.46,
					11.22,
					33.2,
					11.67,
					32.69,
					11.6,
					32.49,
					11.7,
					32.26,
					11.5,
					31.88,
					10.72,
					31.66,
					10.61,
					31.59,
					10.35,
					31.46,
					10.26,
					31.09,
					10.39,
					30.75,
					10.36,
					30.32,
					10.03,
					30.1,
					9.52,
					29.45,
					9.9,
					29.03,
					9.98,
					28.3,
					9.94,
					27.88,
					10.07,
					27.27,
					9.88,
					26.88,
					10.03,
					26.6,
					10.02,
					26.43,
					9.94,
					26.28,
					9.59,
					26.18,
					9.52,
					25.36,
					10.14,
					24.93,
					10.15,
					24.61,
					10.45,
					24.67,
					10.72,
					24.31,
					11.44,
					24.33,
					11.67,
					23.61,
					12.05,
					23.29,
					13.5,
					22.77,
					14.2,
					23.54,
					16.04,
					21.47,
					20.39,
					19.57,
					24.08,
					15.66,
					24.1,
					15.6,
					24.01,
					15.6,
					23.16,
					15.51,
					23.05,
					15.3,
					23.11,
					15.07,
					23.04,
					14.82,
					22.79,
					14.6,
					22.78,
					14.52,
					22.54,
					14.33,
					22.54,
					14.22,
					22.67,
					14.12,
					22.67,
					13.74,
					22.22,
					13.3,
					22.38,
					12.98,
					22.02,
					12.81,
					21.95,
					12.76,
					22.07,
					12.86,
					22.19,
					12.69,
					22.54,
					12.43,
					22.49,
					12.14,
					22.59,
					12.06,
					22.74,
					11.66,
					22.68,
					11.51,
					22.83,
					11.49,
					23.02,
					11.32,
					23.08,
					10.94,
					22.99,
					10.53,
					23.39,
					9.95,
					23.76,
					9.28,
					23.76,
					9.1,
					23.58,
					9.01,
					23.69,
					8.83,
					23.65,
					8.81,
					24.29,
					8.56,
					24.37,
					8.39,
					24.28,
					8.27,
					24.92,
					8.06,
					25.05,
					7.94,
					25.3,
					7.65,
					25.41,
					7.54,
					25.32,
					7.09,
					26.1,
					6.89,
					26.19,
					6.72,
					26.49,
					6.43,
					26.42,
					6.27,
					26.62,
					6.15,
					26.61,
					5.82,
					27.25,
					5.61,
					27.39,
					5.35,
					27.36,
					5.03,
					27.57,
					4.91,
					27.46,
					5.08,
					27.12,
					4.92,
					26.9,
					4.98,
					26.73,
					4.93,
					26.47,
					5.13,
					26.13,
					5.05,
					25.89,
					5.24,
					25.49,
					4.98,
					25.41,
					4.83,
					25.11,
					4.87,
					24.97,
					4.8,
					24.63,
					4.95,
					24.49,
					4.83,
					24.3,
					4.63,
					23.63,
					4.47,
					23.41,
					4.68,
					22.95,
					4.36,
					22.68,
					4.16,
					22.64,
					3.97,
					22.88,
					4,
					23.16,
					3.88,
					23.6,
					3.52,
					23.42,
					3.55,
					23.18,
					3.36,
					22.83,
					3.22,
					22.9,
					3.25,
					23.1,
					3.16,
					23.18,
					2.65,
					23.1,
					2.61,
					23.42,
					2.41,
					23.69,
					2.16,
					23.75,
					2.09,
					23.68,
					2.13,
					23.36,
					1.98,
					23.1,
					2.04,
					22.98,
					1.9,
					22.78,
					1.95,
					22.65,
					1.54,
					22.47,
					1.41,
					22.72,
					1.02,
					22.92,
					0.46,
					23.07,
					-0.17,
					23.51,
					-0.34,
					23.42,
					-0.36,
					23.55,
					-0.61,
					23.73,
					-0.81,
					23.53,
					-1.2,
					24,
					-1.32,
					24.39,
					-1.8,
					24.52,
					-1.89,
					24.42,
					-1.87,
					23.89,
					-2.11,
					23.75,
					-2.19,
					23.23,
					-2.05,
					23.05,
					-2.07,
					22.91,
					-1.94,
					22.65,
					-2.06,
					22.53,
					-2.03,
					22.29,
					-2.45,
					22.36,
					-2.56,
					22.31,
					-2.46,
					22.08,
					-2.63,
					21.85,
					-2.49,
					21.54,
					-2.59,
					21.44,
					-2.59,
					21.08,
					-3.32,
					20.76,
					-4.18,
					20.77,
					-4.49,
					20.38,
					-4.46,
					20.22,
					-4.76,
					20.16,
					-5.15,
					20.3,
					-5.73,
					20.27,
					-6.02,
					20.09,
					-6.23,
					19.8,
					-6.54,
					19.84,
					-6.88,
					20.02,
					-6.8,
					20.62,
					-6.88,
					20.72,
					-7.17,
					20.67,
					-7.21,
					21.86,
					-7.53,
					21.96,
					-7.93,
					21.86,
					-8.51,
					22.06,
					-9.41,
					21.9,
					-9.59,
					21.97,
					-9.89,
					22.29,
					-10.35,
					22.43,
					-10.75,
					22.44,
					-10.91,
					22.29,
					-11.06,
					22.33,
					-10.92,
					22.54,
					-11,
					23.06,
					-10.82,
					23.42,
					-10.91,
					23.8,
					-10.78,
					23.99,
					-10.92,
					24.12,
					-11.38,
					24.19,
					-11.67,
					24.08,
					-12.09,
					24.09,
					-12.4,
					24.18,
					-12.8,
					24.02,
					-12.96,
					24.14,
					-13.07,
					24.11,
					-13.11,
					22.1,
					-16.17,
					22.1,
					-16.43,
					22.23,
					-17.09,
					22.88,
					-17.56,
					23.49,
					-17.7,
					23.51,
					-18.13,
					21.46,
					-18.04,
					21.21,
					-18.15,
					20.81,
					-17.97,
					20.3,
					-18.02,
					19.75,
					-17.93,
					18.9,
					-17.73,
					18.56,
					-17.5,
					18.36,
					-17.54,
					13.95,
					-17.22,
					13.44,
					-17.11,
					13.38,
					-17.07,
					13.15,
					-17.35,
					12.56,
					-17.34,
					12.24,
					-17.26,
					12.07,
					-17.37,
					11.79,
					-17.29,
					11.69,
					-16.85,
					11.68
				]
			},
			{
				"points": [
					3.15,
					8.77,
					3.11,
					8.66,
					3.19,
					8.4,
					3.29,
					8.33,
					3.49,
					8.35,
					3.87,
					8.65,
					3.85,
					8.93,
					3.77,
					9.02,
					3.58,
					9.02,
					3.15,
					8.77
				]
			},
			{
				"points": [
					-1.53,
					5.68,
					-1.5,
					5.52,
					-1.3,
					5.56,
					-1.37,
					5.72,
					-1.53,
					5.68
				]
			},
			{
				"points": [
					37.4,
					8.92,
					37.55,
					8.79,
					37.63,
					8.99,
					37.5,
					9.05,
					37.4,
					8.92
				]
			}
		],
		"transitions": [
			[
				0,
				60,
				[
					"WAT",
					"CET"
				]
			]
		],
		"name": "Africa/Algiers"
	},
	{
		"hoverRegion": [
			{
				"points": [
					59.7,
					-43.57,
					59.66,
					-43.92,
					59.89,
					-44.69,
					59.88,
					-45.28,
					60.26,
					-45.58,
					60.45,
					-46.1,
					60.41,
					-46.26,
					60.54,
					-46.33,
					60.7,
					-47.53,
					60.6,
					-47.64,
					60.56,
					-47.94,
					60.79,
					-48.47,
					60.93,
					-48.51,
					60.94,
					-48.67,
					61.1,
					-48.77,
					61.15,
					-49.03,
					61.29,
					-49.05,
					61.67,
					-49.68,
					62.07,
					-49.86,
					62.41,
					-50.4,
					62.54,
					-50.41,
					62.88,
					-50.69,
					63.04,
					-51.15,
					63.34,
					-51.32,
					63.35,
					-51.46,
					63.66,
					-51.65,
					63.9,
					-51.99,
					64.05,
					-51.96,
					63.91,
					-52.08,
					63.93,
					-52.24,
					64.7,
					-52.26,
					64.85,
					-52.34,
					64.95,
					-52.6,
					65.15,
					-52.64,
					65.34,
					-52.96,
					65.36,
					-53.27,
					65.53,
					-53.38,
					65.7,
					-53.37,
					65.94,
					-53.62,
					65.99,
					-53.99,
					66.16,
					-53.99,
					66.14,
					-53.77,
					66.34,
					-53.87,
					66.67,
					-53.66,
					66.78,
					-53.72,
					66.89,
					-53.97,
					67.1,
					-54.1,
					67.51,
					-53.84,
					67.96,
					-53.94,
					68.35,
					-53.82,
					68.42,
					-53.63,
					68.67,
					-53.64,
					68.73,
					-53.5,
					68.63,
					-53.4,
					68.65,
					-53.3,
					68.87,
					-52.99,
					68.8,
					-52.08,
					68.92,
					-52.07,
					68.96,
					-51.9,
					68.91,
					-51.69,
					68.8,
					-51.66,
					68.72,
					-51.75,
					68.63,
					-51.71,
					68.64,
					-51.58,
					68.75,
					-51.56,
					68.78,
					-51.41,
					69.24,
					-51.25,
					69.42,
					-51.09,
					69.45,
					-51.32,
					69.86,
					-51.53,
					69.93,
					-52.1,
					69.89,
					-51.93,
					69.61,
					-51.74,
					69.35,
					-52.21,
					69.12,
					-53.55,
					69.3,
					-54.32,
					69.45,
					-54.44,
					69.53,
					-54.86,
					69.68,
					-55.07,
					70.04,
					-54.9,
					70.27,
					-54.92,
					70.3,
					-55.05,
					70.5,
					-55.13,
					70.57,
					-55.01,
					70.5,
					-54.62,
					70.38,
					-54.54,
					70.43,
					-54.36,
					70.59,
					-54.7,
					70.7,
					-54.72,
					70.94,
					-54.13,
					70.88,
					-52.96,
					70.75,
					-52.27,
					70.81,
					-52.25,
					70.88,
					-52.43,
					71.04,
					-52.43,
					71.04,
					-52.98,
					71.14,
					-53.21,
					71.3,
					-53.3,
					71.43,
					-53.26,
					71.47,
					-53.48,
					71.65,
					-53.58,
					71.48,
					-53.77,
					71.38,
					-53.71,
					71.39,
					-53.52,
					71.11,
					-53.26,
					71.01,
					-53.33,
					70.92,
					-53.67,
					71.08,
					-54.1,
					71.33,
					-53.94,
					71.28,
					-55.18,
					71.34,
					-55.5,
					71.57,
					-55.77,
					71.61,
					-55.94,
					71.71,
					-55.99,
					71.81,
					-55.86,
					71.96,
					-55.86,
					72.01,
					-56.04,
					72.14,
					-56.16,
					72.39,
					-56.03,
					72.44,
					-55.93,
					72.43,
					-56.08,
					72.62,
					-56.27,
					72.66,
					-56.49,
					72.99,
					-56.61,
					73.08,
					-56.38,
					73.15,
					-56.48,
					73.35,
					-56.53,
					73.53,
					-57.12,
					73.64,
					-57.18,
					73.74,
					-57.05,
					73.91,
					-57.03,
					74.02,
					-57.12,
					74.04,
					-57.4,
					74.18,
					-57.37,
					74.25,
					-57.07,
					74.32,
					-57.13,
					74.29,
					-57.31,
					74.41,
					-57.61,
					74.55,
					-57.62,
					74.6,
					-57.46,
					74.64,
					-57.43,
					74.6,
					-57.65,
					74.49,
					-57.75,
					74.53,
					-57.89,
					74.78,
					-57.92,
					74.86,
					-57.64,
					74.89,
					-57.87,
					74.79,
					-57.94,
					74.75,
					-58.22,
					74.88,
					-58.27,
					74.94,
					-58.17,
					74.98,
					-58.42,
					75.14,
					-58.36,
					75.26,
					-58.53,
					75.28,
					-58.78,
					75.6,
					-58.79,
					75.61,
					-59.34,
					75.71,
					-59.53,
					75.67,
					-60.2,
					75.75,
					-60.3,
					75.92,
					-60.21,
					75.88,
					-60.7,
					75.96,
					-60.85,
					75.88,
					-61.16,
					76.02,
					-61.37,
					76.01,
					-61.6,
					75.91,
					-61.71,
					76,
					-61.9,
					75.95,
					-62.05,
					76.06,
					-62.17,
					75.93,
					-62.36,
					75.99,
					-62.48,
					76.12,
					-62.49,
					76.05,
					-62.74,
					76.21,
					-62.94,
					76.17,
					-63.27,
					76.26,
					-63.39,
					76.15,
					-63.56,
					75.99,
					-63.59,
					75.99,
					-63.73,
					79.09,
					-66.48,
					79.22,
					-66.43,
					79.29,
					-65.83,
					79.55,
					-65.05,
					79.83,
					-65.23,
					79.97,
					-65.17,
					79.89,
					-66.04,
					79.97,
					-66.37,
					79.94,
					-67.02,
					80.03,
					-67.13,
					80.11,
					-67.5,
					80.38,
					-67.5,
					80.46,
					-67.26,
					80.6,
					-67.2,
					80.55,
					-66.75,
					80.68,
					-66.89,
					80.93,
					-66.68,
					80.9,
					-66.53,
					80.74,
					-66.55,
					80.69,
					-66.34,
					80.87,
					-65.04,
					81.07,
					-64.7,
					81.27,
					-63.16,
					81.35,
					-63.07,
					81.19,
					-61.37,
					81.25,
					-61.49,
					81.36,
					-61.5,
					81.49,
					-61.2,
					81.68,
					-61.53,
					81.84,
					-61.47,
					81.98,
					-60.82,
					82.01,
					-59.62,
					82.08,
					-59.54,
					82.21,
					-58.61,
					82.33,
					-56.55,
					82.26,
					-56.3,
					82.37,
					-55.92,
					82.47,
					-54.5,
					82.19,
					-53.52,
					82.29,
					-53.47,
					82.4,
					-53.28,
					82.41,
					-52.76,
					82.31,
					-51.81,
					82.2,
					-51.72,
					82.03,
					-51.09,
					81.99,
					-50.35,
					82.1,
					-50.82,
					82.27,
					-50.94,
					82.43,
					-51.25,
					82.54,
					-51.27,
					82.6,
					-51.18,
					82.62,
					-49.92,
					82.55,
					-49.03,
					82.63,
					-48.94,
					82.64,
					-48.41,
					82.54,
					-48.02,
					82.37,
					-48.03,
					82.22,
					-46.7,
					82.53,
					-47.79,
					82.66,
					-47.85,
					82.68,
					-48.38,
					82.88,
					-48.59,
					82.96,
					-48.49,
					82.98,
					-48.01,
					82.89,
					-47.48,
					83.03,
					-47.42,
					82.99,
					-47.04,
					83.2,
					-46.04,
					83.16,
					-45.7,
					83.23,
					-45.6,
					83.21,
					-44.93,
					83.32,
					-44.24,
					83.39,
					-42.4,
					83.31,
					-41.88,
					83.41,
					-41.79,
					83.44,
					-41.23,
					83.27,
					-40.84,
					83.37,
					-40.79,
					83.47,
					-40.53,
					83.38,
					-39.77,
					83.51,
					-39.24,
					83.42,
					-38.98,
					83.54,
					-38.88,
					83.5,
					-38.21,
					83.62,
					-37.68,
					83.54,
					-37.06,
					83.6,
					-36.98,
					83.71,
					-34.82,
					83.65,
					-34.6,
					83.7,
					-30.31,
					83.59,
					-28.48,
					83.52,
					-28.39,
					83.57,
					-27.36,
					83.39,
					-25.68,
					83.25,
					-25.6,
					83.21,
					-24.83,
					82.96,
					-24.66,
					83.02,
					-23.99,
					82.86,
					-22.84,
					82.89,
					-22.29,
					82.69,
					-21.26,
					82.52,
					-21.26,
					82.36,
					-22.11,
					82.26,
					-22.25,
					82.09,
					-24.63,
					82.02,
					-24.44,
					81.7,
					-24.52,
					81.86,
					-23.8,
					81.8,
					-23.41,
					82.01,
					-23.37,
					82.11,
					-23.13,
					82.18,
					-21.28,
					82,
					-20.92,
					81.68,
					-20.89,
					81.37,
					-21.24,
					81.09,
					-22.18,
					81.37,
					-20.74,
					81.48,
					-20.61,
					81.57,
					-20.16,
					81.76,
					-20.01,
					81.81,
					-19.71,
					81.7,
					-18.92,
					81.76,
					-19.23,
					82.03,
					-19.67,
					82.14,
					-19.62,
					82.21,
					-19.19,
					81.87,
					-18.51,
					81.74,
					-18.58,
					81.69,
					-18.87,
					81.54,
					-18.82,
					81.58,
					-18.18,
					81.65,
					-18.33,
					81.76,
					-18.32,
					81.81,
					-18,
					81.86,
					-18.12,
					82.16,
					-18.27,
					82.23,
					-17.99,
					81.98,
					-17.57,
					81.87,
					-17.56,
					81.81,
					-17.66,
					81.57,
					-17.22,
					81.75,
					-16.88,
					81.73,
					-16.61,
					81.86,
					-16.49,
					81.86,
					-15.87,
					81.94,
					-15.62,
					81.9,
					-13.7,
					81.73,
					-12.01,
					81.51,
					-11.21,
					81.36,
					-11.28,
					80.9,
					-13.31,
					80.9,
					-14.02,
					80.74,
					-14.04,
					80.63,
					-14.51,
					80.51,
					-15.66,
					80.4,
					-15.59,
					80.32,
					-15.66,
					80.11,
					-16.34,
					80.06,
					-17.07,
					79.9,
					-17.11,
					79.53,
					-17.97,
					79.62,
					-18.99,
					79.38,
					-19.41,
					79.53,
					-22.57,
					76.05,
					-22.8,
					75.83,
					-19.32,
					75.73,
					-19.26,
					75.64,
					-19.34,
					75.42,
					-19.23,
					75.22,
					-19.29,
					75.03,
					-19.55,
					75.04,
					-19.87,
					74.88,
					-19.64,
					74.78,
					-19.66,
					74.7,
					-19.81,
					74.79,
					-19.38,
					74.68,
					-19.2,
					74.81,
					-18.3,
					74.69,
					-18.2,
					74.51,
					-18.33,
					74.59,
					-18.63,
					74.41,
					-18.7,
					74.42,
					-18.88,
					74.15,
					-19.36,
					74.15,
					-20.02,
					74.02,
					-20.72,
					73.95,
					-19.92,
					73.8,
					-19.95,
					73.7,
					-20.31,
					73.59,
					-20.22,
					73.38,
					-20.37,
					73.37,
					-21.47,
					73.28,
					-21.55,
					73.14,
					-22.19,
					73.16,
					-22.44,
					73.08,
					-22.41,
					73.01,
					-21.85,
					72.9,
					-21.8,
					72.83,
					-21.87,
					72.7,
					-21.57,
					72.55,
					-21.64,
					72.63,
					-21.81,
					72.58,
					-21.91,
					72.43,
					-21.82,
					72.03,
					-22.14,
					72.05,
					-22.68,
					72.23,
					-23.19,
					72.35,
					-24.13,
					72.53,
					-24.48,
					72.89,
					-24.67,
					72.8,
					-24.72,
					72.74,
					-24.61,
					72.49,
					-24.52,
					72.38,
					-24.29,
					71.13,
					-24.41,
					71.08,
					-24.51,
					71.21,
					-24.77,
					71.14,
					-24.91,
					71.18,
					-25.15,
					70.92,
					-25.28,
					70.71,
					-25.17,
					70.62,
					-25.21,
					70.32,
					-26.24,
					70.52,
					-25.27,
					70.23,
					-23.85,
					70.22,
					-22.07,
					70.16,
					-21.98,
					70.05,
					-22,
					69.79,
					-22.59,
					69.78,
					-22.78,
					69.64,
					-22.97,
					69.67,
					-23.09,
					69.54,
					-23.25,
					69.57,
					-23.47,
					69.4,
					-23.77,
					69.47,
					-23.97,
					69.3,
					-24.06,
					69.32,
					-24.31,
					69.14,
					-24.62,
					69.14,
					-24.86,
					69.06,
					-24.91,
					68.79,
					-25.55,
					68.67,
					-26.22,
					68.55,
					-26.37,
					68.57,
					-26.77,
					68.36,
					-27.61,
					68.34,
					-28.49,
					68.21,
					-28.86,
					68.19,
					-29.26,
					68.1,
					-29.39,
					68.15,
					-29.62,
					68.03,
					-29.84,
					67.96,
					-30.42,
					68.01,
					-31.33,
					67.96,
					-31.6,
					68.07,
					-31.88,
					67.84,
					-31.95,
					67.68,
					-32.17,
					67.7,
					-32.43,
					67.6,
					-32.36,
					67.49,
					-32.43,
					67.52,
					-32.56,
					67.63,
					-32.6,
					67.69,
					-32.54,
					67.7,
					-32.63,
					67.53,
					-32.79,
					67.56,
					-32.97,
					67.47,
					-33.11,
					67.18,
					-33.09,
					67.15,
					-33.25,
					66.99,
					-33.32,
					66.82,
					-33.57,
					66.84,
					-33.69,
					66.7,
					-33.77,
					66.47,
					-34.3,
					66.26,
					-34.58,
					66.1,
					-35.43,
					65.9,
					-35.59,
					65.8,
					-36.06,
					65.68,
					-36.05,
					65.6,
					-36.13,
					65.7,
					-36.47,
					65.66,
					-36.6,
					65.52,
					-36.65,
					65.43,
					-37.23,
					65.52,
					-37.34,
					65.44,
					-37.77,
					65.51,
					-38.05,
					65.61,
					-38.09,
					65.53,
					-38.18,
					65.37,
					-38.94,
					65.43,
					-39.05,
					65.33,
					-39.27,
					65.46,
					-39.53,
					65.28,
					-39.34,
					65.15,
					-39.37,
					65.02,
					-39.71,
					64.9,
					-39.72,
					64.84,
					-39.83,
					64.87,
					-40.27,
					64.69,
					-40.3,
					64.43,
					-40.11,
					64.25,
					-40.21,
					64.22,
					-40.48,
					63.61,
					-40.43,
					63.01,
					-41.14,
					62.54,
					-42.02,
					61.79,
					-41.97,
					61.7,
					-42.08,
					61.47,
					-42.14,
					61.41,
					-42.29,
					61.19,
					-42.39,
					61.08,
					-42.53,
					60.97,
					-42.58,
					60.86,
					-42.52,
					60.77,
					-42.68,
					60.66,
					-42.63,
					60.49,
					-42.75,
					60.4,
					-43,
					60.14,
					-42.93,
					59.93,
					-43.05,
					59.7,
					-43.57
				]
			},
			{
				"points": [
					74.82,
					-17.59,
					74.94,
					-18.94,
					75.03,
					-19.02,
					75.37,
					-19.02,
					75.43,
					-18.94,
					75.53,
					-18.07,
					75.19,
					-17.23,
					74.92,
					-17.32,
					74.82,
					-17.59
				]
			},
			{
				"points": [
					82.65,
					-50.14,
					82.75,
					-50.24,
					82.9,
					-50.11,
					82.8,
					-49.69,
					82.66,
					-49.79,
					82.65,
					-50.14
				]
			},
			{
				"points": [
					72.98,
					-21.37,
					73.04,
					-21.57,
					73.18,
					-21.57,
					73.21,
					-21.12,
					73.04,
					-21.14,
					72.98,
					-21.37
				]
			}
		],
		"transitions": [
			[
				1319950800,
				-180,
				[
					"WGT"
				]
			],
			[
				1332651600,
				-120,
				[
					"WGST"
				]
			],
			[
				1351400400,
				-180,
				[
					"WGT"
				]
			],
			[
				1364706000,
				-120,
				[
					"WGST"
				]
			],
			[
				1382850000,
				-180,
				[
					"WGT"
				]
			],
			[
				1396155600,
				-120,
				[
					"WGST"
				]
			],
			[
				1414299600,
				-180,
				[
					"WGT"
				]
			],
			[
				1427605200,
				-120,
				[
					"WGST"
				]
			],
			[
				1445749200,
				-180,
				[
					"WGT"
				]
			],
			[
				1459054800,
				-120,
				[
					"WGST"
				]
			],
			[
				1477803600,
				-180,
				[
					"WGT"
				]
			],
			[
				1490504400,
				-120,
				[
					"WGST"
				]
			],
			[
				1509253200,
				-180,
				[
					"WGT"
				]
			],
			[
				1521954000,
				-120,
				[
					"WGST"
				]
			],
			[
				1540702800,
				-180,
				[
					"WGT"
				]
			],
			[
				1554008400,
				-120,
				[
					"WGST"
				]
			],
			[
				1572152400,
				-180,
				[
					"WGT"
				]
			],
			[
				1585458000,
				-120,
				[
					"WGST"
				]
			],
			[
				1603602000,
				-180,
				[
					"WGT"
				]
			],
			[
				1616907600,
				-120,
				[
					"WGST"
				]
			],
			[
				1635656400,
				-180,
				[
					"WGT"
				]
			],
			[
				1648357200,
				-120,
				[
					"WGST"
				]
			],
			[
				1667106000,
				-180,
				[
					"WGT"
				]
			],
			[
				1679806800,
				-120,
				[
					"WGST"
				]
			],
			[
				1698555600,
				-180,
				[
					"WGT"
				]
			],
			[
				1711861200,
				-120,
				[
					"WGST"
				]
			],
			[
				1730005200,
				-180,
				[
					"WGT"
				]
			],
			[
				1743310800,
				-120,
				[
					"WGST"
				]
			],
			[
				1761454800,
				-180,
				[
					"WGT"
				]
			],
			[
				1774760400,
				-120,
				[
					"WGST"
				]
			],
			[
				1792904400,
				-180,
				[
					"WGT"
				]
			],
			[
				1806210000,
				-120,
				[
					"WGST"
				]
			],
			[
				1824958800,
				-180,
				[
					"WGT"
				]
			],
			[
				1837659600,
				-120,
				[
					"WGST"
				]
			],
			[
				1856408400,
				-180,
				[
					"WGT"
				]
			],
			[
				1869109200,
				-120,
				[
					"WGST"
				]
			],
			[
				1887858000,
				-180,
				[
					"WGT"
				]
			],
			[
				1901163600,
				-120,
				[
					"WGST"
				]
			],
			[
				1919307600,
				-180,
				[
					"WGT"
				]
			],
			[
				1932613200,
				-120,
				[
					"WGST"
				]
			],
			[
				1950757200,
				-180,
				[
					"WGT"
				]
			],
			[
				1964062800,
				-120,
				[
					"WGST"
				]
			],
			[
				1982811600,
				-180,
				[
					"WGT"
				]
			],
			[
				1995512400,
				-120,
				[
					"WGST"
				]
			],
			[
				2014261200,
				-180,
				[
					"WGT"
				]
			],
			[
				2026962000,
				-120,
				[
					"WGST"
				]
			],
			[
				2045710800,
				-180,
				[
					"WGT"
				]
			],
			[
				2058411600,
				-120,
				[
					"WGST"
				]
			],
			[
				2077160400,
				-180,
				[
					"WGT"
				]
			],
			[
				2090466000,
				-120,
				[
					"WGST"
				]
			],
			[
				2108610000,
				-180,
				[
					"WGT"
				]
			],
			[
				2121915600,
				-120,
				[
					"WGST"
				]
			],
			[
				2140059600,
				-180,
				[
					"WGT"
				]
			]
		],
		"name": "America/Godthab"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-24.41,
					-128.18,
					-24.51,
					-128.27,
					-24.47,
					-128.4,
					-24.24,
					-128.41,
					-24.23,
					-128.21,
					-24.41,
					-128.18
				]
			},
			{
				"points": [
					-25.17,
					-130.05,
					-25.11,
					-130.22,
					-24.95,
					-130.15,
					-25.04,
					-129.97,
					-25.17,
					-130.05
				]
			},
			{
				"points": [
					-24.69,
					-124.67,
					-24.77,
					-124.82,
					-24.64,
					-124.9,
					-24.55,
					-124.74,
					-24.69,
					-124.67
				]
			},
			{
				"points": [
					-24.01,
					-130.67,
					-23.99,
					-130.82,
					-23.85,
					-130.82,
					-23.83,
					-130.65,
					-24.01,
					-130.67
				]
			}
		],
		"transitions": [
			[
				0,
				-480,
				[
					"PST"
				]
			]
		],
		"name": "Pacific/Pitcairn"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-14.48,
					-170.71,
					-14.37,
					-170.91,
					-14.26,
					-170.92,
					-14.16,
					-170.49,
					-14.36,
					-170.47,
					-14.48,
					-170.71
				]
			},
			{
				"points": [
					-19.23,
					-169.81,
					-19.25,
					-169.92,
					-19.06,
					-170.05,
					-18.84,
					-169.82,
					-19.06,
					-169.66,
					-19.23,
					-169.81
				]
			},
			{
				"points": [
					-14.38,
					-169.45,
					-14.27,
					-169.74,
					-14.09,
					-169.76,
					-14.05,
					-169.61,
					-14.13,
					-169.34,
					-14.32,
					-169.33,
					-14.38,
					-169.45
				]
			},
			{
				"points": [
					28.09,
					-177.37,
					28.13,
					-177.47,
					28.27,
					-177.47,
					28.3,
					-177.26,
					28.16,
					-177.22,
					28.09,
					-177.37
				]
			}
		],
		"transitions": [
			[
				0,
				-660,
				[
					"SST",
					"NUT"
				]
			]
		],
		"name": "Pacific/Pago_Pago"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-54.61,
					-37.02,
					-54.1,
					-38.12,
					-54.11,
					-38.27,
					-53.95,
					-38.32,
					-53.89,
					-38.23,
					-53.87,
					-37.4,
					-54.01,
					-36.59,
					-54.45,
					-35.82,
					-54.84,
					-35.69,
					-54.93,
					-35.77,
					-54.99,
					-36.12,
					-54.61,
					-37.02
				]
			},
			{
				"points": [
					-59.54,
					-27.07,
					-59.57,
					-27.4,
					-59.4,
					-27.52,
					-59.33,
					-27.44,
					-59.31,
					-27.06,
					-59.41,
					-26.96,
					-59.54,
					-27.07
				]
			},
			{
				"points": [
					-58.47,
					-26.13,
					-58.6,
					-26.24,
					-58.55,
					-26.47,
					-58.41,
					-26.55,
					-58.28,
					-26.24,
					-58.47,
					-26.13
				]
			},
			{
				"points": [
					-57.2,
					-26.71,
					-57.19,
					-26.87,
					-57.01,
					-26.88,
					-56.98,
					-26.58,
					-57.1,
					-26.55,
					-57.2,
					-26.71
				]
			}
		],
		"transitions": [
			[
				0,
				-120,
				[
					"FNT",
					"GST"
				]
			]
		],
		"name": "America/Noronha"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-52.55,
					-58.86,
					-52.55,
					-59.14,
					-52.44,
					-59.25,
					-52.39,
					-59.54,
					-52.5,
					-59.7,
					-52.46,
					-59.85,
					-52.12,
					-59.95,
					-52.37,
					-60.61,
					-52.25,
					-60.99,
					-51.82,
					-61.45,
					-51.62,
					-61.4,
					-51.56,
					-61.18,
					-51.32,
					-60.88,
					-51.18,
					-61.02,
					-51.1,
					-61.33,
					-50.96,
					-61.34,
					-50.93,
					-61.06,
					-51,
					-60.98,
					-51.02,
					-60.69,
					-51.15,
					-60.54,
					-51.04,
					-60.46,
					-51.05,
					-60.21,
					-51.13,
					-60.14,
					-51.1,
					-59.89,
					-51.31,
					-59.13,
					-51.29,
					-59.04,
					-51.2,
					-59.06,
					-51.13,
					-58.97,
					-51.22,
					-58.68,
					-51.2,
					-58.42,
					-51.32,
					-58.27,
					-51.26,
					-57.91,
					-51.43,
					-57.67,
					-51.77,
					-57.64,
					-51.98,
					-58.23,
					-52.2,
					-58.37,
					-52.33,
					-58.87,
					-52.42,
					-58.78,
					-52.55,
					-58.86
				]
			},
			{
				"points": [
					-52.95,
					-59.11,
					-53,
					-59.2,
					-52.94,
					-59.3,
					-52.77,
					-59.25,
					-52.8,
					-59.11,
					-52.95,
					-59.11
				]
			}
		],
		"transitions": [
			[
				1283680800,
				-180,
				[
					"FKST"
				]
			],
			[
				1334480400,
				-240,
				[
					"FKT"
				]
			],
			[
				1346580000,
				-180,
				[
					"FKST"
				]
			],
			[
				1366534800,
				-240,
				[
					"FKT"
				]
			],
			[
				1378029600,
				-180,
				[
					"FKST"
				]
			],
			[
				1397984400,
				-240,
				[
					"FKT"
				]
			],
			[
				1410084000,
				-180,
				[
					"FKST"
				]
			],
			[
				1429434000,
				-240,
				[
					"FKT"
				]
			],
			[
				1441533600,
				-180,
				[
					"FKST"
				]
			],
			[
				1460883600,
				-240,
				[
					"FKT"
				]
			],
			[
				1472983200,
				-180,
				[
					"FKST"
				]
			],
			[
				1492333200,
				-240,
				[
					"FKT"
				]
			],
			[
				1504432800,
				-180,
				[
					"FKST"
				]
			],
			[
				1523782800,
				-240,
				[
					"FKT"
				]
			],
			[
				1535882400,
				-180,
				[
					"FKST"
				]
			],
			[
				1555837200,
				-240,
				[
					"FKT"
				]
			],
			[
				1567332000,
				-180,
				[
					"FKST"
				]
			],
			[
				1587286800,
				-240,
				[
					"FKT"
				]
			],
			[
				1599386400,
				-180,
				[
					"FKST"
				]
			],
			[
				1618736400,
				-240,
				[
					"FKT"
				]
			],
			[
				1630836000,
				-180,
				[
					"FKST"
				]
			],
			[
				1650186000,
				-240,
				[
					"FKT"
				]
			],
			[
				1662285600,
				-180,
				[
					"FKST"
				]
			],
			[
				1681635600,
				-240,
				[
					"FKT"
				]
			],
			[
				1693735200,
				-180,
				[
					"FKST"
				]
			],
			[
				1713690000,
				-240,
				[
					"FKT"
				]
			],
			[
				1725184800,
				-180,
				[
					"FKST"
				]
			],
			[
				1745139600,
				-240,
				[
					"FKT"
				]
			],
			[
				1757239200,
				-180,
				[
					"FKST"
				]
			],
			[
				1776589200,
				-240,
				[
					"FKT"
				]
			],
			[
				1788688800,
				-180,
				[
					"FKST"
				]
			],
			[
				1808038800,
				-240,
				[
					"FKT"
				]
			],
			[
				1820138400,
				-180,
				[
					"FKST"
				]
			],
			[
				1839488400,
				-240,
				[
					"FKT"
				]
			],
			[
				1851588000,
				-180,
				[
					"FKST"
				]
			],
			[
				1870938000,
				-240,
				[
					"FKT"
				]
			],
			[
				1883037600,
				-180,
				[
					"FKST"
				]
			],
			[
				1902992400,
				-240,
				[
					"FKT"
				]
			],
			[
				1914487200,
				-180,
				[
					"FKST"
				]
			],
			[
				1934442000,
				-240,
				[
					"FKT"
				]
			],
			[
				1946541600,
				-180,
				[
					"FKST"
				]
			],
			[
				1965891600,
				-240,
				[
					"FKT"
				]
			],
			[
				1977991200,
				-180,
				[
					"FKST"
				]
			],
			[
				1997341200,
				-240,
				[
					"FKT"
				]
			],
			[
				2009440800,
				-180,
				[
					"FKST"
				]
			],
			[
				2028790800,
				-240,
				[
					"FKT"
				]
			],
			[
				2040890400,
				-180,
				[
					"FKST"
				]
			],
			[
				2060240400,
				-240,
				[
					"FKT"
				]
			],
			[
				2072340000,
				-180,
				[
					"FKST"
				]
			],
			[
				2092294800,
				-240,
				[
					"FKT"
				]
			],
			[
				2104394400,
				-180,
				[
					"FKST"
				]
			],
			[
				2123744400,
				-240,
				[
					"FKT"
				]
			],
			[
				2135844000,
				-180,
				[
					"FKST"
				]
			]
		],
		"name": "Atlantic/Stanley"
	},
	{
		"hoverRegion": [
			{
				"points": [
					29.01,
					80.01,
					29.25,
					80.16,
					29.42,
					80.12,
					29.62,
					80.28,
					29.8,
					80.27,
					30.3,
					80.84,
					30.3,
					81.1,
					30.18,
					81.2,
					30.51,
					81.37,
					30.44,
					82.14,
					30.18,
					82.28,
					30.09,
					82.56,
					29.8,
					82.89,
					29.67,
					83.3,
					29.29,
					83.6,
					29.42,
					83.9,
					29.38,
					84.12,
					29.23,
					84.3,
					28.98,
					84.24,
					28.82,
					84.7,
					28.68,
					84.85,
					28.77,
					85.17,
					28.62,
					85.3,
					28.43,
					85.25,
					28.39,
					85.64,
					28.15,
					85.99,
					28.26,
					86.21,
					28.08,
					86.3,
					28.06,
					86.45,
					28.21,
					86.72,
					27.93,
					87.2,
					27.97,
					87.57,
					27.92,
					87.86,
					28.02,
					88,
					27.94,
					88.26,
					27.83,
					88.29,
					27.14,
					88.1,
					26.89,
					88.27,
					26.58,
					88.25,
					26.25,
					88.01,
					26.35,
					87.86,
					26.24,
					87.32,
					26.33,
					87.06,
					26.43,
					86.99,
					26.31,
					86.73,
					26.55,
					86.04,
					26.46,
					85.82,
					26.74,
					85.58,
					26.63,
					85.34,
					26.65,
					85.19,
					26.86,
					84.89,
					26.96,
					84.58,
					27.22,
					84.55,
					27.28,
					84.26,
					27.39,
					84.11,
					27.35,
					83.96,
					27.24,
					83.87,
					27.34,
					83.48,
					27.22,
					83.29,
					27.34,
					83.13,
					27.41,
					82.7,
					27.59,
					82.62,
					27.57,
					82.41,
					27.8,
					82.05,
					27.76,
					81.83,
					28.09,
					81.27,
					28.26,
					81.13,
					28.52,
					80.61,
					28.45,
					80.47,
					28.74,
					80,
					29.01,
					80.01
				]
			}
		],
		"transitions": [
			[
				0,
				345,
				[
					"NPT"
				]
			]
		],
		"name": "Asia/Kathmandu"
	},
	{
		"hoverRegion": [
			{
				"points": [
					9.07,
					-73.34,
					9.18,
					-73.44,
					9.84,
					-73.07,
					10.51,
					-72.98,
					11.15,
					-72.57,
					11.24,
					-72.31,
					11.73,
					-72.03,
					11.95,
					-71.34,
					11.91,
					-71.24,
					11.66,
					-71.31,
					11.51,
					-71.85,
					11.15,
					-71.66,
					11.05,
					-71.49,
					11.07,
					-71.32,
					11.3,
					-70.87,
					11.45,
					-70.27,
					11.9,
					-70.39,
					12.17,
					-70.29,
					12.31,
					-70.01,
					12.1,
					-69.75,
					11.58,
					-69.56,
					11.64,
					-69.25,
					11.54,
					-68.8,
					11.27,
					-68.34,
					10.92,
					-68.13,
					10.74,
					-68.19,
					10.59,
					-68.08,
					10.74,
					-66.19,
					10.65,
					-65.97,
					10.5,
					-65.95,
					10.37,
					-65.78,
					10.17,
					-65.07,
					10.26,
					-65,
					10.23,
					-64.85,
					10.39,
					-64.78,
					10.38,
					-64.6,
					10.52,
					-64.34,
					10.82,
					-64.32,
					10.94,
					-64.5,
					11.12,
					-64.44,
					11.27,
					-63.89,
					11.25,
					-63.64,
					11.13,
					-63.63,
					11.08,
					-63.71,
					10.93,
					-63.67,
					10.84,
					-63.81,
					10.73,
					-63.53,
					10.87,
					-62.72,
					10.79,
					-62.16,
					10.85,
					-61.8,
					10.63,
					-61.74,
					10.54,
					-61.8,
					10.42,
					-62.61,
					10.35,
					-62.58,
					10.27,
					-62.42,
					10.09,
					-62.34,
					10.16,
					-62.22,
					9.9,
					-61.79,
					10,
					-61.6,
					9.7,
					-61.16,
					9.63,
					-60.91,
					9.17,
					-60.56,
					8.82,
					-60.49,
					8.72,
					-60.54,
					8.68,
					-59.99,
					8.27,
					-59.69,
					7.72,
					-60.3,
					7.71,
					-60.46,
					7.51,
					-60.6,
					7.27,
					-60.5,
					7.15,
					-60.18,
					6.87,
					-60.27,
					6.65,
					-60.66,
					6.68,
					-60.85,
					6.56,
					-61.09,
					6.2,
					-60.99,
					5.92,
					-61.23,
					5,
					-60.48,
					4.71,
					-60.64,
					4.62,
					-60.81,
					4.45,
					-60.9,
					4.43,
					-61.17,
					4.33,
					-61.38,
					4.17,
					-61.47,
					4.15,
					-61.68,
					4,
					-61.89,
					3.97,
					-62.14,
					4.05,
					-62.38,
					3.91,
					-62.51,
					3.91,
					-62.61,
					3.68,
					-62.6,
					3.47,
					-62.85,
					3.88,
					-63.34,
					3.8,
					-63.43,
					3.89,
					-63.65,
					3.82,
					-63.98,
					4.06,
					-64.19,
					4.04,
					-64.52,
					3.67,
					-64.08,
					3.18,
					-64.1,
					2.79,
					-63.87,
					2.57,
					-63.9,
					2.51,
					-63.74,
					2.53,
					-63.32,
					2.26,
					-63.23,
					2.06,
					-63.34,
					1.88,
					-63.92,
					1.65,
					-63.95,
					1.4,
					-64.12,
					1.27,
					-64.32,
					1.32,
					-64.43,
					1.18,
					-64.59,
					1,
					-65.03,
					0.62,
					-65.3,
					0.51,
					-65.53,
					0.68,
					-65.66,
					0.89,
					-65.63,
					0.66,
					-66.03,
					0.63,
					-66.35,
					1.14,
					-66.94,
					2.34,
					-67.3,
					2.69,
					-67.69,
					2.75,
					-67.96,
					2.94,
					-67.92,
					3.41,
					-67.43,
					3.64,
					-67.56,
					3.74,
					-67.72,
					4.55,
					-67.98,
					5.03,
					-67.9,
					5.3,
					-67.95,
					5.57,
					-67.72,
					5.84,
					-67.71,
					6.03,
					-67.54,
					6.1,
					-67.56,
					6.18,
					-67.82,
					6.05,
					-68.3,
					6.02,
					-68.65,
					6.09,
					-69.02,
					5.98,
					-69.18,
					6,
					-69.45,
					6.87,
					-70.13,
					6.82,
					-70.32,
					6.97,
					-70.69,
					6.87,
					-70.97,
					6.94,
					-71.73,
					6.9,
					-72.05,
					7.27,
					-72.27,
					7.3,
					-72.48,
					7.43,
					-72.57,
					7.96,
					-72.59,
					8.15,
					-72.46,
					8.3,
					-72.49,
					8.59,
					-72.75,
					8.99,
					-72.85,
					8.99,
					-72.98,
					9.12,
					-73.06,
					9.07,
					-73.34
				]
			},
			{
				"points": [
					11.63,
					-66.8,
					11.73,
					-67,
					11.88,
					-67.04,
					12,
					-66.93,
					12.06,
					-66.62,
					11.86,
					-66.48,
					11.73,
					-66.48,
					11.63,
					-66.8
				]
			},
			{
				"points": [
					11.63,
					-64.33,
					11.75,
					-64.72,
					11.97,
					-64.68,
					12,
					-64.58,
					11.86,
					-64.33,
					11.63,
					-64.33
				]
			},
			{
				"points": [
					10.76,
					-65.26,
					10.83,
					-65.48,
					11.02,
					-65.52,
					11.01,
					-65.12,
					10.83,
					-65.1,
					10.76,
					-65.26
				]
			}
		],
		"transitions": [
			[
				0,
				-270,
				[
					"VET"
				]
			]
		],
		"name": "America/Caracas"
	},
	{
		"hoverRegion": [
			{
				"points": [
					54.52,
					-162.31,
					54.56,
					-162.46,
					54.67,
					-162.47,
					54.74,
					-162.39,
					54.84,
					-162.52,
					54.88,
					-162.66,
					54.77,
					-162.86,
					54.84,
					-162.98,
					54.81,
					-163.05,
					54.66,
					-162.96,
					54.56,
					-163,
					54.61,
					-163.32,
					54.5,
					-163.56,
					54.48,
					-164.14,
					54.32,
					-164.38,
					54.28,
					-164.67,
					54.13,
					-164.68,
					53.95,
					-165.01,
					53.91,
					-165.58,
					54.01,
					-165.65,
					53.92,
					-165.95,
					53.82,
					-165.94,
					53.74,
					-166.04,
					53.95,
					-166.3,
					54.08,
					-166.17,
					54.25,
					-166.16,
					54.32,
					-165.96,
					54.28,
					-165.78,
					54.36,
					-165.7,
					54.4,
					-165.46,
					54.18,
					-165.28,
					54.23,
					-164.98,
					54.31,
					-164.86,
					54.49,
					-165.03,
					54.61,
					-165.03,
					54.76,
					-164.75,
					54.96,
					-164.62,
					55.14,
					-163.89,
					55.14,
					-163.48,
					55.29,
					-163.17,
					55.43,
					-163.28,
					55.52,
					-163.19,
					55.52,
					-163.05,
					55.37,
					-163.02,
					55.89,
					-162.03,
					56.11,
					-161.14,
					56.13,
					-160.79,
					55.96,
					-160.66,
					56.38,
					-160.38,
					56.98,
					-158.83,
					57.34,
					-158.42,
					57.64,
					-157.82,
					58.44,
					-157.63,
					58.58,
					-157.52,
					58.79,
					-157.15,
					58.5,
					-158.23,
					58.78,
					-158.67,
					58.67,
					-158.71,
					58.46,
					-158.59,
					58.28,
					-158.87,
					58.32,
					-159.11,
					58.68,
					-159.47,
					58.75,
					-159.71,
					58.66,
					-159.87,
					58.56,
					-159.86,
					58.48,
					-159.98,
					58.55,
					-160.09,
					58.72,
					-160.01,
					58.78,
					-160.09,
					58.5,
					-160.24,
					58.49,
					-160.35,
					58.69,
					-160.55,
					58.85,
					-160.39,
					58.9,
					-160.43,
					58.46,
					-160.86,
					58.43,
					-161.09,
					58.62,
					-161.25,
					58.44,
					-161.7,
					58.52,
					-162.14,
					58.6,
					-162.26,
					58.71,
					-162.26,
					58.82,
					-161.88,
					59.3,
					-162.16,
					59.52,
					-161.88,
					59.93,
					-162.26,
					59.71,
					-163.29,
					59.68,
					-164.2,
					60.19,
					-164.71,
					60.21,
					-164.93,
					60.47,
					-165.5,
					60.61,
					-165.5,
					60.76,
					-165.15,
					60.83,
					-165.13,
					60.97,
					-165.3,
					60.99,
					-165.61,
					61.19,
					-165.72,
					61.27,
					-165.97,
					61.4,
					-166.04,
					61.4,
					-166.18,
					61.51,
					-166.28,
					61.81,
					-166.24,
					61.92,
					-166.1,
					62.1,
					-166.09,
					62.18,
					-165.95,
					62.07,
					-165.85,
					62.6,
					-165.14,
					62.69,
					-165.1,
					62.71,
					-164.97,
					62.88,
					-164.96,
					63.23,
					-164.63,
					63.37,
					-164.02,
					63.14,
					-163.33,
					63.16,
					-163.11,
					63.42,
					-162.56,
					63.58,
					-162.82,
					63.73,
					-162.6,
					63.55,
					-161.93,
					63.6,
					-161.22,
					63.83,
					-160.89,
					64.15,
					-161.05,
					64.28,
					-161.29,
					64.28,
					-161.57,
					64.41,
					-161.63,
					64.63,
					-161.43,
					64.62,
					-161.15,
					64.69,
					-160.91,
					64.73,
					-160.95,
					64.8,
					-161.14,
					64.65,
					-161.41,
					64.6,
					-161.94,
					64.43,
					-162.46,
					64.3,
					-162.55,
					64.21,
					-162.78,
					64.42,
					-162.93,
					64.29,
					-163.17,
					64.42,
					-163.48,
					64.46,
					-163.82,
					64.32,
					-164.99,
					64.45,
					-166.09,
					64.36,
					-166.22,
					64.66,
					-166.56,
					64.83,
					-166.55,
					65.09,
					-167.03,
					65.24,
					-167.01,
					65.46,
					-168.08,
					65.69,
					-168.22,
					66.42,
					-165.87,
					66.69,
					-164.39,
					66.63,
					-163.52,
					66.49,
					-163.52,
					66.34,
					-163.73,
					66.17,
					-163.72,
					66.15,
					-161.92,
					66.28,
					-162.04,
					66.48,
					-162,
					66.64,
					-162.55,
					66.9,
					-162.72,
					67.01,
					-163.75,
					67.33,
					-163.95,
					67.51,
					-164.18,
					68.16,
					-166.23,
					68.24,
					-166.86,
					68.39,
					-166.93,
					68.54,
					-166.38,
					68.98,
					-166.25,
					69.03,
					-164.29,
					69.17,
					-163.73,
					69.42,
					-163.29,
					69.69,
					-163.24,
					69.9,
					-163.07,
					70.28,
					-162.42,
					70.4,
					-162.02,
					70.48,
					-160.85,
					70.89,
					-159.7,
					70.97,
					-159.29,
					71.01,
					-158.78,
					70.9,
					-158.59,
					70.96,
					-157.91,
					71.5,
					-156.46,
					71.42,
					-155.98,
					71.31,
					-155.83,
					71.31,
					-155.41,
					71.15,
					-155.35,
					71.27,
					-155.27,
					71.26,
					-155.08,
					71.12,
					-154.57,
					70.92,
					-154.49,
					70.88,
					-154.23,
					70.99,
					-153.93,
					71.03,
					-153.23,
					70.94,
					-152.24,
					70.84,
					-152.09,
					70.7,
					-152.13,
					70.64,
					-151.64,
					70.51,
					-151.6,
					70.48,
					-151.27,
					70.54,
					-151.19,
					70.59,
					-150.31,
					70.66,
					-150.14,
					70.56,
					-150.04,
					70.65,
					-149.97,
					70.67,
					-149.72,
					70.58,
					-148.82,
					70.46,
					-148.46,
					70.55,
					-148.45,
					70.59,
					-148.31,
					70.55,
					-148.23,
					70.41,
					-148.22,
					70.42,
					-148.06,
					70.55,
					-148.08,
					70.6,
					-147.93,
					70.41,
					-147.84,
					70.31,
					-147.66,
					70.32,
					-147.6,
					70.47,
					-147.61,
					70.5,
					-147.46,
					70.34,
					-147.37,
					70.41,
					-147.05,
					70.38,
					-146.92,
					70.26,
					-146.89,
					70.33,
					-146.58,
					70.3,
					-145.97,
					70.07,
					-144.95,
					70.23,
					-143.91,
					70.25,
					-143.22,
					69.73,
					-140.93,
					69.64,
					-140.88,
					60.4,
					-140.89,
					60.34,
					-140.56,
					60.41,
					-140.42,
					60.3,
					-139.98,
					60.44,
					-139.67,
					60.45,
					-139.02,
					60.36,
					-138.96,
					60.15,
					-139.04,
					60.01,
					-138.66,
					59.85,
					-138.54,
					59.33,
					-137.54,
					59.08,
					-137.41,
					59.27,
					-136.62,
					59.51,
					-136.56,
					59.7,
					-136.37,
					59.9,
					-135.5,
					59.8,
					-135.19,
					59.63,
					-134.94,
					59.38,
					-134.89,
					59.23,
					-134.44,
					58.95,
					-134.19,
					58.82,
					-133.78,
					58.51,
					-133.31,
					58.37,
					-133.28,
					57.29,
					-132.16,
					57.17,
					-132.14,
					57.11,
					-131.95,
					56.95,
					-131.96,
					56.89,
					-131.8,
					56.71,
					-131.74,
					56.71,
					-131.54,
					56.34,
					-130.43,
					56.24,
					-130.34,
					56.22,
					-130.05,
					55.91,
					-129.89,
					55.72,
					-130.04,
					55.23,
					-129.88,
					54.88,
					-130.21,
					54.62,
					-130.62,
					54.72,
					-131,
					55.01,
					-131.09,
					54.83,
					-131.12,
					54.74,
					-131.34,
					54.87,
					-131.62,
					55.13,
					-131.88,
					54.75,
					-131.84,
					54.58,
					-132.05,
					54.62,
					-132.36,
					54.85,
					-132.64,
					54.63,
					-132.56,
					54.56,
					-132.77,
					54.88,
					-133.24,
					55.13,
					-133.33,
					55.13,
					-133.62,
					55.36,
					-133.88,
					55.48,
					-133.9,
					55.7,
					-133.75,
					55.77,
					-133.79,
					55.74,
					-133.92,
					55.84,
					-134.01,
					55.71,
					-134.25,
					55.84,
					-134.43,
					55.96,
					-134.45,
					56.03,
					-134.31,
					56.33,
					-134.39,
					56.44,
					-134.33,
					56.86,
					-134.52,
					56.99,
					-134.36,
					56.91,
					-134.58,
					56.69,
					-134.5,
					56.14,
					-134.55,
					56.06,
					-134.69,
					56.58,
					-135.22,
					56.74,
					-135.58,
					56.89,
					-135.65,
					56.9,
					-135.9,
					57.33,
					-135.97,
					57.7,
					-136.37,
					57.84,
					-136.64,
					58.1,
					-136.64,
					58.51,
					-137.69,
					58.92,
					-138.22,
					59.46,
					-139.93,
					59.6,
					-139.93,
					59.72,
					-139.69,
					59.74,
					-139.7,
					59.59,
					-140.23,
					59.62,
					-140.9,
					59.78,
					-141.5,
					59.86,
					-141.58,
					59.99,
					-142.82,
					59.87,
					-143.87,
					59.91,
					-144.19,
					59.69,
					-144.62,
					59.83,
					-144.68,
					60.08,
					-144.49,
					60.13,
					-145.3,
					60.31,
					-146.02,
					60.13,
					-146.67,
					60.29,
					-146.8,
					59.76,
					-147.39,
					59.65,
					-147.89,
					59.85,
					-147.99,
					59.82,
					-148.28,
					59.9,
					-148.35,
					59.8,
					-148.65,
					59.86,
					-149.16,
					59.72,
					-149.41,
					59.5,
					-149.59,
					59.51,
					-149.8,
					59.59,
					-149.87,
					59.43,
					-150.18,
					59.24,
					-150.34,
					59.33,
					-150.51,
					59.09,
					-150.95,
					59.12,
					-151.33,
					58.99,
					-151.43,
					59.05,
					-151.94,
					59.36,
					-152.1,
					59.52,
					-151.94,
					59.56,
					-151.66,
					59.64,
					-151.89,
					59.73,
					-151.96,
					60.08,
					-151.8,
					60.43,
					-151.41,
					60.77,
					-151.5,
					61.16,
					-150.35,
					61.19,
					-150.64,
					60.93,
					-151.13,
					60.81,
					-151.65,
					60.62,
					-151.65,
					60.61,
					-151.89,
					60.5,
					-151.72,
					60.29,
					-151.87,
					60.23,
					-152.07,
					60.32,
					-152.16,
					60.16,
					-152.45,
					59.84,
					-152.62,
					59.78,
					-152.88,
					59.58,
					-153.01,
					59.54,
					-153.47,
					59.49,
					-153.5,
					59.44,
					-153.25,
					59.24,
					-153.3,
					59.21,
					-153.53,
					59.35,
					-153.66,
					59.23,
					-153.96,
					59.16,
					-153.96,
					59.19,
					-153.69,
					59.08,
					-153.47,
					59.1,
					-153.33,
					58.83,
					-153.14,
					58.49,
					-153.5,
					58.5,
					-153.81,
					58.04,
					-154.15,
					57.91,
					-154.58,
					57.91,
					-154.95,
					57.63,
					-155.24,
					57.65,
					-155.47,
					57.43,
					-155.69,
					57.44,
					-155.92,
					57.33,
					-155.97,
					57.3,
					-156.17,
					56.9,
					-156.41,
					56.91,
					-156.64,
					56.67,
					-156.84,
					56.78,
					-156.98,
					56.67,
					-157.14,
					56.61,
					-156.9,
					56.44,
					-156.91,
					56.41,
					-157.21,
					56.51,
					-157.44,
					56.5,
					-157.6,
					56.37,
					-157.69,
					56.23,
					-157.62,
					56.15,
					-157.74,
					56.25,
					-157.97,
					56.39,
					-158.04,
					56.35,
					-158.11,
					56.17,
					-157.98,
					56.03,
					-158.06,
					56.06,
					-158.3,
					55.89,
					-158.36,
					55.91,
					-158.56,
					55.73,
					-158.65,
					55.67,
					-158.89,
					55.77,
					-158.98,
					55.72,
					-159.17,
					55.46,
					-159.54,
					55.51,
					-159.8,
					55.69,
					-159.79,
					55.61,
					-159.98,
					55.52,
					-159.92,
					55.42,
					-159.96,
					55.37,
					-159.8,
					55.27,
					-159.73,
					55.38,
					-159.52,
					55.35,
					-159.39,
					55.16,
					-159.38,
					55.15,
					-159.23,
					54.95,
					-159.09,
					54.79,
					-159.16,
					54.75,
					-159.29,
					54.83,
					-159.4,
					54.64,
					-159.52,
					54.73,
					-159.88,
					54.92,
					-159.89,
					54.83,
					-159.99,
					54.78,
					-160.27,
					54.86,
					-160.35,
					55.13,
					-160.3,
					55.02,
					-160.5,
					55.01,
					-160.85,
					55.36,
					-160.96,
					55.24,
					-161.22,
					55.06,
					-161.28,
					55.07,
					-161.43,
					54.94,
					-161.54,
					54.94,
					-161.76,
					54.86,
					-161.87,
					54.99,
					-162.12,
					54.79,
					-162.2,
					54.66,
					-162.1,
					54.52,
					-162.31
				]
			},
			{
				"points": [
					56.29,
					-154.71,
					56.36,
					-154.88,
					56.51,
					-154.87,
					56.63,
					-154.7,
					56.7,
					-154.24,
					56.9,
					-154.6,
					57.15,
					-154.67,
					57.24,
					-154.88,
					57.4,
					-154.89,
					57.66,
					-154.58,
					57.76,
					-154.04,
					57.89,
					-154,
					57.98,
					-153.62,
					58.15,
					-153.49,
					58.54,
					-152.78,
					58.74,
					-152.59,
					58.71,
					-152.27,
					58.62,
					-152.22,
					58.52,
					-152.28,
					58.33,
					-151.72,
					58.09,
					-151.76,
					58.01,
					-152.28,
					57.61,
					-152.04,
					57.27,
					-152.22,
					57.34,
					-152.5,
					57.02,
					-152.87,
					56.88,
					-153.29,
					56.97,
					-153.44,
					56.82,
					-153.47,
					56.75,
					-153.73,
					56.46,
					-153.8,
					56.38,
					-154.21,
					56.45,
					-154.42,
					56.29,
					-154.71
				]
			},
			{
				"points": [
					63.04,
					-168.7,
					62.97,
					-168.77,
					63.01,
					-168.92,
					62.82,
					-169.66,
					63.25,
					-171.75,
					63.48,
					-171.93,
					63.81,
					-171.85,
					63.88,
					-171.76,
					63.79,
					-170.28,
					63.38,
					-168.65,
					63.29,
					-168.58,
					63.04,
					-168.7
				]
			},
			{
				"points": [
					59.64,
					-166.18,
					60,
					-167.37,
					60.24,
					-167.56,
					60.31,
					-167.48,
					60.53,
					-166.17,
					60.37,
					-165.6,
					59.98,
					-165.42,
					59.84,
					-165.49,
					59.64,
					-166.18
				]
			}
		],
		"transitions": [
			[
				1320591600,
				-540,
				[
					"AKST"
				]
			],
			[
				1331478000,
				-480,
				[
					"AKDT"
				]
			],
			[
				1352041200,
				-540,
				[
					"AKST"
				]
			],
			[
				1362927600,
				-480,
				[
					"AKDT"
				]
			],
			[
				1383490800,
				-540,
				[
					"AKST"
				]
			],
			[
				1394377200,
				-480,
				[
					"AKDT"
				]
			],
			[
				1414940400,
				-540,
				[
					"AKST"
				]
			],
			[
				1425826800,
				-480,
				[
					"AKDT"
				]
			],
			[
				1446390000,
				-540,
				[
					"AKST"
				]
			],
			[
				1457881200,
				-480,
				[
					"AKDT"
				]
			],
			[
				1478444400,
				-540,
				[
					"AKST"
				]
			],
			[
				1489330800,
				-480,
				[
					"AKDT"
				]
			],
			[
				1509894000,
				-540,
				[
					"AKST"
				]
			],
			[
				1520780400,
				-480,
				[
					"AKDT"
				]
			],
			[
				1541343600,
				-540,
				[
					"AKST"
				]
			],
			[
				1552230000,
				-480,
				[
					"AKDT"
				]
			],
			[
				1572793200,
				-540,
				[
					"AKST"
				]
			],
			[
				1583679600,
				-480,
				[
					"AKDT"
				]
			],
			[
				1604242800,
				-540,
				[
					"AKST"
				]
			],
			[
				1615734000,
				-480,
				[
					"AKDT"
				]
			],
			[
				1636297200,
				-540,
				[
					"AKST"
				]
			],
			[
				1647183600,
				-480,
				[
					"AKDT"
				]
			],
			[
				1667746800,
				-540,
				[
					"AKST"
				]
			],
			[
				1678633200,
				-480,
				[
					"AKDT"
				]
			],
			[
				1699196400,
				-540,
				[
					"AKST"
				]
			],
			[
				1710082800,
				-480,
				[
					"AKDT"
				]
			],
			[
				1730646000,
				-540,
				[
					"AKST"
				]
			],
			[
				1741532400,
				-480,
				[
					"AKDT"
				]
			],
			[
				1762095600,
				-540,
				[
					"AKST"
				]
			],
			[
				1772982000,
				-480,
				[
					"AKDT"
				]
			],
			[
				1793545200,
				-540,
				[
					"AKST"
				]
			],
			[
				1805036400,
				-480,
				[
					"AKDT"
				]
			],
			[
				1825599600,
				-540,
				[
					"AKST"
				]
			],
			[
				1836486000,
				-480,
				[
					"AKDT"
				]
			],
			[
				1857049200,
				-540,
				[
					"AKST"
				]
			],
			[
				1867935600,
				-480,
				[
					"AKDT"
				]
			],
			[
				1888498800,
				-540,
				[
					"AKST"
				]
			],
			[
				1899385200,
				-480,
				[
					"AKDT"
				]
			],
			[
				1919948400,
				-540,
				[
					"AKST"
				]
			],
			[
				1930834800,
				-480,
				[
					"AKDT"
				]
			],
			[
				1951398000,
				-540,
				[
					"AKST"
				]
			],
			[
				1962889200,
				-480,
				[
					"AKDT"
				]
			],
			[
				1983452400,
				-540,
				[
					"AKST"
				]
			],
			[
				1994338800,
				-480,
				[
					"AKDT"
				]
			],
			[
				2014902000,
				-540,
				[
					"AKST"
				]
			],
			[
				2025788400,
				-480,
				[
					"AKDT"
				]
			],
			[
				2046351600,
				-540,
				[
					"AKST"
				]
			],
			[
				2057238000,
				-480,
				[
					"AKDT"
				]
			],
			[
				2077801200,
				-540,
				[
					"AKST"
				]
			],
			[
				2088687600,
				-480,
				[
					"AKDT"
				]
			],
			[
				2109250800,
				-540,
				[
					"AKST"
				]
			],
			[
				2120137200,
				-480,
				[
					"AKDT"
				]
			],
			[
				2140700400,
				-540,
				[
					"AKST"
				]
			]
		],
		"name": "America/Juneau"
	},
	{
		"hoverRegion": [
			{
				"points": [
					54.38,
					-56.83,
					54.32,
					-57.18,
					54.24,
					-57.18,
					54.19,
					-57.02,
					54.03,
					-57.07,
					53.95,
					-57.01,
					53.9,
					-56.65,
					54.01,
					-56.63,
					54.04,
					-56.49,
					53.92,
					-56.43,
					53.85,
					-56.23,
					53.66,
					-56.16,
					53.5,
					-56.47,
					53.51,
					-57.16,
					53.29,
					-57.39,
					53.1,
					-57.39,
					52.79,
					-57,
					51.98,
					-57,
					51.88,
					-57.06,
					51.88,
					-63.81,
					52.07,
					-63.93,
					52.18,
					-63.86,
					52.28,
					-64.08,
					52.09,
					-64.07,
					51.87,
					-64.21,
					51.68,
					-64.19,
					51.48,
					-64.55,
					51.64,
					-64.75,
					51.61,
					-64.97,
					51.73,
					-65.4,
					51.96,
					-65.5,
					51.87,
					-65.67,
					51.99,
					-65.76,
					51.96,
					-66.02,
					52.09,
					-66.19,
					52.06,
					-66.42,
					52.3,
					-66.59,
					52.43,
					-66.47,
					52.87,
					-66.51,
					52.71,
					-66.57,
					52.56,
					-66.77,
					52.81,
					-67.41,
					53.16,
					-67.49,
					53.28,
					-67.27,
					53.21,
					-67.09,
					53.42,
					-67.09,
					53.45,
					-67.37,
					53.63,
					-67.5,
					53.68,
					-67.66,
					53.82,
					-67.67,
					54,
					-67.92,
					54.2,
					-67.88,
					54.25,
					-67.78,
					54.49,
					-67.86,
					54.71,
					-67.27,
					54.91,
					-67.5,
					55.14,
					-67.51,
					55.17,
					-67.38,
					54.92,
					-66.85,
					55.3,
					-66.94,
					55.46,
					-66.82,
					55.07,
					-66.2,
					55.01,
					-65.79,
					54.82,
					-65.65,
					55.07,
					-65.07,
					54.86,
					-64.65,
					54.89,
					-64.37,
					54.72,
					-63.97,
					54.81,
					-64.01,
					55.01,
					-63.9,
					55.04,
					-63.7,
					55.35,
					-63.74,
					55.43,
					-63.88,
					55.58,
					-63.8,
					55.76,
					-63.82,
					55.89,
					-63.95,
					55.99,
					-63.91,
					55.99,
					-64.1,
					56.42,
					-64.29,
					56.54,
					-64.12,
					56.71,
					-64.24,
					56.97,
					-63.99,
					57.31,
					-63.98,
					57.42,
					-63.84,
					57.63,
					-63.86,
					57.68,
					-64.13,
					57.94,
					-64.3,
					58.05,
					-64.55,
					58.25,
					-64.5,
					58.47,
					-64.16,
					58.64,
					-64.18,
					58.78,
					-64.35,
					58.83,
					-64.92,
					58.9,
					-65.01,
					59.16,
					-64.79,
					59.15,
					-64.61,
					59.33,
					-64.64,
					59.53,
					-65.04,
					59.73,
					-64.88,
					60.03,
					-65.03,
					60.17,
					-64.91,
					60.31,
					-64.96,
					60.48,
					-64.43,
					60.3,
					-64.18,
					59.97,
					-64.04,
					59.8,
					-63.83,
					59.67,
					-63.82,
					59.45,
					-63.46,
					59.35,
					-63.43,
					59.35,
					-63.31,
					59.18,
					-63.28,
					59.14,
					-63.08,
					59.01,
					-63.05,
					58.87,
					-62.81,
					58.67,
					-62.74,
					58.41,
					-62.31,
					58.24,
					-62.38,
					58.14,
					-62.26,
					58.28,
					-62.19,
					58.3,
					-62.03,
					58.18,
					-61.99,
					58.07,
					-62.08,
					58,
					-62.03,
					57.94,
					-61.84,
					58.01,
					-61.59,
					57.65,
					-61.52,
					57.71,
					-61.39,
					57.64,
					-61.22,
					57.51,
					-61.21,
					57.34,
					-61.38,
					57.16,
					-61.23,
					57,
					-61.25,
					56.96,
					-60.99,
					56.85,
					-60.94,
					56.8,
					-60.79,
					56.39,
					-60.79,
					56.3,
					-60.58,
					56.09,
					-60.67,
					56.04,
					-60.54,
					55.89,
					-60.49,
					55.93,
					-60.23,
					55.76,
					-60.04,
					55.63,
					-60.04,
					55.59,
					-59.75,
					55.47,
					-59.68,
					55.45,
					-59.49,
					55.32,
					-59.45,
					55.41,
					-59.3,
					55.28,
					-59.04,
					55.3,
					-58.69,
					55.16,
					-58.64,
					55.13,
					-58.49,
					54.95,
					-58.43,
					55.12,
					-58.24,
					55,
					-58.07,
					55,
					-57.84,
					54.74,
					-57.66,
					54.72,
					-57.22,
					54.54,
					-56.83,
					54.38,
					-56.83
				]
			},
			{
				"points": [
					43.53,
					-66.03,
					43.7,
					-66.22,
					44.2,
					-66.28,
					44.16,
					-66.45,
					44.3,
					-66.48,
					44.85,
					-65.71,
					45.13,
					-65.04,
					45.24,
					-65.12,
					45.43,
					-65.02,
					45.08,
					-65.87,
					45.14,
					-66.03,
					44.94,
					-66.45,
					45.01,
					-66.59,
					44.84,
					-66.68,
					44.73,
					-66.61,
					44.53,
					-66.64,
					44.46,
					-66.74,
					44.53,
					-67,
					44.72,
					-66.96,
					44.98,
					-67.13,
					45.05,
					-67.25,
					45.02,
					-67.38,
					45.2,
					-67.56,
					45.51,
					-67.55,
					45.63,
					-67.91,
					47,
					-67.89,
					47.23,
					-68.25,
					47.07,
					-68.91,
					47.25,
					-69.15,
					47.39,
					-69.09,
					47.62,
					-68.49,
					48,
					-68.43,
					48.02,
					-68.21,
					48.1,
					-68.11,
					48.1,
					-67.6,
					47.95,
					-67.36,
					48.06,
					-66.9,
					48.16,
					-66.88,
					48.22,
					-66.75,
					48.12,
					-66.62,
					48.17,
					-66.34,
					47.99,
					-65.77,
					47.77,
					-65.58,
					47.93,
					-65.14,
					47.92,
					-64.77,
					48.1,
					-64.46,
					48.03,
					-64.38,
					47.79,
					-64.41,
					47.52,
					-64.74,
					47.2,
					-64.88,
					47.12,
					-64.71,
					46.87,
					-64.78,
					46.73,
					-64.62,
					46.34,
					-64.45,
					46.31,
					-64.2,
					46.52,
					-64.46,
					46.74,
					-64.51,
					47.16,
					-63.97,
					46.53,
					-61.9,
					46.42,
					-61.88,
					45.89,
					-62.43,
					45.78,
					-62.41,
					46,
					-61.95,
					45.76,
					-61.76,
					45.77,
					-61.6,
					45.93,
					-61.71,
					46.06,
					-61.69,
					46.33,
					-61.38,
					46.7,
					-61.13,
					47.14,
					-60.66,
					47.13,
					-60.38,
					46.89,
					-60.2,
					46.49,
					-60.34,
					46.08,
					-59.59,
					45.91,
					-59.65,
					45.61,
					-60.21,
					45.46,
					-60.66,
					45.5,
					-60.81,
					45.42,
					-60.9,
					45.16,
					-60.94,
					45.15,
					-61.22,
					44.94,
					-61.89,
					44.82,
					-62.02,
					44.82,
					-62.24,
					44.58,
					-62.8,
					44.6,
					-63.07,
					44.51,
					-63.45,
					44.32,
					-63.53,
					44.4,
					-63.98,
					44.14,
					-64.2,
					44.09,
					-64.4,
					43.6,
					-64.96,
					43.58,
					-65.2,
					43.42,
					-65.28,
					43.29,
					-65.57,
					43.38,
					-65.82,
					43.59,
					-65.93,
					43.53,
					-66.03
				]
			},
			{
				"points": [
					75.85,
					-65.03,
					75.87,
					-65.2,
					75.96,
					-65.27,
					75.92,
					-65.98,
					75.98,
					-66.17,
					76.14,
					-66.17,
					76.16,
					-65.97,
					76.17,
					-66.15,
					75.99,
					-66.36,
					75.84,
					-66.35,
					75.8,
					-66.48,
					75.97,
					-68.74,
					76.11,
					-68.89,
					76.3,
					-69.7,
					76.41,
					-69.73,
					76.29,
					-69.95,
					76.31,
					-70.19,
					76.4,
					-70.3,
					76.51,
					-70.28,
					76.53,
					-70.15,
					76.66,
					-70.1,
					76.67,
					-69.92,
					76.68,
					-70.66,
					76.96,
					-71.47,
					77.1,
					-71.44,
					77.26,
					-70.99,
					77.33,
					-71.24,
					77.2,
					-71.99,
					77.32,
					-72.8,
					77.44,
					-72.91,
					77.54,
					-72.81,
					77.49,
					-71.37,
					77.55,
					-71.27,
					77.56,
					-70.4,
					77.61,
					-70.75,
					77.69,
					-70.8,
					77.65,
					-71.25,
					77.79,
					-71.53,
					77.82,
					-72.24,
					77.97,
					-72.44,
					78.09,
					-73.1,
					78.2,
					-73.14,
					78.28,
					-72.96,
					78.45,
					-72.96,
					78.62,
					-72.56,
					78.73,
					-71.55,
					78.72,
					-70.87,
					78.81,
					-70.66,
					78.91,
					-69.3,
					79.06,
					-69.08,
					79.15,
					-68.56,
					79.26,
					-67.1,
					79.23,
					-66.33,
					76.16,
					-63.63,
					76.06,
					-63.66,
					75.94,
					-64.04,
					76.03,
					-64.21,
					76.23,
					-64.28,
					76.02,
					-64.57,
					76.06,
					-64.8,
					75.85,
					-65.03
				]
			},
			{
				"points": [
					47.16,
					-61.68,
					47.11,
					-62,
					47.25,
					-62.13,
					47.47,
					-62.03,
					47.72,
					-61.6,
					47.87,
					-61.57,
					47.9,
					-61.39,
					47.58,
					-61.29,
					47.16,
					-61.68
				]
			}
		],
		"transitions": [
			[
				1320573600,
				-240,
				[
					"AST"
				]
			],
			[
				1331460000,
				-180,
				[
					"ADT"
				]
			],
			[
				1352023200,
				-240,
				[
					"AST"
				]
			],
			[
				1362909600,
				-180,
				[
					"ADT"
				]
			],
			[
				1383472800,
				-240,
				[
					"AST"
				]
			],
			[
				1394359200,
				-180,
				[
					"ADT"
				]
			],
			[
				1414922400,
				-240,
				[
					"AST"
				]
			],
			[
				1425808800,
				-180,
				[
					"ADT"
				]
			],
			[
				1446372000,
				-240,
				[
					"AST"
				]
			],
			[
				1457863200,
				-180,
				[
					"ADT"
				]
			],
			[
				1478426400,
				-240,
				[
					"AST"
				]
			],
			[
				1489312800,
				-180,
				[
					"ADT"
				]
			],
			[
				1509876000,
				-240,
				[
					"AST"
				]
			],
			[
				1520762400,
				-180,
				[
					"ADT"
				]
			],
			[
				1541325600,
				-240,
				[
					"AST"
				]
			],
			[
				1552212000,
				-180,
				[
					"ADT"
				]
			],
			[
				1572775200,
				-240,
				[
					"AST"
				]
			],
			[
				1583661600,
				-180,
				[
					"ADT"
				]
			],
			[
				1604224800,
				-240,
				[
					"AST"
				]
			],
			[
				1615716000,
				-180,
				[
					"ADT"
				]
			],
			[
				1636279200,
				-240,
				[
					"AST"
				]
			],
			[
				1647165600,
				-180,
				[
					"ADT"
				]
			],
			[
				1667728800,
				-240,
				[
					"AST"
				]
			],
			[
				1678615200,
				-180,
				[
					"ADT"
				]
			],
			[
				1699178400,
				-240,
				[
					"AST"
				]
			],
			[
				1710064800,
				-180,
				[
					"ADT"
				]
			],
			[
				1730628000,
				-240,
				[
					"AST"
				]
			],
			[
				1741514400,
				-180,
				[
					"ADT"
				]
			],
			[
				1762077600,
				-240,
				[
					"AST"
				]
			],
			[
				1772964000,
				-180,
				[
					"ADT"
				]
			],
			[
				1793527200,
				-240,
				[
					"AST"
				]
			],
			[
				1805018400,
				-180,
				[
					"ADT"
				]
			],
			[
				1825581600,
				-240,
				[
					"AST"
				]
			],
			[
				1836468000,
				-180,
				[
					"ADT"
				]
			],
			[
				1857031200,
				-240,
				[
					"AST"
				]
			],
			[
				1867917600,
				-180,
				[
					"ADT"
				]
			],
			[
				1888480800,
				-240,
				[
					"AST"
				]
			],
			[
				1899367200,
				-180,
				[
					"ADT"
				]
			],
			[
				1919930400,
				-240,
				[
					"AST"
				]
			],
			[
				1930816800,
				-180,
				[
					"ADT"
				]
			],
			[
				1951380000,
				-240,
				[
					"AST"
				]
			],
			[
				1962871200,
				-180,
				[
					"ADT"
				]
			],
			[
				1983434400,
				-240,
				[
					"AST"
				]
			],
			[
				1994320800,
				-180,
				[
					"ADT"
				]
			],
			[
				2014884000,
				-240,
				[
					"AST"
				]
			],
			[
				2025770400,
				-180,
				[
					"ADT"
				]
			],
			[
				2046333600,
				-240,
				[
					"AST"
				]
			],
			[
				2057220000,
				-180,
				[
					"ADT"
				]
			],
			[
				2077783200,
				-240,
				[
					"AST"
				]
			],
			[
				2088669600,
				-180,
				[
					"ADT"
				]
			],
			[
				2109232800,
				-240,
				[
					"AST"
				]
			],
			[
				2120119200,
				-180,
				[
					"ADT"
				]
			],
			[
				2140682400,
				-240,
				[
					"AST"
				]
			]
		],
		"name": "Atlantic/Bermuda"
	},
	{
		"hoverRegion": [
			{
				"points": [
					54.37,
					95.59,
					54.49,
					95.86,
					54.68,
					96.03,
					54.63,
					96.45,
					54.89,
					96.56,
					55.04,
					96.47,
					55.14,
					96.58,
					55.34,
					96.63,
					55.38,
					96.74,
					55.53,
					96.74,
					55.62,
					96.64,
					55.85,
					96.69,
					55.93,
					96.86,
					56.07,
					96.88,
					56.2,
					97.06,
					56.16,
					97.33,
					56.25,
					97.47,
					56.46,
					97.47,
					56.49,
					97.65,
					56.68,
					97.65,
					56.73,
					97.4,
					56.92,
					97.37,
					57.06,
					97.23,
					57.9,
					97.86,
					57.9,
					98.77,
					57.83,
					98.98,
					57.89,
					99.36,
					58.18,
					99.63,
					58.18,
					100.04,
					57.94,
					100.21,
					57.79,
					100.46,
					57.62,
					100.5,
					57.52,
					100.74,
					57.95,
					100.72,
					58,
					100.97,
					58.18,
					101.02,
					58.31,
					101.22,
					58.33,
					101.47,
					58.51,
					101.62,
					58.62,
					102.15,
					58.78,
					102.41,
					59.08,
					102.29,
					59.29,
					102.49,
					59.31,
					102.79,
					59.43,
					102.99,
					59.36,
					103.34,
					59.1,
					103.45,
					59.02,
					103.62,
					59,
					103.93,
					58.85,
					104.06,
					58.86,
					104.26,
					58.71,
					104.48,
					58.75,
					104.66,
					58.85,
					104.65,
					58.99,
					104.79,
					59.15,
					105.21,
					59.23,
					105.1,
					59.35,
					105.09,
					59.39,
					104.89,
					59.7,
					104.68,
					59.93,
					104.97,
					59.94,
					105.33,
					60.15,
					105.32,
					60.18,
					104.9,
					60.31,
					104.58,
					60.58,
					104.42,
					60.72,
					104.44,
					60.89,
					104.36,
					61.15,
					104.54,
					61.23,
					104.82,
					61.31,
					104.69,
					61.44,
					104.72,
					61.52,
					105.21,
					61.63,
					105.32,
					61.73,
					105.79,
					61.92,
					105.84,
					62.1,
					106.3,
					62.3,
					106.21,
					62.55,
					106.54,
					62.62,
					106.37,
					62.74,
					106.38,
					62.8,
					106.14,
					63.09,
					106.01,
					63.19,
					106.26,
					63.32,
					106.26,
					63.43,
					106.41,
					63.54,
					106.41,
					63.83,
					106.62,
					64.05,
					106.61,
					63.99,
					107.06,
					64.06,
					107.3,
					63.96,
					107.51,
					64.09,
					107.67,
					64.1,
					108.15,
					64.14,
					107.96,
					64.27,
					107.93,
					64.4,
					108.32,
					64.32,
					108.61,
					64.16,
					108.62,
					64.04,
					108.82,
					63.88,
					108.87,
					63.67,
					108.67,
					63.67,
					108.37,
					63.65,
					109.07,
					63.46,
					109.31,
					63.44,
					109.42,
					63.24,
					109.56,
					63,
					109.56,
					62.8,
					109.75,
					62.53,
					109.45,
					62.5,
					109.96,
					62.34,
					110.09,
					62.1,
					110.09,
					61.81,
					109.74,
					61.57,
					109.97,
					61.4,
					109.93,
					61.18,
					110.6,
					60.95,
					110.56,
					60.8,
					110.39,
					60.62,
					110.35,
					60.58,
					110.22,
					60.16,
					109.82,
					59.98,
					109.87,
					59.72,
					109.61,
					59.59,
					109.62,
					59.45,
					109.45,
					59.17,
					109.7,
					59.08,
					109.87,
					59.08,
					110.17,
					59.13,
					110.44,
					59.36,
					110.68,
					59.29,
					111.17,
					59.38,
					111.43,
					59.31,
					111.64,
					59.37,
					111.89,
					59.61,
					112.29,
					59.41,
					112.44,
					59.38,
					112.71,
					59.19,
					112.66,
					59.26,
					113.21,
					59.31,
					113.32,
					59.43,
					113.32,
					59.66,
					113.53,
					59.85,
					114.12,
					60.05,
					114.44,
					60.17,
					114.45,
					60.31,
					114.63,
					60.3,
					114.79,
					60.53,
					115.16,
					60.63,
					115.7,
					60.46,
					116.62,
					60.14,
					117.11,
					60.11,
					117.34,
					60.02,
					117.4,
					59.91,
					117.29,
					59.62,
					117.3,
					59.58,
					117.58,
					59.65,
					117.75,
					59.58,
					117.88,
					59.69,
					118.04,
					59.71,
					118.27,
					59.51,
					118.79,
					59.3,
					118.95,
					59.14,
					118.81,
					59.05,
					118.94,
					58.64,
					118.98,
					58.51,
					119.23,
					58.19,
					119.21,
					58.11,
					119.12,
					58.05,
					118.68,
					58.27,
					118.18,
					58.27,
					117.65,
					58.14,
					117.69,
					58.05,
					117.51,
					57.86,
					117.51,
					57.72,
					117.28,
					57.67,
					117.38,
					57.43,
					117.42,
					57.39,
					117.82,
					57.32,
					117.9,
					57.08,
					117.77,
					56.95,
					117.78,
					56.75,
					117.62,
					56.71,
					117.38,
					56.79,
					117.3,
					56.61,
					116.76,
					56.8,
					115.69,
					56.67,
					115.68,
					56.46,
					115.9,
					56.32,
					115.8,
					56.19,
					115.93,
					56.05,
					115.9,
					55.93,
					116,
					55.73,
					115.96,
					55.49,
					116.03,
					55.46,
					116.42,
					55.31,
					116.54,
					55.11,
					116.91,
					54.76,
					117.02,
					54.46,
					116.8,
					54.35,
					116.55,
					54.39,
					116.18,
					54.31,
					115.7,
					53.88,
					115,
					53.56,
					113.99,
					53.33,
					114.06,
					53.28,
					114.26,
					53.14,
					114.4,
					52.92,
					114.41,
					52.63,
					114.19,
					52.35,
					113.62,
					52.36,
					113.28,
					52.22,
					112.9,
					52.24,
					112.63,
					52.09,
					112.42,
					52.16,
					112.09,
					51.82,
					111.63,
					51.68,
					111.07,
					51.39,
					110.72,
					51.5,
					110.06,
					51.23,
					109.37,
					51.38,
					109.06,
					51.33,
					108.93,
					51.39,
					108.63,
					51.27,
					108.51,
					51.15,
					108.66,
					51.05,
					108.66,
					50.95,
					108.41,
					50.75,
					108.33,
					50.59,
					108.73,
					50.44,
					108.78,
					50.21,
					108.05,
					49.84,
					107.73,
					49.91,
					107.13,
					50.2,
					106.72,
					50.18,
					106.28,
					50.3,
					106.01,
					50.36,
					105.38,
					50.19,
					104.43,
					50.04,
					104.07,
					50.09,
					103.81,
					50.03,
					103.65,
					50.1,
					103.26,
					50.2,
					103.16,
					50.21,
					102.86,
					50.52,
					102.22,
					51.28,
					102.04,
					51.38,
					101.57,
					51.35,
					101.34,
					51.64,
					100.49,
					51.64,
					99.99,
					52.15,
					98.61,
					52.45,
					98.51,
					52.71,
					98.82,
					52.85,
					98.74,
					53.01,
					98.87,
					52.99,
					98.27,
					53.12,
					98.19,
					53.15,
					97.97,
					53.25,
					97.9,
					53.27,
					97.55,
					53.5,
					97.27,
					53.61,
					96.88,
					53.55,
					96.51,
					53.9,
					95.98,
					54.01,
					95.94,
					54.14,
					95.6,
					54.37,
					95.59
				]
			},
			{
				"points": [
					32.06,
					129.97,
					32.15,
					129.86,
					32.5,
					129.9,
					32.43,
					129.79,
					32.49,
					129.66,
					32.72,
					129.65,
					32.79,
					129.51,
					32.95,
					129.46,
					32.87,
					129.24,
					32.45,
					128.94,
					32.51,
					128.55,
					32.57,
					128.49,
					32.76,
					128.49,
					33.24,
					128.89,
					33.4,
					129.15,
					33.25,
					129.25,
					33.51,
					129.35,
					33.58,
					129.63,
					33.69,
					129.54,
					33.93,
					129.62,
					33.93,
					129.82,
					33.71,
					129.9,
					33.67,
					130.07,
					33.79,
					130.26,
					33.99,
					130.36,
					34.03,
					130.69,
					34.17,
					130.69,
					34.21,
					130.79,
					34.34,
					130.73,
					34.44,
					130.78,
					34.54,
					130.97,
					34.5,
					131.1,
					34.62,
					131.26,
					34.62,
					131.42,
					34.75,
					131.54,
					34.79,
					131.73,
					34.91,
					131.75,
					34.9,
					131.93,
					35.34,
					132.52,
					35.51,
					132.55,
					35.7,
					133.04,
					35.67,
					133.36,
					35.57,
					133.41,
					35.65,
					134.21,
					35.77,
					134.54,
					35.75,
					134.9,
					35.88,
					135.22,
					35.76,
					135.5,
					35.62,
					135.57,
					35.74,
					135.9,
					35.83,
					135.94,
					36.02,
					135.86,
					36.3,
					136.03,
					36.46,
					136.3,
					36.77,
					136.59,
					36.96,
					136.65,
					37.13,
					136.56,
					37.44,
					136.68,
					37.58,
					137.43,
					37.24,
					137.34,
					37.12,
					137.13,
					36.92,
					137.16,
					36.88,
					137.28,
					37.04,
					137.43,
					37.28,
					138.2,
					37.44,
					138.46,
					37.89,
					138.77,
					38.15,
					139.25,
					38.59,
					139.43,
					38.84,
					139.66,
					39.53,
					139.94,
					39.77,
					139.91,
					39.75,
					139.7,
					39.91,
					139.59,
					40.07,
					139.62,
					40.1,
					139.82,
					40.24,
					139.9,
					40.65,
					139.76,
					40.84,
					139.96,
					40.88,
					140.16,
					41.13,
					140.14,
					41.28,
					140.23,
					41.35,
					139.98,
					41.52,
					139.88,
					41.94,
					140,
					42.23,
					139.66,
					42.01,
					139.58,
					41.94,
					139.4,
					42.22,
					139.31,
					42.35,
					139.56,
					42.27,
					139.66,
					42.72,
					139.78,
					42.92,
					140.15,
					42.9,
					140.27,
					43.01,
					140.38,
					43.18,
					140.22,
					43.41,
					140.27,
					43.47,
					140.51,
					43.3,
					140.81,
					43.34,
					141.03,
					43.27,
					141.16,
					43.37,
					141.3,
					43.74,
					141.22,
					43.98,
					141.52,
					44.31,
					141.53,
					44.61,
					141.67,
					45.2,
					141.45,
					45.54,
					141.59,
					45.52,
					141.78,
					45.62,
					141.97,
					44.63,
					143.07,
					44.36,
					143.57,
					44.21,
					144.27,
					44.06,
					144.4,
					44.04,
					144.75,
					44.42,
					145.29,
					44.39,
					145.43,
					44.19,
					145.45,
					43.78,
					145.21,
					43.63,
					145.44,
					43.48,
					145.4,
					43.38,
					145.46,
					43.49,
					145.62,
					43.47,
					145.84,
					43.41,
					145.92,
					43.3,
					145.9,
					43.05,
					145.56,
					43.03,
					145.22,
					42.83,
					144.88,
					42.88,
					144.28,
					42.77,
					143.97,
					42.37,
					143.5,
					41.82,
					143.29,
					42.49,
					141.79,
					42.46,
					141.46,
					42.18,
					141.01,
					42.47,
					140.66,
					42.39,
					140.44,
					42.3,
					140.41,
					42.2,
					140.82,
					41.84,
					141.29,
					41.73,
					141.27,
					41.6,
					141.01,
					41.46,
					141.29,
					41.5,
					141.55,
					41,
					141.5,
					40.69,
					141.55,
					40.27,
					141.94,
					39.45,
					142.17,
					39.04,
					142.01,
					38.72,
					141.65,
					38.55,
					141.6,
					38.19,
					141.66,
					38.13,
					141.45,
					38.29,
					141.29,
					38.08,
					141.05,
					37.46,
					141.15,
					36.98,
					141.09,
					36.81,
					140.88,
					36.27,
					140.68,
					35.69,
					140.98,
					35.48,
					140.57,
					35.1,
					140.45,
					35.01,
					140.19,
					34.8,
					139.94,
					34.87,
					139.69,
					35.03,
					139.7,
					35.05,
					139.53,
					35.18,
					139.47,
					35.14,
					139.24,
					35.04,
					139.29,
					34.83,
					139.23,
					34.57,
					139.06,
					34.49,
					138.84,
					34.64,
					138.64,
					35,
					138.66,
					34.83,
					138.45,
					34.48,
					138.26,
					34.56,
					137.6,
					34.47,
					137.07,
					34.19,
					136.98,
					34.19,
					136.69,
					34.09,
					136.41,
					33.9,
					136.36,
					33.79,
					136.18,
					33.52,
					136.06,
					33.32,
					135.79,
					33.44,
					135.41,
					33.68,
					135.22,
					33.81,
					134.97,
					34.15,
					135.01,
					34.04,
					134.83,
					34.08,
					134.71,
					33.99,
					134.75,
					33.98,
					134.9,
					33.82,
					134.91,
					33.52,
					134.54,
					33.49,
					134.4,
					33.16,
					134.26,
					33.13,
					134.15,
					33.37,
					133.88,
					33.4,
					133.61,
					33.28,
					133.36,
					33.08,
					133.31,
					32.92,
					133.1,
					32.68,
					133.12,
					32.61,
					133.05,
					32.66,
					132.89,
					32.6,
					132.49,
					33.16,
					132.16,
					33.32,
					132.26,
					33.25,
					132.06,
					32.88,
					132.19,
					32.38,
					131.75,
					31.31,
					131.44,
					31.25,
					131.35,
					31.29,
					131.23,
					31.17,
					131.18,
					30.87,
					130.67,
					30.93,
					130.57,
					31.07,
					130.59,
					31.15,
					130.16,
					31.35,
					130.01,
					31.47,
					130.01,
					31.52,
					130.19,
					31.59,
					130.21,
					31.74,
					130.07,
					32.03,
					130.09,
					32.06,
					129.97
				]
			},
			{
				"points": [
					-5.27,
					137.56,
					-5.25,
					137.42,
					-5.05,
					137.21,
					-5.02,
					136.78,
					-4.59,
					135.88,
					-4.53,
					135.12,
					-4.13,
					134.52,
					-4.12,
					134.27,
					-3.97,
					133.89,
					-3.82,
					133.81,
					-3.68,
					133.59,
					-3.73,
					133.53,
					-3.99,
					133.63,
					-4.1,
					133.56,
					-4.29,
					133.71,
					-4.39,
					133.67,
					-4.43,
					133.44,
					-4.18,
					133.22,
					-4.16,
					132.82,
					-3.24,
					132.48,
					-3.1,
					132.34,
					-3.03,
					131.89,
					-2.74,
					131.83,
					-2.56,
					132.14,
					-2.59,
					132.36,
					-2.53,
					132.43,
					-2.67,
					132.71,
					-2.33,
					133.08,
					-2.41,
					132.67,
					-2.31,
					132.55,
					-2.39,
					132.25,
					-2.05,
					131.89,
					-1.72,
					131.8,
					-1.6,
					131.55,
					-1.56,
					131.34,
					-1.64,
					131.21,
					-1.53,
					130.87,
					-1.24,
					130.64,
					-1.19,
					130.48,
					-1.02,
					130.55,
					-1.04,
					130.38,
					-0.97,
					130.3,
					-0.64,
					130.46,
					-0.84,
					130.26,
					-0.86,
					130.12,
					-0.79,
					130.02,
					-0.45,
					130.19,
					-0.36,
					130.06,
					-0.2,
					130.09,
					-0.11,
					129.91,
					0.04,
					129.99,
					0.28,
					129.74,
					0.42,
					129.78,
					0.44,
					129.89,
					0.27,
					130.03,
					0.19,
					130.33,
					0.08,
					130.37,
					0.01,
					130.32,
					0.05,
					130.76,
					0.14,
					130.88,
					-0.12,
					131.39,
					-0.32,
					131.44,
					-0.5,
					131.31,
					-0.63,
					130.77,
					-0.71,
					131,
					-0.81,
					131.02,
					-0.6,
					131.78,
					-0.23,
					132.16,
					-0.33,
					132.98,
					-0.62,
					133.45,
					-0.64,
					134.06,
					-0.81,
					134.25,
					-0.97,
					134.17,
					-1.33,
					134.39,
					-1.66,
					134.23,
					-1.75,
					134.36,
					-2,
					134.26,
					-1.89,
					134.36,
					-1.92,
					134.49,
					-2.2,
					134.47,
					-2.22,
					134.67,
					-2.6,
					134.74,
					-2.64,
					134.96,
					-3.1,
					134.93,
					-3.25,
					135.13,
					-3.24,
					135.45,
					-3.17,
					135.53,
					-3.04,
					135.48,
					-2.83,
					135.63,
					-2.84,
					135.85,
					-2.6,
					135.95,
					-2.53,
					136.14,
					-2.12,
					136.19,
					-2.07,
					136.5,
					-2.13,
					136.72,
					-1.99,
					137.04,
					-1.9,
					136.88,
					-2.07,
					136.36,
					-1.92,
					135.79,
					-1.78,
					135.44,
					-1.62,
					135.31,
					-1.56,
					134.95,
					-1.45,
					134.91,
					-1.36,
					134.97,
					-1.37,
					135.32,
					-1.5,
					135.45,
					-1.51,
					135.72,
					-1.41,
					135.83,
					-1.52,
					135.95,
					-1.72,
					136.99,
					-1.36,
					137.79,
					-1.66,
					138.61,
					-1.5,
					138.64,
					-1.48,
					138.74,
					-1.62,
					138.9,
					-1.8,
					138.84,
					-1.85,
					138.9,
					-1.9,
					139.28,
					-2.02,
					139.35,
					-2.01,
					139.55,
					-2.16,
					139.62,
					-2.24,
					139.79,
					-2.21,
					140.18,
					-2.38,
					140.76,
					-2.51,
					140.83,
					-2.52,
					141.07,
					-6.31,
					141.11,
					-6.71,
					140.96,
					-6.89,
					141.13,
					-9.2,
					141.1,
					-9.21,
					140.97,
					-8.9,
					140.55,
					-8.54,
					140.28,
					-8.2,
					139.86,
					-8.19,
					139.59,
					-8.27,
					139.36,
					-8.2,
					139.23,
					-8.31,
					139.02,
					-8.49,
					138.94,
					-8.44,
					138.59,
					-8.55,
					138.37,
					-8.47,
					137.52,
					-8.35,
					137.51,
					-7.68,
					137.87,
					-7.39,
					138.17,
					-7.28,
					138.58,
					-7.14,
					138.61,
					-6.96,
					138.44,
					-6.66,
					138.56,
					-6.36,
					138.29,
					-5.9,
					138.18,
					-5.77,
					137.95,
					-5.53,
					137.94,
					-5.43,
					137.65,
					-5.27,
					137.56
				]
			},
			{
				"points": [
					36,
					125.97,
					36.08,
					125.86,
					36.28,
					125.86,
					36.31,
					126.14,
					36.4,
					126.25,
					36.67,
					125.94,
					37.06,
					126.23,
					36.89,
					125.99,
					37.07,
					125.82,
					37.37,
					126,
					37.36,
					126.28,
					37.71,
					126,
					37.68,
					125.81,
					37.54,
					125.81,
					37.49,
					125.73,
					37.64,
					125.57,
					37.58,
					125.03,
					37.88,
					124.85,
					38,
					124.88,
					37.9,
					124.8,
					37.68,
					124.83,
					37.64,
					124.71,
					37.72,
					124.59,
					37.98,
					124.5,
					38.17,
					124.56,
					38.29,
					124.75,
					38.56,
					124.67,
					38.65,
					124.87,
					38.77,
					124.95,
					38.76,
					125.07,
					38.88,
					125.01,
					39.28,
					125.28,
					39.4,
					125.23,
					39.49,
					125.03,
					39.3,
					124.76,
					39.32,
					124.55,
					39.41,
					124.48,
					39.59,
					124.5,
					39.72,
					124.32,
					39.67,
					124.24,
					39.76,
					124.09,
					40.12,
					124.24,
					40.56,
					124.83,
					40.82,
					125.52,
					40.97,
					125.68,
					41.02,
					125.95,
					41.43,
					126.4,
					41.67,
					126.47,
					41.84,
					126.63,
					41.82,
					126.77,
					41.91,
					126.97,
					41.56,
					127.37,
					41.5,
					128.11,
					41.57,
					128.16,
					41.77,
					127.99,
					42.09,
					128.03,
					42.12,
					128.88,
					42.55,
					129.3,
					42.5,
					129.5,
					42.56,
					129.64,
					43.09,
					129.82,
					42.98,
					130.32,
					42.76,
					130.36,
					42.69,
					130.58,
					42.24,
					130.77,
					42.2,
					130.44,
					41.59,
					129.79,
					41.36,
					129.91,
					40.74,
					129.78,
					40.6,
					129.29,
					40.38,
					129.14,
					40.23,
					128.75,
					40.09,
					128.7,
					39.87,
					128.22,
					39.92,
					128.04,
					39.79,
					127.94,
					39.68,
					127.63,
					39.24,
					127.73,
					39.03,
					127.98,
					39.11,
					128.05,
					39.07,
					128.17,
					38.91,
					128.15,
					38.8,
					128.37,
					38.2,
					128.7,
					37.73,
					129.14,
					37.11,
					129.52,
					36.68,
					129.58,
					36.17,
					129.51,
					36.16,
					129.62,
					36.02,
					129.69,
					35.42,
					129.53,
					34.96,
					129.16,
					34.94,
					128.92,
					34.72,
					128.83,
					34.42,
					128.47,
					34.52,
					128.32,
					34.44,
					128.16,
					34.59,
					128.08,
					34.6,
					127.91,
					34.33,
					127.89,
					34.3,
					127.76,
					34.44,
					127.62,
					34.12,
					127.46,
					34,
					127.49,
					33.9,
					127.38,
					33.94,
					127.21,
					34.08,
					127.17,
					34.13,
					127.06,
					34.06,
					126.98,
					33.96,
					127.04,
					33.85,
					126.95,
					33.89,
					126.82,
					34.06,
					126.79,
					33.98,
					126.6,
					34.03,
					126.45,
					33.89,
					126.43,
					33.81,
					126.3,
					33.93,
					126.17,
					34.09,
					126.26,
					34.07,
					126.43,
					34.25,
					126.31,
					34.13,
					126.23,
					34.04,
					125.89,
					34.21,
					125.74,
					34.5,
					125.93,
					34.48,
					125.79,
					34.6,
					125.69,
					35,
					125.96,
					35.11,
					125.8,
					35.21,
					125.82,
					35.24,
					125.93,
					35.43,
					125.93,
					35.46,
					126.1,
					35.34,
					126.24,
					35.47,
					126.32,
					35.55,
					126.03,
					35.69,
					126,
					35.77,
					126.08,
					35.73,
					126.28,
					35.91,
					126.27,
					35.96,
					126.41,
					36.12,
					126.32,
					36.24,
					126.42,
					36.18,
					126.19,
					36,
					125.97
				]
			},
			{
				"points": [
					-0.61,
					128.6,
					-0.71,
					128.51,
					-0.67,
					128.32,
					-0.93,
					128.53,
					-1.15,
					128.55,
					-1.26,
					128.41,
					-1.15,
					128.17,
					-0.96,
					128.15,
					-0.88,
					127.96,
					-0.99,
					127.74,
					-0.88,
					127.13,
					-0.24,
					126.9,
					-0.09,
					127.07,
					0.21,
					127.01,
					0.27,
					127.12,
					0.2,
					127.32,
					0.32,
					127.22,
					0.61,
					127.27,
					0.8,
					127.17,
					1.51,
					127.42,
					1.69,
					127.37,
					2.06,
					127.67,
					2.23,
					127.62,
					2.39,
					127.74,
					2.32,
					128.01,
					2.5,
					128.1,
					2.48,
					128.24,
					2.75,
					128.58,
					2.47,
					128.79,
					2.03,
					128.65,
					1.87,
					128.25,
					2.03,
					128.09,
					1.9,
					128.01,
					1.75,
					128.17,
					1.47,
					128.13,
					1.66,
					128.44,
					1.68,
					128.71,
					1.62,
					128.81,
					1.02,
					128.8,
					0.82,
					128.42,
					0.73,
					128.43,
					0.74,
					128.65,
					0.61,
					128.92,
					0.41,
					128.97,
					0.35,
					128.85,
					0.26,
					129.03,
					0.12,
					129.09,
					0.06,
					128.98,
					0.29,
					128.42,
					0.32,
					128,
					0.01,
					127.99,
					-0.49,
					128.22,
					-0.43,
					128.4,
					-0.61,
					128.6
				]
			},
			{
				"points": [
					-3.74,
					128.87,
					-3.81,
					128.77,
					-3.74,
					128.37,
					-3.9,
					128.11,
					-3.87,
					127.88,
					-3.35,
					127.77,
					-3.46,
					127.58,
					-3.4,
					127.43,
					-3.25,
					127.38,
					-3.07,
					127.72,
					-2.96,
					127.72,
					-2.8,
					127.88,
					-2.75,
					128.81,
					-2.61,
					128.97,
					-2.8,
					129.16,
					-2.68,
					129.36,
					-2.67,
					129.56,
					-2.89,
					130.04,
					-2.89,
					130.43,
					-3.04,
					130.64,
					-3.2,
					130.71,
					-3.27,
					130.9,
					-3.58,
					130.98,
					-3.77,
					130.94,
					-3.89,
					131.05,
					-4,
					130.94,
					-3.97,
					130.77,
					-3.58,
					129.95,
					-3.43,
					129.84,
					-3.42,
					129.67,
					-3.57,
					129.49,
					-3.4,
					128.84,
					-3.74,
					128.87
				]
			},
			{
				"points": [
					-8.71,
					124.99,
					-8.55,
					125.06,
					-8.42,
					125.56,
					-8.33,
					125.41,
					-8.23,
					125.4,
					-8.03,
					125.61,
					-7.56,
					125.86,
					-7.44,
					126.59,
					-7.65,
					126.91,
					-7.79,
					126.93,
					-8.08,
					126.47,
					-8.12,
					125.81,
					-8.41,
					125.63,
					-8.39,
					126.21,
					-8.31,
					126.42,
					-8.36,
					126.56,
					-8.22,
					126.96,
					-8.24,
					127.24,
					-8.42,
					127.45,
					-8.79,
					127.05,
					-9.54,
					125.14,
					-9.24,
					124.85,
					-9.11,
					124.93,
					-8.99,
					124.83,
					-8.71,
					124.99
				]
			},
			{
				"points": [
					-7.11,
					134.62,
					-7.19,
					134.54,
					-7.17,
					134.4,
					-6.98,
					134.38,
					-7.02,
					134.15,
					-6.75,
					133.93,
					-5.45,
					134.13,
					-5.21,
					134.55,
					-5.34,
					134.76,
					-5.91,
					134.96,
					-6.3,
					135,
					-7.04,
					134.77,
					-7.11,
					134.62
				]
			},
			{
				"points": [
					-2.48,
					126.14,
					-2.58,
					126.09,
					-2.54,
					125.95,
					-2.22,
					125.77,
					-2.05,
					125.79,
					-2.16,
					124.36,
					-2.02,
					124.19,
					-1.7,
					124.18,
					-1.47,
					124.48,
					-1.73,
					126.54,
					-1.9,
					126.55,
					-2,
					126.1,
					-2.48,
					126.14
				]
			},
			{
				"points": [
					-8.36,
					130.66,
					-8.29,
					130.59,
					-8.18,
					130.62,
					-8.16,
					130.77,
					-7.98,
					130.96,
					-7.42,
					130.72,
					-7.19,
					131.26,
					-6.61,
					131.47,
					-6.57,
					131.69,
					-6.8,
					131.68,
					-7.01,
					131.52,
					-7,
					131.81,
					-6.89,
					132.07,
					-7.31,
					132.05,
					-8.15,
					131.32,
					-8.45,
					130.78,
					-8.36,
					130.66
				]
			},
			{
				"points": [
					-3.94,
					127.31,
					-4.01,
					127.17,
					-3.84,
					127.05,
					-3.94,
					126.71,
					-3.71,
					126.14,
					-3.46,
					125.93,
					-3.16,
					125.9,
					-2.99,
					126.07,
					-2.95,
					126.8,
					-3.12,
					127.15,
					-3.33,
					127.36,
					-3.94,
					127.31
				]
			},
			{
				"points": [
					26.05,
					127.94,
					25.96,
					127.69,
					26.14,
					127.54,
					26.04,
					127.38,
					26.07,
					127.17,
					26.35,
					127.03,
					26.48,
					127.16,
					26.62,
					127.1,
					26.69,
					127.28,
					26.57,
					127.35,
					26.46,
					127.2,
					26.34,
					127.27,
					26.27,
					127.54,
					26.61,
					127.7,
					26.79,
					127.67,
					26.83,
					127.86,
					27.07,
					127.84,
					27.18,
					127.98,
					27.15,
					128.09,
					26.89,
					128.05,
					26.94,
					128.34,
					27.12,
					128.31,
					27.13,
					128.52,
					26.94,
					128.53,
					26.93,
					128.37,
					26.68,
					128.41,
					26.05,
					127.94
				]
			},
			{
				"points": [
					-1.35,
					136.51,
					-1.42,
					136.39,
					-1.29,
					135.82,
					-1.06,
					135.58,
					-1.07,
					135.45,
					-0.71,
					135.29,
					-0.56,
					135.31,
					-0.51,
					135.41,
					-0.6,
					135.9,
					-1.12,
					136.49,
					-1.03,
					136.6,
					-1.14,
					136.78,
					-1.39,
					136.75,
					-1.43,
					136.6,
					-1.35,
					136.51
				]
			},
			{
				"points": [
					-2.32,
					130.68,
					-2.31,
					130.17,
					-2.16,
					130.05,
					-1.9,
					129.55,
					-1.73,
					129.5,
					-1.52,
					129.88,
					-1.67,
					130.01,
					-1.59,
					130.23,
					-1.52,
					130.03,
					-1.38,
					130.01,
					-1.33,
					130.36,
					-1.47,
					130.42,
					-1.57,
					130.3,
					-1.58,
					130.4,
					-1.89,
					130.56,
					-1.96,
					130.72,
					-2.32,
					130.68
				]
			},
			{
				"points": [
					-1.76,
					128.36,
					-1.72,
					128.22,
					-1.82,
					128.13,
					-1.84,
					127.73,
					-1.95,
					127.66,
					-1.95,
					127.5,
					-1.44,
					127.16,
					-1.06,
					127.31,
					-1.12,
					127.73,
					-1.28,
					127.77,
					-1.54,
					128.23,
					-1.51,
					128.39,
					-1.67,
					128.45,
					-1.76,
					128.36
				]
			},
			{
				"points": [
					-6.12,
					132.5,
					-6.13,
					132.38,
					-5.97,
					132.31,
					-5.72,
					132.51,
					-5.57,
					132.5,
					-5.37,
					132.6,
					-5.32,
					132.75,
					-5.53,
					132.89,
					-5.18,
					133.1,
					-5.17,
					133.21,
					-5.57,
					133.23,
					-6.06,
					132.92,
					-6.1,
					132.82,
					-6,
					132.6,
					-6.12,
					132.5
				]
			}
		],
		"transitions": [
			[
				0,
				540,
				[
					"KST",
					"IRKT",
					"PWT",
					"EIT",
					"TLT",
					"JST"
				]
			]
		],
		"name": "Asia/Tokyo"
	},
	{
		"hoverRegion": [
			{
				"points": [
					29.26,
					34.93,
					29.39,
					34.85,
					30.13,
					35.06,
					30.46,
					35.05,
					31.11,
					35.33,
					31.27,
					35.28,
					31.77,
					35.44,
					32.08,
					35.41,
					32.75,
					35.53,
					32.86,
					35.78,
					32.82,
					35.96,
					32.6,
					36.15,
					32.43,
					36.81,
					33.46,
					38.74,
					33.44,
					38.86,
					32.44,
					39.17,
					32.42,
					39.34,
					32.17,
					39.39,
					31.88,
					39.02,
					31.44,
					37.21,
					30.56,
					38.07,
					30.42,
					38.07,
					30.25,
					37.74,
					29.91,
					37.56,
					29.76,
					36.81,
					29.41,
					36.56,
					29.07,
					36.09,
					29.26,
					34.93
				]
			}
		],
		"transitions": [
			[
				1319767200,
				120,
				[
					"EET"
				]
			],
			[
				1333072800,
				180,
				[
					"EEST"
				]
			],
			[
				1351216800,
				120,
				[
					"EET"
				]
			],
			[
				1364522400,
				180,
				[
					"EEST"
				]
			],
			[
				1382666400,
				120,
				[
					"EET"
				]
			],
			[
				1395972000,
				180,
				[
					"EEST"
				]
			],
			[
				1414720800,
				120,
				[
					"EET"
				]
			],
			[
				1427421600,
				180,
				[
					"EEST"
				]
			],
			[
				1446170400,
				120,
				[
					"EET"
				]
			],
			[
				1459476000,
				180,
				[
					"EEST"
				]
			],
			[
				1477620000,
				120,
				[
					"EET"
				]
			],
			[
				1490925600,
				180,
				[
					"EEST"
				]
			],
			[
				1509069600,
				120,
				[
					"EET"
				]
			],
			[
				1522375200,
				180,
				[
					"EEST"
				]
			],
			[
				1540519200,
				120,
				[
					"EET"
				]
			],
			[
				1553824800,
				180,
				[
					"EEST"
				]
			],
			[
				1571968800,
				120,
				[
					"EET"
				]
			],
			[
				1585274400,
				180,
				[
					"EEST"
				]
			],
			[
				1604023200,
				120,
				[
					"EET"
				]
			],
			[
				1616724000,
				180,
				[
					"EEST"
				]
			],
			[
				1635472800,
				120,
				[
					"EET"
				]
			],
			[
				1648778400,
				180,
				[
					"EEST"
				]
			],
			[
				1666922400,
				120,
				[
					"EET"
				]
			],
			[
				1680228000,
				180,
				[
					"EEST"
				]
			],
			[
				1698372000,
				120,
				[
					"EET"
				]
			],
			[
				1711677600,
				180,
				[
					"EEST"
				]
			],
			[
				1729821600,
				120,
				[
					"EET"
				]
			],
			[
				1743127200,
				180,
				[
					"EEST"
				]
			],
			[
				1761876000,
				120,
				[
					"EET"
				]
			],
			[
				1774576800,
				180,
				[
					"EEST"
				]
			],
			[
				1793325600,
				120,
				[
					"EET"
				]
			],
			[
				1806026400,
				180,
				[
					"EEST"
				]
			],
			[
				1824775200,
				120,
				[
					"EET"
				]
			],
			[
				1838080800,
				180,
				[
					"EEST"
				]
			],
			[
				1856224800,
				120,
				[
					"EET"
				]
			],
			[
				1869530400,
				180,
				[
					"EEST"
				]
			],
			[
				1887674400,
				120,
				[
					"EET"
				]
			],
			[
				1900980000,
				180,
				[
					"EEST"
				]
			],
			[
				1919124000,
				120,
				[
					"EET"
				]
			],
			[
				1932429600,
				180,
				[
					"EEST"
				]
			],
			[
				1951178400,
				120,
				[
					"EET"
				]
			],
			[
				1963879200,
				180,
				[
					"EEST"
				]
			],
			[
				1982628000,
				120,
				[
					"EET"
				]
			],
			[
				1995933600,
				180,
				[
					"EEST"
				]
			],
			[
				2014077600,
				120,
				[
					"EET"
				]
			],
			[
				2027383200,
				180,
				[
					"EEST"
				]
			],
			[
				2045527200,
				120,
				[
					"EET"
				]
			],
			[
				2058832800,
				180,
				[
					"EEST"
				]
			],
			[
				2076976800,
				120,
				[
					"EET"
				]
			],
			[
				2090282400,
				180,
				[
					"EEST"
				]
			],
			[
				2109031200,
				120,
				[
					"EET"
				]
			],
			[
				2121732000,
				180,
				[
					"EEST"
				]
			],
			[
				2140480800,
				120,
				[
					"EET"
				]
			]
		],
		"name": "Asia/Amman"
	},
	{
		"hoverRegion": [
			{
				"points": [
					25.99,
					-109.53,
					26.4,
					-109.31,
					26.9,
					-108.58,
					27.03,
					-108.72,
					27.47,
					-108.76,
					28.18,
					-109.25,
					28.38,
					-109.04,
					28.33,
					-108.69,
					28.66,
					-108.79,
					28.8,
					-108.73,
					29.38,
					-108.81,
					29.5,
					-108.71,
					29.98,
					-108.66,
					31.14,
					-108.89,
					31.22,
					-108.79,
					31.2,
					-108.11,
					31.68,
					-108.04,
					31.67,
					-106.63,
					31.32,
					-106.27,
					31.01,
					-105.73,
					30.75,
					-105.52,
					30.5,
					-105.06,
					29.53,
					-104.62,
					29.16,
					-104.09,
					28.83,
					-103.35,
					28.71,
					-103.33,
					27.85,
					-103.83,
					26.68,
					-103.52,
					26.57,
					-103.56,
					26.64,
					-104.15,
					26.24,
					-104.59,
					26.37,
					-104.86,
					26.36,
					-105.37,
					26.7,
					-106.02,
					26.35,
					-106.15,
					26.29,
					-106.3,
					26.14,
					-106.25,
					25.96,
					-106.41,
					25.73,
					-106.43,
					25.51,
					-106.7,
					25.5,
					-107,
					25.14,
					-106.98,
					24.91,
					-106.86,
					24.65,
					-106.56,
					24.41,
					-106.46,
					24.49,
					-106.22,
					24.27,
					-105.91,
					23.34,
					-105.58,
					23.15,
					-105.3,
					23,
					-104.84,
					22.78,
					-104.77,
					22.69,
					-104.57,
					22.57,
					-104.53,
					22.51,
					-104.25,
					22.31,
					-104.2,
					22.1,
					-104.27,
					21.82,
					-103.99,
					21.58,
					-104.06,
					21.35,
					-103.83,
					21.12,
					-103.97,
					21.08,
					-104.12,
					20.62,
					-104.21,
					20.61,
					-104.33,
					20.9,
					-104.78,
					20.82,
					-105.02,
					20.62,
					-105.22,
					20.81,
					-105.49,
					20.92,
					-105.52,
					21.11,
					-105.34,
					21.4,
					-105.31,
					21.56,
					-105.55,
					21.93,
					-105.75,
					22.34,
					-105.79,
					22.57,
					-105.9,
					23.1,
					-106.51,
					23.84,
					-107.05,
					24.55,
					-108.05,
					25.21,
					-108.6,
					25.33,
					-109.05,
					25.5,
					-109.2,
					25.54,
					-109.46,
					25.99,
					-109.53
				]
			},
			{
				"points": [
					24.13,
					-109.69,
					23.74,
					-109.59,
					23.49,
					-109.29,
					23.21,
					-109.32,
					22.8,
					-109.76,
					22.77,
					-110.01,
					23.5,
					-110.41,
					24.22,
					-111.49,
					24.21,
					-111.77,
					24.72,
					-112.38,
					25.73,
					-112.2,
					26.13,
					-112.45,
					26.22,
					-112.73,
					26.66,
					-113.36,
					26.6,
					-113.62,
					26.85,
					-113.88,
					27.05,
					-114.44,
					27.17,
					-114.57,
					27.34,
					-114.61,
					27.81,
					-115.28,
					27.95,
					-115.3,
					28,
					-115.21,
					27.88,
					-114.51,
					28.1,
					-114.2,
					28.09,
					-112.71,
					27.82,
					-112.6,
					27.62,
					-112.27,
					27.34,
					-112.14,
					27.36,
					-112.07,
					27.53,
					-112.06,
					27.54,
					-111.9,
					27.38,
					-111.86,
					27.32,
					-112,
					27.12,
					-111.82,
					27,
					-111.81,
					26.7,
					-111.33,
					26.21,
					-111.25,
					26.11,
					-110.99,
					25.93,
					-110.97,
					25.81,
					-111.05,
					25.7,
					-110.92,
					25.8,
					-110.84,
					25.73,
					-110.71,
					25.49,
					-110.74,
					25.59,
					-110.94,
					25.32,
					-110.84,
					25.42,
					-110.71,
					25.38,
					-110.61,
					25.15,
					-110.6,
					25.03,
					-110.46,
					24.77,
					-110.48,
					24.59,
					-110.62,
					24.36,
					-110.53,
					24.32,
					-110.43,
					24.49,
					-110.51,
					24.66,
					-110.48,
					24.71,
					-110.38,
					24.31,
					-110.01,
					24.43,
					-110.01,
					24.46,
					-109.87,
					24.13,
					-109.69
				]
			},
			{
				"points": [
					21.23,
					-106.1,
					21.15,
					-106.24,
					21.3,
					-106.4,
					21.35,
					-106.61,
					21.54,
					-106.74,
					21.78,
					-106.8,
					21.89,
					-106.75,
					21.92,
					-106.64,
					21.76,
					-106.46,
					21.6,
					-106.42,
					21.41,
					-106.12,
					21.23,
					-106.1
				]
			},
			{
				"points": [
					18.61,
					-110.88,
					18.58,
					-110.99,
					18.72,
					-111.15,
					18.94,
					-111.03,
					18.78,
					-110.81,
					18.61,
					-110.88
				]
			}
		],
		"transitions": [
			[
				1319976000,
				-420,
				[
					"MST"
				]
			],
			[
				1333285200,
				-360,
				[
					"MDT"
				]
			],
			[
				1351425600,
				-420,
				[
					"MST"
				]
			],
			[
				1365339600,
				-360,
				[
					"MDT"
				]
			],
			[
				1382875200,
				-420,
				[
					"MST"
				]
			],
			[
				1396789200,
				-360,
				[
					"MDT"
				]
			],
			[
				1414324800,
				-420,
				[
					"MST"
				]
			],
			[
				1428238800,
				-360,
				[
					"MDT"
				]
			],
			[
				1445774400,
				-420,
				[
					"MST"
				]
			],
			[
				1459688400,
				-360,
				[
					"MDT"
				]
			],
			[
				1477828800,
				-420,
				[
					"MST"
				]
			],
			[
				1491138000,
				-360,
				[
					"MDT"
				]
			],
			[
				1509278400,
				-420,
				[
					"MST"
				]
			],
			[
				1522587600,
				-360,
				[
					"MDT"
				]
			],
			[
				1540728000,
				-420,
				[
					"MST"
				]
			],
			[
				1554642000,
				-360,
				[
					"MDT"
				]
			],
			[
				1572177600,
				-420,
				[
					"MST"
				]
			],
			[
				1586091600,
				-360,
				[
					"MDT"
				]
			],
			[
				1603627200,
				-420,
				[
					"MST"
				]
			],
			[
				1617541200,
				-360,
				[
					"MDT"
				]
			],
			[
				1635681600,
				-420,
				[
					"MST"
				]
			],
			[
				1648990800,
				-360,
				[
					"MDT"
				]
			],
			[
				1667131200,
				-420,
				[
					"MST"
				]
			],
			[
				1680440400,
				-360,
				[
					"MDT"
				]
			],
			[
				1698580800,
				-420,
				[
					"MST"
				]
			],
			[
				1712494800,
				-360,
				[
					"MDT"
				]
			],
			[
				1730030400,
				-420,
				[
					"MST"
				]
			],
			[
				1743944400,
				-360,
				[
					"MDT"
				]
			],
			[
				1761480000,
				-420,
				[
					"MST"
				]
			],
			[
				1775394000,
				-360,
				[
					"MDT"
				]
			],
			[
				1792929600,
				-420,
				[
					"MST"
				]
			],
			[
				1806843600,
				-360,
				[
					"MDT"
				]
			],
			[
				1824984000,
				-420,
				[
					"MST"
				]
			],
			[
				1838293200,
				-360,
				[
					"MDT"
				]
			],
			[
				1856433600,
				-420,
				[
					"MST"
				]
			],
			[
				1869742800,
				-360,
				[
					"MDT"
				]
			],
			[
				1887883200,
				-420,
				[
					"MST"
				]
			],
			[
				1901797200,
				-360,
				[
					"MDT"
				]
			],
			[
				1919332800,
				-420,
				[
					"MST"
				]
			],
			[
				1933246800,
				-360,
				[
					"MDT"
				]
			],
			[
				1950782400,
				-420,
				[
					"MST"
				]
			],
			[
				1964696400,
				-360,
				[
					"MDT"
				]
			],
			[
				1982836800,
				-420,
				[
					"MST"
				]
			],
			[
				1996146000,
				-360,
				[
					"MDT"
				]
			],
			[
				2014286400,
				-420,
				[
					"MST"
				]
			],
			[
				2027595600,
				-360,
				[
					"MDT"
				]
			],
			[
				2045736000,
				-420,
				[
					"MST"
				]
			],
			[
				2059045200,
				-360,
				[
					"MDT"
				]
			],
			[
				2077185600,
				-420,
				[
					"MST"
				]
			],
			[
				2091099600,
				-360,
				[
					"MDT"
				]
			],
			[
				2108635200,
				-420,
				[
					"MST"
				]
			],
			[
				2122549200,
				-360,
				[
					"MDT"
				]
			],
			[
				2140084800,
				-420,
				[
					"MST"
				]
			]
		],
		"name": "America/Mazatlan"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-20.59,
					-174.68,
					-20.59,
					-174.79,
					-20.48,
					-174.87,
					-20.2,
					-174.91,
					-20.13,
					-174.73,
					-20.06,
					-174.87,
					-19.92,
					-174.9,
					-19.67,
					-174.8,
					-19.65,
					-174.6,
					-19.48,
					-174.43,
					-19.56,
					-174.23,
					-19.71,
					-174.16,
					-20.02,
					-174.38,
					-20.05,
					-174.55,
					-20.28,
					-174.41,
					-20.42,
					-174.42,
					-20.59,
					-174.68
				]
			},
			{
				"points": [
					-21.56,
					-174.91,
					-21.52,
					-175.04,
					-21.34,
					-175.06,
					-21.37,
					-175.16,
					-21.21,
					-175.42,
					-20.97,
					-175.39,
					-20.9,
					-175.17,
					-20.94,
					-174.92,
					-21.34,
					-174.79,
					-21.5,
					-174.81,
					-21.56,
					-174.91
				]
			},
			{
				"points": [
					-19.06,
					-173.91,
					-19.08,
					-174.09,
					-18.92,
					-174.08,
					-18.78,
					-174.28,
					-18.62,
					-174.22,
					-18.45,
					-173.94,
					-18.5,
					-173.84,
					-18.68,
					-173.81,
					-19.06,
					-173.91
				]
			},
			{
				"points": [
					-19.86,
					-175,
					-19.88,
					-175.11,
					-19.75,
					-175.22,
					-19.53,
					-175.02,
					-19.65,
					-174.9,
					-19.86,
					-175
				]
			}
		],
		"transitions": [
			[
				0,
				780,
				[
					"PHOT",
					"TOT"
				]
			]
		],
		"name": "Pacific/Enderbury"
	},
	{
		"hoverRegion": [
			{
				"points": [
					18.81,
					-155.62,
					18.82,
					-155.74,
					19.03,
					-156,
					19.76,
					-156.15,
					20.22,
					-156.01,
					20.37,
					-155.83,
					20.05,
					-155.13,
					19.54,
					-154.7,
					19.26,
					-154.91,
					18.81,
					-155.62
				]
			},
			{
				"points": [
					20.39,
					-156.65,
					20.53,
					-156.77,
					20.67,
					-156.64,
					20.76,
					-156.72,
					20.65,
					-156.8,
					20.64,
					-157,
					20.86,
					-157.16,
					20.97,
					-157.14,
					21.04,
					-157.39,
					21.31,
					-157.31,
					21.26,
					-156.68,
					21.13,
					-156.6,
					21.04,
					-156.19,
					20.85,
					-155.9,
					20.63,
					-155.91,
					20.39,
					-156.65
				]
			},
			{
				"points": [
					-17.22,
					-144.23,
					-17.24,
					-144.39,
					-17.11,
					-144.52,
					-17.02,
					-144.51,
					-17.1,
					-144.63,
					-17.04,
					-144.79,
					-16.82,
					-144.84,
					-16.93,
					-144.95,
					-16.79,
					-145.4,
					-16.55,
					-145.55,
					-16.45,
					-145.51,
					-16.38,
					-145.57,
					-16.18,
					-145.9,
					-16.05,
					-146.02,
					-15.91,
					-146.02,
					-15.91,
					-146.28,
					-15.78,
					-146.29,
					-15.69,
					-145.98,
					-15.78,
					-145.83,
					-15.98,
					-145.76,
					-15.96,
					-145.55,
					-16.38,
					-145.24,
					-16.51,
					-145.23,
					-16.58,
					-145.33,
					-16.74,
					-144.84,
					-16.68,
					-144.67,
					-16.82,
					-144.48,
					-16.98,
					-144.47,
					-16.94,
					-144.33,
					-17.01,
					-144.19,
					-17.22,
					-144.23
				]
			},
			{
				"points": [
					-15.4,
					-147.38,
					-15.39,
					-147.53,
					-15.29,
					-147.59,
					-15.31,
					-147.82,
					-15.16,
					-147.88,
					-15.17,
					-147.98,
					-14.95,
					-148.21,
					-14.84,
					-148.22,
					-14.8,
					-148.06,
					-14.89,
					-147.96,
					-14.8,
					-147.84,
					-14.87,
					-147.56,
					-15.25,
					-147.11,
					-15.36,
					-147.15,
					-15.4,
					-147.38
				]
			}
		],
		"transitions": [
			[
				0,
				-600,
				[
					"HST",
					"CKT",
					"TKT",
					"TAHT"
				]
			]
		],
		"name": "Pacific/Fakaofo"
	},
	{
		"hoverRegion": [
			{
				"points": [
					46.64,
					-56.21,
					46.79,
					-56.52,
					47.16,
					-56.51,
					47.25,
					-56.37,
					47.1,
					-56.17,
					46.83,
					-56.07,
					46.7,
					-56.08,
					46.64,
					-56.21
				]
			}
		],
		"transitions": [
			[
				1320570000,
				-180,
				[
					"PMST"
				]
			],
			[
				1331456400,
				-120,
				[
					"PMDT"
				]
			],
			[
				1352019600,
				-180,
				[
					"PMST"
				]
			],
			[
				1362906000,
				-120,
				[
					"PMDT"
				]
			],
			[
				1383469200,
				-180,
				[
					"PMST"
				]
			],
			[
				1394355600,
				-120,
				[
					"PMDT"
				]
			],
			[
				1414918800,
				-180,
				[
					"PMST"
				]
			],
			[
				1425805200,
				-120,
				[
					"PMDT"
				]
			],
			[
				1446368400,
				-180,
				[
					"PMST"
				]
			],
			[
				1457859600,
				-120,
				[
					"PMDT"
				]
			],
			[
				1478422800,
				-180,
				[
					"PMST"
				]
			],
			[
				1489309200,
				-120,
				[
					"PMDT"
				]
			],
			[
				1509872400,
				-180,
				[
					"PMST"
				]
			],
			[
				1520758800,
				-120,
				[
					"PMDT"
				]
			],
			[
				1541322000,
				-180,
				[
					"PMST"
				]
			],
			[
				1552208400,
				-120,
				[
					"PMDT"
				]
			],
			[
				1572771600,
				-180,
				[
					"PMST"
				]
			],
			[
				1583658000,
				-120,
				[
					"PMDT"
				]
			],
			[
				1604221200,
				-180,
				[
					"PMST"
				]
			],
			[
				1615712400,
				-120,
				[
					"PMDT"
				]
			],
			[
				1636275600,
				-180,
				[
					"PMST"
				]
			],
			[
				1647162000,
				-120,
				[
					"PMDT"
				]
			],
			[
				1667725200,
				-180,
				[
					"PMST"
				]
			],
			[
				1678611600,
				-120,
				[
					"PMDT"
				]
			],
			[
				1699174800,
				-180,
				[
					"PMST"
				]
			],
			[
				1710061200,
				-120,
				[
					"PMDT"
				]
			],
			[
				1730624400,
				-180,
				[
					"PMST"
				]
			],
			[
				1741510800,
				-120,
				[
					"PMDT"
				]
			],
			[
				1762074000,
				-180,
				[
					"PMST"
				]
			],
			[
				1772960400,
				-120,
				[
					"PMDT"
				]
			],
			[
				1793523600,
				-180,
				[
					"PMST"
				]
			],
			[
				1805014800,
				-120,
				[
					"PMDT"
				]
			],
			[
				1825578000,
				-180,
				[
					"PMST"
				]
			],
			[
				1836464400,
				-120,
				[
					"PMDT"
				]
			],
			[
				1857027600,
				-180,
				[
					"PMST"
				]
			],
			[
				1867914000,
				-120,
				[
					"PMDT"
				]
			],
			[
				1888477200,
				-180,
				[
					"PMST"
				]
			],
			[
				1899363600,
				-120,
				[
					"PMDT"
				]
			],
			[
				1919926800,
				-180,
				[
					"PMST"
				]
			],
			[
				1930813200,
				-120,
				[
					"PMDT"
				]
			],
			[
				1951376400,
				-180,
				[
					"PMST"
				]
			],
			[
				1962867600,
				-120,
				[
					"PMDT"
				]
			],
			[
				1983430800,
				-180,
				[
					"PMST"
				]
			],
			[
				1994317200,
				-120,
				[
					"PMDT"
				]
			],
			[
				2014880400,
				-180,
				[
					"PMST"
				]
			],
			[
				2025766800,
				-120,
				[
					"PMDT"
				]
			],
			[
				2046330000,
				-180,
				[
					"PMST"
				]
			],
			[
				2057216400,
				-120,
				[
					"PMDT"
				]
			],
			[
				2077779600,
				-180,
				[
					"PMST"
				]
			],
			[
				2088666000,
				-120,
				[
					"PMDT"
				]
			],
			[
				2109229200,
				-180,
				[
					"PMST"
				]
			],
			[
				2120115600,
				-120,
				[
					"PMDT"
				]
			],
			[
				2140678800,
				-180,
				[
					"PMST"
				]
			]
		],
		"name": "America/Miquelon"
	},
	{
		"hoverRegion": [
			{
				"points": [
					28.93,
					-90.88,
					28.96,
					-91.02,
					29.08,
					-91.06,
					29.16,
					-91.35,
					29.42,
					-91.44,
					29.4,
					-91.58,
					29.48,
					-91.65,
					29.37,
					-91.75,
					29.47,
					-92.04,
					29.42,
					-92.32,
					29.64,
					-93.12,
					29.56,
					-94.02,
					29.3,
					-94.62,
					28.77,
					-95.32,
					28.3,
					-96.3,
					27.78,
					-96.94,
					25.62,
					-97.09,
					25.46,
					-97.26,
					25.46,
					-97.5,
					25.67,
					-97.89,
					25.66,
					-98.22,
					26.09,
					-99.32,
					26.34,
					-99.5,
					26.6,
					-99.56,
					26.84,
					-99.8,
					27.38,
					-99.92,
					27.5,
					-100.13,
					27.79,
					-100.28,
					28.05,
					-100.61,
					28.86,
					-100.97,
					29.38,
					-101.63,
					29.38,
					-102.41,
					28.97,
					-102.57,
					28.61,
					-103.02,
					28.65,
					-103.45,
					28.77,
					-103.53,
					28.93,
					-103.44,
					29.22,
					-104.1,
					29.57,
					-104.59,
					29.87,
					-104.77,
					30.19,
					-104.81,
					30.6,
					-105.08,
					30.83,
					-105.01,
					32.08,
					-104.99,
					32.1,
					-103.17,
					37.04,
					-103.1,
					37.1,
					-103.01,
					37.1,
					-102.15,
					37.81,
					-102.12,
					37.84,
					-101.64,
					38.69,
					-101.67,
					38.79,
					-101.59,
					39.45,
					-101.5,
					39.49,
					-102.12,
					40,
					-102.15,
					40.1,
					-102.05,
					40.11,
					-101.43,
					40.69,
					-101.45,
					40.79,
					-101.35,
					41.03,
					-101.35,
					41.28,
					-101.37,
					41.35,
					-101.5,
					41.78,
					-101.5,
					41.84,
					-101.41,
					41.84,
					-100.95,
					42.18,
					-100.89,
					42.88,
					-100.99,
					42.95,
					-101.32,
					43.82,
					-101.33,
					43.92,
					-101.17,
					44.25,
					-101.12,
					44.27,
					-100.6,
					44.35,
					-100.53,
					44.41,
					-100.67,
					44.81,
					-100.83,
					44.89,
					-100.76,
					44.91,
					-100.51,
					45.03,
					-100.52,
					45.24,
					-100.37,
					45.39,
					-100.43,
					45.49,
					-100.58,
					45.72,
					-100.43,
					45.8,
					-100.48,
					45.85,
					-101.4,
					45.91,
					-101.45,
					46.15,
					-101.41,
					46.25,
					-101.31,
					46.63,
					-102.17,
					47.47,
					-102.3,
					47.4,
					-102.5,
					47.54,
					-102.97,
					47.47,
					-103.03,
					47.41,
					-103.64,
					47.52,
					-103.82,
					47.73,
					-103.9,
					47.76,
					-104.03,
					47.99,
					-104.15,
					48.99,
					-104.15,
					49.09,
					-104.09,
					49.1,
					-101.47,
					53.97,
					-101.86,
					54.17,
					-102.32,
					54.5,
					-102.6,
					54.82,
					-102.57,
					55.07,
					-102.32,
					55.18,
					-102.02,
					55.79,
					-102.11,
					67,
					-102.1,
					67.1,
					-102,
					67.1,
					-89.1,
					69.27,
					-89.1,
					69.37,
					-88.99,
					68.81,
					-87.84,
					68.24,
					-87.69,
					68.24,
					-87.54,
					68.11,
					-87.45,
					68.02,
					-87.57,
					68.05,
					-87.71,
					68.18,
					-87.76,
					68.1,
					-87.88,
					68.13,
					-88.14,
					67.98,
					-88.22,
					67.77,
					-88.04,
					67.46,
					-87.4,
					67.29,
					-87.26,
					67.46,
					-87.07,
					67.5,
					-86.66,
					67.65,
					-86.73,
					67.79,
					-86.97,
					68.14,
					-87.04,
					68.41,
					-86.63,
					68.28,
					-86.31,
					68.03,
					-86.24,
					68.16,
					-85.98,
					68.69,
					-85.79,
					68.94,
					-85.48,
					69.05,
					-85.56,
					69.17,
					-85.48,
					69.28,
					-85.58,
					69.9,
					-85.64,
					70.06,
					-86.34,
					69.91,
					-86.41,
					69.9,
					-87.15,
					70.04,
					-87.44,
					70.21,
					-87.47,
					70.14,
					-87.95,
					70.4,
					-88.82,
					70.73,
					-89.4,
					70.89,
					-89.52,
					70.98,
					-89.49,
					71.1,
					-89.63,
					71.2,
					-89.53,
					71.18,
					-89.04,
					71.27,
					-89.94,
					71.59,
					-90.13,
					71.75,
					-90,
					71.96,
					-90.21,
					72.18,
					-90,
					72.31,
					-90.06,
					72.47,
					-90.01,
					72.76,
					-89.67,
					72.88,
					-89.63,
					72.93,
					-89.43,
					73.04,
					-89.44,
					73.27,
					-89.21,
					73.75,
					-88.03,
					73.96,
					-86.53,
					73.9,
					-84.99,
					73.8,
					-84.89,
					73.57,
					-84.92,
					73.24,
					-85.91,
					72.76,
					-86.58,
					72.51,
					-86.17,
					72.39,
					-86.13,
					72.4,
					-85.8,
					72.31,
					-85.74,
					72.37,
					-85.46,
					72.46,
					-85.68,
					72.69,
					-85.8,
					72.63,
					-85.88,
					72.67,
					-86.02,
					72.81,
					-86.04,
					72.86,
					-85.88,
					72.78,
					-85.8,
					72.95,
					-85.78,
					73.22,
					-85.48,
					73.25,
					-85.28,
					73.45,
					-85.01,
					73.4,
					-84.9,
					71.65,
					-84.89,
					71.56,
					-85.04,
					71.44,
					-84.89,
					70.07,
					-84.89,
					69.92,
					-85.13,
					69.89,
					-84.94,
					69.8,
					-84.89,
					66.2,
					-84.92,
					66.13,
					-85.02,
					66.17,
					-85.28,
					66.28,
					-85.41,
					66.41,
					-85.39,
					66.47,
					-85.46,
					66.34,
					-85.89,
					66.42,
					-86.49,
					66.25,
					-85.82,
					66.12,
					-85.74,
					65.94,
					-85.88,
					65.8,
					-86.32,
					65.68,
					-86.32,
					65.57,
					-86.45,
					65.34,
					-86.99,
					65.22,
					-86.79,
					65.09,
					-86.81,
					64.67,
					-87.21,
					64.63,
					-87.4,
					64.48,
					-87.48,
					64.41,
					-87.71,
					64.11,
					-87.89,
					63.89,
					-88.54,
					63.91,
					-88.92,
					63.81,
					-89.27,
					63.89,
					-89.73,
					63.53,
					-90.11,
					63.51,
					-90.45,
					63.22,
					-90.45,
					62.98,
					-90.55,
					62.81,
					-90.78,
					62.77,
					-91.13,
					62.75,
					-90.9,
					62.58,
					-90.88,
					62.55,
					-91.17,
					62.7,
					-91.53,
					62.62,
					-91.46,
					62.52,
					-91.51,
					62.52,
					-91.78,
					62.42,
					-91.98,
					62.19,
					-92.09,
					62.26,
					-92.36,
					61.92,
					-92.39,
					61.88,
					-92.56,
					61.73,
					-92.61,
					61.78,
					-92.82,
					61.68,
					-92.93,
					61.74,
					-93.09,
					61.5,
					-93.64,
					61.39,
					-93.61,
					61.23,
					-93.77,
					61.07,
					-93.76,
					60.95,
					-94.09,
					60.81,
					-94.14,
					60.44,
					-94.55,
					60.08,
					-94.6,
					59.96,
					-94.69,
					59.76,
					-94.62,
					59.59,
					-94.68,
					59.37,
					-94.56,
					59.08,
					-94.69,
					59.04,
					-94.54,
					58.85,
					-94.39,
					58.92,
					-94.21,
					58.91,
					-93.26,
					58.82,
					-93.09,
					58.54,
					-93.01,
					58.21,
					-92.75,
					58.11,
					-92.76,
					57.41,
					-92.33,
					57.16,
					-92.4,
					57.36,
					-90.82,
					56.96,
					-89.53,
					56.95,
					-88.98,
					56.88,
					-88.88,
					56.77,
					-88.92,
					56.15,
					-89.89,
					54.1,
					-89.89,
					54.1,
					-88.96,
					53.67,
					-88.4,
					53.33,
					-88.4,
					52.94,
					-88.89,
					52.64,
					-88.95,
					52.64,
					-89.89,
					51.92,
					-89.91,
					51.65,
					-90.43,
					51.45,
					-90.64,
					51.29,
					-90.64,
					51.09,
					-90.43,
					50.78,
					-89.89,
					49.45,
					-89.9,
					49.16,
					-90.89,
					48.89,
					-90.95,
					48.89,
					-91.64,
					48.57,
					-91.68,
					48.48,
					-91.97,
					48.41,
					-91.85,
					48.32,
					-91.85,
					48.16,
					-91.53,
					48.35,
					-90.86,
					48.19,
					-90.7,
					48.21,
					-90.15,
					48.1,
					-89.89,
					48.09,
					-89.46,
					47.96,
					-89.41,
					47.51,
					-90.67,
					46.79,
					-91.85,
					46.96,
					-91.13,
					47.17,
					-90.76,
					47.18,
					-90.37,
					47.1,
					-90.28,
					46.98,
					-90.29,
					46.8,
					-90.36,
					46.71,
					-90.55,
					46.68,
					-90.5,
					46.87,
					-89.86,
					46.61,
					-89.63,
					46.58,
					-89.29,
					46.44,
					-89.25,
					46.44,
					-89.09,
					46.52,
					-88.99,
					46.52,
					-88.08,
					46.35,
					-88.01,
					46.34,
					-87.57,
					46.09,
					-87.51,
					46.03,
					-87.27,
					45.52,
					-87.16,
					45.31,
					-87.3,
					45.39,
					-87.04,
					45.5,
					-86.99,
					45.49,
					-86.72,
					45.33,
					-86.71,
					45.19,
					-86.9,
					44.51,
					-87.35,
					44.17,
					-87.39,
					44.03,
					-87.54,
					43.63,
					-87.59,
					43.21,
					-87.79,
					42.79,
					-87.64,
					42.31,
					-87.71,
					41.84,
					-87.47,
					41.75,
					-87.37,
					41.86,
					-86.5,
					41.44,
					-86.36,
					41.1,
					-86.38,
					41.06,
					-86.82,
					40.87,
					-86.82,
					40.66,
					-87.02,
					40.62,
					-87.41,
					39.35,
					-87.42,
					39.14,
					-87.52,
					38.96,
					-87.4,
					38.63,
					-87.44,
					38.33,
					-87.2,
					38.37,
					-86.57,
					38.3,
					-86.4,
					38.05,
					-86.32,
					37.85,
					-86.05,
					37.67,
					-86.1,
					37.56,
					-85.99,
					37.57,
					-85.54,
					37.33,
					-85.32,
					37.38,
					-85.07,
					37,
					-84.72,
					36.8,
					-84.93,
					36.73,
					-84.91,
					36.69,
					-84.72,
					36.41,
					-84.55,
					36.18,
					-84.76,
					35.85,
					-84.58,
					35.49,
					-85.02,
					34.96,
					-85.3,
					34.9,
					-85.47,
					32.89,
					-85.08,
					32.28,
					-84.78,
					32.07,
					-84.96,
					31.84,
					-85.02,
					31.52,
					-84.93,
					31.21,
					-84.99,
					30.69,
					-84.74,
					30.14,
					-85.02,
					30.02,
					-84.92,
					29.73,
					-84.94,
					29.67,
					-85.15,
					30.11,
					-85.92,
					30.26,
					-86.39,
					30.08,
					-88.42,
					30.14,
					-88.8,
					29.9,
					-88.7,
					29.65,
					-88.79,
					29.38,
					-89.09,
					29.21,
					-88.91,
					28.89,
					-89.07,
					28.93,
					-89.24,
					28.82,
					-89.45,
					29.11,
					-89.53,
					29.19,
					-89.81,
					28.97,
					-90.21,
					28.93,
					-90.88
				]
			},
			{
				"points": [
					74.65,
					-88.64,
					74.54,
					-88.82,
					74.63,
					-88.98,
					74.48,
					-89.15,
					74.42,
					-89.7,
					74.59,
					-91.02,
					74.51,
					-91.13,
					74.6,
					-91.95,
					74.73,
					-92.16,
					74.86,
					-92.16,
					75.07,
					-92.35,
					75.17,
					-92.6,
					75.49,
					-92.49,
					75.63,
					-92.2,
					75.69,
					-92.29,
					75.79,
					-92.29,
					75.92,
					-92.72,
					76.05,
					-92.75,
					76.24,
					-93.12,
					76.21,
					-93.53,
					76.13,
					-93.64,
					76.19,
					-94.72,
					76.07,
					-94.61,
					76.06,
					-94.42,
					75.85,
					-94.19,
					75.74,
					-94.16,
					75.68,
					-94.24,
					75.32,
					-93.38,
					75.05,
					-93.38,
					74.9,
					-93.28,
					74.57,
					-93.45,
					74.52,
					-94.69,
					74.69,
					-95.3,
					74.6,
					-95.14,
					74.46,
					-95.15,
					74.38,
					-95.35,
					74.43,
					-95.7,
					74.57,
					-95.94,
					74.67,
					-95.89,
					74.71,
					-95.71,
					74.77,
					-96.03,
					74.65,
					-96.06,
					74.61,
					-96.26,
					74.75,
					-96.46,
					74.89,
					-96.47,
					74.92,
					-96.69,
					75.02,
					-96.72,
					75.29,
					-96.5,
					75.24,
					-96.81,
					75.3,
					-97.01,
					75.13,
					-97.13,
					75.3,
					-97.35,
					75.19,
					-97.46,
					74.96,
					-97.47,
					74.89,
					-97.64,
					75,
					-97.78,
					74.91,
					-97.96,
					74.85,
					-98.56,
					74.91,
					-100.36,
					75.13,
					-100.62,
					75.23,
					-100.62,
					75.26,
					-100.82,
					75.39,
					-100.87,
					75.47,
					-101.04,
					75.4,
					-101.42,
					75.47,
					-101.56,
					75.47,
					-102.07,
					75.99,
					-102.1,
					76.1,
					-102,
					76.16,
					-102.09,
					76.42,
					-102.1,
					76.51,
					-102.04,
					76.52,
					-101.89,
					76.68,
					-101.88,
					76.76,
					-101.38,
					76.91,
					-101.29,
					76.9,
					-101.16,
					76.81,
					-101.09,
					76.86,
					-99.64,
					76.74,
					-99.29,
					76.79,
					-98.53,
					76.73,
					-98.02,
					76.57,
					-97.59,
					76.41,
					-97.53,
					76.37,
					-97.41,
					76.11,
					-97.35,
					75.97,
					-97.46,
					75.8,
					-97.46,
					75.77,
					-97.29,
					75.63,
					-97.24,
					75.56,
					-97.09,
					75.7,
					-97.03,
					75.75,
					-96.78,
					75.88,
					-96.7,
					75.93,
					-96.32,
					75.9,
					-96.18,
					75.74,
					-96.2,
					75.61,
					-95.79,
					75.65,
					-95.58,
					75.76,
					-95.58,
					75.82,
					-95.49,
					75.81,
					-95.33,
					75.7,
					-95.28,
					75.75,
					-94.89,
					75.93,
					-94.96,
					76.11,
					-95.24,
					76.12,
					-95.42,
					76.27,
					-95.5,
					76.36,
					-96.09,
					76.26,
					-96.13,
					76.25,
					-96.28,
					76.38,
					-96.35,
					76.5,
					-96.23,
					76.44,
					-96.43,
					76.63,
					-97.01,
					76.43,
					-96.99,
					76.35,
					-97.2,
					76.54,
					-97.34,
					76.71,
					-97.18,
					76.86,
					-97.31,
					76.89,
					-97.53,
					77.04,
					-97.55,
					77.1,
					-97.08,
					77.06,
					-96.49,
					77.14,
					-96.4,
					77.16,
					-96.04,
					77.3,
					-96,
					77.34,
					-95.65,
					77.29,
					-95.13,
					77.13,
					-95.1,
					77.03,
					-94.42,
					77.07,
					-94.27,
					77,
					-94.17,
					77.02,
					-93.67,
					76.84,
					-93.13,
					76.72,
					-93.07,
					76.76,
					-90.97,
					76.7,
					-90.69,
					76.82,
					-90.66,
					76.93,
					-90.25,
					76.9,
					-89.8,
					76.71,
					-89.58,
					76.83,
					-89.6,
					76.91,
					-89.53,
					77.22,
					-88.42,
					77.21,
					-87.49,
					77.25,
					-87.76,
					77.46,
					-87.87,
					77.57,
					-88.29,
					77.89,
					-88.31,
					77.96,
					-88.22,
					78,
					-87.3,
					78.09,
					-87.61,
					78.44,
					-87.61,
					78.76,
					-86.99,
					78.53,
					-87.57,
					78.56,
					-87.75,
					78.12,
					-88.31,
					78.29,
					-88.49,
					78.03,
					-88.82,
					78.17,
					-89.33,
					78.05,
					-89.45,
					78.21,
					-90.2,
					78.07,
					-90.24,
					78.02,
					-90.47,
					78.1,
					-92.12,
					78.37,
					-93.02,
					78.48,
					-93.09,
					78.47,
					-93.33,
					78.94,
					-94.41,
					79.07,
					-94.36,
					79.15,
					-93.67,
					79.28,
					-93.45,
					79.09,
					-94.39,
					79.3,
					-95.78,
					79.53,
					-95.86,
					79.68,
					-96.6,
					80.11,
					-96.89,
					80.24,
					-96.75,
					80.39,
					-96.77,
					80.46,
					-96.36,
					80.59,
					-96.37,
					80.76,
					-96.17,
					80.8,
					-95.65,
					80.97,
					-95.58,
					81.11,
					-95.29,
					81.16,
					-94.93,
					81.1,
					-94.54,
					81.15,
					-94.47,
					81.3,
					-94.49,
					81.45,
					-94.23,
					81.42,
					-93.67,
					81.48,
					-93.58,
					81.26,
					-91.82,
					81.1,
					-91.7,
					80.73,
					-90.57,
					80.64,
					-90.5,
					80.58,
					-89.1,
					80.47,
					-88.94,
					80.31,
					-89,
					80.24,
					-88.82,
					80.5,
					-88.64,
					80.5,
					-87.63,
					80.19,
					-87.49,
					80.18,
					-87.27,
					79.99,
					-86.85,
					79.89,
					-86.82,
					79.71,
					-86.93,
					79.76,
					-86.55,
					80.07,
					-86.75,
					80.19,
					-86.74,
					80.4,
					-86.55,
					80.41,
					-86.12,
					80.49,
					-86.78,
					80.58,
					-86.86,
					80.5,
					-87.55,
					80.81,
					-89.47,
					80.92,
					-89.55,
					80.98,
					-90.28,
					81.16,
					-90.42,
					81.25,
					-90.4,
					81.34,
					-90.88,
					81.44,
					-90.96,
					81.36,
					-91.91,
					81.41,
					-92.08,
					81.53,
					-92.13,
					81.69,
					-92.03,
					81.82,
					-91.74,
					81.93,
					-90.81,
					82.03,
					-90.67,
					82,
					-89.63,
					82.21,
					-88.07,
					82.09,
					-87.12,
					82.14,
					-86.99,
					82.3,
					-86.93,
					82.53,
					-85.93,
					82.57,
					-84.95,
					82.47,
					-84.89,
					80.45,
					-84.9,
					80.39,
					-84.99,
					80.41,
					-85.93,
					80.37,
					-84.99,
					80.31,
					-84.9,
					79.57,
					-84.89,
					79.47,
					-85.03,
					79.38,
					-84.89,
					79.23,
					-84.89,
					79.11,
					-85.09,
					78.91,
					-84.89,
					76.2,
					-84.93,
					76.27,
					-86.39,
					76.37,
					-86.54,
					76.23,
					-86.69,
					76.33,
					-88.78,
					76.3,
					-89.02,
					76.13,
					-89.15,
					76.05,
					-89.78,
					75.84,
					-89.08,
					75.65,
					-89.09,
					75.61,
					-89.03,
					75.79,
					-88.78,
					75.61,
					-88.12,
					75.73,
					-87.26,
					75.49,
					-86.26,
					75.62,
					-86.12,
					75.76,
					-84.97,
					75.67,
					-84.9,
					74.49,
					-84.89,
					74.38,
					-85.32,
					74.44,
					-85.46,
					74.38,
					-85.58,
					74.37,
					-86.09,
					74.43,
					-86.19,
					74.35,
					-86.65,
					74.38,
					-88.5,
					74.53,
					-88.67,
					74.65,
					-88.64
				]
			},
			{
				"points": [
					72.88,
					-95.92,
					73.16,
					-95.94,
					73.22,
					-95.68,
					73.42,
					-95.82,
					73.78,
					-95.74,
					73.89,
					-95.43,
					74.13,
					-95.25,
					74.28,
					-93.46,
					74.22,
					-92.57,
					74.06,
					-92.16,
					74.13,
					-91.54,
					74.02,
					-90.36,
					74.12,
					-90.3,
					74.15,
					-89.86,
					74.06,
					-89.76,
					73.96,
					-89.81,
					73.2,
					-91.23,
					72.64,
					-92.03,
					72.59,
					-92.32,
					72.69,
					-93.52,
					72.51,
					-93.34,
					72.4,
					-93.35,
					72.13,
					-93.87,
					72.34,
					-95.28,
					72.51,
					-95.42,
					72.45,
					-95.51,
					72.49,
					-95.61,
					72.65,
					-95.69,
					72.78,
					-95.91,
					72.88,
					-95.92
				]
			},
			{
				"points": [
					73.27,
					-96.75,
					73.08,
					-96.44,
					72.98,
					-96.44,
					72.88,
					-96.56,
					72.66,
					-96.33,
					72.52,
					-96.35,
					73.11,
					-100.59,
					73.19,
					-100.67,
					73.16,
					-100.96,
					73.4,
					-101.65,
					73.53,
					-101.74,
					73.63,
					-101.67,
					73.65,
					-101.29,
					73.73,
					-101.29,
					73.86,
					-101.15,
					73.96,
					-100.79,
					73.94,
					-100.35,
					74.04,
					-100.09,
					74.04,
					-99.76,
					73.92,
					-99.52,
					74.01,
					-99.44,
					74.21,
					-98,
					74.17,
					-97.57,
					74.04,
					-97.52,
					73.96,
					-97.64,
					74.04,
					-97.17,
					73.81,
					-96.85,
					73.58,
					-96.84,
					73.49,
					-97.07,
					73.27,
					-96.75
				]
			},
			{
				"points": [
					78.05,
					-94.34,
					78.08,
					-94.58,
					78.26,
					-94.8,
					78.22,
					-94.94,
					78.19,
					-94.82,
					78.09,
					-94.78,
					77.91,
					-94.97,
					77.88,
					-93.62,
					77.75,
					-93.05,
					77.63,
					-92.97,
					77.37,
					-93.41,
					77.3,
					-93.71,
					77.35,
					-95.85,
					77.51,
					-96.46,
					77.67,
					-96.5,
					77.76,
					-96.32,
					77.66,
					-96.72,
					77.7,
					-97.14,
					77.84,
					-97.22,
					77.94,
					-97.84,
					78.1,
					-97.85,
					78.11,
					-98.05,
					78.25,
					-98.12,
					78.39,
					-98.48,
					78.58,
					-98.45,
					78.83,
					-98.55,
					78.91,
					-98.39,
					78.9,
					-97.48,
					78.71,
					-96.14,
					78.63,
					-96.06,
					78.62,
					-95.53,
					78.27,
					-94.23,
					78.14,
					-94.19,
					78.05,
					-94.34
				]
			},
			{
				"points": [
					78.17,
					-101.94,
					78.28,
					-102.1,
					79.09,
					-102.1,
					79.19,
					-102,
					79.16,
					-101.37,
					79.02,
					-100.89,
					78.92,
					-100.85,
					78.93,
					-100.32,
					78.71,
					-99.74,
					78.68,
					-99.43,
					78.54,
					-99.4,
					78.4,
					-99.58,
					78.14,
					-98.87,
					78.06,
					-98.81,
					77.79,
					-98.94,
					77.66,
					-99.91,
					77.76,
					-100.62,
					78.08,
					-101.02,
					78.05,
					-101.85,
					78.17,
					-101.94
				]
			},
			{
				"points": [
					77.02,
					-90.83,
					77.05,
					-91.19,
					77.16,
					-91.38,
					77.26,
					-91.37,
					77.31,
					-91.24,
					77.41,
					-91.31,
					77.7,
					-91.26,
					77.77,
					-90.85,
					77.71,
					-90.18,
					77.59,
					-89.75,
					77.38,
					-89.51,
					77.27,
					-89.53,
					77.11,
					-89.9,
					77.14,
					-90.6,
					77.02,
					-90.83
				]
			},
			{
				"points": [
					79.56,
					-98.82,
					79.77,
					-100.11,
					79.87,
					-100.26,
					80.1,
					-100.25,
					80.25,
					-99.86,
					80.26,
					-99.08,
					80,
					-98.58,
					79.74,
					-98.51,
					79.56,
					-98.82
				]
			}
		],
		"transitions": [
			[
				1320580800,
				-360,
				[
					"CST"
				]
			],
			[
				1331467200,
				-300,
				[
					"CDT"
				]
			],
			[
				1352030400,
				-360,
				[
					"CST"
				]
			],
			[
				1362916800,
				-300,
				[
					"CDT"
				]
			],
			[
				1383480000,
				-360,
				[
					"CST"
				]
			],
			[
				1394366400,
				-300,
				[
					"CDT"
				]
			],
			[
				1414929600,
				-360,
				[
					"CST"
				]
			],
			[
				1425816000,
				-300,
				[
					"CDT"
				]
			],
			[
				1446379200,
				-360,
				[
					"CST"
				]
			],
			[
				1457870400,
				-300,
				[
					"CDT"
				]
			],
			[
				1478433600,
				-360,
				[
					"CST"
				]
			],
			[
				1489320000,
				-300,
				[
					"CDT"
				]
			],
			[
				1509883200,
				-360,
				[
					"CST"
				]
			],
			[
				1520769600,
				-300,
				[
					"CDT"
				]
			],
			[
				1541332800,
				-360,
				[
					"CST"
				]
			],
			[
				1552219200,
				-300,
				[
					"CDT"
				]
			],
			[
				1572782400,
				-360,
				[
					"CST"
				]
			],
			[
				1583668800,
				-300,
				[
					"CDT"
				]
			],
			[
				1604232000,
				-360,
				[
					"CST"
				]
			],
			[
				1615723200,
				-300,
				[
					"CDT"
				]
			],
			[
				1636286400,
				-360,
				[
					"CST"
				]
			],
			[
				1647172800,
				-300,
				[
					"CDT"
				]
			],
			[
				1667736000,
				-360,
				[
					"CST"
				]
			],
			[
				1678622400,
				-300,
				[
					"CDT"
				]
			],
			[
				1699185600,
				-360,
				[
					"CST"
				]
			],
			[
				1710072000,
				-300,
				[
					"CDT"
				]
			],
			[
				1730635200,
				-360,
				[
					"CST"
				]
			],
			[
				1741521600,
				-300,
				[
					"CDT"
				]
			],
			[
				1762084800,
				-360,
				[
					"CST"
				]
			],
			[
				1772971200,
				-300,
				[
					"CDT"
				]
			],
			[
				1793534400,
				-360,
				[
					"CST"
				]
			],
			[
				1805025600,
				-300,
				[
					"CDT"
				]
			],
			[
				1825588800,
				-360,
				[
					"CST"
				]
			],
			[
				1836475200,
				-300,
				[
					"CDT"
				]
			],
			[
				1857038400,
				-360,
				[
					"CST"
				]
			],
			[
				1867924800,
				-300,
				[
					"CDT"
				]
			],
			[
				1888488000,
				-360,
				[
					"CST"
				]
			],
			[
				1899374400,
				-300,
				[
					"CDT"
				]
			],
			[
				1919937600,
				-360,
				[
					"CST"
				]
			],
			[
				1930824000,
				-300,
				[
					"CDT"
				]
			],
			[
				1951387200,
				-360,
				[
					"CST"
				]
			],
			[
				1962878400,
				-300,
				[
					"CDT"
				]
			],
			[
				1983441600,
				-360,
				[
					"CST"
				]
			],
			[
				1994328000,
				-300,
				[
					"CDT"
				]
			],
			[
				2014891200,
				-360,
				[
					"CST"
				]
			],
			[
				2025777600,
				-300,
				[
					"CDT"
				]
			],
			[
				2046340800,
				-360,
				[
					"CST"
				]
			],
			[
				2057227200,
				-300,
				[
					"CDT"
				]
			],
			[
				2077790400,
				-360,
				[
					"CST"
				]
			],
			[
				2088676800,
				-300,
				[
					"CDT"
				]
			],
			[
				2109240000,
				-360,
				[
					"CST"
				]
			],
			[
				2120126400,
				-300,
				[
					"CDT"
				]
			],
			[
				2140689600,
				-360,
				[
					"CST"
				]
			]
		],
		"name": "America/Chicago"
	},
	{
		"hoverRegion": [
			{
				"points": [
					27.85,
					-111.37,
					28,
					-111.49,
					28.09,
					-111.37,
					28.27,
					-111.52,
					28.37,
					-111.77,
					28.81,
					-112.13,
					28.6,
					-112.24,
					28.67,
					-112.44,
					28.56,
					-112.52,
					28.6,
					-112.68,
					28.91,
					-112.68,
					29.45,
					-112.49,
					29.87,
					-112.84,
					30.15,
					-112.86,
					30.64,
					-113.18,
					30.89,
					-113.22,
					30.98,
					-113.34,
					31.11,
					-113.27,
					31.23,
					-113.68,
					31.41,
					-113.74,
					31.46,
					-113.86,
					31.4,
					-114.22,
					31.91,
					-115.12,
					32.28,
					-115.08,
					32.79,
					-114.8,
					32.87,
					-114.58,
					33.02,
					-114.79,
					33.42,
					-114.83,
					33.6,
					-114.63,
					34,
					-114.62,
					34.28,
					-114.32,
					34.39,
					-114.47,
					34.65,
					-114.56,
					34.83,
					-114.73,
					35.1,
					-114.75,
					35.21,
					-114.69,
					36.1,
					-114.86,
					36.25,
					-114.41,
					36.13,
					-114.21,
					37.1,
					-114.09,
					37.1,
					-111.29,
					36.81,
					-111.13,
					36.76,
					-111.23,
					36.83,
					-111.37,
					36.77,
					-111.52,
					36.35,
					-111.73,
					36.01,
					-111.6,
					35.83,
					-111.61,
					35.81,
					-111.22,
					35.26,
					-111.13,
					35.28,
					-109.72,
					35.36,
					-109.52,
					35.21,
					-108.94,
					31.43,
					-108.94,
					31.37,
					-108.73,
					30.01,
					-108.45,
					29.39,
					-108.5,
					29.3,
					-108.58,
					28.78,
					-108.51,
					28.67,
					-108.56,
					28.27,
					-108.45,
					28.1,
					-108.62,
					28.17,
					-109,
					27.55,
					-108.55,
					27.18,
					-108.55,
					26.86,
					-108.37,
					26.25,
					-109.07,
					26.21,
					-109.28,
					26.46,
					-109.38,
					26.63,
					-109.85,
					26.93,
					-110.02,
					27.23,
					-110.66,
					27.79,
					-110.69,
					27.74,
					-110.93,
					27.95,
					-111.25,
					27.85,
					-111.37
				]
			},
			{
				"points": [
					55.75,
					-123.44,
					55.86,
					-123.56,
					56.15,
					-123.6,
					56.32,
					-123.72,
					56.43,
					-123.69,
					56.55,
					-123.84,
					56.92,
					-123.92,
					57.01,
					-123.88,
					57.21,
					-123.39,
					57.26,
					-122.95,
					57.15,
					-122.71,
					57.07,
					-121.95,
					57.33,
					-121.73,
					57.32,
					-121.36,
					57.49,
					-121.02,
					57.57,
					-120.49,
					57.34,
					-120.23,
					57.35,
					-119.95,
					57.25,
					-119.89,
					53.75,
					-119.9,
					53.69,
					-120.02,
					54.01,
					-120.36,
					54.04,
					-120.57,
					54.18,
					-120.66,
					54.22,
					-120.81,
					54.37,
					-120.85,
					54.34,
					-121.1,
					54.43,
					-121.19,
					54.42,
					-121.43,
					54.61,
					-121.63,
					54.72,
					-121.62,
					54.81,
					-121.92,
					55.26,
					-122.58,
					55.3,
					-123.03,
					55.62,
					-123.21,
					55.62,
					-123.39,
					55.75,
					-123.44
				]
			},
			{
				"points": [
					35.41,
					-110.2,
					35.45,
					-111.04,
					35.86,
					-111.1,
					35.88,
					-111.31,
					36.13,
					-111.38,
					36.5,
					-110.8,
					36.51,
					-110.24,
					35.98,
					-109.92,
					35.64,
					-109.89,
					35.41,
					-110.2
				]
			},
			{
				"points": [
					48.89,
					-116.92,
					48.98,
					-117.11,
					49.16,
					-117.14,
					49.83,
					-116.97,
					49.91,
					-116.88,
					49.91,
					-116.67,
					49.82,
					-116.52,
					49.37,
					-115.95,
					49,
					-115.61,
					48.9,
					-115.71,
					48.89,
					-116.92
				]
			}
		],
		"transitions": [
			[
				0,
				-420,
				[
					"MST"
				]
			]
		],
		"name": "America/Phoenix"
	},
	{
		"hoverRegion": [
			{
				"points": [
					30.45,
					34.45,
					31.26,
					34.16,
					31.53,
					34.4,
					31.64,
					34.39,
					32.16,
					34.68,
					32.84,
					34.85,
					32.93,
					34.97,
					33.15,
					35.02,
					33.2,
					35.42,
					33.36,
					35.5,
					33.39,
					35.61,
					33.25,
					35.77,
					33,
					35.7,
					32.75,
					35.76,
					32.36,
					35.67,
					32.28,
					35.57,
					32.42,
					35.22,
					32.18,
					35.07,
					31.89,
					35.13,
					31.78,
					35.33,
					31.47,
					35.04,
					31.6,
					35.43,
					31.41,
					35.58,
					30.92,
					35.52,
					30.4,
					35.26,
					30.08,
					35.28,
					29.59,
					35.13,
					29.38,
					34.94,
					29.44,
					34.81,
					30.45,
					34.45
				]
			}
		],
		"transitions": [
			[
				1317524400,
				120,
				[
					"IST"
				]
			],
			[
				1333080000,
				180,
				[
					"IDT"
				]
			],
			[
				1348369200,
				120,
				[
					"IST"
				]
			],
			[
				1364529600,
				180,
				[
					"IDT"
				]
			],
			[
				1378609200,
				120,
				[
					"IST"
				]
			],
			[
				1395979200,
				180,
				[
					"IDT"
				]
			],
			[
				1411873200,
				120,
				[
					"IST"
				]
			],
			[
				1427428800,
				180,
				[
					"IDT"
				]
			],
			[
				1442718000,
				120,
				[
					"IST"
				]
			],
			[
				1459483200,
				180,
				[
					"IDT"
				]
			],
			[
				1475982000,
				120,
				[
					"IST"
				]
			],
			[
				1490932800,
				180,
				[
					"IDT"
				]
			],
			[
				1506222000,
				120,
				[
					"IST"
				]
			],
			[
				1522382400,
				180,
				[
					"IDT"
				]
			],
			[
				1537066800,
				120,
				[
					"IST"
				]
			],
			[
				1553832000,
				180,
				[
					"IDT"
				]
			],
			[
				1570330800,
				120,
				[
					"IST"
				]
			],
			[
				1585281600,
				180,
				[
					"IDT"
				]
			],
			[
				1601175600,
				120,
				[
					"IST"
				]
			],
			[
				1616731200,
				180,
				[
					"IDT"
				]
			],
			[
				1631415600,
				120,
				[
					"IST"
				]
			],
			[
				1648785600,
				180,
				[
					"IDT"
				]
			],
			[
				1664679600,
				120,
				[
					"IST"
				]
			],
			[
				1680235200,
				180,
				[
					"IDT"
				]
			],
			[
				1695524400,
				120,
				[
					"IST"
				]
			],
			[
				1711684800,
				180,
				[
					"IDT"
				]
			],
			[
				1728183600,
				120,
				[
					"IST"
				]
			],
			[
				1743134400,
				180,
				[
					"IDT"
				]
			],
			[
				1759028400,
				120,
				[
					"IST"
				]
			],
			[
				1774584000,
				180,
				[
					"IDT"
				]
			],
			[
				1789873200,
				120,
				[
					"IST"
				]
			],
			[
				1806033600,
				180,
				[
					"IDT"
				]
			],
			[
				1823137200,
				120,
				[
					"IST"
				]
			],
			[
				1838088000,
				180,
				[
					"IDT"
				]
			],
			[
				1853377200,
				120,
				[
					"IST"
				]
			],
			[
				1869537600,
				180,
				[
					"IDT"
				]
			],
			[
				1884222000,
				120,
				[
					"IST"
				]
			],
			[
				1900987200,
				180,
				[
					"IDT"
				]
			],
			[
				1917486000,
				120,
				[
					"IST"
				]
			],
			[
				1932436800,
				180,
				[
					"IDT"
				]
			],
			[
				1947726000,
				120,
				[
					"IST"
				]
			],
			[
				1963886400,
				180,
				[
					"IDT"
				]
			],
			[
				1978570800,
				120,
				[
					"IST"
				]
			],
			[
				1995940800,
				180,
				[
					"IDT"
				]
			],
			[
				2011834800,
				120,
				[
					"IST"
				]
			],
			[
				2027390400,
				180,
				[
					"IDT"
				]
			],
			[
				2042074800,
				120,
				[
					"IST"
				]
			],
			[
				2058840000,
				180,
				[
					"IDT"
				]
			],
			[
				2075338800,
				120,
				[
					"IST"
				]
			],
			[
				2090289600,
				180,
				[
					"IDT"
				]
			],
			[
				2106183600,
				120,
				[
					"IST"
				]
			],
			[
				2121739200,
				180,
				[
					"IDT"
				]
			],
			[
				2136423600,
				120,
				[
					"IST"
				]
			]
		],
		"name": "Asia/Jerusalem"
	},
	{
		"hoverRegion": [
			{
				"points": [
					32.45,
					60.71,
					33.14,
					60.47,
					33.44,
					60.72,
					33.49,
					60.55,
					34.08,
					60.36,
					34.41,
					60.69,
					34.59,
					60.66,
					34.71,
					60.9,
					35.12,
					61.02,
					35.3,
					60.99,
					35.37,
					61.09,
					35.68,
					61.19,
					35.72,
					61.4,
					35.54,
					61.63,
					35.54,
					62.09,
					35.33,
					62.36,
					35.36,
					62.7,
					35.5,
					62.98,
					35.96,
					63.07,
					36.13,
					63.98,
					36.33,
					64.38,
					36.46,
					64.5,
					36.66,
					64.5,
					36.95,
					64.67,
					37.18,
					64.68,
					37.33,
					65.06,
					37.34,
					65.46,
					37.63,
					65.68,
					37.43,
					66.32,
					37.49,
					66.99,
					37.3,
					67.29,
					37.38,
					67.48,
					37.32,
					67.77,
					37.05,
					68.01,
					37.43,
					68.87,
					37.22,
					69.25,
					37.26,
					69.3,
					37.44,
					69.26,
					37.66,
					69.45,
					37.72,
					69.89,
					37.65,
					70.12,
					37.7,
					70.17,
					38.01,
					70.09,
					38.2,
					70.42,
					38.49,
					70.61,
					38.59,
					71,
					38.31,
					71.45,
					38.02,
					71.4,
					37.94,
					71.69,
					37.08,
					71.54,
					36.79,
					71.72,
					37.07,
					72.26,
					37.12,
					72.6,
					37.32,
					72.75,
					37.57,
					73.31,
					37.53,
					73.8,
					37.37,
					73.87,
					37.52,
					74.32,
					37.51,
					74.69,
					37.3,
					74.97,
					37.16,
					74.93,
					37.13,
					74.61,
					37.02,
					74.67,
					36.85,
					74.58,
					36.88,
					74.43,
					36.73,
					74.13,
					36.8,
					73.68,
					36.73,
					72.65,
					36.65,
					72.32,
					36.43,
					71.95,
					36.3,
					71.9,
					36.34,
					71.69,
					36.06,
					71.4,
					35.6,
					71.71,
					35.43,
					71.75,
					35.31,
					71.69,
					35.16,
					71.78,
					34.89,
					71.58,
					34.54,
					71.14,
					34.36,
					71.28,
					33.99,
					71.16,
					33.83,
					70.52,
					33.9,
					70.01,
					33.77,
					70.22,
					33.28,
					70.42,
					33.04,
					70.07,
					32.94,
					69.63,
					32.62,
					69.55,
					32.42,
					69.35,
					31.88,
					69.41,
					31.52,
					69.06,
					31.5,
					68.76,
					31.63,
					68.61,
					31.7,
					68.19,
					31.46,
					67.85,
					31.23,
					67.82,
					31.09,
					67.29,
					31.19,
					66.97,
					31.11,
					66.79,
					30.89,
					66.64,
					30.84,
					66.47,
					30.57,
					66.39,
					30.38,
					66.45,
					30.1,
					66.36,
					29.92,
					66.46,
					29.74,
					66.27,
					29.42,
					65.09,
					29.43,
					64.38,
					29.26,
					64.12,
					29.37,
					63.58,
					29.28,
					62.42,
					29.75,
					60.84,
					29.92,
					60.8,
					30.88,
					61.69,
					31.03,
					61.73,
					31.27,
					61.63,
					31.41,
					60.77,
					32.45,
					60.71
				]
			}
		],
		"transitions": [
			[
				0,
				270,
				[
					"AFT"
				]
			]
		],
		"name": "Asia/Kabul"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-45.2,
					-65.38,
					-45.14,
					-65.53,
					-45.22,
					-65.94,
					-45.09,
					-66.18,
					-45.17,
					-66.39,
					-45.29,
					-66.46,
					-45.4,
					-66.95,
					-46.04,
					-67.48,
					-46.22,
					-67.49,
					-46.47,
					-67.34,
					-46.62,
					-67.04,
					-46.9,
					-66.73,
					-46.96,
					-65.96,
					-47.13,
					-65.66,
					-47.51,
					-65.62,
					-47.76,
					-65.76,
					-47.98,
					-65.67,
					-48.05,
					-65.81,
					-48.2,
					-65.86,
					-48.22,
					-66.05,
					-48.36,
					-66.22,
					-48.44,
					-66.07,
					-48.59,
					-66.14,
					-48.56,
					-66.27,
					-48.46,
					-66.29,
					-48.71,
					-66.94,
					-48.82,
					-66.99,
					-48.82,
					-67.12,
					-49.1,
					-67.47,
					-49.98,
					-67.71,
					-50.16,
					-67.97,
					-50.46,
					-68.84,
					-50.61,
					-68.97,
					-51,
					-69.07,
					-51.59,
					-68.84,
					-52.27,
					-68.26,
					-52.48,
					-68.35,
					-52.1,
					-70.03,
					-52.07,
					-72.03,
					-51.91,
					-72.08,
					-51.59,
					-72.54,
					-51.27,
					-72.39,
					-51.09,
					-72.5,
					-50.96,
					-72.35,
					-50.72,
					-72.43,
					-50.78,
					-72.59,
					-50.73,
					-72.73,
					-50.87,
					-73.17,
					-50.72,
					-73.23,
					-50.32,
					-73.67,
					-49.91,
					-73.65,
					-49.79,
					-73.56,
					-49.53,
					-73.69,
					-49.34,
					-73.56,
					-49.11,
					-73.58,
					-49.03,
					-73.14,
					-48.84,
					-72.96,
					-48.75,
					-72.7,
					-48.4,
					-72.67,
					-48.3,
					-72.4,
					-48.13,
					-72.43,
					-47.96,
					-72.62,
					-47.7,
					-72.6,
					-47.58,
					-72.4,
					-47.37,
					-72.4,
					-47.31,
					-72.21,
					-47.11,
					-72.08,
					-46.74,
					-72.01,
					-46.62,
					-71.77,
					-46.27,
					-71.85,
					-46.11,
					-71.99,
					-45.94,
					-71.76,
					-45.84,
					-71.85,
					-45.49,
					-71.84,
					-45.42,
					-71.6,
					-45.25,
					-71.46,
					-45.07,
					-71.62,
					-44.99,
					-72.1,
					-44.74,
					-72.17,
					-44.66,
					-72.08,
					-44.67,
					-71.34,
					-44.54,
					-71.25,
					-44.43,
					-71.92,
					-44.06,
					-71.94,
					-43.92,
					-71.8,
					-43.79,
					-71.86,
					-43.67,
					-71.76,
					-43.47,
					-72.04,
					-43.22,
					-71.91,
					-43.15,
					-72.06,
					-42.92,
					-72.21,
					-42.6,
					-72.24,
					-42.47,
					-72.16,
					-42.3,
					-72.23,
					-42.09,
					-72.13,
					-42.04,
					-71.87,
					-41.83,
					-71.85,
					-41.39,
					-72.01,
					-41.06,
					-71.94,
					-40.73,
					-72.05,
					-40.32,
					-71.87,
					-40.05,
					-71.92,
					-39.94,
					-71.72,
					-39.84,
					-71.79,
					-39.53,
					-71.79,
					-39.48,
					-71.63,
					-39.26,
					-71.49,
					-38.86,
					-71.51,
					-38.58,
					-70.97,
					-38.45,
					-71.1,
					-38.13,
					-71.11,
					-37.89,
					-71.29,
					-37.48,
					-71.23,
					-37.31,
					-71.32,
					-37.11,
					-71.22,
					-37,
					-71.3,
					-36.81,
					-71.27,
					-36.38,
					-71.11,
					-36.28,
					-70.8,
					-36.04,
					-70.65,
					-36.02,
					-70.52,
					-35.87,
					-70.52,
					-35.78,
					-70.44,
					-35.41,
					-70.51,
					-35.23,
					-70.68,
					-35.06,
					-70.45,
					-34.71,
					-70.41,
					-34.37,
					-70.13,
					-34.22,
					-70.13,
					-34.14,
					-69.93,
					-33.66,
					-69.99,
					-33.43,
					-69.87,
					-33.34,
					-70.13,
					-33.02,
					-70.2,
					-32.91,
					-70.13,
					-32.76,
					-70.24,
					-32.55,
					-70.24,
					-31.53,
					-70.66,
					-31.12,
					-70.61,
					-31,
					-70.5,
					-30.99,
					-70.39,
					-30.28,
					-70.24,
					-30.27,
					-70.01,
					-30.2,
					-69.96,
					-30.11,
					-70.04,
					-29.69,
					-69.99,
					-29.28,
					-70.12,
					-29.08,
					-70.02,
					-29.02,
					-69.88,
					-28.35,
					-69.73,
					-28.04,
					-69.38,
					-27.02,
					-68.84,
					-26.93,
					-68.39,
					-26.53,
					-68.69,
					-26.25,
					-68.66,
					-26.14,
					-68.51,
					-25.42,
					-68.7,
					-25.01,
					-68.54,
					-24.77,
					-68.67,
					-24.38,
					-68.45,
					-23.95,
					-67.42,
					-23.02,
					-67.11,
					-22.77,
					-67.27,
					-22.45,
					-67.1,
					-22.35,
					-66.87,
					-22.14,
					-66.8,
					-22,
					-66.38,
					-21.67,
					-66.25,
					-21.74,
					-66,
					-21.99,
					-65.71,
					-21.97,
					-65.18,
					-22.1,
					-64.59,
					-22.47,
					-64.32,
					-21.89,
					-63.97,
					-21.9,
					-62.76,
					-22.09,
					-62.69,
					-22.48,
					-62.14,
					-22.95,
					-61.9,
					-23.32,
					-61.43,
					-23.45,
					-61.12,
					-23.71,
					-60.91,
					-23.93,
					-60.31,
					-23.9,
					-60.01,
					-24.51,
					-59.07,
					-24.86,
					-58.31,
					-24.82,
					-58.18,
					-25,
					-57.79,
					-25.23,
					-57.56,
					-25.57,
					-57.45,
					-25.75,
					-57.66,
					-26.07,
					-57.76,
					-26.25,
					-58.03,
					-26.68,
					-58.08,
					-27.18,
					-58.5,
					-27.15,
					-57.97,
					-27.32,
					-57.48,
					-27.36,
					-56.95,
					-27.46,
					-56.83,
					-27.33,
					-56.61,
					-27.44,
					-56.41,
					-27.19,
					-56.12,
					-27.32,
					-55.75,
					-27.1,
					-55.69,
					-26.92,
					-55.5,
					-26.85,
					-55.2,
					-26.6,
					-55,
					-26.56,
					-54.88,
					-26.21,
					-54.73,
					-25.65,
					-54.76,
					-25.52,
					-54.67,
					-25.48,
					-54.58,
					-25.56,
					-54.43,
					-25.39,
					-54.12,
					-25.55,
					-53.8,
					-25.92,
					-53.72,
					-26.27,
					-53.48,
					-26.53,
					-53.61,
					-26.97,
					-53.56,
					-27.2,
					-53.7,
					-27.4,
					-54.13,
					-27.53,
					-54.22,
					-27.66,
					-54.75,
					-27.94,
					-54.96,
					-28.02,
					-55.25,
					-28.27,
					-55.57,
					-28.49,
					-55.6,
					-28.5,
					-55.78,
					-28.86,
					-56.2,
					-29.15,
					-56.35,
					-29.21,
					-56.51,
					-29.43,
					-56.63,
					-29.9,
					-57.19,
					-30.07,
					-57.25,
					-30.24,
					-57.53,
					-30.4,
					-57.54,
					-30.55,
					-57.75,
					-30.87,
					-57.69,
					-31.45,
					-57.94,
					-31.56,
					-57.87,
					-31.72,
					-57.91,
					-31.9,
					-58.08,
					-32.24,
					-57.99,
					-32.47,
					-58.08,
					-32.97,
					-58,
					-33.13,
					-58.08,
					-33.2,
					-58.31,
					-33.7,
					-58.44,
					-34.07,
					-58.27,
					-34.19,
					-58.12,
					-34.37,
					-58.4,
					-34.64,
					-58.13,
					-34.97,
					-57.39,
					-35.31,
					-57.05,
					-35.43,
					-57.03,
					-35.92,
					-57.26,
					-36.19,
					-57.02,
					-36.27,
					-56.64,
					-36.97,
					-56.58,
					-37.55,
					-57.02,
					-37.89,
					-57.39,
					-38.17,
					-57.46,
					-38.54,
					-58.14,
					-38.8,
					-59.08,
					-39.09,
					-60.83,
					-39.1,
					-61.78,
					-39.28,
					-61.79,
					-39.34,
					-61.91,
					-39.89,
					-62,
					-40,
					-62.15,
					-40.06,
					-62.03,
					-40.18,
					-61.99,
					-40.63,
					-62.06,
					-41.01,
					-62.35,
					-41.26,
					-63.09,
					-41.27,
					-63.8,
					-41.09,
					-64.13,
					-40.92,
					-65.03,
					-41.54,
					-64.89,
					-41.99,
					-64.96,
					-42.08,
					-64.83,
					-42.14,
					-64.42,
					-41.99,
					-63.68,
					-42.29,
					-63.49,
					-42.61,
					-63.47,
					-42.89,
					-63.62,
					-42.96,
					-64.2,
					-43.07,
					-64.26,
					-43.33,
					-64.89,
					-43.68,
					-65.21,
					-43.88,
					-65.19,
					-44.02,
					-65.07,
					-44.21,
					-65.18,
					-44.39,
					-65.1,
					-44.65,
					-65.27,
					-44.77,
					-65.52,
					-45.07,
					-65.31,
					-45.2,
					-65.38
				]
			},
			{
				"points": [
					-11.2,
					-37.07,
					-11.51,
					-37.27,
					-11.68,
					-37.65,
					-11.44,
					-38.08,
					-11.24,
					-38.09,
					-10.81,
					-38.35,
					-10.61,
					-38.24,
					-10.6,
					-37.91,
					-10.13,
					-37.88,
					-9.77,
					-38.13,
					-9.55,
					-38.12,
					-9.45,
					-38.3,
					-9.12,
					-38.37,
					-9.07,
					-38.69,
					-8.88,
					-38.85,
					-8.79,
					-39.24,
					-8.65,
					-39.4,
					-8.73,
					-39.57,
					-8.87,
					-39.62,
					-8.92,
					-39.8,
					-9.14,
					-39.91,
					-9.17,
					-40.16,
					-9.43,
					-40.25,
					-9.59,
					-40.63,
					-9.5,
					-40.85,
					-9.28,
					-40.82,
					-9.2,
					-40.95,
					-8.92,
					-40.99,
					-8.81,
					-41.3,
					-9.02,
					-41.43,
					-9.07,
					-41.62,
					-9.18,
					-41.63,
					-9.35,
					-41.8,
					-9.31,
					-42.03,
					-9.4,
					-42.25,
					-9.67,
					-42.59,
					-9.66,
					-42.86,
					-9.48,
					-43.14,
					-9.54,
					-43.37,
					-9.43,
					-43.57,
					-9.55,
					-43.67,
					-9.83,
					-43.57,
					-10.08,
					-43.59,
					-10.49,
					-43.82,
					-10.72,
					-44.15,
					-10.74,
					-44.5,
					-10.97,
					-44.75,
					-11,
					-45.05,
					-10.87,
					-45.37,
					-10.43,
					-45.69,
					-10.8,
					-46.16,
					-10.97,
					-46.14,
					-11.06,
					-46.29,
					-11.31,
					-46.44,
					-11.6,
					-45.97,
					-11.77,
					-46.1,
					-11.87,
					-45.97,
					-11.97,
					-45.97,
					-12.19,
					-46.23,
					-12.33,
					-46.22,
					-12.47,
					-46.06,
					-12.84,
					-46.14,
					-13.13,
					-46.81,
					-13.19,
					-47.2,
					-13.4,
					-47.5,
					-13.31,
					-47.64,
					-13.42,
					-47.75,
					-13.26,
					-48.24,
					-13.14,
					-48.27,
					-13.15,
					-48.56,
					-13.28,
					-48.67,
					-13.28,
					-48.84,
					-12.76,
					-49.04,
					-13.26,
					-49.36,
					-13.06,
					-49.85,
					-12.87,
					-50.68,
					-11.91,
					-50.75,
					-11.74,
					-50.82,
					-11.62,
					-50.77,
					-11.51,
					-50.85,
					-11.04,
					-50.71,
					-10.61,
					-50.7,
					-9.94,
					-50.38,
					-9.59,
					-56.45,
					-9.5,
					-56.8,
					-9.36,
					-56.91,
					-9.32,
					-57.11,
					-9.12,
					-57.18,
					-8.82,
					-57.68,
					-8.47,
					-57.78,
					-8.23,
					-57.75,
					-7.16,
					-58.3,
					-6.95,
					-58.52,
					-6.7,
					-58.58,
					-6.26,
					-58.3,
					-2.35,
					-56.49,
					-2.27,
					-56.79,
					-2.11,
					-56.85,
					-2.03,
					-57.06,
					-1.89,
					-57.15,
					-1.69,
					-57.7,
					-1.38,
					-58.15,
					-1.11,
					-58.48,
					-0.9,
					-58.54,
					-0.7,
					-58.83,
					-0.49,
					-58.84,
					-0.26,
					-58.98,
					1.3,
					-59.07,
					1.41,
					-58.98,
					1.31,
					-58.81,
					1.38,
					-58.61,
					1.53,
					-58.58,
					1.69,
					-58.36,
					1.64,
					-58.1,
					1.76,
					-58.04,
					1.8,
					-57.59,
					2.09,
					-57.31,
					2.12,
					-57.05,
					1.97,
					-56.79,
					2.77,
					-57.29,
					3.26,
					-57.39,
					3.28,
					-57.73,
					4.14,
					-58.19,
					4.63,
					-57.96,
					4.88,
					-58.02,
					5.12,
					-57.72,
					5.14,
					-57.41,
					5.33,
					-57.45,
					5.64,
					-57.28,
					6.05,
					-57.23,
					6.1,
					-56.92,
					5.91,
					-56.03,
					6.06,
					-55.83,
					6.03,
					-55.27,
					6.11,
					-55.01,
					5.92,
					-53.99,
					5.66,
					-53.44,
					5.56,
					-52.9,
					5.12,
					-52.42,
					5.14,
					-52.3,
					5.01,
					-52.13,
					4.86,
					-52.03,
					4.92,
					-51.86,
					4.75,
					-51.84,
					4.68,
					-51.71,
					4.47,
					-51.61,
					4.48,
					-51.47,
					3.94,
					-50.98,
					3.3,
					-50.94,
					2.29,
					-50.61,
					2.36,
					-50.46,
					2.27,
					-50.29,
					1.82,
					-50.07,
					1.73,
					-49.86,
					1.27,
					-49.75,
					0.86,
					-49.92,
					0.75,
					-49.9,
					0.66,
					-49.99,
					0.43,
					-49.53,
					0.16,
					-49.5,
					0.08,
					-49.26,
					-0.02,
					-49.23,
					0.09,
					-48.97,
					-0.02,
					-48.91,
					-0.03,
					-48.67,
					-0.15,
					-48.6,
					-0.24,
					-48.26,
					-1.03,
					-48.48,
					-0.58,
					-48.12,
					-0.44,
					-47.92,
					-0.43,
					-47.7,
					-0.6,
					-46.8,
					-0.71,
					-46.7,
					-0.69,
					-46.54,
					-0.85,
					-46.3,
					-0.8,
					-46.17,
					-0.95,
					-46.07,
					-1.02,
					-45.58,
					-1.3,
					-45.2,
					-1.17,
					-44.86,
					-1.96,
					-44.34,
					-2.36,
					-44.25,
					-2.29,
					-44,
					-2.34,
					-43.93,
					-2.14,
					-43.61,
					-2.25,
					-43.51,
					-2.23,
					-43.27,
					-2.61,
					-42.4,
					-2.56,
					-42.22,
					-2.61,
					-41.8,
					-2.79,
					-41.56,
					-2.82,
					-41.32,
					-2.67,
					-40.48,
					-2.73,
					-39.96,
					-3.12,
					-39.2,
					-3.57,
					-38.6,
					-3.6,
					-38.42,
					-4.13,
					-37.96,
					-4.52,
					-37.53,
					-4.6,
					-37.25,
					-4.82,
					-37.1,
					-4.81,
					-36.93,
					-4.98,
					-36.66,
					-4.93,
					-35.96,
					-5.07,
					-35.42,
					-5.45,
					-35.14,
					-7.13,
					-34.68,
					-8.04,
					-34.72,
					-9.31,
					-35.25,
					-10.33,
					-36.18,
					-10.57,
					-36.31,
					-10.82,
					-36.78,
					-11.2,
					-37.07
				]
			},
			{
				"points": [
					-54.98,
					-68.26,
					-54.95,
					-68.64,
					-54.85,
					-68.72,
					-52.65,
					-68.7,
					-52.55,
					-68.6,
					-52.91,
					-68.17,
					-53.12,
					-68.08,
					-53.21,
					-68.13,
					-53.52,
					-67.89,
					-53.95,
					-67.26,
					-54.5,
					-65.97,
					-54.56,
					-65.09,
					-54.66,
					-65,
					-55.02,
					-65.29,
					-55.07,
					-65.68,
					-55,
					-65.94,
					-55.16,
					-66.38,
					-54.99,
					-67.31,
					-54.92,
					-68.15,
					-54.98,
					-68.26
				]
			},
			{
				"points": [
					-55.01,
					-64.66,
					-54.81,
					-64.86,
					-54.6,
					-64.58,
					-54.51,
					-64.16,
					-54.67,
					-63.7,
					-54.8,
					-63.75,
					-54.97,
					-64.12,
					-55.01,
					-64.66
				]
			}
		],
		"transitions": [
			[
				0,
				-180,
				[
					"ART",
					"BRT",
					"WARST",
					"SRT",
					"GFT"
				]
			]
		],
		"name": "America/Araguaina"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-46.89,
					168.56,
					-46.85,
					168.4,
					-46.72,
					168.37,
					-46.71,
					168.26,
					-46.46,
					168.09,
					-46.55,
					167.79,
					-46.28,
					167.48,
					-46.36,
					167.19,
					-46.31,
					166.63,
					-45.96,
					166.32,
					-45.67,
					166.33,
					-44.78,
					167.19,
					-44.51,
					167.72,
					-44.36,
					167.78,
					-43.92,
					168.29,
					-43.86,
					168.76,
					-43.62,
					169.14,
					-43.49,
					169.55,
					-43,
					170.21,
					-42.78,
					170.74,
					-42.22,
					171.2,
					-41.68,
					171.36,
					-41.59,
					171.68,
					-41.33,
					171.95,
					-40.87,
					171.99,
					-40.68,
					172.16,
					-40.39,
					172.63,
					-40.44,
					173.06,
					-40.6,
					173.08,
					-40.64,
					172.8,
					-40.71,
					173.08,
					-40.85,
					173.17,
					-41.09,
					173.13,
					-41.16,
					173.21,
					-40.95,
					173.65,
					-40.66,
					173.77,
					-40.56,
					173.96,
					-40.59,
					174.07,
					-40.77,
					174.09,
					-40.9,
					174.36,
					-41.07,
					174.49,
					-41.28,
					174.44,
					-41.44,
					174.16,
					-41.79,
					174.37,
					-42.38,
					173.81,
					-42.5,
					173.78,
					-42.56,
					173.6,
					-42.97,
					173.37,
					-43.29,
					172.85,
					-43.48,
					172.86,
					-43.64,
					173.2,
					-43.91,
					173.18,
					-44.01,
					172.93,
					-43.93,
					172.7,
					-43.98,
					172.32,
					-44.4,
					171.37,
					-44.6,
					171.27,
					-44.97,
					171.25,
					-45.22,
					171,
					-45.5,
					170.93,
					-45.68,
					170.77,
					-45.77,
					170.84,
					-45.96,
					170.8,
					-46.06,
					170.36,
					-46.23,
					170.23,
					-46.67,
					169.63,
					-46.78,
					169.02,
					-46.69,
					168.64,
					-46.79,
					168.67,
					-46.89,
					168.56
				]
			},
			{
				"points": [
					-41.08,
					174.66,
					-40.96,
					174.8,
					-40.81,
					174.78,
					-40.62,
					175.06,
					-40.2,
					175.08,
					-39.99,
					174.87,
					-39.92,
					174.52,
					-39.72,
					174.24,
					-39.6,
					173.84,
					-39.26,
					173.63,
					-38.97,
					173.95,
					-38.8,
					174.44,
					-37.75,
					174.71,
					-37.08,
					174.43,
					-36.49,
					174.04,
					-35.22,
					172.94,
					-35.05,
					173.05,
					-34.51,
					172.53,
					-34.32,
					172.62,
					-34.3,
					173.08,
					-34.57,
					173.11,
					-34.75,
					173.23,
					-34.67,
					173.43,
					-34.8,
					173.56,
					-34.88,
					174,
					-35.02,
					174.05,
					-35.1,
					174.22,
					-35.08,
					174.4,
					-35.78,
					174.68,
					-35.86,
					174.88,
					-36.08,
					174.73,
					-36.32,
					174.96,
					-36.51,
					174.95,
					-36.65,
					175.04,
					-36.71,
					175.29,
					-36.5,
					175.21,
					-36.36,
					175.33,
					-36.24,
					175.2,
					-36.33,
					175.12,
					-36.31,
					174.99,
					-36.1,
					174.97,
					-36.06,
					175.12,
					-36.17,
					175.2,
					-35.92,
					175.39,
					-36.04,
					175.57,
					-36.44,
					175.57,
					-36.53,
					175.65,
					-36.35,
					175.67,
					-36.35,
					175.84,
					-36.51,
					175.84,
					-36.58,
					176.04,
					-36.82,
					175.92,
					-36.93,
					175.95,
					-36.83,
					176.1,
					-36.9,
					176.2,
					-37.03,
					176.16,
					-37.04,
					176.05,
					-37.14,
					176.01,
					-37.41,
					176.08,
					-37.53,
					176.21,
					-37.57,
					176.3,
					-37.5,
					176.45,
					-37.67,
					176.52,
					-37.78,
					176.87,
					-37.74,
					176.98,
					-37.88,
					177.28,
					-37.42,
					177.98,
					-37.45,
					178.37,
					-37.64,
					178.65,
					-38.05,
					178.44,
					-38.58,
					178.37,
					-38.78,
					178.03,
					-38.98,
					178,
					-39.13,
					178.1,
					-39.37,
					177.94,
					-39.39,
					177.79,
					-39.17,
					177.74,
					-39.16,
					177.44,
					-39.28,
					177.11,
					-39.45,
					176.99,
					-39.65,
					177.19,
					-40.17,
					176.96,
					-40.34,
					176.76,
					-40.55,
					176.71,
					-40.79,
					176.39,
					-41.18,
					176.15,
					-41.44,
					175.88,
					-41.72,
					175.25,
					-41.51,
					175.08,
					-41.55,
					174.89,
					-41.44,
					174.79,
					-41.42,
					174.57,
					-41.25,
					174.51,
					-41.08,
					174.66
				]
			},
			{
				"points": [
					-47.36,
					167.42,
					-47.32,
					167.31,
					-47.22,
					167.27,
					-47.08,
					167.3,
					-47.03,
					167.44,
					-46.85,
					167.52,
					-46.65,
					167.55,
					-46.61,
					167.98,
					-46.76,
					168.3,
					-46.92,
					168.35,
					-47.18,
					168.27,
					-47.36,
					167.42
				]
			},
			{
				"points": [
					-51.12,
					166.17,
					-51.15,
					165.99,
					-51,
					165.98,
					-50.91,
					165.8,
					-50.81,
					165.78,
					-50.51,
					165.88,
					-50.38,
					166.33,
					-50.5,
					166.41,
					-50.87,
					166.34,
					-50.99,
					166.16,
					-51.12,
					166.17
				]
			}
		],
		"transitions": [
			[
				1316887200,
				780,
				[
					"NZDT"
				]
			],
			[
				1333216800,
				720,
				[
					"NZST"
				]
			],
			[
				1348941600,
				780,
				[
					"NZDT"
				]
			],
			[
				1365271200,
				720,
				[
					"NZST"
				]
			],
			[
				1380391200,
				780,
				[
					"NZDT"
				]
			],
			[
				1396720800,
				720,
				[
					"NZST"
				]
			],
			[
				1411840800,
				780,
				[
					"NZDT"
				]
			],
			[
				1428170400,
				720,
				[
					"NZST"
				]
			],
			[
				1443290400,
				780,
				[
					"NZDT"
				]
			],
			[
				1459620000,
				720,
				[
					"NZST"
				]
			],
			[
				1474740000,
				780,
				[
					"NZDT"
				]
			],
			[
				1491069600,
				720,
				[
					"NZST"
				]
			],
			[
				1506189600,
				780,
				[
					"NZDT"
				]
			],
			[
				1522519200,
				720,
				[
					"NZST"
				]
			],
			[
				1538244000,
				780,
				[
					"NZDT"
				]
			],
			[
				1554573600,
				720,
				[
					"NZST"
				]
			],
			[
				1569693600,
				780,
				[
					"NZDT"
				]
			],
			[
				1586023200,
				720,
				[
					"NZST"
				]
			],
			[
				1601143200,
				780,
				[
					"NZDT"
				]
			],
			[
				1617472800,
				720,
				[
					"NZST"
				]
			],
			[
				1632592800,
				780,
				[
					"NZDT"
				]
			],
			[
				1648922400,
				720,
				[
					"NZST"
				]
			],
			[
				1664042400,
				780,
				[
					"NZDT"
				]
			],
			[
				1680372000,
				720,
				[
					"NZST"
				]
			],
			[
				1695492000,
				780,
				[
					"NZDT"
				]
			],
			[
				1712426400,
				720,
				[
					"NZST"
				]
			],
			[
				1727546400,
				780,
				[
					"NZDT"
				]
			],
			[
				1743876000,
				720,
				[
					"NZST"
				]
			],
			[
				1758996000,
				780,
				[
					"NZDT"
				]
			],
			[
				1775325600,
				720,
				[
					"NZST"
				]
			],
			[
				1790445600,
				780,
				[
					"NZDT"
				]
			],
			[
				1806775200,
				720,
				[
					"NZST"
				]
			],
			[
				1821895200,
				780,
				[
					"NZDT"
				]
			],
			[
				1838224800,
				720,
				[
					"NZST"
				]
			],
			[
				1853344800,
				780,
				[
					"NZDT"
				]
			],
			[
				1869674400,
				720,
				[
					"NZST"
				]
			],
			[
				1885399200,
				780,
				[
					"NZDT"
				]
			],
			[
				1901728800,
				720,
				[
					"NZST"
				]
			],
			[
				1916848800,
				780,
				[
					"NZDT"
				]
			],
			[
				1933178400,
				720,
				[
					"NZST"
				]
			],
			[
				1948298400,
				780,
				[
					"NZDT"
				]
			],
			[
				1964628000,
				720,
				[
					"NZST"
				]
			],
			[
				1979748000,
				780,
				[
					"NZDT"
				]
			],
			[
				1996077600,
				720,
				[
					"NZST"
				]
			],
			[
				2011197600,
				780,
				[
					"NZDT"
				]
			],
			[
				2027527200,
				720,
				[
					"NZST"
				]
			],
			[
				2042647200,
				780,
				[
					"NZDT"
				]
			],
			[
				2058976800,
				720,
				[
					"NZST"
				]
			],
			[
				2074701600,
				780,
				[
					"NZDT"
				]
			],
			[
				2091031200,
				720,
				[
					"NZST"
				]
			],
			[
				2106151200,
				780,
				[
					"NZDT"
				]
			],
			[
				2122480800,
				720,
				[
					"NZST"
				]
			],
			[
				2137600800,
				780,
				[
					"NZDT"
				]
			]
		],
		"name": "Pacific/Auckland"
	},
	{
		"hoverRegion": [
			{
				"points": [
					58.01,
					70.36,
					58.65,
					70.88,
					58.48,
					71.37,
					58.19,
					71.37,
					58.23,
					71.98,
					58.13,
					72.16,
					58.11,
					72.83,
					58.25,
					73.08,
					58.24,
					74.18,
					58.67,
					75.04,
					58.76,
					75.09,
					59.06,
					75.56,
					59.29,
					75.51,
					59.38,
					75.75,
					59.53,
					75.84,
					59.65,
					76.15,
					59.68,
					76.53,
					59.8,
					76.63,
					60.1,
					76.57,
					60.25,
					76.68,
					60.53,
					76.68,
					60.61,
					76.89,
					60.77,
					76.88,
					60.96,
					77.1,
					60.85,
					77.93,
					60.94,
					79.17,
					60.87,
					79.39,
					60.75,
					79.41,
					60.77,
					80.16,
					60.9,
					80.71,
					60.86,
					81.05,
					60.74,
					81.16,
					60.76,
					81.85,
					60.63,
					82.16,
					60.81,
					82.33,
					61,
					82.76,
					61.14,
					83.13,
					61.15,
					83.5,
					60.93,
					84.01,
					60.95,
					84.29,
					60.54,
					84.77,
					60.33,
					84.89,
					60.01,
					84.71,
					60.06,
					86.56,
					59.99,
					87.11,
					59.79,
					87.25,
					59.75,
					87.59,
					59.37,
					87.94,
					59.4,
					88.66,
					59.25,
					88.71,
					59.06,
					88.93,
					58.96,
					88.92,
					58.81,
					88.43,
					58.48,
					88.05,
					58.2,
					88.2,
					58.06,
					88.86,
					58.05,
					89.35,
					57.97,
					89.45,
					57.57,
					89.48,
					57.51,
					89.18,
					57.17,
					88.77,
					57.06,
					88.84,
					56.89,
					88.73,
					56.68,
					88.84,
					56.58,
					88.72,
					56.51,
					88.73,
					56.39,
					89.13,
					55.84,
					89.55,
					55.67,
					89.4,
					55.42,
					88.74,
					55.25,
					88.54,
					54.8,
					88.87,
					54.67,
					88.72,
					54.43,
					88.64,
					54.52,
					88.89,
					54.41,
					89.03,
					54.44,
					89.19,
					54.28,
					89.33,
					54.04,
					89.23,
					53.8,
					89.38,
					53.53,
					88.95,
					53.28,
					89.15,
					53.04,
					89.12,
					52.81,
					89.34,
					52.66,
					89.19,
					52.53,
					89.2,
					52.31,
					88.83,
					52.15,
					88.74,
					51.96,
					88.12,
					51.87,
					88.04,
					51.74,
					88.21,
					51.57,
					88.06,
					51.44,
					88.49,
					51.66,
					88.74,
					51.5,
					89.05,
					51.29,
					89.05,
					51.11,
					89.16,
					50.55,
					89.96,
					50.33,
					89.9,
					50.28,
					89.59,
					50.08,
					89.66,
					50.12,
					90.21,
					50.24,
					90.31,
					50.27,
					90.58,
					50.37,
					90.56,
					50.59,
					90.7,
					50.57,
					91.33,
					50.81,
					91.7,
					50.82,
					92.21,
					51,
					92.39,
					50.82,
					92.64,
					50.87,
					93.06,
					50.67,
					93.13,
					50.67,
					94.31,
					50.27,
					94.5,
					50.14,
					94.65,
					50.16,
					94.99,
					50.06,
					95.13,
					50.03,
					95.48,
					50.15,
					95.87,
					50.02,
					96.43,
					50.09,
					96.61,
					50.01,
					96.72,
					50.01,
					97.03,
					49.78,
					97.28,
					49.48,
					97.09,
					49.3,
					97.64,
					49.14,
					97.86,
					49.18,
					98.27,
					49.11,
					98.58,
					49.23,
					98.87,
					49.2,
					99.14,
					48.88,
					99.33,
					48.47,
					99.16,
					48.28,
					99.2,
					47.94,
					98.17,
					47.72,
					98.42,
					47.52,
					98.42,
					47.18,
					98.19,
					46.99,
					97.94,
					46.56,
					97.68,
					46.23,
					97.88,
					45.9,
					98.41,
					45.43,
					98.55,
					44.56,
					98.28,
					43.74,
					97.81,
					42.64,
					97.92,
					42.62,
					96.29,
					42.82,
					96.22,
					43.21,
					95.79,
					43.89,
					95.47,
					43.99,
					95.24,
					44.16,
					95.27,
					44.14,
					94.96,
					44.23,
					94.67,
					44.85,
					93.47,
					44.95,
					91.58,
					45.03,
					91.42,
					45.09,
					90.82,
					45.53,
					90.55,
					45.78,
					90.62,
					46.04,
					90.89,
					46.31,
					90.8,
					46.67,
					90.95,
					46.86,
					90.84,
					46.92,
					90.65,
					47.17,
					90.43,
					47.56,
					90.25,
					47.72,
					89.99,
					47.73,
					89.71,
					47.93,
					89.52,
					47.84,
					89.01,
					47.99,
					88.9,
					48.15,
					88.5,
					48.29,
					88.48,
					48.41,
					87.92,
					48.5,
					87.87,
					48.65,
					87.93,
					48.73,
					87.72,
					48.88,
					87.66,
					49.04,
					87.72,
					49,
					87.27,
					49.13,
					87.2,
					49.2,
					86.89,
					49.61,
					86.51,
					49.35,
					86.18,
					49.49,
					85.57,
					49.48,
					85.24,
					49.78,
					85.03,
					49.84,
					84.9,
					49.98,
					84.88,
					50.1,
					84.62,
					50.14,
					84.25,
					50.26,
					84.13,
					50.45,
					84.12,
					50.72,
					83.84,
					50.9,
					83.39,
					50.9,
					83.15,
					50.78,
					82.99,
					50.8,
					82.81,
					50.63,
					82.48,
					50.7,
					81.78,
					50.64,
					81.46,
					50.86,
					81.32,
					50.86,
					81,
					51.12,
					81.01,
					51.18,
					80.72,
					51.09,
					80.56,
					50.88,
					80.53,
					50.66,
					80.02,
					51.95,
					79.01,
					53.25,
					77.73,
					53.86,
					76.53,
					54.08,
					76.33,
					54.24,
					76.35,
					53.99,
					75.56,
					53.87,
					75.5,
					53.68,
					75.08,
					53.7,
					74.84,
					53.56,
					74.67,
					53.56,
					74.54,
					53.35,
					74.42,
					53.53,
					73.93,
					53.34,
					73.39,
					53.53,
					73.14,
					53.72,
					73.15,
					53.84,
					73.27,
					53.99,
					72.92,
					54,
					72.81,
					53.85,
					72.78,
					53.79,
					72.47,
					53.87,
					72.3,
					54.06,
					72.25,
					54.02,
					72.14,
					54.11,
					71.85,
					53.99,
					71.66,
					54.06,
					71.35,
					54.03,
					71.08,
					54.33,
					70.9,
					54.43,
					70.95,
					54.45,
					71.1,
					54.64,
					71.1,
					54.83,
					70.85,
					55.06,
					70.89,
					55.18,
					70.77,
					55.08,
					70.32,
					55.18,
					70.21,
					55.37,
					70.38,
					55.5,
					70.4,
					55.59,
					70.54,
					55.68,
					70.43,
					55.92,
					70.37,
					56,
					70.7,
					56.09,
					70.79,
					56.25,
					70.65,
					56.54,
					70.68,
					56.63,
					70.96,
					56.81,
					71.02,
					56.78,
					71.34,
					56.84,
					71.51,
					57.09,
					71.18,
					57.12,
					71.03,
					57.22,
					70.98,
					57.08,
					70.78,
					57.1,
					70.55,
					57.23,
					70.41,
					57.42,
					70.31,
					57.63,
					70.46,
					57.69,
					70.34,
					57.91,
					70.26,
					58.01,
					70.36
				]
			},
			{
				"points": [
					6.35,
					100.04,
					6.55,
					99.88,
					6.39,
					99.66,
					6.49,
					99.53,
					6.36,
					99.28,
					6.47,
					99.06,
					6.62,
					99.09,
					6.71,
					99.52,
					6.77,
					99.43,
					6.91,
					99.45,
					7.19,
					99.28,
					7.21,
					99.19,
					7.08,
					99.08,
					7.15,
					98.96,
					7.27,
					98.98,
					7.32,
					99.12,
					7.4,
					99,
					7.71,
					98.9,
					7.55,
					98.75,
					7.64,
					98.65,
					7.79,
					98.65,
					7.77,
					98.59,
					7.38,
					98.38,
					7.45,
					98.2,
					7.65,
					98.26,
					7.84,
					98.15,
					8.56,
					98.09,
					9.21,
					98.15,
					9.36,
					98.28,
					9.52,
					98.23,
					9.6,
					98.34,
					9.76,
					98.28,
					10.51,
					98.7,
					10.72,
					98.68,
					11.17,
					99.14,
					11.66,
					99.38,
					11.81,
					99.54,
					12.08,
					99.38,
					12.52,
					99.33,
					12.68,
					99.14,
					13.02,
					99,
					13.27,
					99.1,
					13.83,
					99.01,
					14,
					98.88,
					14.25,
					98.52,
					14.75,
					98.16,
					15.07,
					98.08,
					15.39,
					98.23,
					15.46,
					98.47,
					16.07,
					98.45,
					16.18,
					98.61,
					16.42,
					98.55,
					16.7,
					98.36,
					16.88,
					98.4,
					17.75,
					97.61,
					18.17,
					97.56,
					18.21,
					97.4,
					18.6,
					97.24,
					18.67,
					97.32,
					18.64,
					97.63,
					18.95,
					97.56,
					19.13,
					97.71,
					19.44,
					97.68,
					19.65,
					97.78,
					19.72,
					97.93,
					19.89,
					97.97,
					19.79,
					98.53,
					19.9,
					98.92,
					20.18,
					99.01,
					20.21,
					99.4,
					20.4,
					99.36,
					20.49,
					99.42,
					20.43,
					99.67,
					20.56,
					99.92,
					20.54,
					100.04,
					20.77,
					100.14,
					20.93,
					100.41,
					21.39,
					100.65,
					21.48,
					100.94,
					21.66,
					101.1,
					21.61,
					101.31,
					21.31,
					101.37,
					21.33,
					101.63,
					21.66,
					101.7,
					21.93,
					101.51,
					22.26,
					101.43,
					22.59,
					101.7,
					22.49,
					101.91,
					22.51,
					102.19,
					22.88,
					102.49,
					22.6,
					103.02,
					22.93,
					103.33,
					22.77,
					103.51,
					22.9,
					103.68,
					22.68,
					103.93,
					22.9,
					104.07,
					22.95,
					104.28,
					22.84,
					104.39,
					22.96,
					104.56,
					22.94,
					104.69,
					23.2,
					104.74,
					23.48,
					105.38,
					23.18,
					105.63,
					23.04,
					105.91,
					23.1,
					106.17,
					22.98,
					106.36,
					23.05,
					106.54,
					22.9,
					106.87,
					22.81,
					106.93,
					22.54,
					106.83,
					22.44,
					106.67,
					22.31,
					106.79,
					22.07,
					106.8,
					22.04,
					107.06,
					21.89,
					107.12,
					21.75,
					107.41,
					21.76,
					107.89,
					21.54,
					108.17,
					21.31,
					108.06,
					21.2,
					108.09,
					21.12,
					107.96,
					20.91,
					107.9,
					20.83,
					107.74,
					20.89,
					107.65,
					20.6,
					107.47,
					20.73,
					107.23,
					20.63,
					107.16,
					20.66,
					106.91,
					20.58,
					106.77,
					20.5,
					106.68,
					20.13,
					106.65,
					19.82,
					106.04,
					19.56,
					105.92,
					19.31,
					106.03,
					18.99,
					105.74,
					18.86,
					105.87,
					18.91,
					105.97,
					18.85,
					106.06,
					18.72,
					106.05,
					18.68,
					105.94,
					18.44,
					106.09,
					18.15,
					106.56,
					17.93,
					106.62,
					17.81,
					106.57,
					17.54,
					106.71,
					17.17,
					107.18,
					16.86,
					107.4,
					16.3,
					108.28,
					16.08,
					108.43,
					16.03,
					108.61,
					15.84,
					108.63,
					15.79,
					108.54,
					15.28,
					109.04,
					15.01,
					109.03,
					13.64,
					109.47,
					13.16,
					109.41,
					12.92,
					109.56,
					12.79,
					109.49,
					12.62,
					109.57,
					12.43,
					109.45,
					12.15,
					109.44,
					12.08,
					109.34,
					11.85,
					109.39,
					11.46,
					109.13,
					11.3,
					109.12,
					11.13,
					108.9,
					11.05,
					108.59,
					10.8,
					108.33,
					10.8,
					108.16,
					10.59,
					108.03,
					10.59,
					107.85,
					10.21,
					107.12,
					10.23,
					107,
					10.32,
					106.97,
					10.26,
					106.89,
					10.07,
					106.89,
					9.96,
					106.75,
					9.82,
					106.79,
					9.75,
					106.66,
					9.49,
					106.6,
					9.43,
					106.33,
					9.25,
					106.21,
					9.02,
					105.6,
					8.72,
					105.4,
					8.53,
					105.18,
					8.46,
					104.95,
					8.35,
					104.94,
					8.29,
					104.84,
					8.34,
					104.73,
					8.48,
					104.73,
					8.6,
					104.61,
					8.72,
					104.71,
					9.85,
					104.8,
					9.98,
					104.72,
					10.06,
					104.79,
					10.04,
					104.66,
					9.92,
					104.62,
					9.85,
					104.76,
					9.72,
					104.73,
					9.69,
					104.56,
					9.9,
					104.55,
					10.08,
					104.38,
					10.25,
					104.41,
					10.22,
					104.27,
					10.45,
					104.18,
					10.44,
					104.11,
					10.28,
					104.19,
					9.89,
					104.12,
					9.83,
					103.95,
					10.33,
					103.72,
					10.39,
					103.51,
					10.49,
					103.42,
					10.45,
					103.26,
					10.78,
					103.07,
					10.81,
					102.98,
					10.96,
					102.93,
					11.09,
					103,
					11.22,
					102.88,
					11.49,
					102.88,
					11.95,
					102.63,
					11.67,
					102.71,
					11.5,
					102.68,
					11.45,
					102.58,
					11.54,
					102.43,
					11.68,
					102.43,
					11.7,
					102.3,
					12.19,
					102.15,
					12.48,
					101.88,
					12.45,
					101.77,
					12.56,
					101.68,
					12.41,
					101.43,
					12.55,
					101.07,
					12.41,
					101,
					12.42,
					100.89,
					12.57,
					100.83,
					12.6,
					100.7,
					12.92,
					100.56,
					13.04,
					100.62,
					13.03,
					100.76,
					13.16,
					100.69,
					13.36,
					100.83,
					13.39,
					100.3,
					13.26,
					100.09,
					13.05,
					100.2,
					12.62,
					100.06,
					12.19,
					100.13,
					11.29,
					99.66,
					10.81,
					99.6,
					10.53,
					99.36,
					10.39,
					99.46,
					10.07,
					99.25,
					9.75,
					99.26,
					9.31,
					99.44,
					9.38,
					99.55,
					9.86,
					99.6,
					9.85,
					99.75,
					9.63,
					99.82,
					9.86,
					99.89,
					9.86,
					100.13,
					9.42,
					100.17,
					9.19,
					99.96,
					8.63,
					100.06,
					8.45,
					100.32,
					7.32,
					100.63,
					7.06,
					100.84,
					6.96,
					101.02,
					7.05,
					101.28,
					6.91,
					101.64,
					6.3,
					102.18,
					6.13,
					102.19,
					5.64,
					101.89,
					5.66,
					101.63,
					5.79,
					101.54,
					5.72,
					101.34,
					5.5,
					101.12,
					5.77,
					100.87,
					5.99,
					100.99,
					6.13,
					100.95,
					6.14,
					100.78,
					6.34,
					100.72,
					6.43,
					100.33,
					6.52,
					100.24,
					6.33,
					100.17,
					6.35,
					100.04
				]
			},
			{
				"points": [
					-0.79,
					104.38,
					-0.75,
					104.27,
					-0.41,
					104.05,
					-0.24,
					104.1,
					-0.23,
					104.31,
					0.01,
					104.26,
					0.17,
					104.07,
					0.28,
					104.19,
					0.44,
					104.17,
					0.52,
					104.01,
					0.66,
					103.98,
					0.61,
					103.85,
					0.45,
					103.84,
					0.44,
					103.72,
					0.32,
					103.82,
					-0.05,
					103.9,
					-0.13,
					103.65,
					-0.37,
					103.87,
					-0.6,
					103.51,
					-0.68,
					103.49,
					-0.89,
					103.78,
					-0.96,
					104.45,
					-1.78,
					104.63,
					-1.87,
					104.69,
					-1.93,
					104.89,
					-2.07,
					104.97,
					-2.21,
					104.95,
					-2.3,
					105.67,
					-2.25,
					105.66,
					-2.18,
					105.07,
					-1.92,
					105.02,
					-1.75,
					105.23,
					-1.52,
					105.31,
					-1.39,
					105.93,
					-1.55,
					106.13,
					-2.32,
					106.37,
					-2.51,
					106.93,
					-2.62,
					106.94,
					-2.73,
					106.81,
					-2.79,
					106.95,
					-2.71,
					107.08,
					-2.85,
					107.24,
					-2.46,
					107.61,
					-2.46,
					108.05,
					-2.78,
					108.51,
					-2.9,
					108.47,
					-2.91,
					108.34,
					-3.11,
					108.34,
					-3.29,
					108.5,
					-3.41,
					108.38,
					-3.31,
					108.24,
					-3.36,
					107.5,
					-3.05,
					107.33,
					-3.15,
					107.13,
					-3,
					107,
					-3.13,
					106.94,
					-3.23,
					106.46,
					-3.06,
					106.34,
					-3,
					106.16,
					-3.24,
					106.32,
					-3.47,
					105.97,
					-3.62,
					105.93,
					-3.84,
					106.06,
					-4.16,
					105.92,
					-4.44,
					106.01,
					-4.93,
					106.02,
					-5.85,
					105.91,
					-5.7,
					106.31,
					-5.86,
					106.37,
					-5.93,
					106.49,
					-5.9,
					106.71,
					-6,
					106.85,
					-5.8,
					107.03,
					-5.88,
					107.4,
					-6.12,
					107.67,
					-6.07,
					107.81,
					-6.2,
					108.13,
					-6.13,
					108.33,
					-6.42,
					108.63,
					-6.67,
					108.68,
					-6.72,
					108.89,
					-6.67,
					109,
					-6.74,
					109.32,
					-6.67,
					109.47,
					-6.8,
					109.89,
					-6.74,
					110.19,
					-6.83,
					110.35,
					-6.68,
					110.51,
					-6.41,
					110.59,
					-6.28,
					110.91,
					-6.36,
					111.11,
					-6.58,
					111.21,
					-6.5,
					111.5,
					-6.65,
					111.75,
					-6.66,
					112.01,
					-6.78,
					112.12,
					-6.74,
					112.58,
					-6.89,
					112.69,
					-6.77,
					112.86,
					-6.75,
					113.96,
					-6.96,
					114.32,
					-6.85,
					114.45,
					-7.03,
					114.83,
					-7.21,
					114.85,
					-7.3,
					114.38,
					-7.22,
					114.21,
					-7.1,
					114.16,
					-7.27,
					114.13,
					-7.33,
					113.97,
					-7.33,
					113.32,
					-7.42,
					113.21,
					-7.3,
					113.09,
					-7.28,
					112.93,
					-7.48,
					112.87,
					-7.63,
					113.35,
					-7.62,
					113.75,
					-7.5,
					114.04,
					-7.7,
					114.5,
					-8.39,
					114.47,
					-8.54,
					114.52,
					-8.59,
					114.65,
					-8.81,
					114.68,
					-8.85,
					114.34,
					-8.71,
					114.23,
					-8.75,
					114.01,
					-8.53,
					113.51,
					-8.61,
					113.3,
					-8.41,
					113.19,
					-8.56,
					112.73,
					-8.38,
					111.87,
					-8.51,
					111.69,
					-8.37,
					111.4,
					-8.3,
					110.66,
					-7.94,
					109.86,
					-7.8,
					109.23,
					-7.89,
					109.05,
					-7.79,
					108.61,
					-7.92,
					108.41,
					-7.84,
					107.82,
					-7.6,
					107.36,
					-7.47,
					106.35,
					-7.21,
					106.27,
					-7.09,
					106.36,
					-6.92,
					105.95,
					-7.05,
					105.84,
					-7,
					105.66,
					-7.12,
					105.53,
					-7.07,
					105.42,
					-6.94,
					105.42,
					-6.92,
					105.16,
					-6.63,
					105,
					-6.53,
					105.02,
					-6.41,
					105.28,
					-6.6,
					105.45,
					-6.39,
					105.57,
					-6.37,
					105.7,
					-6.04,
					105.77,
					-5.97,
					105.72,
					-5.94,
					105.62,
					-6.21,
					105.55,
					-6.27,
					105.46,
					-6.12,
					105.24,
					-5.93,
					105.35,
					-5.81,
					104.95,
					-6.02,
					104.78,
					-6.03,
					104.5,
					-5.3,
					103.81,
					-5.19,
					103.79,
					-4.57,
					102.82,
					-4.03,
					102.19,
					-3.73,
					102.11,
					-3.29,
					101.51,
					-2.8,
					101.22,
					-2.36,
					100.78,
					-2.15,
					100.7,
					-1.94,
					100.73,
					-1.41,
					100.46,
					-1.26,
					100.22,
					-1.04,
					100.28,
					-0.92,
					100.23,
					-0.38,
					99.72,
					-0.05,
					99.58,
					0.19,
					99.04,
					0.71,
					98.94,
					1.47,
					98.63,
					1.48,
					98.47,
					1.61,
					98.35,
					1.74,
					98.36,
					1.78,
					98.49,
					2.14,
					97.94,
					2.2,
					97.66,
					2.38,
					97.55,
					2.79,
					97.5,
					2.91,
					97.28,
					3.58,
					96.8,
					3.67,
					96.42,
					4.78,
					95.28,
					5.23,
					95.1,
					5.46,
					95.1,
					5.56,
					94.94,
					5.82,
					94.94,
					5.85,
					95.05,
					5.77,
					95.15,
					5.94,
					95.11,
					6.01,
					95.22,
					5.93,
					95.44,
					5.76,
					95.42,
					5.6,
					95.92,
					5.39,
					96.13,
					5.32,
					96.39,
					5.38,
					96.89,
					5.26,
					97.2,
					5.34,
					97.55,
					4.94,
					97.99,
					4.67,
					98.06,
					4.48,
					98.37,
					4.16,
					98.38,
					4.08,
					98.6,
					3.8,
					98.85,
					3.24,
					99.83,
					3,
					100.07,
					2.84,
					100.08,
					2.75,
					100.31,
					2.3,
					100.57,
					2.41,
					101.07,
					2.13,
					101.37,
					2.2,
					101.53,
					2.18,
					101.77,
					1.97,
					101.89,
					1.74,
					101.84,
					1.6,
					102.52,
					1.17,
					102.62,
					1.25,
					102.71,
					1.24,
					102.88,
					0.95,
					103.25,
					1.06,
					103.18,
					1.2,
					103.22,
					1.23,
					103.42,
					0.96,
					103.6,
					1.18,
					103.72,
					1.26,
					103.87,
					1.32,
					104.63,
					1.17,
					104.71,
					1.13,
					104.89,
					0.89,
					105.03,
					0.82,
					104.97,
					0.84,
					104.84,
					0.61,
					104.77,
					0.66,
					104.43,
					0.61,
					104.38,
					0.48,
					104.64,
					0.27,
					104.64,
					0,
					104.95,
					-0.27,
					105.09,
					-0.44,
					104.96,
					-0.4,
					104.67,
					-0.7,
					104.59,
					-0.79,
					104.38
				]
			},
			{
				"points": [
					-1.72,
					109.44,
					-1.85,
					109.31,
					-1.71,
					108.99,
					-1.83,
					108.73,
					-1.73,
					108.57,
					-1.48,
					108.64,
					-1.43,
					108.93,
					-1.23,
					109.01,
					-1.09,
					109.17,
					-1.1,
					109.32,
					-0.99,
					109.34,
					-0.93,
					109.18,
					-0.64,
					109.14,
					-0.58,
					109.02,
					-0.28,
					108.94,
					0.05,
					109.07,
					0.28,
					108.8,
					0.49,
					108.72,
					0.62,
					108.79,
					0.63,
					108.68,
					0.77,
					108.58,
					0.87,
					108.62,
					0.98,
					108.84,
					1.17,
					108.79,
					1.57,
					108.95,
					1.74,
					109.16,
					2.01,
					109.24,
					2.18,
					109.63,
					2.11,
					109.74,
					1.93,
					109.67,
					1.81,
					109.78,
					1.65,
					109.77,
					1.26,
					110.25,
					1.07,
					110.35,
					0.97,
					110.58,
					1.13,
					110.88,
					1.19,
					111.19,
					1.11,
					111.79,
					1.21,
					111.88,
					1.24,
					112.05,
					1.52,
					112.12,
					1.68,
					112.48,
					1.65,
					113.08,
					1.53,
					113.16,
					1.35,
					113.65,
					1.56,
					114.12,
					1.24,
					114.2,
					0.94,
					113.9,
					0.83,
					114,
					0.72,
					113.96,
					0.65,
					114.36,
					0.86,
					114.84,
					0.79,
					115.02,
					0.42,
					115.19,
					0.22,
					114.98,
					-0.06,
					114.97,
					0.1,
					115.25,
					0.05,
					115.36,
					-0.06,
					115.42,
					-0.29,
					115.35,
					-0.74,
					115.48,
					-1.02,
					115.8,
					-1.23,
					115.86,
					-1.58,
					115.68,
					-1.62,
					115.49,
					-2.07,
					115.41,
					-3.01,
					114.67,
					-3.56,
					114.39,
					-3.43,
					114.05,
					-3.56,
					113.83,
					-3.56,
					113.59,
					-3.29,
					113.5,
					-3.4,
					113.32,
					-3.21,
					113.11,
					-3.51,
					112.66,
					-3.54,
					112.52,
					-3.43,
					112.25,
					-3.67,
					111.86,
					-3.55,
					111.67,
					-3.03,
					111.69,
					-3.14,
					111.58,
					-3.04,
					111.32,
					-3.2,
					110.92,
					-3.13,
					110.77,
					-3.16,
					110.59,
					-3.01,
					110.5,
					-3.12,
					110.25,
					-2.96,
					110.01,
					-2.76,
					109.92,
					-2.5,
					110.07,
					-2.38,
					109.94,
					-2.07,
					109.99,
					-1.84,
					109.78,
					-1.63,
					109.92,
					-1.37,
					109.92,
					-1.25,
					109.8,
					-1.42,
					109.48,
					-1.72,
					109.44
				]
			},
			{
				"points": [
					0.73,
					97.41,
					0.73,
					97.27,
					0.87,
					97.15,
					1.01,
					97.21,
					1.21,
					96.96,
					1.46,
					97.01,
					1.62,
					97.41,
					1.13,
					97.96,
					0.95,
					98.04,
					0.45,
					97.87,
					0.48,
					97.64,
					0.73,
					97.41
				]
			},
			{
				"points": [
					-3.52,
					100.76,
					-3.58,
					100.61,
					-3.42,
					100.53,
					-3.37,
					100.25,
					-2.87,
					99.88,
					-2.51,
					99.86,
					-2.49,
					99.69,
					-2.28,
					99.43,
					-1.87,
					99.51,
					-1.9,
					99.65,
					-2.39,
					99.95,
					-2.95,
					100.55,
					-3.24,
					100.67,
					-3.35,
					100.63,
					-3.42,
					100.76,
					-3.52,
					100.76
				]
			},
			{
				"points": [
					-1.93,
					99.41,
					-2.04,
					99.33,
					-1.95,
					99.17,
					-1.96,
					99.01,
					-1.68,
					98.72,
					-1.21,
					98.47,
					-0.89,
					98.59,
					-0.84,
					98.91,
					-0.89,
					99.01,
					-1.59,
					99.38,
					-1.93,
					99.41
				]
			},
			{
				"points": [
					2.56,
					106.37,
					2.5,
					106.27,
					2.55,
					106.18,
					2.92,
					106,
					2.73,
					105.81,
					2.72,
					105.71,
					3.14,
					105.49,
					3.22,
					105.66,
					3.12,
					105.84,
					3.23,
					106,
					3.38,
					105.94,
					3.5,
					106.12,
					3.46,
					106.53,
					3.2,
					106.6,
					2.95,
					106.52,
					2.87,
					106.43,
					2.89,
					106.27,
					2.56,
					106.37
				]
			},
			{
				"points": [
					1.97,
					96.71,
					2.03,
					96.52,
					2.24,
					96.52,
					2.24,
					96.15,
					2.56,
					95.7,
					2.79,
					95.58,
					3,
					95.71,
					3,
					95.92,
					2.73,
					96.28,
					2.74,
					96.45,
					2.56,
					96.47,
					2.4,
					96.6,
					2.28,
					96.56,
					2.26,
					96.7,
					2.13,
					96.78,
					1.97,
					96.71
				]
			},
			{
				"points": [
					-0.7,
					98.58,
					-0.75,
					98.49,
					-0.59,
					98.19,
					-0.25,
					98.16,
					-0.11,
					98.06,
					0.16,
					98.18,
					0.09,
					98.43,
					0.22,
					98.46,
					0.27,
					98.83,
					0.1,
					98.96,
					0.01,
					98.88,
					-0.03,
					98.63,
					-0.7,
					98.58
				]
			}
		],
		"transitions": [
			[
				0,
				420,
				[
					"ICT",
					"WIT",
					"NOVT",
					"CXT",
					"HOVT",
					"OMST"
				]
			]
		],
		"name": "Asia/Ho_Chi_Minh"
	},
	{
		"hoverRegion": [
			{
				"points": [
					16.02,
					42.49,
					15.98,
					42.39,
					16.06,
					42.19,
					16.28,
					42.07,
					16.45,
					42.13,
					16.43,
					42.01,
					16.21,
					42.04,
					16.21,
					41.89,
					16.42,
					41.78,
					16.53,
					41.84,
					16.62,
					41.67,
					16.59,
					41.52,
					16.68,
					41.47,
					16.93,
					41.46,
					17.09,
					41.56,
					17.2,
					41.92,
					17.14,
					42.01,
					17.01,
					42.01,
					16.65,
					42.43,
					16.86,
					42.29,
					17.38,
					42.2,
					17.77,
					41.68,
					18.06,
					41.45,
					18.38,
					41.34,
					18.3,
					41.23,
					18.41,
					40.96,
					18.62,
					40.94,
					18.7,
					41.09,
					19,
					41.05,
					18.95,
					40.87,
					19.33,
					40.76,
					19.59,
					40.48,
					19.86,
					40.42,
					20.02,
					40.22,
					19.86,
					40.21,
					19.85,
					40.09,
					19.98,
					40,
					20.08,
					40.1,
					20.22,
					39.83,
					20.2,
					39.67,
					21.05,
					39.09,
					21.3,
					38.99,
					21.47,
					39.05,
					22,
					38.81,
					22.13,
					38.93,
					22.32,
					38.95,
					22.38,
					38.83,
					22.71,
					38.84,
					22.9,
					38.65,
					23.14,
					38.66,
					23.16,
					38.54,
					23.32,
					38.53,
					23.4,
					38.42,
					23.45,
					38.14,
					23.6,
					38.13,
					23.64,
					38.26,
					23.7,
					38.25,
					23.91,
					38.06,
					24.16,
					37.67,
					24.15,
					37.51,
					24.31,
					37.33,
					24.45,
					37.31,
					24.92,
					36.95,
					25.06,
					36.99,
					25.08,
					37.14,
					25.23,
					37.05,
					25.13,
					36.9,
					25.55,
					36.4,
					25.95,
					36.52,
					26.12,
					36.26,
					26.27,
					36.29,
					26.47,
					36.19,
					26.43,
					36.06,
					26.58,
					35.92,
					26.7,
					35.92,
					26.75,
					35.79,
					27.09,
					35.63,
					27.23,
					35.64,
					27.54,
					35.41,
					27.67,
					35.08,
					27.84,
					34.97,
					27.79,
					34.56,
					27.94,
					34.39,
					28.54,
					34.69,
					28.69,
					34.66,
					29.44,
					34.89,
					29.3,
					36.04,
					29.57,
					36.42,
					29.96,
					36.69,
					30.09,
					37.42,
					30.41,
					37.58,
					30.53,
					37.81,
					31.43,
					36.92,
					31.55,
					36.91,
					32.09,
					38.94,
					32.21,
					39.09,
					32.26,
					38.93,
					32.48,
					38.87,
					32.57,
					38.94,
					33.41,
					38.68,
					34.43,
					40.61,
					34.51,
					40.92,
					34.81,
					41.11,
					35.24,
					41.1,
					35.64,
					41.25,
					36.06,
					41.14,
					36.35,
					41.17,
					36.61,
					41.33,
					36.69,
					41.76,
					37.19,
					42.28,
					37.24,
					42.52,
					37.48,
					42.74,
					37.43,
					42.96,
					37.47,
					43.17,
					37.31,
					43.82,
					37.43,
					44.13,
					37.3,
					44.35,
					37.11,
					44.31,
					37.29,
					44.59,
					37.24,
					44.84,
					37.04,
					45,
					36.84,
					44.97,
					36.73,
					45.16,
					36.55,
					45.12,
					36.45,
					45.36,
					36.1,
					45.44,
					36.1,
					45.58,
					35.92,
					45.79,
					35.97,
					46.11,
					35.87,
					46.43,
					35.64,
					46.34,
					35.58,
					46.11,
					35.33,
					46.25,
					35.04,
					46.28,
					34.94,
					45.99,
					34.75,
					45.81,
					34.44,
					45.8,
					34.46,
					45.58,
					34.3,
					45.69,
					34.1,
					45.68,
					34,
					45.6,
					33.72,
					45.81,
					33.7,
					45.99,
					33.33,
					46.27,
					33.06,
					46.27,
					33.02,
					46.5,
					32.56,
					47.19,
					32.56,
					47.44,
					32.29,
					47.65,
					32.17,
					47.66,
					31.86,
					47.95,
					31.37,
					47.79,
					31.1,
					47.79,
					31.07,
					48.11,
					30.54,
					48.13,
					30.26,
					48.49,
					30.06,
					48.54,
					29.96,
					48.68,
					29.85,
					48.64,
					29.84,
					48.46,
					29.55,
					48.37,
					29.42,
					48.48,
					29.31,
					48.47,
					29.33,
					48.21,
					29.04,
					48.27,
					28.8,
					48.48,
					28.13,
					48.75,
					27.87,
					48.98,
					27.69,
					48.99,
					27.6,
					49.32,
					27.43,
					49.43,
					27.36,
					49.79,
					27.04,
					49.78,
					26.91,
					50.04,
					26.71,
					50.24,
					26.26,
					50.33,
					26.38,
					50.6,
					26.35,
					50.71,
					25.81,
					50.68,
					25.83,
					50.85,
					26.02,
					50.89,
					26.28,
					51.18,
					25.98,
					51.66,
					25.78,
					51.71,
					25.51,
					51.6,
					25.41,
					51.69,
					24.98,
					51.74,
					24.67,
					51.55,
					24.57,
					51.59,
					24.41,
					51.5,
					24.31,
					51.66,
					24.15,
					51.69,
					23.04,
					52.63,
					22.74,
					55.1,
					22.81,
					55.23,
					21.97,
					55.77,
					19.92,
					55.07,
					18.93,
					52.15,
					16.65,
					53.21,
					16.56,
					53.15,
					16.32,
					52.5,
					16.19,
					52.36,
					15.93,
					52.26,
					15.53,
					52.28,
					15.12,
					51.41,
					14.92,
					50.55,
					14.74,
					50.22,
					14.73,
					49.95,
					14.51,
					49.35,
					14.42,
					49.16,
					14.23,
					49.07,
					13.93,
					48.7,
					13.86,
					48.22,
					13.92,
					47.98,
					13.53,
					47.41,
					13.32,
					46.73,
					13.24,
					45.71,
					12.97,
					45.45,
					12.88,
					45.21,
					12.66,
					45.11,
					12.68,
					44.59,
					12.56,
					44.44,
					12.48,
					43.98,
					12.62,
					43.6,
					12.52,
					43.41,
					12.08,
					43.52,
					11.9,
					43.44,
					11.82,
					43.27,
					11.63,
					43.27,
					11.57,
					43.55,
					11.23,
					43.62,
					10.76,
					44.03,
					10.53,
					44.33,
					10.52,
					44.92,
					10.97,
					45.79,
					10.79,
					46.43,
					11.28,
					47.41,
					11.2,
					47.69,
					11.22,
					48,
					11.41,
					48.49,
					11.35,
					48.95,
					11.43,
					49.37,
					11.55,
					49.53,
					11.68,
					50.22,
					11.78,
					50.38,
					11.99,
					50.5,
					12.09,
					50.76,
					11.89,
					51.37,
					11.25,
					51.2,
					11.15,
					51.28,
					10.93,
					51.22,
					10.63,
					51.27,
					10.42,
					51.52,
					10.25,
					51.41,
					10.3,
					51.21,
					10.23,
					51,
					9.35,
					50.91,
					8.79,
					50.51,
					8.15,
					50.22,
					7.87,
					49.93,
					7.68,
					49.92,
					6.68,
					49.31,
					5.98,
					49.07,
					4.4,
					48.04,
					2.34,
					46.08,
					1.5,
					44.66,
					0.56,
					43.56,
					-1.12,
					42.06,
					-2.1,
					41.33,
					-2.62,
					40.71,
					-2.65,
					40.46,
					-2.76,
					40.31,
					-2.97,
					40.35,
					-3.32,
					40.22,
					-3.45,
					40.06,
					-3.87,
					39.92,
					-4.72,
					39.46,
					-4.76,
					39.33,
					-5.23,
					39.25,
					-5.47,
					39.08,
					-6.01,
					38.89,
					-6.32,
					38.97,
					-6.58,
					39.34,
					-6.72,
					39.37,
					-6.78,
					39.54,
					-6.97,
					39.65,
					-7.17,
					39.65,
					-7.33,
					39.48,
					-7.47,
					39.51,
					-7.53,
					39.41,
					-7.67,
					39.4,
					-7.82,
					39.55,
					-7.53,
					39.87,
					-7.6,
					40,
					-8.08,
					39.85,
					-8.17,
					39.73,
					-8.05,
					39.51,
					-8.46,
					39.4,
					-8.39,
					39.51,
					-8.47,
					39.61,
					-8.7,
					39.54,
					-9.03,
					39.72,
					-9.39,
					39.71,
					-9.9,
					39.9,
					-10.25,
					40.5,
					-10.37,
					40.53,
					-10.62,
					40.45,
					-11.27,
					39.3,
					-11.28,
					38.91,
					-11.52,
					38.5,
					-11.38,
					38.18,
					-11.39,
					38,
					-11.64,
					37.87,
					-11.84,
					37.47,
					-11.78,
					37.08,
					-11.68,
					36.98,
					-11.85,
					36.58,
					-11.82,
					36.15,
					-11.66,
					36.07,
					-11.54,
					35.85,
					-11.7,
					35.64,
					-11.67,
					34.91,
					-11.05,
					34.49,
					-10.77,
					34.53,
					-10.52,
					34.43,
					-10.06,
					34.41,
					-9.68,
					34.06,
					-9.82,
					33.94,
					-9.69,
					33.73,
					-9.72,
					33.42,
					-9.6,
					33.28,
					-9.34,
					32.48,
					-9.22,
					32.37,
					-9.16,
					31.93,
					-9.03,
					31.86,
					-9,
					31.62,
					-8.71,
					31.35,
					-8.67,
					30.96,
					-8.35,
					30.7,
					-7.08,
					30.14,
					-6.48,
					29.57,
					-6.17,
					29.47,
					-5.67,
					29.48,
					-4.8,
					29.22,
					-4.38,
					29.29,
					-4.35,
					29.69,
					-4.18,
					29.95,
					-3.68,
					30.3,
					-3.49,
					30.34,
					-3.2,
					30.72,
					-3.09,
					30.72,
					-3.05,
					30.45,
					-2.87,
					30.29,
					-2.41,
					30.41,
					-2.27,
					30.72,
					-2.1,
					30.77,
					-1.96,
					30.67,
					-1.66,
					30.71,
					-1.51,
					30.63,
					-1.4,
					30.47,
					-1.18,
					30.4,
					-1.41,
					30.24,
					-1.58,
					29.96,
					-1.57,
					29.85,
					-1.44,
					29.77,
					-1.49,
					29.54,
					-1.16,
					29.47,
					0.08,
					29.6,
					0.54,
					29.86,
					0.84,
					29.85,
					0.98,
					30.08,
					1.19,
					30.18,
					1.3,
					30.4,
					2.13,
					31.16,
					2.27,
					30.96,
					2.25,
					30.81,
					2.44,
					30.63,
					2.85,
					30.76,
					3.05,
					30.65,
					3.38,
					30.8,
					3.53,
					30.71,
					3.51,
					30.49,
					3.77,
					30.44,
					3.84,
					30.16,
					4.22,
					29.87,
					4.29,
					29.71,
					4.48,
					29.7,
					4.54,
					29.55,
					4.22,
					29.24,
					4.37,
					28.98,
					4.39,
					28.75,
					4.16,
					28.4,
					4.3,
					28.03,
					4.45,
					27.95,
					4.51,
					27.71,
					4.71,
					27.66,
					4.85,
					27.45,
					5.18,
					27.19,
					5.64,
					27.11,
					5.89,
					26.72,
					6.01,
					26.36,
					6.19,
					26.4,
					6.45,
					26.17,
					6.6,
					26.25,
					6.75,
					26.02,
					6.92,
					25.96,
					7.18,
					25.4,
					7.42,
					25.1,
					7.59,
					25.06,
					7.7,
					25.16,
					7.78,
					25.13,
					7.9,
					24.89,
					8.08,
					24.79,
					8.21,
					24.13,
					8.37,
					24.04,
					8.6,
					24.1,
					8.64,
					23.44,
					8.87,
					23.44,
					9,
					23.33,
					9.23,
					23.4,
					9.34,
					23.54,
					9.86,
					23.55,
					10.4,
					23.21,
					10.84,
					22.78,
					11.28,
					22.86,
					11.32,
					22.71,
					11.58,
					22.46,
					11.93,
					22.5,
					12,
					22.34,
					12.16,
					22.37,
					12.43,
					22.26,
					12.57,
					22.31,
					12.62,
					22.2,
					12.53,
					21.89,
					12.79,
					21.72,
					13.1,
					21.85,
					13.37,
					22.15,
					13.82,
					21.99,
					14.17,
					22.4,
					14.54,
					22.27,
					14.67,
					22.33,
					14.76,
					22.58,
					14.9,
					22.57,
					15.16,
					22.84,
					15.63,
					22.85,
					15.81,
					23.11,
					15.83,
					23.89,
					19.99,
					23.89,
					20.09,
					23.98,
					20.1,
					24.89,
					22.07,
					24.92,
					22.11,
					31.26,
					22.33,
					31.49,
					22.23,
					31.6,
					22.11,
					31.6,
					22.11,
					33.16,
					21.83,
					33.59,
					21.87,
					33.92,
					22.3,
					34.1,
					22.39,
					34.61,
					22.93,
					34.87,
					22.9,
					35.18,
					23.25,
					35.59,
					23.2,
					35.7,
					22.82,
					35.97,
					22.85,
					36.1,
					23.01,
					36.21,
					22.98,
					36.35,
					22.5,
					36.46,
					22.44,
					36.68,
					22.28,
					36.74,
					22.13,
					36.98,
					21.63,
					37.02,
					21.09,
					37.42,
					20.93,
					37.33,
					20.84,
					37.39,
					20.66,
					37.31,
					20.04,
					37.29,
					18.88,
					37.54,
					18.85,
					37.79,
					18.38,
					38.21,
					18.29,
					38.5,
					18.16,
					38.61,
					17.45,
					39.01,
					16.7,
					39.25,
					16.66,
					39.42,
					16.53,
					39.4,
					16.51,
					39.28,
					16.19,
					39.32,
					16.24,
					39.47,
					16.37,
					39.42,
					16.46,
					39.54,
					16.39,
					39.66,
					16.45,
					39.91,
					16.3,
					40.09,
					16.36,
					40.12,
					16.38,
					40.01,
					16.5,
					39.97,
					16.61,
					40.07,
					16.63,
					40.23,
					16.35,
					40.34,
					16.11,
					40.29,
					15.95,
					40.45,
					16.02,
					40.56,
					15.97,
					40.68,
					15.63,
					40.9,
					15.68,
					41.01,
					15.61,
					41.1,
					15.48,
					41.07,
					15.36,
					41.19,
					15.25,
					41.12,
					15.26,
					41.03,
					15.45,
					40.95,
					15.25,
					40.66,
					15.46,
					40.48,
					15.36,
					40.38,
					15.46,
					40.1,
					14.77,
					41,
					14.71,
					41.24,
					14.03,
					41.74,
					13.98,
					42.04,
					13.74,
					42.16,
					13.71,
					42.3,
					13.32,
					42.45,
					13.32,
					42.58,
					13.13,
					42.79,
					13.13,
					42.91,
					12.69,
					43.28,
					12.8,
					43.37,
					13.25,
					43.11,
					13.66,
					43.17,
					14.58,
					42.79,
					14.97,
					42.79,
					15.06,
					42.76,
					15.15,
					42.52,
					15.37,
					42.44,
					15.41,
					42.29,
					15.68,
					42.16,
					15.81,
					42.25,
					15.83,
					42.51,
					15.92,
					42.47,
					16.02,
					42.56,
					15.97,
					42.7,
					16.59,
					42.62,
					16.61,
					42.45,
					16.47,
					42.36,
					16.44,
					42.53,
					16.31,
					42.61,
					16.02,
					42.49
				]
			},
			{
				"points": [
					-25.32,
					44.25,
					-25.06,
					43.93,
					-24.68,
					43.82,
					-24.4,
					43.57,
					-23.67,
					43.52,
					-23.48,
					43.62,
					-23.41,
					43.53,
					-23.12,
					43.48,
					-22.84,
					43.24,
					-22.08,
					43.08,
					-21.6,
					43.35,
					-21.26,
					43.4,
					-21.17,
					43.61,
					-21.06,
					43.61,
					-21.01,
					43.74,
					-20.79,
					43.8,
					-19.95,
					44.35,
					-19.79,
					44.27,
					-19.48,
					44.35,
					-19.1,
					44.12,
					-18.84,
					44.14,
					-18.45,
					43.94,
					-17.79,
					43.92,
					-17.6,
					43.81,
					-17.07,
					44.03,
					-16.67,
					44.32,
					-16.14,
					44.34,
					-16.08,
					44.44,
					-16.11,
					44.81,
					-15.84,
					45.18,
					-15.83,
					45.53,
					-15.68,
					45.6,
					-15.68,
					45.79,
					-15.6,
					45.86,
					-15.66,
					46,
					-15.61,
					46.23,
					-15.1,
					46.97,
					-14.25,
					47.64,
					-13.9,
					47.66,
					-13.82,
					47.76,
					-13.51,
					47.73,
					-13.39,
					48,
					-13.55,
					48.21,
					-13.32,
					48.03,
					-13.09,
					48.22,
					-13.32,
					48.61,
					-13.29,
					48.68,
					-12.82,
					48.83,
					-12.73,
					48.8,
					-13.06,
					48.62,
					-13.05,
					48.46,
					-12.8,
					48.47,
					-12.63,
					48.63,
					-12.67,
					48.78,
					-12.52,
					48.58,
					-12.39,
					48.56,
					-12.27,
					48.66,
					-12.32,
					48.86,
					-12.03,
					48.97,
					-11.85,
					49.32,
					-12.24,
					49.5,
					-12.34,
					49.65,
					-12.65,
					49.76,
					-12.73,
					49.93,
					-13,
					50.03,
					-13.76,
					50.24,
					-14.55,
					50.29,
					-15.17,
					50.56,
					-15.46,
					50.57,
					-16.09,
					50.24,
					-15.93,
					49.92,
					-15.59,
					49.82,
					-15.61,
					49.75,
					-15.9,
					49.84,
					-16.02,
					49.8,
					-16.23,
					49.96,
					-16.6,
					49.94,
					-16.71,
					49.85,
					-16.6,
					50,
					-16.73,
					50.1,
					-17.21,
					49.87,
					-17.18,
					49.73,
					-16.98,
					49.73,
					-17,
					49.66,
					-17.31,
					49.53,
					-17.7,
					49.62,
					-18.2,
					49.53,
					-22.51,
					48,
					-23.83,
					47.69,
					-25.06,
					47.18,
					-25.28,
					46.76,
					-25.28,
					46.41,
					-25.67,
					45.56,
					-25.71,
					45.15,
					-25.43,
					44.74,
					-25.32,
					44.25
				]
			},
			{
				"points": [
					52.17,
					23.15,
					52.29,
					23.09,
					52.64,
					23.34,
					52.75,
					23.81,
					53.12,
					23.81,
					53.57,
					23.5,
					54.05,
					23.43,
					54.01,
					24.37,
					54.12,
					24.71,
					54.22,
					24.78,
					54.42,
					25.49,
					54.62,
					25.65,
					54.86,
					25.65,
					55,
					25.79,
					55.25,
					26.42,
					55.38,
					26.38,
					55.77,
					26.56,
					55.96,
					27.11,
					55.9,
					27.55,
					56.13,
					27.76,
					56.26,
					28.11,
					56.18,
					28.32,
					56.2,
					28.69,
					56.09,
					28.79,
					56.16,
					29.12,
					56.07,
					29.45,
					55.95,
					29.57,
					55.84,
					29.55,
					55.98,
					29.97,
					55.97,
					30.25,
					55.89,
					30.55,
					55.7,
					30.8,
					55.7,
					31.01,
					55.3,
					30.99,
					55.19,
					31.12,
					55.04,
					31.13,
					54.85,
					30.96,
					54.73,
					31.28,
					54.56,
					31.27,
					54.34,
					31.4,
					54.12,
					31.96,
					53.89,
					31.93,
					53.83,
					32.5,
					53.73,
					32.6,
					53.63,
					32.59,
					53.46,
					32.88,
					53.23,
					32.79,
					52.97,
					32.17,
					53.08,
					31.51,
					53.01,
					31.46,
					52.81,
					31.7,
					52.68,
					31.68,
					52.55,
					31.78,
					52.38,
					31.71,
					52.3,
					31.84,
					52.07,
					31.9,
					52.01,
					31.81,
					52.02,
					31.45,
					51.93,
					31.3,
					51.96,
					30.99,
					51.64,
					30.66,
					51.32,
					30.77,
					51.15,
					30.59,
					51.39,
					30.16,
					51.33,
					29.81,
					51.39,
					29.67,
					51.28,
					29.26,
					51.53,
					29.12,
					51.46,
					28.91,
					51.3,
					28.78,
					51.35,
					28.6,
					51.45,
					28.56,
					51.44,
					28.35,
					51.55,
					28.24,
					51.45,
					28.03,
					51.49,
					27.9,
					51.36,
					27.72,
					51.51,
					27.56,
					51.52,
					27.22,
					51.66,
					27.12,
					51.86,
					25.28,
					51.81,
					24.48,
					51.55,
					24.25,
					51.47,
					24,
					51.52,
					23.79,
					51.39,
					23.6,
					51.72,
					23.42,
					51.86,
					23.53,
					52,
					23.54,
					52.17,
					23.15
				]
			},
			{
				"points": [
					54.35,
					19.71,
					54.38,
					19.59,
					54.48,
					19.57,
					54.75,
					19.83,
					55.04,
					19.91,
					55.06,
					20.41,
					55.38,
					20.92,
					55.26,
					21.09,
					55.39,
					21.42,
					55.13,
					22.08,
					55.17,
					22.6,
					54.82,
					23,
					54.56,
					22.81,
					54.34,
					22.86,
					54.25,
					22.77,
					54.21,
					21.46,
					54.35,
					19.71
				]
			},
			{
				"points": [
					12.19,
					53.67,
					12.51,
					53.19,
					12.7,
					53.31,
					12.81,
					53.49,
					12.8,
					54.14,
					12.58,
					54.63,
					12.45,
					54.58,
					12.25,
					54.18,
					12.19,
					53.67
				]
			}
		],
		"transitions": [
			[
				0,
				180,
				[
					"EAT",
					"AST",
					"FET"
				]
			]
		],
		"name": "Asia/Kuwait"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-32.38,
					126.06,
					-32.65,
					125.53,
					-32.6,
					125.39,
					-31.29,
					125.39,
					-31.19,
					125.45,
					-31.19,
					129,
					-31.25,
					129.09,
					-31.77,
					129.06,
					-32.16,
					128.12,
					-32.39,
					127.21,
					-32.38,
					126.06
				]
			}
		],
		"transitions": [
			[
				0,
				525,
				[
					"CWST"
				]
			]
		],
		"name": "Australia/Eucla"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-20.2,
					-58.24,
					-20.08,
					-58.24,
					-19.96,
					-58.05,
					-19.79,
					-58.23,
					-19.71,
					-58.23,
					-18.95,
					-57.84,
					-18.82,
					-57.86,
					-18.17,
					-57.61,
					-17.6,
					-57.9,
					-17.6,
					-58.07,
					-17.25,
					-58.49,
					-16.67,
					-58.57,
					-16.42,
					-58.43,
					-16.37,
					-60.18,
					-16.31,
					-60.27,
					-15.52,
					-60.34,
					-15.1,
					-60.67,
					-15.01,
					-60.61,
					-14.99,
					-60.36,
					-14.65,
					-60.36,
					-14.22,
					-60.58,
					-14,
					-60.51,
					-13.88,
					-60.55,
					-13.69,
					-60.84,
					-13.36,
					-60.47,
					-12.98,
					-60.35,
					-12.81,
					-60.13,
					-12.39,
					-59.93,
					-11.75,
					-60.21,
					-11.55,
					-60.2,
					-11.35,
					-60.03,
					-11.24,
					-60.07,
					-11.2,
					-60.42,
					-11.11,
					-60.49,
					-11.07,
					-61.6,
					-10.44,
					-61.58,
					-10.26,
					-61.67,
					-9.72,
					-61.68,
					-9.6,
					-61.6,
					-9.32,
					-61.72,
					-8.93,
					-61.59,
					-8.8,
					-61.71,
					-8.69,
					-61.69,
					-8.63,
					-58.57,
					-8.1,
					-58.41,
					-7.77,
					-58.47,
					-7.28,
					-58.22,
					-7.23,
					-58.11,
					-8.15,
					-57.54,
					-8.43,
					-57.57,
					-8.68,
					-57.5,
					-8.96,
					-57.03,
					-9.13,
					-56.96,
					-9.36,
					-56.44,
					-9.77,
					-50.14,
					-9.88,
					-50.13,
					-10.68,
					-50.49,
					-11.06,
					-50.49,
					-11.45,
					-50.62,
					-11.61,
					-50.53,
					-11.76,
					-50.6,
					-12.37,
					-50.5,
					-12.6,
					-50.55,
					-12.88,
					-50.36,
					-13.35,
					-50.49,
					-13.74,
					-50.75,
					-14.11,
					-50.73,
					-14.27,
					-50.85,
					-14.57,
					-50.86,
					-15.05,
					-51.08,
					-15.1,
					-51.36,
					-15.24,
					-51.54,
					-15.87,
					-51.79,
					-15.97,
					-52.18,
					-16.14,
					-52.33,
					-16.3,
					-52.33,
					-16.42,
					-52.49,
					-16.71,
					-52.62,
					-16.93,
					-52.91,
					-17.48,
					-53.1,
					-17.65,
					-53.01,
					-18.27,
					-52.92,
					-18.38,
					-52.65,
					-18.58,
					-52.72,
					-18.61,
					-52.42,
					-18.95,
					-51.79,
					-19.18,
					-51.07,
					-19.41,
					-50.82,
					-20.27,
					-50.93,
					-20.65,
					-51.47,
					-20.95,
					-51.54,
					-21.19,
					-51.76,
					-21.39,
					-51.77,
					-21.59,
					-51.97,
					-21.79,
					-51.97,
					-22.28,
					-52.4,
					-22.56,
					-52.9,
					-22.8,
					-53.11,
					-22.96,
					-53.48,
					-23.36,
					-53.63,
					-23.51,
					-53.87,
					-24.03,
					-54.02,
					-24.17,
					-54.26,
					-23.93,
					-54.67,
					-24.09,
					-55.01,
					-24.06,
					-55.42,
					-23.64,
					-55.63,
					-23.23,
					-55.63,
					-23.01,
					-55.79,
					-22.67,
					-55.72,
					-22.39,
					-55.91,
					-22.38,
					-56.24,
					-22.22,
					-56.41,
					-22.36,
					-56.61,
					-22.4,
					-56.84,
					-22.22,
					-57.65,
					-22.25,
					-57.83,
					-22.14,
					-58.08,
					-21.7,
					-58,
					-21.52,
					-58.07,
					-21.01,
					-57.94,
					-20.2,
					-58.24
				]
			}
		],
		"transitions": [
			[
				1318752000,
				-180,
				[
					"AMST"
				]
			],
			[
				1330243200,
				-240,
				[
					"AMT"
				]
			],
			[
				1350806400,
				-180,
				[
					"AMST"
				]
			],
			[
				1361088000,
				-240,
				[
					"AMT"
				]
			],
			[
				1382256000,
				-180,
				[
					"AMST"
				]
			],
			[
				1392537600,
				-240,
				[
					"AMT"
				]
			],
			[
				1413705600,
				-180,
				[
					"AMST"
				]
			],
			[
				1424592000,
				-240,
				[
					"AMT"
				]
			],
			[
				1445155200,
				-180,
				[
					"AMST"
				]
			],
			[
				1456041600,
				-240,
				[
					"AMT"
				]
			],
			[
				1476604800,
				-180,
				[
					"AMST"
				]
			],
			[
				1487491200,
				-240,
				[
					"AMT"
				]
			],
			[
				1508054400,
				-180,
				[
					"AMST"
				]
			],
			[
				1518940800,
				-240,
				[
					"AMT"
				]
			],
			[
				1540108800,
				-180,
				[
					"AMST"
				]
			],
			[
				1550390400,
				-240,
				[
					"AMT"
				]
			],
			[
				1571558400,
				-180,
				[
					"AMST"
				]
			],
			[
				1581840000,
				-240,
				[
					"AMT"
				]
			],
			[
				1603008000,
				-180,
				[
					"AMST"
				]
			],
			[
				1613894400,
				-240,
				[
					"AMT"
				]
			],
			[
				1634457600,
				-180,
				[
					"AMST"
				]
			],
			[
				1645344000,
				-240,
				[
					"AMT"
				]
			],
			[
				1665907200,
				-180,
				[
					"AMST"
				]
			],
			[
				1677398400,
				-240,
				[
					"AMT"
				]
			],
			[
				1697356800,
				-180,
				[
					"AMST"
				]
			],
			[
				1708243200,
				-240,
				[
					"AMT"
				]
			],
			[
				1729411200,
				-180,
				[
					"AMST"
				]
			],
			[
				1739692800,
				-240,
				[
					"AMT"
				]
			],
			[
				1760860800,
				-180,
				[
					"AMST"
				]
			],
			[
				1771747200,
				-240,
				[
					"AMT"
				]
			],
			[
				1792310400,
				-180,
				[
					"AMST"
				]
			],
			[
				1803196800,
				-240,
				[
					"AMT"
				]
			],
			[
				1823760000,
				-180,
				[
					"AMST"
				]
			],
			[
				1834646400,
				-240,
				[
					"AMT"
				]
			],
			[
				1855209600,
				-180,
				[
					"AMST"
				]
			],
			[
				1866096000,
				-240,
				[
					"AMT"
				]
			],
			[
				1887264000,
				-180,
				[
					"AMST"
				]
			],
			[
				1897545600,
				-240,
				[
					"AMT"
				]
			],
			[
				1918713600,
				-180,
				[
					"AMST"
				]
			],
			[
				1928995200,
				-240,
				[
					"AMT"
				]
			],
			[
				1950163200,
				-180,
				[
					"AMST"
				]
			],
			[
				1960444800,
				-240,
				[
					"AMT"
				]
			],
			[
				1981612800,
				-180,
				[
					"AMST"
				]
			],
			[
				1992499200,
				-240,
				[
					"AMT"
				]
			],
			[
				2013062400,
				-180,
				[
					"AMST"
				]
			],
			[
				2024553600,
				-240,
				[
					"AMT"
				]
			],
			[
				2044512000,
				-180,
				[
					"AMST"
				]
			],
			[
				2055398400,
				-240,
				[
					"AMT"
				]
			],
			[
				2076566400,
				-180,
				[
					"AMST"
				]
			],
			[
				2086848000,
				-240,
				[
					"AMT"
				]
			],
			[
				2108016000,
				-180,
				[
					"AMST"
				]
			],
			[
				2118902400,
				-240,
				[
					"AMT"
				]
			],
			[
				2139465600,
				-180,
				[
					"AMST"
				]
			]
		],
		"name": "America/Cuiaba"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-21.43,
					-136.27,
					-21.55,
					-136.3,
					-21.56,
					-136.46,
					-21.46,
					-136.52,
					-21.4,
					-136.81,
					-21.26,
					-136.85,
					-21.18,
					-136.74,
					-21.22,
					-136.48,
					-21.43,
					-136.27
				]
			},
			{
				"points": [
					-23.26,
					-134.83,
					-23.25,
					-135.1,
					-23.07,
					-135.14,
					-22.96,
					-134.86,
					-23.07,
					-134.77,
					-23.26,
					-134.83
				]
			},
			{
				"points": [
					-21.6,
					-135.53,
					-21.61,
					-135.7,
					-21.38,
					-135.7,
					-21.44,
					-135.37,
					-21.61,
					-135.39,
					-21.6,
					-135.53
				]
			},
			{
				"points": [
					-22.13,
					-136.14,
					-22.06,
					-136.29,
					-21.9,
					-136.22,
					-21.94,
					-136.07,
					-22.13,
					-136.14
				]
			}
		],
		"transitions": [
			[
				0,
				-540,
				[
					"GAMT"
				]
			]
		],
		"name": "Pacific/Gambier"
	},
	{
		"hoverRegion": [
			{
				"points": [
					42.35,
					130.95,
					42.17,
					130.63,
					42.58,
					130.46,
					42.73,
					130.29,
					42.82,
					130.36,
					42.99,
					130.99,
					43.39,
					131.17,
					43.57,
					131.07,
					44.07,
					131.18,
					44.9,
					130.85,
					45.06,
					131.43,
					45.16,
					131.57,
					45.28,
					131.59,
					45.44,
					131.87,
					45.13,
					132.93,
					45.17,
					132.99,
					45.53,
					133.07,
					45.64,
					133.31,
					45.93,
					133.39,
					46.02,
					133.58,
					46.21,
					133.6,
					46.31,
					133.76,
					46.5,
					133.74,
					46.7,
					133.91,
					47.09,
					134,
					47.17,
					134.09,
					47.39,
					134.09,
					47.58,
					134.5,
					47.73,
					134.63,
					47.96,
					134.44,
					48.21,
					134.54,
					48.27,
					134.38,
					48.22,
					134.09,
					48.08,
					133.9,
					47.96,
					133.53,
					47.99,
					133.18,
					47.82,
					132.73,
					47.6,
					132.56,
					47.61,
					130.9,
					47.82,
					130.8,
					48.05,
					130.55,
					48.32,
					130.7,
					48.42,
					130.53,
					48.64,
					130.41,
					49,
					130.59,
					49.06,
					130.91,
					49.34,
					131.11,
					49.35,
					131.31,
					49.56,
					131.37,
					49.72,
					131.24,
					49.83,
					131.38,
					49.94,
					131.18,
					50.11,
					131.2,
					50.18,
					131.3,
					50.24,
					131.26,
					50.28,
					130.87,
					50.7,
					130.54,
					50.89,
					130.71,
					51.06,
					130.69,
					51.12,
					130.86,
					51.34,
					131.01,
					51.48,
					131.32,
					51.62,
					131.28,
					51.78,
					131.36,
					51.89,
					132.23,
					52.19,
					132.56,
					52.32,
					133.21,
					52.47,
					133.13,
					52.78,
					133.27,
					52.54,
					134.53,
					52.96,
					134.54,
					53.13,
					134.75,
					53.24,
					134.76,
					53.4,
					134.72,
					53.49,
					134.56,
					53.32,
					134.02,
					53.43,
					133.57,
					53.33,
					133.29,
					53.17,
					133.16,
					53.11,
					132.14,
					53.01,
					131.88,
					53.12,
					131.78,
					53.14,
					131.36,
					53.24,
					131.34,
					53.33,
					131.41,
					53.65,
					131.34,
					53.65,
					130.89,
					53.83,
					130.31,
					53.95,
					130.29,
					54.2,
					130.44,
					54.38,
					130.72,
					54.42,
					131.03,
					54.68,
					131.11,
					54.96,
					131.85,
					55.14,
					132,
					55.16,
					132.25,
					55.29,
					132.3,
					55.3,
					132.54,
					55.43,
					132.59,
					55.59,
					132.39,
					55.5,
					131.81,
					55.5,
					131.1,
					55.6,
					130.84,
					55.9,
					130.74,
					56.17,
					130.86,
					56.28,
					130.99,
					56.45,
					131.02,
					56.6,
					131.23,
					56.55,
					131.37,
					56.64,
					131.55,
					56.75,
					131.62,
					56.99,
					131.33,
					57.05,
					131.1,
					57.27,
					130.99,
					57.41,
					131.24,
					57.35,
					131.48,
					57.62,
					131.6,
					57.69,
					131.78,
					58.11,
					131.36,
					58.23,
					131.37,
					58.28,
					131.71,
					58.2,
					131.9,
					58.32,
					132.09,
					58.56,
					132.03,
					58.69,
					132.44,
					58.68,
					132.31,
					58.77,
					132.15,
					58.96,
					132.05,
					59.07,
					131.68,
					59.31,
					131.59,
					59.7,
					131.63,
					60.05,
					131.78,
					60.09,
					131.99,
					60.33,
					132.23,
					60.74,
					132.45,
					60.79,
					132.84,
					60.91,
					133.03,
					61.32,
					132.91,
					61.43,
					132.96,
					61.52,
					132.83,
					61.63,
					132.86,
					61.8,
					133.29,
					61.77,
					133.48,
					61.91,
					133.72,
					61.84,
					134.23,
					61.54,
					134.69,
					61.52,
					134.91,
					61.59,
					135.1,
					61.75,
					135.04,
					62.06,
					135.52,
					62.16,
					135.5,
					62.25,
					135.63,
					62.51,
					135.31,
					62.47,
					135.15,
					62.72,
					134.21,
					63.01,
					133.82,
					62.93,
					133.34,
					62.98,
					133.14,
					63.11,
					133.02,
					63.23,
					133.02,
					63.57,
					132.02,
					63.71,
					132,
					64,
					132.45,
					64.1,
					132.46,
					64.21,
					132.62,
					64.47,
					132.59,
					64.55,
					132.16,
					64.81,
					132.14,
					65.27,
					131.75,
					65.34,
					131.55,
					65.64,
					131.47,
					65.69,
					131.21,
					66.19,
					130,
					66.57,
					129.97,
					67.12,
					131.81,
					68.01,
					132.99,
					68.37,
					133.02,
					68.78,
					132.65,
					68.94,
					132.2,
					69.03,
					132.13,
					69.22,
					132.43,
					69.33,
					132.46,
					69.64,
					133.08,
					69.72,
					133.13,
					69.87,
					133.05,
					69.99,
					132.84,
					70.22,
					133.06,
					70.31,
					132.06,
					70.74,
					131.92,
					70.9,
					132.03,
					70.94,
					131.72,
					71.16,
					131.67,
					71.36,
					131.93,
					71.73,
					132.18,
					71.96,
					132.5,
					72.06,
					133.16,
					71.9,
					133.45,
					71.78,
					133.45,
					71.8,
					133,
					71.62,
					133.39,
					71.48,
					134.08,
					71.5,
					134.69,
					71.6,
					135.12,
					71.69,
					135.2,
					71.73,
					135.65,
					71.63,
					138.03,
					71.69,
					138.21,
					71.91,
					138.28,
					71.99,
					138.46,
					71.93,
					138.68,
					71.78,
					138.69,
					71.8,
					138.93,
					71.66,
					139.2,
					71.53,
					139.28,
					71.59,
					139.71,
					71.77,
					139.68,
					71.9,
					139.28,
					72.04,
					139.34,
					72.11,
					139.1,
					72.34,
					139.08,
					72.59,
					139.62,
					72.55,
					140.18,
					72.64,
					140.84,
					72.77,
					140.67,
					72.91,
					140.66,
					72.98,
					140.73,
					72.83,
					141.98,
					72.66,
					145.47,
					72.4,
					147.02,
					72.41,
					147.43,
					72.25,
					147.46,
					72.05,
					146.87,
					72.08,
					145.2,
					71.94,
					144.55,
					72.03,
					143.78,
					71.98,
					143.62,
					71.85,
					143.57,
					71.38,
					142.72,
					71.28,
					142.66,
					71.16,
					142.74,
					70.97,
					142.71,
					70.74,
					142.08,
					70.1,
					141.07,
					70.07,
					141.42,
					69.89,
					141.79,
					69.92,
					142.37,
					69.83,
					142.44,
					69.68,
					142.33,
					69.63,
					142.61,
					69.52,
					142.62,
					69.22,
					142.88,
					69.12,
					142.85,
					69.11,
					141.69,
					68.87,
					142.05,
					68.59,
					142.06,
					68.38,
					141.73,
					68.33,
					141.22,
					68.2,
					141.35,
					68.03,
					141.28,
					67.88,
					141.36,
					67.78,
					141.32,
					67.6,
					140.2,
					67.22,
					139.16,
					66.97,
					139.59,
					66.62,
					140.55,
					66.34,
					140.46,
					66.34,
					140,
					66.24,
					139.81,
					65.89,
					140.27,
					65.79,
					140.31,
					65.68,
					140.2,
					65.59,
					140.5,
					65.45,
					140.51,
					65.29,
					139.85,
					64.97,
					139.56,
					64.61,
					140.44,
					64.47,
					140.45,
					64.4,
					140.31,
					64.3,
					140.36,
					64.2,
					140.63,
					63.97,
					140.72,
					63.8,
					140.65,
					63.73,
					140.73,
					63.57,
					140.73,
					63.27,
					139.78,
					63.13,
					139.68,
					62.96,
					139.69,
					62.5,
					140.4,
					62.51,
					140.55,
					62.68,
					140.68,
					62.52,
					141.15,
					62.54,
					141.32,
					62.22,
					141.69,
					62.15,
					141.96,
					62.19,
					142.2,
					61.99,
					142.43,
					62.07,
					142.69,
					62.02,
					142.93,
					62.18,
					143.05,
					62.22,
					143.23,
					62.13,
					143.39,
					62.13,
					143.64,
					62.01,
					143.7,
					62.08,
					143.97,
					61.84,
					144.03,
					61.94,
					144.46,
					62.06,
					144.51,
					62.17,
					144.81,
					62.06,
					145.47,
					62.17,
					145.74,
					62.01,
					146.24,
					61.71,
					146.65,
					61.52,
					146.71,
					61.46,
					146.86,
					60.95,
					146.83,
					60.85,
					146.59,
					60.68,
					146.57,
					60.56,
					146.43,
					60.62,
					146.07,
					60.47,
					145.7,
					60.36,
					145.72,
					60.3,
					145.81,
					60.37,
					146.4,
					60.22,
					146.52,
					60.19,
					146.74,
					60.01,
					146.79,
					60.05,
					147.01,
					59.97,
					147.17,
					59.64,
					147.27,
					59.33,
					147.17,
					59.25,
					146.85,
					59.34,
					146.44,
					59.1,
					146.4,
					59.03,
					146.06,
					59.14,
					145.77,
					59.31,
					145.66,
					59.24,
					143.17,
					59.06,
					142.42,
					58.91,
					142.09,
					58.49,
					141.58,
					58.21,
					140.84,
					57.75,
					140.55,
					57.62,
					140.1,
					57.38,
					139.83,
					57.05,
					139.01,
					56.92,
					138.94,
					56.86,
					138.7,
					56.67,
					138.61,
					56.72,
					138.48,
					56.54,
					138.33,
					56.33,
					138.28,
					56.26,
					137.97,
					55.85,
					137.45,
					55.84,
					137.32,
					55.54,
					136.82,
					55.47,
					136.49,
					55.18,
					136.18,
					54.83,
					135.34,
					54.67,
					135.8,
					54.69,
					136.16,
					54.79,
					136.27,
					54.74,
					136.87,
					54.63,
					136.96,
					54.7,
					137.14,
					54.81,
					137.15,
					55.28,
					137.53,
					55.13,
					138.23,
					55.18,
					138.47,
					55.1,
					138.53,
					54.97,
					138.47,
					54.93,
					138.27,
					54.81,
					138.18,
					54.78,
					138.32,
					54.62,
					138.32,
					54.58,
					138.17,
					54.69,
					138.07,
					54.58,
					137.88,
					54.51,
					138.04,
					54.41,
					138.05,
					54.1,
					137.64,
					54.04,
					137.92,
					53.93,
					137.96,
					53.66,
					137.63,
					53.68,
					137.92,
					53.81,
					138.21,
					53.97,
					138.29,
					54.09,
					138.55,
					54.32,
					138.55,
					54.39,
					138.63,
					54.28,
					139.26,
					54.45,
					139.83,
					54.27,
					139.89,
					54.05,
					140.36,
					53.89,
					140.39,
					53.74,
					140.59,
					53.35,
					141.56,
					53.09,
					141.52,
					52.94,
					141.3,
					52.63,
					141.39,
					52.44,
					141.25,
					52.32,
					141.42,
					52.33,
					141.51,
					52.62,
					141.72,
					53.04,
					141.79,
					53.44,
					141.58,
					53.76,
					142.5,
					53.9,
					142.55,
					54.31,
					142.14,
					54.39,
					142.22,
					54.39,
					142.56,
					54.51,
					142.67,
					54.48,
					142.79,
					54.14,
					143.08,
					53.87,
					142.99,
					53.36,
					143.29,
					52.86,
					143.43,
					52.46,
					143.39,
					52.23,
					143.25,
					51.98,
					143.27,
					51.56,
					143.52,
					50.53,
					143.82,
					49.55,
					144.33,
					49.28,
					144.39,
					49.1,
					144.48,
					48.92,
					144.77,
					48.68,
					144.85,
					48.44,
					144.74,
					48.38,
					144.63,
					48.47,
					144.52,
					48.59,
					144.58,
					48.85,
					144.43,
					49.15,
					143.99,
					49.19,
					143.39,
					49.04,
					143.08,
					48.87,
					143.08,
					48.08,
					142.67,
					47.81,
					142.64,
					47.58,
					142.77,
					47.31,
					143.11,
					46.98,
					143.19,
					46.88,
					143.56,
					46.31,
					143.71,
					45.96,
					143.5,
					45.91,
					143.4,
					45.98,
					143.32,
					46.43,
					143.2,
					46.49,
					142.74,
					46.59,
					142.65,
					46.5,
					142.49,
					45.81,
					142.16,
					45.79,
					142.06,
					45.99,
					141.82,
					46.59,
					141.7,
					47.09,
					141.94,
					47.63,
					141.85,
					48,
					142.08,
					48.28,
					142.03,
					48.78,
					141.73,
					48.93,
					141.87,
					49.24,
					141.97,
					50.12,
					142.05,
					50.57,
					141.93,
					51.1,
					142.12,
					51.53,
					141.86,
					51.66,
					141.6,
					51.91,
					141.51,
					51.76,
					141.26,
					51.6,
					141.18,
					51.54,
					140.98,
					51.35,
					140.96,
					51.25,
					140.77,
					50.92,
					140.75,
					50.68,
					140.55,
					50.22,
					140.61,
					50.08,
					140.79,
					49.88,
					140.58,
					49.54,
					140.65,
					49.21,
					140.44,
					48.93,
					140.49,
					48.71,
					140.3,
					48.39,
					140.26,
					47.73,
					139.37,
					47.25,
					139.08,
					46.95,
					138.65,
					46.46,
					138.43,
					46.37,
					138.27,
					46.15,
					138.19,
					45.72,
					137.76,
					45.1,
					136.87,
					44.69,
					136.53,
					44.59,
					136.32,
					44.41,
					136.22,
					44.3,
					135.94,
					43.67,
					135.5,
					43.62,
					135.3,
					43.43,
					135.22,
					42.97,
					134.24,
					42.79,
					134.01,
					42.56,
					133.04,
					42.66,
					132.94,
					42.64,
					132.79,
					42.77,
					132.7,
					42.61,
					132.33,
					42.71,
					132.2,
					43.11,
					132.2,
					42.99,
					132.01,
					42.87,
					131.98,
					42.75,
					131.62,
					42.53,
					131.49,
					42.58,
					131.33,
					42.46,
					131.27,
					42.48,
					131.04,
					42.35,
					130.95
				]
			},
			{
				"points": [
					75.71,
					137.07,
					75.82,
					137.12,
					75.86,
					137.37,
					76.04,
					137.46,
					76.11,
					138.08,
					76.22,
					138.23,
					76.19,
					138.42,
					76.31,
					138.84,
					76.3,
					139.19,
					76.22,
					139.25,
					76.05,
					140.04,
					75.95,
					140.12,
					75.87,
					140.56,
					75.79,
					140.62,
					75.79,
					140.79,
					76.02,
					140.9,
					76.18,
					140.89,
					76.16,
					141.24,
					76.28,
					141.4,
					75.96,
					142.65,
					75.94,
					143.88,
					75.59,
					145.44,
					75.51,
					145.52,
					75.41,
					145.47,
					75.34,
					145.05,
					75.25,
					145.09,
					75.17,
					145.02,
					74.95,
					144.46,
					74.94,
					143.82,
					74.79,
					143.55,
					74.78,
					142.77,
					74.69,
					142.52,
					74.86,
					141.82,
					74.68,
					139.93,
					74.75,
					139.76,
					74.53,
					139.22,
					74.64,
					138.18,
					74.91,
					137.67,
					74.96,
					137.32,
					75.15,
					136.92,
					75.37,
					136.84,
					75.47,
					137.01,
					75.62,
					136.9,
					75.71,
					137.07
				]
			},
			{
				"points": [
					75.32,
					146.15,
					75.47,
					146.17,
					75.69,
					146.53,
					75.62,
					146.79,
					75.44,
					146.94,
					75.55,
					147.63,
					75.51,
					148.4,
					75.45,
					148.65,
					75.31,
					148.67,
					75.37,
					149.37,
					75.31,
					150.16,
					75.2,
					150.55,
					75.21,
					151.02,
					75.12,
					151.09,
					74.75,
					150.67,
					74.62,
					148.71,
					74.67,
					148.15,
					74.84,
					147.67,
					75.11,
					146.14,
					75.2,
					146.06,
					75.32,
					146.15
				]
			},
			{
				"points": [
					73.51,
					139.78,
					73.62,
					140.58,
					73.88,
					140.98,
					73.84,
					140.36,
					74.01,
					140.11,
					74.27,
					140.15,
					74.38,
					140.64,
					74.29,
					141.18,
					73.97,
					141.16,
					74.02,
					142.11,
					73.66,
					143.46,
					73.51,
					143.69,
					73.35,
					143.64,
					73.21,
					143.72,
					73.11,
					143.62,
					73.11,
					142.49,
					73.31,
					140.72,
					73.23,
					139.97,
					73.32,
					139.72,
					73.51,
					139.78
				]
			},
			{
				"points": [
					-17.69,
					168.05,
					-17.56,
					168.06,
					-17.3,
					168.32,
					-17.08,
					168.25,
					-16.93,
					168.34,
					-16.86,
					168.08,
					-16.58,
					168.04,
					-16.48,
					168.1,
					-16.34,
					167.87,
					-16.54,
					167.94,
					-16.63,
					167.9,
					-16.7,
					167.43,
					-16.14,
					167.05,
					-15.82,
					167.12,
					-15.73,
					167,
					-15.7,
					166.67,
					-15.41,
					166.51,
					-14.85,
					166.41,
					-14.52,
					166.56,
					-14.89,
					167.24,
					-15.54,
					167.39,
					-15.78,
					167.32,
					-16.27,
					167.8,
					-16.15,
					167.85,
					-16,
					168.1,
					-15.7,
					168,
					-15.46,
					168.05,
					-15.59,
					167.85,
					-15.51,
					167.61,
					-15.4,
					167.58,
					-15.17,
					168.01,
					-14.83,
					168.02,
					-14.87,
					168.19,
					-15.16,
					168.29,
					-15.46,
					168.26,
					-15.89,
					168.37,
					-16.09,
					168.28,
					-16.29,
					168.41,
					-16.62,
					168.42,
					-16.82,
					168.68,
					-16.99,
					168.75,
					-17.13,
					168.55,
					-17.3,
					168.53,
					-17.36,
					168.44,
					-17.38,
					168.56,
					-17.66,
					168.69,
					-17.88,
					168.61,
					-17.93,
					168.36,
					-17.78,
					168.07,
					-17.69,
					168.05
				]
			},
			{
				"points": [
					-20.38,
					164.01,
					-20.12,
					163.69,
					-19.94,
					163.73,
					-19.91,
					163.95,
					-20,
					164.06,
					-19.95,
					164.17,
					-20.16,
					164.33,
					-20.22,
					164.56,
					-20.59,
					164.98,
					-20.69,
					165.29,
					-21.18,
					165.69,
					-21.58,
					166.47,
					-21.79,
					166.63,
					-22.01,
					167.01,
					-22.37,
					167.1,
					-22.58,
					166.8,
					-22.37,
					166.56,
					-22.42,
					166.4,
					-22.18,
					165.99,
					-21.88,
					165.7,
					-21.43,
					164.86,
					-21.2,
					164.74,
					-20.83,
					164.27,
					-20.38,
					164.01
				]
			},
			{
				"points": [
					-8.62,
					160,
					-8.69,
					159.91,
					-8.65,
					159.57,
					-7.52,
					158.11,
					-7.59,
					157.86,
					-7.43,
					157.02,
					-6.81,
					156.32,
					-6.57,
					156.29,
					-6.49,
					156.54,
					-6.81,
					157.1,
					-7.29,
					157.7,
					-7.35,
					157.88,
					-7.25,
					158.21,
					-7.41,
					158.74,
					-8.27,
					159.93,
					-8.52,
					160.04,
					-8.62,
					160
				]
			},
			{
				"points": [
					-8.77,
					157.73,
					-8.9,
					157.65,
					-8.81,
					157.33,
					-8.62,
					157.09,
					-8.46,
					157.13,
					-8.23,
					156.9,
					-8.15,
					156.69,
					-8.39,
					156.58,
					-8.37,
					156.44,
					-7.56,
					156.4,
					-7.45,
					156.61,
					-7.65,
					156.86,
					-7.95,
					156.85,
					-7.75,
					156.98,
					-7.86,
					157.57,
					-8.41,
					158.22,
					-8.74,
					158.4,
					-8.85,
					158.37,
					-8.93,
					158.17,
					-8.77,
					157.73
				]
			},
			{
				"points": [
					-10.04,
					160.66,
					-9.89,
					159.77,
					-9.6,
					159.5,
					-9.26,
					159.49,
					-8.99,
					159.78,
					-9.05,
					159.92,
					-9.18,
					159.93,
					-9.24,
					160.14,
					-9.02,
					159.91,
					-8.88,
					159.86,
					-8.78,
					159.92,
					-8.74,
					160.07,
					-8.88,
					160.14,
					-9.04,
					160.49,
					-9.33,
					160.45,
					-9.47,
					160.89,
					-9.63,
					160.84,
					-9.74,
					160.96,
					-9.88,
					160.94,
					-10.04,
					160.66
				]
			},
			{
				"points": [
					-9.79,
					161.65,
					-9.89,
					161.59,
					-9.87,
					161.49,
					-9.14,
					160.71,
					-8.43,
					160.46,
					-8.22,
					160.49,
					-8.22,
					160.87,
					-9.51,
					161.62,
					-9.79,
					161.65
				]
			},
			{
				"points": [
					-10.94,
					162.54,
					-11.01,
					162.44,
					-10.9,
					162.31,
					-10.85,
					161.81,
					-10.37,
					161.19,
					-10.1,
					161.19,
					-10.05,
					161.28,
					-10.11,
					161.58,
					-10.04,
					161.68,
					-10.13,
					161.81,
					-10.01,
					161.89,
					-10.02,
					162,
					-10.31,
					162.08,
					-10.77,
					162.57,
					-10.94,
					162.54
				]
			},
			{
				"points": [
					-21.76,
					168.05,
					-21.68,
					167.77,
					-21.47,
					167.71,
					-21.36,
					167.47,
					-21.21,
					167.46,
					-21.29,
					167.3,
					-21.02,
					166.96,
					-20.89,
					166.89,
					-20.64,
					166.96,
					-20.56,
					167.2,
					-20.63,
					167.35,
					-21.23,
					167.69,
					-21.02,
					167.71,
					-21.06,
					167.91,
					-21.21,
					167.9,
					-21.24,
					167.78,
					-21.23,
					167.99,
					-21.4,
					168.23,
					-21.67,
					168.21,
					-21.76,
					168.05
				]
			}
		],
		"transitions": [
			[
				0,
				660,
				[
					"MIST",
					"SBT",
					"PONT",
					"NCT",
					"VLAT",
					"VUT",
					"SAKT",
					"KOST"
				]
			]
		],
		"name": "Antarctica/Macquarie"
	},
	{
		"hoverRegion": [
			{
				"points": [
					26.58,
					53.7,
					26.58,
					53.52,
					26.71,
					53.48,
					26.68,
					53.22,
					26.76,
					53.08,
					26.92,
					53.07,
					26.93,
					53.26,
					27.2,
					52.63,
					27.33,
					52.48,
					27.5,
					52.44,
					27.73,
					52.01,
					27.76,
					51.37,
					28.43,
					51,
					28.7,
					50.94,
					28.74,
					50.81,
					28.96,
					50.71,
					29.11,
					50.54,
					29.39,
					50.54,
					29.86,
					50.06,
					30.08,
					49.99,
					29.88,
					49.56,
					30.02,
					49.43,
					30.03,
					49.2,
					30.02,
					49.02,
					29.92,
					48.96,
					29.92,
					48.76,
					29.83,
					48.63,
					29.91,
					48.38,
					30.13,
					48.31,
					30.42,
					47.92,
					30.88,
					47.92,
					30.95,
					47.57,
					31.39,
					47.57,
					31.76,
					47.73,
					32.06,
					47.45,
					32.31,
					47.38,
					32.36,
					47.1,
					32.84,
					46.37,
					32.91,
					46.01,
					33.12,
					45.93,
					33.23,
					46.07,
					33.39,
					45.95,
					33.41,
					45.78,
					33.96,
					45.29,
					34.19,
					45.46,
					34.45,
					45.33,
					34.64,
					45.43,
					34.7,
					45.54,
					34.88,
					45.6,
					34.97,
					45.77,
					35.17,
					45.84,
					35.2,
					46.05,
					35.46,
					45.88,
					35.71,
					45.9,
					35.69,
					45.73,
					35.88,
					45.51,
					35.89,
					45.27,
					36.3,
					45.15,
					36.36,
					44.99,
					36.52,
					44.89,
					36.64,
					44.92,
					36.74,
					44.73,
					36.96,
					44.77,
					37.1,
					44.63,
					37.26,
					44.69,
					37.41,
					44.49,
					37.65,
					44.51,
					37.85,
					44.13,
					38.26,
					44.34,
					38.33,
					44.21,
					38.78,
					44.2,
					38.89,
					44.09,
					39.39,
					43.96,
					39.5,
					44.01,
					39.51,
					44.33,
					39.75,
					44.39,
					39.88,
					44.65,
					39.68,
					44.96,
					39.31,
					45.22,
					39.28,
					45.39,
					39.08,
					45.51,
					38.94,
					46.16,
					39.01,
					46.33,
					38.98,
					46.51,
					39.54,
					47.32,
					39.79,
					48.02,
					39.37,
					48.48,
					39.21,
					48.3,
					38.95,
					48.46,
					38.84,
					48.26,
					38.52,
					48.66,
					38.49,
					48.97,
					37.93,
					49.03,
					37.73,
					49.15,
					37.6,
					49.41,
					37.48,
					50.23,
					37.11,
					50.54,
					36.85,
					51.06,
					36.7,
					51.69,
					36.68,
					51.97,
					37.01,
					53.86,
					37.42,
					53.82,
					37.42,
					54.22,
					37.54,
					54.62,
					37.8,
					54.74,
					38.05,
					55.09,
					38.19,
					55.48,
					38.18,
					56.22,
					38.35,
					56.41,
					38.38,
					56.74,
					38.29,
					57.03,
					38.36,
					57.28,
					38.05,
					57.48,
					37.89,
					58.18,
					37.73,
					58.41,
					37.8,
					58.83,
					37.62,
					59.38,
					37.22,
					59.62,
					37.12,
					60.07,
					36.73,
					60.41,
					36.71,
					61.24,
					36.16,
					61.34,
					36,
					61.27,
					35.9,
					61.35,
					35.51,
					61.38,
					34.6,
					61.1,
					34.48,
					60.91,
					34.25,
					61.01,
					34.19,
					60.72,
					34.05,
					60.6,
					33.65,
					60.72,
					33.59,
					60.97,
					33.5,
					61.05,
					33.11,
					60.71,
					32.23,
					60.98,
					31.58,
					60.96,
					31.47,
					61.76,
					31.04,
					61.95,
					30.75,
					61.87,
					29.86,
					61.03,
					29.42,
					61.45,
					29.18,
					61.51,
					28.73,
					61.87,
					28.51,
					62.47,
					28.36,
					62.63,
					28.32,
					62.88,
					27.34,
					62.93,
					27.33,
					63.22,
					27.21,
					63.39,
					26.86,
					63.38,
					26.57,
					63.24,
					26.46,
					62.46,
					26.26,
					62.34,
					26.14,
					61.94,
					25.79,
					61.88,
					25.71,
					61.79,
					25.25,
					61.75,
					24.95,
					61.42,
					25.26,
					60.29,
					25.23,
					59.87,
					25.36,
					59.43,
					25.3,
					58.99,
					25.46,
					58.74,
					25.45,
					58.08,
					25.58,
					57.9,
					25.52,
					57.75,
					25.64,
					57.65,
					25.69,
					57.25,
					26.27,
					56.98,
					26.63,
					56.95,
					27.03,
					56.72,
					27.05,
					56.6,
					26.75,
					56.43,
					26.71,
					56.29,
					26.78,
					56.22,
					26.51,
					55.88,
					26.55,
					55.76,
					26.45,
					55.23,
					26.6,
					55.15,
					26.39,
					54.76,
					26.61,
					54.11,
					26.38,
					54,
					26.43,
					53.84,
					26.59,
					53.79,
					26.58,
					53.7
				]
			},
			{
				"points": [
					25.87,
					54.64,
					25.78,
					54.52,
					25.88,
					54.38,
					26,
					54.44,
					26.15,
					54.32,
					26.42,
					54.46,
					26.33,
					54.63,
					26.02,
					54.49,
					26,
					54.62,
					25.87,
					54.64
				]
			},
			{
				"points": [
					26.16,
					55.21,
					26.15,
					55.07,
					26.31,
					55.04,
					26.38,
					55.36,
					26.21,
					55.41,
					26.16,
					55.21
				]
			},
			{
				"points": [
					29.16,
					50.42,
					29.09,
					50.33,
					29.17,
					50.2,
					29.33,
					50.2,
					29.45,
					50.34,
					29.34,
					50.46,
					29.16,
					50.42
				]
			}
		],
		"transitions": [
			[
				1316647800,
				210,
				[
					"IRST"
				]
			],
			[
				1332289800,
				270,
				[
					"IRDT"
				]
			],
			[
				1348183800,
				210,
				[
					"IRST"
				]
			],
			[
				1363912200,
				270,
				[
					"IRDT"
				]
			],
			[
				1379806200,
				210,
				[
					"IRST"
				]
			],
			[
				1395448200,
				270,
				[
					"IRDT"
				]
			],
			[
				1411342200,
				210,
				[
					"IRST"
				]
			],
			[
				1426984200,
				270,
				[
					"IRDT"
				]
			],
			[
				1442878200,
				210,
				[
					"IRST"
				]
			],
			[
				1458520200,
				270,
				[
					"IRDT"
				]
			],
			[
				1474414200,
				210,
				[
					"IRST"
				]
			],
			[
				1490142600,
				270,
				[
					"IRDT"
				]
			],
			[
				1506036600,
				210,
				[
					"IRST"
				]
			],
			[
				1521678600,
				270,
				[
					"IRDT"
				]
			],
			[
				1537572600,
				210,
				[
					"IRST"
				]
			],
			[
				1553214600,
				270,
				[
					"IRDT"
				]
			],
			[
				1569108600,
				210,
				[
					"IRST"
				]
			],
			[
				1584750600,
				270,
				[
					"IRDT"
				]
			],
			[
				1600644600,
				210,
				[
					"IRST"
				]
			],
			[
				1616373000,
				270,
				[
					"IRDT"
				]
			],
			[
				1632267000,
				210,
				[
					"IRST"
				]
			],
			[
				1647909000,
				270,
				[
					"IRDT"
				]
			],
			[
				1663803000,
				210,
				[
					"IRST"
				]
			],
			[
				1679445000,
				270,
				[
					"IRDT"
				]
			],
			[
				1695339000,
				210,
				[
					"IRST"
				]
			],
			[
				1710981000,
				270,
				[
					"IRDT"
				]
			],
			[
				1726875000,
				210,
				[
					"IRST"
				]
			],
			[
				1742603400,
				270,
				[
					"IRDT"
				]
			],
			[
				1758497400,
				210,
				[
					"IRST"
				]
			],
			[
				1774139400,
				270,
				[
					"IRDT"
				]
			],
			[
				1790033400,
				210,
				[
					"IRST"
				]
			],
			[
				1805675400,
				270,
				[
					"IRDT"
				]
			],
			[
				1821569400,
				210,
				[
					"IRST"
				]
			],
			[
				1837211400,
				270,
				[
					"IRDT"
				]
			],
			[
				1853105400,
				210,
				[
					"IRST"
				]
			],
			[
				1868747400,
				270,
				[
					"IRDT"
				]
			],
			[
				1884641400,
				210,
				[
					"IRST"
				]
			],
			[
				1900369800,
				270,
				[
					"IRDT"
				]
			],
			[
				1916263800,
				210,
				[
					"IRST"
				]
			],
			[
				1931905800,
				270,
				[
					"IRDT"
				]
			],
			[
				1947799800,
				210,
				[
					"IRST"
				]
			],
			[
				1963441800,
				270,
				[
					"IRDT"
				]
			],
			[
				1979335800,
				210,
				[
					"IRST"
				]
			],
			[
				1994977800,
				270,
				[
					"IRDT"
				]
			],
			[
				2010871800,
				210,
				[
					"IRST"
				]
			],
			[
				2026600200,
				270,
				[
					"IRDT"
				]
			],
			[
				2042494200,
				210,
				[
					"IRST"
				]
			],
			[
				2058136200,
				270,
				[
					"IRDT"
				]
			],
			[
				2074030200,
				210,
				[
					"IRST"
				]
			],
			[
				2089672200,
				270,
				[
					"IRDT"
				]
			],
			[
				2105566200,
				210,
				[
					"IRST"
				]
			],
			[
				2121208200,
				270,
				[
					"IRDT"
				]
			],
			[
				2137102200,
				210,
				[
					"IRST"
				]
			]
		],
		"name": "Asia/Tehran"
	},
	{
		"hoverRegion": [
			{
				"points": [
					10.88,
					-15.57,
					10.85,
					-15.68,
					10.97,
					-15.81,
					10.91,
					-16.19,
					11.06,
					-16.35,
					11.17,
					-16.34,
					11.21,
					-16.57,
					11.36,
					-16.58,
					11.4,
					-16.45,
					11.5,
					-16.53,
					11.61,
					-16.5,
					11.7,
					-16.27,
					11.61,
					-16.09,
					11.65,
					-16.06,
					11.67,
					-16.16,
					11.77,
					-16.21,
					11.76,
					-16.4,
					12.07,
					-16.49,
					12.23,
					-16.78,
					12.42,
					-16.89,
					12.99,
					-16.83,
					13.37,
					-16.91,
					13.57,
					-16.74,
					13.71,
					-16.77,
					13.81,
					-16.88,
					14.08,
					-16.91,
					14.55,
					-17.24,
					14.6,
					-17.34,
					14.55,
					-17.53,
					14.73,
					-17.64,
					14.84,
					-17.58,
					14.99,
					-17.21,
					15.79,
					-16.65,
					16.66,
					-16.53,
					17.48,
					-16.2,
					17.99,
					-16.13,
					18.87,
					-16.28,
					19.38,
					-16.64,
					19.53,
					-16.52,
					19.69,
					-16.61,
					20.02,
					-16.33,
					20.2,
					-16.31,
					20.46,
					-16.47,
					20.59,
					-16.74,
					20.94,
					-16.9,
					20.66,
					-17.04,
					20.86,
					-17.21,
					21.87,
					-17.05,
					22.28,
					-16.85,
					22.4,
					-16.57,
					23.86,
					-16,
					24.75,
					-14.99,
					25.31,
					-14.93,
					26,
					-14.6,
					26.19,
					-14.59,
					26.51,
					-14.25,
					26.8,
					-13.66,
					27.71,
					-13.26,
					28.02,
					-12.98,
					28.19,
					-12.08,
					28.39,
					-11.58,
					28.81,
					-11.15,
					29.1,
					-10.59,
					29.37,
					-10.3,
					30.21,
					-9.74,
					30.36,
					-9.72,
					30.63,
					-10,
					30.83,
					-9.92,
					31.42,
					-9.95,
					32.21,
					-9.37,
					32.59,
					-9.37,
					33.36,
					-8.55,
					33.74,
					-7.57,
					34.12,
					-6.9,
					34.77,
					-6.47,
					35.87,
					-5.99,
					36.02,
					-5.48,
					35.97,
					-5.29,
					35.63,
					-5.14,
					35.31,
					-4.65,
					35.26,
					-4.36,
					35.4,
					-3.69,
					35.31,
					-3.34,
					35.55,
					-2.92,
					35.34,
					-2.86,
					35.24,
					-2.7,
					35.26,
					-2.37,
					35.03,
					-1.93,
					34.76,
					-1.63,
					34.64,
					-1.69,
					34.51,
					-1.58,
					34.37,
					-1.65,
					34.1,
					-1.53,
					33.75,
					-1.61,
					33.62,
					-1.48,
					33.31,
					-1.55,
					33.1,
					-1.37,
					32.96,
					-1.4,
					32.55,
					-0.88,
					32.29,
					-1.11,
					32.16,
					-1.08,
					32.01,
					-1.17,
					32.06,
					-2.28,
					31.99,
					-2.81,
					31.77,
					-2.72,
					31.68,
					-2.77,
					31.52,
					-3.54,
					31.34,
					-3.54,
					31.22,
					-3.69,
					31.05,
					-3.45,
					30.82,
					-3.51,
					30.54,
					-4.74,
					29.91,
					-5.06,
					29.59,
					-6.07,
					29.59,
					-6.4,
					29.48,
					-6.51,
					29.52,
					-7.08,
					29.28,
					-7.4,
					29.27,
					-7.6,
					28.65,
					-8.56,
					27.35,
					-8.56,
					25.08,
					-4.76,
					21.21,
					1.22,
					20.85,
					1.27,
					20.67,
					1.68,
					20.39,
					1.85,
					20.33,
					2.08,
					20.38,
					2.26,
					20.15,
					2.47,
					19.91,
					3.29,
					19.4,
					3.38,
					19.17,
					3.24,
					19.09,
					3.33,
					19.23,
					4.23,
					19.18,
					4.34,
					16.98,
					4.35,
					16.84,
					4.18,
					16.28,
					4.18,
					15.65,
					3.97,
					15.42,
					3.64,
					15.24,
					3.56,
					15.25,
					2.63,
					15.15,
					1.36,
					14.87,
					0.98,
					14.87,
					0.32,
					14.56,
					0.28,
					14.38,
					0.46,
					14.07,
					0.5,
					13.8,
					0.72,
					13.4,
					1.38,
					13.27,
					1.33,
					13.22,
					1.1,
					13.11,
					1.1,
					12.73,
					1.6,
					12.72,
					1.82,
					12.84,
					1.94,
					12.81,
					2.16,
					12.43,
					2.38,
					12.3,
					2.23,
					11.93,
					2.51,
					11.62,
					2.4,
					11.33,
					2.07,
					11.33,
					1.46,
					11.19,
					1.38,
					11.16,
					1.22,
					10.94,
					1.17,
					10.94,
					1,
					10.43,
					0.89,
					10.06,
					1.44,
					9.56,
					1.45,
					9,
					1.73,
					7.48,
					1.78,
					6.98,
					1.75,
					6.89,
					1.67,
					6.23,
					1.89,
					6.01,
					1.25,
					5.68,
					0.97,
					5.65,
					0.26,
					5.11,
					-0.76,
					4.93,
					-1.54,
					4.77,
					-1.7,
					4.62,
					-2.08,
					4.82,
					-2.4,
					5.04,
					-3.2,
					5.13,
					-3.98,
					4.93,
					-5.75,
					4.56,
					-6.84,
					4.44,
					-6.98,
					4.25,
					-7.49,
					4.26,
					-7.76,
					5.05,
					-9.34,
					5.95,
					-10.29,
					6.16,
					-10.79,
					6.41,
					-10.99,
					6.6,
					-11.4,
					6.84,
					-11.56,
					7.05,
					-11.91,
					7.5,
					-13.08,
					7.61,
					-13.16,
					7.75,
					-13.13,
					7.69,
					-12.87,
					7.86,
					-13.04,
					8.09,
					-13.05,
					7.98,
					-13.23,
					8.05,
					-13.33,
					8.19,
					-13.29,
					8.41,
					-13.4,
					8.85,
					-13.34,
					9.35,
					-13.53,
					9.43,
					-13.62,
					9.33,
					-13.74,
					9.39,
					-13.92,
					9.52,
					-13.93,
					9.64,
					-13.77,
					10.11,
					-14.39,
					10.13,
					-14.53,
					10.69,
					-14.87,
					10.78,
					-15.29,
					10.91,
					-15.3,
					11.24,
					-15.56,
					11.15,
					-15.59,
					11.04,
					-15.5,
					10.88,
					-15.57
				]
			},
			{
				"points": [
					63.3,
					-20.23,
					63.33,
					-20.36,
					63.49,
					-20.4,
					63.76,
					-21.22,
					63.69,
					-22.75,
					63.99,
					-22.87,
					64.17,
					-22.75,
					64.08,
					-22.45,
					64.14,
					-22.14,
					64.2,
					-22.12,
					64.33,
					-22.19,
					64.32,
					-22.34,
					64.51,
					-22.47,
					64.51,
					-22.59,
					64.69,
					-22.6,
					64.71,
					-23.33,
					64.61,
					-23.83,
					64.86,
					-24.16,
					64.97,
					-24.12,
					65.07,
					-23.39,
					65.18,
					-23.28,
					65.1,
					-23.08,
					65.19,
					-22.94,
					65.28,
					-22.97,
					65.39,
					-23.16,
					65.29,
					-23.85,
					65.4,
					-24.57,
					65.55,
					-24.63,
					65.73,
					-24.37,
					65.72,
					-24.23,
					65.89,
					-24.15,
					65.88,
					-23.98,
					66.12,
					-23.87,
					66.3,
					-23.49,
					66.25,
					-23.25,
					66.36,
					-23.3,
					66.49,
					-23.22,
					66.57,
					-22.96,
					66.55,
					-22.36,
					66.37,
					-22.09,
					66.28,
					-21.69,
					66.18,
					-21.63,
					66.09,
					-21.27,
					65.9,
					-21.16,
					65.68,
					-21.24,
					65.53,
					-21.15,
					65.79,
					-20.7,
					65.72,
					-20.4,
					65.99,
					-20.54,
					66.19,
					-20.43,
					66.22,
					-20.06,
					66,
					-19.78,
					66.13,
					-19.59,
					66.29,
					-18.82,
					66.13,
					-18.41,
					66.26,
					-18.34,
					66.28,
					-17.87,
					66.09,
					-17.59,
					66.09,
					-17.45,
					66.38,
					-17.14,
					66.23,
					-16.91,
					66.28,
					-16.56,
					66.53,
					-16.66,
					66.64,
					-16.19,
					66.5,
					-15.67,
					66.31,
					-15.59,
					66.27,
					-15.44,
					66.47,
					-14.96,
					66.47,
					-14.49,
					66.3,
					-14.47,
					66.2,
					-14.83,
					66.14,
					-14.83,
					66.04,
					-14.52,
					65.86,
					-14.58,
					65.89,
					-14.3,
					65.77,
					-14.22,
					65.61,
					-13.57,
					65.52,
					-13.5,
					65.37,
					-13.58,
					65.18,
					-13.41,
					64.89,
					-13.44,
					64.6,
					-14.04,
					64.5,
					-14.08,
					64.52,
					-14.25,
					64.31,
					-14.48,
					64.24,
					-14.81,
					64.13,
					-14.92,
					64.04,
					-15.86,
					63.68,
					-16.73,
					63.63,
					-17.57,
					63.39,
					-18.03,
					63.28,
					-18.76,
					63.41,
					-20.11,
					63.3,
					-20.23
				]
			},
			{
				"points": [
					75.93,
					-18.35,
					75.84,
					-18.4,
					75.85,
					-18.51,
					76.38,
					-19.23,
					76.69,
					-19.25,
					76.72,
					-19.44,
					76.54,
					-19.7,
					76.58,
					-19.94,
					76.74,
					-20.04,
					76.7,
					-20.16,
					76.34,
					-20.06,
					76.34,
					-19.83,
					76.18,
					-19.67,
					75.97,
					-19.68,
					75.77,
					-19.38,
					75.64,
					-19.45,
					75.87,
					-23,
					79.73,
					-22.74,
					79.6,
					-19.4,
					79.45,
					-19.32,
					79.41,
					-18.91,
					79.28,
					-18.7,
					79.04,
					-18.84,
					78.62,
					-18.93,
					78.56,
					-19.3,
					78.66,
					-19.68,
					78.79,
					-19.7,
					78.72,
					-19.85,
					78.74,
					-20.42,
					78.24,
					-21.12,
					78.13,
					-21.1,
					78.06,
					-21.2,
					78.09,
					-21.04,
					78.23,
					-21.03,
					78.23,
					-20.79,
					78.37,
					-20.59,
					78.33,
					-20.34,
					78.07,
					-20.01,
					78.05,
					-19.63,
					78.16,
					-19.7,
					78.09,
					-19.85,
					78.18,
					-19.96,
					78.5,
					-19.73,
					78.5,
					-19.45,
					78.4,
					-19.39,
					78.58,
					-18.96,
					78.53,
					-18.74,
					78.65,
					-18.7,
					78.71,
					-18.32,
					78.89,
					-18.23,
					78.92,
					-18.01,
					79.09,
					-18.01,
					79.27,
					-17.65,
					79.18,
					-17.29,
					79.11,
					-17.25,
					78.93,
					-17.34,
					78.83,
					-17.7,
					78.63,
					-17.81,
					78.54,
					-18.17,
					78.35,
					-18.38,
					78.47,
					-18.7,
					78.28,
					-18.71,
					78.29,
					-18.46,
					78.19,
					-18.41,
					77.88,
					-18.51,
					77.82,
					-18.78,
					77.5,
					-18.87,
					77.42,
					-19.27,
					77.46,
					-19.5,
					77.3,
					-19.32,
					77.29,
					-19.17,
					77.45,
					-19.08,
					77.41,
					-18.46,
					77.21,
					-18.15,
					76.82,
					-18.13,
					76.6,
					-18.5,
					75.93,
					-18.35
				]
			},
			{
				"points": [
					77.51,
					-18.06,
					77.6,
					-18.32,
					77.81,
					-18.16,
					77.98,
					-18.18,
					77.98,
					-17.73,
					77.87,
					-17.5,
					77.76,
					-17.48,
					77.57,
					-17.68,
					77.51,
					-18.06
				]
			}
		],
		"transitions": [
			[
				0,
				0,
				[
					"GMT",
					"WET"
				]
			]
		],
		"name": "Africa/Casablanca"
	},
	{
		"hoverRegion": [
			{
				"points": [
					50.08,
					155.03,
					50.16,
					154.85,
					50.28,
					154.89,
					50.26,
					155.09,
					50.36,
					155.14,
					50.86,
					155.98,
					50.97,
					156.5,
					50.91,
					156.58,
					51.06,
					156.64,
					51.24,
					156.43,
					52.28,
					156.29,
					52.87,
					156.02,
					53.79,
					155.83,
					54.8,
					155.51,
					55.37,
					155.43,
					56.03,
					155.56,
					56.76,
					155.9,
					57.04,
					156.39,
					57.26,
					156.47,
					57.22,
					156.67,
					57.45,
					156.88,
					57.7,
					156.7,
					57.83,
					156.74,
					57.97,
					157,
					57.9,
					157.4,
					58.11,
					157.64,
					58.08,
					157.92,
					58.16,
					158.27,
					58.52,
					159.03,
					58.91,
					159.61,
					59.2,
					159.77,
					59.47,
					160.32,
					59.65,
					160.44,
					59.72,
					160.85,
					60.13,
					161.43,
					60.28,
					161.83,
					60.47,
					161.86,
					60.64,
					162.12,
					60.6,
					162.26,
					60.7,
					162.66,
					60.92,
					162.76,
					60.86,
					162.89,
					60.89,
					163.17,
					60.97,
					163.27,
					60.92,
					163.46,
					61.08,
					163.42,
					61.3,
					163.86,
					61.48,
					163.64,
					61.73,
					163.81,
					61.77,
					163.96,
					62.33,
					164.08,
					62.54,
					164.53,
					62.44,
					163.54,
					62.28,
					163.59,
					62.15,
					163.22,
					62.02,
					163.3,
					61.86,
					163.18,
					61.79,
					163.41,
					61.61,
					163.43,
					61.51,
					163.18,
					61.36,
					163.08,
					61.34,
					162.97,
					61.49,
					162.82,
					61.44,
					162.57,
					61.49,
					162.43,
					60.8,
					161,
					60.61,
					160.84,
					60.61,
					160.42,
					60.46,
					160.18,
					60.54,
					160.06,
					60.87,
					160.09,
					60.78,
					159.88,
					60.86,
					159.71,
					60.97,
					159.7,
					61.13,
					159.86,
					61.22,
					159.67,
					61.62,
					160.18,
					61.73,
					160.17,
					61.54,
					159.6,
					61.8,
					159.14,
					61.7,
					158.82,
					61.7,
					158.28,
					61.61,
					158.03,
					61.67,
					157.53,
					61.56,
					157.38,
					61.42,
					156.79,
					61.11,
					156.72,
					60.86,
					156.04,
					60.61,
					155.95,
					60.2,
					154.88,
					59.76,
					154.48,
					59.74,
					154.37,
					59.63,
					154.45,
					59.6,
					154.98,
					59.43,
					155.27,
					59.23,
					155.37,
					59.07,
					155.22,
					59.08,
					154.89,
					59.01,
					154.81,
					59.1,
					154.46,
					59,
					154.38,
					58.93,
					154.02,
					59.06,
					153.79,
					59.1,
					153.47,
					58.99,
					153.38,
					58.95,
					153.06,
					58.79,
					152.93,
					58.93,
					152.39,
					58.78,
					152.09,
					58.72,
					151.36,
					59.1,
					151.01,
					59.2,
					151.1,
					59.25,
					151.64,
					59.48,
					151.38,
					59.46,
					151.03,
					59.34,
					150.98,
					59.32,
					150.74,
					59.4,
					150.42,
					59.53,
					150.28,
					59.64,
					149.58,
					59.56,
					149.26,
					59.42,
					149.32,
					59.34,
					149.19,
					59.17,
					149.25,
					58.99,
					149.01,
					59.12,
					148.84,
					59.15,
					148.38,
					59.28,
					148.31,
					59.29,
					148.2,
					59.26,
					147.91,
					59.15,
					147.82,
					59.13,
					147.49,
					59.26,
					146.85,
					59.37,
					146.77,
					59.5,
					147.01,
					59.82,
					146.99,
					59.81,
					146.7,
					60.15,
					146.31,
					60.08,
					145.76,
					60.23,
					145.51,
					60.38,
					145.41,
					60.53,
					145.41,
					60.66,
					145.57,
					60.84,
					146.04,
					60.79,
					146.33,
					61,
					146.4,
					61.16,
					146.64,
					61.57,
					146.48,
					61.8,
					146.16,
					61.94,
					145.74,
					61.84,
					145.46,
					61.95,
					144.85,
					61.62,
					144.25,
					61.61,
					143.98,
					61.82,
					143.8,
					61.76,
					143.59,
					61.91,
					143.45,
					61.98,
					143.22,
					61.8,
					143.02,
					61.85,
					142.68,
					61.75,
					142.4,
					61.97,
					142.14,
					61.92,
					141.82,
					62.09,
					141.47,
					62.32,
					141.25,
					62.29,
					141.07,
					62.45,
					140.76,
					62.3,
					140.64,
					62.27,
					140.3,
					62.42,
					140.2,
					62.59,
					139.82,
					62.85,
					139.5,
					63.19,
					139.46,
					63.43,
					139.63,
					63.67,
					140.42,
					63.75,
					140.39,
					63.97,
					140.49,
					64.33,
					139.94,
					64.44,
					139.95,
					64.52,
					140.09,
					64.72,
					139.52,
					64.97,
					139.31,
					65.34,
					139.54,
					65.55,
					139.89,
					65.69,
					139.85,
					65.8,
					140,
					65.99,
					139.81,
					66.06,
					139.61,
					66.33,
					139.53,
					66.55,
					139.92,
					66.56,
					140.2,
					66.77,
					139.49,
					67.15,
					138.84,
					67.29,
					138.8,
					67.81,
					140.13,
					67.96,
					141.05,
					68.14,
					141.11,
					68.31,
					140.93,
					68.42,
					140.94,
					68.54,
					141.15,
					68.6,
					141.68,
					68.69,
					141.84,
					69.1,
					141.44,
					69.22,
					141.44,
					69.35,
					141.7,
					69.32,
					142.49,
					69.45,
					142.35,
					69.5,
					142.02,
					69.6,
					141.97,
					69.69,
					142.03,
					69.68,
					141.72,
					69.86,
					141.34,
					69.9,
					140.87,
					70.13,
					140.81,
					70.93,
					141.97,
					71.11,
					142.48,
					71.29,
					142.42,
					71.56,
					142.59,
					71.98,
					143.35,
					72.18,
					143.5,
					72.25,
					143.73,
					72.16,
					144.52,
					72.3,
					145.19,
					72.27,
					146.86,
					72.44,
					147.62,
					72.33,
					149.21,
					72.17,
					149.86,
					71.9,
					150.2,
					71.8,
					150.2,
					71.74,
					150.08,
					71.56,
					150.89,
					71.64,
					151.28,
					71.46,
					151.41,
					71.34,
					151.83,
					71.21,
					151.94,
					70.97,
					152.37,
					70.96,
					153.82,
					71.19,
					156.05,
					71.1,
					158.15,
					70.94,
					159.15,
					70.66,
					159.9,
					70.32,
					160.2,
					70.19,
					160.2,
					69.88,
					159.94,
					69.76,
					161.09,
					69.66,
					161.23,
					69.77,
					163.65,
					69.85,
					164.02,
					69.68,
					164.61,
					69.58,
					166.94,
					69.83,
					167.67,
					70.05,
					168.04,
					70.09,
					168.69,
					70.02,
					169.31,
					69.89,
					169.52,
					69.77,
					169.56,
					69.44,
					169.23,
					69.51,
					168.38,
					69.32,
					168.35,
					69.19,
					169.36,
					69.08,
					169.53,
					68.89,
					169.58,
					68.86,
					169.7,
					68.91,
					170.33,
					69.08,
					170.83,
					69.23,
					170.8,
					69.45,
					170.61,
					69.49,
					170.15,
					69.74,
					169.94,
					69.84,
					170.03,
					69.83,
					170.46,
					69.99,
					170.47,
					70.12,
					170.35,
					70.23,
					170.57,
					70.07,
					172.77,
					69.94,
					173.15,
					70.04,
					173.51,
					69.91,
					173.8,
					69.98,
					174.14,
					69.98,
					176.11,
					69.74,
					176.91,
					69.49,
					178.83,
					69.05,
					180.07,
					64.98,
					180.1,
					64.69,
					179.56,
					64.45,
					178.58,
					64.55,
					178.41,
					64.61,
					177.57,
					64.55,
					177.54,
					64.31,
					178.04,
					64.37,
					178.16,
					64.52,
					178.16,
					64.53,
					178.27,
					64.07,
					178.76,
					63.49,
					178.98,
					63.13,
					179.55,
					62.95,
					179.51,
					62.91,
					179.64,
					62.67,
					179.73,
					62.4,
					179.47,
					62.35,
					179.27,
					62.25,
					179.26,
					62.16,
					179.11,
					62.41,
					178.06,
					62.42,
					177.13,
					61.53,
					173.87,
					61.58,
					173.61,
					61.44,
					173.54,
					61.32,
					173.3,
					61.31,
					173.04,
					61.18,
					173.01,
					61.06,
					172.59,
					60.96,
					172.55,
					60.9,
					172.32,
					60.73,
					172.09,
					60.72,
					171.75,
					60.51,
					171.42,
					60.33,
					170.79,
					60.22,
					170.76,
					60.16,
					170.6,
					59.89,
					170.5,
					59.82,
					170.35,
					59.98,
					169.9,
					60.3,
					169.67,
					60.4,
					169.39,
					60.48,
					168.37,
					60.24,
					167.15,
					59.71,
					166.29,
					59.77,
					165.98,
					60.31,
					166.14,
					60.04,
					165.31,
					59.89,
					165.28,
					59.67,
					164.86,
					59.9,
					164.65,
					59.98,
					164.46,
					59.74,
					164.22,
					59.81,
					164,
					59.89,
					163.96,
					59.76,
					163.75,
					59.75,
					163.52,
					59.56,
					163.52,
					59.48,
					163.39,
					59.23,
					163.45,
					58.97,
					163.32,
					58.96,
					163.17,
					58.58,
					162.51,
					58.1,
					162.12,
					57.98,
					162.14,
					57.91,
					162.28,
					58.05,
					162.73,
					57.92,
					163.23,
					57.76,
					163.42,
					57.65,
					163.4,
					57.39,
					163.17,
					57.25,
					162.89,
					57.02,
					162.97,
					56.83,
					162.91,
					56.83,
					163.31,
					56.18,
					163.47,
					55.9,
					163.07,
					55.95,
					162.8,
					56.11,
					162.59,
					55.99,
					162.17,
					55.53,
					161.86,
					55.23,
					161.89,
					54.89,
					162.25,
					54.68,
					162.2,
					54.39,
					161.72,
					54.36,
					161.28,
					54.47,
					161.13,
					54.45,
					160.89,
					54.08,
					160.12,
					53.77,
					159.96,
					53.26,
					160.13,
					53.01,
					160.11,
					52.99,
					160,
					53.13,
					159.61,
					52.97,
					159.07,
					52.77,
					158.69,
					52.47,
					158.6,
					52.4,
					158.67,
					52.23,
					158.64,
					52.12,
					158.47,
					51.88,
					158.35,
					51.54,
					157.97,
					51.4,
					157.62,
					51.14,
					157.36,
					50.77,
					156.72,
					50.77,
					156.61,
					50.54,
					156.38,
					50.53,
					156.27,
					50.16,
					155.96,
					49.9,
					155.45,
					49.99,
					155.13,
					50.13,
					155.09,
					50.08,
					155.03
				]
			},
			{
				"points": [
					64.89,
					-172.18,
					64.78,
					-171.95,
					64.67,
					-171.99,
					64.61,
					-172.32,
					64.45,
					-172.13,
					64.31,
					-172.17,
					64.29,
					-172.72,
					64.2,
					-172.78,
					64.14,
					-173.15,
					64.26,
					-173.47,
					64.22,
					-173.65,
					64.31,
					-174,
					64.54,
					-174.31,
					64.68,
					-174.93,
					64.68,
					-175.45,
					64.78,
					-175.52,
					64.91,
					-175.94,
					65.03,
					-175.97,
					65.13,
					-175.88,
					65.34,
					-176.12,
					65.48,
					-176.91,
					65.32,
					-177.57,
					65.36,
					-178.76,
					65.52,
					-178.8,
					65.65,
					-178.56,
					65.82,
					-178.93,
					66.09,
					-178.99,
					66.13,
					-179.1,
					66.01,
					-179.25,
					65.99,
					-179.63,
					65.91,
					-179.62,
					65.7,
					-179.19,
					65.46,
					-179.16,
					65.33,
					-179.38,
					65.16,
					-179.43,
					65.04,
					-179.6,
					64.92,
					-180.04,
					65.01,
					-180.1,
					69.02,
					-180.1,
					69.08,
					-179.99,
					69.02,
					-179.39,
					68.41,
					-177.59,
					67.77,
					-175.25,
					67.63,
					-175.15,
					67.46,
					-174.75,
					67.57,
					-174.7,
					67.55,
					-174.55,
					67.47,
					-174.48,
					67.33,
					-174.63,
					67.16,
					-174.57,
					67.22,
					-173.63,
					67.06,
					-171.71,
					66.84,
					-171.26,
					66.73,
					-171.21,
					66.17,
					-169.57,
					65.92,
					-169.65,
					65.93,
					-170,
					65.79,
					-170.4,
					65.62,
					-170.4,
					65.49,
					-170.55,
					65.54,
					-170.88,
					65.39,
					-170.97,
					65.36,
					-172.02,
					65.3,
					-172.07,
					65.08,
					-171.97,
					64.89,
					-172.18
				]
			},
			{
				"points": [
					71.63,
					-179.96,
					71.72,
					-179.28,
					71.64,
					-178.26,
					71.31,
					-177.41,
					71.21,
					-177.34,
					71.02,
					-177.52,
					70.91,
					-177.89,
					70.75,
					-179.59,
					70.93,
					-180.1,
					71.56,
					-180.1,
					71.63,
					-179.96
				]
			},
			{
				"points": [
					44.32,
					147,
					44.42,
					146.75,
					44.7,
					146.86,
					45.51,
					147.85,
					45.64,
					148.65,
					45.56,
					148.99,
					45.22,
					148.89,
					44.32,
					147
				]
			},
			{
				"points": [
					70.67,
					178.79,
					71.02,
					178.51,
					71.16,
					178.54,
					71.32,
					178.84,
					71.62,
					179.98,
					71.59,
					180.08,
					70.87,
					180.05,
					70.67,
					178.79
				]
			},
			{
				"points": [
					58.34,
					163.53,
					58.38,
					163.41,
					58.58,
					163.32,
					59.09,
					163.66,
					59.34,
					164.61,
					59.09,
					164.84,
					58.98,
					164.84,
					58.76,
					164.69,
					58.34,
					163.53
				]
			},
			{
				"points": [
					43.56,
					145.6,
					43.58,
					145.46,
					43.87,
					145.29,
					44.59,
					146.05,
					44.5,
					146.67,
					44.26,
					146.55,
					43.56,
					145.6
				]
			},
			{
				"points": [
					54.67,
					166.77,
					54.55,
					166.66,
					54.85,
					166.11,
					55.2,
					165.62,
					55.33,
					165.59,
					55.45,
					165.87,
					55.4,
					166.32,
					54.92,
					166.71,
					54.67,
					166.77
				]
			},
			{
				"points": [
					45.49,
					149.42,
					45.62,
					149.32,
					45.93,
					149.62,
					46.28,
					150.2,
					46.28,
					150.67,
					46.15,
					150.64,
					45.52,
					149.74,
					45.49,
					149.42
				]
			}
		],
		"transitions": [
			[
				0,
				720,
				[
					"MHT",
					"ANAT",
					"WAKT",
					"TVT",
					"MAGT",
					"PETT",
					"GILT",
					"WFT",
					"NRT"
				]
			]
		],
		"name": "Pacific/Wallis"
	},
	{
		"hoverRegion": [
			{
				"points": [
					69.7,
					-95.95,
					69.77,
					-96.24,
					69.9,
					-96.27,
					70.04,
					-96.55,
					70.34,
					-96.64,
					70.58,
					-96.34,
					70.72,
					-96.66,
					70.8,
					-96.68,
					71.03,
					-96.55,
					71.16,
					-96.63,
					71.23,
					-96.84,
					71.41,
					-96.84,
					71.4,
					-96.29,
					71.54,
					-96.02,
					71.66,
					-95.96,
					71.79,
					-95.62,
					71.92,
					-95.59,
					71.98,
					-95.31,
					72.16,
					-95.28,
					72.2,
					-95.31,
					72.05,
					-95.41,
					72.08,
					-95.51,
					72.2,
					-95.54,
					72.27,
					-95.45,
					72.23,
					-95.32,
					72.45,
					-95.33,
					72.54,
					-95.26,
					72.33,
					-93.83,
					72.22,
					-93.79,
					72.05,
					-93.92,
					71.9,
					-93.91,
					71.86,
					-93.62,
					71.69,
					-93.56,
					71.44,
					-92.87,
					71.19,
					-92.72,
					70.96,
					-92.76,
					70.88,
					-92.71,
					70.64,
					-91.94,
					70.5,
					-91.81,
					70.44,
					-91.61,
					70.34,
					-91.57,
					70.32,
					-91.37,
					70.09,
					-91.38,
					70.01,
					-91.64,
					69.99,
					-91.36,
					69.89,
					-91.21,
					69.79,
					-91.2,
					69.8,
					-91.02,
					69.71,
					-90.92,
					69.72,
					-90.42,
					69.58,
					-90.06,
					69.49,
					-89.99,
					69.28,
					-90,
					69.2,
					-89.81,
					69.09,
					-89.79,
					69.35,
					-89.33,
					69.34,
					-88.92,
					66.96,
					-88.89,
					66.9,
					-88.98,
					66.89,
					-101.89,
					59.92,
					-101.92,
					59.89,
					-109.89,
					53.7,
					-109.89,
					53.68,
					-109.59,
					53.51,
					-109.48,
					53.38,
					-109.04,
					53.02,
					-108.7,
					52.7,
					-108.83,
					52.79,
					-109.17,
					52.66,
					-109.22,
					52.57,
					-109.38,
					52.55,
					-109.89,
					49.1,
					-109.89,
					49.09,
					-104.01,
					49,
					-103.94,
					48.03,
					-103.93,
					47.91,
					-103.71,
					47.68,
					-103.64,
					47.69,
					-103.12,
					47.78,
					-103.01,
					47.63,
					-102.51,
					47.7,
					-102.18,
					47.33,
					-102.03,
					46.81,
					-101.99,
					46.72,
					-101.25,
					46.47,
					-101.19,
					46.46,
					-100.99,
					46.36,
					-100.94,
					46.21,
					-100.96,
					46.05,
					-101.18,
					46.04,
					-100.46,
					45.93,
					-100.27,
					45.73,
					-100.19,
					45.54,
					-100.31,
					45.43,
					-100.17,
					44.98,
					-100.17,
					44.65,
					-100.52,
					44.53,
					-100.32,
					44.33,
					-100.26,
					44.06,
					-100.5,
					44.05,
					-100.94,
					43.79,
					-100.96,
					43.71,
					-101.12,
					43.1,
					-101.11,
					43.02,
					-100.79,
					42.7,
					-100.75,
					42.63,
					-100.66,
					42.36,
					-100.71,
					42.07,
					-100.64,
					41.98,
					-100.73,
					41.65,
					-100.77,
					41.63,
					-101.29,
					41.5,
					-101.29,
					41.44,
					-101.17,
					41.05,
					-101.13,
					40.65,
					-101.14,
					40.59,
					-101.23,
					39.96,
					-101.21,
					39.9,
					-101.31,
					39.89,
					-101.93,
					39.67,
					-101.93,
					39.67,
					-101.37,
					39.61,
					-101.28,
					39.13,
					-101.28,
					39.03,
					-101.36,
					38.66,
					-101.38,
					38.6,
					-101.45,
					37.69,
					-101.42,
					37.63,
					-101.51,
					37.62,
					-101.93,
					36.98,
					-101.93,
					36.89,
					-102,
					36.88,
					-102.89,
					31.95,
					-102.96,
					31.89,
					-103.05,
					31.89,
					-104.8,
					30.62,
					-104.81,
					30.28,
					-104.6,
					29.96,
					-104.57,
					29.71,
					-104.42,
					29.41,
					-103.98,
					29.06,
					-103.2,
					28.94,
					-103.19,
					28.64,
					-103.45,
					29.26,
					-104.65,
					29.67,
					-104.98,
					30.09,
					-105.07,
					30.33,
					-105.22,
					30.56,
					-105.65,
					30.81,
					-105.85,
					31.13,
					-106.39,
					31.44,
					-106.66,
					31.47,
					-107.88,
					31.14,
					-107.88,
					30.97,
					-108.05,
					30.97,
					-108.78,
					31.11,
					-108.97,
					31.22,
					-108.99,
					31.25,
					-109.12,
					35.07,
					-109.15,
					35.14,
					-109.52,
					35.06,
					-109.62,
					35.07,
					-111.3,
					35.64,
					-111.41,
					35.53,
					-111.53,
					35.64,
					-111.84,
					35.95,
					-111.81,
					36.37,
					-111.98,
					36.89,
					-111.71,
					36.92,
					-114.12,
					41.89,
					-114.14,
					41.89,
					-117.03,
					41.95,
					-117.12,
					42.34,
					-117.13,
					42.34,
					-118.22,
					42.4,
					-118.31,
					44.24,
					-118.33,
					44.55,
					-117.97,
					44.55,
					-117.59,
					44.41,
					-117.42,
					44.41,
					-117.32,
					44.55,
					-117.3,
					44.92,
					-116.96,
					45.08,
					-116.93,
					45.61,
					-116.59,
					45.82,
					-116.89,
					46.1,
					-116.72,
					46.13,
					-116.59,
					45.93,
					-116.21,
					45.51,
					-116.19,
					45.57,
					-115.81,
					45.49,
					-115.52,
					45.67,
					-115.21,
					45.55,
					-114.88,
					45.58,
					-114.67,
					45.83,
					-114.65,
					45.92,
					-114.53,
					46.18,
					-114.62,
					46.25,
					-114.53,
					46.55,
					-114.46,
					46.59,
					-114.81,
					47.16,
					-115.38,
					47.37,
					-115.85,
					47.65,
					-115.84,
					47.95,
					-116.12,
					49,
					-116.15,
					49.11,
					-115.99,
					49.2,
					-116.23,
					49.4,
					-116.35,
					49.42,
					-116.76,
					49.74,
					-116.73,
					49.91,
					-116.79,
					50.13,
					-116.57,
					50.45,
					-116.78,
					50.58,
					-116.76,
					50.92,
					-117.25,
					51.33,
					-117.42,
					51.38,
					-118.03,
					51.62,
					-118.06,
					51.72,
					-118.27,
					51.85,
					-118.26,
					51.94,
					-118.61,
					52.07,
					-118.75,
					52.17,
					-118.78,
					52.36,
					-118.62,
					52.46,
					-118.34,
					52.75,
					-118.52,
					52.81,
					-118.68,
					53.09,
					-118.91,
					53.01,
					-119.05,
					53.08,
					-119.3,
					53.25,
					-119.44,
					53.28,
					-119.77,
					53.57,
					-120.02,
					53.67,
					-120,
					53.8,
					-120.1,
					59.89,
					-120.1,
					59.89,
					-124.05,
					60.35,
					-124.31,
					60.36,
					-124.47,
					60.6,
					-124.71,
					60.85,
					-124.66,
					60.74,
					-124.85,
					60.67,
					-125.3,
					60.77,
					-125.85,
					60.69,
					-125.97,
					60.74,
					-126.12,
					60.66,
					-126.3,
					60.65,
					-126.88,
					60.95,
					-127.02,
					61,
					-127.2,
					61.2,
					-127.13,
					61.37,
					-127.22,
					61.52,
					-127.88,
					61.99,
					-128.56,
					61.94,
					-128.79,
					62.06,
					-129.34,
					62.42,
					-129.41,
					62.47,
					-129.61,
					62.62,
					-129.64,
					62.81,
					-129.87,
					62.97,
					-129.82,
					63.18,
					-130.27,
					63.3,
					-130.27,
					63.47,
					-130.01,
					63.58,
					-130.14,
					63.59,
					-130.38,
					63.73,
					-130.42,
					63.96,
					-130.97,
					64.31,
					-131.2,
					64.28,
					-131.9,
					64.45,
					-131.91,
					64.6,
					-132.08,
					64.74,
					-132.68,
					64.87,
					-132.71,
					65,
					-132.57,
					65.07,
					-132.63,
					65.08,
					-132.79,
					65.28,
					-132.86,
					65.59,
					-132.34,
					65.78,
					-132.64,
					65.9,
					-132.64,
					65.8,
					-132.92,
					65.9,
					-133.08,
					65.88,
					-133.67,
					66.05,
					-133.78,
					66.19,
					-133.68,
					66.3,
					-133.92,
					66.54,
					-133.78,
					66.76,
					-133.93,
					66.89,
					-134.18,
					66.92,
					-136.21,
					67.17,
					-136.33,
					67.3,
					-136.24,
					67.51,
					-136.29,
					67.68,
					-136.52,
					68.9,
					-136.54,
					68.99,
					-136.48,
					68.99,
					-136.22,
					69.24,
					-136.35,
					69.4,
					-135.86,
					69.48,
					-135.93,
					69.59,
					-135.87,
					69.73,
					-135.38,
					69.7,
					-135.19,
					69.57,
					-135.17,
					69.56,
					-134.95,
					69.69,
					-135.08,
					69.79,
					-134.98,
					69.79,
					-134.68,
					69.63,
					-134.63,
					69.63,
					-134.58,
					69.75,
					-134.6,
					69.89,
					-134.4,
					69.62,
					-133.68,
					69.64,
					-133.51,
					69.47,
					-133.43,
					69.53,
					-133.09,
					69.72,
					-133.02,
					69.84,
					-132.57,
					69.87,
					-132.24,
					69.79,
					-132.14,
					70.07,
					-131.36,
					70,
					-131.14,
					70.23,
					-130.88,
					70.26,
					-130.37,
					70.19,
					-130,
					70.35,
					-129.88,
					70.38,
					-129.67,
					70.15,
					-129.27,
					70.05,
					-129.27,
					69.96,
					-129.38,
					70.05,
					-128.83,
					69.91,
					-128.76,
					70.01,
					-128.48,
					70.14,
					-128.46,
					70.25,
					-128.22,
					70.4,
					-128.29,
					70.5,
					-128.46,
					70.74,
					-128.29,
					70.38,
					-127.19,
					70.05,
					-126.71,
					69.82,
					-126.61,
					69.62,
					-126.25,
					69.49,
					-125.74,
					69.92,
					-125.31,
					70.04,
					-125.31,
					70.27,
					-125.16,
					70.19,
					-124.85,
					70.28,
					-124.8,
					70.3,
					-124.53,
					70.19,
					-124.28,
					69.8,
					-124.24,
					69.81,
					-123.91,
					69.75,
					-123.82,
					69.59,
					-123.86,
					69.44,
					-124.25,
					69.48,
					-123.53,
					69.64,
					-123.21,
					69.84,
					-123.22,
					69.93,
					-122.96,
					69.87,
					-121.37,
					69.51,
					-120.24,
					69.34,
					-118.68,
					69.12,
					-117.98,
					68.98,
					-116.43,
					69.06,
					-116.34,
					69.09,
					-115.58,
					68.97,
					-114.95,
					68.85,
					-114.71,
					68.88,
					-114.59,
					68.99,
					-114.55,
					69.02,
					-114.3,
					68.89,
					-114.16,
					68.76,
					-114.42,
					68.72,
					-114.36,
					68.78,
					-114.19,
					68.71,
					-113.71,
					68.82,
					-113.77,
					68.97,
					-113.7,
					69.11,
					-113.81,
					69.18,
					-114.27,
					69.14,
					-115.48,
					69.3,
					-116.53,
					69.46,
					-116.72,
					69.54,
					-117.12,
					69.66,
					-117.28,
					70.03,
					-117.5,
					70.23,
					-116.95,
					70.42,
					-114.55,
					70.37,
					-113.33,
					70.43,
					-113.09,
					70.34,
					-112.43,
					70.44,
					-112.55,
					70.6,
					-113.84,
					70.47,
					-115.38,
					70.4,
					-115.5,
					70.45,
					-115.84,
					70.36,
					-116.63,
					70.52,
					-117.76,
					70.64,
					-117.87,
					70.75,
					-118.26,
					70.95,
					-118.49,
					71.05,
					-118.49,
					71.27,
					-117.81,
					71.32,
					-117.35,
					71.27,
					-118.18,
					71.55,
					-118.52,
					71.55,
					-118.77,
					71.47,
					-118.9,
					71.52,
					-119.02,
					71.43,
					-119.13,
					71.55,
					-119.28,
					71.67,
					-119.18,
					71.9,
					-119.2,
					72.29,
					-118.47,
					72.35,
					-118.63,
					72.45,
					-118.63,
					72.58,
					-118.55,
					72.72,
					-118.24,
					72.54,
					-119.04,
					72.25,
					-119.25,
					72.11,
					-119.75,
					72.11,
					-120.02,
					71.9,
					-120.28,
					71.65,
					-120.27,
					71.42,
					-120.5,
					71.27,
					-121.3,
					71.34,
					-121.71,
					70.97,
					-122.79,
					71.01,
					-123.27,
					71.15,
					-123.51,
					71.4,
					-123.68,
					71.59,
					-124.09,
					71.87,
					-125.29,
					71.86,
					-126.02,
					71.93,
					-126.11,
					72.04,
					-126.08,
					72.1,
					-125.88,
					72.33,
					-125.72,
					72.37,
					-125.56,
					72.59,
					-125.38,
					72.72,
					-125.14,
					72.74,
					-125.27,
					72.91,
					-125.28,
					72.99,
					-124.91,
					73.15,
					-124.94,
					73.32,
					-124.62,
					73.54,
					-124.42,
					73.61,
					-124.44,
					73.56,
					-124.58,
					73.61,
					-124.77,
					73.77,
					-124.77,
					73.79,
					-124.54,
					73.97,
					-124.61,
					74.21,
					-124.8,
					74.19,
					-125.13,
					74.29,
					-125.19,
					74.38,
					-125.13,
					74.66,
					-121.46,
					74.38,
					-120.06,
					74.31,
					-119.07,
					74.21,
					-118.95,
					74.32,
					-118.68,
					74.35,
					-117.62,
					74.26,
					-117.09,
					73.76,
					-115.53,
					73.54,
					-115.19,
					73.43,
					-115.19,
					73.36,
					-115.32,
					73.47,
					-114.66,
					73.4,
					-114.1,
					73.17,
					-113.82,
					72.96,
					-113.89,
					72.73,
					-113.85,
					72.75,
					-113.67,
					72.87,
					-113.62,
					73.11,
					-113.02,
					72.81,
					-111.07,
					72.58,
					-110.95,
					72.68,
					-110.65,
					72.95,
					-110.82,
					73.06,
					-110.72,
					73.03,
					-109.61,
					72.9,
					-109.44,
					72.97,
					-108.99,
					72.92,
					-108.9,
					73,
					-108.7,
					72.72,
					-108.65,
					72.74,
					-108.43,
					72.59,
					-108.28,
					72.48,
					-108.31,
					72.36,
					-108.49,
					72.22,
					-108.28,
					72.31,
					-108.18,
					72.29,
					-108.03,
					72.12,
					-107.93,
					71.93,
					-108,
					71.82,
					-107.87,
					71.82,
					-107.68,
					71.93,
					-107.58,
					71.88,
					-107.79,
					71.94,
					-107.87,
					72.34,
					-107.92,
					73.07,
					-108.35,
					73.26,
					-108.29,
					73.4,
					-108.14,
					73.45,
					-107.5,
					73.31,
					-107.14,
					73.4,
					-107.05,
					73.55,
					-107.08,
					73.82,
					-106.49,
					73.86,
					-105.08,
					73.63,
					-104.4,
					73.53,
					-104.33,
					73.24,
					-104.45,
					72.86,
					-105.07,
					72.75,
					-105.12,
					72.49,
					-104.96,
					72.38,
					-105.02,
					72.22,
					-104.83,
					71.93,
					-104.71,
					71.8,
					-104.38,
					71.62,
					-104.22,
					71.31,
					-104.19,
					71.24,
					-104.32,
					71.12,
					-104.32,
					71.01,
					-104.01,
					70.87,
					-103.93,
					70.79,
					-102.97,
					70.68,
					-102.73,
					70.6,
					-102.7,
					70.47,
					-101.99,
					70.37,
					-101.86,
					70.39,
					-101.46,
					70.28,
					-101.4,
					70.31,
					-100.99,
					70.41,
					-100.94,
					70.47,
					-100.68,
					70.51,
					-100.79,
					70.64,
					-100.84,
					70.87,
					-100.71,
					70.92,
					-100.58,
					70.83,
					-100.21,
					70.57,
					-99.96,
					70.28,
					-100.11,
					70.46,
					-100.66,
					70.35,
					-100.59,
					70.19,
					-100.64,
					70.19,
					-100.88,
					69.96,
					-100.69,
					69.63,
					-100.81,
					69.58,
					-100.9,
					69.49,
					-100.82,
					69.39,
					-100.88,
					69.25,
					-101.29,
					69.43,
					-101.47,
					69.54,
					-101.46,
					69.57,
					-101.58,
					69.47,
					-101.5,
					69.34,
					-101.55,
					69.14,
					-101.36,
					68.89,
					-101.8,
					68.84,
					-101.61,
					68.74,
					-101.56,
					68.59,
					-101.59,
					68.46,
					-101.78,
					68.5,
					-102.19,
					68.76,
					-102.49,
					68.67,
					-103.43,
					68.8,
					-104.36,
					68.75,
					-104.55,
					68.78,
					-105.13,
					68.9,
					-105.33,
					68.99,
					-105.35,
					69.02,
					-105.73,
					68.94,
					-105.76,
					68.84,
					-105.4,
					68.69,
					-105.24,
					68.68,
					-104.63,
					68.56,
					-104.34,
					68.43,
					-104.29,
					68.33,
					-104.46,
					68.32,
					-104.29,
					68.18,
					-104.25,
					68.14,
					-103.79,
					68.27,
					-103.37,
					68.09,
					-103.2,
					68.07,
					-102.83,
					67.85,
					-102.38,
					67.99,
					-102.2,
					67.88,
					-101.83,
					67.91,
					-101.59,
					67.99,
					-101.56,
					68.02,
					-101.43,
					67.86,
					-101.32,
					67.86,
					-101.02,
					68.02,
					-100.65,
					67.91,
					-99.83,
					67.96,
					-99.45,
					67.84,
					-99.07,
					67.89,
					-99,
					68,
					-99.13,
					68.23,
					-99.08,
					68.38,
					-99.26,
					68.41,
					-99.44,
					68.58,
					-99.44,
					68.61,
					-99.08,
					68.47,
					-98.89,
					68.6,
					-98.57,
					68.51,
					-98.36,
					68.62,
					-98.23,
					68.65,
					-98.71,
					68.81,
					-98.95,
					68.73,
					-99.21,
					68.87,
					-99.62,
					69.03,
					-99.69,
					69.35,
					-99.43,
					69.42,
					-99.17,
					69.28,
					-99.08,
					69.3,
					-98.78,
					69.67,
					-98.61,
					69.68,
					-98.43,
					69.79,
					-98.37,
					70.02,
					-97.96,
					69.91,
					-97.57,
					70.05,
					-97.5,
					70,
					-97.18,
					69.85,
					-97.06,
					69.75,
					-97.1,
					69.67,
					-96.96,
					69.77,
					-96.83,
					69.69,
					-96.67,
					69.69,
					-96.11,
					69.6,
					-96.01,
					69.7,
					-95.95
				]
			},
			{
				"points": [
					75.55,
					-117.32,
					75.66,
					-117.28,
					75.9,
					-116.83,
					76.17,
					-116.7,
					76.27,
					-116.41,
					76.27,
					-116,
					76.44,
					-115.93,
					76.53,
					-115.61,
					76.62,
					-114.87,
					76.56,
					-114.1,
					76.31,
					-113.85,
					76.38,
					-112.98,
					76.28,
					-112.39,
					76.14,
					-112.31,
					75.93,
					-111.37,
					75.63,
					-111.16,
					75.6,
					-109.14,
					75.8,
					-110.09,
					75.88,
					-110.15,
					75.97,
					-110.1,
					76.06,
					-109.69,
					76.21,
					-110.41,
					76.32,
					-110.59,
					76.44,
					-110.62,
					76.54,
					-110.52,
					76.59,
					-109.91,
					76.87,
					-109.38,
					77.01,
					-109.35,
					77.04,
					-109.1,
					76.93,
					-108.98,
					76.95,
					-108.7,
					76.82,
					-108.35,
					76.73,
					-108.29,
					76.55,
					-108.39,
					76.46,
					-108.32,
					76.35,
					-107.96,
					76.17,
					-107.98,
					76.09,
					-107.54,
					75.97,
					-107.47,
					75.99,
					-106.94,
					76.16,
					-106.63,
					76.16,
					-106.28,
					76,
					-105.45,
					75.68,
					-105.24,
					75.28,
					-105.53,
					74.94,
					-105.97,
					74.8,
					-107.18,
					74.89,
					-107.81,
					74.82,
					-107.9,
					74.8,
					-108.37,
					74.84,
					-108.77,
					74.93,
					-108.88,
					74.76,
					-109.35,
					74.68,
					-110.44,
					74.5,
					-110.94,
					74.28,
					-113.03,
					74.34,
					-113.71,
					74.56,
					-114.44,
					74.67,
					-114.52,
					74.77,
					-114.48,
					74.95,
					-113.68,
					74.96,
					-113.96,
					75.19,
					-114.01,
					74.95,
					-114.41,
					74.85,
					-115.03,
					74.91,
					-115.23,
					75.04,
					-115.27,
					74.86,
					-115.69,
					74.95,
					-116.26,
					75.05,
					-116.37,
					75,
					-116.7,
					75.19,
					-117.74,
					75.33,
					-117.71,
					75.55,
					-117.32
				]
			},
			{
				"points": [
					76.26,
					-123.02,
					76.38,
					-123.07,
					76.45,
					-122.99,
					76.44,
					-122.89,
					76.32,
					-122.83,
					76.47,
					-122.56,
					76.54,
					-121.55,
					76.83,
					-121.2,
					76.89,
					-120.51,
					76.98,
					-120.44,
					77.43,
					-119.14,
					77.5,
					-118.15,
					77.45,
					-117.41,
					77.53,
					-117.38,
					77.61,
					-117.17,
					77.62,
					-116.21,
					77.73,
					-116.15,
					77.85,
					-115.62,
					77.79,
					-115.48,
					77.67,
					-115.5,
					77.62,
					-115.82,
					77.53,
					-115.84,
					77.44,
					-115.46,
					77.54,
					-115.51,
					77.64,
					-115.44,
					77.58,
					-115.26,
					77.46,
					-115.3,
					77.43,
					-115.39,
					77.36,
					-115.24,
					77.22,
					-115.27,
					77.11,
					-116.02,
					76.98,
					-115.6,
					76.88,
					-115.63,
					76.8,
					-115.81,
					76.61,
					-115.79,
					76.47,
					-116.26,
					76.44,
					-116.81,
					76.32,
					-116.81,
					76.2,
					-116.99,
					76.17,
					-117.36,
					76.01,
					-117.36,
					75.65,
					-117.83,
					75.39,
					-118.52,
					75.5,
					-119.42,
					75.64,
					-119.5,
					75.8,
					-119.2,
					76.22,
					-117.75,
					76.35,
					-118.13,
					76.67,
					-118.02,
					76.63,
					-118.2,
					76.45,
					-118.25,
					76.43,
					-118.47,
					76.34,
					-118.41,
					76.24,
					-118.46,
					76.18,
					-118.74,
					75.99,
					-118.99,
					76.07,
					-119.38,
					75.9,
					-119.39,
					75.8,
					-119.57,
					75.74,
					-119.9,
					75.79,
					-120.13,
					75.7,
					-120.34,
					75.75,
					-120.54,
					75.91,
					-120.57,
					75.92,
					-120.72,
					75.82,
					-120.75,
					75.62,
					-121.04,
					75.68,
					-121.34,
					75.82,
					-121.37,
					75.91,
					-121.67,
					75.92,
					-122.03,
					75.75,
					-122.31,
					75.73,
					-122.52,
					75.8,
					-122.73,
					75.9,
					-122.79,
					75.95,
					-123.1,
					76.1,
					-123.12,
					76.26,
					-123.02
				]
			},
			{
				"points": [
					71.58,
					-96.75,
					71.54,
					-97.92,
					71.22,
					-98.41,
					71.2,
					-98.99,
					71.26,
					-99.24,
					71.76,
					-99.87,
					71.78,
					-100.1,
					72.07,
					-100.64,
					72.06,
					-100.96,
					72.2,
					-101.19,
					72.13,
					-101.41,
					72.19,
					-101.82,
					72.39,
					-101.99,
					72.57,
					-102.66,
					72.8,
					-102.85,
					73.1,
					-102.56,
					73.21,
					-102.23,
					73.13,
					-101.72,
					72.89,
					-101.36,
					72.86,
					-101.18,
					72.88,
					-100.93,
					73.04,
					-101.09,
					73.13,
					-101.04,
					73.13,
					-100.91,
					73.02,
					-100.84,
					73,
					-100.69,
					72.84,
					-100.68,
					73.02,
					-100.61,
					73.11,
					-100.68,
					73.24,
					-100.66,
					73.32,
					-100.55,
					72.71,
					-96.41,
					72.49,
					-96.18,
					72.38,
					-96.17,
					72.27,
					-96.38,
					72.05,
					-96.35,
					71.76,
					-96.44,
					71.7,
					-96.67,
					71.58,
					-96.75
				]
			},
			{
				"points": [
					77.75,
					-113.36,
					77.89,
					-113.38,
					78.04,
					-113.09,
					78.16,
					-113.06,
					78.2,
					-113.26,
					78.13,
					-113.43,
					78.22,
					-114.07,
					78.17,
					-114.21,
					78.24,
					-114.31,
					78.35,
					-114.29,
					78.42,
					-113.83,
					78.36,
					-113.36,
					78.49,
					-113.26,
					78.53,
					-113.09,
					78.86,
					-110.7,
					78.78,
					-109.94,
					78.57,
					-109.19,
					78.48,
					-109.11,
					78.21,
					-109.33,
					78.2,
					-109.8,
					78.16,
					-109.49,
					78.03,
					-109.44,
					77.86,
					-109.61,
					77.81,
					-109.93,
					77.47,
					-109.98,
					77.35,
					-110.4,
					77.21,
					-112.03,
					77.42,
					-113.23,
					77.64,
					-113.41,
					77.75,
					-113.36
				]
			},
			{
				"points": [
					78.01,
					-103.05,
					78.06,
					-103.35,
					78.19,
					-103.39,
					78.13,
					-104.02,
					78.22,
					-104.71,
					78.41,
					-105.07,
					78.55,
					-105.11,
					78.69,
					-104.73,
					78.65,
					-104.13,
					78.69,
					-104.27,
					78.84,
					-104.26,
					78.69,
					-105.02,
					78.8,
					-105.1,
					78.91,
					-104.99,
					78.92,
					-105.6,
					79.17,
					-105.72,
					79.44,
					-105.52,
					79.52,
					-104.15,
					79.35,
					-102.82,
					79.24,
					-102.74,
					79.18,
					-102.54,
					79.02,
					-102.48,
					79.12,
					-102.4,
					79.16,
					-101.93,
					78.21,
					-101.91,
					78.15,
					-102.68,
					78.01,
					-103.05
				]
			},
			{
				"points": [
					75.38,
					-102.62,
					75.54,
					-102.9,
					75.66,
					-102.94,
					75.74,
					-103.81,
					76.06,
					-104.53,
					76.19,
					-104.58,
					76.27,
					-104.46,
					76.53,
					-104.73,
					76.66,
					-104.73,
					76.78,
					-104.08,
					76.53,
					-102.94,
					76.41,
					-102.87,
					76.41,
					-102.67,
					76.1,
					-102.17,
					76.03,
					-101.92,
					75.47,
					-101.92,
					75.38,
					-102.62
				]
			},
			{
				"points": [
					76.93,
					-103.6,
					77.11,
					-105.42,
					77.65,
					-106.15,
					77.75,
					-106.19,
					77.87,
					-105.85,
					77.78,
					-105.33,
					77.17,
					-103.84,
					77.14,
					-103.55,
					77.02,
					-103.49,
					76.93,
					-103.6
				]
			},
			{
				"points": [
					68.29,
					-100.73,
					68.28,
					-100.89,
					68.52,
					-101.16,
					68.76,
					-100.87,
					68.89,
					-100.91,
					68.97,
					-100.76,
					69.1,
					-100.73,
					69.17,
					-100.27,
					69.28,
					-100.15,
					69.21,
					-99.72,
					69.05,
					-99.71,
					68.81,
					-100.02,
					68.71,
					-99.98,
					68.61,
					-100.05,
					68.57,
					-100.53,
					68.68,
					-100.7,
					68.44,
					-100.46,
					68.34,
					-100.52,
					68.29,
					-100.73
				]
			},
			{
				"points": [
					76.58,
					-114.02,
					76.66,
					-114.86,
					76.77,
					-114.95,
					76.97,
					-114.59,
					76.99,
					-113.84,
					77.1,
					-114,
					77.22,
					-113.94,
					77.17,
					-113.14,
					77,
					-113.19,
					76.99,
					-113.7,
					76.86,
					-113.36,
					76.7,
					-113.38,
					76.59,
					-113.59,
					76.58,
					-114.02
				]
			},
			{
				"points": [
					74.91,
					-104.17,
					75.01,
					-104.92,
					75.12,
					-105.01,
					75.5,
					-104.53,
					75.53,
					-104.12,
					75.44,
					-103.73,
					75.2,
					-103.46,
					75.06,
					-103.53,
					74.91,
					-104.17
				]
			},
			{
				"points": [
					77.61,
					-113.86,
					77.63,
					-114.51,
					77.87,
					-115.12,
					77.99,
					-115.18,
					78.06,
					-115.1,
					78.18,
					-114.32,
					77.85,
					-113.43,
					77.73,
					-113.46,
					77.61,
					-113.86
				]
			}
		],
		"transitions": [
			[
				1320584400,
				-420,
				[
					"MST"
				]
			],
			[
				1331470800,
				-360,
				[
					"MDT"
				]
			],
			[
				1352034000,
				-420,
				[
					"MST"
				]
			],
			[
				1362920400,
				-360,
				[
					"MDT"
				]
			],
			[
				1383483600,
				-420,
				[
					"MST"
				]
			],
			[
				1394370000,
				-360,
				[
					"MDT"
				]
			],
			[
				1414933200,
				-420,
				[
					"MST"
				]
			],
			[
				1425819600,
				-360,
				[
					"MDT"
				]
			],
			[
				1446382800,
				-420,
				[
					"MST"
				]
			],
			[
				1457874000,
				-360,
				[
					"MDT"
				]
			],
			[
				1478437200,
				-420,
				[
					"MST"
				]
			],
			[
				1489323600,
				-360,
				[
					"MDT"
				]
			],
			[
				1509886800,
				-420,
				[
					"MST"
				]
			],
			[
				1520773200,
				-360,
				[
					"MDT"
				]
			],
			[
				1541336400,
				-420,
				[
					"MST"
				]
			],
			[
				1552222800,
				-360,
				[
					"MDT"
				]
			],
			[
				1572786000,
				-420,
				[
					"MST"
				]
			],
			[
				1583672400,
				-360,
				[
					"MDT"
				]
			],
			[
				1604235600,
				-420,
				[
					"MST"
				]
			],
			[
				1615726800,
				-360,
				[
					"MDT"
				]
			],
			[
				1636290000,
				-420,
				[
					"MST"
				]
			],
			[
				1647176400,
				-360,
				[
					"MDT"
				]
			],
			[
				1667739600,
				-420,
				[
					"MST"
				]
			],
			[
				1678626000,
				-360,
				[
					"MDT"
				]
			],
			[
				1699189200,
				-420,
				[
					"MST"
				]
			],
			[
				1710075600,
				-360,
				[
					"MDT"
				]
			],
			[
				1730638800,
				-420,
				[
					"MST"
				]
			],
			[
				1741525200,
				-360,
				[
					"MDT"
				]
			],
			[
				1762088400,
				-420,
				[
					"MST"
				]
			],
			[
				1772974800,
				-360,
				[
					"MDT"
				]
			],
			[
				1793538000,
				-420,
				[
					"MST"
				]
			],
			[
				1805029200,
				-360,
				[
					"MDT"
				]
			],
			[
				1825592400,
				-420,
				[
					"MST"
				]
			],
			[
				1836478800,
				-360,
				[
					"MDT"
				]
			],
			[
				1857042000,
				-420,
				[
					"MST"
				]
			],
			[
				1867928400,
				-360,
				[
					"MDT"
				]
			],
			[
				1888491600,
				-420,
				[
					"MST"
				]
			],
			[
				1899378000,
				-360,
				[
					"MDT"
				]
			],
			[
				1919941200,
				-420,
				[
					"MST"
				]
			],
			[
				1930827600,
				-360,
				[
					"MDT"
				]
			],
			[
				1951390800,
				-420,
				[
					"MST"
				]
			],
			[
				1962882000,
				-360,
				[
					"MDT"
				]
			],
			[
				1983445200,
				-420,
				[
					"MST"
				]
			],
			[
				1994331600,
				-360,
				[
					"MDT"
				]
			],
			[
				2014894800,
				-420,
				[
					"MST"
				]
			],
			[
				2025781200,
				-360,
				[
					"MDT"
				]
			],
			[
				2046344400,
				-420,
				[
					"MST"
				]
			],
			[
				2057230800,
				-360,
				[
					"MDT"
				]
			],
			[
				2077794000,
				-420,
				[
					"MST"
				]
			],
			[
				2088680400,
				-360,
				[
					"MDT"
				]
			],
			[
				2109243600,
				-420,
				[
					"MST"
				]
			],
			[
				2120130000,
				-360,
				[
					"MDT"
				]
			],
			[
				2140693200,
				-420,
				[
					"MST"
				]
			]
		],
		"name": "America/Inuvik"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-25.87,
					32.86,
					-25.92,
					33.09,
					-26.88,
					33,
					-28.16,
					32.66,
					-28.61,
					32.46,
					-29.44,
					31.42,
					-30.67,
					30.64,
					-31.37,
					30.08,
					-31.76,
					29.49,
					-32.65,
					28.62,
					-33.62,
					27.16,
					-33.87,
					26.54,
					-33.86,
					25.82,
					-34.14,
					25.72,
					-34.08,
					25.04,
					-34.32,
					24.86,
					-34.09,
					23.64,
					-34.21,
					23.39,
					-34.1,
					22.57,
					-34.17,
					22.26,
					-34.26,
					22.23,
					-34.33,
					22,
					-34.48,
					21.85,
					-34.54,
					21.26,
					-34.48,
					20.99,
					-34.57,
					20.87,
					-34.58,
					20.56,
					-34.94,
					20.03,
					-34.89,
					19.62,
					-34.73,
					19.37,
					-34.72,
					19.23,
					-34.51,
					19.21,
					-34.47,
					18.76,
					-34.2,
					18.69,
					-34.2,
					18.58,
					-34.45,
					18.54,
					-34.38,
					18.31,
					-34.01,
					18.2,
					-33.71,
					18.3,
					-33.52,
					18.14,
					-33.47,
					17.97,
					-33.33,
					17.99,
					-33.08,
					17.79,
					-32.84,
					17.73,
					-32.6,
					17.93,
					-32.64,
					18.11,
					-32.57,
					18.18,
					-31.93,
					18.17,
					-30.39,
					17.18,
					-29.4,
					16.83,
					-28.68,
					16.36,
					-28.53,
					16.37,
					-28.4,
					16.65,
					-28.22,
					16.65,
					-28,
					16.8,
					-27.93,
					17.05,
					-28.23,
					17.47,
					-28.62,
					17.52,
					-28.65,
					17.92,
					-28.8,
					18.2,
					-28.73,
					18.71,
					-28.84,
					19.16,
					-28.68,
					19.17,
					-28.61,
					19.38,
					-28.44,
					19.49,
					-28.34,
					19.88,
					-21.99,
					19.89,
					-21.89,
					19.99,
					-21.89,
					20.89,
					-18.23,
					20.92,
					-17.88,
					23.31,
					-18.32,
					23.66,
					-17.91,
					24.16,
					-17.84,
					24.44,
					-17.92,
					24.55,
					-17.68,
					24.95,
					-17.59,
					24.23,
					-17.73,
					23.37,
					-17.54,
					23.06,
					-16.54,
					22.02,
					-16.19,
					21.88,
					-12.96,
					21.89,
					-12.9,
					21.98,
					-12.88,
					23.8,
					-12.52,
					23.84,
					-12.35,
					23.95,
					-12.11,
					23.87,
					-11.65,
					23.86,
					-11.38,
					23.96,
					-11.09,
					23.92,
					-11.05,
					23.45,
					-11.23,
					23.09,
					-11.15,
					22.57,
					-11.35,
					22.29,
					-11.31,
					22.18,
					-10.85,
					22.06,
					-10.71,
					22.21,
					-10.38,
					22.21,
					-9.98,
					22.09,
					-9.73,
					21.8,
					-9.45,
					21.68,
					-8.5,
					21.84,
					-7.93,
					21.63,
					-7.43,
					21.72,
					-7.39,
					20.53,
					-7.31,
					20.44,
					-7.03,
					20.48,
					-7.08,
					19.89,
					-6.62,
					19.63,
					-6.2,
					19.57,
					-5.64,
					20.06,
					-5.17,
					20.08,
					-4.8,
					19.95,
					-4.5,
					20,
					-4.23,
					19.93,
					-4.17,
					20.02,
					-4.25,
					20.27,
					-4.08,
					20.55,
					-3.26,
					20.55,
					-2.41,
					20.92,
					-2.37,
					21.35,
					-2.22,
					21.48,
					-2.39,
					21.81,
					-2.17,
					22.1,
					-1.83,
					22.09,
					-1.84,
					22.46,
					-1.69,
					22.59,
					-1.84,
					22.95,
					-1.84,
					23.15,
					-1.96,
					23.26,
					-1.91,
					23.62,
					-1.66,
					23.8,
					-1.67,
					24.27,
					-1.48,
					24.21,
					-1.39,
					23.87,
					-0.86,
					23.26,
					-0.75,
					23.26,
					-0.61,
					23.47,
					-0.56,
					23.42,
					-0.6,
					23.25,
					-0.47,
					22.88,
					-0.36,
					22.87,
					-0.19,
					23.06,
					-0.19,
					23.26,
					0.35,
					22.88,
					1.27,
					22.54,
					1.46,
					22.18,
					1.74,
					22.37,
					2.21,
					22.52,
					2.14,
					22.74,
					2.29,
					22.94,
					2.22,
					23.09,
					2.34,
					23.41,
					2.49,
					22.94,
					2.65,
					22.85,
					2.93,
					22.91,
					2.9,
					22.74,
					3.19,
					22.69,
					3.31,
					22.52,
					3.53,
					22.59,
					3.64,
					22.98,
					3.78,
					23.14,
					3.75,
					22.83,
					4.11,
					22.35,
					4.54,
					22.51,
					4.57,
					22.63,
					4.92,
					22.86,
					4.71,
					23.39,
					4.83,
					23.55,
					5.03,
					24.22,
					5.22,
					24.38,
					5.04,
					24.72,
					5.07,
					25.05,
					5.14,
					25.23,
					5.39,
					25.29,
					5.49,
					25.54,
					5.31,
					25.85,
					5.37,
					26.15,
					5.16,
					26.53,
					5.18,
					26.83,
					5.31,
					27.15,
					4.96,
					27.74,
					4.68,
					27.89,
					4.43,
					28.41,
					4.66,
					28.75,
					4.47,
					29.22,
					4.75,
					29.39,
					4.75,
					29.66,
					4.62,
					29.9,
					4.44,
					29.91,
					4.03,
					30.28,
					3.95,
					30.61,
					3.74,
					30.66,
					3.72,
					30.87,
					3.38,
					31.04,
					3.05,
					30.88,
					2.88,
					30.99,
					2.49,
					30.87,
					2.51,
					31.01,
					2.38,
					31.26,
					2.08,
					31.41,
					1.67,
					31.1,
					0.73,
					30.07,
					0.46,
					30.06,
					0.03,
					29.81,
					-1.24,
					29.71,
					-1.2,
					29.84,
					-1.35,
					29.96,
					-0.96,
					30.3,
					-0.95,
					30.48,
					-1.26,
					30.65,
					-1.38,
					30.81,
					-1.6,
					30.92,
					-1.89,
					30.91,
					-2.1,
					31,
					-2.43,
					30.9,
					-2.51,
					30.63,
					-2.78,
					30.58,
					-2.89,
					30.92,
					-3.25,
					30.94,
					-3.61,
					30.54,
					-3.84,
					30.49,
					-3.89,
					30.39,
					-4.35,
					30.1,
					-4.56,
					29.79,
					-4.55,
					29.47,
					-4.84,
					29.44,
					-5.63,
					29.7,
					-6.27,
					29.72,
					-6.53,
					29.87,
					-7,
					30.35,
					-8.16,
					30.86,
					-8.5,
					31.12,
					-8.49,
					31.43,
					-8.61,
					31.63,
					-8.8,
					31.74,
					-8.83,
					31.99,
					-8.97,
					32.07,
					-9.02,
					32.48,
					-9.15,
					32.6,
					-9.38,
					33.36,
					-9.5,
					33.51,
					-9.51,
					33.85,
					-9.38,
					34.01,
					-9.41,
					34.11,
					-9.97,
					34.62,
					-10.52,
					34.66,
					-10.74,
					34.76,
					-11,
					34.71,
					-11.31,
					34.99,
					-11.48,
					35.04,
					-11.48,
					35.56,
					-11.29,
					35.84,
					-11.48,
					36.2,
					-11.59,
					36.27,
					-11.61,
					36.56,
					-11.48,
					36.76,
					-11.45,
					37.02,
					-11.58,
					37.18,
					-11.62,
					37.43,
					-11.48,
					37.71,
					-11.18,
					37.88,
					-11.16,
					38.2,
					-11.29,
					38.47,
					-11.07,
					38.83,
					-11.06,
					39.22,
					-10.37,
					40.51,
					-10.64,
					40.73,
					-10.96,
					40.82,
					-11.2,
					40.79,
					-11.28,
					40.71,
					-11.41,
					40.74,
					-11.46,
					40.57,
					-11.56,
					40.53,
					-11.71,
					40.57,
					-11.81,
					40.71,
					-12.1,
					40.64,
					-12.18,
					40.71,
					-12.74,
					40.74,
					-12.89,
					40.66,
					-13.45,
					40.64,
					-13.53,
					40.71,
					-13.65,
					40.65,
					-14.09,
					40.73,
					-14.14,
					40.81,
					-14.53,
					40.95,
					-14.87,
					40.94,
					-15.18,
					40.74,
					-15.34,
					40.75,
					-15.6,
					40.61,
					-16.01,
					40.21,
					-16.49,
					39.97,
					-16.9,
					39.28,
					-17.2,
					39.15,
					-17.23,
					39.06,
					-17.14,
					38.97,
					-17.35,
					38.16,
					-17.8,
					37.35,
					-18.02,
					37.07,
					-18.95,
					36.38,
					-19.13,
					35.84,
					-19.55,
					35.45,
					-19.95,
					34.87,
					-20.48,
					34.79,
					-20.58,
					35.03,
					-20.88,
					35.2,
					-21.32,
					35.22,
					-21.49,
					35.31,
					-21.4,
					35.47,
					-21.5,
					35.58,
					-21.83,
					35.61,
					-22,
					35.54,
					-22.13,
					35.64,
					-22.77,
					35.62,
					-22.93,
					35.71,
					-23.67,
					35.49,
					-23.75,
					35.65,
					-24.13,
					35.6,
					-24.72,
					35.13,
					-25.23,
					33.73,
					-25.6,
					32.98,
					-25.87,
					32.86
				]
			},
			{
				"points": [
					23.78,
					35.7,
					23.7,
					35.59,
					23.49,
					35.6,
					23.34,
					35.65,
					23.29,
					35.78,
					23.1,
					35.79,
					22.68,
					35.23,
					22.72,
					35.01,
					22.21,
					34.75,
					22.1,
					34.24,
					21.66,
					34.01,
					21.61,
					33.53,
					21.89,
					33.13,
					21.89,
					25.1,
					19.95,
					25.1,
					19.89,
					25,
					19.89,
					24.1,
					19.45,
					24.08,
					19.39,
					23.98,
					21.27,
					20.3,
					23.32,
					15.99,
					22.53,
					14.15,
					23.08,
					13.43,
					23.43,
					11.91,
					24.11,
					11.55,
					24.09,
					11.38,
					24.44,
					10.7,
					24.37,
					10.48,
					24.5,
					10.2,
					24.7,
					10.11,
					24.83,
					9.93,
					25.28,
					9.93,
					26.16,
					9.27,
					26.43,
					9.43,
					26.64,
					9.81,
					27.34,
					9.66,
					27.89,
					9.84,
					28.29,
					9.72,
					29.03,
					9.76,
					29.39,
					9.68,
					30.18,
					9.29,
					30.27,
					9.35,
					30.44,
					9.82,
					30.86,
					10.16,
					31.07,
					10.17,
					31.48,
					10.02,
					31.75,
					10.2,
					31.84,
					10.46,
					32.05,
					10.57,
					32.1,
					10.74,
					32.28,
					10.94,
					32.49,
					11.45,
					32.89,
					11.37,
					33.2,
					11.46,
					33.27,
					11.56,
					32.94,
					12.34,
					32.9,
					12.75,
					33,
					13.4,
					32.89,
					13.63,
					32.82,
					14.2,
					32.61,
					14.54,
					32.49,
					15.23,
					32.19,
					15.47,
					31.71,
					15.59,
					31.49,
					15.8,
					31.03,
					17.87,
					30.38,
					19.03,
					30.51,
					19.55,
					30.91,
					19.96,
					31.14,
					20.05,
					31.45,
					19.88,
					31.84,
					19.81,
					32.27,
					20.03,
					32.65,
					20.53,
					32.86,
					21.03,
					32.9,
					21.4,
					33.03,
					21.62,
					33.03,
					22.19,
					32.73,
					23.14,
					32.48,
					23.26,
					32.37,
					23.23,
					32.31,
					23.31,
					32.28,
					23.77,
					32.11,
					24.21,
					32.13,
					24.73,
					32.06,
					25.03,
					31.61,
					25.28,
					31.73,
					25.93,
					31.47,
					27.36,
					31.31,
					27.52,
					31.34,
					27.9,
					31.2,
					28,
					31.19,
					28.46,
					30.93,
					29.1,
					31.06,
					29.48,
					31.42,
					30,
					31.41,
					30.19,
					31.61,
					30.35,
					31.57,
					30.51,
					31.7,
					31.05,
					31.55,
					31.55,
					31.64,
					31.92,
					31.17,
					32.62,
					31.34,
					33.14,
					31.23,
					33.72,
					31.4,
					34.15,
					31.7,
					34.5,
					31.48,
					34.65,
					31.18,
					34.38,
					29.49,
					35.01,
					29.25,
					34.84,
					28.7,
					34.73,
					28.29,
					34.52,
					27.95,
					34.54,
					27.67,
					34.35,
					27.63,
					34.21,
					27.94,
					33.68,
					28.47,
					33.16,
					28.94,
					33.07,
					29.26,
					32.73,
					29,
					32.74,
					28.62,
					32.96,
					27.89,
					33.68,
					27.55,
					34.11,
					27.34,
					34.06,
					27.41,
					33.78,
					27.23,
					34.08,
					27.05,
					34,
					26.87,
					34.11,
					26.64,
					34.09,
					25.08,
					34.99,
					25.03,
					35.09,
					24.81,
					35.12,
					24.68,
					35.28,
					24.56,
					35.25,
					24.48,
					35.47,
					24.23,
					35.54,
					23.95,
					35.89,
					23.74,
					35.87,
					23.78,
					35.7
				]
			},
			{
				"points": [
					31.25,
					35.17,
					31.29,
					34.82,
					31.38,
					34.77,
					32.22,
					34.85,
					32.51,
					34.97,
					32.66,
					35.2,
					32.58,
					35.47,
					32.39,
					35.66,
					31.75,
					35.66,
					31.42,
					35.55,
					31.25,
					35.17
				]
			},
			{
				"points": [
					-47.06,
					37.9,
					-47.07,
					37.59,
					-46.94,
					37.48,
					-46.72,
					37.65,
					-46.73,
					37.82,
					-46.59,
					37.77,
					-46.51,
					37.88,
					-46.53,
					38.04,
					-46.62,
					38.09,
					-46.78,
					37.92,
					-46.91,
					38.02,
					-47.06,
					37.9
				]
			}
		],
		"transitions": [
			[
				0,
				120,
				[
					"CAT",
					"EET",
					"SAST"
				]
			]
		],
		"name": "Africa/Mbabane"
	},
	{
		"hoverRegion": [
			{
				"points": [
					64.57,
					105.64,
					64.7,
					105.61,
					64.77,
					105.75,
					65.1,
					105.9,
					65.28,
					106.32,
					65.47,
					106.49,
					65.48,
					106.65,
					65.58,
					106.34,
					65.97,
					106.36,
					66.13,
					106.02,
					66.41,
					105.99,
					66.53,
					106.19,
					66.61,
					106.16,
					66.7,
					105.92,
					66.82,
					105.9,
					66.91,
					105.48,
					67,
					105.41,
					67.11,
					105.49,
					67.4,
					106.69,
					68.8,
					106.77,
					69.34,
					106.06,
					69.49,
					106.05,
					69.68,
					106.43,
					69.62,
					106.81,
					69.78,
					107.86,
					69.96,
					108.24,
					69.88,
					109.19,
					69.98,
					109.31,
					70.2,
					109.22,
					70.31,
					109.26,
					70.36,
					109.5,
					70.49,
					109.63,
					70.52,
					110.02,
					70.67,
					110.02,
					70.74,
					110.09,
					70.81,
					110.43,
					70.9,
					110.52,
					70.96,
					111.32,
					71.16,
					112.05,
					71.16,
					112.41,
					71.35,
					111.91,
					72.02,
					111.9,
					72.11,
					111.57,
					72.21,
					111.51,
					72.27,
					111.03,
					72.38,
					110.98,
					72.46,
					111.04,
					72.55,
					110.67,
					72.76,
					110.52,
					72.96,
					110.56,
					73.06,
					110.74,
					73.09,
					110.37,
					73.25,
					110.34,
					73.38,
					110.05,
					73.48,
					110.11,
					73.51,
					110.53,
					73.64,
					110.76,
					73.74,
					110.74,
					73.89,
					110.9,
					73.96,
					111.27,
					73.83,
					111.88,
					73.83,
					112.79,
					73.99,
					112.7,
					74.23,
					111.39,
					74.34,
					111.39,
					74.45,
					111.53,
					74.62,
					111.96,
					74.61,
					112.79,
					74.76,
					112.84,
					74.78,
					112.98,
					74.61,
					113.08,
					74.54,
					113.46,
					74.28,
					113.54,
					74.03,
					112.98,
					73.77,
					113.46,
					73.62,
					113.55,
					73.82,
					115.56,
					73.66,
					118.72,
					73.49,
					119.07,
					73.38,
					119.05,
					73.25,
					118.87,
					73.19,
					119.15,
					73.29,
					120.13,
					73.26,
					120.32,
					73.08,
					120.58,
					73.04,
					121.08,
					73.04,
					121.94,
					73.15,
					122.1,
					73.2,
					122.55,
					73.14,
					122.96,
					73.05,
					123.01,
					73.01,
					123.2,
					73.11,
					123.31,
					73.5,
					123.06,
					73.61,
					123.11,
					73.74,
					123.32,
					73.73,
					123.15,
					73.87,
					123.02,
					74.05,
					123.09,
					74.09,
					123.28,
					74.01,
					123.36,
					73.77,
					123.37,
					73.94,
					123.75,
					73.9,
					124.17,
					74.03,
					124.52,
					74.02,
					124.86,
					73.96,
					125.05,
					73.81,
					125.03,
					73.67,
					125.56,
					73.75,
					125.67,
					73.76,
					125.9,
					73.7,
					125.99,
					73.61,
					125.99,
					73.66,
					126.35,
					73.52,
					126.56,
					73.54,
					126.91,
					73.63,
					127.02,
					73.62,
					127.36,
					73.55,
					127.48,
					73.62,
					127.57,
					73.62,
					127.86,
					73.51,
					128.04,
					73.32,
					128.93,
					73.2,
					129.01,
					73.1,
					129.54,
					72.96,
					129.68,
					72.82,
					129.6,
					72.56,
					129.71,
					72.41,
					129.61,
					72.23,
					129.7,
					72.07,
					129.67,
					71.94,
					129.42,
					71.71,
					129.71,
					71.6,
					129.66,
					71.58,
					129.38,
					71.38,
					129.54,
					71.2,
					129.91,
					71.16,
					130.21,
					71,
					130.41,
					70.96,
					130.73,
					71.06,
					130.89,
					70.82,
					131.07,
					70.94,
					131.49,
					71.14,
					131.74,
					71.09,
					132.2,
					70.89,
					132.32,
					70.71,
					132.15,
					70.51,
					132.2,
					70.44,
					133.13,
					70.23,
					133.35,
					70.05,
					133.2,
					69.91,
					133.27,
					69.74,
					133.62,
					69.55,
					133.56,
					69.53,
					133.29,
					69.39,
					133,
					69.29,
					132.95,
					69.2,
					132.72,
					69.1,
					132.69,
					69.04,
					132.57,
					68.95,
					132.79,
					68.45,
					133.24,
					67.87,
					133.17,
					66.93,
					131.93,
					66.41,
					130.17,
					66.31,
					130.2,
					66.07,
					130.98,
					65.9,
					131.26,
					65.82,
					131.66,
					65.51,
					131.71,
					65.44,
					131.89,
					64.93,
					132.34,
					64.72,
					132.35,
					64.63,
					132.78,
					64.47,
					132.81,
					64.38,
					132.97,
					64.17,
					132.93,
					64,
					132.7,
					63.87,
					132.66,
					63.71,
					132.39,
					63.46,
					132.86,
					63.41,
					133.28,
					63.3,
					133.32,
					63.18,
					133.25,
					63.24,
					133.91,
					62.92,
					134.3,
					62.69,
					135.17,
					62.74,
					135.37,
					62.23,
					135.95,
					62.09,
					135.8,
					61.95,
					135.77,
					61.69,
					135.35,
					61.59,
					135.47,
					61.49,
					135.44,
					61.3,
					134.97,
					61.34,
					134.59,
					61.63,
					134.16,
					61.67,
					133.98,
					61.68,
					133.75,
					61.52,
					133.41,
					61.54,
					133.22,
					61.43,
					133.24,
					61.32,
					133.16,
					60.79,
					133.24,
					60.59,
					132.93,
					60.55,
					132.59,
					60.19,
					132.4,
					59.89,
					132.09,
					59.87,
					131.93,
					59.67,
					131.85,
					59.24,
					131.84,
					59.14,
					132.18,
					58.91,
					132.39,
					58.93,
					132.58,
					58.62,
					132.67,
					58.38,
					132.47,
					58.37,
					132.27,
					58.03,
					132.24,
					57.92,
					132.12,
					58.03,
					131.76,
					57.65,
					132.15,
					57.47,
					132.02,
					57.36,
					131.7,
					57.22,
					131.68,
					57.15,
					131.56,
					56.91,
					131.84,
					56.67,
					131.9,
					56.59,
					131.79,
					56.35,
					131.74,
					56.41,
					131.53,
					56.31,
					131.41,
					56.35,
					131.23,
					55.81,
					130.98,
					55.72,
					131.12,
					55.78,
					132.57,
					55.55,
					132.77,
					55.44,
					133.03,
					55.33,
					133.05,
					55.26,
					132.75,
					55.12,
					132.69,
					55.08,
					132.48,
					54.96,
					132.44,
					54.93,
					132.09,
					54.79,
					132.02,
					54.54,
					131.32,
					54.24,
					131.19,
					54.17,
					130.78,
					53.98,
					130.55,
					53.84,
					131.48,
					53.33,
					131.64,
					53.33,
					131.9,
					53.27,
					131.95,
					53.39,
					133.08,
					53.52,
					133.17,
					53.65,
					133.53,
					53.54,
					134,
					53.72,
					134.58,
					53.42,
					135.04,
					53.26,
					135.06,
					53.02,
					134.97,
					52.84,
					134.78,
					52.61,
					134.89,
					52.3,
					134.63,
					52.56,
					133.35,
					52.26,
					133.54,
					52.09,
					133.38,
					51.98,
					132.64,
					51.68,
					132.29,
					51.59,
					131.54,
					51.3,
					131.59,
					51.15,
					131.13,
					50.76,
					130.89,
					50.72,
					131.03,
					50.45,
					131.23,
					50.46,
					131.35,
					50.22,
					131.54,
					50.09,
					131.56,
					50.01,
					131.49,
					49.94,
					131.6,
					49.36,
					131.59,
					49.15,
					131.46,
					49.13,
					131.21,
					48.87,
					131.03,
					48.74,
					130.52,
					48.77,
					130.16,
					49.28,
					129.43,
					49.24,
					129.08,
					49.38,
					128.68,
					49.47,
					128.64,
					49.39,
					128.22,
					49.58,
					127.61,
					49.81,
					127.4,
					50.03,
					127.37,
					50.16,
					127.44,
					50.27,
					127.23,
					50.69,
					127.18,
					51,
					126.82,
					51.47,
					126.69,
					51.55,
					126.57,
					51.67,
					126.59,
					51.89,
					126.36,
					52.07,
					126.34,
					52.14,
					126.2,
					52.33,
					126.22,
					52.55,
					125.87,
					52.68,
					125.88,
					52.77,
					125.79,
					52.76,
					125.61,
					52.92,
					125.59,
					53.07,
					125.17,
					52.99,
					124.83,
					53.37,
					123.82,
					53.44,
					123.26,
					53.34,
					122.85,
					53.38,
					122.32,
					53.17,
					121.23,
					53.17,
					120.9,
					52.71,
					120.18,
					52.74,
					120.48,
					52.62,
					120.79,
					52.37,
					120.75,
					52.22,
					120.86,
					51.93,
					120.79,
					51.59,
					120.17,
					51.03,
					119.83,
					50.84,
					119.61,
					50.67,
					119.57,
					50.53,
					119.37,
					50.43,
					119.34,
					50.32,
					119.47,
					49.98,
					119.35,
					49.82,
					118.6,
					49.39,
					117.87,
					49.61,
					116.9,
					49.83,
					116.56,
					49.91,
					116.23,
					49.78,
					115.78,
					49.79,
					115.39,
					50.08,
					114.92,
					50.17,
					114.35,
					49.87,
					113.53,
					49.73,
					113.28,
					49.53,
					113.17,
					49.39,
					112.82,
					49.43,
					112.51,
					49.28,
					111.96,
					49.26,
					111.4,
					49.04,
					110.81,
					49.13,
					110.41,
					49.05,
					110.22,
					49.11,
					109.52,
					49.25,
					109.18,
					49.24,
					108.48,
					49.6,
					107.86,
					49.84,
					107.85,
					49.89,
					107.68,
					49.99,
					107.64,
					50.23,
					107.69,
					50.44,
					107.95,
					50.52,
					108.23,
					50.68,
					107.98,
					50.78,
					107.96,
					50.91,
					108.16,
					51.15,
					108.32,
					51.29,
					108.24,
					51.54,
					108.46,
					51.61,
					109.08,
					51.46,
					109.37,
					51.72,
					110.06,
					51.61,
					110.66,
					51.86,
					110.94,
					52.02,
					111.55,
					52.39,
					112.05,
					52.32,
					112.36,
					52.45,
					112.49,
					52.44,
					112.9,
					52.58,
					113.27,
					52.56,
					113.56,
					52.79,
					114.03,
					52.96,
					114.11,
					53.33,
					113.73,
					53.7,
					113.74,
					54.08,
					114.91,
					54.28,
					115.13,
					54.52,
					115.62,
					54.63,
					116.65,
					54.81,
					116.79,
					55.02,
					116.69,
					55.14,
					116.39,
					55.25,
					116.33,
					55.35,
					115.82,
					55.66,
					115.73,
					55.87,
					115.77,
					55.99,
					115.65,
					56.13,
					115.69,
					56.25,
					115.58,
					56.48,
					115.56,
					56.6,
					115.32,
					56.77,
					115.48,
					56.95,
					115.51,
					57.06,
					115.73,
					56.92,
					116.13,
					56.95,
					116.39,
					56.83,
					116.79,
					57.05,
					117.34,
					56.94,
					117.46,
					57.04,
					117.53,
					57.15,
					117.48,
					57.26,
					117.27,
					57.78,
					116.97,
					57.88,
					117.01,
					57.97,
					117.3,
					58.39,
					117.4,
					58.51,
					117.67,
					58.49,
					118.21,
					58.28,
					118.68,
					58.31,
					118.96,
					58.42,
					118.97,
					58.59,
					118.65,
					58.76,
					118.78,
					59.05,
					118.59,
					59.22,
					118.58,
					59.31,
					118.68,
					59.49,
					118.26,
					59.47,
					118.1,
					59.33,
					117.9,
					59.41,
					117.74,
					59.36,
					117.58,
					59.42,
					117.19,
					59.54,
					116.98,
					59.76,
					117.1,
					59.84,
					116.97,
					60.07,
					116.89,
					60.25,
					116.56,
					60.41,
					115.68,
					60.32,
					115.23,
					60.07,
					114.82,
					60.1,
					114.71,
					59.9,
					114.62,
					59.65,
					114.23,
					59.49,
					113.71,
					59.16,
					113.51,
					59.04,
					113.26,
					58.97,
					112.73,
					58.76,
					112.54,
					58.87,
					112.34,
					59.19,
					112.36,
					59.22,
					112.21,
					59.31,
					112.18,
					59.16,
					111.96,
					59.09,
					111.67,
					59.14,
					110.74,
					58.94,
					110.55,
					58.86,
					110.2,
					58.86,
					109.82,
					58.95,
					109.6,
					59.18,
					109.44,
					59.24,
					109.17,
					59.5,
					109.16,
					59.68,
					109.4,
					59.79,
					109.39,
					60.03,
					109.61,
					60.3,
					109.65,
					60.59,
					109.96,
					60.74,
					109.95,
					60.78,
					110.12,
					61.04,
					110.32,
					61.05,
					110.13,
					61.17,
					110.03,
					61.27,
					109.69,
					61.49,
					109.74,
					61.64,
					109.52,
					61.83,
					109.47,
					62.17,
					109.84,
					62.26,
					109.82,
					62.3,
					109.42,
					62.45,
					109.17,
					62.64,
					109.15,
					62.68,
					109.31,
					62.83,
					109.41,
					63.26,
					109.28,
					63.44,
					109.01,
					63.48,
					108.05,
					63.65,
					108,
					63.75,
					108.17,
					63.89,
					108.22,
					63.9,
					108.57,
					64.04,
					108.4,
					64.17,
					108.39,
					64.06,
					108,
					64.18,
					107.61,
					64.13,
					107.3,
					64.35,
					106.64,
					64.28,
					106.16,
					64.39,
					105.96,
					64.36,
					105.77,
					64.57,
					105.64
				]
			},
			{
				"points": [
					-26.98,
					153.3,
					-26.91,
					153.45,
					-26.98,
					153.54,
					-27.31,
					153.54,
					-27.4,
					153.65,
					-27.92,
					153.54,
					-28.23,
					153.64,
					-28.46,
					153.11,
					-28.41,
					152.49,
					-28.57,
					152.11,
					-28.69,
					152.18,
					-28.99,
					152.08,
					-29.08,
					151.82,
					-29.02,
					151.65,
					-29.28,
					151.41,
					-29.25,
					151.24,
					-29.02,
					151.17,
					-28.92,
					150.96,
					-28.82,
					150.92,
					-28.75,
					150.74,
					-28.77,
					150.4,
					-28.65,
					150.26,
					-28.74,
					149.71,
					-28.7,
					149.52,
					-29.11,
					148.96,
					-29.11,
					141,
					-29.01,
					140.9,
					-26.11,
					140.89,
					-26.1,
					137.98,
					-26.04,
					137.89,
					-16.49,
					137.89,
					-16.44,
					137.99,
					-16.64,
					138.35,
					-16.74,
					139.01,
					-16.4,
					139.21,
					-16.21,
					139.23,
					-16.22,
					139.35,
					-16.32,
					139.4,
					-16.28,
					139.58,
					-16.41,
					139.89,
					-16.68,
					139.99,
					-16.81,
					139.78,
					-16.72,
					139.71,
					-16.58,
					139.74,
					-16.8,
					139.51,
					-16.85,
					139.25,
					-16.95,
					139.37,
					-16.88,
					139.54,
					-17.03,
					139.74,
					-17.23,
					139.66,
					-17.24,
					139.43,
					-17.15,
					139.31,
					-17.24,
					139.32,
					-17.6,
					140.02,
					-17.57,
					140.36,
					-17.38,
					140.73,
					-16.94,
					140.86,
					-16.44,
					141.19,
					-16.06,
					141.31,
					-15.92,
					141.26,
					-15.62,
					141.32,
					-15.02,
					141.55,
					-14.51,
					141.41,
					-14.13,
					141.48,
					-13.84,
					141.36,
					-13.25,
					141.57,
					-12.95,
					141.48,
					-12.67,
					141.7,
					-12.64,
					141.53,
					-12.55,
					141.48,
					-11.93,
					141.75,
					-11.86,
					141.85,
					-11.35,
					142.01,
					-10.94,
					141.99,
					-10.84,
					142.15,
					-10.74,
					142,
					-10.49,
					142.11,
					-10.38,
					141.94,
					-9.84,
					142.13,
					-9.87,
					142.28,
					-9.99,
					142.29,
					-10.08,
					142.42,
					-10.09,
					142.6,
					-10.3,
					142.58,
					-10.47,
					142.41,
					-10.6,
					142.43,
					-10.48,
					142.59,
					-10.56,
					142.74,
					-10.8,
					142.69,
					-11.05,
					142.89,
					-11.38,
					142.97,
					-11.77,
					142.96,
					-11.92,
					143.36,
					-12.26,
					143.24,
					-12.17,
					143.42,
					-12.24,
					143.51,
					-12.35,
					143.51,
					-12.39,
					143.36,
					-12.56,
					143.55,
					-12.74,
					143.51,
					-12.81,
					143.65,
					-13.44,
					143.7,
					-13.74,
					143.64,
					-14.31,
					143.86,
					-14.35,
					143.99,
					-13.98,
					144.18,
					-13.94,
					144.27,
					-13.99,
					144.36,
					-14.14,
					144.38,
					-14.01,
					144.5,
					-14.04,
					144.61,
					-14.36,
					144.72,
					-14.31,
					144.82,
					-14.41,
					145.05,
					-14.65,
					145.04,
					-14.68,
					145.15,
					-14.54,
					145.26,
					-14.61,
					145.35,
					-14.54,
					145.48,
					-14.62,
					145.57,
					-14.88,
					145.58,
					-14.96,
					145.45,
					-15.3,
					145.46,
					-15.45,
					145.36,
					-16.05,
					145.58,
					-16.32,
					145.62,
					-16.42,
					145.52,
					-16.8,
					145.83,
					-16.79,
					145.99,
					-16.87,
					146.09,
					-17.04,
					146.01,
					-17.11,
					146.11,
					-17.24,
					146.08,
					-17.64,
					146.25,
					-18.07,
					146.23,
					-18.16,
					146.38,
					-18.43,
					146.46,
					-18.69,
					146.78,
					-18.87,
					146.7,
					-19.01,
					146.74,
					-19.08,
					147.06,
					-19.3,
					147.19,
					-19.21,
					147.46,
					-19.62,
					147.68,
					-19.62,
					147.89,
					-19.81,
					147.99,
					-19.86,
					148.26,
					-19.95,
					148.35,
					-19.87,
					148.43,
					-19.88,
					148.57,
					-20.11,
					148.76,
					-19.94,
					148.82,
					-19.97,
					149,
					-20.1,
					149.14,
					-20.67,
					149.29,
					-20.65,
					149.64,
					-20.89,
					149.73,
					-20.92,
					149.97,
					-21.05,
					150.01,
					-21.13,
					149.9,
					-21.09,
					149.73,
					-20.98,
					149.66,
					-21.05,
					149.4,
					-20.68,
					148.95,
					-20.72,
					148.88,
					-20.99,
					149.3,
					-21.41,
					149.39,
					-21.5,
					149.58,
					-21.66,
					149.56,
					-21.55,
					149.68,
					-21.36,
					149.55,
					-21.22,
					149.58,
					-21.2,
					149.69,
					-21.31,
					149.91,
					-21.49,
					150.01,
					-21.89,
					149.89,
					-22.04,
					150,
					-21.91,
					149.99,
					-21.81,
					150.09,
					-21.98,
					150.47,
					-22.11,
					150.43,
					-22.06,
					150.26,
					-22.14,
					150.19,
					-22.13,
					150.56,
					-21.87,
					150.6,
					-21.88,
					150.77,
					-22.13,
					150.77,
					-22.2,
					150.65,
					-22.41,
					150.84,
					-22.65,
					150.93,
					-22.95,
					150.89,
					-23.15,
					151.18,
					-23.3,
					151.04,
					-23.3,
					150.9,
					-23.39,
					150.93,
					-23.31,
					151.22,
					-23.91,
					151.49,
					-23.93,
					151.83,
					-24.51,
					152.19,
					-24.77,
					152.56,
					-25.14,
					152.73,
					-25.17,
					152.89,
					-24.97,
					153.09,
					-24.75,
					153.03,
					-24.6,
					153.26,
					-24.63,
					153.35,
					-25.01,
					153.47,
					-25.81,
					153.18,
					-25.93,
					153.3,
					-26.32,
					153.17,
					-26.98,
					153.3
				]
			},
			{
				"points": [
					-8.59,
					143.9,
					-8.65,
					143.73,
					-8.8,
					143.67,
					-8.8,
					143.54,
					-9.11,
					143.49,
					-9.3,
					143.17,
					-9.27,
					142.94,
					-9.42,
					142.89,
					-9.53,
					142.74,
					-9.53,
					142.49,
					-9.33,
					142.37,
					-9.4,
					142.22,
					-9.28,
					141.9,
					-9.32,
					141.6,
					-9.25,
					141.34,
					-9.33,
					141.11,
					-9.16,
					140.91,
					-6.96,
					140.91,
					-6.87,
					140.79,
					-6.6,
					140.73,
					-6.28,
					140.89,
					-2.6,
					140.89,
					-2.5,
					140.96,
					-2.57,
					141.35,
					-3.02,
					142.33,
					-3.01,
					142.49,
					-3.13,
					142.57,
					-3.25,
					143.15,
					-3.1,
					143.19,
					-3.11,
					143.33,
					-3.26,
					143.41,
					-3.2,
					143.51,
					-3.28,
					143.69,
					-3.43,
					143.69,
					-3.68,
					144.01,
					-3.7,
					144.52,
					-3.48,
					144.48,
					-3.46,
					144.16,
					-3.32,
					144,
					-3.19,
					143.94,
					-3.08,
					144.06,
					-3.31,
					144.31,
					-3.28,
					144.45,
					-3.41,
					144.52,
					-3.4,
					144.65,
					-3.54,
					144.71,
					-3.5,
					144.86,
					-3.62,
					144.93,
					-3.7,
					144.88,
					-3.73,
					144.78,
					-3.61,
					144.69,
					-3.72,
					144.58,
					-3.92,
					144.66,
					-3.99,
					144.84,
					-3.88,
					144.94,
					-3.94,
					145.1,
					-4.06,
					145.19,
					-4.24,
					145.08,
					-4.28,
					145.37,
					-4.66,
					145.77,
					-4.44,
					145.92,
					-4.41,
					146.02,
					-4.67,
					146.17,
					-4.74,
					146.35,
					-4.92,
					146.27,
					-4.9,
					146.16,
					-4.77,
					146.09,
					-4.85,
					145.91,
					-5.38,
					145.87,
					-5.49,
					146.47,
					-5.82,
					147.02,
					-5.82,
					147.38,
					-5.97,
					147.65,
					-6.25,
					147.89,
					-6.69,
					147.94,
					-6.84,
					147.61,
					-6.9,
					147.06,
					-6.96,
					147.16,
					-7.28,
					147.23,
					-7.34,
					147.41,
					-7.6,
					147.61,
					-7.63,
					147.71,
					-7.83,
					147.77,
					-8,
					148.22,
					-8.49,
					148.32,
					-8.61,
					148.52,
					-8.96,
					148.67,
					-8.92,
					149.35,
					-9.15,
					149.43,
					-9.41,
					149.31,
					-9.5,
					149.48,
					-9.53,
					150.06,
					-9.78,
					150.14,
					-9.88,
					149.89,
					-9.92,
					149.93,
					-10.15,
					150.67,
					-10.11,
					150.84,
					-9.8,
					150.68,
					-9.73,
					150.38,
					-9.27,
					149.99,
					-9.06,
					150.19,
					-9.22,
					150.61,
					-9.1,
					150.76,
					-9.12,
					150.94,
					-9.23,
					151.02,
					-9.35,
					150.96,
					-9.4,
					151.07,
					-9.56,
					151.13,
					-9.73,
					151.1,
					-9.84,
					151.35,
					-9.93,
					151.37,
					-10.28,
					151.28,
					-10.28,
					151.16,
					-10.41,
					151.05,
					-10.32,
					150.89,
					-10.41,
					150.73,
					-10.5,
					151.28,
					-10.32,
					151.32,
					-10.28,
					151.41,
					-10.33,
					151.51,
					-10.44,
					151.52,
					-10.5,
					151.43,
					-10.61,
					151.47,
					-10.86,
					151.34,
					-10.75,
					151.13,
					-10.82,
					150.73,
					-10.73,
					150.57,
					-10.87,
					150.39,
					-10.65,
					149.81,
					-10.46,
					149.71,
					-10.49,
					149.35,
					-10.35,
					149.09,
					-10.39,
					148.94,
					-10.27,
					148.64,
					-10.31,
					148.38,
					-10.21,
					148.2,
					-10.27,
					147.97,
					-10.18,
					147.81,
					-10.2,
					147.67,
					-9.61,
					147.23,
					-9.61,
					146.98,
					-9.19,
					146.78,
					-9.07,
					146.51,
					-8.76,
					146.42,
					-8.17,
					145.99,
					-8.05,
					145.72,
					-8.05,
					145.38,
					-7.95,
					145.26,
					-7.88,
					144.84,
					-7.74,
					144.69,
					-7.77,
					144.59,
					-7.91,
					144.52,
					-7.83,
					144.34,
					-7.9,
					144.27,
					-7.88,
					144.07,
					-8.07,
					144,
					-8.16,
					143.8,
					-8.31,
					143.76,
					-8.45,
					143.92,
					-8.59,
					143.9
				]
			},
			{
				"points": [
					-6.38,
					149.87,
					-6.39,
					149.57,
					-6.17,
					149.33,
					-6.28,
					149.07,
					-6.27,
					148.88,
					-6.18,
					148.81,
					-6.08,
					148.86,
					-5.79,
					148.25,
					-5.42,
					148.25,
					-5.33,
					148.4,
					-5.4,
					148.54,
					-5.34,
					148.98,
					-5.46,
					149.23,
					-5.33,
					149.64,
					-5.41,
					149.81,
					-5,
					149.91,
					-4.88,
					150.07,
					-5.04,
					150.29,
					-5.24,
					150.18,
					-5.42,
					150.19,
					-5.23,
					150.47,
					-5.41,
					150.61,
					-5.35,
					150.84,
					-5.02,
					151.06,
					-4.93,
					151,
					-4.83,
					151.05,
					-4.77,
					151.16,
					-4.84,
					151.56,
					-4.12,
					151.42,
					-4.08,
					151.9,
					-3.09,
					150.85,
					-3.09,
					150.67,
					-2.92,
					150.67,
					-2.84,
					150.59,
					-2.78,
					150.12,
					-2.43,
					149.83,
					-2.23,
					150.31,
					-3.06,
					151.96,
					-2.86,
					151.8,
					-2.69,
					151.8,
					-2.5,
					151.91,
					-2.5,
					152.03,
					-2.61,
					152.13,
					-2.95,
					152.18,
					-3.11,
					152.03,
					-3.93,
					153.03,
					-4.37,
					153.22,
					-4.75,
					153.09,
					-4.95,
					152.84,
					-4.61,
					152.46,
					-4.85,
					152.43,
					-5.04,
					152.29,
					-5.09,
					152.05,
					-5.31,
					152.23,
					-5.54,
					152.13,
					-5.69,
					151.81,
					-5.62,
					151.59,
					-5.76,
					151.57,
					-6.04,
					151.25,
					-6.12,
					150.85,
					-6.22,
					150.78,
					-6.4,
					150.35,
					-6.38,
					149.87
				]
			},
			{
				"points": [
					-6.98,
					155.74,
					-6.95,
					155.53,
					-6.72,
					155.18,
					-6,
					154.65,
					-5.11,
					154.4,
					-4.9,
					154.58,
					-4.93,
					154.69,
					-6.44,
					156,
					-6.75,
					156.06,
					-6.88,
					155.98,
					-6.98,
					155.74
				]
			},
			{
				"points": [
					-10.92,
					152.18,
					-10.77,
					152.07,
					-10.7,
					152.23,
					-10.56,
					152.31,
					-10.57,
					152.92,
					-10.73,
					152.94,
					-10.84,
					153.14,
					-10.96,
					153.08,
					-10.94,
					152.92,
					-11.05,
					152.93,
					-11,
					153.09,
					-11.22,
					153.34,
					-11.21,
					153.47,
					-11.53,
					153.86,
					-11.64,
					153.86,
					-11.75,
					153.5,
					-11.58,
					153.17,
					-11.37,
					153.09,
					-11.2,
					152.58,
					-11.2,
					152.23,
					-11.33,
					152.22,
					-11.35,
					152.07,
					-11.18,
					152.04,
					-11.17,
					152.21,
					-10.96,
					152.32,
					-11.01,
					152.71,
					-10.91,
					152.76,
					-10.9,
					152.87,
					-10.78,
					152.85,
					-10.79,
					152.6,
					-10.93,
					152.53,
					-10.86,
					152.31,
					-10.92,
					152.18
				]
			},
			{
				"points": [
					-2.68,
					147.3,
					-2.65,
					147.2,
					-2.54,
					147.15,
					-2.28,
					147.26,
					-2.33,
					146.93,
					-2.42,
					146.92,
					-2.48,
					146.8,
					-2.35,
					146.71,
					-2.35,
					146.52,
					-2.2,
					146.33,
					-2.02,
					146.31,
					-1.98,
					146.45,
					-1.84,
					146.58,
					-1.8,
					146.84,
					-1.9,
					147.47,
					-1.99,
					147.52,
					-1.93,
					147.83,
					-2.36,
					147.96,
					-2.48,
					147.71,
					-2.36,
					147.61,
					-2.36,
					147.49,
					-2.68,
					147.3
				]
			}
		],
		"transitions": [
			[
				0,
				600,
				[
					"ChST",
					"EST",
					"CHUT",
					"PGT",
					"YAKT"
				]
			]
		],
		"name": "Australia/Lindeman"
	},
	{
		"hoverRegion": [
			{
				"points": [
					48.75,
					-125.31,
					49.07,
					-126.11,
					49.32,
					-126.43,
					49.27,
					-126.58,
					49.47,
					-126.63,
					49.53,
					-126.89,
					49.9,
					-127.35,
					49.89,
					-127.47,
					50.02,
					-127.62,
					50.03,
					-127.99,
					50.14,
					-128.01,
					50.22,
					-127.93,
					50.23,
					-128.04,
					50.71,
					-128.5,
					50.69,
					-128.7,
					50.79,
					-128.82,
					50.94,
					-128.72,
					50.87,
					-128.48,
					51.05,
					-127.9,
					51.01,
					-127.76,
					51.09,
					-127.86,
					51.31,
					-127.9,
					51.4,
					-128.16,
					51.68,
					-128.24,
					51.84,
					-128.55,
					51.97,
					-128.58,
					52.06,
					-128.5,
					52.1,
					-128.6,
					52.2,
					-128.61,
					52.19,
					-128.74,
					52.4,
					-128.89,
					52.32,
					-129.02,
					52.6,
					-129.31,
					52.44,
					-129.32,
					52.42,
					-129.45,
					52.67,
					-129.53,
					52.87,
					-129.45,
					52.84,
					-129.65,
					53.05,
					-129.84,
					53.07,
					-130.02,
					53.41,
					-130.49,
					53.35,
					-130.58,
					53.41,
					-130.71,
					53.69,
					-130.62,
					53.76,
					-130.77,
					54.03,
					-130.81,
					54.1,
					-130.92,
					54.3,
					-130.85,
					54.37,
					-131.02,
					54.62,
					-131.2,
					54.73,
					-131.06,
					54.71,
					-130.72,
					54.82,
					-130.72,
					55.08,
					-130.27,
					55.3,
					-130.08,
					55.73,
					-130.25,
					55.97,
					-130.13,
					56.5,
					-131.6,
					56.51,
					-131.89,
					56.72,
					-131.97,
					56.83,
					-132.21,
					56.95,
					-132.2,
					57.02,
					-132.45,
					57.21,
					-132.39,
					58.23,
					-133.46,
					58.41,
					-133.55,
					58.63,
					-133.89,
					58.76,
					-134.29,
					59.03,
					-134.54,
					59.2,
					-135.03,
					59.39,
					-135.19,
					59.51,
					-135.17,
					59.68,
					-135.49,
					59.54,
					-136.11,
					59.38,
					-136.35,
					59.24,
					-136.35,
					59.06,
					-136.53,
					59.04,
					-136.79,
					58.8,
					-137.46,
					58.85,
					-137.61,
					59.16,
					-137.69,
					59.67,
					-138.67,
					59.81,
					-138.77,
					60,
					-139.25,
					60.23,
					-139.23,
					60.23,
					-139.64,
					60.07,
					-139.96,
					60.18,
					-140.41,
					60.11,
					-140.54,
					60.26,
					-141.09,
					69.71,
					-141.07,
					69.64,
					-139.38,
					69.73,
					-139.18,
					69.73,
					-138.95,
					69.63,
					-138.76,
					69.47,
					-138.8,
					69.36,
					-138.55,
					69.39,
					-138.34,
					69.27,
					-138.15,
					69.07,
					-137.33,
					68.99,
					-136.39,
					68.9,
					-136.33,
					67.73,
					-136.31,
					67.62,
					-136.08,
					67.45,
					-136.08,
					67.3,
					-135.97,
					67.11,
					-136.07,
					67.08,
					-133.73,
					66.75,
					-133.66,
					66.59,
					-133.45,
					66.37,
					-133.51,
					66.29,
					-133.44,
					66.08,
					-133.46,
					66.13,
					-132.95,
					66.07,
					-132.8,
					66.13,
					-132.59,
					66.05,
					-132.22,
					65.94,
					-132.22,
					65.85,
					-132.35,
					65.58,
					-132.04,
					65.26,
					-132.45,
					65.1,
					-132.21,
					64.88,
					-132.36,
					64.62,
					-131.63,
					64.49,
					-131.59,
					64.56,
					-131.39,
					64.52,
					-131.13,
					64.04,
					-130.64,
					63.93,
					-130.33,
					63.94,
					-130.07,
					63.68,
					-129.99,
					63.48,
					-129.69,
					63.27,
					-129.84,
					63.11,
					-129.52,
					62.86,
					-129.59,
					62.64,
					-129.41,
					62.54,
					-129.09,
					62.22,
					-129.08,
					62.16,
					-128.8,
					62.22,
					-128.53,
					61.71,
					-127.77,
					61.55,
					-127.08,
					60.87,
					-126.76,
					60.88,
					-126.33,
					60.97,
					-126.11,
					60.92,
					-126.01,
					61,
					-125.9,
					60.89,
					-125.31,
					60.95,
					-124.94,
					61.07,
					-124.84,
					61.06,
					-124.59,
					60.8,
					-124.38,
					60.67,
					-124.46,
					60.57,
					-124.37,
					60.51,
					-124.13,
					60.1,
					-123.89,
					60.07,
					-119.92,
					57.16,
					-119.92,
					57.08,
					-120.15,
					57.12,
					-120.41,
					57.34,
					-120.48,
					57.29,
					-120.88,
					57.1,
					-121.31,
					57.12,
					-121.64,
					56.84,
					-121.89,
					57.03,
					-123.06,
					56.82,
					-123.69,
					56.52,
					-123.44,
					56.37,
					-123.48,
					55.95,
					-123.35,
					55.82,
					-123.08,
					55.69,
					-123,
					55.68,
					-122.88,
					55.49,
					-122.86,
					55.5,
					-122.53,
					54.95,
					-121.74,
					54.9,
					-121.49,
					54.64,
					-121.33,
					54.59,
					-120.76,
					54.23,
					-120.45,
					54.19,
					-120.08,
					53.88,
					-119.94,
					53.72,
					-119.64,
					53.49,
					-119.66,
					53.45,
					-119.34,
					53.26,
					-119.11,
					53.32,
					-118.87,
					53.18,
					-118.63,
					52.98,
					-118.52,
					52.91,
					-118.3,
					52.53,
					-118.09,
					52.36,
					-118.11,
					52.18,
					-118.49,
					51.97,
					-118.03,
					51.83,
					-118.03,
					51.69,
					-117.81,
					51.57,
					-117.82,
					51.57,
					-117.42,
					51.42,
					-117.14,
					51.07,
					-117.08,
					50.69,
					-116.47,
					50.5,
					-116.55,
					50.19,
					-116.34,
					49.96,
					-116.32,
					49.7,
					-116.63,
					49.69,
					-116.78,
					49.25,
					-116.57,
					49.11,
					-116.81,
					49.08,
					-115.98,
					48.02,
					-115.93,
					47.77,
					-115.65,
					47.45,
					-115.52,
					47.33,
					-115.24,
					46.81,
					-114.72,
					46.75,
					-114.3,
					46.67,
					-114.21,
					46.09,
					-114.37,
					45.85,
					-114.27,
					45.29,
					-114.68,
					45.44,
					-115.19,
					45.27,
					-115.49,
					45.35,
					-115.81,
					45.31,
					-116.34,
					45.48,
					-116.41,
					44.98,
					-116.73,
					44.8,
					-116.77,
					44.44,
					-117.1,
					44.22,
					-117.14,
					44.19,
					-117.47,
					44.33,
					-117.64,
					44.33,
					-117.92,
					44.17,
					-118.12,
					42.55,
					-118.1,
					42.55,
					-116.98,
					42.1,
					-116.92,
					42.09,
					-114.03,
					42.03,
					-113.93,
					36.19,
					-113.93,
					35.91,
					-114.17,
					36.03,
					-114.42,
					36,
					-114.62,
					35.2,
					-114.46,
					34.92,
					-114.52,
					34.24,
					-114.02,
					33.91,
					-114.41,
					33.51,
					-114.42,
					33.35,
					-114.6,
					33.15,
					-114.59,
					33.02,
					-114.37,
					32.94,
					-114.36,
					32.68,
					-114.44,
					32.64,
					-114.63,
					32.4,
					-114.76,
					31.59,
					-116.49,
					31.61,
					-116.74,
					31.74,
					-116.89,
					32.31,
					-117.16,
					32.28,
					-117.26,
					32.38,
					-117.39,
					32.51,
					-117.37,
					32.53,
					-117.24,
					32.6,
					-117.33,
					33.05,
					-117.42,
					33.23,
					-117.56,
					33.63,
					-118.15,
					33.64,
					-118.45,
					33.9,
					-118.58,
					33.89,
					-118.83,
					34.05,
					-119.25,
					33.89,
					-119.37,
					33.85,
					-119.77,
					33.92,
					-119.9,
					33.78,
					-120.11,
					33.91,
					-120.3,
					33.93,
					-120.5,
					34.09,
					-120.54,
					34.18,
					-120.37,
					34.11,
					-120.23,
					34.18,
					-119.9,
					34.12,
					-119.34,
					34.3,
					-119.59,
					34.33,
					-120.45,
					34.5,
					-120.73,
					35.06,
					-120.75,
					35.15,
					-120.95,
					35.36,
					-120.99,
					35.57,
					-121.34,
					35.92,
					-121.58,
					36.24,
					-121.99,
					36.59,
					-122.08,
					36.79,
					-121.91,
					36.87,
					-122.19,
					37.13,
					-122.49,
					37.5,
					-122.62,
					37.75,
					-122.59,
					37.9,
					-122.88,
					37.9,
					-123.08,
					38.22,
					-123.09,
					38.86,
					-123.82,
					39.76,
					-123.94,
					40.17,
					-124.43,
					40.41,
					-124.51,
					40.92,
					-124.25,
					41.16,
					-124.26,
					41.43,
					-124.17,
					41.64,
					-124.23,
					41.75,
					-124.36,
					41.96,
					-124.32,
					42.22,
					-124.51,
					42.58,
					-124.51,
					42.84,
					-124.67,
					43.86,
					-124.26,
					45.27,
					-124.06,
					46.03,
					-124.05,
					46.22,
					-124.18,
					46.64,
					-124.16,
					47.17,
					-124.3,
					47.66,
					-124.51,
					47.82,
					-124.71,
					48.13,
					-124.83,
					48.4,
					-124.83,
					48.49,
					-124.69,
					48.62,
					-125.13,
					48.75,
					-125.31
				]
			},
			{
				"points": [
					51.98,
					-131.21,
					52.72,
					-132.31,
					52.94,
					-132.46,
					52.99,
					-132.64,
					53.13,
					-132.68,
					53.19,
					-132.8,
					53.38,
					-132.84,
					53.48,
					-133.1,
					53.64,
					-133.07,
					53.94,
					-133.29,
					54.08,
					-133.16,
					54.32,
					-133.14,
					54.35,
					-132.93,
					54.25,
					-132.84,
					54.25,
					-132.6,
					54.16,
					-132.51,
					54.22,
					-132.3,
					54.13,
					-132.16,
					54.18,
					-131.81,
					54.27,
					-131.65,
					54.23,
					-131.55,
					53.95,
					-131.59,
					53.72,
					-131.77,
					53.36,
					-131.81,
					53.17,
					-131.55,
					52.68,
					-131.33,
					52.11,
					-130.82,
					51.83,
					-130.98,
					51.98,
					-131.21
				]
			},
			{
				"points": [
					33.32,
					-118.22,
					33.19,
					-118.29,
					33.23,
					-118.51,
					33.41,
					-118.68,
					33.53,
					-118.69,
					33.58,
					-118.58,
					33.5,
					-118.3,
					33.32,
					-118.22
				]
			},
			{
				"points": [
					32.69,
					-118.38,
					32.79,
					-118.58,
					33.02,
					-118.7,
					33.12,
					-118.65,
					33.11,
					-118.54,
					32.86,
					-118.24,
					32.75,
					-118.26,
					32.69,
					-118.38
				]
			}
		],
		"transitions": [
			[
				1320588000,
				-480,
				[
					"PST"
				]
			],
			[
				1331474400,
				-420,
				[
					"PDT"
				]
			],
			[
				1352037600,
				-480,
				[
					"PST"
				]
			],
			[
				1362924000,
				-420,
				[
					"PDT"
				]
			],
			[
				1383487200,
				-480,
				[
					"PST"
				]
			],
			[
				1394373600,
				-420,
				[
					"PDT"
				]
			],
			[
				1414936800,
				-480,
				[
					"PST"
				]
			],
			[
				1425823200,
				-420,
				[
					"PDT"
				]
			],
			[
				1446386400,
				-480,
				[
					"PST"
				]
			],
			[
				1457877600,
				-420,
				[
					"PDT"
				]
			],
			[
				1478440800,
				-480,
				[
					"PST"
				]
			],
			[
				1489327200,
				-420,
				[
					"PDT"
				]
			],
			[
				1509890400,
				-480,
				[
					"PST"
				]
			],
			[
				1520776800,
				-420,
				[
					"PDT"
				]
			],
			[
				1541340000,
				-480,
				[
					"PST"
				]
			],
			[
				1552226400,
				-420,
				[
					"PDT"
				]
			],
			[
				1572789600,
				-480,
				[
					"PST"
				]
			],
			[
				1583676000,
				-420,
				[
					"PDT"
				]
			],
			[
				1604239200,
				-480,
				[
					"PST"
				]
			],
			[
				1615730400,
				-420,
				[
					"PDT"
				]
			],
			[
				1636293600,
				-480,
				[
					"PST"
				]
			],
			[
				1647180000,
				-420,
				[
					"PDT"
				]
			],
			[
				1667743200,
				-480,
				[
					"PST"
				]
			],
			[
				1678629600,
				-420,
				[
					"PDT"
				]
			],
			[
				1699192800,
				-480,
				[
					"PST"
				]
			],
			[
				1710079200,
				-420,
				[
					"PDT"
				]
			],
			[
				1730642400,
				-480,
				[
					"PST"
				]
			],
			[
				1741528800,
				-420,
				[
					"PDT"
				]
			],
			[
				1762092000,
				-480,
				[
					"PST"
				]
			],
			[
				1772978400,
				-420,
				[
					"PDT"
				]
			],
			[
				1793541600,
				-480,
				[
					"PST"
				]
			],
			[
				1805032800,
				-420,
				[
					"PDT"
				]
			],
			[
				1825596000,
				-480,
				[
					"PST"
				]
			],
			[
				1836482400,
				-420,
				[
					"PDT"
				]
			],
			[
				1857045600,
				-480,
				[
					"PST"
				]
			],
			[
				1867932000,
				-420,
				[
					"PDT"
				]
			],
			[
				1888495200,
				-480,
				[
					"PST"
				]
			],
			[
				1899381600,
				-420,
				[
					"PDT"
				]
			],
			[
				1919944800,
				-480,
				[
					"PST"
				]
			],
			[
				1930831200,
				-420,
				[
					"PDT"
				]
			],
			[
				1951394400,
				-480,
				[
					"PST"
				]
			],
			[
				1962885600,
				-420,
				[
					"PDT"
				]
			],
			[
				1983448800,
				-480,
				[
					"PST"
				]
			],
			[
				1994335200,
				-420,
				[
					"PDT"
				]
			],
			[
				2014898400,
				-480,
				[
					"PST"
				]
			],
			[
				2025784800,
				-420,
				[
					"PDT"
				]
			],
			[
				2046348000,
				-480,
				[
					"PST"
				]
			],
			[
				2057234400,
				-420,
				[
					"PDT"
				]
			],
			[
				2077797600,
				-480,
				[
					"PST"
				]
			],
			[
				2088684000,
				-420,
				[
					"PDT"
				]
			],
			[
				2109247200,
				-480,
				[
					"PST"
				]
			],
			[
				2120133600,
				-420,
				[
					"PDT"
				]
			],
			[
				2140696800,
				-480,
				[
					"PST"
				]
			]
		],
		"name": "America/Vancouver"
	},
	{
		"hoverRegion": [
			{
				"points": [
					56.39,
					12.44,
					56.53,
					12.48,
					56.56,
					12.64,
					56.73,
					12.52,
					56.85,
					12.26,
					57.25,
					12,
					57.27,
					11.85,
					57.45,
					11.8,
					57.61,
					11.53,
					57.9,
					11.45,
					58.08,
					11.24,
					58.24,
					11.27,
					58.29,
					11.11,
					58.62,
					11.13,
					59.11,
					10.65,
					58.95,
					10.54,
					58.85,
					9.86,
					58.89,
					9.76,
					58.77,
					9.66,
					58.74,
					9.5,
					58.02,
					8.29,
					57.87,
					7.57,
					57.95,
					6.61,
					58.06,
					6.46,
					58.15,
					6.46,
					58.33,
					5.8,
					58.59,
					5.47,
					58.73,
					5.38,
					58.95,
					5.39,
					59.12,
					5.07,
					59.33,
					5.04,
					59.36,
					5,
					59.19,
					4.92,
					59.25,
					4.76,
					59.38,
					4.78,
					59.4,
					4.97,
					59.55,
					5.07,
					60.4,
					4.83,
					60.75,
					4.59,
					60.88,
					4.67,
					61.04,
					4.54,
					61.36,
					4.57,
					61.44,
					4.77,
					61.53,
					4.64,
					61.9,
					4.72,
					61.98,
					4.89,
					62.29,
					5.06,
					62.29,
					5.25,
					62.52,
					5.56,
					62.43,
					5.76,
					62.78,
					6.12,
					62.93,
					6.55,
					62.89,
					6.69,
					63.09,
					7.05,
					63.09,
					7.29,
					63.23,
					7.75,
					63.39,
					7.69,
					63.5,
					7.73,
					63.57,
					8.17,
					63.72,
					8.21,
					63.86,
					8.53,
					63.95,
					8.58,
					63.97,
					8.71,
					63.72,
					9.25,
					63.92,
					9.36,
					63.94,
					9.64,
					64.27,
					9.94,
					64.29,
					10.16,
					64.65,
					10.63,
					64.71,
					11.01,
					64.78,
					10.58,
					64.88,
					10.56,
					65.08,
					10.72,
					65.13,
					11.11,
					65.03,
					11.38,
					65.2,
					11.52,
					65.22,
					11.87,
					65.48,
					11.92,
					65.54,
					11.68,
					65.69,
					11.6,
					65.77,
					11.67,
					65.81,
					11.92,
					66.12,
					11.93,
					66.18,
					12.08,
					66.14,
					12.15,
					66.42,
					12.21,
					66.52,
					12.38,
					66.48,
					12.55,
					66.6,
					12.5,
					66.69,
					12.56,
					66.7,
					12.8,
					67.26,
					13.81,
					67.39,
					13.75,
					67.5,
					13.8,
					67.53,
					14.03,
					67.37,
					14.08,
					67.29,
					14.16,
					67.41,
					14.14,
					67.53,
					14.3,
					67.52,
					14.54,
					67.75,
					14.46,
					67.89,
					14.58,
					68.23,
					15.41,
					68.18,
					14.93,
					68.05,
					14.68,
					68.11,
					14.57,
					68.06,
					14.2,
					68.13,
					14.11,
					67.97,
					13.74,
					68.02,
					13.6,
					67.73,
					12.87,
					67.56,
					12.79,
					67.52,
					12.61,
					67.59,
					12.48,
					67.71,
					12.46,
					67.78,
					12.63,
					68.21,
					13.02,
					68.25,
					13.42,
					68.4,
					13.55,
					68.46,
					13.96,
					68.4,
					14.28,
					68.51,
					14.5,
					68.48,
					14.28,
					68.63,
					14.19,
					68.87,
					14.38,
					68.94,
					14.73,
					69.1,
					14.97,
					69.13,
					15.17,
					69.02,
					15.34,
					69.34,
					15.78,
					69.43,
					16.14,
					69.23,
					16.28,
					68.96,
					16.04,
					68.95,
					16.14,
					69.05,
					16.19,
					69.19,
					16.48,
					69.11,
					16.68,
					69.47,
					16.8,
					69.7,
					17.44,
					69.66,
					17.75,
					69.87,
					18.07,
					69.94,
					18.4,
					70.12,
					18.37,
					70.2,
					18.43,
					70.15,
					18.61,
					70.3,
					18.82,
					70.26,
					18.97,
					70.37,
					19.19,
					70.25,
					19.34,
					70.4,
					19.75,
					70.24,
					20.06,
					70.36,
					20.07,
					70.42,
					20.16,
					70.29,
					20.39,
					70.32,
					20.8,
					70.08,
					21.13,
					70.25,
					21.07,
					70.5,
					21.42,
					70.42,
					21.59,
					70.49,
					21.67,
					70.44,
					21.97,
					70.62,
					21.82,
					70.75,
					21.9,
					70.96,
					23.04,
					70.98,
					23.31,
					70.88,
					23.57,
					71,
					23.6,
					71.02,
					23.74,
					71.18,
					23.93,
					71.18,
					24.18,
					70.99,
					24.32,
					71.16,
					24.57,
					71.2,
					24.87,
					71.06,
					25.15,
					71.24,
					25.26,
					71.27,
					25.83,
					71.22,
					26.08,
					71.04,
					26.32,
					70.94,
					26.27,
					70.89,
					26.01,
					70.76,
					25.97,
					71.04,
					26.51,
					71.05,
					26.72,
					70.83,
					26.84,
					70.66,
					26.74,
					70.61,
					26.79,
					70.7,
					26.87,
					70.68,
					26.98,
					71.04,
					27.05,
					71.14,
					27.22,
					71.12,
					27.38,
					71.24,
					27.65,
					71.14,
					27.84,
					71.2,
					28.22,
					71.08,
					28.37,
					71.04,
					28.63,
					70.92,
					28.64,
					70.85,
					28.55,
					70.98,
					28.97,
					70.81,
					29.48,
					70.78,
					30.2,
					70.64,
					30.4,
					70.65,
					30.64,
					70.54,
					30.76,
					70.47,
					31.21,
					70.36,
					31.23,
					70.18,
					31.1,
					70.13,
					30.55,
					69.98,
					30.23,
					69.88,
					30.88,
					69.73,
					31.03,
					69.5,
					31.02,
					69.43,
					30.8,
					69.52,
					30.29,
					69.35,
					30.13,
					69.2,
					29.39,
					69.04,
					29.34,
					68.9,
					29.03,
					69.03,
					28.75,
					69.14,
					28.69,
					69.32,
					28.77,
					69.51,
					29.15,
					69.59,
					29.07,
					69.71,
					28.4,
					69.98,
					27.94,
					69.8,
					27.03,
					69.82,
					26.49,
					69.64,
					26.08,
					69.24,
					25.83,
					68.93,
					25.85,
					68.78,
					25.64,
					68.7,
					25.23,
					68.56,
					25.19,
					68.44,
					24.91,
					68.72,
					23.95,
					68.52,
					23.18,
					68.61,
					22.36,
					68.87,
					22.1,
					69.16,
					21.6,
					69.16,
					21.21,
					69.06,
					21.22,
					68.94,
					21.09,
					68.58,
					22.06,
					68.48,
					22.87,
					68.03,
					23.74,
					67.91,
					23.74,
					67.8,
					23.6,
					67.56,
					23.64,
					67.51,
					23.84,
					67.3,
					23.91,
					67.18,
					23.72,
					66.83,
					24.12,
					66.49,
					23.96,
					66.36,
					23.76,
					66.21,
					24.02,
					65.86,
					24.24,
					65.59,
					24.21,
					65.49,
					24.04,
					65.58,
					23.92,
					65.45,
					23.74,
					65.51,
					23.64,
					65.64,
					23.63,
					65.64,
					23.39,
					65.54,
					22.91,
					65.42,
					22.86,
					65.26,
					22.47,
					65.31,
					22.12,
					65.08,
					22,
					65.1,
					21.83,
					64.87,
					21.39,
					64.69,
					21.4,
					64.55,
					21.68,
					64.38,
					21.71,
					64.06,
					21.05,
					63.91,
					20.99,
					63.76,
					21.1,
					63.51,
					20.86,
					63.49,
					20.72,
					63.63,
					20.65,
					63.64,
					20.52,
					63.56,
					20.41,
					63.55,
					20.06,
					63.37,
					19.92,
					63.33,
					19.37,
					63.17,
					19.23,
					63.1,
					18.96,
					62.79,
					18.56,
					62.71,
					18.28,
					62.5,
					18.13,
					62.41,
					17.84,
					62.17,
					17.85,
					62.09,
					17.67,
					61.87,
					17.61,
					61.83,
					17.5,
					61.77,
					17.66,
					61.48,
					17.56,
					61.44,
					17.33,
					61.18,
					17.44,
					60.98,
					17.36,
					60.64,
					17.77,
					60.71,
					18,
					60.49,
					18.26,
					60.6,
					18.3,
					60.62,
					18.46,
					60.26,
					18.85,
					60.02,
					19,
					59.94,
					19.22,
					59.64,
					19.31,
					59.46,
					19.08,
					59.22,
					19.06,
					58.93,
					18.64,
					58.75,
					18.15,
					58.78,
					18.04,
					58.63,
					17.88,
					58.72,
					17.6,
					58.58,
					17.54,
					58.67,
					17.38,
					58.53,
					17.1,
					58.36,
					17.07,
					58.24,
					17.13,
					58.06,
					16.91,
					57.4,
					16.83,
					57.25,
					16.63,
					57.15,
					16.73,
					57.37,
					16.89,
					57.46,
					17.14,
					57.38,
					17.23,
					57.14,
					17.18,
					56.09,
					16.46,
					56.13,
					16.32,
					56.43,
					16.28,
					56.17,
					16.13,
					55.9,
					15.8,
					55.99,
					15.68,
					56.05,
					15.25,
					56.05,
					15.07,
					55.89,
					14.86,
					55.91,
					14.51,
					55.75,
					14.32,
					55.51,
					14.46,
					55.27,
					14.2,
					55.32,
					13.88,
					55.22,
					13.34,
					55.26,
					12.8,
					55.34,
					12.71,
					55.5,
					12.77,
					55.46,
					12.45,
					55.27,
					12.56,
					55.14,
					12.35,
					55.02,
					12.63,
					54.89,
					12.64,
					54.78,
					12.21,
					54.45,
					12,
					54.55,
					11.82,
					54.48,
					11.51,
					54.53,
					11.34,
					54.36,
					11.41,
					54.29,
					11.22,
					54.12,
					11.17,
					54.07,
					11.31,
					54.25,
					11.65,
					54.28,
					12.08,
					54.58,
					12.48,
					54.57,
					12.97,
					54.68,
					13.05,
					54.79,
					13.43,
					54.68,
					13.53,
					54.65,
					13.74,
					54.49,
					13.73,
					54.34,
					13.87,
					54.32,
					14.01,
					54.18,
					14.01,
					54.03,
					14.25,
					54.38,
					16.08,
					54.64,
					16.49,
					54.84,
					17.25,
					54.94,
					18.3,
					54.69,
					18.9,
					54.53,
					18.87,
					54.57,
					18.65,
					54.48,
					18.74,
					54.46,
					19.21,
					54.55,
					19.68,
					54.43,
					21.47,
					54.46,
					22.73,
					54.53,
					22.87,
					54.22,
					23.57,
					53.64,
					23.71,
					53.19,
					24.02,
					52.66,
					24.03,
					52.56,
					23.95,
					52.47,
					23.5,
					52.32,
					23.36,
					52.17,
					23.7,
					52.04,
					23.79,
					51.64,
					23.65,
					51.45,
					23.8,
					51.32,
					23.78,
					50.91,
					24.24,
					50.8,
					24.23,
					50.75,
					24.12,
					50.56,
					24.2,
					50.35,
					24.09,
					50.28,
					23.76,
					49.51,
					22.79,
					49.25,
					22.83,
					49.12,
					22.99,
					48.94,
					22.97,
					48.95,
					22.62,
					48.64,
					22.45,
					48.52,
					22.27,
					48.21,
					22.69,
					48.19,
					22.91,
					47.91,
					23,
					47.68,
					22.72,
					47.65,
					22.37,
					47.47,
					22.14,
					47.34,
					22.12,
					47,
					21.78,
					46.65,
					21.62,
					46.54,
					21.42,
					46.35,
					21.39,
					46.15,
					21.13,
					46.16,
					20.87,
					46.03,
					20.67,
					46.06,
					20.47,
					45.86,
					20.73,
					45.84,
					20.9,
					45.55,
					20.89,
					45.24,
					21.59,
					45.14,
					21.61,
					45.03,
					21.53,
					44.93,
					21.65,
					44.76,
					21.7,
					44.73,
					22.03,
					44.62,
					22.14,
					44.82,
					22.47,
					44.61,
					22.84,
					44.46,
					22.83,
					44.4,
					22.67,
					44.25,
					22.79,
					44.02,
					22.72,
					43.91,
					22.5,
					43.82,
					22.47,
					43.54,
					22.61,
					43.2,
					23.11,
					42.81,
					22.83,
					42.74,
					22.6,
					42.6,
					22.56,
					42.48,
					22.66,
					42.28,
					22.54,
					42.1,
					22.93,
					41.73,
					23.14,
					41.59,
					23.06,
					41.31,
					23.06,
					41.22,
					22.85,
					41.06,
					22.79,
					41.04,
					22.09,
					40.75,
					21.61,
					40.78,
					21.12,
					40.55,
					21.14,
					40.38,
					21.01,
					40.33,
					20.87,
					40.01,
					20.75,
					39.92,
					20.47,
					39.74,
					20.5,
					39.54,
					20.25,
					39.59,
					19.92,
					39.96,
					19.77,
					40.14,
					19.4,
					40.48,
					19.17,
					41.25,
					19.39,
					41.42,
					19.29,
					41.65,
					19.37,
					41.71,
					19.49,
					41.85,
					19.11,
					42.03,
					19,
					42.16,
					18.8,
					42.62,
					17.83,
					42.58,
					17.72,
					42.65,
					17.36,
					42.8,
					17.21,
					42.8,
					17.04,
					42.62,
					16.93,
					42.7,
					16.61,
					42.64,
					16.46,
					42.77,
					16.39,
					42.86,
					16.44,
					42.87,
					16.55,
					43.04,
					16.54,
					43.05,
					16.36,
					42.92,
					16.27,
					42.87,
					15.93,
					42.98,
					15.88,
					43.15,
					16.01,
					43.17,
					16.23,
					43.25,
					16.28,
					43.41,
					15.9,
					43.58,
					15.81,
					43.52,
					15.7,
					43.68,
					15.24,
					44.38,
					14.44,
					44.43,
					14.2,
					44.61,
					14.11,
					44.87,
					14.2,
					44.66,
					13.93,
					44.69,
					13.82,
					45.03,
					13.52,
					45.56,
					13.41,
					45.6,
					13.25,
					45.34,
					12.48,
					45.18,
					12.42,
					44.97,
					12.65,
					44.72,
					12.48,
					44.69,
					12.36,
					44.29,
					12.48,
					44.08,
					12.74,
					43.62,
					13.7,
					42.75,
					14.09,
					42.34,
					14.57,
					42.03,
					15.19,
					42.02,
					15.4,
					42.18,
					15.38,
					42.25,
					15.51,
					42.15,
					15.63,
					42.02,
					15.56,
					42.01,
					16.19,
					41.73,
					16.29,
					41.54,
					16.04,
					40.74,
					18.05,
					40.37,
					18.49,
					40.13,
					18.61,
					39.73,
					18.43,
					39.67,
					18.34,
					39.85,
					17.96,
					40.17,
					17.78,
					40.19,
					17.46,
					40.36,
					16.99,
					40.05,
					16.72,
					39.93,
					16.74,
					39.76,
					16.61,
					39.46,
					17.24,
					39.14,
					17.23,
					38.98,
					17.31,
					38.79,
					17.15,
					38.81,
					16.9,
					38.72,
					16.68,
					38.35,
					16.66,
					38.2,
					16.39,
					37.82,
					16.11,
					37.82,
					15.69,
					37.96,
					15.54,
					37.46,
					15.2,
					37.27,
					15.36,
					36.98,
					15.44,
					36.84,
					15.25,
					36.55,
					15.14,
					36.68,
					14.46,
					36.94,
					14.22,
					37.05,
					13.69,
					37.38,
					13.13,
					37.46,
					12.61,
					37.8,
					12.31,
					37.88,
					12.17,
					37.86,
					11.99,
					38,
					11.92,
					38.1,
					12.06,
					38,
					12.18,
					38.12,
					12.29,
					38.09,
					12.41,
					38.3,
					12.71,
					38.15,
					12.93,
					38.28,
					13.04,
					38.33,
					13.29,
					38.08,
					13.77,
					38.15,
					14.47,
					38.3,
					14.89,
					38.52,
					14.69,
					38.64,
					14.71,
					38.65,
					14.94,
					38.91,
					15.19,
					38.86,
					15.33,
					38.76,
					15.34,
					38.51,
					15.08,
					38.26,
					15.03,
					38.38,
					15.22,
					38.36,
					15.7,
					38.52,
					15.8,
					38.69,
					15.74,
					38.87,
					16.09,
					39.92,
					15.6,
					39.89,
					15.3,
					40.15,
					14.84,
					40.25,
					14.79,
					40.39,
					14.86,
					40.54,
					14.74,
					40.43,
					14.18,
					40.58,
					14.09,
					40.72,
					14.26,
					40.61,
					13.83,
					40.79,
					13.75,
					40.88,
					13.9,
					41.12,
					13.67,
					41.18,
					13.27,
					41.12,
					12.99,
					41.27,
					12.87,
					41.35,
					12.55,
					41.65,
					12.15,
					41.83,
					12.05,
					41.96,
					11.75,
					42.2,
					11.56,
					42.28,
					11.21,
					42.12,
					11.11,
					42.23,
					10.98,
					42.22,
					10.86,
					42.33,
					10.75,
					42.45,
					10.78,
					42.5,
					10.88,
					42.43,
					11,
					42.5,
					11.05,
					42.71,
					10.68,
					42.82,
					10.62,
					42.83,
					10.51,
					42.61,
					10.46,
					42.62,
					10.2,
					42.48,
					10.15,
					42.49,
					9.98,
					42.84,
					10,
					42.98,
					10.38,
					43.23,
					10.4,
					43.51,
					10.19,
					43.82,
					10.13,
					44.23,
					9.23,
					44.31,
					8.77,
					44.23,
					8.56,
					43.79,
					8.12,
					43.68,
					7.56,
					43.32,
					6.79,
					43.09,
					6.71,
					42.89,
					6.41,
					42.88,
					6.17,
					43.1,
					5.32,
					43.24,
					5.19,
					43.28,
					4.93,
					43.23,
					4.8,
					43.44,
					4.05,
					43.05,
					3.19,
					42.6,
					3.14,
					42.32,
					3.42,
					42.14,
					3.28,
					41.79,
					3.25,
					41.37,
					2.33,
					41.2,
					2.17,
					40.93,
					1.03,
					40.81,
					0.89,
					40.65,
					0.97,
					40.47,
					0.72,
					40.47,
					0.6,
					39.96,
					0.13,
					39.41,
					-0.2,
					39.04,
					-0.04,
					38.81,
					0.29,
					38.67,
					0.32,
					38.26,
					-0.4,
					38.1,
					-0.37,
					38.06,
					-0.54,
					37.84,
					-0.64,
					37.53,
					-0.63,
					37.45,
					-1.28,
					37.27,
					-1.59,
					36.88,
					-1.8,
					36.63,
					-2.08,
					36.73,
					-2.37,
					36.58,
					-2.7,
					36.64,
					-2.94,
					36.61,
					-4.35,
					36.4,
					-4.61,
					36.31,
					-5.11,
					36.01,
					-5.29,
					35.97,
					-5.19,
					35.86,
					-5.18,
					35.76,
					-5.34,
					35.93,
					-5.49,
					35.89,
					-5.64,
					36.11,
					-6.11,
					36.59,
					-6.49,
					36.89,
					-6.59,
					37.09,
					-7.06,
					37.1,
					-7.47,
					37.56,
					-7.62,
					38.04,
					-7.34,
					38.1,
					-7.17,
					38.43,
					-7.44,
					38.78,
					-7.34,
					39.01,
					-7.09,
					39.12,
					-7.3,
					39.69,
					-7.62,
					39.75,
					-7.53,
					39.78,
					-7.08,
					39.99,
					-6.99,
					40.21,
					-7.12,
					40.38,
					-6.93,
					40.82,
					-6.91,
					41.05,
					-7.03,
					41.53,
					-6.38,
					41.6,
					-6.62,
					41.85,
					-6.65,
					41.87,
					-6.78,
					41.87,
					-7.08,
					41.78,
					-7.15,
					41.7,
					-7.42,
					41.79,
					-7.69,
					41.7,
					-8.13,
					41.87,
					-8.31,
					42.01,
					-8.27,
					41.77,
					-8.93,
					42.27,
					-9,
					42.55,
					-9.18,
					42.65,
					-9.15,
					42.8,
					-9.21,
					42.88,
					-9.39,
					43.12,
					-9.36,
					43.37,
					-9.03,
					43.47,
					-8.44,
					43.66,
					-8.36,
					43.86,
					-7.93,
					43.83,
					-7.81,
					43.89,
					-7.69,
					43.66,
					-7.12,
					43.67,
					-6.12,
					43.77,
					-5.83,
					43.65,
					-5.64,
					43.5,
					-4.57,
					43.62,
					-3.59,
					43.46,
					-3.05,
					43.56,
					-2.76,
					43.4,
					-2.28,
					43.49,
					-1.74,
					43.68,
					-1.55,
					44.57,
					-1.36,
					45.55,
					-1.23,
					46,
					-1.5,
					46.11,
					-1.48,
					46.18,
					-1.65,
					46.3,
					-1.64,
					46.4,
					-1.88,
					46.7,
					-2.17,
					46.59,
					-2.24,
					46.61,
					-2.45,
					46.79,
					-2.47,
					46.79,
					-2.25,
					46.96,
					-2.39,
					47.13,
					-2.35,
					47.17,
					-2.55,
					47.39,
					-2.65,
					47.38,
					-2.75,
					47.23,
					-2.82,
					47.21,
					-3.29,
					47.41,
					-3.34,
					47.48,
					-3.26,
					47.57,
					-3.32,
					47.52,
					-3.51,
					47.76,
					-3.98,
					47.69,
					-4.42,
					47.87,
					-4.51,
					47.96,
					-4.94,
					48.13,
					-4.93,
					48.16,
					-4.68,
					48.34,
					-5.16,
					48.54,
					-5.19,
					48.56,
					-5.01,
					48.47,
					-4.87,
					48.6,
					-4.84,
					48.73,
					-4.59,
					48.86,
					-4.04,
					48.8,
					-3.69,
					48.91,
					-3.6,
					48.99,
					-3.09,
					48.95,
					-2.91,
					48.81,
					-2.89,
					48.63,
					-2.68,
					48.8,
					-2.33,
					48.71,
					-2.18,
					48.8,
					-1.92,
					48.97,
					-1.9,
					48.91,
					-1.72,
					49.16,
					-1.71,
					49.34,
					-1.91,
					49.75,
					-2.04,
					49.83,
					-1.96,
					49.76,
					-1.61,
					49.8,
					-1.23,
					49.48,
					-1.12,
					49.39,
					-0.23,
					49.43,
					-0.01,
					49.55,
					-0.02,
					49.79,
					0.12,
					50.04,
					1.07,
					50.28,
					1.43,
					50.96,
					1.51,
					51.48,
					3.34,
					51.61,
					3.36,
					51.93,
					3.92,
					52.03,
					3.92,
					52.32,
					4.34,
					52.51,
					4.48,
					53.14,
					4.64,
					53.3,
					4.77,
					53.4,
					5.1,
					53.5,
					5.15,
					53.6,
					6.34,
					53.77,
					6.84,
					53.88,
					7.7,
					53.82,
					8.23,
					53.69,
					8.37,
					53.81,
					8.44,
					53.88,
					8.32,
					54,
					8.31,
					54.06,
					8.44,
					54.02,
					8.56,
					54.19,
					8.59,
					54.36,
					8.36,
					54.5,
					8.34,
					54.63,
					8.19,
					54.93,
					8.19,
					55.24,
					8.39,
					55.52,
					7.97,
					55.78,
					8.06,
					56.05,
					7.99,
					56.55,
					8.01,
					56.94,
					8.21,
					57.21,
					8.55,
					57.26,
					9.35,
					57.69,
					9.92,
					57.83,
					10.71,
					57.69,
					10.74,
					57.57,
					10.59,
					57.2,
					10.66,
					56.82,
					10.39,
					56.66,
					10.44,
					56.61,
					10.9,
					56.47,
					11.06,
					56.02,
					10.84,
					55.89,
					10.86,
					55.83,
					10.78,
					55.69,
					10.7,
					55.55,
					10.9,
					55.41,
					10.88,
					55.43,
					11.01,
					55.56,
					10.99,
					55.75,
					10.77,
					55.84,
					10.83,
					55.84,
					11.01,
					56.01,
					11.03,
					56,
					11.18,
					56.1,
					11.29,
					56.09,
					11.66,
					56.2,
					11.61,
					56.29,
					11.68,
					56.24,
					11.84,
					56.07,
					11.81,
					56.21,
					12.37,
					56.34,
					12.35,
					56.39,
					12.44
				]
			},
			{
				"points": [
					76.39,
					16.69,
					76.46,
					16.25,
					76.62,
					16.2,
					76.77,
					15.48,
					76.9,
					15.41,
					77.08,
					14.39,
					77.31,
					13.91,
					77.54,
					13.83,
					77.62,
					13.91,
					77.63,
					13.73,
					77.76,
					13.59,
					78.11,
					13.51,
					78.1,
					12.95,
					78.26,
					12.81,
					78.51,
					11.99,
					78.24,
					12.24,
					78.11,
					12.2,
					78.36,
					11.01,
					78.69,
					10.47,
					78.98,
					10.41,
					78.94,
					11.03,
					78.79,
					11.38,
					78.83,
					11.5,
					78.9,
					11.27,
					79.01,
					11.24,
					79.03,
					11.12,
					79.16,
					11.04,
					79.29,
					10.77,
					79.4,
					10.75,
					79.45,
					10.59,
					79.56,
					10.55,
					79.65,
					10.64,
					79.7,
					10.56,
					79.82,
					10.57,
					79.88,
					10.9,
					79.78,
					11.09,
					79.95,
					11.29,
					79.94,
					11.85,
					79.8,
					12.07,
					79.94,
					12.17,
					79.86,
					12.57,
					79.97,
					13.84,
					79.85,
					14.04,
					79.74,
					14.07,
					79.89,
					14.44,
					79.89,
					14.74,
					79.71,
					15.29,
					79.44,
					15.51,
					79.33,
					15.79,
					79.87,
					15.5,
					79.95,
					15.81,
					80.15,
					16.09,
					80.15,
					16.54,
					80.02,
					16.82,
					80.04,
					17.37,
					79.86,
					17.95,
					80,
					17.9,
					80.04,
					17.63,
					80.18,
					17.6,
					80.26,
					17.96,
					80.37,
					17.99,
					80.48,
					18.31,
					80.43,
					18.78,
					80.33,
					18.89,
					80.44,
					18.96,
					80.39,
					19.3,
					80.51,
					19.32,
					80.61,
					19.63,
					80.72,
					19.73,
					80.6,
					20.34,
					80.39,
					20.6,
					80.41,
					20.83,
					80.31,
					20.94,
					80.46,
					21.49,
					80.34,
					21.57,
					80.35,
					21.89,
					80.25,
					21.95,
					80.14,
					22.21,
					80.26,
					22.36,
					80.35,
					22.23,
					80.46,
					22.25,
					80.49,
					22.69,
					80.61,
					22.8,
					80.51,
					23.38,
					80.3,
					23.41,
					80.24,
					23.6,
					80.38,
					23.74,
					80.41,
					23.89,
					80.58,
					23.91,
					80.59,
					24.13,
					80.41,
					24.61,
					80.47,
					24.78,
					80.37,
					24.98,
					80.39,
					25.39,
					80.26,
					25.93,
					80.26,
					26.8,
					80.1,
					27.33,
					79.81,
					27.18,
					79.56,
					25.97,
					79.47,
					25.97,
					79.33,
					25.76,
					79.11,
					23.64,
					79.28,
					22.56,
					79.24,
					21.29,
					79.16,
					21.18,
					79.32,
					20.29,
					79.21,
					20.29,
					79.13,
					21.23,
					78.97,
					21.27,
					78.94,
					21.52,
					79.08,
					21.57,
					79.07,
					21.87,
					78.91,
					21.91,
					78.87,
					21.62,
					78.68,
					21.6,
					78.68,
					21.97,
					78.34,
					22.31,
					78.39,
					22.48,
					78.26,
					23.28,
					78.19,
					23.35,
					78.1,
					23.32,
					77.98,
					23.62,
					77.92,
					24.42,
					77.79,
					24.47,
					77.62,
					24.4,
					77.47,
					24.19,
					77.32,
					23.38,
					77.17,
					23.29,
					77.19,
					22.96,
					77.04,
					22.88,
					77.31,
					22.3,
					77.45,
					22.31,
					77.5,
					22.49,
					77.38,
					21.43,
					77.28,
					21.53,
					77.16,
					21.38,
					77.24,
					21.26,
					77.37,
					21.31,
					77.33,
					20.83,
					77.54,
					20.7,
					77.63,
					20.75,
					77.7,
					21.07,
					77.88,
					21.24,
					77.99,
					20.77,
					78.09,
					20.7,
					78.1,
					20.36,
					78.24,
					20.33,
					78.34,
					20.45,
					78.39,
					20.1,
					78.54,
					20.08,
					78.52,
					19.78,
					78.4,
					19.69,
					78.37,
					19.17,
					78.03,
					19.12,
					77.92,
					18.58,
					77.44,
					18.37,
					77.36,
					17.75,
					77.24,
					17.55,
					76.88,
					17.39,
					76.8,
					17.19,
					76.74,
					17.28,
					76.63,
					17.26,
					76.39,
					16.69
				]
			},
			{
				"points": [
					39.1,
					9.71,
					38.99,
					9.52,
					39.11,
					9.2,
					38.93,
					9.1,
					38.79,
					8.91,
					38.76,
					8.61,
					38.91,
					8.48,
					38.89,
					8.32,
					39.14,
					8.1,
					39.29,
					8.27,
					40.23,
					8.35,
					40.48,
					8.24,
					40.54,
					8.05,
					40.99,
					8.08,
					41.2,
					8.21,
					41.21,
					8.29,
					41.13,
					8.44,
					40.97,
					8.37,
					40.94,
					8.51,
					41.22,
					9.04,
					41.32,
					9.06,
					41.45,
					8.75,
					41.69,
					8.56,
					42.38,
					8.44,
					42.67,
					8.65,
					42.83,
					9.22,
					43.04,
					9.24,
					43.1,
					9.33,
					43.04,
					9.55,
					42.14,
					9.66,
					41.41,
					9.37,
					41.31,
					9.56,
					41.11,
					9.63,
					41,
					9.81,
					40.78,
					9.8,
					40.53,
					9.93,
					40.25,
					9.75,
					40.06,
					9.84,
					39.1,
					9.71
				]
			},
			{
				"points": [
					57.18,
					18.84,
					56.83,
					18.36,
					56.8,
					18.13,
					56.85,
					18.03,
					57.16,
					18,
					57.28,
					17.85,
					57.41,
					18.01,
					57.65,
					18.09,
					58.01,
					18.64,
					58.1,
					19.17,
					58.03,
					19.43,
					57.89,
					19.45,
					57.36,
					19.08,
					57.18,
					18.84
				]
			},
			{
				"points": [
					39.01,
					2.95,
					39.11,
					2.81,
					39.23,
					2.83,
					39.47,
					2.26,
					39.57,
					2.21,
					39.94,
					2.71,
					40.05,
					3.24,
					39.68,
					3.57,
					39.29,
					3.31,
					39.01,
					2.95
				]
			},
			{
				"points": [
					78.73,
					28.8,
					78.64,
					28.72,
					78.71,
					28.51,
					78.68,
					28.05,
					78.77,
					27.79,
					78.87,
					27.75,
					78.95,
					27.83,
					79.07,
					28.43,
					79,
					29.7,
					78.9,
					29.8,
					78.8,
					29.7,
					78.73,
					28.8
				]
			}
		],
		"transitions": [
			[
				1319950800,
				60,
				[
					"CET"
				]
			],
			[
				1332651600,
				120,
				[
					"CEST"
				]
			],
			[
				1351400400,
				60,
				[
					"CET"
				]
			],
			[
				1364706000,
				120,
				[
					"CEST"
				]
			],
			[
				1382850000,
				60,
				[
					"CET"
				]
			],
			[
				1396155600,
				120,
				[
					"CEST"
				]
			],
			[
				1414299600,
				60,
				[
					"CET"
				]
			],
			[
				1427605200,
				120,
				[
					"CEST"
				]
			],
			[
				1445749200,
				60,
				[
					"CET"
				]
			],
			[
				1459054800,
				120,
				[
					"CEST"
				]
			],
			[
				1477803600,
				60,
				[
					"CET"
				]
			],
			[
				1490504400,
				120,
				[
					"CEST"
				]
			],
			[
				1509253200,
				60,
				[
					"CET"
				]
			],
			[
				1521954000,
				120,
				[
					"CEST"
				]
			],
			[
				1540702800,
				60,
				[
					"CET"
				]
			],
			[
				1554008400,
				120,
				[
					"CEST"
				]
			],
			[
				1572152400,
				60,
				[
					"CET"
				]
			],
			[
				1585458000,
				120,
				[
					"CEST"
				]
			],
			[
				1603602000,
				60,
				[
					"CET"
				]
			],
			[
				1616907600,
				120,
				[
					"CEST"
				]
			],
			[
				1635656400,
				60,
				[
					"CET"
				]
			],
			[
				1648357200,
				120,
				[
					"CEST"
				]
			],
			[
				1667106000,
				60,
				[
					"CET"
				]
			],
			[
				1679806800,
				120,
				[
					"CEST"
				]
			],
			[
				1698555600,
				60,
				[
					"CET"
				]
			],
			[
				1711861200,
				120,
				[
					"CEST"
				]
			],
			[
				1730005200,
				60,
				[
					"CET"
				]
			],
			[
				1743310800,
				120,
				[
					"CEST"
				]
			],
			[
				1761454800,
				60,
				[
					"CET"
				]
			],
			[
				1774760400,
				120,
				[
					"CEST"
				]
			],
			[
				1792904400,
				60,
				[
					"CET"
				]
			],
			[
				1806210000,
				120,
				[
					"CEST"
				]
			],
			[
				1824958800,
				60,
				[
					"CET"
				]
			],
			[
				1837659600,
				120,
				[
					"CEST"
				]
			],
			[
				1856408400,
				60,
				[
					"CET"
				]
			],
			[
				1869109200,
				120,
				[
					"CEST"
				]
			],
			[
				1887858000,
				60,
				[
					"CET"
				]
			],
			[
				1901163600,
				120,
				[
					"CEST"
				]
			],
			[
				1919307600,
				60,
				[
					"CET"
				]
			],
			[
				1932613200,
				120,
				[
					"CEST"
				]
			],
			[
				1950757200,
				60,
				[
					"CET"
				]
			],
			[
				1964062800,
				120,
				[
					"CEST"
				]
			],
			[
				1982811600,
				60,
				[
					"CET"
				]
			],
			[
				1995512400,
				120,
				[
					"CEST"
				]
			],
			[
				2014261200,
				60,
				[
					"CET"
				]
			],
			[
				2026962000,
				120,
				[
					"CEST"
				]
			],
			[
				2045710800,
				60,
				[
					"CET"
				]
			],
			[
				2058411600,
				120,
				[
					"CEST"
				]
			],
			[
				2077160400,
				60,
				[
					"CET"
				]
			],
			[
				2090466000,
				120,
				[
					"CEST"
				]
			],
			[
				2108610000,
				60,
				[
					"CET"
				]
			],
			[
				2121915600,
				120,
				[
					"CEST"
				]
			],
			[
				2140059600,
				60,
				[
					"CET"
				]
			]
		],
		"name": "Europe/Skopje"
	},
	{
		"hoverRegion": [
			{
				"points": [
					36.15,
					30.56,
					36.06,
					30.38,
					36.19,
					30.2,
					36.01,
					29.78,
					36,
					29.53,
					36.28,
					29.05,
					36.44,
					29.01,
					36.49,
					28.78,
					36.69,
					28.51,
					36.53,
					28.19,
					36.53,
					28.29,
					36.44,
					28.34,
					35.98,
					28.17,
					35.78,
					27.79,
					35.88,
					27.63,
					36.1,
					27.6,
					36.12,
					27.45,
					36.25,
					27.42,
					36.32,
					27.24,
					36.45,
					27.18,
					36.42,
					26.88,
					36.85,
					26.86,
					37.21,
					26.67,
					37.19,
					26.48,
					37.41,
					26.43,
					37.5,
					26.32,
					37.4,
					25.97,
					37.51,
					25.88,
					37.74,
					26.06,
					37.75,
					26.45,
					37.92,
					26.75,
					37.89,
					27.15,
					37.93,
					26.83,
					38.1,
					26.7,
					37.99,
					26.58,
					38.18,
					26.18,
					38.04,
					25.99,
					38.19,
					25.77,
					38.52,
					25.72,
					38.42,
					25.47,
					38.54,
					25.38,
					38.68,
					25.46,
					38.72,
					25.57,
					38.58,
					25.73,
					38.69,
					25.84,
					38.63,
					26.24,
					38.79,
					26.39,
					38.66,
					26.61,
					38.84,
					26.72,
					38.95,
					26.69,
					38.86,
					26.45,
					38.9,
					26.14,
					39.12,
					25.76,
					39.31,
					25.77,
					39.39,
					26,
					39.49,
					25.95,
					39.67,
					26.04,
					39.75,
					25.88,
					39.86,
					25.85,
					40.07,
					26.07,
					39.98,
					25.72,
					40.18,
					25.56,
					40.31,
					25.73,
					40.35,
					25.96,
					40.17,
					26.12,
					40.4,
					26.14,
					40.51,
					26.38,
					40.5,
					26.08,
					40.74,
					25.91,
					40.75,
					25.53,
					40.89,
					25.1,
					40.78,
					24.88,
					40.62,
					24.88,
					40.47,
					24.67,
					40.61,
					24.41,
					40.83,
					24.51,
					40.63,
					24.13,
					40.62,
					23.98,
					40.18,
					24.51,
					40.01,
					24.31,
					40.04,
					24.23,
					40.18,
					24.11,
					40.19,
					24.08,
					39.93,
					24.09,
					39.83,
					23.99,
					39.86,
					23.3,
					40.14,
					23.22,
					40.36,
					22.78,
					40.14,
					22.67,
					39.28,
					23.41,
					39.31,
					23.58,
					39.25,
					23.77,
					39.58,
					24.11,
					39.58,
					24.25,
					39.31,
					24.43,
					39.23,
					24.36,
					39.27,
					24.22,
					39.21,
					24.13,
					39.08,
					24.23,
					38.97,
					24.18,
					38.92,
					24.07,
					39.03,
					23.83,
					38.96,
					23.73,
					39.01,
					23.5,
					38.87,
					23.64,
					38.68,
					24.31,
					38.3,
					24.35,
					38.23,
					24.65,
					38.07,
					24.68,
					38.1,
					24.8,
					37.99,
					25.01,
					37.6,
					25.36,
					37.51,
					25.62,
					37.39,
					25.68,
					37.29,
					25.59,
					37.2,
					25.66,
					37.2,
					25.92,
					37,
					25.9,
					37.13,
					26.46,
					37.05,
					26.59,
					36.89,
					26.54,
					36.9,
					26.37,
					36.66,
					25.8,
					36.51,
					25.7,
					36.61,
					25.56,
					36.73,
					25.64,
					36.73,
					25.52,
					36.54,
					25.4,
					36.46,
					25.58,
					36.28,
					25.54,
					36.25,
					25.32,
					36.13,
					25.2,
					36.26,
					25.08,
					36.36,
					25.24,
					36.55,
					25.29,
					36.6,
					25.23,
					36.48,
					24.92,
					36.55,
					24.78,
					36.69,
					24.73,
					36.57,
					24.55,
					36.57,
					24.25,
					36.76,
					24.11,
					36.87,
					24.14,
					36.93,
					24.56,
					37.01,
					24.54,
					37.06,
					24.33,
					37.57,
					24.18,
					37.54,
					24.02,
					37.41,
					24.03,
					37.35,
					23.89,
					37.44,
					23.79,
					37.67,
					23.81,
					37.72,
					23.66,
					37.6,
					23.59,
					37.4,
					23.68,
					37.28,
					23.65,
					37.1,
					23.17,
					37.18,
					23.02,
					36.82,
					23.21,
					36.65,
					23.16,
					36.44,
					23.31,
					36.34,
					23.16,
					36.24,
					23.2,
					36.03,
					23.07,
					36.13,
					22.82,
					36.5,
					22.83,
					36.69,
					22.69,
					36.56,
					22.58,
					36.34,
					22.56,
					36.28,
					22.48,
					36.43,
					22.26,
					36.65,
					22.26,
					36.79,
					22.16,
					36.82,
					22.07,
					36.58,
					21.91,
					36.65,
					21.63,
					36.92,
					21.55,
					37.03,
					21.43,
					37.37,
					21.55,
					37.55,
					21.23,
					37.75,
					21.09,
					37.64,
					21.05,
					37.56,
					20.77,
					37.77,
					20.52,
					37.99,
					20.6,
					38.12,
					20.24,
					38.81,
					20.5,
					38.92,
					20.63,
					39,
					20.59,
					39.15,
					20.36,
					39.04,
					20.3,
					39.04,
					20.17,
					39.18,
					20.02,
					39.28,
					20.02,
					39.38,
					19.78,
					39.66,
					19.57,
					39.79,
					19.29,
					39.95,
					19.31,
					40.01,
					19.55,
					39.89,
					19.7,
					39.92,
					19.88,
					39.76,
					20.18,
					40.05,
					20.22,
					40.18,
					20.58,
					40.5,
					20.7,
					40.61,
					20.91,
					40.94,
					20.92,
					41.02,
					21.4,
					40.98,
					21.57,
					41.26,
					22.03,
					41.23,
					22.55,
					41.45,
					22.83,
					41.73,
					22.89,
					41.93,
					22.78,
					42.06,
					22.45,
					42.31,
					22.25,
					42.47,
					22.38,
					42.88,
					22.34,
					42.98,
					22.69,
					43.16,
					22.83,
					43.37,
					22.47,
					43.77,
					22.25,
					44.06,
					22.31,
					44.19,
					22.55,
					44.43,
					22.35,
					44.53,
					22.37,
					44.36,
					22.11,
					44.52,
					21.93,
					44.55,
					21.59,
					44.65,
					21.51,
					44.68,
					21.34,
					45.03,
					21.25,
					45.12,
					21.32,
					45.4,
					20.68,
					45.64,
					20.68,
					46.1,
					20.15,
					46.29,
					20.46,
					46.26,
					20.62,
					46.38,
					20.78,
					46.4,
					21.12,
					46.67,
					21.22,
					46.8,
					21.44,
					47.08,
					21.56,
					47.44,
					21.92,
					47.61,
					21.96,
					47.84,
					22.26,
					47.88,
					22.63,
					47.98,
					22.77,
					47.98,
					22.57,
					48.29,
					22.23,
					48.28,
					22.08,
					48.6,
					22.07,
					48.77,
					22.26,
					49.01,
					22.36,
					49.2,
					22.61,
					49.65,
					22.61,
					50.47,
					23.65,
					50.54,
					23.96,
					50.77,
					23.85,
					50.9,
					23.93,
					51.24,
					23.55,
					51.72,
					23.59,
					51.74,
					24.15,
					52.03,
					24.43,
					52.06,
					25.79,
					51.91,
					26.52,
					51.88,
					27.23,
					51.73,
					27.33,
					51.68,
					28.02,
					51.79,
					28.27,
					51.66,
					28.44,
					51.63,
					28.75,
					51.75,
					29.13,
					51.69,
					29.31,
					51.52,
					29.37,
					51.62,
					29.69,
					51.56,
					29.81,
					51.61,
					30.2,
					51.42,
					30.5,
					51.63,
					30.41,
					52.17,
					30.89,
					52.15,
					31.25,
					52.25,
					31.43,
					52.14,
					31.99,
					52.21,
					32.25,
					52.44,
					32.36,
					52.35,
					32.89,
					52.47,
					33.17,
					52.41,
					33.53,
					52.47,
					33.83,
					52.22,
					34.19,
					52.03,
					34.24,
					51.82,
					34.54,
					51.69,
					34.52,
					51.62,
					34.32,
					51.35,
					34.44,
					51.29,
					34.76,
					51.32,
					35.15,
					51.16,
					35.27,
					51.14,
					35.49,
					50.97,
					35.47,
					50.68,
					35.61,
					50.59,
					35.56,
					50.49,
					35.66,
					50.55,
					36.15,
					50.41,
					36.34,
					50.44,
					36.46,
					50.34,
					36.65,
					50.55,
					37.5,
					50.38,
					37.71,
					50.23,
					37.75,
					50.02,
					38.06,
					50.17,
					38.15,
					50.18,
					38.37,
					50.1,
					38.45,
					50.11,
					38.73,
					49.93,
					38.97,
					49.99,
					39.18,
					49.86,
					39.33,
					49.83,
					39.66,
					49.67,
					39.84,
					49.72,
					40.17,
					49.61,
					40.3,
					49.45,
					40.21,
					49.17,
					40.28,
					48.97,
					40.01,
					48.93,
					40.15,
					48.82,
					40.17,
					48.69,
					40.04,
					48.68,
					39.83,
					48.62,
					39.94,
					48.25,
					40.12,
					47.73,
					39.79,
					47.76,
					38.93,
					47.59,
					38.82,
					47.47,
					38.39,
					47.35,
					38.35,
					47.2,
					38.43,
					46.92,
					38.14,
					46.99,
					38,
					46.98,
					37.62,
					46.76,
					37.34,
					46.82,
					37.21,
					46.77,
					37.08,
					46.54,
					36.84,
					46.53,
					36.71,
					46.66,
					36.61,
					46.37,
					36.13,
					46.42,
					36.02,
					46.54,
					36.03,
					46.54,
					35.94,
					46.34,
					35.52,
					46.06,
					35.26,
					45.97,
					35.02,
					45.74,
					35.13,
					45.4,
					35.52,
					45.57,
					35.81,
					45.48,
					35.99,
					45.58,
					36.34,
					45.45,
					36.72,
					45.31,
					36.73,
					45.25,
					36.54,
					45.06,
					36.56,
					44.96,
					36.42,
					44.89,
					35.85,
					45,
					35.54,
					44.86,
					35.45,
					44.84,
					35.3,
					44.69,
					35.12,
					44.7,
					34.74,
					44.32,
					34.14,
					44.29,
					33.74,
					44.54,
					33.27,
					44.65,
					33.29,
					44.73,
					33.45,
					44.9,
					33.5,
					45.04,
					33.42,
					45.05,
					33.2,
					45.24,
					32.89,
					45.2,
					32.63,
					45.33,
					32.41,
					45.56,
					32.5,
					45.91,
					33.14,
					45.94,
					33.43,
					46.01,
					33.16,
					45.9,
					33,
					46.16,
					31.53,
					46.35,
					31.42,
					46.51,
					31.44,
					46.45,
					30.85,
					46.3,
					30.83,
					46,
					30.55,
					45.51,
					29.84,
					45.21,
					29.85,
					44.73,
					29.67,
					44.65,
					29.14,
					44.29,
					28.76,
					43.51,
					28.71,
					43.29,
					28.55,
					43.27,
					28.15,
					43.14,
					28.03,
					42.66,
					28,
					42.6,
					27.79,
					42.52,
					27.75,
					42.01,
					28.13,
					41.81,
					28.13,
					41.62,
					28.29,
					41.31,
					29.14,
					41.25,
					30.06,
					41.32,
					30.29,
					41.18,
					30.94,
					41.22,
					31.26,
					41.42,
					31.36,
					41.93,
					32.55,
					42.13,
					33.34,
					42.05,
					34.68,
					42.21,
					34.93,
					42.09,
					35.29,
					41.97,
					35.31,
					41.91,
					35.24,
					41.8,
					35.35,
					41.74,
					35.58,
					41.82,
					36.04,
					41.38,
					36.41,
					41.48,
					36.59,
					41.46,
					36.81,
					41.14,
					37.51,
					41.24,
					37.71,
					41.08,
					37.92,
					41.02,
					38.35,
					41.21,
					39.4,
					41.02,
					40.17,
					41.3,
					41,
					41.63,
					41.53,
					41.55,
					41.81,
					41.63,
					41.99,
					41.55,
					42.43,
					41.68,
					42.56,
					41.69,
					42.82,
					41.28,
					43.31,
					41.27,
					43.48,
					41.1,
					43.56,
					40.99,
					43.76,
					40.67,
					43.85,
					40.45,
					43.68,
					40.16,
					43.82,
					40.1,
					44.46,
					39.69,
					44.92,
					39.55,
					44.86,
					39.64,
					44.61,
					39.33,
					44.5,
					39.28,
					44.24,
					39.13,
					44.33,
					38.98,
					44.3,
					38.87,
					44.41,
					38.46,
					44.42,
					38.34,
					44.61,
					37.94,
					44.39,
					37.83,
					44.68,
					37.5,
					44.71,
					37.3,
					44.94,
					37.05,
					44.86,
					37.07,
					44.65,
					36.85,
					44.33,
					37.02,
					44.1,
					37.2,
					44.11,
					37.08,
					43.83,
					37.25,
					43.14,
					37.2,
					42.95,
					37.25,
					42.82,
					37.03,
					42.59,
					37.01,
					42.33,
					37.17,
					42.21,
					37.05,
					41.99,
					36.97,
					41.57,
					37,
					40.8,
					36.65,
					39.88,
					36.55,
					39.24,
					36.59,
					38.72,
					36.79,
					38.26,
					36.52,
					37.47,
					36.52,
					37.04,
					36.66,
					36.92,
					36.7,
					36.75,
					36.5,
					36.67,
					36.18,
					36.79,
					36.12,
					36.49,
					35.95,
					36.47,
					35.7,
					36.16,
					35.86,
					35.83,
					36.01,
					35.85,
					36.28,
					35.68,
					36.65,
					36.09,
					36.79,
					36.02,
					36.47,
					35.62,
					36.43,
					35.36,
					36.69,
					34.68,
					36.5,
					34.35,
					36.11,
					34,
					36.15,
					33.87,
					36.02,
					33.73,
					36.02,
					33.16,
					35.9,
					32.8,
					36.06,
					32.34,
					36.44,
					31.96,
					36.7,
					31.3,
					36.77,
					30.71,
					36.15,
					30.56
				]
			},
			{
				"points": [
					59.8,
					20.94,
					59.85,
					20.79,
					59.97,
					20.73,
					59.87,
					20.17,
					60.04,
					19.51,
					60.12,
					19.43,
					60.09,
					19.28,
					60.2,
					19.21,
					60.52,
					19.59,
					60.57,
					20.26,
					60.42,
					20.5,
					60.51,
					20.57,
					60.53,
					20.76,
					60.63,
					20.88,
					60.9,
					20.91,
					61.06,
					21.19,
					61.24,
					21.24,
					61.32,
					21.35,
					61.47,
					21.23,
					61.58,
					21.31,
					61.95,
					21.17,
					62.2,
					21.21,
					62.52,
					20.94,
					62.73,
					20.93,
					62.91,
					21.04,
					63.04,
					21.02,
					63.09,
					21.1,
					63.28,
					20.97,
					63.48,
					20.96,
					63.53,
					21.06,
					63.48,
					21.41,
					63.37,
					21.51,
					63.51,
					21.63,
					63.56,
					21.82,
					63.42,
					21.93,
					64.02,
					22.72,
					63.95,
					22.95,
					64.05,
					23.16,
					64.03,
					23.3,
					64.16,
					23.33,
					64.64,
					24.29,
					64.93,
					24.55,
					65.01,
					24.45,
					65.12,
					24.49,
					65.2,
					24.8,
					65.16,
					25.02,
					65.4,
					25.15,
					65.3,
					25.04,
					65.27,
					24.77,
					65.44,
					24.73,
					65.51,
					24.94,
					65.52,
					24.57,
					65.66,
					24.39,
					65.57,
					24.27,
					65.65,
					24.11,
					66.06,
					23.85,
					66.22,
					23.57,
					66.48,
					23.54,
					66.63,
					23.78,
					66.83,
					23.81,
					67.1,
					23.48,
					67.36,
					23.56,
					67.46,
					23.3,
					67.63,
					23.42,
					67.95,
					23.43,
					68.04,
					23.11,
					68.16,
					23.05,
					68.28,
					22.8,
					68.37,
					21.99,
					68.97,
					20.51,
					69.14,
					20.47,
					69.22,
					20.68,
					69.19,
					20.91,
					69.31,
					20.97,
					69.41,
					21.29,
					69.36,
					21.69,
					69.05,
					22.22,
					68.82,
					22.42,
					68.74,
					23.17,
					68.94,
					23.98,
					68.67,
					24.89,
					68.72,
					25.02,
					68.88,
					25.08,
					69,
					25.6,
					69.05,
					25.65,
					69.29,
					25.6,
					69.74,
					25.81,
					70.03,
					26.42,
					70.02,
					27.02,
					70.18,
					27.55,
					70.2,
					27.96,
					69.92,
					28.46,
					69.77,
					29.21,
					69.44,
					29.43,
					69.16,
					28.93,
					69,
					29.02,
					68.52,
					28.59,
					68.29,
					28.72,
					68.18,
					29.35,
					67.71,
					30.13,
					67.42,
					30.02,
					66.9,
					29.2,
					66.2,
					29.99,
					65.84,
					30.21,
					65.59,
					30.2,
					65.54,
					29.98,
					65.41,
					29.86,
					65.25,
					29.97,
					65.04,
					29.98,
					64.97,
					29.74,
					64.89,
					29.8,
					64.84,
					30.17,
					64.66,
					30.25,
					64.48,
					30.15,
					64.33,
					30.55,
					64.15,
					30.65,
					64.03,
					30.63,
					63.71,
					30.27,
					63.3,
					31.3,
					62.97,
					31.65,
					62.83,
					31.66,
					62.43,
					31.31,
					62.22,
					31.01,
					62.1,
					30.7,
					61.18,
					29.3,
					61.03,
					28.89,
					60.86,
					28.71,
					60.82,
					28.5,
					60.38,
					27.79,
					60.29,
					27.43,
					60.17,
					27.36,
					60.17,
					27.14,
					60.3,
					26.87,
					60.17,
					26.64,
					60.27,
					26.39,
					60.09,
					25.9,
					60.14,
					25.71,
					60.05,
					25.43,
					60.11,
					25.24,
					59.99,
					25.08,
					60.05,
					24.84,
					59.85,
					24.42,
					59.96,
					24.28,
					59.8,
					23.68,
					59.71,
					23.59,
					59.78,
					23.3,
					59.65,
					22.94,
					59.75,
					22.8,
					59.9,
					22.76,
					59.69,
					22.42,
					59.75,
					22.03,
					59.92,
					21.98,
					60.03,
					22.2,
					60.04,
					22.09,
					59.72,
					21.67,
					59.79,
					21.48,
					59.99,
					21.6,
					59.88,
					21.22,
					60.04,
					21.14,
					59.9,
					21.1,
					59.8,
					20.94
				]
			},
			{
				"points": [
					55.57,
					26.73,
					55.42,
					26.66,
					55.36,
					26.93,
					55.22,
					26.96,
					55.06,
					26.73,
					55.03,
					26.38,
					54.91,
					26.28,
					54.76,
					25.86,
					54.55,
					25.86,
					54.38,
					25.73,
					54.27,
					25.91,
					54.07,
					25.84,
					54.05,
					25.5,
					54.17,
					25.44,
					54.02,
					24.94,
					53.84,
					24.78,
					53.81,
					23.57,
					53.89,
					23.42,
					54.11,
					23.33,
					54.3,
					22.87,
					54.29,
					22.69,
					54.58,
					22.57,
					54.81,
					22.73,
					54.95,
					22.54,
					54.92,
					22.03,
					55.17,
					21.38,
					55.14,
					21.23,
					55.25,
					21.13,
					55.19,
					20.86,
					55.74,
					20.97,
					56.03,
					20.96,
					56.2,
					20.87,
					56.53,
					20.89,
					56.89,
					20.97,
					57.1,
					21.3,
					57.33,
					21.33,
					57.67,
					21.68,
					57.87,
					22.62,
					57.69,
					22.7,
					57.44,
					23.21,
					57.18,
					23.34,
					57.08,
					23.75,
					57.32,
					24.29,
					57.87,
					24.24,
					58.22,
					24.35,
					57.98,
					23.95,
					58.06,
					23.86,
					58.21,
					23.88,
					58.24,
					23.7,
					58.45,
					23.51,
					57.79,
					22,
					58.34,
					21.66,
					58.58,
					21.77,
					58.69,
					22.26,
					58.86,
					21.95,
					59.02,
					22,
					59.19,
					22.66,
					59.05,
					23.02,
					59.13,
					23.11,
					59.13,
					23.38,
					59.28,
					23.25,
					59.38,
					23.28,
					59.35,
					23.76,
					59.45,
					23.83,
					59.58,
					24.37,
					59.71,
					24.49,
					59.6,
					24.66,
					59.69,
					24.73,
					59.66,
					24.86,
					59.74,
					24.93,
					59.74,
					25.04,
					59.6,
					25.4,
					59.74,
					25.45,
					59.78,
					25.78,
					59.54,
					26.98,
					59.5,
					27.8,
					59.56,
					28.09,
					59.45,
					28.29,
					59.35,
					28.31,
					59.2,
					28.18,
					59.14,
					27.96,
					58.8,
					27.64,
					58.39,
					27.55,
					57.82,
					27.93,
					57.72,
					27.64,
					57.63,
					27.6,
					57.5,
					27.64,
					57.3,
					27.97,
					56.93,
					27.83,
					56.89,
					28.05,
					56.77,
					28.05,
					56.61,
					28.23,
					56.26,
					28.35,
					56.07,
					28.22,
					55.85,
					27.74,
					55.68,
					27.63,
					55.73,
					27.15,
					55.57,
					26.73
				]
			},
			{
				"points": [
					34.81,
					24.23,
					34.7,
					24.16,
					34.74,
					24.01,
					34.88,
					23.89,
					35.02,
					23.92,
					35.12,
					23.56,
					35.24,
					23.42,
					35.72,
					23.54,
					35.8,
					23.75,
					35.45,
					26.22,
					35.3,
					26.45,
					35.02,
					26.36,
					34.84,
					26.19,
					34.87,
					25.84,
					34.75,
					25.69,
					34.86,
					25.58,
					34.81,
					24.74,
					34.96,
					24.17,
					34.81,
					24.23
				]
			},
			{
				"points": [
					34.45,
					33.07,
					34.65,
					32.37,
					34.96,
					32.2,
					35.17,
					32.19,
					35.51,
					32.9,
					35.8,
					34.58,
					35.75,
					34.69,
					35.64,
					34.69,
					34.86,
					34.16,
					34.45,
					33.07
				]
			}
		],
		"transitions": [
			[
				1319950800,
				120,
				[
					"EET"
				]
			],
			[
				1332651600,
				180,
				[
					"EEST"
				]
			],
			[
				1351400400,
				120,
				[
					"EET"
				]
			],
			[
				1364706000,
				180,
				[
					"EEST"
				]
			],
			[
				1382850000,
				120,
				[
					"EET"
				]
			],
			[
				1396155600,
				180,
				[
					"EEST"
				]
			],
			[
				1414299600,
				120,
				[
					"EET"
				]
			],
			[
				1427605200,
				180,
				[
					"EEST"
				]
			],
			[
				1445749200,
				120,
				[
					"EET"
				]
			],
			[
				1459054800,
				180,
				[
					"EEST"
				]
			],
			[
				1477803600,
				120,
				[
					"EET"
				]
			],
			[
				1490504400,
				180,
				[
					"EEST"
				]
			],
			[
				1509253200,
				120,
				[
					"EET"
				]
			],
			[
				1521954000,
				180,
				[
					"EEST"
				]
			],
			[
				1540702800,
				120,
				[
					"EET"
				]
			],
			[
				1554008400,
				180,
				[
					"EEST"
				]
			],
			[
				1572152400,
				120,
				[
					"EET"
				]
			],
			[
				1585458000,
				180,
				[
					"EEST"
				]
			],
			[
				1603602000,
				120,
				[
					"EET"
				]
			],
			[
				1616907600,
				180,
				[
					"EEST"
				]
			],
			[
				1635656400,
				120,
				[
					"EET"
				]
			],
			[
				1648357200,
				180,
				[
					"EEST"
				]
			],
			[
				1667106000,
				120,
				[
					"EET"
				]
			],
			[
				1679806800,
				180,
				[
					"EEST"
				]
			],
			[
				1698555600,
				120,
				[
					"EET"
				]
			],
			[
				1711861200,
				180,
				[
					"EEST"
				]
			],
			[
				1730005200,
				120,
				[
					"EET"
				]
			],
			[
				1743310800,
				180,
				[
					"EEST"
				]
			],
			[
				1761454800,
				120,
				[
					"EET"
				]
			],
			[
				1774760400,
				180,
				[
					"EEST"
				]
			],
			[
				1792904400,
				120,
				[
					"EET"
				]
			],
			[
				1806210000,
				180,
				[
					"EEST"
				]
			],
			[
				1824958800,
				120,
				[
					"EET"
				]
			],
			[
				1837659600,
				180,
				[
					"EEST"
				]
			],
			[
				1856408400,
				120,
				[
					"EET"
				]
			],
			[
				1869109200,
				180,
				[
					"EEST"
				]
			],
			[
				1887858000,
				120,
				[
					"EET"
				]
			],
			[
				1901163600,
				180,
				[
					"EEST"
				]
			],
			[
				1919307600,
				120,
				[
					"EET"
				]
			],
			[
				1932613200,
				180,
				[
					"EEST"
				]
			],
			[
				1950757200,
				120,
				[
					"EET"
				]
			],
			[
				1964062800,
				180,
				[
					"EEST"
				]
			],
			[
				1982811600,
				120,
				[
					"EET"
				]
			],
			[
				1995512400,
				180,
				[
					"EEST"
				]
			],
			[
				2014261200,
				120,
				[
					"EET"
				]
			],
			[
				2026962000,
				180,
				[
					"EEST"
				]
			],
			[
				2045710800,
				120,
				[
					"EET"
				]
			],
			[
				2058411600,
				180,
				[
					"EEST"
				]
			],
			[
				2077160400,
				120,
				[
					"EET"
				]
			],
			[
				2090466000,
				180,
				[
					"EEST"
				]
			],
			[
				2108610000,
				120,
				[
					"EET"
				]
			],
			[
				2121915600,
				180,
				[
					"EEST"
				]
			],
			[
				2140059600,
				120,
				[
					"EET"
				]
			]
		],
		"name": "Europe/Riga"
	},
	{
		"hoverRegion": [
			{
				"points": [
					9.52,
					98.04,
					9.5,
					97.91,
					9.63,
					97.8,
					9.92,
					97.95,
					10.18,
					97.76,
					10.3,
					97.84,
					10.43,
					97.79,
					10.35,
					97.66,
					10.47,
					97.57,
					10.57,
					97.7,
					10.45,
					97.79,
					10.64,
					97.87,
					10.69,
					98.02,
					10.76,
					97.82,
					10.99,
					97.83,
					11.09,
					98.19,
					11.24,
					98.11,
					11.16,
					97.95,
					11.22,
					97.82,
					11.48,
					97.87,
					11.56,
					97.99,
					11.88,
					97.88,
					11.89,
					97.79,
					11.71,
					97.72,
					11.73,
					97.6,
					11.62,
					97.61,
					11.52,
					97.51,
					11.59,
					97.39,
					11.82,
					97.33,
					11.94,
					97.57,
					12.06,
					97.52,
					12.38,
					97.73,
					12.49,
					97.68,
					12.68,
					97.77,
					12.88,
					97.75,
					12.92,
					97.85,
					12.84,
					97.97,
					12.48,
					97.95,
					12.59,
					98.1,
					12.93,
					98.07,
					13.29,
					98.17,
					13.3,
					98.28,
					13.13,
					98.42,
					12.85,
					98.43,
					13.08,
					98.46,
					13.5,
					98.25,
					13.45,
					98.08,
					13.72,
					98,
					13.68,
					97.9,
					13.77,
					97.79,
					14,
					97.82,
					14.13,
					97.67,
					14.45,
					97.65,
					14.54,
					97.79,
					15.05,
					97.61,
					15.38,
					97.66,
					15.5,
					97.54,
					15.8,
					97.61,
					16.8,
					97.08,
					16.98,
					97.09,
					17.07,
					97.01,
					16.6,
					96.83,
					16.04,
					95.82,
					15.85,
					95.73,
					15.61,
					95.46,
					15.56,
					95.03,
					15.81,
					94.53,
					15.72,
					94.41,
					15.78,
					94.2,
					16.01,
					94.08,
					16.54,
					94.13,
					16.64,
					94.25,
					17.2,
					94.33,
					17.4,
					94.46,
					18.15,
					94.33,
					18.21,
					94.22,
					18.34,
					94.25,
					18.64,
					94.07,
					18.65,
					93.9,
					18.54,
					93.88,
					18.41,
					94.01,
					18.32,
					93.89,
					18.39,
					93.8,
					18.49,
					93.81,
					18.71,
					93.44,
					18.91,
					93.38,
					18.98,
					93.56,
					19.34,
					93.36,
					19.61,
					93.39,
					19.73,
					93.31,
					19.68,
					93.14,
					19.76,
					92.95,
					20.65,
					92.27,
					21.18,
					92.07,
					21.37,
					92.1,
					21.55,
					92.29,
					21.48,
					92.52,
					21.72,
					92.49,
					22.2,
					92.6,
					22.25,
					92.69,
					22.14,
					92.92,
					22.26,
					92.95,
					22.3,
					93.07,
					22.79,
					92.99,
					23.11,
					93.04,
					23.16,
					93.27,
					23.67,
					93.32,
					24.13,
					93.23,
					24.18,
					93.34,
					24.06,
					93.52,
					24.1,
					93.79,
					23.98,
					94.09,
					24.52,
					94.3,
					25.05,
					94.62,
					25.18,
					94.47,
					25.41,
					94.52,
					25.78,
					94.92,
					25.96,
					94.92,
					26.09,
					95.05,
					26.29,
					94.96,
					26.67,
					95.05,
					26.79,
					95.38,
					27.32,
					96.06,
					27.47,
					96.57,
					27.45,
					96.79,
					27.65,
					96.78,
					28.01,
					97.25,
					28.25,
					97.24,
					28.65,
					97.56,
					28.59,
					97.77,
					28.46,
					97.85,
					28.45,
					97.97,
					28.23,
					98.2,
					27.75,
					98.34,
					27.79,
					98.46,
					27.63,
					98.79,
					26.66,
					98.89,
					26.3,
					98.79,
					26.1,
					98.82,
					26.03,
					98.73,
					25.78,
					98.79,
					25.71,
					98.55,
					25.47,
					98.43,
					25.48,
					98.25,
					25.3,
					98.21,
					25.11,
					97.98,
					25.13,
					97.89,
					24.78,
					97.88,
					24.67,
					97.66,
					24.55,
					97.65,
					24.53,
					97.74,
					24.28,
					97.87,
					24.06,
					97.83,
					24.21,
					98.12,
					24.23,
					98.95,
					24.02,
					98.96,
					23.88,
					98.79,
					23.66,
					98.99,
					23.28,
					99.01,
					23.2,
					99.16,
					23.18,
					99.55,
					22.97,
					99.66,
					22.87,
					99.64,
					22.7,
					99.44,
					22.48,
					99.49,
					22.23,
					99.35,
					22.14,
					100.02,
					21.81,
					100.08,
					21.71,
					100.26,
					21.59,
					100.24,
					21.64,
					100.36,
					21.58,
					100.62,
					21.74,
					100.78,
					21.88,
					101.11,
					21.6,
					101.28,
					21.29,
					101.06,
					21.21,
					100.8,
					20.96,
					100.67,
					20.82,
					100.74,
					20.65,
					100.34,
					20.25,
					100.14,
					20.33,
					99.95,
					20.22,
					99.62,
					20.04,
					99.58,
					19.97,
					99.16,
					19.71,
					99.09,
					19.64,
					98.97,
					19.68,
					98.82,
					19.56,
					98.56,
					19.61,
					98.14,
					19.49,
					97.95,
					19.06,
					97.93,
					18.93,
					97.82,
					18.53,
					97.86,
					18.41,
					97.64,
					18.32,
					97.74,
					17.78,
					97.86,
					17.14,
					98.39,
					17.01,
					98.59,
					16.79,
					98.65,
					16.71,
					98.61,
					16.5,
					98.75,
					16.44,
					99.01,
					16.07,
					98.93,
					15.99,
					98.72,
					15.31,
					98.68,
					15.08,
					98.3,
					14.85,
					98.35,
					14.39,
					98.68,
					14.18,
					99.02,
					13.95,
					99.2,
					13.27,
					99.32,
					13.08,
					99.24,
					12.78,
					99.34,
					12.63,
					99.54,
					12.24,
					99.58,
					12.19,
					99.67,
					12.03,
					99.66,
					11.83,
					99.77,
					11.02,
					99.31,
					10.63,
					98.89,
					10.42,
					98.9,
					9.86,
					98.62,
					9.81,
					98.51,
					9.93,
					98.37,
					9.57,
					98.19,
					9.52,
					98.04
				]
			},
			{
				"points": [
					13.89,
					93.3,
					13.88,
					93.17,
					14.01,
					93.11,
					14.12,
					93.25,
					14.27,
					93.29,
					14.29,
					93.39,
					14.2,
					93.48,
					14.03,
					93.47,
					13.89,
					93.3
				]
			},
			{
				"points": [
					-12.27,
					96.96,
					-12.28,
					96.8,
					-12.19,
					96.72,
					-11.96,
					96.77,
					-12.03,
					97,
					-12.16,
					97.04,
					-12.27,
					96.96
				]
			},
			{
				"points": [
					14.79,
					93.76,
					14.74,
					93.66,
					14.82,
					93.57,
					15.01,
					93.66,
					14.96,
					93.8,
					14.79,
					93.76
				]
			}
		],
		"transitions": [
			[
				0,
				390,
				[
					"MMT",
					"CCT"
				]
			]
		],
		"name": "Asia/Rangoon"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-39.26,
					146.49,
					-39.33,
					146.32,
					-39.15,
					146.13,
					-38.96,
					146.08,
					-39,
					145.87,
					-38.76,
					145.68,
					-38.57,
					145.03,
					-38.6,
					144.86,
					-38.37,
					144.57,
					-38.56,
					144.1,
					-38.77,
					143.91,
					-38.96,
					143.51,
					-38.46,
					142.35,
					-38.53,
					141.97,
					-38.37,
					141.73,
					-38.51,
					141.65,
					-38.49,
					141.35,
					-38.28,
					141.19,
					-38.1,
					140.86,
					-32.21,
					140.89,
					-32.11,
					140.99,
					-32.17,
					141.71,
					-31.92,
					141.73,
					-31.86,
					141.84,
					-31.71,
					141.84,
					-31.69,
					141.15,
					-31.53,
					140.89,
					-28.95,
					140.9,
					-28.89,
					140.99,
					-28.89,
					148.92,
					-28.47,
					149.46,
					-28.52,
					149.69,
					-28.43,
					150.27,
					-28.55,
					150.47,
					-28.53,
					150.75,
					-28.64,
					151.05,
					-28.76,
					151.13,
					-28.86,
					151.35,
					-29.01,
					151.38,
					-28.77,
					151.68,
					-28.81,
					151.92,
					-28.43,
					151.88,
					-28.27,
					152.32,
					-28.16,
					152.41,
					-28.24,
					153.05,
					-28.14,
					153.16,
					-28.08,
					153.61,
					-28.87,
					153.71,
					-29.33,
					153.45,
					-29.96,
					153.37,
					-30.6,
					153.12,
					-30.95,
					153.19,
					-31.51,
					153.04,
					-31.9,
					152.85,
					-32.09,
					152.65,
					-32.52,
					152.61,
					-32.84,
					152.27,
					-32.97,
					151.88,
					-33.55,
					151.53,
					-33.62,
					151.41,
					-34.01,
					151.36,
					-34.37,
					151.03,
					-34.65,
					150.99,
					-34.87,
					150.87,
					-35.1,
					150.93,
					-35.27,
					150.8,
					-35.31,
					150.61,
					-35.82,
					150.29,
					-36.14,
					150.26,
					-36.27,
					150.33,
					-36.36,
					150.23,
					-36.92,
					150.01,
					-37.26,
					150.15,
					-37.35,
					150.06,
					-37.56,
					150.06,
					-37.88,
					149.49,
					-37.94,
					148.12,
					-38.13,
					147.69,
					-38.85,
					146.71,
					-38.86,
					146.58,
					-39.09,
					146.58,
					-39.26,
					146.49
				]
			},
			{
				"points": [
					-43.71,
					146.38,
					-43.6,
					146.24,
					-43.64,
					145.95,
					-42.68,
					145.16,
					-42.22,
					145.05,
					-42.08,
					145.13,
					-41.75,
					144.81,
					-41.05,
					144.5,
					-40.82,
					144.59,
					-40.48,
					144.59,
					-40.3,
					144.73,
					-40.29,
					144.99,
					-40.53,
					145.03,
					-40.67,
					145.16,
					-40.6,
					145.28,
					-40.75,
					145.4,
					-41.06,
					146.38,
					-40.87,
					146.99,
					-40.87,
					147.43,
					-40.67,
					147.61,
					-40.74,
					147.81,
					-40.64,
					147.89,
					-40.63,
					148.05,
					-40.43,
					147.89,
					-40.36,
					147.69,
					-40.21,
					147.71,
					-40.1,
					147.61,
					-39.8,
					147.68,
					-39.69,
					147.56,
					-39.58,
					147.64,
					-39.64,
					147.78,
					-39.54,
					148.06,
					-39.7,
					148.1,
					-39.89,
					148.44,
					-40.25,
					148.43,
					-40.43,
					148.59,
					-40.69,
					148.22,
					-40.96,
					148.45,
					-41.82,
					148.37,
					-42.36,
					148.44,
					-42.44,
					148.37,
					-42.37,
					148.14,
					-42.48,
					148.12,
					-42.68,
					148.26,
					-42.83,
					148.06,
					-43.28,
					148.1,
					-43.34,
					147.75,
					-43.12,
					147.57,
					-43.62,
					147.33,
					-43.57,
					147.05,
					-43.74,
					146.88,
					-43.67,
					146.56,
					-43.71,
					146.38
				]
			},
			{
				"points": [
					-40.25,
					143.96,
					-40.2,
					143.82,
					-39.68,
					143.7,
					-39.48,
					143.91,
					-39.57,
					144.15,
					-39.66,
					144.21,
					-40.08,
					144.19,
					-40.25,
					143.96
				]
			},
			{
				"points": [
					-39.57,
					147.41,
					-39.55,
					147.18,
					-39.37,
					147.19,
					-39.38,
					147.43,
					-39.57,
					147.41
				]
			}
		],
		"transitions": [
			[
				1317499200,
				660,
				[
					"EST"
				]
			],
			[
				1333224000,
				600,
				[
					"EST"
				]
			],
			[
				1349553600,
				660,
				[
					"EST"
				]
			],
			[
				1365278400,
				600,
				[
					"EST"
				]
			],
			[
				1381003200,
				660,
				[
					"EST"
				]
			],
			[
				1396728000,
				600,
				[
					"EST"
				]
			],
			[
				1412452800,
				660,
				[
					"EST"
				]
			],
			[
				1428177600,
				600,
				[
					"EST"
				]
			],
			[
				1443902400,
				660,
				[
					"EST"
				]
			],
			[
				1459627200,
				600,
				[
					"EST"
				]
			],
			[
				1475352000,
				660,
				[
					"EST"
				]
			],
			[
				1491076800,
				600,
				[
					"EST"
				]
			],
			[
				1506801600,
				660,
				[
					"EST"
				]
			],
			[
				1522526400,
				600,
				[
					"EST"
				]
			],
			[
				1538856000,
				660,
				[
					"EST"
				]
			],
			[
				1554580800,
				600,
				[
					"EST"
				]
			],
			[
				1570305600,
				660,
				[
					"EST"
				]
			],
			[
				1586030400,
				600,
				[
					"EST"
				]
			],
			[
				1601755200,
				660,
				[
					"EST"
				]
			],
			[
				1617480000,
				600,
				[
					"EST"
				]
			],
			[
				1633204800,
				660,
				[
					"EST"
				]
			],
			[
				1648929600,
				600,
				[
					"EST"
				]
			],
			[
				1664654400,
				660,
				[
					"EST"
				]
			],
			[
				1680379200,
				600,
				[
					"EST"
				]
			],
			[
				1696104000,
				660,
				[
					"EST"
				]
			],
			[
				1712433600,
				600,
				[
					"EST"
				]
			],
			[
				1728158400,
				660,
				[
					"EST"
				]
			],
			[
				1743883200,
				600,
				[
					"EST"
				]
			],
			[
				1759608000,
				660,
				[
					"EST"
				]
			],
			[
				1775332800,
				600,
				[
					"EST"
				]
			],
			[
				1791057600,
				660,
				[
					"EST"
				]
			],
			[
				1806782400,
				600,
				[
					"EST"
				]
			],
			[
				1822507200,
				660,
				[
					"EST"
				]
			],
			[
				1838232000,
				600,
				[
					"EST"
				]
			],
			[
				1853956800,
				660,
				[
					"EST"
				]
			],
			[
				1869681600,
				600,
				[
					"EST"
				]
			],
			[
				1886011200,
				660,
				[
					"EST"
				]
			],
			[
				1901736000,
				600,
				[
					"EST"
				]
			],
			[
				1917460800,
				660,
				[
					"EST"
				]
			],
			[
				1933185600,
				600,
				[
					"EST"
				]
			],
			[
				1948910400,
				660,
				[
					"EST"
				]
			],
			[
				1964635200,
				600,
				[
					"EST"
				]
			],
			[
				1980360000,
				660,
				[
					"EST"
				]
			],
			[
				1996084800,
				600,
				[
					"EST"
				]
			],
			[
				2011809600,
				660,
				[
					"EST"
				]
			],
			[
				2027534400,
				600,
				[
					"EST"
				]
			],
			[
				2043259200,
				660,
				[
					"EST"
				]
			],
			[
				2058984000,
				600,
				[
					"EST"
				]
			],
			[
				2075313600,
				660,
				[
					"EST"
				]
			],
			[
				2091038400,
				600,
				[
					"EST"
				]
			],
			[
				2106763200,
				660,
				[
					"EST"
				]
			],
			[
				2122488000,
				600,
				[
					"EST"
				]
			],
			[
				2138212800,
				660,
				[
					"EST"
				]
			]
		],
		"name": "Australia/Melbourne"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-31.67,
					159.16,
					-31.64,
					158.97,
					-31.41,
					158.99,
					-31.51,
					159.2,
					-31.67,
					159.16
				]
			}
		],
		"transitions": [
			[
				1317497400,
				660,
				[
					"LHST"
				]
			],
			[
				1333220400,
				630,
				[
					"LHST"
				]
			],
			[
				1349551800,
				660,
				[
					"LHST"
				]
			],
			[
				1365274800,
				630,
				[
					"LHST"
				]
			],
			[
				1381001400,
				660,
				[
					"LHST"
				]
			],
			[
				1396724400,
				630,
				[
					"LHST"
				]
			],
			[
				1412451000,
				660,
				[
					"LHST"
				]
			],
			[
				1428174000,
				630,
				[
					"LHST"
				]
			],
			[
				1443900600,
				660,
				[
					"LHST"
				]
			],
			[
				1459623600,
				630,
				[
					"LHST"
				]
			],
			[
				1475350200,
				660,
				[
					"LHST"
				]
			],
			[
				1491073200,
				630,
				[
					"LHST"
				]
			],
			[
				1506799800,
				660,
				[
					"LHST"
				]
			],
			[
				1522522800,
				630,
				[
					"LHST"
				]
			],
			[
				1538854200,
				660,
				[
					"LHST"
				]
			],
			[
				1554577200,
				630,
				[
					"LHST"
				]
			],
			[
				1570303800,
				660,
				[
					"LHST"
				]
			],
			[
				1586026800,
				630,
				[
					"LHST"
				]
			],
			[
				1601753400,
				660,
				[
					"LHST"
				]
			],
			[
				1617476400,
				630,
				[
					"LHST"
				]
			],
			[
				1633203000,
				660,
				[
					"LHST"
				]
			],
			[
				1648926000,
				630,
				[
					"LHST"
				]
			],
			[
				1664652600,
				660,
				[
					"LHST"
				]
			],
			[
				1680375600,
				630,
				[
					"LHST"
				]
			],
			[
				1696102200,
				660,
				[
					"LHST"
				]
			],
			[
				1712430000,
				630,
				[
					"LHST"
				]
			],
			[
				1728156600,
				660,
				[
					"LHST"
				]
			],
			[
				1743879600,
				630,
				[
					"LHST"
				]
			],
			[
				1759606200,
				660,
				[
					"LHST"
				]
			],
			[
				1775329200,
				630,
				[
					"LHST"
				]
			],
			[
				1791055800,
				660,
				[
					"LHST"
				]
			],
			[
				1806778800,
				630,
				[
					"LHST"
				]
			],
			[
				1822505400,
				660,
				[
					"LHST"
				]
			],
			[
				1838228400,
				630,
				[
					"LHST"
				]
			],
			[
				1853955000,
				660,
				[
					"LHST"
				]
			],
			[
				1869678000,
				630,
				[
					"LHST"
				]
			],
			[
				1886009400,
				660,
				[
					"LHST"
				]
			],
			[
				1901732400,
				630,
				[
					"LHST"
				]
			],
			[
				1917459000,
				660,
				[
					"LHST"
				]
			],
			[
				1933182000,
				630,
				[
					"LHST"
				]
			],
			[
				1948908600,
				660,
				[
					"LHST"
				]
			],
			[
				1964631600,
				630,
				[
					"LHST"
				]
			],
			[
				1980358200,
				660,
				[
					"LHST"
				]
			],
			[
				1996081200,
				630,
				[
					"LHST"
				]
			],
			[
				2011807800,
				660,
				[
					"LHST"
				]
			],
			[
				2027530800,
				630,
				[
					"LHST"
				]
			],
			[
				2043257400,
				660,
				[
					"LHST"
				]
			],
			[
				2058980400,
				630,
				[
					"LHST"
				]
			],
			[
				2075311800,
				660,
				[
					"LHST"
				]
			],
			[
				2091034800,
				630,
				[
					"LHST"
				]
			],
			[
				2106761400,
				660,
				[
					"LHST"
				]
			],
			[
				2122484400,
				630,
				[
					"LHST"
				]
			],
			[
				2138211000,
				660,
				[
					"LHST"
				]
			]
		],
		"name": "Australia/Lord_Howe"
	},
	{
		"hoverRegion": [
			{
				"points": [
					9.01,
					78.65,
					9,
					78.45,
					8.86,
					78.29,
					8.3,
					78.15,
					7.96,
					77.56,
					8.03,
					77.25,
					8.26,
					76.94,
					8.86,
					76.44,
					11.3,
					75.63,
					11.63,
					75.43,
					12.02,
					75.06,
					13.23,
					74.57,
					13.81,
					74.5,
					13.98,
					74.21,
					14.13,
					74.33,
					14.44,
					74.25,
					14.63,
					74.16,
					14.75,
					73.95,
					15.25,
					73.77,
					15.31,
					73.65,
					15.42,
					73.67,
					15.77,
					73.53,
					15.86,
					73.33,
					17.05,
					73.18,
					18.51,
					72.8,
					18.67,
					72.69,
					19.3,
					72.67,
					19.81,
					72.55,
					20.57,
					72.77,
					21.09,
					72.51,
					21.6,
					72.5,
					21.48,
					72.35,
					21.1,
					72.15,
					20.77,
					71.49,
					20.59,
					70.77,
					20.92,
					70.14,
					22.28,
					68.82,
					22.58,
					69.04,
					22.55,
					69.21,
					22.62,
					69.37,
					22.51,
					69.45,
					22.57,
					69.76,
					22.69,
					69.9,
					22.67,
					70.11,
					22.83,
					70.21,
					22.75,
					69.89,
					22.63,
					69.73,
					22.72,
					69.17,
					23.05,
					68.59,
					23.34,
					68.31,
					23.47,
					68.29,
					23.59,
					68.05,
					23.95,
					68.13,
					24.06,
					68.29,
					24.07,
					68.65,
					24.4,
					68.76,
					24.34,
					69.03,
					24.39,
					69.61,
					24.28,
					69.76,
					24.27,
					69.94,
					24.39,
					70.08,
					24.52,
					70.52,
					24.48,
					70.64,
					24.34,
					70.67,
					24.42,
					70.89,
					24.64,
					70.88,
					24.71,
					70.95,
					25.08,
					70.78,
					25.35,
					70.56,
					25.59,
					70.55,
					25.61,
					70.22,
					25.91,
					69.99,
					26.45,
					70.04,
					26.49,
					69.76,
					26.68,
					69.42,
					27.21,
					69.48,
					28.11,
					70.32,
					28.1,
					70.62,
					27.81,
					70.85,
					28.05,
					71.8,
					28.85,
					72.31,
					29.11,
					72.86,
					29.6,
					73.17,
					30.01,
					73.31,
					30.24,
					73.81,
					30.38,
					73.76,
					30.52,
					73.84,
					31.1,
					74.44,
					31.45,
					74.52,
					31.7,
					74.4,
					31.88,
					74.45,
					32.15,
					74.86,
					32.22,
					75.21,
					32.37,
					75.03,
					32.39,
					74.63,
					32.63,
					74.53,
					32.83,
					74.24,
					32.96,
					74.22,
					33.13,
					73.92,
					33.44,
					74.05,
					33.74,
					73.84,
					33.9,
					74.06,
					33.98,
					73.79,
					34.24,
					73.85,
					34.35,
					73.65,
					34.75,
					73.86,
					34.91,
					74.39,
					34.62,
					75.73,
					34.89,
					76.43,
					34.88,
					76.61,
					35.02,
					76.7,
					35.04,
					76.9,
					35.6,
					77.81,
					35.57,
					78.16,
					35.47,
					78.2,
					35.33,
					78.11,
					34.78,
					78.32,
					34.7,
					78.63,
					34.37,
					79.08,
					34.13,
					79.02,
					34.01,
					78.83,
					33.67,
					78.84,
					33.26,
					79.26,
					33.07,
					79.27,
					32.96,
					79.38,
					32.48,
					79.35,
					32.29,
					79.17,
					32.23,
					78.95,
					32.37,
					78.73,
					32.54,
					78.67,
					32.49,
					78.56,
					32.23,
					78.57,
					32,
					78.81,
					31.81,
					78.81,
					31.64,
					78.94,
					31.4,
					78.9,
					31.22,
					79.06,
					31.2,
					79.38,
					31.05,
					79.64,
					31.07,
					79.92,
					30.68,
					80.26,
					30.57,
					80.64,
					30.23,
					81.16,
					30.13,
					81.13,
					30.1,
					80.95,
					29.69,
					80.48,
					29.55,
					80.5,
					29.42,
					80.37,
					29.11,
					80.37,
					29.01,
					80.23,
					28.88,
					80.19,
					28.74,
					80.42,
					28.78,
					80.62,
					28.46,
					81.25,
					28.27,
					81.4,
					27.97,
					81.9,
					28.03,
					82.07,
					27.79,
					82.47,
					27.81,
					82.75,
					27.6,
					82.84,
					27.49,
					83.75,
					27.61,
					84.2,
					27.49,
					84.34,
					27.41,
					84.69,
					27.12,
					84.78,
					26.9,
					85.28,
					26.97,
					85.67,
					26.71,
					85.88,
					26.77,
					86.01,
					26.73,
					86.35,
					26.54,
					86.73,
					26.69,
					87.06,
					26.48,
					87.31,
					26.59,
					87.89,
					26.54,
					87.97,
					26.75,
					88.06,
					27.13,
					87.87,
					27.56,
					87.94,
					27.8,
					88.07,
					28,
					88.03,
					28.23,
					88.63,
					28.04,
					88.93,
					27.83,
					88.97,
					27.53,
					88.88,
					27.29,
					89.03,
					27.12,
					88.92,
					26.92,
					89.16,
					26.96,
					89.4,
					26.82,
					89.85,
					26.86,
					90.12,
					27.01,
					90.35,
					26.88,
					90.71,
					26.88,
					91.29,
					26.98,
					91.44,
					26.91,
					91.58,
					27,
					91.95,
					27.32,
					91.98,
					27.3,
					91.74,
					27.4,
					91.6,
					27.65,
					91.49,
					27.81,
					91.56,
					27.83,
					91.96,
					27.98,
					92.25,
					27.92,
					92.35,
					27.95,
					92.5,
					28.01,
					92.6,
					28.21,
					92.63,
					28.45,
					93.11,
					28.59,
					93.12,
					28.74,
					93.26,
					28.87,
					93.88,
					29.07,
					93.98,
					29.41,
					94.64,
					29.27,
					94.85,
					29.19,
					95.23,
					29.56,
					96.06,
					29.36,
					96.28,
					29.35,
					96.46,
					29.16,
					96.46,
					29.12,
					96.6,
					29,
					96.6,
					28.78,
					96.73,
					28.56,
					96.58,
					28.43,
					97,
					28.47,
					97.16,
					28.24,
					97.45,
					27.81,
					97.45,
					27.79,
					97.29,
					27.56,
					97,
					27.07,
					97.26,
					27.06,
					96.85,
					27.24,
					96.67,
					27.17,
					96.27,
					26.6,
					95.49,
					26.52,
					95.23,
					26.31,
					95.18,
					26.02,
					95.28,
					25.87,
					95.13,
					25.65,
					95.1,
					25.32,
					94.72,
					24.99,
					94.84,
					24.42,
					94.49,
					23.78,
					94.24,
					23.88,
					93.74,
					23.84,
					93.5,
					23.12,
					93.49,
					22.9,
					93.34,
					22.9,
					93.23,
					22.21,
					93.29,
					22.07,
					93.13,
					21.92,
					93.09,
					21.84,
					92.94,
					21.94,
					92.76,
					21.87,
					92.6,
					21.92,
					92.51,
					22.67,
					92.41,
					22.93,
					92.26,
					23.57,
					92.19,
					23.53,
					92.07,
					23.24,
					91.89,
					23.03,
					91.92,
					22.82,
					91.6,
					22.97,
					91.47,
					23,
					91.27,
					23.6,
					91.04,
					24.19,
					91.31,
					24.19,
					91.52,
					24.32,
					91.61,
					24.31,
					91.83,
					24.46,
					91.9,
					24.49,
					92.04,
					24.89,
					92.17,
					24.94,
					92.3,
					25.07,
					92.03,
					25.03,
					90.45,
					25.17,
					89.83,
					25.26,
					89.75,
					25.99,
					89.7,
					25.85,
					89.58,
					25.9,
					89.33,
					26.13,
					89.05,
					26.16,
					88.66,
					26.27,
					88.57,
					26.07,
					88.27,
					25.92,
					88.24,
					25.62,
					88.58,
					25.62,
					88.87,
					25.44,
					88.93,
					25.3,
					89.12,
					25.06,
					88.95,
					25.08,
					88.55,
					24.82,
					88.42,
					24.79,
					88.25,
					24.68,
					88.16,
					24.32,
					88.82,
					23.96,
					88.88,
					23.8,
					88.7,
					23.69,
					88.68,
					23.54,
					88.89,
					23.33,
					88.86,
					23.22,
					89.1,
					22.99,
					88.98,
					22.87,
					89.07,
					22.32,
					89.11,
					22.18,
					89.21,
					21.85,
					89.13,
					21.58,
					89.2,
					21.44,
					88.94,
					21.48,
					88.38,
					21.42,
					88.22,
					21.56,
					87.97,
					21.71,
					87.96,
					21.61,
					87.86,
					21.41,
					87.18,
					21.15,
					86.95,
					20.64,
					87.14,
					20.46,
					86.91,
					20.3,
					86.89,
					20.1,
					86.62,
					19.89,
					86.48,
					19.6,
					85.65,
					19.2,
					85.03,
					18.24,
					84.22,
					17.99,
					83.74,
					17.49,
					83.26,
					17.01,
					82.44,
					16.88,
					82.48,
					16.5,
					82.39,
					16.21,
					81.77,
					16.2,
					81.39,
					15.69,
					81.11,
					15.61,
					80.99,
					15.59,
					80.77,
					15.76,
					80.69,
					15.62,
					80.37,
					15.07,
					80.16,
					14.59,
					80.3,
					14.09,
					80.24,
					13.28,
					80.45,
					12.45,
					80.26,
					12,
					79.98,
					11.6,
					79.87,
					11.18,
					79.96,
					10.25,
					79.97,
					10.17,
					79.38,
					9.97,
					79.35,
					9.48,
					79.03,
					9.4,
					79.11,
					9.41,
					79.38,
					9.09,
					79.53,
					9.08,
					78.74,
					9.01,
					78.65
				]
			},
			{
				"points": [
					8.13,
					79.59,
					8.56,
					79.68,
					8.72,
					79.84,
					8.88,
					79.79,
					9.09,
					79.57,
					9.17,
					79.66,
					9.18,
					79.87,
					9.1,
					79.95,
					9.17,
					79.97,
					9.25,
					79.86,
					9.46,
					79.89,
					9.37,
					79.68,
					9.45,
					79.55,
					9.59,
					79.55,
					9.85,
					79.8,
					9.92,
					80.28,
					9.34,
					80.9,
					8.59,
					81.32,
					8.55,
					81.44,
					8.08,
					81.57,
					7.66,
					81.88,
					7.03,
					81.98,
					6.41,
					81.78,
					6.09,
					81.36,
					5.81,
					80.62,
					6.01,
					80.05,
					6.81,
					79.75,
					8.13,
					79.59
				]
			},
			{
				"points": [
					10.44,
					92.56,
					10.44,
					92.28,
					10.77,
					92.24,
					11.08,
					92.62,
					11.51,
					92.44,
					11.82,
					92.41,
					12.97,
					92.56,
					13.62,
					92.79,
					13.75,
					92.93,
					13.76,
					93.08,
					13.69,
					93.17,
					13.44,
					93.22,
					12.37,
					93.08,
					12.32,
					93.19,
					12.15,
					93.23,
					11.9,
					93.16,
					11.77,
					93.2,
					11.66,
					93.07,
					11.76,
					92.93,
					11.07,
					92.73,
					10.95,
					92.78,
					10.82,
					92.65,
					10.69,
					92.69,
					10.44,
					92.56
				]
			},
			{
				"points": [
					6.69,
					93.93,
					6.65,
					93.78,
					6.99,
					93.55,
					7.37,
					93.51,
					7.54,
					93.65,
					7.5,
					93.78,
					7.03,
					94.05,
					6.69,
					93.93
				]
			}
		],
		"transitions": [
			[
				0,
				330,
				[
					"IST"
				]
			]
		],
		"name": "Asia/Colombo"
	},
	{
		"hoverRegion": [
			{
				"points": [
					21.44,
					-82.14,
					21.46,
					-82.5,
					21.33,
					-82.83,
					21.37,
					-83.13,
					21.62,
					-83.3,
					21.84,
					-83.32,
					21.87,
					-83.67,
					22.07,
					-83.71,
					22.06,
					-83.84,
					21.81,
					-83.99,
					21.78,
					-84.23,
					21.66,
					-84.42,
					21.67,
					-84.57,
					21.76,
					-84.63,
					21.71,
					-84.85,
					21.88,
					-85.06,
					22.15,
					-84.54,
					22.46,
					-84.54,
					22.92,
					-83.83,
					23.29,
					-82.22,
					23.26,
					-81.59,
					23.18,
					-81.49,
					23.39,
					-80.88,
					23.25,
					-80.19,
					22.72,
					-79.29,
					22.8,
					-78.93,
					22.7,
					-78.73,
					22.65,
					-78.35,
					22.56,
					-78.23,
					22.58,
					-78.1,
					22.4,
					-77.78,
					22.01,
					-77.52,
					21.75,
					-77.08,
					21.53,
					-76.85,
					21.22,
					-76.08,
					21.23,
					-75.67,
					21.08,
					-75.48,
					20.88,
					-75.49,
					20.72,
					-74.68,
					20.44,
					-74.43,
					20.41,
					-74.16,
					20.2,
					-74.02,
					19.97,
					-74.21,
					19.93,
					-74.77,
					19.79,
					-75.07,
					19.88,
					-76.22,
					19.74,
					-77.77,
					19.89,
					-77.83,
					20.18,
					-77.63,
					20.33,
					-77.33,
					20.57,
					-77.34,
					20.52,
					-77.47,
					20.6,
					-77.55,
					20.5,
					-77.51,
					20.4,
					-77.6,
					20.47,
					-77.74,
					20.42,
					-77.88,
					20.55,
					-78,
					20.41,
					-78.35,
					20.57,
					-78.77,
					21.04,
					-79.52,
					21.14,
					-79.55,
					21.22,
					-79.48,
					21.2,
					-79.25,
					21.06,
					-79.1,
					21.19,
					-78.94,
					21.09,
					-78.84,
					20.9,
					-78.87,
					20.95,
					-78.61,
					20.86,
					-78.41,
					21.06,
					-78.6,
					20.99,
					-78.67,
					21.04,
					-78.82,
					21.2,
					-78.78,
					21.18,
					-78.63,
					21.34,
					-78.67,
					21.29,
					-78.85,
					21.47,
					-78.94,
					21.43,
					-79.19,
					21.5,
					-79.46,
					21.38,
					-79.47,
					21.34,
					-79.6,
					21.44,
					-79.68,
					21.55,
					-79.61,
					21.57,
					-79.88,
					21.93,
					-80.45,
					22,
					-81.13,
					21.89,
					-81.71,
					21.73,
					-81.72,
					21.77,
					-81.28,
					21.66,
					-81.27,
					21.51,
					-81.44,
					21.53,
					-81.81,
					21.44,
					-82.14
				]
			},
			{
				"points": [
					23.45,
					-79.44,
					23.41,
					-79.59,
					23.54,
					-79.71,
					23.67,
					-79.69,
					23.69,
					-79.59,
					23.58,
					-79.45,
					23.45,
					-79.44
				]
			},
			{
				"points": [
					21.56,
					-81.07,
					21.58,
					-81.22,
					21.73,
					-81.21,
					21.72,
					-81.04,
					21.56,
					-81.07
				]
			}
		],
		"transitions": [
			[
				1321178400,
				-300,
				[
					"CST"
				]
			],
			[
				1331456400,
				-240,
				[
					"CDT"
				]
			],
			[
				1351414800,
				-300,
				[
					"CST"
				]
			],
			[
				1362906000,
				-240,
				[
					"CDT"
				]
			],
			[
				1382864400,
				-300,
				[
					"CST"
				]
			],
			[
				1394355600,
				-240,
				[
					"CDT"
				]
			],
			[
				1414314000,
				-300,
				[
					"CST"
				]
			],
			[
				1425805200,
				-240,
				[
					"CDT"
				]
			],
			[
				1445763600,
				-300,
				[
					"CST"
				]
			],
			[
				1457859600,
				-240,
				[
					"CDT"
				]
			],
			[
				1477818000,
				-300,
				[
					"CST"
				]
			],
			[
				1489309200,
				-240,
				[
					"CDT"
				]
			],
			[
				1509267600,
				-300,
				[
					"CST"
				]
			],
			[
				1520758800,
				-240,
				[
					"CDT"
				]
			],
			[
				1540717200,
				-300,
				[
					"CST"
				]
			],
			[
				1552208400,
				-240,
				[
					"CDT"
				]
			],
			[
				1572166800,
				-300,
				[
					"CST"
				]
			],
			[
				1583658000,
				-240,
				[
					"CDT"
				]
			],
			[
				1603616400,
				-300,
				[
					"CST"
				]
			],
			[
				1615712400,
				-240,
				[
					"CDT"
				]
			],
			[
				1635670800,
				-300,
				[
					"CST"
				]
			],
			[
				1647162000,
				-240,
				[
					"CDT"
				]
			],
			[
				1667120400,
				-300,
				[
					"CST"
				]
			],
			[
				1678611600,
				-240,
				[
					"CDT"
				]
			],
			[
				1698570000,
				-300,
				[
					"CST"
				]
			],
			[
				1710061200,
				-240,
				[
					"CDT"
				]
			],
			[
				1730019600,
				-300,
				[
					"CST"
				]
			],
			[
				1741510800,
				-240,
				[
					"CDT"
				]
			],
			[
				1761469200,
				-300,
				[
					"CST"
				]
			],
			[
				1772960400,
				-240,
				[
					"CDT"
				]
			],
			[
				1792918800,
				-300,
				[
					"CST"
				]
			],
			[
				1805014800,
				-240,
				[
					"CDT"
				]
			],
			[
				1824973200,
				-300,
				[
					"CST"
				]
			],
			[
				1836464400,
				-240,
				[
					"CDT"
				]
			],
			[
				1856422800,
				-300,
				[
					"CST"
				]
			],
			[
				1867914000,
				-240,
				[
					"CDT"
				]
			],
			[
				1887872400,
				-300,
				[
					"CST"
				]
			],
			[
				1899363600,
				-240,
				[
					"CDT"
				]
			],
			[
				1919322000,
				-300,
				[
					"CST"
				]
			],
			[
				1930813200,
				-240,
				[
					"CDT"
				]
			],
			[
				1950771600,
				-300,
				[
					"CST"
				]
			],
			[
				1962867600,
				-240,
				[
					"CDT"
				]
			],
			[
				1982826000,
				-300,
				[
					"CST"
				]
			],
			[
				1994317200,
				-240,
				[
					"CDT"
				]
			],
			[
				2014275600,
				-300,
				[
					"CST"
				]
			],
			[
				2025766800,
				-240,
				[
					"CDT"
				]
			],
			[
				2045725200,
				-300,
				[
					"CST"
				]
			],
			[
				2057216400,
				-240,
				[
					"CDT"
				]
			],
			[
				2077174800,
				-300,
				[
					"CST"
				]
			],
			[
				2088666000,
				-240,
				[
					"CDT"
				]
			],
			[
				2108624400,
				-300,
				[
					"CST"
				]
			],
			[
				2120115600,
				-240,
				[
					"CDT"
				]
			],
			[
				2140074000,
				-300,
				[
					"CST"
				]
			]
		],
		"name": "America/Havana"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-27.1,
					15.12,
					-26.71,
					14.97,
					-26.51,
					15.02,
					-26.3,
					14.81,
					-26.09,
					14.86,
					-25.75,
					14.71,
					-25.55,
					14.76,
					-25.29,
					14.69,
					-25.08,
					14.75,
					-24.59,
					14.49,
					-24.09,
					14.35,
					-23.63,
					14.4,
					-23,
					14.3,
					-22.77,
					14.41,
					-22.57,
					14.39,
					-20.92,
					13.32,
					-20.29,
					13.09,
					-20.13,
					12.94,
					-19.21,
					12.51,
					-18.81,
					12.24,
					-18.53,
					11.92,
					-17.8,
					11.62,
					-17.16,
					11.68,
					-17.03,
					12.09,
					-17.12,
					12.27,
					-17.13,
					12.53,
					-16.85,
					13.16,
					-16.91,
					13.51,
					-17.05,
					13.59,
					-17.32,
					13.98,
					-17.28,
					18.42,
					-17.71,
					18.94,
					-17.8,
					19.77,
					-17.75,
					20.3,
					-17.92,
					20.82,
					-17.82,
					21.22,
					-17.91,
					21.45,
					-17.36,
					24.21,
					-17.44,
					24.98,
					-17.7,
					25.32,
					-17.86,
					25.31,
					-17.91,
					24.95,
					-18.17,
					24.59,
					-18.07,
					24.4,
					-18.11,
					24.24,
					-18.61,
					23.64,
					-18.56,
					23.53,
					-18.11,
					23.24,
					-18.42,
					21.48,
					-18.42,
					21.1,
					-22.04,
					21.1,
					-22.1,
					21.01,
					-22.11,
					20.1,
					-28.51,
					20.06,
					-28.62,
					19.63,
					-28.8,
					19.52,
					-28.83,
					19.38,
					-28.97,
					19.37,
					-29.06,
					19.18,
					-28.95,
					18.72,
					-29.02,
					18.15,
					-28.87,
					17.88,
					-28.82,
					17.35,
					-28.5,
					17.22,
					-28.37,
					17.27,
					-28.32,
					17.13,
					-28.15,
					17.03,
					-28.36,
					16.87,
					-28.51,
					16.85,
					-28.74,
					16.41,
					-28.05,
					15.61,
					-27.42,
					15.22,
					-27.1,
					15.12
				]
			}
		],
		"transitions": [
			[
				1315112400,
				120,
				[
					"WAST"
				]
			],
			[
				1333252800,
				60,
				[
					"WAT"
				]
			],
			[
				1346562000,
				120,
				[
					"WAST"
				]
			],
			[
				1365307200,
				60,
				[
					"WAT"
				]
			],
			[
				1378011600,
				120,
				[
					"WAST"
				]
			],
			[
				1396756800,
				60,
				[
					"WAT"
				]
			],
			[
				1410066000,
				120,
				[
					"WAST"
				]
			],
			[
				1428206400,
				60,
				[
					"WAT"
				]
			],
			[
				1441515600,
				120,
				[
					"WAST"
				]
			],
			[
				1459656000,
				60,
				[
					"WAT"
				]
			],
			[
				1472965200,
				120,
				[
					"WAST"
				]
			],
			[
				1491105600,
				60,
				[
					"WAT"
				]
			],
			[
				1504414800,
				120,
				[
					"WAST"
				]
			],
			[
				1522555200,
				60,
				[
					"WAT"
				]
			],
			[
				1535864400,
				120,
				[
					"WAST"
				]
			],
			[
				1554609600,
				60,
				[
					"WAT"
				]
			],
			[
				1567314000,
				120,
				[
					"WAST"
				]
			],
			[
				1586059200,
				60,
				[
					"WAT"
				]
			],
			[
				1599368400,
				120,
				[
					"WAST"
				]
			],
			[
				1617508800,
				60,
				[
					"WAT"
				]
			],
			[
				1630818000,
				120,
				[
					"WAST"
				]
			],
			[
				1648958400,
				60,
				[
					"WAT"
				]
			],
			[
				1662267600,
				120,
				[
					"WAST"
				]
			],
			[
				1680408000,
				60,
				[
					"WAT"
				]
			],
			[
				1693717200,
				120,
				[
					"WAST"
				]
			],
			[
				1712462400,
				60,
				[
					"WAT"
				]
			],
			[
				1725166800,
				120,
				[
					"WAST"
				]
			],
			[
				1743912000,
				60,
				[
					"WAT"
				]
			],
			[
				1757221200,
				120,
				[
					"WAST"
				]
			],
			[
				1775361600,
				60,
				[
					"WAT"
				]
			],
			[
				1788670800,
				120,
				[
					"WAST"
				]
			],
			[
				1806811200,
				60,
				[
					"WAT"
				]
			],
			[
				1820120400,
				120,
				[
					"WAST"
				]
			],
			[
				1838260800,
				60,
				[
					"WAT"
				]
			],
			[
				1851570000,
				120,
				[
					"WAST"
				]
			],
			[
				1869710400,
				60,
				[
					"WAT"
				]
			],
			[
				1883019600,
				120,
				[
					"WAST"
				]
			],
			[
				1901764800,
				60,
				[
					"WAT"
				]
			],
			[
				1914469200,
				120,
				[
					"WAST"
				]
			],
			[
				1933214400,
				60,
				[
					"WAT"
				]
			],
			[
				1946523600,
				120,
				[
					"WAST"
				]
			],
			[
				1964664000,
				60,
				[
					"WAT"
				]
			],
			[
				1977973200,
				120,
				[
					"WAST"
				]
			],
			[
				1996113600,
				60,
				[
					"WAT"
				]
			],
			[
				2009422800,
				120,
				[
					"WAST"
				]
			],
			[
				2027563200,
				60,
				[
					"WAT"
				]
			],
			[
				2040872400,
				120,
				[
					"WAST"
				]
			],
			[
				2059012800,
				60,
				[
					"WAT"
				]
			],
			[
				2072322000,
				120,
				[
					"WAST"
				]
			],
			[
				2091067200,
				60,
				[
					"WAT"
				]
			],
			[
				2104376400,
				120,
				[
					"WAST"
				]
			],
			[
				2122516800,
				60,
				[
					"WAT"
				]
			],
			[
				2135826000,
				120,
				[
					"WAST"
				]
			]
		],
		"name": "Africa/Windhoek"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-14.4,
					-76.24,
					-14.21,
					-76.39,
					-14,
					-76.4,
					-13.88,
					-76.57,
					-13.67,
					-76.48,
					-13.64,
					-76.34,
					-13.42,
					-76.31,
					-12.46,
					-76.91,
					-12.13,
					-77.35,
					-11.76,
					-77.28,
					-11.59,
					-77.38,
					-11.36,
					-77.75,
					-10.99,
					-77.77,
					-10.16,
					-78.28,
					-9.83,
					-78.34,
					-9.21,
					-78.72,
					-8.65,
					-78.87,
					-8.51,
					-79.02,
					-8.27,
					-79.09,
					-7.89,
					-79.44,
					-7.82,
					-79.6,
					-7.71,
					-79.57,
					-7.17,
					-79.77,
					-6.78,
					-80.1,
					-6.4,
					-80.73,
					-6.56,
					-80.78,
					-6.56,
					-80.88,
					-6.42,
					-80.97,
					-6.3,
					-80.91,
					-6.09,
					-81.21,
					-5.8,
					-81.21,
					-5.65,
					-80.95,
					-5.25,
					-81.3,
					-4.99,
					-81.22,
					-4.69,
					-81.43,
					-4.18,
					-81.32,
					-3.66,
					-80.85,
					-3.12,
					-80.09,
					-3.16,
					-80.33,
					-3.28,
					-80.4,
					-3.26,
					-80.53,
					-3.12,
					-80.54,
					-3.05,
					-80.42,
					-2.9,
					-80.49,
					-2.77,
					-80.39,
					-2.4,
					-80.97,
					-2.17,
					-81.11,
					-2.01,
					-80.85,
					-1.59,
					-80.97,
					-1.35,
					-80.86,
					-1.02,
					-81.01,
					-0.86,
					-80.88,
					-0.8,
					-80.63,
					-0.58,
					-80.52,
					-0.32,
					-80.58,
					0.11,
					-80.16,
					0.54,
					-80.12,
					0.79,
					-80.18,
					0.92,
					-80.08,
					1.16,
					-79.46,
					1.18,
					-79.22,
					1.46,
					-78.97,
					1.54,
					-79.13,
					1.67,
					-79.13,
					1.91,
					-78.92,
					1.91,
					-78.7,
					2.16,
					-78.79,
					2.51,
					-78.63,
					2.75,
					-78.36,
					2.78,
					-77.87,
					3.08,
					-77.77,
					3.66,
					-77.3,
					4.2,
					-77.63,
					4.47,
					-77.45,
					4.75,
					-77.41,
					5.36,
					-77.5,
					5.48,
					-77.65,
					5.67,
					-77.57,
					5.76,
					-77.37,
					6.12,
					-77.59,
					6.53,
					-77.44,
					6.56,
					-77.6,
					6.71,
					-77.66,
					6.78,
					-77.79,
					6.96,
					-77.78,
					7.46,
					-78.28,
					8.05,
					-78.55,
					8.22,
					-78.41,
					8.42,
					-78.6,
					8.57,
					-78.62,
					8.9,
					-79.22,
					8.87,
					-79.42,
					8.48,
					-79.52,
					8.51,
					-79.68,
					8.14,
					-80.36,
					7.68,
					-79.9,
					7.35,
					-79.96,
					7.29,
					-80.27,
					7.12,
					-80.42,
					7.09,
					-80.9,
					7.41,
					-81.06,
					7.38,
					-81.3,
					7.53,
					-81.33,
					7.6,
					-81.54,
					7.57,
					-81.6,
					7.26,
					-81.5,
					7.1,
					-81.85,
					7.51,
					-81.99,
					7.71,
					-81.83,
					7.88,
					-81.9,
					8.01,
					-81.79,
					8.08,
					-81.98,
					7.94,
					-81.91,
					7.84,
					-82.08,
					7.95,
					-82.16,
					8.07,
					-82.11,
					7.97,
					-82.34,
					8.02,
					-82.45,
					8.19,
					-82.51,
					8.2,
					-82.71,
					7.95,
					-82.8,
					7.9,
					-82.9,
					8.19,
					-83.03,
					8.27,
					-83.14,
					8.38,
					-83.14,
					8.52,
					-82.95,
					8.78,
					-83.02,
					8.92,
					-82.89,
					9.03,
					-83.03,
					9.47,
					-83.04,
					9.71,
					-82.9,
					9.62,
					-82.65,
					9.66,
					-82.51,
					9.39,
					-82.03,
					9.24,
					-81.98,
					9.28,
					-81.84,
					9.11,
					-81.67,
					9.21,
					-81.58,
					9.18,
					-81.48,
					9.05,
					-81.43,
					8.98,
					-81.54,
					8.88,
					-81.3,
					8.98,
					-80.88,
					9.21,
					-80.56,
					9.33,
					-80.14,
					9.75,
					-79.58,
					9.65,
					-79.18,
					9.69,
					-78.84,
					9.55,
					-78.69,
					9.32,
					-77.97,
					9.09,
					-77.68,
					8.8,
					-77.48,
					8.77,
					-77.28,
					8.54,
					-77.15,
					8.33,
					-76.87,
					8.51,
					-77.03,
					8.61,
					-77.02,
					9,
					-76.41,
					9.29,
					-76.24,
					9.46,
					-76.26,
					9.54,
					-75.7,
					9.65,
					-75.79,
					9.59,
					-75.94,
					9.69,
					-76.01,
					9.89,
					-75.91,
					9.89,
					-75.75,
					10.05,
					-75.69,
					10.07,
					-75.85,
					10.19,
					-75.9,
					10.29,
					-75.69,
					10.64,
					-75.59,
					10.87,
					-75.34,
					11.22,
					-74.87,
					11.11,
					-74.33,
					11.37,
					-74.29,
					11.45,
					-74.13,
					11.37,
					-73.77,
					11.39,
					-73.31,
					11.76,
					-72.84,
					11.98,
					-72.31,
					12.3,
					-72.24,
					12.56,
					-71.63,
					12.42,
					-71.19,
					12.11,
					-71,
					11.94,
					-71.04,
					11.71,
					-71.34,
					11.55,
					-71.89,
					11.06,
					-72.17,
					11.01,
					-72.4,
					10.42,
					-72.78,
					9.82,
					-72.84,
					9.34,
					-73.12,
					9.39,
					-72.96,
					9.2,
					-72.86,
					9.16,
					-72.67,
					8.67,
					-72.55,
					8.36,
					-72.27,
					7.98,
					-72.24,
					7.87,
					-72.37,
					7.5,
					-72.36,
					7.45,
					-72.12,
					7.13,
					-71.96,
					7.18,
					-71.75,
					7.09,
					-70.97,
					7.2,
					-70.69,
					7.04,
					-70.31,
					7.09,
					-70.03,
					6.24,
					-69.4,
					6.21,
					-69.22,
					6.32,
					-69.07,
					6.24,
					-68.65,
					6.27,
					-68.32,
					6.41,
					-67.85,
					6.25,
					-67.38,
					5.99,
					-67.31,
					5.76,
					-67.5,
					5.49,
					-67.51,
					5.25,
					-67.73,
					5.02,
					-67.68,
					4.54,
					-67.76,
					3.86,
					-67.53,
					3.78,
					-67.39,
					3.4,
					-67.19,
					2.91,
					-67.6,
					2.44,
					-67.09,
					1.21,
					-66.76,
					1.13,
					-66.83,
					1.09,
					-67.17,
					1.69,
					-67.22,
					1.98,
					-67.43,
					1.64,
					-67.9,
					1.62,
					-69.74,
					1.16,
					-69.74,
					1.12,
					-69.2,
					0.89,
					-69.02,
					0.62,
					-69,
					0.54,
					-69.09,
					0.51,
					-69.39,
					0.58,
					-69.47,
					0.46,
					-69.93,
					-0.08,
					-69.95,
					-0.48,
					-69.48,
					-0.74,
					-69.47,
					-0.97,
					-69.31,
					-1.31,
					-69.25,
					-4.43,
					-69.86,
					-4.46,
					-70.23,
					-4.26,
					-70.41,
					-4.28,
					-70.71,
					-4.49,
					-70.91,
					-4.63,
					-71.86,
					-4.83,
					-72.07,
					-5.22,
					-72.77,
					-5.71,
					-72.86,
					-6.13,
					-73.12,
					-6.39,
					-72.99,
					-6.54,
					-73.03,
					-6.91,
					-73.61,
					-7.1,
					-73.67,
					-7.34,
					-73.59,
					-7.51,
					-73.85,
					-7.7,
					-73.59,
					-8.28,
					-73.43,
					-8.4,
					-73.24,
					-8.54,
					-73.22,
					-8.95,
					-72.83,
					-9.19,
					-72.85,
					-9.32,
					-72.97,
					-9.4,
					-72.29,
					-9.48,
					-72.18,
					-9.88,
					-72.04,
					-9.85,
					-71.25,
					-9.35,
					-70.66,
					-9.33,
					-70.43,
					-9.42,
					-70.39,
					-9.61,
					-70.47,
					-9.77,
					-70.42,
					-9.87,
					-70.51,
					-10.82,
					-70.51,
					-10.94,
					-70.29,
					-10.81,
					-69.93,
					-10.88,
					-69.48,
					-12.51,
					-68.56,
					-12.78,
					-68.66,
					-12.91,
					-68.84,
					-13.48,
					-68.83,
					-13.73,
					-68.92,
					-14.21,
					-68.73,
					-14.87,
					-69.25,
					-15.27,
					-69.01,
					-15.63,
					-69.29,
					-16.06,
					-69.14,
					-16.08,
					-68.91,
					-16.36,
					-68.7,
					-16.49,
					-68.88,
					-16.76,
					-68.93,
					-16.82,
					-69.09,
					-17.13,
					-69.28,
					-17.25,
					-69.45,
					-17.33,
					-69.35,
					-17.55,
					-69.36,
					-17.76,
					-69.67,
					-18.01,
					-69.64,
					-18.33,
					-69.88,
					-18.45,
					-70.39,
					-18.01,
					-70.99,
					-17.78,
					-71.46,
					-17.45,
					-71.49,
					-17.35,
					-71.57,
					-17.12,
					-72.15,
					-16.8,
					-72.5,
					-16.34,
					-73.74,
					-16.05,
					-74.11,
					-15.48,
					-75.24,
					-14.99,
					-75.59,
					-14.72,
					-76,
					-14.54,
					-76.07,
					-14.4,
					-76.24
				]
			},
			{
				"points": [
					63.89,
					-83.22,
					64.02,
					-83.33,
					64.01,
					-83.42,
					63.94,
					-83.54,
					63.74,
					-83.5,
					63.66,
					-83.56,
					63.47,
					-84.07,
					63.5,
					-84.23,
					63.18,
					-84.55,
					62.99,
					-85.21,
					63,
					-85.51,
					63.11,
					-85.7,
					63.38,
					-85.77,
					63.6,
					-85.73,
					63.55,
					-86.53,
					63.44,
					-86.96,
					63.61,
					-87.33,
					63.78,
					-87.28,
					63.98,
					-87,
					64.14,
					-86.36,
					64.26,
					-86.46,
					64.61,
					-86.49,
					64.87,
					-86.3,
					65.79,
					-86.07,
					66.03,
					-85.5,
					65.92,
					-85.39,
					65.93,
					-85.25,
					66.05,
					-85.24,
					66.19,
					-85.07,
					66.11,
					-84.69,
					65.68,
					-84.41,
					65.57,
					-84.42,
					65.41,
					-84.04,
					65.3,
					-84.02,
					65.23,
					-83.34,
					65.03,
					-83.11,
					64.84,
					-82.51,
					64.86,
					-82.31,
					64.63,
					-81.75,
					64.41,
					-81.55,
					64.31,
					-81.57,
					64.31,
					-81.33,
					64.17,
					-81.28,
					64.11,
					-81.06,
					64.22,
					-80.87,
					64.07,
					-80.5,
					63.92,
					-80.38,
					63.84,
					-80.07,
					63.73,
					-80.03,
					63.32,
					-81.05,
					63.57,
					-82.08,
					63.55,
					-82.53,
					63.72,
					-82.65,
					63.84,
					-82.58,
					63.89,
					-83.22
				]
			},
			{
				"points": [
					18.02,
					-73.49,
					17.94,
					-73.56,
					17.91,
					-73.91,
					18.15,
					-74.15,
					18.24,
					-74.47,
					18.35,
					-74.55,
					18.67,
					-74.51,
					18.78,
					-74.19,
					18.54,
					-72.76,
					18.65,
					-72.65,
					18.65,
					-72.47,
					18.82,
					-72.71,
					18.67,
					-72.7,
					18.59,
					-72.85,
					18.73,
					-73.25,
					18.87,
					-73.38,
					19.01,
					-73.36,
					19.07,
					-73.21,
					18.97,
					-72.9,
					19.39,
					-72.83,
					19.53,
					-73.11,
					19.56,
					-73.46,
					19.69,
					-73.56,
					19.92,
					-73.48,
					20.19,
					-72.77,
					19.87,
					-72.29,
					19.77,
					-71.67,
					19.43,
					-71.56,
					19.34,
					-71.62,
					19.2,
					-71.5,
					18.98,
					-71.68,
					18.9,
					-71.61,
					18.66,
					-71.64,
					18.52,
					-71.79,
					18.36,
					-71.58,
					17.93,
					-71.69,
					18.12,
					-72.08,
					18.02,
					-72.8,
					18.14,
					-73.49,
					18.02,
					-73.49
				]
			},
			{
				"points": [
					48.33,
					-92.16,
					48.38,
					-92.33,
					48.52,
					-92.35,
					48.75,
					-91.86,
					49.1,
					-91.79,
					49.1,
					-90.96,
					49.01,
					-90.86,
					48.58,
					-90.85,
					48.33,
					-89.93,
					48.03,
					-89.88,
					47.93,
					-89.98,
					47.99,
					-90.16,
					47.97,
					-90.76,
					48.11,
					-90.9,
					47.96,
					-91.24,
					47.94,
					-91.61,
					48.09,
					-91.79,
					48.17,
					-92.09,
					48.33,
					-92.16
				]
			},
			{
				"points": [
					62.32,
					-84,
					62.54,
					-84.03,
					62.75,
					-83.69,
					62.91,
					-83.64,
					63.02,
					-83.39,
					62.95,
					-83.04,
					63.13,
					-82.59,
					63.05,
					-82.51,
					63.1,
					-82.23,
					62.96,
					-81.77,
					62.61,
					-81.91,
					62.07,
					-83.07,
					62.14,
					-83.33,
					62.03,
					-83.74,
					62.22,
					-83.84,
					62.32,
					-84
				]
			},
			{
				"points": [
					17.74,
					-77.01,
					17.59,
					-77.16,
					17.75,
					-77.43,
					17.75,
					-77.78,
					18.1,
					-78.1,
					18.16,
					-78.42,
					18.4,
					-78.44,
					18.56,
					-78.24,
					18.55,
					-77.98,
					18.63,
					-77.83,
					18.52,
					-76.87,
					18.36,
					-76.71,
					18.23,
					-76.26,
					17.93,
					-76.07,
					17.83,
					-76.11,
					17.73,
					-76.51,
					17.81,
					-76.81,
					17.74,
					-77.01
				]
			}
		],
		"transitions": [
			[
				0,
				-300,
				[
					"EST",
					"PET",
					"ECT",
					"COT"
				]
			]
		],
		"name": "America/Coral_Harbour"
	},
	{
		"hoverRegion": [
			{
				"points": [
					21.43,
					112.21,
					21.52,
					112.05,
					21.4,
					111.44,
					21.26,
					111.2,
					21.34,
					111.07,
					21.29,
					110.84,
					21.04,
					110.63,
					20.97,
					110.73,
					20.82,
					110.69,
					20.77,
					110.51,
					20.31,
					110.68,
					20.18,
					110.41,
					20.14,
					110.52,
					20.26,
					110.68,
					20.12,
					110.83,
					20.08,
					111.01,
					19.58,
					111.13,
					19.31,
					110.76,
					18.58,
					110.55,
					18.53,
					110.27,
					18.29,
					110.11,
					18.28,
					109.86,
					18.13,
					109.8,
					18.05,
					109.57,
					18.44,
					108.6,
					19.26,
					108.51,
					19.46,
					108.62,
					19.72,
					109.06,
					19.83,
					109.05,
					20,
					109.22,
					19.96,
					109.44,
					20.09,
					109.55,
					20.05,
					109.83,
					20.16,
					110.14,
					20.15,
					109.84,
					20.45,
					109.77,
					20.59,
					109.64,
					20.89,
					109.55,
					21.36,
					109.66,
					21.29,
					109.14,
					21.37,
					108.96,
					21.52,
					108.96,
					21.5,
					108.71,
					21.58,
					108.59,
					21.46,
					108.51,
					21.4,
					108.21,
					21.43,
					107.94,
					21.53,
					107.79,
					21.49,
					107.35,
					21.75,
					106.94,
					21.86,
					106.91,
					21.92,
					106.59,
					22.21,
					106.58,
					22.3,
					106.46,
					22.45,
					106.45,
					22.62,
					106.52,
					22.75,
					106.68,
					22.83,
					106.52,
					22.75,
					106.28,
					22.87,
					106.12,
					22.81,
					105.83,
					22.96,
					105.68,
					22.97,
					105.52,
					23.25,
					105.31,
					23.06,
					104.94,
					22.9,
					104.96,
					22.74,
					104.8,
					22.73,
					104.61,
					22.58,
					104.36,
					22.68,
					104.17,
					22.4,
					104.01,
					22.63,
					103.66,
					22.48,
					103.5,
					22.64,
					103.34,
					22.33,
					103.05,
					22.63,
					102.54,
					22.32,
					102.32,
					22.34,
					102.04,
					22.27,
					101.89,
					22.36,
					101.75,
					22.22,
					101.66,
					22.02,
					101.72,
					21.88,
					101.87,
					21.62,
					101.93,
					21.35,
					101.85,
					21.18,
					101.95,
					21.04,
					101.83,
					21.13,
					101.55,
					21.08,
					101.23,
					21.62,
					101.05,
					21.38,
					100.72,
					21.35,
					100.46,
					21.41,
					100.37,
					21.33,
					100.17,
					21.69,
					99.87,
					21.95,
					99.85,
					22.09,
					99.07,
					22.42,
					99.14,
					22.53,
					99.26,
					22.76,
					99.21,
					22.97,
					99.34,
					22.99,
					99.06,
					23.12,
					98.8,
					23.38,
					98.8,
					23.54,
					98.69,
					23.63,
					98.75,
					23.76,
					98.58,
					24.02,
					98.59,
					23.99,
					98.16,
					23.73,
					97.66,
					23.88,
					97.43,
					24.2,
					97.63,
					24.39,
					97.43,
					24.78,
					97.45,
					24.89,
					97.63,
					25.02,
					97.61,
					25.31,
					97.74,
					25.38,
					97.97,
					25.69,
					98.08,
					25.69,
					98.3,
					25.88,
					98.4,
					25.91,
					98.57,
					26.14,
					98.46,
					26.22,
					98.58,
					26.63,
					98.66,
					27.49,
					98.59,
					27.46,
					98.24,
					28.11,
					98,
					28.24,
					97.87,
					28.23,
					97.75,
					28.36,
					97.62,
					28.2,
					97.55,
					28.1,
					97.35,
					28.24,
					97.11,
					28.21,
					96.97,
					28.33,
					96.6,
					28.23,
					96.44,
					28.3,
					96.23,
					28.39,
					96.17,
					28.58,
					96.23,
					28.79,
					96.47,
					28.9,
					96.4,
					28.79,
					96.16,
					28.83,
					96.09,
					29.09,
					96.01,
					29.21,
					96.13,
					29.32,
					96.05,
					29.23,
					95.84,
					29.11,
					95.77,
					28.96,
					95.28,
					29.05,
					94.78,
					29.18,
					94.65,
					29.11,
					94.48,
					28.68,
					94.01,
					28.53,
					93.38,
					28.28,
					93.3,
					28.05,
					92.8,
					27.84,
					92.75,
					27.69,
					92.39,
					27.74,
					92.26,
					27.61,
					92.02,
					27.66,
					91.6,
					27.87,
					91.55,
					27.96,
					91.32,
					27.86,
					91.11,
					27.97,
					90.7,
					27.96,
					90.35,
					28.14,
					90.28,
					28.19,
					89.92,
					27.9,
					89.47,
					27.79,
					89.44,
					27.5,
					89.12,
					27.16,
					88.98,
					27.37,
					88.68,
					27.8,
					88.76,
					27.99,
					88.64,
					27.7,
					87.9,
					27.71,
					87.16,
					27.98,
					86.69,
					27.81,
					86.54,
					27.87,
					86.21,
					27.81,
					85.97,
					28.03,
					85.81,
					28.2,
					85.52,
					28.25,
					85.04,
					28.53,
					85.05,
					28.46,
					84.83,
					28.52,
					84.62,
					28.62,
					84.57,
					28.64,
					84.36,
					28.75,
					84.3,
					28.79,
					84.09,
					29.02,
					84.01,
					29.17,
					84.05,
					29.19,
					83.93,
					29.06,
					83.63,
					29.1,
					83.49,
					29.48,
					83.17,
					29.6,
					82.8,
					29.9,
					82.44,
					30,
					82.13,
					30.23,
					82.06,
					30.29,
					81.5,
					30.12,
					81.46,
					29.92,
					81.19,
					30,
					81.01,
					30.17,
					80.94,
					30.48,
					80.16,
					30.85,
					79.83,
					30.83,
					79.59,
					30.99,
					79.34,
					31.01,
					78.95,
					31.25,
					78.68,
					31.91,
					78.6,
					32.15,
					78.35,
					32.39,
					78.37,
					32.52,
					78.29,
					32.62,
					78.35,
					32.8,
					78.74,
					32.47,
					78.97,
					32.58,
					79.15,
					32.88,
					79.16,
					32.96,
					79.06,
					33.11,
					79.06,
					33.64,
					78.6,
					33.79,
					78.66,
					34.09,
					78.59,
					34.28,
					78.85,
					34.51,
					78.52,
					34.61,
					78.17,
					35.31,
					77.88,
					35.4,
					77.77,
					35.36,
					77.35,
					35.57,
					76.71,
					35.78,
					76.48,
					35.72,
					76.14,
					36.03,
					75.84,
					36.23,
					75.93,
					36.59,
					75.77,
					36.62,
					75.39,
					36.85,
					75.3,
					36.9,
					75.14,
					36.82,
					74.91,
					36.94,
					74.77,
					36.92,
					74.48,
					37.07,
					74.33,
					37.33,
					74.43,
					37.39,
					74.99,
					37.48,
					74.84,
					37.62,
					74.79,
					37.78,
					74.86,
					38.17,
					74.67,
					38.42,
					74.73,
					38.55,
					74.2,
					38.43,
					74.12,
					38.42,
					73.95,
					38.56,
					73.72,
					38.82,
					73.6,
					38.98,
					73.68,
					39.26,
					73.44,
					39.54,
					73.57,
					39.6,
					73.8,
					39.76,
					73.72,
					40.1,
					73.86,
					40.2,
					74.32,
					40.45,
					74.68,
					40.62,
					74.79,
					40.55,
					75.19,
					40.76,
					75.57,
					40.72,
					75.67,
					40.44,
					75.82,
					40.56,
					76.26,
					40.51,
					76.38,
					40.66,
					76.53,
					40.82,
					76.54,
					41.12,
					76.82,
					41.14,
					78.02,
					41.33,
					78.28,
					41.51,
					78.35,
					41.94,
					79.37,
					41.9,
					79.62,
					42.13,
					79.83,
					42.16,
					80.15,
					42.71,
					80.07,
					42.91,
					80.19,
					42.94,
					80.3,
					43.12,
					80.32,
					43.22,
					80.59,
					43.31,
					80.55,
					43.45,
					80.62,
					43.8,
					80.41,
					44.45,
					80.23,
					44.71,
					80.27,
					44.69,
					80.01,
					44.79,
					79.78,
					44.96,
					79.77,
					45.15,
					80.04,
					45.15,
					80.36,
					45.28,
					80.72,
					45.24,
					80.88,
					45.47,
					81.66,
					45.27,
					81.97,
					45.34,
					82.26,
					45.25,
					82.46,
					45.36,
					82.48,
					45.5,
					82.18,
					45.61,
					82.17,
					47.29,
					82.95,
					47.07,
					84.04,
					47.1,
					84.72,
					46.98,
					84.86,
					47.15,
					85.17,
					47.16,
					85.45,
					47.3,
					85.56,
					47.95,
					85.43,
					48.41,
					85.63,
					48.64,
					86.53,
					48.83,
					86.69,
					49.04,
					86.62,
					49.19,
					86.79,
					49.25,
					87.12,
					49.19,
					87.41,
					49.28,
					87.86,
					49.02,
					88.01,
					48.89,
					87.96,
					48.74,
					88.18,
					48.64,
					88.15,
					48.49,
					88.58,
					48.3,
					88.71,
					48.18,
					89.02,
					48.07,
					89.1,
					48.15,
					89.59,
					47.93,
					89.83,
					47.96,
					90.09,
					47.84,
					90.17,
					47.73,
					90.41,
					47.3,
					90.61,
					47.09,
					90.79,
					47.03,
					90.98,
					46.71,
					91.17,
					46.53,
					91.18,
					46.29,
					91.03,
					45.98,
					91.12,
					45.54,
					90.78,
					45.29,
					90.99,
					45.25,
					91.47,
					45.17,
					91.62,
					45.07,
					93.51,
					44.44,
					94.74,
					44.36,
					95,
					44.39,
					95.45,
					44.3,
					95.52,
					44.11,
					95.47,
					44.03,
					95.64,
					43.33,
					95.98,
					42.96,
					96.39,
					42.83,
					96.44,
					42.83,
					97.68,
					43.82,
					97.6,
					44.64,
					98.08,
					45.4,
					98.33,
					45.77,
					98.23,
					46.08,
					97.72,
					46.33,
					97.5,
					46.57,
					97.44,
					47.12,
					97.76,
					47.59,
					98.21,
					47.84,
					97.97,
					48.08,
					97.98,
					48.4,
					98.95,
					48.87,
					99.09,
					49.01,
					99,
					48.89,
					98.62,
					48.96,
					98.27,
					48.91,
					97.87,
					49.3,
					96.95,
					49.56,
					96.85,
					49.68,
					97,
					49.76,
					97.04,
					49.8,
					96.97,
					49.84,
					96.58,
					49.79,
					96.4,
					49.88,
					96.25,
					49.92,
					95.84,
					49.81,
					95.48,
					49.85,
					95.05,
					49.94,
					94.93,
					49.92,
					94.58,
					50.13,
					94.33,
					50.46,
					94.2,
					50.45,
					93.1,
					50.53,
					92.92,
					50.64,
					92.87,
					50.59,
					92.59,
					50.73,
					92.4,
					50.61,
					92.31,
					50.61,
					91.8,
					50.35,
					91.46,
					50.37,
					90.8,
					50.23,
					90.87,
					50.06,
					90.72,
					50.03,
					90.42,
					49.9,
					90.27,
					49.8,
					89.59,
					50.09,
					89.44,
					50.1,
					89.29,
					50.2,
					89.23,
					50.56,
					89.44,
					50.51,
					89.65,
					50.98,
					88.97,
					51.2,
					88.83,
					51.36,
					88.85,
					51.41,
					88.75,
					51.23,
					88.6,
					51.2,
					88.37,
					51.42,
					87.81,
					51.57,
					87.75,
					51.69,
					87.85,
					51.82,
					87.72,
					52.14,
					87.98,
					52.32,
					88.55,
					52.43,
					88.6,
					52.63,
					88.96,
					52.8,
					89,
					52.98,
					88.78,
					53.16,
					88.92,
					53.24,
					88.89,
					53.27,
					88.7,
					53.36,
					88.64,
					53.65,
					88.74,
					53.85,
					89.08,
					54.01,
					88.88,
					54.13,
					88.89,
					54.18,
					88.99,
					54.28,
					88.84,
					54.17,
					88.58,
					54.34,
					88.27,
					54.45,
					88.3,
					54.5,
					88.44,
					54.84,
					88.58,
					55.26,
					88.28,
					55.6,
					88.61,
					55.87,
					89.21,
					56,
					89.17,
					56.21,
					88.94,
					56.28,
					88.65,
					56.58,
					88.39,
					56.72,
					88.53,
					57,
					88.58,
					57.07,
					88.43,
					57.17,
					88.42,
					57.7,
					89.08,
					57.73,
					89.28,
					57.8,
					89.28,
					57.99,
					88.12,
					58.19,
					87.91,
					58.58,
					87.83,
					58.99,
					88.31,
					59.07,
					88.59,
					59.18,
					88.48,
					59.16,
					87.86,
					59.56,
					87.47,
					59.58,
					87.13,
					59.78,
					87.02,
					59.84,
					86.56,
					59.79,
					84.69,
					59.9,
					84.44,
					60.02,
					84.43,
					60.34,
					84.64,
					60.78,
					84.18,
					60.93,
					84.18,
					61.36,
					85.55,
					61.45,
					85.56,
					61.51,
					85.68,
					61.71,
					84.62,
					61.87,
					84.42,
					62.2,
					84.32,
					62.89,
					85.16,
					63.02,
					85.43,
					63.13,
					85.35,
					63.24,
					85.41,
					63.42,
					85.22,
					63.51,
					84.96,
					63.64,
					84.93,
					63.74,
					85.2,
					64.03,
					85.48,
					64.14,
					85.87,
					64.24,
					85.9,
					64.42,
					85.73,
					64.68,
					85.7,
					64.64,
					85.12,
					64.81,
					84.82,
					64.83,
					84.2,
					65.11,
					84.2,
					65.33,
					84.45,
					65.41,
					84.41,
					65.5,
					84.12,
					65.64,
					84.1,
					65.68,
					84.01,
					65.66,
					83.59,
					65.73,
					83.44,
					66.05,
					83.18,
					66.19,
					83.31,
					66.41,
					82.98,
					66.65,
					82.98,
					66.72,
					83.09,
					67.16,
					82.04,
					67.26,
					82.01,
					67.36,
					82.14,
					67.48,
					82.14,
					67.85,
					81.64,
					67.96,
					81.62,
					68.02,
					81.71,
					68.05,
					82.27,
					68.25,
					82.31,
					68.34,
					82.58,
					68.41,
					82.57,
					68.54,
					82.35,
					68.67,
					82.39,
					68.7,
					82.56,
					68.9,
					82.4,
					69.06,
					82.2,
					69.08,
					81.8,
					69.2,
					81.66,
					69.09,
					80.96,
					69.19,
					80.73,
					69.24,
					79.81,
					69.55,
					79.44,
					69.59,
					78.95,
					69.83,
					78.78,
					69.96,
					78.8,
					70.03,
					79.01,
					70.24,
					79.26,
					70.22,
					79.47,
					70.38,
					79.67,
					70.61,
					80.56,
					70.67,
					80.49,
					70.96,
					80.44,
					71.2,
					79.2,
					71.37,
					79.03,
					71.69,
					79.28,
					71.72,
					79.95,
					71.88,
					79.94,
					72.1,
					78.56,
					72.3,
					78.34,
					72.48,
					78.37,
					72.44,
					79.55,
					72.19,
					80.65,
					71.85,
					81.36,
					71.79,
					81.67,
					71.85,
					82.54,
					72,
					82.19,
					72.14,
					82.17,
					72.27,
					81.23,
					72.16,
					81.21,
					72.12,
					81.07,
					72.32,
					80.69,
					72.71,
					80.57,
					72.9,
					80.76,
					73.1,
					80.22,
					73.31,
					80.24,
					73.43,
					80.03,
					73.6,
					80.09,
					73.83,
					84.51,
					73.95,
					84.56,
					73.95,
					84.76,
					74.16,
					84.7,
					74.21,
					84.84,
					74.29,
					84.8,
					74.32,
					84.22,
					74.46,
					84.12,
					74.69,
					84.11,
					74.76,
					84.18,
					74.73,
					84.35,
					74.55,
					84.33,
					74.54,
					84.39,
					74.66,
					85.04,
					74.91,
					85.02,
					74.98,
					85.22,
					74.87,
					85.34,
					74.97,
					85.5,
					74.94,
					86.14,
					75.07,
					86.28,
					75.07,
					86.76,
					75.2,
					86.85,
					75.23,
					87.98,
					75.37,
					88.05,
					75.29,
					88.22,
					75.57,
					89.06,
					75.68,
					88.98,
					75.79,
					89.09,
					75.6,
					89.4,
					75.77,
					90.92,
					75.74,
					91.58,
					75.85,
					91.73,
					75.84,
					92.07,
					76.02,
					91.99,
					75.93,
					91.86,
					75.96,
					91.7,
					76.09,
					91.66,
					76.15,
					91.75,
					76.1,
					91.98,
					76.16,
					92.16,
					76.05,
					92.22,
					76.14,
					92.37,
					76.03,
					92.48,
					76.1,
					92.68,
					76.05,
					92.78,
					76.15,
					92.9,
					76.22,
					93.25,
					76.17,
					93.57,
					76.28,
					93.84,
					76.22,
					94.34,
					76.3,
					94.45,
					76.45,
					94.46,
					76.49,
					94.61,
					76.47,
					93.95,
					76.55,
					93.83,
					76.67,
					93.86,
					76.68,
					94.24,
					76.88,
					94.45,
					76.83,
					95.02,
					76.95,
					95.01,
					77.14,
					95.18,
					77.09,
					95.38,
					77.33,
					96.45,
					77.18,
					96.68,
					76.96,
					96.58,
					76.96,
					96.93,
					76.9,
					97.02,
					76.73,
					96.95,
					76.75,
					96.65,
					76.55,
					96.66,
					76.43,
					96.75,
					76.49,
					96.85,
					76.38,
					97.15,
					76.19,
					97.19,
					76.21,
					97.37,
					76.08,
					97.47,
					76.26,
					98.23,
					76.37,
					98.3,
					76.3,
					98.51,
					76.36,
					98.85,
					76.47,
					98.77,
					76.56,
					98.87,
					76.55,
					100.31,
					76.64,
					101.05,
					76.77,
					100.87,
					76.89,
					100.85,
					77.2,
					101.37,
					77.49,
					102.15,
					77.49,
					102.41,
					77.62,
					102.51,
					77.57,
					102.7,
					77.74,
					103.22,
					77.73,
					103.64,
					77.84,
					104.06,
					77.79,
					104.81,
					77.68,
					105.01,
					77.67,
					105.92,
					77.51,
					106.14,
					77.64,
					106.18,
					77.65,
					106.3,
					77.58,
					106.45,
					77.46,
					106.43,
					77.57,
					106.72,
					77.5,
					107.05,
					77.37,
					106.99,
					77.23,
					106.5,
					77.24,
					106.16,
					77.12,
					106.03,
					77.13,
					107.14,
					77.23,
					106.99,
					77.36,
					106.99,
					77.37,
					107.24,
					77.51,
					107.48,
					77.37,
					107.84,
					77.23,
					107.82,
					77.1,
					107.38,
					76.97,
					107.62,
					76.83,
					107.6,
					76.58,
					106.94,
					76.6,
					107.69,
					76.65,
					107.88,
					76.81,
					107.92,
					76.85,
					108.27,
					76.81,
					108.68,
					76.88,
					109.47,
					76.79,
					110.12,
					76.9,
					110.91,
					76.89,
					111.31,
					76.71,
					111.99,
					76.72,
					112.66,
					76.52,
					112.88,
					76.52,
					113.44,
					76.36,
					113.59,
					76.23,
					113.54,
					76.05,
					113.66,
					76.06,
					113.77,
					75.88,
					114.02,
					75.55,
					113.8,
					75.42,
					113.83,
					75.17,
					113.67,
					74.88,
					112.93,
					74.77,
					112.2,
					74.54,
					111.82,
					74.57,
					111.42,
					74.25,
					110.02,
					74.06,
					109.85,
					73.93,
					109.11,
					73.56,
					108.25,
					73.53,
					107.17,
					73.27,
					106.92,
					73.25,
					107.75,
					73.47,
					109.08,
					73.62,
					109.15,
					73.58,
					109.4,
					73.5,
					109.45,
					73.54,
					109.8,
					73.57,
					109.64,
					73.85,
					109.42,
					74.11,
					109.98,
					74.09,
					111.64,
					73.94,
					111.67,
					73.71,
					111.18,
					73.54,
					111.23,
					73.33,
					110.69,
					73.04,
					111.05,
					72.75,
					110.8,
					72.61,
					111.35,
					72.44,
					111.4,
					72.21,
					112.09,
					71.49,
					112.12,
					71.33,
					112.75,
					71.24,
					112.83,
					71.01,
					112.66,
					70.89,
					112.3,
					70.94,
					112.09,
					70.74,
					111.37,
					70.69,
					110.61,
					70.55,
					110.25,
					70.46,
					110.39,
					70.35,
					110.37,
					70.27,
					109.7,
					70.14,
					109.52,
					70.1,
					109.62,
					69.98,
					109.64,
					69.66,
					109.25,
					69.74,
					108.25,
					69.56,
					107.91,
					69.39,
					106.34,
					68.88,
					106.99,
					67.34,
					106.91,
					67.13,
					106.69,
					67.17,
					106.5,
					67,
					106.05,
					66.73,
					106.36,
					66.43,
					106.42,
					66.28,
					106.21,
					66.24,
					106.4,
					66.07,
					106.57,
					65.74,
					106.54,
					65.59,
					107,
					65.5,
					107.07,
					65.27,
					106.88,
					65.28,
					106.63,
					65.11,
					106.58,
					64.98,
					106.21,
					64.9,
					106.31,
					64.8,
					106.31,
					64.7,
					105.97,
					64.59,
					105.96,
					64.59,
					106.17,
					64.51,
					106.24,
					64.62,
					106.59,
					64.35,
					107.34,
					64.4,
					107.65,
					64.28,
					107.96,
					64.34,
					108.17,
					64,
					108.42,
					63.92,
					108.33,
					63.88,
					107.72,
					63.74,
					107.54,
					63.81,
					106.9,
					63.49,
					106.7,
					63.39,
					106.83,
					63.29,
					106.81,
					63.18,
					106.69,
					63.2,
					106.54,
					63.04,
					106.49,
					62.98,
					106.3,
					62.93,
					106.5,
					62.75,
					106.63,
					62.61,
					106.92,
					62.28,
					106.54,
					61.95,
					106.49,
					61.77,
					106.03,
					61.58,
					105.99,
					61.27,
					105.07,
					61.08,
					105.07,
					60.97,
					104.69,
					60.88,
					104.74,
					60.63,
					104.65,
					60.49,
					104.73,
					60.32,
					105.51,
					60.25,
					105.59,
					59.76,
					105.56,
					59.66,
					104.95,
					59.57,
					105.02,
					59.52,
					105.28,
					59.14,
					105.46,
					59.03,
					105.44,
					58.79,
					104.91,
					58.61,
					104.92,
					58.49,
					104.42,
					58.64,
					104.21,
					58.64,
					103.79,
					58.79,
					103.78,
					58.82,
					103.51,
					59.18,
					103.13,
					59.05,
					102.54,
					58.83,
					102.67,
					58.64,
					102.59,
					58.41,
					102.21,
					58.31,
					101.74,
					58.12,
					101.57,
					58.07,
					101.25,
					57.95,
					101.23,
					57.78,
					100.99,
					57.67,
					100.96,
					57.55,
					101.06,
					57.39,
					101,
					57.29,
					100.76,
					57.47,
					100.32,
					57.66,
					100.26,
					57.79,
					100.03,
					57.96,
					99.97,
					57.97,
					99.72,
					57.69,
					99.47,
					57.61,
					98.99,
					57.68,
					98.71,
					57.67,
					97.95,
					57.1,
					97.52,
					57.03,
					97.69,
					56.89,
					97.7,
					56.85,
					97.86,
					56.66,
					97.87,
					56.6,
					97.98,
					56.35,
					97.98,
					56.28,
					97.68,
					56.12,
					97.67,
					55.95,
					97.4,
					55.95,
					97.08,
					55.8,
					97.06,
					55.72,
					96.92,
					55.31,
					97.02,
					55.17,
					96.8,
					54.99,
					96.75,
					54.83,
					96.81,
					54.65,
					96.67,
					54.43,
					96.64,
					54.45,
					96.1,
					54.29,
					95.88,
					53.76,
					96.59,
					53.83,
					96.91,
					53.7,
					97.36,
					53.47,
					97.64,
					53.46,
					97.96,
					53.35,
					98.09,
					53.32,
					98.34,
					53.21,
					98.39,
					53.26,
					98.91,
					53.19,
					99.11,
					52.99,
					99.34,
					52.8,
					99.3,
					52.74,
					99.22,
					52.78,
					99.04,
					52.61,
					99.03,
					52.38,
					98.75,
					51.86,
					100.01,
					51.85,
					100.54,
					51.57,
					101.38,
					51.6,
					101.59,
					51.48,
					102.13,
					51.35,
					102.31,
					51.23,
					102.27,
					50.87,
					102.35,
					50.78,
					102.45,
					50.65,
					102.44,
					50.42,
					102.94,
					50.4,
					103.27,
					50.3,
					103.36,
					50.26,
					104.04,
					50.41,
					104.38,
					50.58,
					105.33,
					50.52,
					106.05,
					50.4,
					106.29,
					50.43,
					106.71,
					50.32,
					107.01,
					50.12,
					107.2,
					50.01,
					108.02,
					49.73,
					108.05,
					49.44,
					108.57,
					49.47,
					109.21,
					49.3,
					109.85,
					49.27,
					110.21,
					49.36,
					110.38,
					49.26,
					110.78,
					49.48,
					111.37,
					49.5,
					111.91,
					49.64,
					112.47,
					49.6,
					112.73,
					49.7,
					113.01,
					49.93,
					113.18,
					50.39,
					114.36,
					50.3,
					114.98,
					50.01,
					115.43,
					49.99,
					115.74,
					50.13,
					116.22,
					49.62,
					117.83,
					50.02,
					118.5,
					50.17,
					119.2,
					50.25,
					119.22,
					50.34,
					119.01,
					50.46,
					119.03,
					50.79,
					119.38,
					50.95,
					119.41,
					51.14,
					119.64,
					51.74,
					120,
					52.01,
					120.57,
					52.14,
					120.64,
					52.31,
					120.5,
					52.48,
					120.56,
					52.49,
					120,
					52.84,
					119.94,
					53.37,
					120.8,
					53.6,
					122.3,
					53.56,
					122.82,
					53.66,
					123.23,
					53.65,
					123.58,
					53.22,
					124.82,
					53.3,
					125.11,
					53.18,
					125.62,
					52.87,
					126.01,
					52.84,
					126.18,
					52.66,
					126.15,
					52.34,
					126.53,
					52.12,
					126.66,
					51.97,
					126.59,
					51.76,
					126.82,
					51.47,
					126.92,
					51.38,
					127.06,
					51.1,
					127.03,
					50.8,
					127.39,
					50.39,
					127.44,
					50.26,
					127.69,
					49.87,
					127.62,
					49.7,
					127.83,
					49.62,
					128.23,
					49.69,
					128.37,
					49.7,
					128.74,
					49.46,
					129.13,
					49.53,
					129.49,
					48.97,
					130.25,
					48.97,
					130.71,
					48.87,
					130.77,
					48.62,
					130.65,
					48.53,
					130.85,
					48.29,
					130.93,
					48.11,
					130.8,
					47.8,
					131.05,
					47.82,
					132.49,
					48.05,
					132.63,
					48.04,
					132.78,
					48.21,
					133.17,
					48.18,
					133.48,
					48.44,
					134.04,
					48.49,
					134.39,
					48.31,
					134.81,
					48,
					134.68,
					47.78,
					134.87,
					47.62,
					134.84,
					47.36,
					134.56,
					47.25,
					134.3,
					47.09,
					134.32,
					46.99,
					134.21,
					46.62,
					134.12,
					46.48,
					134,
					46.22,
					134.01,
					46.1,
					133.83,
					45.86,
					133.74,
					45.78,
					133.58,
					45.53,
					133.54,
					45.38,
					133.24,
					45.04,
					133.21,
					44.9,
					132.91,
					45.18,
					131.9,
					44.87,
					131.55,
					44.78,
					131.16,
					44.11,
					131.39,
					43.57,
					131.3,
					43.39,
					131.41,
					42.83,
					131.17,
					42.69,
					130.7,
					42.33,
					130.66,
					42.46,
					130.37,
					42.66,
					130.15,
					42.82,
					130.15,
					42.87,
					129.96,
					42.33,
					129.75,
					42.25,
					129.55,
					42.31,
					129.35,
					42.11,
					129.28,
					41.89,
					128.91,
					41.88,
					128.2,
					41.59,
					128.42,
					41.32,
					128.27,
					41.26,
					128.14,
					41.37,
					127.21,
					41.46,
					127.02,
					41.66,
					126.92,
					41.57,
					126.69,
					41.28,
					126.61,
					41.24,
					126.48,
					40.79,
					126.01,
					40.77,
					125.79,
					40.66,
					125.72,
					40.45,
					125.13,
					40.35,
					125.06,
					40.36,
					124.92,
					40.06,
					124.49,
					39.74,
					124.21,
					39.73,
					123.91,
					39.62,
					123.72,
					39.65,
					123.37,
					39.57,
					123.14,
					39.42,
					123.2,
					39.31,
					123.1,
					39.49,
					122.86,
					39.37,
					122.58,
					39.28,
					122.84,
					39.1,
					122.97,
					38.97,
					122.95,
					38.9,
					122.79,
					38.94,
					122.63,
					39.09,
					122.61,
					39.03,
					122.32,
					39.08,
					122.24,
					38.94,
					121.98,
					38.75,
					121.87,
					38.63,
					121.1,
					38.93,
					120.98,
					39.13,
					121.05,
					39.19,
					121.18,
					39.1,
					121.27,
					39.26,
					121.35,
					39.3,
					121.18,
					39.58,
					121.12,
					39.71,
					121.39,
					39.87,
					121.39,
					40.03,
					121.72,
					40.47,
					122.13,
					40.61,
					122.03,
					40.73,
					121.78,
					40.81,
					121.19,
					40.76,
					121.1,
					40.61,
					121.08,
					40.57,
					120.89,
					40.42,
					120.91,
					40.37,
					120.72,
					40.1,
					120.51,
					39.8,
					119.63,
					39.63,
					119.42,
					39.32,
					119.39,
					38.91,
					118.77,
					38.8,
					118.5,
					38.96,
					118.41,
					38.93,
					118.28,
					39.09,
					118.09,
					39.04,
					117.85,
					38.66,
					117.65,
					38.43,
					117.79,
					38.25,
					118.08,
					38.2,
					118.51,
					38.29,
					118.91,
					37.73,
					119.18,
					37.41,
					119.06,
					37.27,
					119.3,
					37.27,
					119.72,
					37.44,
					119.76,
					37.63,
					120.13,
					37.76,
					120.15,
					37.89,
					120.52,
					38.13,
					120.54,
					38.5,
					120.87,
					38.39,
					121.03,
					38.13,
					120.88,
					38.11,
					121,
					38.01,
					121.05,
					37.91,
					120.86,
					37.79,
					121.2,
					37.7,
					121.24,
					37.65,
					121.57,
					37.55,
					121.62,
					37.66,
					122.13,
					37.52,
					122.3,
					37.42,
					122.8,
					36.8,
					122.56,
					36.73,
					122.15,
					36.85,
					121.92,
					36.61,
					121.66,
					36.65,
					121.47,
					36.48,
					121.07,
					36.31,
					121,
					36.23,
					120.78,
					36.04,
					120.77,
					35.96,
					120.4,
					35.84,
					120.25,
					35.67,
					120.24,
					35.5,
					119.7,
					35.04,
					119.45,
					34.9,
					119.29,
					34.84,
					119.56,
					34.71,
					119.58,
					34.62,
					119.69,
					34.38,
					120.36,
					33.86,
					120.58,
					33.74,
					120.55,
					33.02,
					120.93,
					32.81,
					120.92,
					32.66,
					121.01,
					32.47,
					121.43,
					32.21,
					121.48,
					31.97,
					121.94,
					31.54,
					121.98,
					31.19,
					121.87,
					30.87,
					121.99,
					30.76,
					121.9,
					30.73,
					121.56,
					30.47,
					121.08,
					30.33,
					121,
					30.41,
					121.32,
					30.09,
					121.71,
					30.39,
					121.85,
					30.43,
					122.17,
					30.52,
					121.96,
					30.72,
					121.98,
					30.71,
					122.19,
					30.86,
					122.34,
					30.84,
					122.49,
					30.95,
					122.69,
					30.84,
					122.87,
					30.65,
					122.93,
					30.58,
					122.78,
					30.63,
					122.68,
					30.52,
					122.48,
					30.45,
					122.56,
					30.33,
					122.55,
					30.29,
					122.77,
					30.1,
					122.88,
					30.01,
					122.77,
					30.1,
					122.5,
					29.91,
					122.56,
					29.53,
					122.27,
					29.37,
					122.31,
					29.29,
					122.19,
					29.33,
					122.09,
					29.13,
					122.17,
					29,
					122.04,
					28.95,
					121.83,
					28.75,
					122.03,
					28.6,
					121.94,
					28.41,
					122.02,
					28.31,
					121.84,
					28.37,
					121.75,
					28.22,
					121.77,
					28,
					121.58,
					27.95,
					121.33,
					27.73,
					121.25,
					27.56,
					121.32,
					27.36,
					121.17,
					27.37,
					120.97,
					27.54,
					120.96,
					27.55,
					120.76,
					27.43,
					120.78,
					27.04,
					120.53,
					26.91,
					120.55,
					26.81,
					120.37,
					26.72,
					120.47,
					26.6,
					120.46,
					26.55,
					120.27,
					26.38,
					120.06,
					25.9,
					120.11,
					25.83,
					119.93,
					25.96,
					119.82,
					25.84,
					119.74,
					25.74,
					119.78,
					25.61,
					120,
					25.23,
					119.84,
					25.05,
					119.53,
					24.94,
					119.55,
					24.88,
					119.48,
					25.06,
					119.25,
					24.79,
					119.06,
					24.77,
					118.87,
					24.33,
					118.51,
					24.29,
					118.23,
					24.18,
					118.21,
					23.82,
					117.81,
					23.69,
					117.78,
					23.64,
					117.65,
					23.56,
					117.78,
					23.44,
					117.74,
					23.46,
					117.58,
					23.61,
					117.6,
					23.48,
					117.48,
					23.48,
					117.22,
					23.29,
					117.15,
					23.3,
					116.85,
					23.15,
					116.88,
					23.08,
					116.65,
					22.84,
					116.54,
					22.84,
					116.31,
					22.63,
					115.82,
					22.73,
					115.7,
					22.54,
					115.58,
					22.68,
					115.11,
					22.41,
					114.89,
					22.33,
					114.49,
					21.97,
					114.38,
					21.78,
					114.06,
					21.79,
					113.94,
					21.91,
					113.89,
					21.82,
					113.68,
					21.98,
					113.52,
					21.77,
					113.29,
					21.75,
					112.97,
					21.59,
					113,
					21.5,
					112.94,
					21.48,
					112.57,
					21.6,
					112.34,
					21.43,
					112.21
				]
			},
			{
				"points": [
					-35.22,
					117.99,
					-35.29,
					117.87,
					-35.17,
					117.72,
					-35.24,
					117.62,
					-35.13,
					117.34,
					-35.15,
					116.58,
					-34.94,
					115.94,
					-34.69,
					115.75,
					-34.45,
					115.39,
					-34.47,
					115.08,
					-34.29,
					114.92,
					-33.48,
					114.9,
					-33.42,
					115,
					-33.53,
					115.31,
					-33.26,
					115.56,
					-32.65,
					115.49,
					-32.42,
					115.63,
					-32.13,
					115.56,
					-32.12,
					115.41,
					-32.02,
					115.33,
					-31.88,
					115.49,
					-31.93,
					115.62,
					-31.79,
					115.61,
					-30.53,
					114.94,
					-30.04,
					114.83,
					-29.5,
					114.88,
					-29.17,
					114.76,
					-28.85,
					114.48,
					-28.54,
					114.41,
					-28.14,
					114.06,
					-27.87,
					113.98,
					-27.63,
					114.02,
					-27.34,
					113.89,
					-26.8,
					113.53,
					-26.45,
					113.18,
					-25.63,
					112.8,
					-25.4,
					112.89,
					-25.41,
					113.06,
					-25.92,
					113.24,
					-25.91,
					113.36,
					-25.68,
					113.3,
					-25.4,
					113.5,
					-25.74,
					113.77,
					-25.74,
					113.99,
					-25.24,
					113.72,
					-25.14,
					113.59,
					-24.8,
					113.51,
					-24.46,
					113.28,
					-23.99,
					113.31,
					-23.41,
					113.67,
					-22.97,
					113.71,
					-22.72,
					113.56,
					-22.5,
					113.56,
					-21.76,
					113.96,
					-21.71,
					114.21,
					-21.52,
					114.37,
					-21.55,
					114.47,
					-21.68,
					114.48,
					-21.82,
					114.3,
					-22.14,
					114.2,
					-22.32,
					114.3,
					-21.95,
					114.4,
					-21.73,
					114.64,
					-21.61,
					114.55,
					-21.51,
					114.58,
					-21.42,
					114.81,
					-21.54,
					114.87,
					-21.66,
					114.79,
					-21.57,
					115.02,
					-21.5,
					114.88,
					-21.35,
					114.92,
					-21.38,
					115.1,
					-21.54,
					115.08,
					-21.48,
					115.24,
					-21.36,
					115.3,
					-21.25,
					115.54,
					-21.09,
					115.59,
					-21.15,
					115.74,
					-20.86,
					115.8,
					-20.89,
					116.07,
					-20.4,
					116.49,
					-20.34,
					116.59,
					-20.4,
					116.7,
					-20.25,
					116.78,
					-20.34,
					117.13,
					-20.6,
					117.29,
					-20.6,
					117.56,
					-20.24,
					118.13,
					-20.17,
					118.76,
					-20.12,
					118.8,
					-20.07,
					118.7,
					-19.97,
					118.69,
					-19.79,
					118.85,
					-19.79,
					118.95,
					-19.9,
					119,
					-19.85,
					119.11,
					-19.96,
					119.56,
					-19.85,
					119.74,
					-19.66,
					120.61,
					-19.46,
					121.01,
					-19.04,
					121.41,
					-18.65,
					121.52,
					-18.39,
					121.72,
					-18.08,
					122.23,
					-17.98,
					122.06,
					-17.2,
					122.08,
					-16.69,
					122.48,
					-16.65,
					122.66,
					-16.3,
					122.86,
					-16.21,
					123.22,
					-15.95,
					123.21,
					-15.93,
					123.57,
					-15.82,
					123.71,
					-16,
					123.78,
					-16.03,
					123.89,
					-15.93,
					123.92,
					-15.92,
					124.07,
					-15.82,
					124.14,
					-15.84,
					124.29,
					-15.65,
					124.25,
					-15.5,
					124.33,
					-15.41,
					124.1,
					-15.3,
					124.1,
					-15.11,
					124.36,
					-15.05,
					124.63,
					-14.91,
					124.54,
					-14.77,
					124.64,
					-14.75,
					124.75,
					-14.82,
					124.83,
					-14.65,
					125.01,
					-14.55,
					124.87,
					-14.3,
					124.89,
					-14.27,
					125,
					-14.37,
					125.08,
					-14.21,
					125.14,
					-14.14,
					125.3,
					-14.24,
					125.48,
					-14.09,
					125.43,
					-13.84,
					125.56,
					-13.73,
					125.83,
					-13.84,
					125.92,
					-13.81,
					126.05,
					-13.63,
					126.11,
					-13.83,
					126.4,
					-13.64,
					127.01,
					-13.78,
					127.12,
					-13.85,
					127.48,
					-14.5,
					128.02,
					-14.68,
					128.41,
					-14.77,
					129.02,
					-14.86,
					129.1,
					-31.34,
					129.09,
					-31.4,
					129,
					-31.4,
					125.6,
					-32.63,
					125.58,
					-33,
					124.79,
					-33.12,
					124.29,
					-33.64,
					124.05,
					-34.11,
					123.59,
					-34.11,
					123.48,
					-34.01,
					123.4,
					-34.2,
					123.28,
					-34.23,
					123.16,
					-33.97,
					123,
					-34.12,
					122.79,
					-34,
					122.7,
					-34.07,
					122.58,
					-34.03,
					122.38,
					-34.27,
					122.26,
					-34.22,
					121.95,
					-34.03,
					121.83,
					-34.14,
					121.56,
					-33.95,
					121.43,
					-34,
					120.6,
					-34.08,
					120.44,
					-34.03,
					120.05,
					-34.21,
					119.68,
					-34.28,
					119.64,
					-34.39,
					119.72,
					-34.48,
					119.66,
					-34.64,
					119.26,
					-34.57,
					119,
					-34.62,
					118.85,
					-34.73,
					118.8,
					-34.85,
					118.55,
					-35.01,
					118.54,
					-35.03,
					118.3,
					-35.22,
					117.99
				]
			},
			{
				"points": [
					-4.17,
					116.28,
					-4.16,
					115.96,
					-3.75,
					115.91,
					-4.26,
					114.55,
					-4.17,
					114.49,
					-3.68,
					114.49,
					-3.49,
					114.27,
					-3.06,
					114.39,
					-2.08,
					115.15,
					-1.87,
					115.26,
					-1.48,
					115.3,
					-1.39,
					115.54,
					-1.21,
					115.63,
					-0.83,
					115.28,
					-0.23,
					115.13,
					-0.3,
					114.97,
					-0.15,
					114.77,
					0.11,
					114.72,
					0.35,
					114.79,
					0.45,
					114.94,
					0.62,
					114.85,
					0.43,
					114.37,
					0.51,
					114.05,
					0.43,
					113.83,
					0.48,
					113.67,
					0.56,
					113.6,
					0.79,
					113.74,
					1.04,
					113.69,
					1.32,
					113.98,
					1.1,
					113.65,
					1.32,
					113.08,
					1.3,
					112.92,
					1.45,
					112.88,
					1.46,
					112.51,
					1.36,
					112.29,
					1.07,
					112.23,
					1.01,
					111.99,
					0.88,
					111.84,
					0.91,
					111.68,
					0.84,
					111.52,
					0.97,
					111.22,
					0.74,
					110.56,
					0.91,
					110.19,
					1.08,
					110.11,
					1.34,
					109.75,
					1.85,
					109.44,
					2.13,
					109.55,
					2.19,
					109.65,
					1.8,
					109.95,
					1.91,
					110.33,
					1.82,
					110.58,
					1.68,
					110.62,
					1.64,
					110.9,
					2.06,
					111.09,
					2.39,
					111.07,
					2.54,
					111.2,
					2.86,
					111.23,
					2.84,
					111.43,
					2.96,
					111.6,
					3.27,
					112.95,
					3.82,
					113.34,
					4.27,
					113.79,
					4.66,
					113.88,
					5.13,
					115.06,
					5.22,
					115,
					5.41,
					115.1,
					5.48,
					115.3,
					5.82,
					115.56,
					5.84,
					115.73,
					5.67,
					115.77,
					5.95,
					115.94,
					6.09,
					115.91,
					6.56,
					116.4,
					6.62,
					116.43,
					6.62,
					116.23,
					6.78,
					116.21,
					6.82,
					116.36,
					6.7,
					116.46,
					7.08,
					116.64,
					7.13,
					116.77,
					7.34,
					116.79,
					7.46,
					117,
					7.45,
					117.3,
					7.29,
					117.45,
					6.99,
					117.43,
					6.96,
					117.55,
					6.68,
					117.61,
					6.46,
					117.83,
					6.13,
					117.76,
					6.05,
					117.82,
					6.22,
					117.98,
					6.36,
					118,
					6.38,
					118.13,
					6.16,
					118.22,
					6.06,
					118.12,
					5.95,
					118.22,
					5.91,
					118.4,
					5.54,
					118.95,
					5.56,
					119.16,
					5.41,
					119.35,
					5.17,
					119.36,
					5.03,
					119.24,
					4.81,
					118.52,
					4.69,
					118.66,
					4.73,
					118.77,
					4.63,
					119.04,
					4.23,
					118.96,
					4.19,
					118.82,
					4.3,
					118.73,
					4.13,
					118.65,
					4.23,
					118.52,
					4.11,
					118.01,
					3.99,
					118,
					3.92,
					117.85,
					3.82,
					117.94,
					3.66,
					117.89,
					3.42,
					117.98,
					3.34,
					117.9,
					3.38,
					117.77,
					3.06,
					117.7,
					2.45,
					118.11,
					2.48,
					118.22,
					2.37,
					118.32,
					2.25,
					118.27,
					2.1,
					118.01,
					1.93,
					117.97,
					0.99,
					119.1,
					0.69,
					118.82,
					0.69,
					118.36,
					0.77,
					118.15,
					0.62,
					118.06,
					0.68,
					117.83,
					0.27,
					117.63,
					0.05,
					117.66,
					-0.23,
					117.54,
					-0.37,
					117.73,
					-0.68,
					117.63,
					-0.84,
					117.7,
					-1,
					117.49,
					-1,
					117.3,
					-1.33,
					117,
					-1.53,
					116.65,
					-1.67,
					116.64,
					-1.73,
					116.54,
					-2.01,
					116.56,
					-2.24,
					116.78,
					-2.63,
					116.6,
					-2.67,
					116.49,
					-2.95,
					116.43,
					-3.05,
					116.34,
					-3.29,
					116.36,
					-3.3,
					116.49,
					-3.4,
					116.53,
					-4.17,
					116.28
				]
			},
			{
				"points": [
					9,
					123.35,
					8.97,
					122.89,
					9.24,
					122.78,
					9.35,
					122.52,
					9.62,
					122.3,
					9.87,
					122.28,
					10.03,
					122.36,
					10.15,
					122.74,
					10.33,
					122.71,
					10.28,
					122.61,
					10.39,
					122.41,
					10.55,
					122.38,
					10.53,
					122.25,
					10.32,
					122.02,
					10.42,
					121.8,
					11.33,
					121.94,
					11.48,
					121.79,
					11.64,
					121.98,
					11.74,
					121.74,
					12.17,
					121.86,
					12.34,
					121.81,
					12.71,
					121.97,
					12.91,
					121.89,
					12.8,
					121.66,
					12.57,
					121.66,
					12.26,
					121.52,
					12.12,
					121.69,
					11.85,
					121.68,
					11.72,
					121.5,
					11.76,
					121.24,
					11.87,
					121.17,
					11.97,
					121.28,
					12.07,
					121.23,
					12.11,
					120.94,
					13.36,
					120.21,
					13.57,
					120.26,
					13.85,
					119.91,
					14,
					119.98,
					13.93,
					120.34,
					13.62,
					120.5,
					13.63,
					120.73,
					13.75,
					120.52,
					14.29,
					120.5,
					14.72,
					119.99,
					15.22,
					119.9,
					15.4,
					119.78,
					15.58,
					119.81,
					15.75,
					119.68,
					15.98,
					119.63,
					16.37,
					119.68,
					16.53,
					119.89,
					16.48,
					120,
					16.16,
					120.18,
					16.2,
					120.29,
					16.61,
					120.17,
					17.01,
					120.33,
					17.37,
					120.34,
					17.59,
					120.22,
					18.58,
					120.52,
					18.74,
					120.79,
					18.68,
					120.95,
					18.73,
					121.18,
					18.38,
					121.92,
					18.68,
					122.16,
					18.41,
					122.42,
					18.2,
					122.42,
					18.03,
					122.27,
					17.79,
					122.25,
					17.45,
					122.33,
					17.42,
					122.47,
					17.23,
					122.52,
					17.15,
					122.62,
					16.84,
					122.56,
					16.39,
					122.3,
					16.27,
					122.34,
					15.99,
					122.13,
					15.92,
					121.98,
					16,
					121.88,
					15.86,
					121.68,
					15.69,
					121.74,
					15.3,
					121.5,
					14.96,
					121.69,
					15.12,
					121.78,
					15.13,
					122.06,
					14.83,
					122.35,
					14.78,
					122.5,
					14.67,
					122.54,
					14.57,
					122.43,
					14.61,
					122.24,
					14.52,
					121.9,
					14.62,
					121.8,
					14.58,
					121.73,
					14.4,
					121.78,
					14.35,
					121.94,
					14.49,
					121.93,
					14.53,
					122.07,
					14.41,
					122.15,
					14.29,
					122.01,
					14.24,
					122.08,
					14.41,
					122.36,
					14.45,
					122.7,
					14.56,
					122.75,
					14.6,
					122.95,
					14.47,
					123.08,
					14.27,
					123.02,
					14.16,
					123.19,
					14.22,
					123.34,
					14.07,
					123.45,
					14.13,
					123.59,
					14.03,
					123.75,
					14.06,
					123.91,
					14.2,
					124.25,
					13.89,
					124.51,
					13.63,
					124.52,
					13.45,
					124.4,
					13.4,
					124.19,
					13.61,
					123.93,
					13.59,
					123.65,
					13.26,
					124.3,
					12.64,
					124.21,
					12.8,
					124.34,
					12.62,
					124.69,
					12.79,
					125.1,
					12.16,
					125.66,
					11.63,
					125.56,
					10.88,
					125.93,
					10.81,
					126.06,
					10.71,
					126.06,
					10.58,
					125.73,
					10.69,
					125.57,
					10.88,
					125.59,
					11.01,
					125.51,
					10.98,
					125.2,
					11.08,
					125.11,
					10.82,
					125.11,
					10.64,
					125.28,
					10.39,
					125.37,
					10.16,
					125.3,
					10.05,
					125.37,
					10.35,
					125.41,
					10.46,
					125.35,
					10.57,
					125.47,
					10.53,
					125.73,
					9.97,
					125.8,
					10.16,
					126.02,
					10.11,
					126.15,
					9.63,
					126.29,
					9.52,
					126.22,
					9.5,
					126.1,
					9.32,
					126.31,
					9.12,
					126.27,
					8.86,
					126.44,
					8.63,
					126.33,
					8.53,
					126.5,
					8.39,
					126.46,
					8.29,
					126.55,
					8.09,
					126.56,
					7.92,
					126.49,
					7.77,
					126.67,
					7.29,
					126.71,
					6.94,
					126.55,
					6.86,
					126.43,
					6.17,
					126.22,
					6.19,
					126.12,
					6.48,
					125.98,
					6.81,
					125.96,
					6.91,
					125.89,
					6.79,
					125.72,
					6.89,
					125.61,
					6.75,
					125.49,
					6.67,
					125.49,
					6.53,
					125.69,
					6.07,
					125.81,
					5.57,
					125.54,
					5.47,
					125.6,
					5.31,
					125.55,
					5.26,
					125.34,
					5.34,
					125.23,
					5.47,
					125.25,
					5.75,
					125.07,
					5.75,
					124.88,
					6.01,
					124.27,
					6.32,
					123.95,
					6.9,
					123.84,
					7.18,
					124,
					7.32,
					123.9,
					7.45,
					124,
					7.54,
					123.95,
					7.7,
					123.55,
					7.27,
					123.5,
					7.39,
					123.08,
					7.28,
					123.04,
					7.15,
					122.83,
					7.32,
					122.67,
					7.66,
					122.67,
					7.44,
					122.48,
					7.07,
					122.35,
					6.7,
					122.5,
					6.36,
					122.28,
					6.16,
					121.95,
					6.07,
					122.04,
					5.94,
					121.98,
					5.82,
					121.58,
					5.86,
					121.49,
					5.55,
					121.03,
					5.39,
					120.98,
					5.34,
					120.69,
					5.23,
					120.78,
					5.11,
					120.73,
					5.07,
					120.43,
					4.91,
					120.23,
					4.9,
					120.09,
					4.69,
					119.88,
					4.71,
					119.74,
					5.07,
					119.64,
					5.29,
					119.8,
					5.42,
					120.07,
					5.67,
					120.16,
					5.73,
					120.29,
					6.17,
					120.3,
					6.47,
					120.52,
					6.54,
					120.79,
					6.19,
					121.16,
					6.19,
					121.7,
					6.34,
					121.8,
					6.54,
					121.43,
					6.8,
					121.32,
					7.01,
					121.59,
					6.91,
					121.7,
					6.78,
					121.65,
					6.84,
					121.91,
					7.14,
					121.79,
					7.34,
					121.95,
					7.57,
					122.02,
					7.75,
					121.97,
					8.02,
					122.13,
					8.26,
					122.62,
					8.26,
					122.84,
					8.57,
					122.95,
					8.62,
					123.25,
					8.65,
					123.27,
					8.68,
					123.14,
					8.81,
					123.12,
					8.81,
					123.31,
					8.98,
					123.4,
					8.9,
					123.52,
					8.8,
					123.51,
					8.67,
					123.83,
					8.29,
					123.97,
					8.32,
					124.15,
					8.67,
					124.3,
					8.73,
					124.47,
					8.65,
					124.65,
					8.99,
					124.69,
					9.12,
					124.53,
					9.35,
					124.62,
					9.28,
					124.86,
					9.12,
					124.87,
					8.98,
					125.08,
					9.19,
					125.17,
					9.11,
					125.39,
					9.8,
					125.29,
					9.86,
					125.18,
					9.79,
					125.05,
					10.06,
					124.71,
					9.63,
					124.62,
					9.37,
					123.94,
					9.46,
					123.7,
					9.58,
					123.61,
					9.29,
					123.42,
					9.4,
					123.65,
					9.11,
					123.81,
					8.98,
					123.61,
					9.11,
					123.38,
					9,
					123.35
				]
			},
			{
				"points": [
					-5.45,
					121.78,
					-5.39,
					121.65,
					-5.22,
					121.66,
					-5.06,
					121.73,
					-4.98,
					121.88,
					-4.93,
					121.62,
					-4.76,
					121.39,
					-4.32,
					121.43,
					-4.14,
					121.23,
					-4.02,
					121.23,
					-4.12,
					121.16,
					-4.14,
					121.06,
					-3.88,
					120.88,
					-3.74,
					120.96,
					-3.58,
					120.78,
					-3.39,
					120.76,
					-3.14,
					120.95,
					-2.96,
					120.97,
					-2.76,
					120.86,
					-2.74,
					120.77,
					-3.03,
					120.33,
					-3.22,
					120.51,
					-3.73,
					120.54,
					-4.11,
					120.44,
					-4.68,
					120.56,
					-4.94,
					120.4,
					-5.08,
					120.54,
					-5.17,
					120.39,
					-6.03,
					120.67,
					-6.79,
					120.49,
					-6.73,
					120.32,
					-6.14,
					120.28,
					-5.75,
					120.37,
					-5.63,
					120.31,
					-5.67,
					119.97,
					-5.76,
					119.9,
					-5.81,
					119.67,
					-5.6,
					119.18,
					-5.42,
					119.07,
					-5.31,
					119.12,
					-5.3,
					119.24,
					-5.16,
					119.3,
					-5.03,
					119.21,
					-4.8,
					119.37,
					-4.63,
					119.35,
					-4.53,
					119.48,
					-4.04,
					119.5,
					-3.73,
					119.34,
					-3.57,
					119.38,
					-3.63,
					118.84,
					-3.12,
					118.66,
					-2.97,
					118.71,
					-2.76,
					118.64,
					-2.54,
					118.74,
					-2.54,
					118.89,
					-2.42,
					119.02,
					-1.97,
					119.11,
					-1.85,
					119.23,
					-1.48,
					119.17,
					-1.15,
					119.22,
					-0.55,
					119.67,
					-0.24,
					119.68,
					-0.05,
					119.52,
					0.13,
					119.51,
					0.18,
					119.67,
					0.55,
					119.75,
					0.63,
					119.82,
					0.62,
					119.94,
					0.75,
					119.94,
					0.87,
					120.13,
					1.06,
					120.17,
					1.18,
					120.39,
					1.09,
					120.5,
					1.48,
					120.88,
					1.34,
					121.26,
					1.39,
					121.51,
					1.17,
					121.59,
					1.2,
					121.94,
					1.13,
					122.03,
					1.13,
					122.43,
					1,
					122.82,
					1.07,
					122.98,
					0.94,
					123.86,
					1.09,
					124.21,
					1.28,
					124.33,
					1.3,
					124.44,
					1.43,
					124.46,
					1.52,
					124.65,
					1.64,
					124.56,
					1.84,
					124.67,
					1.9,
					124.78,
					1.82,
					124.89,
					1.99,
					125.11,
					1.83,
					125.27,
					1.66,
					125.27,
					1.6,
					125.38,
					1.38,
					125.35,
					1.3,
					125.16,
					0.89,
					125,
					0.72,
					124.72,
					0.34,
					124.49,
					0.16,
					123.61,
					0.21,
					123.21,
					0.4,
					123.02,
					0.38,
					122.11,
					0.3,
					121.77,
					0.42,
					121.57,
					0.29,
					121.07,
					0.41,
					120.55,
					0.34,
					120.39,
					0.11,
					120.22,
					-0.19,
					120.11,
					-0.59,
					120.16,
					-0.85,
					120.35,
					-0.91,
					120.59,
					-1.26,
					120.73,
					-1.3,
					121.04,
					-0.82,
					121.37,
					-0.69,
					121.59,
					-0.63,
					121.5,
					-0.5,
					121.53,
					-0.25,
					121.79,
					-0.09,
					122.2,
					-0.17,
					122.43,
					-0.38,
					122.48,
					-0.4,
					122.68,
					-0.55,
					122.69,
					-0.46,
					123.26,
					-0.65,
					123.53,
					-0.84,
					123.56,
					-1.1,
					123.43,
					-1.24,
					123.65,
					-1.38,
					123.62,
					-1.63,
					123.72,
					-1.75,
					123.66,
					-1.82,
					123.88,
					-1.73,
					123.91,
					-1.62,
					124.13,
					-1.71,
					124.27,
					-1.87,
					124.22,
					-1.98,
					123.98,
					-2.18,
					123.99,
					-2.27,
					123.69,
					-2.2,
					123.36,
					-1.99,
					123.37,
					-1.92,
					123.26,
					-2,
					123.02,
					-1.72,
					122.94,
					-1.68,
					122.78,
					-1.52,
					122.67,
					-1.1,
					122.82,
					-1.05,
					123.1,
					-0.97,
					123.03,
					-1.02,
					122.87,
					-1.56,
					122.47,
					-1.79,
					121.9,
					-2.02,
					121.77,
					-2.05,
					121.64,
					-2.21,
					121.89,
					-2.63,
					122.09,
					-3.07,
					122.69,
					-3.18,
					122.69,
					-3.22,
					122.56,
					-3.36,
					122.5,
					-3.47,
					122.57,
					-3.62,
					122.44,
					-3.78,
					122.58,
					-3.8,
					122.72,
					-3.99,
					122.88,
					-3.86,
					123,
					-4.04,
					123.36,
					-4.34,
					123.18,
					-4.59,
					123.31,
					-5.31,
					123.32,
					-5.77,
					122.88,
					-5.81,
					122.47,
					-5.45,
					122.19,
					-5.56,
					122.16,
					-5.63,
					121.98,
					-5.45,
					121.78
				]
			},
			{
				"points": [
					78.38,
					98.8,
					78.44,
					98.63,
					78.66,
					98.61,
					78.7,
					98.06,
					78.62,
					97.89,
					78.87,
					96.93,
					78.88,
					95.74,
					78.98,
					95.61,
					78.94,
					94.87,
					79.15,
					94.32,
					79.36,
					94.29,
					79.33,
					93.82,
					79.46,
					93.69,
					79.35,
					93.52,
					79.38,
					93.17,
					79.31,
					93.08,
					79.27,
					92.29,
					79.44,
					90.64,
					79.57,
					90.52,
					79.65,
					90.59,
					79.63,
					91.02,
					79.72,
					91.14,
					80.1,
					90.89,
					80.16,
					91.42,
					80.34,
					91.33,
					80.46,
					91.39,
					80.44,
					91.88,
					80.51,
					91.97,
					80.57,
					92.79,
					80.62,
					92.83,
					80.58,
					92.47,
					80.72,
					92.37,
					80.93,
					93.05,
					81.17,
					93.13,
					81.17,
					93.58,
					81.1,
					93.65,
					81.26,
					95.06,
					81.35,
					95.17,
					81.35,
					95.96,
					81.24,
					96.1,
					81.16,
					96.56,
					81.01,
					96.86,
					80.82,
					98.19,
					80.7,
					98.21,
					80.58,
					98.07,
					80.5,
					97.26,
					80.39,
					97.53,
					80.26,
					97.6,
					80.15,
					98.15,
					80.06,
					98.23,
					80.18,
					98.72,
					80.16,
					99.35,
					79.73,
					100.47,
					79.61,
					100.46,
					79.51,
					100.24,
					79.37,
					100.24,
					79.22,
					99.97,
					78.96,
					100.12,
					78.84,
					100.09,
					78.7,
					99.56,
					78.67,
					98.91,
					78.47,
					98.9,
					78.38,
					98.8
				]
			},
			{
				"points": [
					5.16,
					100.27,
					5.11,
					100.18,
					5.19,
					100.07,
					5.52,
					100.08,
					5.57,
					100.23,
					5.73,
					100.17,
					5.94,
					100.24,
					6.33,
					100.04,
					6.09,
					99.88,
					6.07,
					99.7,
					6.41,
					99.54,
					6.54,
					99.64,
					6.47,
					100.02,
					6.81,
					100.16,
					6.79,
					100.34,
					6.62,
					100.44,
					6.6,
					100.78,
					6.34,
					100.92,
					6.33,
					101.18,
					5.97,
					101.22,
					5.79,
					101.12,
					5.91,
					101.22,
					6.03,
					101.54,
					5.9,
					101.78,
					6.35,
					102.08,
					6.24,
					102.42,
					5.92,
					102.61,
					6.04,
					102.73,
					5.9,
					102.88,
					5.89,
					103.08,
					5.64,
					103.18,
					5.5,
					103.11,
					5.28,
					103.36,
					4.8,
					103.55,
					4.31,
					103.6,
					3.75,
					103.45,
					3.53,
					103.59,
					2.94,
					103.55,
					2.77,
					103.69,
					2.76,
					104.01,
					2.99,
					104.03,
					3,
					104.2,
					2.81,
					104.33,
					2.7,
					104.31,
					2.49,
					104.64,
					2.34,
					104.61,
					2.31,
					104.51,
					2.72,
					104.03,
					2.56,
					103.94,
					2.35,
					104.24,
					2.1,
					104.13,
					1.47,
					104.4,
					1.29,
					104.36,
					1.27,
					104.06,
					1.05,
					103.72,
					1.19,
					103.61,
					1.2,
					103.39,
					1.36,
					103.3,
					1.38,
					103.17,
					1.52,
					103.15,
					2.3,
					101.8,
					2.51,
					101.69,
					2.6,
					101.41,
					2.82,
					101.16,
					3.05,
					101.13,
					3.2,
					101.2,
					3.92,
					100.59,
					3.99,
					100.44,
					4.64,
					100.52,
					5.02,
					100.26,
					5.16,
					100.27
				]
			},
			{
				"points": [
					-9,
					121.58,
					-8.95,
					121.41,
					-9.03,
					121.32,
					-9.07,
					121,
					-8.91,
					120.52,
					-9,
					120.27,
					-8.9,
					120.14,
					-8.97,
					119.9,
					-8.91,
					119.63,
					-8.79,
					119.54,
					-8.85,
					119.36,
					-8.78,
					119.27,
					-8.96,
					118.89,
					-8.91,
					118.7,
					-8.97,
					118.39,
					-8.88,
					118.3,
					-8.98,
					118.14,
					-9.02,
					117.71,
					-9.21,
					117.08,
					-8.99,
					116.61,
					-9.06,
					116.36,
					-8.9,
					115.79,
					-8.81,
					115.72,
					-8.24,
					115.99,
					-8.1,
					116.39,
					-8.19,
					116.77,
					-8.33,
					116.82,
					-8.25,
					117.11,
					-8.34,
					117.35,
					-8.27,
					117.37,
					-8.17,
					117.24,
					-8.06,
					117.29,
					-7.97,
					117.92,
					-8.04,
					118.2,
					-8.22,
					118.33,
					-8.14,
					118.5,
					-8.25,
					118.68,
					-8.02,
					119.09,
					-8.19,
					119.24,
					-8.36,
					119.1,
					-8.5,
					119.12,
					-8.48,
					119.18,
					-8.3,
					119.22,
					-8.4,
					119.68,
					-8.27,
					119.79,
					-8.29,
					119.94,
					-8.12,
					120.45,
					-8.24,
					121.01,
					-8.48,
					121.47,
					-8.27,
					121.58,
					-8.18,
					121.72,
					-8.37,
					121.85,
					-8.32,
					122.03,
					-8.5,
					122.23,
					-8.28,
					122.19,
					-8.28,
					122.62,
					-8.16,
					122.63,
					-7.96,
					122.83,
					-8.14,
					123.07,
					-8.18,
					123.33,
					-8.06,
					123.77,
					-8.13,
					124.13,
					-8.01,
					124.6,
					-8.05,
					125.12,
					-8.21,
					125.23,
					-8.45,
					125.12,
					-8.55,
					124.37,
					-8.65,
					124.1,
					-8.47,
					123.72,
					-8.68,
					123.56,
					-8.59,
					123.11,
					-8.84,
					122.44,
					-8.84,
					122.11,
					-8.99,
					121.83,
					-9,
					121.58
				]
			},
			{
				"points": [
					78.06,
					103.17,
					78.01,
					102.91,
					78.1,
					102.72,
					78.09,
					101.54,
					77.82,
					99.75,
					78.03,
					99.38,
					78.12,
					99.44,
					78.4,
					100.03,
					78.76,
					100.38,
					78.89,
					100.77,
					79.29,
					101.33,
					79.45,
					101.9,
					79.32,
					102.12,
					79.51,
					102.35,
					79.38,
					103.22,
					79.29,
					103.3,
					79.23,
					103.57,
					79.26,
					103.89,
					79.2,
					104.12,
					79.1,
					104.16,
					79.14,
					104.43,
					79.03,
					104.51,
					78.95,
					104.85,
					79,
					105.05,
					78.86,
					105.28,
					78.56,
					105.49,
					78.44,
					105.44,
					78.18,
					104.85,
					78.06,
					103.17
				]
			},
			{
				"points": [
					22.22,
					120.4,
					22.27,
					120.25,
					22.43,
					120.29,
					22.54,
					120.16,
					22.9,
					120.05,
					23.02,
					119.93,
					23.33,
					119.98,
					23.54,
					119.92,
					25.1,
					120.95,
					25.4,
					121.53,
					25.22,
					121.96,
					24.99,
					122.1,
					24.77,
					122.03,
					24.72,
					121.93,
					24.45,
					121.95,
					24.03,
					121.71,
					23.09,
					121.51,
					22.5,
					121.07,
					21.84,
					120.94,
					21.84,
					120.64,
					22.24,
					120.53,
					22.28,
					120.47,
					22.22,
					120.4
				]
			},
			{
				"points": [
					7.71,
					117.27,
					7.7,
					116.98,
					7.94,
					116.82,
					8.24,
					116.91,
					8.35,
					117.07,
					8.8,
					117.26,
					9.27,
					117.73,
					9.43,
					118.05,
					10.25,
					118.71,
					10.3,
					118.83,
					10.53,
					118.91,
					10.68,
					119.06,
					10.68,
					119.19,
					10.84,
					119.1,
					11.29,
					119.17,
					11.53,
					119.43,
					11.53,
					119.56,
					11.7,
					119.8,
					12.06,
					119.68,
					12.43,
					119.81,
					12.58,
					120.04,
					12.51,
					120.13,
					12.37,
					120.08,
					12.46,
					120.26,
					12.37,
					120.44,
					12.18,
					120.5,
					12.09,
					120.43,
					11.8,
					120.41,
					11.57,
					120.18,
					11.5,
					120.29,
					11.39,
					120.29,
					11.26,
					120.04,
					11.4,
					119.97,
					11.53,
					120.1,
					11.55,
					120.05,
					11.18,
					119.8,
					10.99,
					119.84,
					10.82,
					119.74,
					10.67,
					120.06,
					10.43,
					120.09,
					10.33,
					119.8,
					10.37,
					119.72,
					10.16,
					119.51,
					10.13,
					119.36,
					9.97,
					119.29,
					9.82,
					118.88,
					9.63,
					118.85,
					9.15,
					118.54,
					9.05,
					118.24,
					8.81,
					118.34,
					8.77,
					118.21,
					8.91,
					118.14,
					8.79,
					118.06,
					8.59,
					117.8,
					8.56,
					117.64,
					8.42,
					117.57,
					8.35,
					117.42,
					8.11,
					117.38,
					7.99,
					117.18,
					7.83,
					117.32,
					7.71,
					117.27
				]
			},
			{
				"points": [
					-11.04,
					122.96,
					-11.09,
					122.8,
					-10.93,
					122.7,
					-10.88,
					122.55,
					-10.75,
					122.53,
					-10.4,
					123.2,
					-10.31,
					123.16,
					-10.08,
					123.29,
					-10.01,
					123.46,
					-9.58,
					123.55,
					-9.26,
					123.89,
					-9.32,
					124.27,
					-9.08,
					124.4,
					-8.85,
					124.92,
					-8.94,
					125.21,
					-9.19,
					125.24,
					-9.26,
					125.13,
					-9.48,
					125.22,
					-10.19,
					124.54,
					-10.26,
					124.17,
					-10.47,
					123.79,
					-10.47,
					123.52,
					-10.78,
					123.46,
					-11.04,
					122.96
				]
			},
			{
				"points": [
					-10.43,
					120.17,
					-10.43,
					120.05,
					-10.28,
					120,
					-9.69,
					118.92,
					-9.42,
					118.87,
					-9.27,
					119.15,
					-9.17,
					119.96,
					-9.55,
					120.52,
					-10.1,
					120.93,
					-10.41,
					120.5,
					-10.43,
					120.17
				]
			},
			{
				"points": [
					-8.89,
					115.6,
					-8.83,
					115.38,
					-8.93,
					115.25,
					-8.92,
					115.01,
					-8.45,
					114.48,
					-8.02,
					114.35,
					-7.94,
					115.17,
					-8.26,
					115.76,
					-8.4,
					115.8,
					-8.63,
					115.63,
					-8.75,
					115.73,
					-8.89,
					115.6
				]
			},
			{
				"points": [
					77.93,
					107.55,
					78.01,
					106.47,
					78.16,
					106.08,
					78.26,
					106.02,
					78.35,
					106.09,
					78.49,
					106.62,
					78.37,
					106.93,
					78.26,
					106.95,
					78.3,
					107.52,
					78.21,
					107.81,
					78.07,
					107.83,
					77.93,
					107.55
				]
			},
			{
				"points": [
					72.61,
					79.03,
					72.77,
					78.51,
					72.89,
					78.52,
					73.07,
					78.85,
					73.1,
					78.69,
					73.21,
					78.67,
					73.35,
					78.96,
					73.27,
					79.41,
					73.11,
					79.42,
					72.95,
					79.61,
					72.7,
					79.66,
					72.61,
					79.03
				]
			},
			{
				"points": [
					80.92,
					90.93,
					80.96,
					90.17,
					81.03,
					90,
					81.13,
					89.97,
					81.29,
					90.23,
					81.32,
					91.05,
					81.28,
					91.64,
					81.12,
					91.83,
					81.01,
					91.74,
					80.92,
					90.93
				]
			}
		],
		"transitions": [
			[
				0,
				480,
				[
					"CST",
					"MYT",
					"HKT",
					"SGT",
					"KRAT",
					"CHOT",
					"WST",
					"CIT",
					"ULAT",
					"BNT",
					"PHT"
				]
			]
		],
		"name": "Asia/Kashgar"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-29.21,
					168,
					-29.2,
					167.89,
					-29.07,
					167.81,
					-28.88,
					167.89,
					-28.98,
					168.09,
					-29.21,
					168
				]
			}
		],
		"transitions": [
			[
				0,
				690,
				[
					"NFT"
				]
			]
		],
		"name": "Pacific/Norfolk"
	},
	{
		"hoverRegion": [
			{
				"points": [
					1.62,
					-157.13,
					1.59,
					-157.26,
					1.78,
					-157.65,
					2.11,
					-157.59,
					2.14,
					-157.48,
					2.04,
					-157.24,
					1.76,
					-157.07,
					1.62,
					-157.13
				]
			},
			{
				"points": [
					3.71,
					-159.24,
					3.69,
					-159.35,
					3.81,
					-159.48,
					4.02,
					-159.44,
					3.91,
					-159.16,
					3.71,
					-159.24
				]
			},
			{
				"points": [
					-4.11,
					-154.84,
					-4.15,
					-154.93,
					-4.07,
					-155.04,
					-3.9,
					-155.02,
					-3.93,
					-154.8,
					-4.11,
					-154.84
				]
			},
			{
				"points": [
					-10.02,
					-150.13,
					-10.1,
					-150.23,
					-10.04,
					-150.34,
					-9.8,
					-150.26,
					-9.85,
					-150.11,
					-10.02,
					-150.13
				]
			}
		],
		"transitions": [
			[
				0,
				840,
				[
					"LINT"
				]
			]
		],
		"name": "Pacific/Kiritimati"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-8.87,
					-61.38,
					-9.34,
					-61.48,
					-9.62,
					-61.36,
					-9.74,
					-61.44,
					-10.13,
					-61.46,
					-10.43,
					-61.35,
					-10.89,
					-61.4,
					-10.89,
					-60.39,
					-11,
					-60.3,
					-11.07,
					-59.91,
					-11.35,
					-59.8,
					-11.69,
					-59.98,
					-12.42,
					-59.71,
					-12.98,
					-59.98,
					-13.11,
					-60.17,
					-13.49,
					-60.29,
					-13.66,
					-60.52,
					-13.71,
					-60.39,
					-13.95,
					-60.27,
					-14.18,
					-60.35,
					-14.62,
					-60.14,
					-15.13,
					-60.14,
					-15.2,
					-60.33,
					-15.43,
					-60.13,
					-16.15,
					-60.07,
					-16.2,
					-58.22,
					-16.55,
					-58.23,
					-16.73,
					-58.35,
					-17.14,
					-58.28,
					-17.39,
					-57.99,
					-17.35,
					-57.84,
					-17.47,
					-57.7,
					-17.81,
					-57.59,
					-18.2,
					-57.35,
					-18.34,
					-57.47,
					-18.86,
					-57.64,
					-19.08,
					-57.61,
					-19.14,
					-57.71,
					-19.73,
					-57.99,
					-19.88,
					-57.8,
					-20.01,
					-57.77,
					-20.13,
					-57.85,
					-20.26,
					-58.2,
					-19.87,
					-58.29,
					-19.45,
					-59.14,
					-19.4,
					-59.97,
					-19.72,
					-61.66,
					-20.17,
					-61.84,
					-20.6,
					-62.15,
					-21.09,
					-62.15,
					-22.34,
					-62.59,
					-22.25,
					-62.85,
					-22.11,
					-62.9,
					-22.11,
					-63.86,
					-22.91,
					-64.23,
					-22.97,
					-64.32,
					-22.92,
					-64.41,
					-22.28,
					-64.71,
					-22.19,
					-65,
					-22.21,
					-65.78,
					-21.96,
					-66.15,
					-22.16,
					-66.22,
					-22.31,
					-66.64,
					-22.5,
					-66.69,
					-22.6,
					-66.9,
					-22.72,
					-66.93,
					-22.91,
					-67.14,
					-23,
					-67.54,
					-22.92,
					-67.93,
					-22.14,
					-68.04,
					-22.01,
					-68.16,
					-21.79,
					-68.16,
					-21.63,
					-68.28,
					-21.32,
					-68.28,
					-21.02,
					-68.47,
					-20.92,
					-68.64,
					-20.64,
					-68.61,
					-20.4,
					-68.86,
					-20.29,
					-68.79,
					-20.05,
					-68.88,
					-19.94,
					-68.64,
					-19.7,
					-68.79,
					-19.41,
					-68.56,
					-19,
					-69.04,
					-18.86,
					-69.02,
					-18.1,
					-69.23,
					-18.01,
					-69.38,
					-17.78,
					-69.43,
					-17.64,
					-69.56,
					-17.43,
					-69.57,
					-17.27,
					-69.75,
					-17,
					-69.46,
					-16.64,
					-69.23,
					-16.58,
					-69.1,
					-16.38,
					-69.08,
					-16.31,
					-68.99,
					-16.32,
					-69.11,
					-16.21,
					-69.32,
					-15.61,
					-69.52,
					-15.22,
					-69.29,
					-15.01,
					-69.46,
					-14.76,
					-69.46,
					-14.12,
					-68.99,
					-13.65,
					-69.18,
					-13.47,
					-69.05,
					-12.81,
					-69.06,
					-12.52,
					-68.79,
					-11.03,
					-69.64,
					-11.03,
					-69.91,
					-11.17,
					-70.31,
					-11.05,
					-70.71,
					-9.81,
					-70.73,
					-9.69,
					-70.67,
					-10.07,
					-71.18,
					-10.1,
					-72.18,
					-10.04,
					-72.27,
					-9.86,
					-72.27,
					-9.8,
					-72.35,
					-9.6,
					-72.39,
					-9.47,
					-73.28,
					-9.37,
					-73.3,
					-9.02,
					-73.05,
					-8.78,
					-73.23,
					-8.68,
					-73.42,
					-8.53,
					-73.44,
					-8.41,
					-73.63,
					-8.09,
					-73.71,
					-7.92,
					-73.88,
					-7.8,
					-73.82,
					-7.58,
					-74.08,
					-7.33,
					-74.05,
					-7.23,
					-73.85,
					-7.06,
					-73.89,
					-6.67,
					-73.71,
					-6.4,
					-73.24,
					-6.01,
					-73.34,
					-5.64,
					-73.09,
					-5.14,
					-72.99,
					-5.02,
					-72.89,
					-4.93,
					-72.67,
					-4.42,
					-71.96,
					-4.26,
					-70.99,
					-4.05,
					-70.8,
					-4.03,
					-70.32,
					-4.17,
					-70.17,
					-4.16,
					-70.04,
					-1.31,
					-69.48,
					-1.04,
					-69.52,
					-0.78,
					-69.71,
					-0.56,
					-69.7,
					-0.2,
					-70.13,
					0.56,
					-70.14,
					0.66,
					-70.06,
					0.73,
					-69.64,
					0.84,
					-69.48,
					0.73,
					-69.29,
					0.84,
					-69.25,
					0.92,
					-69.31,
					0.99,
					-69.93,
					1.8,
					-69.91,
					1.88,
					-69.55,
					1.84,
					-68.39,
					2.14,
					-68.2,
					1.9,
					-67.92,
					2.15,
					-67.65,
					2.25,
					-67.4,
					1.76,
					-67.01,
					1.3,
					-66.99,
					1.31,
					-66.78,
					0.85,
					-66.28,
					0.86,
					-66.13,
					1.11,
					-65.73,
					1.1,
					-65.53,
					0.96,
					-65.4,
					1.03,
					-65.24,
					1.2,
					-65.18,
					1.22,
					-65.01,
					1.41,
					-64.83,
					1.4,
					-64.67,
					1.63,
					-64.42,
					1.59,
					-64.25,
					2.06,
					-64.07,
					2.09,
					-63.81,
					2.32,
					-63.46,
					2.29,
					-63.79,
					2.43,
					-64.11,
					2.74,
					-64.1,
					3.12,
					-64.32,
					3.59,
					-64.29,
					3.81,
					-64.63,
					4.18,
					-64.89,
					4.3,
					-64.89,
					4.44,
					-64.73,
					4.26,
					-64.51,
					4.28,
					-64.1,
					4.07,
					-63.93,
					4.12,
					-63.81,
					4.03,
					-63.49,
					4.14,
					-63.32,
					3.73,
					-62.86,
					4.1,
					-62.8,
					4.13,
					-62.61,
					4.25,
					-62.47,
					4.19,
					-62.14,
					4.26,
					-61.89,
					4.37,
					-61.62,
					4.64,
					-61.34,
					4.65,
					-61.03,
					4.77,
					-60.99,
					4.97,
					-60.71,
					5.95,
					-61.48,
					6.24,
					-61.22,
					6.58,
					-61.32,
					6.8,
					-61.18,
					6.92,
					-60.91,
					6.87,
					-60.72,
					7.04,
					-60.41,
					7.01,
					-60.56,
					7.14,
					-60.72,
					7.55,
					-60.83,
					7.91,
					-60.58,
					7.92,
					-60.4,
					8.29,
					-59.94,
					8.54,
					-60.1,
					8.66,
					-59.99,
					8.47,
					-59.78,
					8.46,
					-59.63,
					8.11,
					-59.05,
					7.41,
					-58.38,
					7.13,
					-58.38,
					6.97,
					-58.22,
					6.89,
					-57.96,
					6.39,
					-57.47,
					6.37,
					-57.31,
					6.13,
					-57.07,
					5.61,
					-57.07,
					5.33,
					-57.21,
					5.12,
					-57.09,
					4.93,
					-57.25,
					4.91,
					-57.64,
					4.82,
					-57.79,
					4.58,
					-57.74,
					4.12,
					-57.96,
					3.48,
					-57.57,
					3.43,
					-57.21,
					2.92,
					-57.11,
					2.11,
					-56.62,
					1.92,
					-56.37,
					1.83,
					-56.44,
					1.75,
					-56.77,
					1.88,
					-57.11,
					1.85,
					-57.28,
					1.6,
					-57.49,
					1.56,
					-57.9,
					1.39,
					-57.99,
					1.46,
					-58.26,
					1.35,
					-58.39,
					1.17,
					-58.43,
					1.07,
					-58.84,
					-0.22,
					-58.76,
					-0.41,
					-58.61,
					-0.58,
					-58.63,
					-0.74,
					-58.38,
					-1.03,
					-58.24,
					-1.48,
					-57.62,
					-1.6,
					-57.21,
					-1.84,
					-56.93,
					-1.94,
					-56.68,
					-2.1,
					-56.64,
					-2.06,
					-56.45,
					-2.23,
					-56.19,
					-6.52,
					-58.18,
					-6.73,
					-58.34,
					-6.86,
					-58.31,
					-7.06,
					-58.11,
					-7.33,
					-58.02,
					-7.84,
					-58.26,
					-8.13,
					-58.19,
					-8.77,
					-58.38,
					-8.87,
					-61.38
				]
			},
			{
				"points": [
					17.39,
					-71.55,
					17.36,
					-71.67,
					17.44,
					-71.74,
					17.65,
					-71.61,
					17.7,
					-71.77,
					17.85,
					-71.75,
					18.17,
					-71.88,
					18.29,
					-71.83,
					18.6,
					-72.11,
					18.71,
					-72.06,
					18.77,
					-71.84,
					18.96,
					-71.99,
					19.19,
					-71.78,
					19.32,
					-71.89,
					19.47,
					-71.79,
					19.79,
					-71.88,
					20,
					-71.68,
					19.94,
					-71.25,
					20.03,
					-71.06,
					20.01,
					-70.83,
					19.75,
					-70.23,
					19.78,
					-69.91,
					19.39,
					-69.68,
					19.46,
					-69.18,
					19.31,
					-69.04,
					19.11,
					-69.14,
					19.11,
					-68.86,
					18.7,
					-68.24,
					18.27,
					-68.37,
					18.25,
					-68.51,
					18.08,
					-68.47,
					18,
					-68.54,
					18.04,
					-68.8,
					18.26,
					-68.9,
					18.3,
					-69.11,
					18.35,
					-69.87,
					18.13,
					-70.09,
					18.08,
					-70.49,
					18.13,
					-70.64,
					18.29,
					-70.68,
					18.15,
					-70.96,
					18.03,
					-70.98,
					17.53,
					-71.34,
					17.39,
					-71.55
				]
			},
			{
				"points": [
					50.08,
					-60.21,
					50.1,
					-61.03,
					49.99,
					-61.79,
					50.11,
					-61.9,
					50.46,
					-61.3,
					50.47,
					-60.32,
					50.53,
					-60.06,
					50.64,
					-60,
					50.65,
					-59.7,
					50.75,
					-59.67,
					50.78,
					-59.54,
					50.95,
					-59.51,
					51.09,
					-59.24,
					51.25,
					-59.23,
					51.27,
					-58.97,
					51.46,
					-58.91,
					51.55,
					-58.02,
					51.69,
					-57.92,
					51.69,
					-57.09,
					51.62,
					-56.99,
					51.26,
					-57.09,
					51.3,
					-57.61,
					51.1,
					-58.32,
					50.91,
					-58.78,
					50.82,
					-58.72,
					50.67,
					-58.79,
					50.68,
					-58.93,
					50.54,
					-59.06,
					50.36,
					-59.5,
					50.2,
					-59.58,
					50.08,
					-60.21
				]
			},
			{
				"points": [
					17.79,
					-66.45,
					17.83,
					-67.23,
					18.34,
					-67.37,
					18.29,
					-67.54,
					18.46,
					-67.57,
					18.49,
					-67.46,
					18.41,
					-67.36,
					18.62,
					-67.09,
					18.56,
					-65.88,
					18.48,
					-65.55,
					18.26,
					-65.47,
					18.25,
					-65.41,
					18.45,
					-65.39,
					18.41,
					-65.16,
					18.56,
					-64.86,
					18.61,
					-64.37,
					18.69,
					-64.5,
					18.83,
					-64.47,
					18.86,
					-64.29,
					18.73,
					-64.19,
					18.44,
					-64.23,
					18.23,
					-64.52,
					18.25,
					-65.14,
					18.04,
					-65.23,
					17.97,
					-65.54,
					18.04,
					-65.64,
					17.9,
					-65.8,
					17.79,
					-66.45
				]
			},
			{
				"points": [
					9.93,
					-61.91,
					10.02,
					-62.02,
					10.77,
					-61.83,
					10.91,
					-61.36,
					10.91,
					-60.83,
					10.04,
					-60.93,
					9.93,
					-61.91
				]
			},
			{
				"points": [
					15.79,
					-61.47,
					15.72,
					-61.55,
					15.79,
					-61.74,
					16.04,
					-61.87,
					16.37,
					-61.89,
					16.62,
					-61.46,
					16.38,
					-61.16,
					16.43,
					-60.93,
					16.3,
					-60.89,
					16.09,
					-61.03,
					16.09,
					-61.21,
					15.87,
					-61.09,
					15.75,
					-61.28,
					15.95,
					-61.43,
					15.79,
					-61.47
				]
			}
		],
		"transitions": [
			[
				0,
				-240,
				[
					"AST",
					"AMT",
					"GYT",
					"BOT"
				]
			]
		],
		"name": "America/St_Lucia"
	},
	{
		"hoverRegion": [
			{
				"points": [
					47.19,
					-84.77,
					47.55,
					-85.14,
					47.83,
					-85.02,
					47.8,
					-85.5,
					47.66,
					-85.52,
					47.58,
					-85.78,
					47.66,
					-86.02,
					47.78,
					-86.04,
					47.86,
					-85.87,
					48.05,
					-86.16,
					48.63,
					-86.49,
					48.57,
					-86.64,
					48.68,
					-86.73,
					48.67,
					-86.86,
					48.51,
					-86.97,
					48.66,
					-87.29,
					48.5,
					-88.23,
					48.37,
					-88.32,
					48.26,
					-88.57,
					48.33,
					-88.29,
					48.15,
					-88.25,
					47.82,
					-88.74,
					47.7,
					-89.15,
					47.78,
					-89.32,
					47.91,
					-89.32,
					48.24,
					-88.69,
					47.88,
					-89.53,
					47.89,
					-89.96,
					47.93,
					-90.04,
					48.16,
					-90.09,
					48.44,
					-91.05,
					49.33,
					-91.07,
					49.58,
					-90.1,
					50.68,
					-90.1,
					50.9,
					-90.54,
					51.17,
					-90.82,
					51.54,
					-90.85,
					51.84,
					-90.54,
					52.06,
					-90.1,
					52.82,
					-90.07,
					52.85,
					-89.1,
					53.08,
					-89.06,
					53.42,
					-88.6,
					53.57,
					-88.6,
					53.89,
					-89.03,
					53.89,
					-90,
					53.95,
					-90.1,
					56.26,
					-90.09,
					56.96,
					-88.85,
					56.79,
					-88.61,
					56.56,
					-87.93,
					56.19,
					-87.56,
					56.05,
					-87.31,
					55.75,
					-85.88,
					55.36,
					-85.03,
					55.4,
					-83.91,
					55.33,
					-83.68,
					55.33,
					-83.1,
					55.42,
					-82.97,
					55.25,
					-82.84,
					55.3,
					-82.74,
					55.2,
					-82.2,
					54.78,
					-82.09,
					54.27,
					-82.31,
					53.82,
					-82.02,
					53.57,
					-82.1,
					53.25,
					-82,
					53.07,
					-82.14,
					53.25,
					-81.9,
					53.3,
					-81.12,
					53.06,
					-80.74,
					52.74,
					-80.56,
					52.55,
					-80.69,
					52.85,
					-81.95,
					52.52,
					-81.48,
					52.21,
					-81.31,
					52.13,
					-80.99,
					51.88,
					-80.6,
					51.42,
					-80.34,
					51.28,
					-79.83,
					51.45,
					-79.81,
					51.77,
					-79.37,
					51.82,
					-79.36,
					51.82,
					-79.68,
					52,
					-79.76,
					52.14,
					-79.56,
					52.25,
					-79.59,
					52.34,
					-79.52,
					52.34,
					-79.33,
					52.44,
					-79.24,
					52.89,
					-79.37,
					52.98,
					-79.26,
					52.93,
					-79.15,
					53.18,
					-79.08,
					53.49,
					-79.36,
					53.61,
					-79.25,
					53.82,
					-79.3,
					53.92,
					-79.24,
					54.02,
					-79.37,
					53.91,
					-79.46,
					53.96,
					-79.58,
					54.31,
					-79.59,
					54.5,
					-79.71,
					54.54,
					-79.86,
					54.75,
					-79.89,
					54.94,
					-79.7,
					55,
					-78.93,
					55.36,
					-77.84,
					55.51,
					-77.71,
					55.68,
					-77.34,
					55.85,
					-77.27,
					55.86,
					-77.11,
					56.03,
					-76.89,
					56.29,
					-76.89,
					56.41,
					-76.79,
					56.75,
					-76.74,
					57.64,
					-77,
					57.72,
					-77.14,
					57.82,
					-77.15,
					57.96,
					-77.33,
					58.62,
					-78.98,
					58.81,
					-79.07,
					59,
					-78.98,
					59.06,
					-78.45,
					59.36,
					-78.06,
					59.8,
					-77.88,
					59.85,
					-77.6,
					60.13,
					-77.82,
					60.64,
					-77.98,
					60.69,
					-78.33,
					60.59,
					-78.67,
					60.71,
					-78.79,
					60.87,
					-78.65,
					60.92,
					-78.23,
					61.19,
					-77.9,
					61.54,
					-77.94,
					61.65,
					-78.11,
					62.14,
					-78.3,
					62.29,
					-78.3,
					62.46,
					-78.18,
					62.61,
					-78.23,
					62.68,
					-78.14,
					62.63,
					-76.82,
					62.44,
					-76.08,
					62.34,
					-74.76,
					62.36,
					-74.37,
					62.48,
					-74.02,
					62.61,
					-74.66,
					62.71,
					-74.73,
					62.8,
					-74.67,
					62.77,
					-73.97,
					62.65,
					-73.82,
					62.54,
					-73.84,
					62.59,
					-73.69,
					62.43,
					-73.02,
					62.32,
					-72.94,
					62.34,
					-72.79,
					62.13,
					-72.49,
					62.09,
					-72.11,
					61.97,
					-72.02,
					61.93,
					-71.87,
					61.8,
					-71.87,
					61.75,
					-71.51,
					61.62,
					-71.4,
					61.49,
					-71.5,
					61.24,
					-71.31,
					61.13,
					-70.58,
					61.2,
					-70.11,
					61.05,
					-69.82,
					61.17,
					-69.73,
					61.17,
					-69.48,
					61.07,
					-69.3,
					60.88,
					-69.2,
					60.73,
					-69.28,
					60.61,
					-69.52,
					60.47,
					-69.62,
					60.24,
					-69.47,
					60.07,
					-69.45,
					59.97,
					-69.52,
					59.63,
					-69.39,
					59.49,
					-69.55,
					59.41,
					-69.18,
					59.24,
					-69.12,
					59.14,
					-68.89,
					58.99,
					-68.81,
					58.99,
					-68.54,
					58.85,
					-68.27,
					58.66,
					-68.21,
					58.68,
					-67.98,
					58.43,
					-67.39,
					58.45,
					-67.32,
					58.52,
					-67.39,
					58.65,
					-67.35,
					58.64,
					-67.19,
					58.49,
					-67.12,
					58.61,
					-66.98,
					58.65,
					-66.72,
					58.92,
					-66.51,
					58.95,
					-66.18,
					59.04,
					-66.23,
					59.13,
					-66.17,
					59.1,
					-66,
					59.6,
					-65.57,
					59.81,
					-65.62,
					60.02,
					-65.23,
					60.34,
					-64.97,
					60.69,
					-64.87,
					60.78,
					-64.53,
					60.42,
					-64.32,
					60.19,
					-64.52,
					60.05,
					-64.51,
					60,
					-64.59,
					59.91,
					-64.55,
					59.79,
					-64.66,
					59.56,
					-64.7,
					59.57,
					-64.26,
					59.45,
					-64.26,
					59.3,
					-64.42,
					59.18,
					-64.39,
					59.09,
					-64.19,
					58.94,
					-64.2,
					58.86,
					-64.11,
					58.99,
					-63.68,
					58.79,
					-63.36,
					58.68,
					-63.4,
					58.61,
					-63.79,
					58.42,
					-63.73,
					58.26,
					-64.09,
					58.13,
					-64.17,
					57.89,
					-64.01,
					57.77,
					-63.48,
					57.53,
					-63.64,
					57.21,
					-63.64,
					57.04,
					-63.77,
					56.85,
					-63.77,
					56.68,
					-63.97,
					56.48,
					-63.78,
					56.37,
					-63.8,
					56.34,
					-63.92,
					56.29,
					-63.8,
					56.15,
					-63.75,
					56.06,
					-63.33,
					55.92,
					-63.35,
					55.86,
					-63.6,
					55.66,
					-63.6,
					55.53,
					-63.56,
					55.47,
					-63.25,
					55.37,
					-63.21,
					55.07,
					-63.47,
					54.84,
					-63.51,
					54.83,
					-63.71,
					54.56,
					-63.63,
					54.49,
					-63.88,
					54.52,
					-64.15,
					54.67,
					-64.41,
					54.62,
					-64.8,
					54.75,
					-64.87,
					54.84,
					-65.06,
					54.64,
					-65.4,
					54.6,
					-65.72,
					54.81,
					-65.91,
					54.86,
					-66.26,
					55.06,
					-66.57,
					54.81,
					-66.49,
					54.62,
					-66.59,
					54.76,
					-67,
					54.64,
					-66.97,
					54.39,
					-67.21,
					54.36,
					-67.6,
					54.18,
					-67.5,
					54.06,
					-67.67,
					53.65,
					-67.25,
					53.62,
					-67,
					53.48,
					-66.79,
					53.03,
					-66.92,
					52.96,
					-67.01,
					52.84,
					-66.95,
					52.9,
					-66.75,
					53.06,
					-66.65,
					53.09,
					-66.29,
					52.89,
					-66.16,
					52.78,
					-66.24,
					52.63,
					-66.17,
					52.52,
					-66.27,
					52.42,
					-66.24,
					52.18,
					-65.96,
					52.2,
					-65.45,
					51.86,
					-65.11,
					51.86,
					-64.7,
					51.73,
					-64.53,
					51.79,
					-64.42,
					52.02,
					-64.47,
					52.18,
					-64.32,
					52.31,
					-64.35,
					52.42,
					-64.26,
					52.6,
					-64.34,
					52.78,
					-64.24,
					52.88,
					-63.79,
					52.98,
					-63.64,
					52.71,
					-63.3,
					52.59,
					-63.3,
					52.45,
					-63.91,
					52.38,
					-63.65,
					52.1,
					-63.55,
					52.09,
					-57.09,
					51.99,
					-56.99,
					51.58,
					-56.99,
					51.49,
					-57.05,
					51.47,
					-57.81,
					51.34,
					-57.9,
					51.26,
					-58.75,
					51.08,
					-58.78,
					51.05,
					-59.01,
					50.91,
					-59.02,
					50.88,
					-59.22,
					50.59,
					-59.35,
					50.56,
					-59.5,
					50.46,
					-59.54,
					50.43,
					-59.85,
					50.32,
					-59.92,
					50.25,
					-60.22,
					50.25,
					-61.07,
					50.17,
					-61.12,
					50.16,
					-61.44,
					50.05,
					-61.56,
					50.01,
					-61.76,
					50.1,
					-61.91,
					50.19,
					-62.96,
					50.07,
					-63.3,
					50.08,
					-64.1,
					50.18,
					-64.23,
					50.17,
					-65.91,
					49.97,
					-66.38,
					50,
					-66.63,
					49.7,
					-67.04,
					49.4,
					-67.13,
					49.21,
					-67.31,
					49.15,
					-68.08,
					49,
					-68.13,
					48.95,
					-68.49,
					48.79,
					-68.59,
					48.68,
					-68.96,
					48.51,
					-69.03,
					48.48,
					-69.17,
					48.23,
					-69.35,
					48.06,
					-69.64,
					47.98,
					-69.61,
					48.12,
					-69.52,
					48.13,
					-69.39,
					48.5,
					-68.92,
					49.18,
					-66.77,
					49.32,
					-65.99,
					49.32,
					-65.05,
					49.15,
					-64.46,
					48.95,
					-64.15,
					48.75,
					-64.05,
					48.4,
					-64.08,
					48.24,
					-64.62,
					48.1,
					-64.72,
					47.89,
					-65.24,
					47.89,
					-65.51,
					48.06,
					-65.93,
					47.97,
					-66.07,
					47.99,
					-66.46,
					47.88,
					-66.84,
					47.78,
					-66.91,
					47.73,
					-67.36,
					47.88,
					-67.69,
					47.8,
					-68.27,
					47.46,
					-68.31,
					47.42,
					-68.1,
					47.11,
					-67.68,
					45.76,
					-67.69,
					45.63,
					-67.32,
					45.31,
					-67.36,
					45.24,
					-67.07,
					44.74,
					-66.86,
					44.34,
					-67.54,
					44.42,
					-67.75,
					44.32,
					-67.81,
					44.24,
					-68.11,
					44.06,
					-68.17,
					43.98,
					-68.52,
					43.75,
					-68.77,
					43.72,
					-68.92,
					43.88,
					-69.01,
					43.65,
					-69.28,
					43.78,
					-69.42,
					43.65,
					-69.58,
					43.68,
					-69.71,
					43.59,
					-69.82,
					43.65,
					-69.92,
					43.23,
					-70.49,
					42.88,
					-70.69,
					42.8,
					-70.68,
					42.75,
					-70.54,
					42.58,
					-70.49,
					42.37,
					-70.85,
					42.34,
					-70.71,
					41.86,
					-70.41,
					41.82,
					-70.28,
					41.87,
					-70.15,
					42.01,
					-70.34,
					42.13,
					-70.33,
					42.1,
					-69.98,
					41.78,
					-69.82,
					41.45,
					-69.96,
					41.25,
					-69.86,
					41.14,
					-69.97,
					41.25,
					-70.4,
					41.14,
					-70.85,
					41.38,
					-71.05,
					41.36,
					-71.36,
					41.25,
					-71.47,
					41.15,
					-71.44,
					41.06,
					-71.51,
					41.06,
					-71.67,
					41.23,
					-71.7,
					41.21,
					-71.85,
					41.18,
					-71.89,
					41.09,
					-71.75,
					40.97,
					-71.81,
					40.56,
					-73.02,
					40.44,
					-73.87,
					39.69,
					-74.01,
					39.34,
					-74.26,
					39.21,
					-74.48,
					38.86,
					-74.78,
					38.83,
					-74.99,
					38.44,
					-74.94,
					38.03,
					-75.1,
					37.8,
					-75.26,
					37.71,
					-75.43,
					37.18,
					-75.69,
					36.98,
					-75.9,
					35.61,
					-75.35,
					35.16,
					-75.43,
					34.9,
					-76.07,
					34.49,
					-76.49,
					34.58,
					-76.7,
					34.5,
					-77.16,
					34.16,
					-77.68,
					33.73,
					-77.93,
					33.79,
					-78.36,
					33.66,
					-78.73,
					33.41,
					-79,
					33.14,
					-79.08,
					32.92,
					-79.29,
					32.9,
					-79.46,
					32.7,
					-79.78,
					32.59,
					-79.83,
					32.37,
					-80.32,
					32.24,
					-80.39,
					32.02,
					-80.76,
					31.9,
					-80.77,
					31.8,
					-80.95,
					31.02,
					-81.31,
					30.57,
					-81.33,
					29.8,
					-81.14,
					29.26,
					-80.9,
					28.63,
					-80.48,
					28.12,
					-80.45,
					26.84,
					-79.92,
					25.76,
					-80.01,
					25.42,
					-80.08,
					25.07,
					-80.27,
					24.8,
					-80.59,
					24.58,
					-81.05,
					24.44,
					-81.66,
					24.45,
					-82.13,
					24.63,
					-82.24,
					24.69,
					-82.1,
					24.64,
					-81.87,
					24.89,
					-81.51,
					24.87,
					-81.25,
					24.79,
					-81.18,
					24.94,
					-80.82,
					25.05,
					-80.86,
					25.08,
					-81.21,
					25.57,
					-81.33,
					25.76,
					-81.53,
					25.77,
					-81.76,
					26.31,
					-81.96,
					26.41,
					-82.27,
					26.77,
					-82.38,
					27.54,
					-82.87,
					28.17,
					-82.95,
					28.67,
					-82.75,
					29.04,
					-82.87,
					29.01,
					-83.14,
					29.33,
					-83.3,
					29.46,
					-83.49,
					29.6,
					-83.52,
					29.98,
					-84.03,
					29.97,
					-84.23,
					29.8,
					-84.28,
					29.81,
					-84.44,
					29.71,
					-84.51,
					29.47,
					-85.01,
					29.57,
					-85.42,
					29.75,
					-85.51,
					30.09,
					-85.47,
					30.13,
					-85.36,
					30.04,
					-85.25,
					30.69,
					-84.98,
					31.17,
					-85.21,
					31.53,
					-85.15,
					31.86,
					-85.24,
					32.42,
					-85.08,
					32.84,
					-85.29,
					35,
					-85.71,
					35.12,
					-85.49,
					35.63,
					-85.19,
					35.92,
					-84.83,
					36.22,
					-85.02,
					36.42,
					-84.8,
					36.5,
					-84.84,
					36.54,
					-85.06,
					36.83,
					-85.16,
					37.02,
					-85.03,
					37.17,
					-85.17,
					37.09,
					-85.39,
					37.35,
					-85.63,
					37.34,
					-86.09,
					37.46,
					-86.18,
					37.5,
					-86.34,
					37.6,
					-86.38,
					37.76,
					-86.29,
					38.13,
					-86.68,
					38.12,
					-87.33,
					38.43,
					-87.85,
					38.91,
					-87.65,
					39.11,
					-87.75,
					39.42,
					-87.64,
					40.77,
					-87.62,
					40.84,
					-87.2,
					41,
					-87.03,
					41.27,
					-86.97,
					41.28,
					-86.6,
					41.65,
					-86.62,
					41.66,
					-86.85,
					41.76,
					-86.91,
					41.99,
					-86.67,
					42.58,
					-86.33,
					42.96,
					-86.32,
					43.62,
					-86.63,
					43.82,
					-86.53,
					44.08,
					-86.61,
					44.39,
					-86.36,
					44.74,
					-86.34,
					44.82,
					-86.17,
					45.07,
					-86.22,
					45.23,
					-86.11,
					45.2,
					-85.89,
					45.04,
					-85.86,
					45.3,
					-85.58,
					45.28,
					-85.47,
					45.43,
					-85.17,
					45.54,
					-85.21,
					45.66,
					-85.12,
					45.77,
					-85.17,
					45.87,
					-85.01,
					45.97,
					-85.47,
					45.92,
					-85.52,
					45.89,
					-85.28,
					45.73,
					-85.25,
					45.47,
					-85.48,
					45.48,
					-85.65,
					45.27,
					-85.79,
					45.4,
					-85.97,
					45.57,
					-85.83,
					45.7,
					-85.94,
					45.81,
					-85.87,
					45.82,
					-86.2,
					45.42,
					-86.6,
					45.36,
					-86.75,
					45.48,
					-86.89,
					45.61,
					-86.8,
					45.58,
					-87.02,
					45.02,
					-87.54,
					44.99,
					-87.65,
					45.11,
					-87.71,
					45.51,
					-87.43,
					45.87,
					-87.47,
					45.91,
					-87.7,
					46.13,
					-87.72,
					46.14,
					-88.15,
					46.3,
					-88.22,
					46.22,
					-89.37,
					46.39,
					-89.47,
					46.4,
					-89.77,
					46.58,
					-89.97,
					46.85,
					-89.94,
					47.1,
					-89,
					47.55,
					-88.22,
					47.57,
					-87.76,
					47.51,
					-87.53,
					47.41,
					-87.47,
					47.29,
					-87.59,
					47.27,
					-87.9,
					47.04,
					-88.21,
					46.93,
					-87.62,
					46.61,
					-87.31,
					46.63,
					-86.96,
					46.52,
					-86.65,
					46.77,
					-86.15,
					46.77,
					-85.51,
					46.87,
					-84.96,
					46.8,
					-84.85,
					46.58,
					-84.9,
					46.58,
					-84.8,
					46.71,
					-84.84,
					46.81,
					-84.71,
					46.98,
					-84.89,
					47.19,
					-84.77
				]
			},
			{
				"points": [
					62.71,
					-64.6,
					62.72,
					-64.82,
					62.66,
					-64.74,
					62.61,
					-64.05,
					62.48,
					-64,
					62.33,
					-64.22,
					62.24,
					-64.64,
					62.4,
					-65.15,
					62.76,
					-65.66,
					62.85,
					-66.25,
					62.72,
					-66.33,
					62.77,
					-66.66,
					63.02,
					-67.13,
					63.17,
					-67.15,
					63.23,
					-67.29,
					63.17,
					-67.42,
					63.26,
					-67.63,
					63.18,
					-67.6,
					62.73,
					-66.78,
					62.68,
					-66.51,
					62.18,
					-65.74,
					61.94,
					-65.74,
					61.77,
					-65.54,
					61.78,
					-65.36,
					61.93,
					-65.34,
					62.03,
					-65.08,
					61.85,
					-64.7,
					61.58,
					-64.5,
					61.25,
					-64.64,
					61.19,
					-64.84,
					61.47,
					-65.51,
					61.66,
					-65.58,
					61.63,
					-65.91,
					61.76,
					-66.02,
					61.81,
					-66.59,
					61.98,
					-67.18,
					62.02,
					-67.91,
					62.25,
					-68.99,
					62.63,
					-69.69,
					62.68,
					-69.91,
					62.49,
					-69.84,
					62.42,
					-69.96,
					62.5,
					-70.82,
					63.4,
					-72.2,
					63.61,
					-73.13,
					63.7,
					-73.19,
					63.81,
					-73.1,
					63.93,
					-73.14,
					63.92,
					-73.6,
					64.02,
					-73.8,
					64.03,
					-74.01,
					64.27,
					-74.24,
					64.2,
					-74.51,
					64.31,
					-75.01,
					64.14,
					-75.19,
					64.24,
					-75.41,
					64.15,
					-75.68,
					64.25,
					-76.09,
					64.02,
					-76.53,
					64.14,
					-76.95,
					64.13,
					-77.39,
					64.33,
					-78.07,
					64.72,
					-78.39,
					64.85,
					-78.21,
					65.02,
					-78.22,
					65.25,
					-77.61,
					65.37,
					-77.61,
					65.56,
					-77.44,
					65.5,
					-76.62,
					65.58,
					-76.49,
					65.45,
					-76.4,
					65.37,
					-76.04,
					65.47,
					-75.79,
					65.36,
					-75.33,
					65.45,
					-75.34,
					65.54,
					-75.23,
					65.49,
					-74.81,
					65.64,
					-74.15,
					65.59,
					-73.73,
					65.98,
					-74.47,
					66.23,
					-74.53,
					66.76,
					-73.34,
					66.81,
					-73.06,
					67.11,
					-72.86,
					67.2,
					-72.39,
					67.53,
					-72.56,
					67.61,
					-72.74,
					67.71,
					-72.73,
					67.85,
					-73.01,
					68.13,
					-73.07,
					68.13,
					-73.45,
					67.86,
					-73.23,
					67.65,
					-73.4,
					67.65,
					-74.31,
					67.72,
					-74.62,
					67.98,
					-74.88,
					68.16,
					-74.78,
					68.27,
					-74.4,
					68.4,
					-74.64,
					68.2,
					-74.71,
					68.22,
					-74.9,
					67.93,
					-74.99,
					67.57,
					-74.93,
					67.33,
					-75.15,
					67.19,
					-75.56,
					67.14,
					-77.03,
					67.33,
					-77.33,
					67.8,
					-77.37,
					68.21,
					-76.93,
					68.37,
					-76.65,
					68.44,
					-76.26,
					68.36,
					-75.31,
					68.53,
					-75.51,
					68.69,
					-75.47,
					68.84,
					-75.32,
					68.87,
					-75.4,
					68.58,
					-76.28,
					68.58,
					-76.67,
					68.77,
					-76.75,
					69.11,
					-76.68,
					69.16,
					-75.73,
					69.34,
					-76.52,
					69,
					-76.84,
					69.05,
					-77.31,
					69.27,
					-77.47,
					69.47,
					-77.42,
					69.54,
					-77.23,
					69.67,
					-77.7,
					70.09,
					-77.79,
					69.91,
					-77.85,
					69.79,
					-77.99,
					69.71,
					-77.85,
					69.6,
					-77.84,
					69.47,
					-78.25,
					69.34,
					-78.1,
					69.22,
					-78.13,
					68.82,
					-78.77,
					68.74,
					-79.28,
					68.85,
					-79.46,
					68.95,
					-79.47,
					69.18,
					-79.26,
					69.38,
					-78.86,
					69.44,
					-78.96,
					69.55,
					-78.94,
					69.84,
					-78.42,
					69.83,
					-78.29,
					69.96,
					-78.35,
					70.06,
					-78.3,
					70.03,
					-78.13,
					70.12,
					-77.98,
					70.1,
					-78.39,
					70.34,
					-78.77,
					70.1,
					-78.57,
					69.87,
					-78.6,
					69.78,
					-78.8,
					69.77,
					-79.14,
					69.61,
					-79.28,
					69.39,
					-79.96,
					69.24,
					-80.09,
					69.37,
					-80.36,
					69.47,
					-80.41,
					69.54,
					-80.68,
					69.45,
					-80.72,
					69.44,
					-80.84,
					69.5,
					-80.92,
					69.61,
					-80.92,
					69.83,
					-81.64,
					69.76,
					-81.99,
					69.5,
					-81.84,
					69.63,
					-81.62,
					69.51,
					-81.4,
					69.31,
					-81.34,
					69.02,
					-81,
					68.91,
					-81.01,
					68.87,
					-81.14,
					68.78,
					-81.08,
					68.56,
					-81.15,
					68.46,
					-81.53,
					68.3,
					-81.63,
					68.37,
					-81.78,
					68.3,
					-81.89,
					68.18,
					-81.85,
					67.99,
					-82,
					67.54,
					-81.13,
					67.42,
					-81.08,
					66.87,
					-81.37,
					66.86,
					-81.87,
					66.6,
					-82.08,
					66.62,
					-82.3,
					66.47,
					-82.5,
					66.45,
					-82.8,
					66.24,
					-82.73,
					66.1,
					-82.91,
					66.23,
					-83.55,
					66.07,
					-83.38,
					65.94,
					-83.38,
					65.91,
					-83.16,
					65.64,
					-83.01,
					65.49,
					-83.03,
					65.54,
					-83.83,
					65.67,
					-84.17,
					65.83,
					-84.24,
					66.03,
					-84.56,
					66.15,
					-85,
					66.25,
					-85.08,
					69.8,
					-85.1,
					69.89,
					-85.05,
					69.94,
					-84.71,
					69.98,
					-85.05,
					70.07,
					-85.1,
					71.49,
					-85.09,
					71.54,
					-85.03,
					71.51,
					-84.73,
					71.56,
					-85.04,
					71.65,
					-85.1,
					73.38,
					-85.1,
					73.45,
					-85.02,
					73.75,
					-83.05,
					73.84,
					-82.85,
					73.83,
					-81.54,
					73.61,
					-81.13,
					73.35,
					-81.07,
					73.33,
					-80.97,
					73.49,
					-80.91,
					73.74,
					-81.07,
					73.86,
					-80.85,
					73.74,
					-79.46,
					73.77,
					-78.09,
					73.61,
					-77.16,
					73.46,
					-76.98,
					73.42,
					-76.65,
					73.22,
					-76.46,
					73.18,
					-76.19,
					73.03,
					-76.14,
					72.96,
					-75.95,
					72.83,
					-75.97,
					72.71,
					-76.31,
					72.59,
					-75.11,
					72.3,
					-74.82,
					72.32,
					-74.64,
					72.19,
					-74.48,
					72.16,
					-74.17,
					71.98,
					-73.99,
					71.84,
					-74.07,
					71.88,
					-73.58,
					71.71,
					-73.43,
					71.78,
					-73.12,
					71.69,
					-73.01,
					71.76,
					-72.51,
					71.6,
					-71.52,
					71.35,
					-71.07,
					71.19,
					-70.94,
					71.15,
					-70.53,
					70.87,
					-70.4,
					70.98,
					-69.83,
					70.83,
					-69.64,
					70.89,
					-69.41,
					70.63,
					-68.21,
					70.37,
					-68.24,
					70.43,
					-68.09,
					70.27,
					-67.53,
					70.05,
					-67.13,
					69.71,
					-67,
					69.62,
					-67.07,
					69.62,
					-67.21,
					69.57,
					-67.19,
					69.46,
					-66.78,
					69.27,
					-66.55,
					69.17,
					-66.55,
					69.03,
					-66.72,
					69.05,
					-67.35,
					68.9,
					-67.38,
					68.64,
					-67.19,
					68.75,
					-66.94,
					68.63,
					-66.79,
					68.65,
					-66.56,
					68.43,
					-66.5,
					68.33,
					-66,
					68.11,
					-66.03,
					68.25,
					-65.92,
					68.19,
					-65.79,
					68.27,
					-65.68,
					68.25,
					-65.42,
					68.12,
					-65.28,
					68.15,
					-64.98,
					68.08,
					-64.67,
					67.9,
					-64.55,
					67.8,
					-64.18,
					67.71,
					-64.13,
					67.73,
					-63.88,
					67.57,
					-63.63,
					67.47,
					-63.62,
					67.43,
					-63.09,
					67.19,
					-62.85,
					67.32,
					-62.57,
					67.19,
					-62.27,
					67.22,
					-62.07,
					66.71,
					-61.17,
					66.55,
					-61.17,
					66.28,
					-61.39,
					66.15,
					-61.7,
					66.19,
					-61.98,
					66,
					-61.81,
					65.9,
					-61.87,
					65.89,
					-62.04,
					65.57,
					-62.05,
					65.41,
					-62.46,
					65.48,
					-62.59,
					65.37,
					-62.92,
					65.15,
					-62.95,
					65.14,
					-63.21,
					64.83,
					-63.2,
					64.84,
					-63.44,
					64.77,
					-63.52,
					65.03,
					-64.38,
					64.97,
					-64.6,
					65.17,
					-64.92,
					65.13,
					-65.11,
					65.43,
					-65.26,
					65.47,
					-65.65,
					65.71,
					-65.6,
					65.56,
					-65.78,
					65.59,
					-65.89,
					65.99,
					-66.01,
					66.25,
					-66.99,
					66.18,
					-67.02,
					66.13,
					-66.83,
					65.93,
					-66.79,
					65.85,
					-67.1,
					65.69,
					-67.08,
					65.58,
					-66.97,
					65.52,
					-66.71,
					65.34,
					-66.68,
					65.23,
					-66.53,
					65.09,
					-66.49,
					65.02,
					-66.36,
					65.08,
					-66.16,
					64.95,
					-66,
					64.91,
					-65.44,
					64.69,
					-65.1,
					64.68,
					-64.88,
					64.47,
					-64.85,
					64.38,
					-64.47,
					63.69,
					-63.84,
					63.42,
					-63.8,
					63.31,
					-63.86,
					63.31,
					-63.95,
					63.17,
					-63.99,
					63.27,
					-64.36,
					63.18,
					-64.4,
					63.08,
					-64.64,
					62.91,
					-64.48,
					62.75,
					-64.51,
					62.71,
					-64.6
				]
			},
			{
				"points": [
					76.03,
					-81.31,
					76.07,
					-81.62,
					76.22,
					-81.66,
					76.27,
					-81.19,
					76.36,
					-81.05,
					76.39,
					-82.04,
					76.32,
					-82.13,
					76.26,
					-82.78,
					76.36,
					-84.16,
					76.35,
					-84.28,
					76.21,
					-84.36,
					76.17,
					-84.91,
					76.24,
					-85.1,
					78.91,
					-85.1,
					79.08,
					-84.98,
					79.25,
					-84.5,
					79.39,
					-84.87,
					79.29,
					-84.75,
					79.19,
					-84.79,
					79.14,
					-84.98,
					79.19,
					-85.08,
					79.44,
					-85.03,
					80.31,
					-85.09,
					80.37,
					-85,
					80.33,
					-83.7,
					80.24,
					-83.29,
					80.39,
					-83.31,
					80.43,
					-83.06,
					80.62,
					-83.59,
					80.43,
					-83.82,
					80.42,
					-85.07,
					82.48,
					-85.1,
					82.58,
					-85.03,
					82.38,
					-83.23,
					82.28,
					-83.13,
					82.37,
					-82.83,
					82.47,
					-82.79,
					82.77,
					-82.26,
					82.73,
					-81.71,
					82.86,
					-81.7,
					82.91,
					-81.6,
					82.89,
					-80.52,
					82.99,
					-80.43,
					83.07,
					-79.49,
					83.05,
					-79.11,
					82.98,
					-78.99,
					83.07,
					-78.35,
					83.01,
					-77.55,
					83.08,
					-77.46,
					83.16,
					-76.04,
					83.18,
					-73.97,
					83.08,
					-73.88,
					83.07,
					-73.47,
					83.2,
					-72.67,
					83.2,
					-71.57,
					83.12,
					-71.47,
					83.2,
					-71.08,
					83.21,
					-69.63,
					83.14,
					-69.54,
					83.13,
					-69.03,
					83.04,
					-68.87,
					83.11,
					-68.54,
					83.03,
					-66.36,
					82.91,
					-66.26,
					83.02,
					-64.85,
					82.97,
					-64.38,
					82.87,
					-64.32,
					82.93,
					-63.52,
					82.75,
					-63.35,
					82.68,
					-62.94,
					82.59,
					-62.86,
					82.59,
					-61.7,
					82.52,
					-61.27,
					82.33,
					-61.02,
					82.11,
					-61.19,
					81.6,
					-64.43,
					81.54,
					-64.36,
					81.42,
					-64.37,
					81.26,
					-64.75,
					81.12,
					-65.98,
					80.92,
					-66.68,
					80.83,
					-67.45,
					80.51,
					-68.87,
					80.24,
					-69.82,
					80.08,
					-70.08,
					80.06,
					-70.36,
					79.78,
					-70.83,
					79.61,
					-71.43,
					79.56,
					-72.7,
					79.62,
					-72.9,
					79.44,
					-72.98,
					79.42,
					-73.82,
					79.32,
					-74.06,
					79.35,
					-74.52,
					79.27,
					-74.35,
					79.15,
					-74.38,
					78.99,
					-74.31,
					78.9,
					-74.71,
					78.79,
					-74.07,
					78.62,
					-74.07,
					78.59,
					-74.48,
					78.48,
					-74.57,
					78.42,
					-74.97,
					78.35,
					-74.91,
					78.25,
					-74.95,
					78.1,
					-75.49,
					77.95,
					-75.57,
					77.85,
					-75.84,
					77.89,
					-76.22,
					77.76,
					-76.37,
					77.86,
					-76.48,
					77.76,
					-76.78,
					77.82,
					-77.45,
					77.68,
					-77.69,
					77.61,
					-77.6,
					77.49,
					-77.66,
					77.26,
					-78.32,
					77.22,
					-79.01,
					77.06,
					-78.87,
					77.03,
					-78.64,
					77.11,
					-78.03,
					76.85,
					-77.64,
					76.55,
					-77.75,
					76.51,
					-78.02,
					76.34,
					-78.36,
					76.44,
					-78.77,
					76.18,
					-79.29,
					76.1,
					-79.75,
					76.03,
					-81.31
				]
			},
			{
				"points": [
					75.77,
					-84.68,
					75.93,
					-83.99,
					75.84,
					-83.26,
					75.94,
					-82.33,
					75.88,
					-81.13,
					75.75,
					-80.98,
					75.74,
					-80.28,
					75.56,
					-79.84,
					75.55,
					-79.54,
					75.27,
					-79.34,
					75.1,
					-79.53,
					74.89,
					-79.22,
					74.79,
					-79.31,
					74.73,
					-80.01,
					74.55,
					-80.05,
					74.47,
					-80.22,
					74.46,
					-81.21,
					74.34,
					-81.8,
					74.43,
					-82.92,
					74.69,
					-83.24,
					74.49,
					-83.39,
					74.43,
					-83.57,
					74.39,
					-84.89,
					74.53,
					-85.1,
					75.66,
					-85.1,
					75.75,
					-85.04,
					75.77,
					-84.68
				]
			},
			{
				"points": [
					55.33,
					-79.65,
					55.35,
					-79.79,
					55.63,
					-79.93,
					55.66,
					-80.05,
					55.91,
					-80.26,
					56.37,
					-80.13,
					56.59,
					-79.69,
					56.7,
					-79.7,
					56.64,
					-79.96,
					56.87,
					-80.07,
					57.09,
					-79.69,
					56.73,
					-79.39,
					56.79,
					-79.24,
					56.67,
					-78.96,
					56.89,
					-78.94,
					56.98,
					-78.84,
					57.15,
					-78.86,
					57.27,
					-78.58,
					57.39,
					-78.68,
					57.26,
					-78.75,
					57.24,
					-78.88,
					57.33,
					-78.95,
					57.43,
					-78.92,
					57.63,
					-78.77,
					57.65,
					-78.47,
					57.47,
					-78.42,
					57.37,
					-78.21,
					57.18,
					-78.15,
					57.06,
					-78.29,
					57.09,
					-78.44,
					56.94,
					-78.73,
					56.8,
					-78.62,
					56.53,
					-78.67,
					56.4,
					-78.54,
					55.74,
					-78.64,
					55.68,
					-78.82,
					55.88,
					-78.82,
					55.57,
					-79.19,
					55.58,
					-79.45,
					55.33,
					-79.65
				]
			},
			{
				"points": [
					49.82,
					-64.58,
					49.97,
					-64.55,
					50.05,
					-64.16,
					49.83,
					-62.92,
					49.49,
					-62.14,
					49.44,
					-61.84,
					49.09,
					-61.56,
					48.94,
					-61.82,
					48.94,
					-62.25,
					49.11,
					-63.12,
					49.27,
					-63.62,
					49.53,
					-63.87,
					49.68,
					-64.44,
					49.82,
					-64.58
				]
			},
			{
				"points": [
					25.96,
					-77.5,
					26.02,
					-77.63,
					26.42,
					-77.79,
					26.38,
					-78.74,
					26.61,
					-79.06,
					26.74,
					-79.09,
					26.89,
					-78.71,
					27.02,
					-78.65,
					26.93,
					-78.33,
					27.08,
					-78.28,
					27.21,
					-78.45,
					27.33,
					-78.36,
					27.16,
					-77.93,
					27,
					-77.91,
					27.01,
					-77.83,
					27.15,
					-77.76,
					27.13,
					-77.65,
					26.57,
					-76.84,
					26.32,
					-76.87,
					25.76,
					-77.14,
					25.74,
					-77.24,
					25.96,
					-77.5
				]
			},
			{
				"points": [
					23.57,
					-77.71,
					23.7,
					-77.92,
					24.63,
					-78.62,
					25.43,
					-78.15,
					25.18,
					-77.88,
					24.7,
					-77.62,
					23.94,
					-77.37,
					23.65,
					-77.48,
					23.57,
					-77.71
				]
			},
			{
				"points": [
					24,
					-75.44,
					24.07,
					-75.61,
					24.48,
					-75.78,
					24.45,
					-75.94,
					24.55,
					-76.06,
					24.54,
					-76.19,
					25.24,
					-76.95,
					25.59,
					-76.94,
					25.65,
					-76.61,
					25.2,
					-76.03,
					24.66,
					-76.03,
					24.67,
					-75.86,
					24.78,
					-75.77,
					24.7,
					-75.53,
					24.15,
					-75.19,
					24.04,
					-75.23,
					24,
					-75.44
				]
			},
			{
				"points": [
					23.32,
					-75.73,
					23.38,
					-76.1,
					23.6,
					-76.16,
					24.41,
					-76.84,
					24.8,
					-76.93,
					24.93,
					-76.85,
					24.89,
					-76.71,
					24.53,
					-76.65,
					24.21,
					-76.32,
					23.94,
					-76.17,
					23.49,
					-75.42,
					23.76,
					-75.4,
					23.75,
					-75.24,
					23.06,
					-74.75,
					22.8,
					-74.73,
					22.78,
					-74.87,
					23.08,
					-75.29,
					23.31,
					-75.38,
					23.32,
					-75.73
				]
			},
			{
				"points": [
					61.49,
					-79.69,
					61.48,
					-79.9,
					61.7,
					-80.27,
					61.96,
					-80.38,
					62.21,
					-80.3,
					62.46,
					-79.99,
					62.52,
					-79.58,
					62.32,
					-79.21,
					62.22,
					-79.16,
					61.97,
					-79.21,
					61.49,
					-79.69
				]
			},
			{
				"points": [
					58.98,
					-80.51,
					58.91,
					-80.64,
					59,
					-80.74,
					59.68,
					-80.73,
					60.03,
					-80.04,
					60.05,
					-79.76,
					59.96,
					-79.71,
					59.82,
					-79.77,
					59.68,
					-79.89,
					59.57,
					-80.18,
					59.31,
					-80.18,
					59.14,
					-80.44,
					58.98,
					-80.51
				]
			},
			{
				"points": [
					21.52,
					-72.41,
					21.54,
					-72.55,
					21.74,
					-72.55,
					21.95,
					-72.38,
					21.93,
					-72.19,
					22.07,
					-72.06,
					21.76,
					-71.36,
					21.43,
					-71.4,
					21.35,
					-71.52,
					21.06,
					-71.64,
					21.08,
					-71.75,
					21.29,
					-71.82,
					21.46,
					-71.74,
					21.74,
					-72.04,
					21.63,
					-72.33,
					21.52,
					-72.41
				]
			},
			{
				"points": [
					62.99,
					-77.92,
					63.31,
					-78.58,
					63.5,
					-78.66,
					63.62,
					-78.47,
					63.51,
					-77.59,
					63.19,
					-77.4,
					62.99,
					-77.92
				]
			},
			{
				"points": [
					67.98,
					-79.1,
					68.04,
					-79.27,
					68.24,
					-79.31,
					68.55,
					-79.22,
					68.55,
					-79.05,
					68.76,
					-78.93,
					68.69,
					-78.36,
					68.57,
					-78.36,
					68.35,
					-78.74,
					68.3,
					-78.71,
					68.38,
					-78.63,
					68.33,
					-78.47,
					68.24,
					-78.41,
					68.15,
					-78.46,
					68.07,
					-78.78,
					68.13,
					-78.9,
					67.98,
					-79.1
				]
			}
		],
		"transitions": [
			[
				1320577200,
				-300,
				[
					"EST"
				]
			],
			[
				1331463600,
				-240,
				[
					"EDT"
				]
			],
			[
				1352026800,
				-300,
				[
					"EST"
				]
			],
			[
				1362913200,
				-240,
				[
					"EDT"
				]
			],
			[
				1383476400,
				-300,
				[
					"EST"
				]
			],
			[
				1394362800,
				-240,
				[
					"EDT"
				]
			],
			[
				1414926000,
				-300,
				[
					"EST"
				]
			],
			[
				1425812400,
				-240,
				[
					"EDT"
				]
			],
			[
				1446375600,
				-300,
				[
					"EST"
				]
			],
			[
				1457866800,
				-240,
				[
					"EDT"
				]
			],
			[
				1478430000,
				-300,
				[
					"EST"
				]
			],
			[
				1489316400,
				-240,
				[
					"EDT"
				]
			],
			[
				1509879600,
				-300,
				[
					"EST"
				]
			],
			[
				1520766000,
				-240,
				[
					"EDT"
				]
			],
			[
				1541329200,
				-300,
				[
					"EST"
				]
			],
			[
				1552215600,
				-240,
				[
					"EDT"
				]
			],
			[
				1572778800,
				-300,
				[
					"EST"
				]
			],
			[
				1583665200,
				-240,
				[
					"EDT"
				]
			],
			[
				1604228400,
				-300,
				[
					"EST"
				]
			],
			[
				1615719600,
				-240,
				[
					"EDT"
				]
			],
			[
				1636282800,
				-300,
				[
					"EST"
				]
			],
			[
				1647169200,
				-240,
				[
					"EDT"
				]
			],
			[
				1667732400,
				-300,
				[
					"EST"
				]
			],
			[
				1678618800,
				-240,
				[
					"EDT"
				]
			],
			[
				1699182000,
				-300,
				[
					"EST"
				]
			],
			[
				1710068400,
				-240,
				[
					"EDT"
				]
			],
			[
				1730631600,
				-300,
				[
					"EST"
				]
			],
			[
				1741518000,
				-240,
				[
					"EDT"
				]
			],
			[
				1762081200,
				-300,
				[
					"EST"
				]
			],
			[
				1772967600,
				-240,
				[
					"EDT"
				]
			],
			[
				1793530800,
				-300,
				[
					"EST"
				]
			],
			[
				1805022000,
				-240,
				[
					"EDT"
				]
			],
			[
				1825585200,
				-300,
				[
					"EST"
				]
			],
			[
				1836471600,
				-240,
				[
					"EDT"
				]
			],
			[
				1857034800,
				-300,
				[
					"EST"
				]
			],
			[
				1867921200,
				-240,
				[
					"EDT"
				]
			],
			[
				1888484400,
				-300,
				[
					"EST"
				]
			],
			[
				1899370800,
				-240,
				[
					"EDT"
				]
			],
			[
				1919934000,
				-300,
				[
					"EST"
				]
			],
			[
				1930820400,
				-240,
				[
					"EDT"
				]
			],
			[
				1951383600,
				-300,
				[
					"EST"
				]
			],
			[
				1962874800,
				-240,
				[
					"EDT"
				]
			],
			[
				1983438000,
				-300,
				[
					"EST"
				]
			],
			[
				1994324400,
				-240,
				[
					"EDT"
				]
			],
			[
				2014887600,
				-300,
				[
					"EST"
				]
			],
			[
				2025774000,
				-240,
				[
					"EDT"
				]
			],
			[
				2046337200,
				-300,
				[
					"EST"
				]
			],
			[
				2057223600,
				-240,
				[
					"EDT"
				]
			],
			[
				2077786800,
				-300,
				[
					"EST"
				]
			],
			[
				2088673200,
				-240,
				[
					"EDT"
				]
			],
			[
				2109236400,
				-300,
				[
					"EST"
				]
			],
			[
				2120122800,
				-240,
				[
					"EDT"
				]
			],
			[
				2140686000,
				-300,
				[
					"EST"
				]
			]
		],
		"name": "America/Nipigon"
	},
	{
		"hoverRegion": [
			{
				"points": [
					52.77,
					-109.49,
					53.02,
					-109.29,
					52.99,
					-108.95,
					53.18,
					-109.13,
					53.32,
					-109.6,
					53.48,
					-109.7,
					53.5,
					-110.05,
					53.59,
					-110.1,
					60.07,
					-110.07,
					60.07,
					-101.92,
					55.81,
					-101.89,
					55.08,
					-101.8,
					54.9,
					-102.19,
					54.7,
					-102.39,
					54.54,
					-102.39,
					54.34,
					-102.18,
					54.06,
					-101.65,
					48.92,
					-101.28,
					48.89,
					-110.04,
					48.98,
					-110.1,
					52.66,
					-110.1,
					52.76,
					-110.01,
					52.77,
					-109.49
				]
			},
			{
				"points": [
					16.28,
					-88.04,
					16.22,
					-88.2,
					16.4,
					-88.24,
					16.4,
					-88.31,
					16.17,
					-88.49,
					16.11,
					-88.68,
					15.97,
					-88.79,
					15.87,
					-88.67,
					16.01,
					-88.69,
					16.07,
					-88.58,
					15.8,
					-88.15,
					15.95,
					-88,
					16.02,
					-87.61,
					15.91,
					-87.45,
					15.86,
					-86.9,
					15.88,
					-86.38,
					15.97,
					-86.11,
					16.07,
					-86.13,
					16.13,
					-86.04,
					15.97,
					-85.45,
					16.09,
					-84.98,
					15.89,
					-84.23,
					15.52,
					-83.79,
					15.33,
					-83.31,
					15.03,
					-83.05,
					14.75,
					-83.19,
					14.3,
					-83.09,
					13.88,
					-83.34,
					13.44,
					-83.44,
					12.43,
					-83.38,
					12.17,
					-83.57,
					11.92,
					-83.62,
					11.59,
					-83.53,
					11.33,
					-83.75,
					11.11,
					-83.71,
					10.28,
					-83.2,
					9.74,
					-82.71,
					9.57,
					-82.45,
					9.4,
					-82.59,
					9.39,
					-82.82,
					9.13,
					-82.82,
					8.91,
					-82.6,
					8.74,
					-82.77,
					8.61,
					-82.71,
					8.4,
					-82.75,
					8.33,
					-82.85,
					8.04,
					-82.79,
					7.93,
					-82.84,
					7.95,
					-82.95,
					8.28,
					-83.22,
					8.33,
					-83.59,
					8.49,
					-83.8,
					8.63,
					-83.81,
					8.63,
					-83.97,
					8.82,
					-83.95,
					8.82,
					-83.83,
					8.71,
					-83.77,
					8.84,
					-83.71,
					8.99,
					-83.74,
					9.18,
					-83.96,
					9.54,
					-84.75,
					9.73,
					-84.75,
					9.65,
					-84.92,
					9.42,
					-85.12,
					9.7,
					-85.36,
					9.81,
					-85.74,
					10.34,
					-85.98,
					10.7,
					-85.78,
					10.75,
					-85.97,
					10.86,
					-86.05,
					10.97,
					-86.01,
					11.02,
					-85.86,
					11.69,
					-86.59,
					12.11,
					-86.85,
					12.37,
					-87.25,
					12.85,
					-87.76,
					13.05,
					-87.72,
					13.04,
					-88.5,
					13.37,
					-89.32,
					13.42,
					-89.87,
					13.66,
					-90.2,
					13.81,
					-90.64,
					13.83,
					-91.3,
					14.1,
					-91.85,
					14.48,
					-92.33,
					15.08,
					-92.2,
					15.27,
					-92.31,
					16.16,
					-91.79,
					16.18,
					-90.55,
					16.34,
					-90.53,
					16.41,
					-90.71,
					16.64,
					-90.8,
					16.8,
					-91.11,
					17.2,
					-91.54,
					17.33,
					-91.49,
					17.36,
					-91.09,
					17.82,
					-91.09,
					17.91,
					-91.03,
					17.92,
					-89.25,
					18.11,
					-89.04,
					18.03,
					-88.88,
					18.55,
					-88.57,
					18.59,
					-88.27,
					18.47,
					-88.2,
					18.46,
					-88.02,
					18.23,
					-87.97,
					18.27,
					-87.82,
					18.18,
					-87.75,
					17.84,
					-87.9,
					17.53,
					-87.93,
					17.7,
					-87.77,
					17.59,
					-87.66,
					17.1,
					-87.78,
					17.07,
					-87.93,
					16.98,
					-87.89,
					16.88,
					-88,
					16.71,
					-87.98,
					16.6,
					-88.21,
					16.43,
					-88.19,
					16.41,
					-88.07,
					16.28,
					-88.04
				]
			},
			{
				"points": [
					-0.73,
					-90.62,
					-1.11,
					-90.82,
					-1.1,
					-91.46,
					-0.96,
					-91.6,
					-0.56,
					-91.64,
					-0.31,
					-91.76,
					-0.19,
					-91.68,
					0.06,
					-91.68,
					0.26,
					-91.31,
					-0.2,
					-90.95,
					-0.03,
					-90.77,
					-0.2,
					-90.47,
					-0.39,
					-90.49,
					-0.3,
					-90.2,
					-0.69,
					-90.06,
					-0.8,
					-89.92,
					-0.94,
					-90.04,
					-0.9,
					-90.16,
					-0.79,
					-90.19,
					-0.87,
					-90.34,
					-0.73,
					-90.62
				]
			},
			{
				"points": [
					16.16,
					-86.6,
					16.19,
					-86.71,
					16.31,
					-86.72,
					16.53,
					-86.43,
					16.55,
					-86.1,
					16.49,
					-86.03,
					16.61,
					-85.82,
					16.53,
					-85.74,
					16.31,
					-85.86,
					16.36,
					-86.05,
					16.16,
					-86.6
				]
			}
		],
		"transitions": [
			[
				0,
				-360,
				[
					"CST",
					"GALT"
				]
			]
		],
		"name": "America/Belize"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-35.11,
					-54.8,
					-35.15,
					-54.89,
					-35,
					-55.08,
					-35.01,
					-55.28,
					-34.9,
					-55.43,
					-34.88,
					-55.67,
					-35.06,
					-55.89,
					-35.04,
					-56.19,
					-34.85,
					-56.53,
					-34.77,
					-56.91,
					-34.57,
					-57.16,
					-34.58,
					-57.89,
					-34.02,
					-58.48,
					-33.66,
					-58.55,
					-33.13,
					-58.46,
					-32.93,
					-58.22,
					-32.44,
					-58.3,
					-32.26,
					-58.21,
					-31.86,
					-58.31,
					-31.6,
					-58.1,
					-31.45,
					-58.19,
					-31.17,
					-58.02,
					-30.87,
					-58.01,
					-30.79,
					-57.92,
					-30.49,
					-57.98,
					-30.28,
					-57.74,
					-30.07,
					-57.68,
					-30.18,
					-57.37,
					-30.17,
					-57.26,
					-29.98,
					-57.09,
					-30,
					-56.76,
					-30.7,
					-55.94,
					-30.96,
					-55.9,
					-30.75,
					-55.53,
					-31.15,
					-55.18,
					-31.18,
					-54.96,
					-31.33,
					-54.79,
					-31.34,
					-54.55,
					-31.58,
					-54.38,
					-31.98,
					-53.68,
					-32.35,
					-53.5,
					-32.67,
					-52.98,
					-32.8,
					-52.99,
					-33.2,
					-53.4,
					-33.61,
					-53.41,
					-33.76,
					-53.26,
					-34.46,
					-53.68,
					-34.76,
					-54.07,
					-35.02,
					-54.77,
					-35.11,
					-54.8
				]
			}
		],
		"transitions": [
			[
				1317546000,
				-120,
				[
					"UYST"
				]
			],
			[
				1331452800,
				-180,
				[
					"UYT"
				]
			],
			[
				1349600400,
				-120,
				[
					"UYST"
				]
			],
			[
				1362902400,
				-180,
				[
					"UYT"
				]
			],
			[
				1381050000,
				-120,
				[
					"UYST"
				]
			],
			[
				1394352000,
				-180,
				[
					"UYT"
				]
			],
			[
				1412499600,
				-120,
				[
					"UYST"
				]
			],
			[
				1425801600,
				-180,
				[
					"UYT"
				]
			],
			[
				1443949200,
				-120,
				[
					"UYST"
				]
			],
			[
				1457856000,
				-180,
				[
					"UYT"
				]
			],
			[
				1475398800,
				-120,
				[
					"UYST"
				]
			],
			[
				1489305600,
				-180,
				[
					"UYT"
				]
			],
			[
				1506848400,
				-120,
				[
					"UYST"
				]
			],
			[
				1520755200,
				-180,
				[
					"UYT"
				]
			],
			[
				1538902800,
				-120,
				[
					"UYST"
				]
			],
			[
				1552204800,
				-180,
				[
					"UYT"
				]
			],
			[
				1570352400,
				-120,
				[
					"UYST"
				]
			],
			[
				1583654400,
				-180,
				[
					"UYT"
				]
			],
			[
				1601802000,
				-120,
				[
					"UYST"
				]
			],
			[
				1615708800,
				-180,
				[
					"UYT"
				]
			],
			[
				1633251600,
				-120,
				[
					"UYST"
				]
			],
			[
				1647158400,
				-180,
				[
					"UYT"
				]
			],
			[
				1664701200,
				-120,
				[
					"UYST"
				]
			],
			[
				1678608000,
				-180,
				[
					"UYT"
				]
			],
			[
				1696150800,
				-120,
				[
					"UYST"
				]
			],
			[
				1710057600,
				-180,
				[
					"UYT"
				]
			],
			[
				1728205200,
				-120,
				[
					"UYST"
				]
			],
			[
				1741507200,
				-180,
				[
					"UYT"
				]
			],
			[
				1759654800,
				-120,
				[
					"UYST"
				]
			],
			[
				1772956800,
				-180,
				[
					"UYT"
				]
			],
			[
				1791104400,
				-120,
				[
					"UYST"
				]
			],
			[
				1805011200,
				-180,
				[
					"UYT"
				]
			],
			[
				1822554000,
				-120,
				[
					"UYST"
				]
			],
			[
				1836460800,
				-180,
				[
					"UYT"
				]
			],
			[
				1854003600,
				-120,
				[
					"UYST"
				]
			],
			[
				1867910400,
				-180,
				[
					"UYT"
				]
			],
			[
				1886058000,
				-120,
				[
					"UYST"
				]
			],
			[
				1899360000,
				-180,
				[
					"UYT"
				]
			],
			[
				1917507600,
				-120,
				[
					"UYST"
				]
			],
			[
				1930809600,
				-180,
				[
					"UYT"
				]
			],
			[
				1948957200,
				-120,
				[
					"UYST"
				]
			],
			[
				1962864000,
				-180,
				[
					"UYT"
				]
			],
			[
				1980406800,
				-120,
				[
					"UYST"
				]
			],
			[
				1994313600,
				-180,
				[
					"UYT"
				]
			],
			[
				2011856400,
				-120,
				[
					"UYST"
				]
			],
			[
				2025763200,
				-180,
				[
					"UYT"
				]
			],
			[
				2043306000,
				-120,
				[
					"UYST"
				]
			],
			[
				2057212800,
				-180,
				[
					"UYT"
				]
			],
			[
				2075360400,
				-120,
				[
					"UYST"
				]
			],
			[
				2088662400,
				-180,
				[
					"UYT"
				]
			],
			[
				2106810000,
				-120,
				[
					"UYST"
				]
			],
			[
				2120112000,
				-180,
				[
					"UYT"
				]
			],
			[
				2138259600,
				-120,
				[
					"UYST"
				]
			]
		],
		"name": "America/Montevideo"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-14.05,
					-171.31,
					-14.17,
					-171.42,
					-14.09,
					-171.96,
					-13.89,
					-172.2,
					-13.9,
					-172.56,
					-13.58,
					-172.88,
					-13.44,
					-172.86,
					-13.37,
					-172.77,
					-13.33,
					-172.28,
					-13.6,
					-172.07,
					-13.71,
					-172.07,
					-13.68,
					-171.78,
					-13.87,
					-171.38,
					-14.05,
					-171.31
				]
			}
		],
		"transitions": [
			[
				1316887200,
				-600,
				[
					"WSDT"
				]
			],
			[
				1325257200,
				840,
				[
					"WSDT"
				]
			],
			[
				1333216800,
				780,
				[
					"WST"
				]
			]
		],
		"name": "Pacific/Apia"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-36.18,
					137.48,
					-36.16,
					136.65,
					-35.9,
					136.42,
					-35.64,
					136.56,
					-35.45,
					137.59,
					-35.6,
					137.99,
					-35.28,
					138.33,
					-34.74,
					138.37,
					-34.36,
					138.08,
					-35.21,
					137.8,
					-35.27,
					137.63,
					-35.21,
					137.41,
					-35.41,
					136.88,
					-35.29,
					136.72,
					-34.81,
					136.94,
					-34.8,
					137.35,
					-34.63,
					137.38,
					-34.62,
					137.29,
					-34.47,
					137.22,
					-34.3,
					137.37,
					-34.12,
					137.33,
					-33.83,
					137.49,
					-33.55,
					137.81,
					-33.19,
					137.72,
					-33.1,
					137.79,
					-33.07,
					137.67,
					-33.21,
					137.53,
					-33.74,
					137.28,
					-33.99,
					136.65,
					-34.41,
					136.21,
					-34.45,
					136.39,
					-34.65,
					136.46,
					-34.75,
					136.42,
					-34.78,
					136.3,
					-34.6,
					136.18,
					-34.63,
					136.05,
					-34.83,
					136.11,
					-34.99,
					136.29,
					-35.14,
					136.27,
					-35.16,
					136.16,
					-35.37,
					136.21,
					-35.43,
					136.09,
					-35.26,
					135.94,
					-35.14,
					135.98,
					-34.99,
					135.76,
					-35.1,
					135.67,
					-35.09,
					135.54,
					-34.67,
					135.21,
					-34.65,
					135.02,
					-34.54,
					135.01,
					-34.32,
					135.19,
					-34.03,
					135.14,
					-33.68,
					134.7,
					-33.48,
					134.73,
					-33.36,
					134.66,
					-33.27,
					134.44,
					-33.3,
					134.28,
					-33.1,
					134.06,
					-32.95,
					133.95,
					-32.73,
					133.95,
					-32.63,
					134,
					-32.62,
					134.14,
					-32.58,
					134.09,
					-32.65,
					133.83,
					-32.53,
					133.74,
					-32.57,
					133.6,
					-32.48,
					133.44,
					-32.67,
					133.35,
					-32.68,
					133.23,
					-32.5,
					133.15,
					-32.37,
					133.25,
					-32.06,
					132.71,
					-32.12,
					132.27,
					-32.22,
					132.14,
					-32.06,
					132.05,
					-31.8,
					131.68,
					-31.58,
					131.14,
					-31.72,
					130.79,
					-31.68,
					130.16,
					-31.77,
					128.91,
					-25.92,
					128.91,
					-25.92,
					141.08,
					-31.38,
					141.09,
					-31.49,
					141.98,
					-31.59,
					142.06,
					-32,
					142.05,
					-32.37,
					141.89,
					-32.33,
					141.09,
					-38.1,
					141.07,
					-38.17,
					140.65,
					-37.98,
					140.3,
					-37.61,
					140.03,
					-37.35,
					139.72,
					-36.99,
					139.56,
					-36.91,
					139.56,
					-36.78,
					139.73,
					-36.65,
					139.73,
					-36.24,
					139.53,
					-35.96,
					139.28,
					-35.64,
					138.75,
					-35.75,
					138.51,
					-35.73,
					138.17,
					-35.86,
					138.23,
					-35.99,
					138.09,
					-36.18,
					137.48
				]
			},
			{
				"points": [
					-33.87,
					134.49,
					-33.85,
					134.38,
					-33.68,
					134.36,
					-33.57,
					134.54,
					-33.74,
					134.65,
					-33.87,
					134.49
				]
			},
			{
				"points": [
					-35.24,
					136.57,
					-35.28,
					136.47,
					-35.22,
					136.35,
					-35.02,
					136.41,
					-35.05,
					136.55,
					-35.24,
					136.57
				]
			},
			{
				"points": [
					-34.07,
					134.33,
					-34.06,
					134.14,
					-33.83,
					134.22,
					-33.92,
					134.38,
					-34.07,
					134.33
				]
			}
		],
		"transitions": [
			[
				1317501000,
				630,
				[
					"CST"
				]
			],
			[
				1333225800,
				570,
				[
					"CST"
				]
			],
			[
				1349555400,
				630,
				[
					"CST"
				]
			],
			[
				1365280200,
				570,
				[
					"CST"
				]
			],
			[
				1381005000,
				630,
				[
					"CST"
				]
			],
			[
				1396729800,
				570,
				[
					"CST"
				]
			],
			[
				1412454600,
				630,
				[
					"CST"
				]
			],
			[
				1428179400,
				570,
				[
					"CST"
				]
			],
			[
				1443904200,
				630,
				[
					"CST"
				]
			],
			[
				1459629000,
				570,
				[
					"CST"
				]
			],
			[
				1475353800,
				630,
				[
					"CST"
				]
			],
			[
				1491078600,
				570,
				[
					"CST"
				]
			],
			[
				1506803400,
				630,
				[
					"CST"
				]
			],
			[
				1522528200,
				570,
				[
					"CST"
				]
			],
			[
				1538857800,
				630,
				[
					"CST"
				]
			],
			[
				1554582600,
				570,
				[
					"CST"
				]
			],
			[
				1570307400,
				630,
				[
					"CST"
				]
			],
			[
				1586032200,
				570,
				[
					"CST"
				]
			],
			[
				1601757000,
				630,
				[
					"CST"
				]
			],
			[
				1617481800,
				570,
				[
					"CST"
				]
			],
			[
				1633206600,
				630,
				[
					"CST"
				]
			],
			[
				1648931400,
				570,
				[
					"CST"
				]
			],
			[
				1664656200,
				630,
				[
					"CST"
				]
			],
			[
				1680381000,
				570,
				[
					"CST"
				]
			],
			[
				1696105800,
				630,
				[
					"CST"
				]
			],
			[
				1712435400,
				570,
				[
					"CST"
				]
			],
			[
				1728160200,
				630,
				[
					"CST"
				]
			],
			[
				1743885000,
				570,
				[
					"CST"
				]
			],
			[
				1759609800,
				630,
				[
					"CST"
				]
			],
			[
				1775334600,
				570,
				[
					"CST"
				]
			],
			[
				1791059400,
				630,
				[
					"CST"
				]
			],
			[
				1806784200,
				570,
				[
					"CST"
				]
			],
			[
				1822509000,
				630,
				[
					"CST"
				]
			],
			[
				1838233800,
				570,
				[
					"CST"
				]
			],
			[
				1853958600,
				630,
				[
					"CST"
				]
			],
			[
				1869683400,
				570,
				[
					"CST"
				]
			],
			[
				1886013000,
				630,
				[
					"CST"
				]
			],
			[
				1901737800,
				570,
				[
					"CST"
				]
			],
			[
				1917462600,
				630,
				[
					"CST"
				]
			],
			[
				1933187400,
				570,
				[
					"CST"
				]
			],
			[
				1948912200,
				630,
				[
					"CST"
				]
			],
			[
				1964637000,
				570,
				[
					"CST"
				]
			],
			[
				1980361800,
				630,
				[
					"CST"
				]
			],
			[
				1996086600,
				570,
				[
					"CST"
				]
			],
			[
				2011811400,
				630,
				[
					"CST"
				]
			],
			[
				2027536200,
				570,
				[
					"CST"
				]
			],
			[
				2043261000,
				630,
				[
					"CST"
				]
			],
			[
				2058985800,
				570,
				[
					"CST"
				]
			],
			[
				2075315400,
				630,
				[
					"CST"
				]
			],
			[
				2091040200,
				570,
				[
					"CST"
				]
			],
			[
				2106765000,
				630,
				[
					"CST"
				]
			],
			[
				2122489800,
				570,
				[
					"CST"
				]
			],
			[
				2138214600,
				630,
				[
					"CST"
				]
			]
		],
		"name": "Australia/Broken_Hill"
	},
	{
		"hoverRegion": [
			{
				"points": [
					41.74,
					46.45,
					41.64,
					46.38,
					41.58,
					46.42,
					41.27,
					46.83,
					41.02,
					46.7,
					40.94,
					46.49,
					41.06,
					46.21,
					41.12,
					45.77,
					41.28,
					45.56,
					41.35,
					45.32,
					41.1,
					44.9,
					41.12,
					44.19,
					41,
					43.73,
					41.08,
					43.16,
					41.47,
					42.7,
					41.33,
					42.54,
					41.4,
					42.16,
					41.41,
					41.98,
					41.32,
					41.84,
					41.38,
					41.61,
					41.52,
					41.43,
					41.81,
					41.64,
					41.98,
					41.64,
					42.61,
					41.38,
					42.71,
					41.08,
					42.9,
					40.97,
					42.96,
					40.83,
					43.07,
					40.23,
					43.22,
					40.16,
					43.29,
					39.92,
					44.17,
					38.73,
					44.3,
					38.18,
					44.58,
					37.82,
					44.53,
					37.7,
					44.59,
					37.42,
					44.9,
					37.15,
					45.04,
					36.57,
					45.22,
					36.42,
					45.35,
					36.43,
					45.54,
					36.75,
					45.43,
					37.27,
					45.47,
					37.44,
					45.73,
					37.52,
					45.83,
					37.74,
					46.09,
					37.87,
					46.16,
					38.1,
					46.23,
					38.14,
					46.28,
					38.06,
					46.34,
					37.81,
					46.68,
					37.59,
					46.79,
					37.64,
					46.74,
					37.97,
					46.98,
					38.47,
					47.1,
					39.15,
					47.01,
					38.18,
					47.31,
					38.11,
					47.57,
					38.19,
					47.7,
					38.32,
					47.78,
					38.69,
					47.98,
					38.84,
					47.94,
					39.67,
					48.21,
					39.82,
					48.31,
					39.74,
					48.48,
					39.77,
					48.6,
					39.55,
					48.87,
					39.69,
					49.08,
					39.56,
					49.28,
					40.06,
					49.45,
					39.96,
					49.53,
					39.6,
					49.63,
					39.52,
					49.66,
					39.23,
					49.75,
					39.14,
					49.7,
					38.92,
					49.89,
					38.66,
					49.94,
					38.3,
					49.79,
					38.02,
					50.08,
					37.58,
					50.3,
					37.4,
					50.12,
					36.63,
					50.21,
					36.43,
					50.18,
					36.28,
					50.33,
					36.09,
					50.27,
					35.58,
					50.55,
					35.3,
					50.75,
					35.36,
					51.1,
					35.06,
					51.06,
					34.73,
					51.18,
					34.19,
					51.48,
					34.14,
					51.65,
					33.98,
					51.74,
					34.02,
					51.8,
					34.19,
					52.24,
					33.8,
					52.19,
					33.52,
					52.25,
					33.2,
					52.13,
					32.88,
					52.2,
					32.48,
					52.04,
					32.41,
					51.91,
					31.99,
					52,
					31.74,
					52.29,
					31.5,
					52.72,
					31.47,
					52.96,
					31.18,
					53.07,
					31.15,
					53.31,
					31.4,
					53.2,
					32.19,
					53.41,
					32.55,
					53.46,
					32.41,
					53.63,
					32.31,
					53.7,
					31.71,
					53.79,
					31.66,
					53.98,
					31.74,
					54.17,
					31.24,
					54.37,
					31.15,
					54.44,
					30.99,
					54.56,
					31,
					54.73,
					30.67,
					54.99,
					30.74,
					55.08,
					30.86,
					55.29,
					30.72,
					55.48,
					30.83,
					55.75,
					30.23,
					55.76,
					30.02,
					55.59,
					29.47,
					55.7,
					29.27,
					55.88,
					29.31,
					55.94,
					29.09,
					55.85,
					28.71,
					55.99,
					28.6,
					55.96,
					28.27,
					56.1,
					28.05,
					56.29,
					28.11,
					56.5,
					28.04,
					56.72,
					27.8,
					56.77,
					27.57,
					57.24,
					27.69,
					57.46,
					27.26,
					57.56,
					27.21,
					57.76,
					27.32,
					57.93,
					27.54,
					58.19,
					27.38,
					58.49,
					27.34,
					58.89,
					27.44,
					59.32,
					27.82,
					59.38,
					27.97,
					59.83,
					27.96,
					59.89,
					28.19,
					59.78,
					28.34,
					59.9,
					28.4,
					59.99,
					28.26,
					60.13,
					28.31,
					60.1,
					28.48,
					59.94,
					28.47,
					59.89,
					28.83,
					60.07,
					29.05,
					60.21,
					28.8,
					60.15,
					28.71,
					60.2,
					28.45,
					60.3,
					28.32,
					60.45,
					28.35,
					60.33,
					27.78,
					60.39,
					27.63,
					60.52,
					27.63,
					61.04,
					28.47,
					61.06,
					28.61,
					61.22,
					28.79,
					61.37,
					29.19,
					62.29,
					30.59,
					62.41,
					30.89,
					62.88,
					31.41,
					63.13,
					31.15,
					63.36,
					30.45,
					63.72,
					29.87,
					63.82,
					29.9,
					63.91,
					30.18,
					64.13,
					30.41,
					64.32,
					29.98,
					64.67,
					29.94,
					64.71,
					29.65,
					64.97,
					29.48,
					65.15,
					29.56,
					65.27,
					29.5,
					65.39,
					29.64,
					65.69,
					29.64,
					65.79,
					29.99,
					66.05,
					29.83,
					66.9,
					28.92,
					67.61,
					29.88,
					67.7,
					29.62,
					67.97,
					29.28,
					68.1,
					28.59,
					68.54,
					28.34,
					68.79,
					28.56,
					68.83,
					28.37,
					68.96,
					28.34,
					69.17,
					29.13,
					69.41,
					29.29,
					69.56,
					30.05,
					69.69,
					30.01,
					69.77,
					30.08,
					69.65,
					30.79,
					69.79,
					30.74,
					69.89,
					30.81,
					69.81,
					31.45,
					69.93,
					31.49,
					69.88,
					31.68,
					70.06,
					31.95,
					69.82,
					33.16,
					69.71,
					33.21,
					69.54,
					33.12,
					69.5,
					33.51,
					69.39,
					33.6,
					69.4,
					33.89,
					69.48,
					34.07,
					69.27,
					35.05,
					69.35,
					35.24,
					69.29,
					35.84,
					68.92,
					37.38,
					68.44,
					38.45,
					68.47,
					38.68,
					68.14,
					39.58,
					68.25,
					39.8,
					68.08,
					40.03,
					67.77,
					41.05,
					67.34,
					41.21,
					67.29,
					41.39,
					67.05,
					41.49,
					66.72,
					41.25,
					66.38,
					40.74,
					66.14,
					40.01,
					65.94,
					38.69,
					65.96,
					37.91,
					66.16,
					36.86,
					66.27,
					35.51,
					66.48,
					34.82,
					66.42,
					34.46,
					66.56,
					34.24,
					66.65,
					33.73,
					66.6,
					33.59,
					66.51,
					33.83,
					66.29,
					34.06,
					66.17,
					34.57,
					65.83,
					35.09,
					65.73,
					35.11,
					65.55,
					34.97,
					65.31,
					34.63,
					65.27,
					34.79,
					65.04,
					34.92,
					65.09,
					35.03,
					65.01,
					35.25,
					64.52,
					35.12,
					64.43,
					36.5,
					64.26,
					36.81,
					64.02,
					36.89,
					63.9,
					37.44,
					64,
					37.76,
					64.1,
					37.83,
					64.25,
					37.8,
					64.28,
					37.14,
					64.66,
					36.43,
					64.96,
					36.33,
					65.05,
					36.69,
					65.28,
					36.71,
					65.13,
					37.71,
					64.95,
					38.08,
					64.65,
					39.56,
					64.67,
					39.7,
					64.86,
					39.93,
					64.87,
					40.11,
					65.27,
					39.63,
					65.64,
					39.69,
					65.9,
					40.42,
					66.09,
					40.71,
					66.21,
					41.46,
					66.62,
					42.2,
					66.5,
					42.65,
					66.5,
					43.31,
					66.25,
					43.95,
					66.65,
					44.33,
					66.77,
					44.24,
					66.88,
					44.34,
					67.03,
					44.11,
					67.1,
					43.7,
					67.19,
					43.65,
					67.52,
					43.79,
					67.76,
					44.02,
					68.2,
					44.11,
					68.59,
					43.21,
					68.68,
					43.15,
					68.77,
					43.23,
					68.64,
					44.11,
					68.61,
					45.49,
					68.42,
					46.42,
					68.26,
					46.47,
					67.95,
					46.78,
					67.71,
					46.72,
					67.61,
					45.46,
					67.48,
					45.36,
					67.41,
					45.12,
					67.26,
					45.62,
					66.98,
					45.87,
					66.93,
					46.04,
					67,
					47.53,
					67.07,
					47.63,
					67.23,
					47.57,
					67.46,
					47.79,
					67.66,
					47.77,
					67.75,
					48.64,
					67.89,
					48.49,
					68.02,
					48.56,
					67.96,
					49.14,
					68.59,
					51.08,
					68.57,
					51.54,
					68.67,
					52.22,
					69.06,
					53.85,
					69.01,
					55.11,
					68.89,
					55.12,
					68.8,
					55.04,
					68.85,
					54.5,
					68.7,
					54.46,
					68.69,
					54.22,
					68.78,
					54.1,
					68.62,
					53.92,
					68.35,
					54.1,
					68.44,
					54.35,
					68.29,
					54.76,
					68.41,
					54.81,
					68.65,
					55.35,
					68.75,
					56.07,
					68.66,
					57.03,
					68.81,
					57.17,
					69.08,
					59.08,
					69.35,
					58.44,
					69.49,
					58.36,
					69.58,
					58.44,
					69.35,
					59.26,
					69.17,
					59.39,
					69.1,
					59.57,
					68.68,
					59.61,
					68.5,
					59.26,
					68.47,
					59.75,
					68.63,
					59.68,
					68.79,
					59.87,
					68.79,
					60.4,
					68.98,
					60.83,
					69.02,
					60.59,
					69.18,
					60.53,
					69.55,
					60.07,
					69.6,
					59.55,
					69.98,
					58.52,
					70.2,
					58.3,
					70.41,
					58.28,
					70.44,
					58.56,
					70.57,
					58.64,
					70.51,
					58.8,
					70.57,
					59.1,
					70.03,
					60.48,
					69.87,
					60.63,
					69.96,
					60.86,
					69.8,
					63.01,
					69.58,
					64.4,
					69.33,
					65.02,
					69.19,
					65.03,
					68.96,
					64.69,
					68.9,
					65.36,
					68.74,
					65.48,
					68.63,
					65.73,
					68.51,
					65.75,
					68.18,
					65.38,
					68.07,
					65.39,
					68.01,
					66.16,
					67.84,
					66.15,
					67.71,
					66.31,
					67.58,
					66.17,
					67.42,
					66.2,
					67.07,
					65.31,
					66.79,
					65.15,
					66.36,
					63.44,
					66.3,
					63.36,
					66.15,
					63.36,
					66.13,
					63.12,
					66.01,
					62.96,
					65.77,
					62.9,
					65.59,
					61.9,
					65.3,
					61.43,
					65.08,
					61.29,
					64.93,
					60.85,
					64.78,
					60.67,
					64.94,
					60.38,
					64.95,
					60.18,
					64.73,
					59.78,
					64.3,
					59.7,
					64.21,
					59.93,
					64.11,
					59.96,
					63.91,
					59.84,
					63.84,
					59.65,
					63.18,
					59.39,
					63.04,
					59.37,
					62.94,
					59.58,
					62.73,
					59.51,
					62.53,
					59.75,
					62.13,
					59.53,
					61.95,
					59.58,
					61.59,
					59.41,
					61.39,
					58.8,
					61.41,
					56.71,
					61.32,
					56.45,
					61.09,
					56.32,
					61.13,
					55.88,
					60.97,
					55.75,
					61.01,
					55.33,
					60.75,
					55.01,
					60.86,
					53.93,
					60.74,
					53.84,
					60.75,
					53.55,
					60.8,
					53.27,
					60.94,
					53.24,
					60.97,
					52.94,
					60.83,
					52.82,
					60.86,
					52.48,
					60.72,
					52.37,
					60.76,
					51.96,
					60.67,
					51.92,
					60.53,
					52.4,
					60.36,
					52.43,
					60.27,
					52.85,
					60.32,
					53.5,
					60.04,
					53.81,
					59.62,
					53.68,
					59.58,
					53.48,
					59.35,
					53.34,
					59.25,
					53.45,
					59.14,
					53.97,
					58.95,
					53.87,
					58.76,
					54.03,
					58.57,
					53.83,
					58.35,
					53.99,
					58.24,
					53.96,
					58.02,
					54.2,
					57.63,
					54.24,
					57.5,
					54.36,
					57.15,
					54.39,
					57.06,
					54.5,
					56.95,
					54.47,
					56.87,
					54.2,
					56.73,
					54.18,
					56.61,
					54.19,
					56.52,
					54.41,
					56.22,
					54.46,
					55.91,
					54.03,
					55.68,
					54.35,
					55.11,
					53.65,
					55.07,
					53.42,
					54.91,
					53.75,
					54.65,
					53.7,
					54.38,
					53.46,
					53.96,
					53.54,
					53.86,
					53.34,
					53.96,
					53.22,
					53.97,
					53.01,
					54.21,
					52.8,
					54.2,
					52.45,
					54.03,
					52.59,
					53.49,
					52.23,
					53.38,
					52.3,
					53.05,
					52.26,
					52.82,
					51.88,
					52.58,
					51.81,
					52.56,
					51.65,
					52.4,
					51.66,
					52.28,
					51.51,
					52.01,
					51.49,
					51.69,
					50.87,
					51.52,
					50.86,
					51.47,
					50.62,
					51.23,
					50.4,
					51.01,
					49.77,
					51.01,
					49.47,
					50.77,
					49.48,
					50.49,
					48.78,
					50.17,
					48.85,
					50.04,
					48.98,
					49.94,
					48.94,
					49.7,
					48.39,
					49.77,
					48.16,
					50.02,
					48,
					50.33,
					47.54,
					50.24,
					47.39,
					50.08,
					47.44,
					49.89,
					47.3,
					49.76,
					46.98,
					49.38,
					46.9,
					49.14,
					47.16,
					48.94,
					47.04,
					48.85,
					46.85,
					48.5,
					46.65,
					48.32,
					47.2,
					48.18,
					47.21,
					48.07,
					47.31,
					47.95,
					47.18,
					47.83,
					47.26,
					47.92,
					47.41,
					47.87,
					48.06,
					47.53,
					48.43,
					47.48,
					48.68,
					47.14,
					48.82,
					46.8,
					49.1,
					46.69,
					49.08,
					46.58,
					48.87,
					46.35,
					49.3,
					46.15,
					49.35,
					45.78,
					49.18,
					45.88,
					48.98,
					45.83,
					48.82,
					45.51,
					48.76,
					45.55,
					48.51,
					45.49,
					48.38,
					45.61,
					48.24,
					45.55,
					48.08,
					45.34,
					48.04,
					45.41,
					47.68,
					45.29,
					47.54,
					45.08,
					47.55,
					45.04,
					47.37,
					44.85,
					47.43,
					44.74,
					47.37,
					44.59,
					47.04,
					44.6,
					46.86,
					44.53,
					47.08,
					44.38,
					47.08,
					44.31,
					47.28,
					43.98,
					47.53,
					44.09,
					47.62,
					44.02,
					47.97,
					43.51,
					47.62,
					43.32,
					47.67,
					43.05,
					47.59,
					42.93,
					47.77,
					42.72,
					47.82,
					42.38,
					48.19,
					42.03,
					48.43,
					41.92,
					48.63,
					41.54,
					48.48,
					41.39,
					48.11,
					41.13,
					47.95,
					41.08,
					47.72,
					41.23,
					47.2,
					41.45,
					47.06,
					41.46,
					46.95,
					41.73,
					46.71,
					41.74,
					46.45
				]
			},
			{
				"points": [
					24.41,
					53.21,
					24.58,
					53.34,
					24.4,
					53.54,
					24.44,
					53.84,
					24.3,
					53.97,
					24.78,
					54.58,
					24.91,
					54.64,
					25.08,
					54.97,
					25.65,
					55.46,
					25.82,
					55.8,
					26.46,
					56.27,
					26.48,
					56.56,
					26.37,
					56.63,
					25.92,
					56.55,
					25.67,
					56.4,
					25,
					56.48,
					24.55,
					56.7,
					24.03,
					57.23,
					23.71,
					58.31,
					23.73,
					58.58,
					23.61,
					58.81,
					22.83,
					59.37,
					22.67,
					59.57,
					22.6,
					59.87,
					22.22,
					59.91,
					21.38,
					59.44,
					20.98,
					58.93,
					20.71,
					58.79,
					20.79,
					58.89,
					20.76,
					58.99,
					20.46,
					59.06,
					20.08,
					58.71,
					20.07,
					58.57,
					20.27,
					58.52,
					20.26,
					58.23,
					20.38,
					58.08,
					20.15,
					57.92,
					19.7,
					57.78,
					18.98,
					57.91,
					18.87,
					57.86,
					18.68,
					56.89,
					18.53,
					56.74,
					18.04,
					56.62,
					17.82,
					56.39,
					17.71,
					55.49,
					17.52,
					55.35,
					17.4,
					55.41,
					17.2,
					55.36,
					16.9,
					55.05,
					16.83,
					54.79,
					16.91,
					54.6,
					16.88,
					54.1,
					16.65,
					53.63,
					16.54,
					53.11,
					16.6,
					53,
					17.23,
					52.65,
					19.04,
					51.89,
					20.08,
					54.91,
					21.98,
					55.54,
					22.53,
					55.18,
					22.84,
					52.53,
					24.04,
					51.49,
					24.38,
					51.4,
					24.48,
					51.45,
					24.5,
					51.62,
					24.68,
					51.66,
					24.7,
					51.77,
					24.61,
					51.85,
					24.45,
					51.84,
					24.37,
					51.69,
					24.35,
					51.84,
					24.24,
					51.89,
					24.35,
					52.06,
					24.22,
					52.14,
					24.08,
					52.07,
					24.07,
					52.19,
					24.23,
					52.48,
					24.33,
					52.46,
					24.46,
					52.59,
					24.38,
					52.74,
					24.23,
					52.78,
					24.25,
					52.98,
					24.46,
					53.04,
					24.41,
					53.21
				]
			},
			{
				"points": [
					70.4,
					57.39,
					70.37,
					57.01,
					70.46,
					56.81,
					70.37,
					56.44,
					70.5,
					56.14,
					70.45,
					55.64,
					70.55,
					55.55,
					70.43,
					55.14,
					70.63,
					54.3,
					70.67,
					53.53,
					70.85,
					53.23,
					70.84,
					52.99,
					71.12,
					52.59,
					71.11,
					52.34,
					71.21,
					52.15,
					71.35,
					52.16,
					71.35,
					51.86,
					71.47,
					51.53,
					71.85,
					51.32,
					72.16,
					51.54,
					72.25,
					51.83,
					72.22,
					52.34,
					72.35,
					52.37,
					72.52,
					52.6,
					72.68,
					52.29,
					72.94,
					52.52,
					72.97,
					52.95,
					73.14,
					53,
					73.31,
					53.32,
					73.35,
					53.89,
					73.46,
					53.87,
					73.51,
					53.96,
					73.68,
					53.54,
					73.87,
					53.61,
					73.87,
					53.89,
					74.04,
					54.48,
					74.34,
					55.17,
					74.49,
					55.27,
					74.52,
					55.42,
					74.72,
					55.52,
					74.76,
					55.77,
					74.87,
					55.84,
					75.09,
					55.68,
					75.28,
					55.92,
					75.27,
					56.35,
					75.17,
					56.48,
					75.23,
					56.65,
					75.37,
					56.66,
					75.46,
					56.95,
					75.44,
					57.46,
					75.56,
					57.5,
					75.63,
					57.83,
					75.76,
					58.01,
					75.91,
					58.54,
					75.89,
					58.72,
					75.97,
					58.73,
					76.03,
					58.89,
					76.18,
					59.01,
					76.16,
					59.16,
					76.06,
					59.19,
					76.15,
					59.49,
					76.13,
					59.79,
					76.26,
					60.11,
					76.2,
					60.85,
					76.39,
					61.05,
					76.36,
					62.4,
					76.27,
					62.51,
					76.37,
					62.75,
					76.3,
					63.02,
					76.43,
					63.67,
					76.4,
					64.06,
					76.67,
					65.45,
					76.65,
					65.69,
					76.75,
					65.76,
					77.04,
					67,
					77.1,
					67.66,
					77.06,
					68.51,
					76.97,
					68.86,
					76.75,
					69.16,
					76.45,
					68.97,
					76.25,
					68.42,
					76.13,
					68.28,
					75.51,
					63.76,
					75.59,
					63.62,
					75.47,
					63.31,
					75.33,
					62.03,
					75.1,
					61.44,
					75.17,
					61.32,
					75.03,
					60.89,
					74.82,
					60.72,
					74.73,
					60.42,
					74.63,
					60.34,
					74.62,
					59.98,
					74.46,
					59.78,
					74.5,
					59.56,
					74.31,
					59.4,
					74.32,
					59.19,
					74.22,
					59.11,
					74.26,
					58.88,
					74,
					58.56,
					73.87,
					58.07,
					73.68,
					57.96,
					73.61,
					57.72,
					73.51,
					57.65,
					73.12,
					56.67,
					72.68,
					56.14,
					72.66,
					56.01,
					72.56,
					55.97,
					72.55,
					55.75,
					72.29,
					55.55,
					72.12,
					55.67,
					71.97,
					55.51,
					71.64,
					55.79,
					71.28,
					56.25,
					70.8,
					57.64,
					70.69,
					57.67,
					70.45,
					57.53,
					70.4,
					57.39
				]
			},
			{
				"points": [
					79.98,
					52.86,
					80.15,
					52.17,
					80.24,
					52.11,
					80.38,
					52.15,
					80.44,
					52.24,
					80.47,
					53.08,
					80.56,
					52.96,
					80.68,
					52.97,
					80.73,
					53.38,
					80.57,
					53.65,
					80.42,
					53.6,
					80.37,
					53.78,
					80.55,
					53.71,
					80.65,
					53.77,
					80.68,
					54.27,
					80.8,
					53.92,
					80.91,
					53.98,
					80.94,
					54.36,
					81.02,
					54.14,
					81.17,
					54.14,
					81.14,
					54.5,
					81.26,
					54.12,
					81.44,
					54.16,
					81.35,
					54.64,
					81.21,
					54.69,
					81.11,
					55.53,
					81.2,
					55.37,
					81.3,
					55.35,
					81.45,
					55.67,
					81.51,
					56.65,
					81.63,
					56.74,
					81.65,
					57.88,
					81.8,
					57.8,
					81.91,
					57.9,
					81.91,
					59.42,
					81.83,
					59.48,
					81.73,
					59.43,
					81.62,
					59.04,
					81.49,
					58.9,
					81.53,
					59.23,
					81.39,
					59.45,
					81.28,
					59.45,
					81.27,
					59.73,
					81.38,
					59.83,
					81.32,
					60.69,
					81.18,
					60.67,
					81.14,
					60.49,
					81.22,
					61.13,
					81.19,
					61.67,
					81.04,
					61.75,
					80.95,
					61.59,
					80.97,
					61.9,
					80.78,
					62.32,
					80.49,
					62.12,
					80.45,
					61.74,
					80.36,
					61.67,
					80.22,
					61.16,
					80.32,
					60.44,
					80.23,
					60.3,
					80.06,
					60.31,
					80.02,
					60.12,
					79.89,
					60.18,
					79.79,
					60.07,
					79.84,
					59.08,
					79.66,
					58.66,
					79.81,
					58.51,
					79.86,
					58.23,
					79.99,
					58.2,
					80.08,
					57.25,
					79.94,
					57.02,
					79.99,
					55.76,
					80.41,
					55.66,
					80.5,
					55.91,
					80.52,
					55.55,
					80.62,
					55.32,
					80.6,
					55.03,
					80.39,
					55.61,
					80.22,
					55.62,
					80.1,
					55.12,
					80.16,
					54.89,
					80.29,
					54.86,
					80.25,
					54.55,
					80.11,
					54.45,
					80.05,
					54.2,
					80.18,
					54.05,
					80.02,
					53.48,
					79.98,
					52.86
				]
			},
			{
				"points": [
					79.98,
					51.51,
					79.87,
					51.53,
					79.81,
					51.43,
					79.85,
					50.04,
					79.97,
					49.76,
					79.91,
					49.66,
					79.91,
					49.15,
					79.96,
					49.04,
					80.06,
					49.02,
					80.07,
					48.61,
					79.96,
					48.35,
					79.97,
					47.64,
					80.08,
					47.54,
					80.1,
					46.87,
					80.22,
					46.66,
					80.36,
					46.65,
					80.39,
					45.54,
					80.49,
					44.86,
					80.61,
					44.77,
					80.69,
					44.86,
					80.96,
					47.47,
					80.9,
					48.5,
					80.74,
					48.84,
					80.63,
					48.89,
					80.63,
					48.98,
					80.74,
					48.87,
					80.88,
					48.98,
					81.02,
					50.27,
					81.24,
					50.31,
					81.29,
					50.75,
					81.19,
					51.11,
					81.07,
					51.11,
					81.01,
					50.96,
					80.89,
					51.09,
					80.81,
					51.82,
					80.66,
					51.89,
					80.43,
					51,
					80.38,
					49.91,
					80.3,
					49.87,
					80.28,
					50.43,
					80.12,
					50.46,
					80.21,
					50.97,
					80.15,
					51.32,
					79.98,
					51.51
				]
			},
			{
				"points": [
					68.55,
					49.45,
					68.68,
					49.34,
					68.55,
					49.21,
					68.67,
					48.2,
					68.76,
					48.13,
					69.11,
					48.1,
					69.38,
					48.27,
					69.56,
					48.67,
					69.6,
					49.32,
					69.36,
					50.18,
					69.18,
					50.4,
					69.06,
					50.37,
					68.86,
					50.14,
					68.85,
					49.87,
					68.75,
					49.68,
					68.6,
					49.66,
					68.55,
					49.45
				]
			},
			{
				"points": [
					80.53,
					63.04,
					80.7,
					62.47,
					80.83,
					62.41,
					81.06,
					63.02,
					81.29,
					64.5,
					81.23,
					65.22,
					81.03,
					65.51,
					80.81,
					65.42,
					80.66,
					64.96,
					80.53,
					63.04
				]
			},
			{
				"points": [
					81.4,
					62.12,
					81.48,
					61.76,
					81.61,
					61.7,
					81.73,
					61.89,
					81.69,
					62.1,
					81.76,
					62.19,
					81.8,
					62.86,
					81.81,
					63.53,
					81.66,
					63.94,
					81.54,
					63.86,
					81.46,
					63.41,
					81.54,
					62.42,
					81.46,
					62.38,
					81.4,
					62.12
				]
			}
		],
		"transitions": [
			[
				0,
				240,
				[
					"GST",
					"MUT",
					"GET",
					"RET",
					"VOLT",
					"MSK",
					"SCT",
					"SAMT"
				]
			]
		],
		"name": "Indian/Mauritius"
	},
	{
		"hoverRegion": [
			{
				"points": [
					39.55,
					69.25,
					39.79,
					69.16,
					40.05,
					69.25,
					40.12,
					69.33,
					40.07,
					69.43,
					40.2,
					69.53,
					40.34,
					70.04,
					40.13,
					70.59,
					40.43,
					71.12,
					40.3,
					71.74,
					40.6,
					72.15,
					40.58,
					72.26,
					40.71,
					72.31,
					40.64,
					72.59,
					40.74,
					72.69,
					40.78,
					72.53,
					40.93,
					72.42,
					40.9,
					72.14,
					41.05,
					72.08,
					41.1,
					71.8,
					41.33,
					71.75,
					41.2,
					71.53,
					40.99,
					71.41,
					41.08,
					70.73,
					41.33,
					70.63,
					41.29,
					70.44,
					41.47,
					70.08,
					41.67,
					70.12,
					41.92,
					70.54,
					41.98,
					70.45,
					41.67,
					70.1,
					41.55,
					69.67,
					41.35,
					69.46,
					41.33,
					69.23,
					40.82,
					68.65,
					41,
					68.38,
					41.08,
					68.01,
					41.15,
					66.56,
					41.79,
					66.43,
					41.9,
					65.9,
					42.81,
					65.99,
					42.79,
					65.74,
					43.23,
					65.56,
					43.65,
					65.07,
					43.49,
					64.5,
					43.56,
					63.38,
					43.39,
					61.96,
					44.28,
					61,
					44.51,
					60.63,
					44.63,
					60.63,
					44.77,
					60.82,
					45.16,
					60.72,
					45.48,
					60.52,
					45.82,
					60.52,
					46,
					60.68,
					46.05,
					60.05,
					45.97,
					59.77,
					45.71,
					59.57,
					45.67,
					59.33,
					45.44,
					59.35,
					45.2,
					59.51,
					45.09,
					59.42,
					45.38,
					58.79,
					45.54,
					58.79,
					45.72,
					59.13,
					45.82,
					59.15,
					45.85,
					59,
					45.77,
					58.8,
					45.51,
					58.63,
					45.52,
					58.5,
					45.99,
					58.63,
					46.1,
					58.99,
					46.99,
					60.02,
					47.02,
					60.25,
					47.34,
					60.31,
					47.31,
					60.9,
					47.87,
					61.24,
					47.93,
					61.95,
					47.42,
					62.65,
					47.28,
					62.73,
					47.24,
					62.86,
					47.9,
					64.07,
					48.35,
					63.69,
					48.57,
					63.05,
					48.78,
					62.99,
					48.74,
					62.79,
					49.14,
					62.24,
					49.36,
					62.31,
					49.58,
					62.23,
					49.63,
					62.35,
					49.92,
					62.49,
					50.05,
					62.73,
					50.6,
					62.31,
					50.63,
					62.11,
					50.89,
					62.13,
					51,
					61.92,
					51.18,
					61.8,
					51.15,
					61.67,
					50.68,
					61.45,
					50.55,
					60.85,
					50.55,
					60.47,
					50.73,
					60.09,
					50.49,
					59.88,
					50.4,
					59.54,
					50.52,
					59.4,
					50.58,
					58.91,
					50.72,
					58.56,
					50.98,
					58.42,
					51.03,
					58.31,
					50.96,
					58.2,
					51,
					57.86,
					50.82,
					57.78,
					50.77,
					57.51,
					50.85,
					57.25,
					50.99,
					57.13,
					50.85,
					56.73,
					50.93,
					56.5,
					50.81,
					56.41,
					50.81,
					56.25,
					50.61,
					56.16,
					50.44,
					55.7,
					50.7,
					55.05,
					50.81,
					54.98,
					50.78,
					54.78,
					50.55,
					54.8,
					50.42,
					54.52,
					50.59,
					54.32,
					50.76,
					54.36,
					50.8,
					54.22,
					51.02,
					54.06,
					51.13,
					53.61,
					51.31,
					53.54,
					51.4,
					53.35,
					51.35,
					52.52,
					51.62,
					52.29,
					51.54,
					52.09,
					51.56,
					51.89,
					51.44,
					51.87,
					51.36,
					51.68,
					51.44,
					51.52,
					51.38,
					51.26,
					51.56,
					51.13,
					51.57,
					50.85,
					51.69,
					50.69,
					51.86,
					50.71,
					52.15,
					51.3,
					52.38,
					51.3,
					52.74,
					51.45,
					52.77,
					51.62,
					52.94,
					51.64,
					53.11,
					51.95,
					53.36,
					52.06,
					53.55,
					51.97,
					53.92,
					52.28,
					54.27,
					52.09,
					54.38,
					52.12,
					54.48,
					52.51,
					54.39,
					52.95,
					54.45,
					53.06,
					54.13,
					53.33,
					54.42,
					53.24,
					54.64,
					53.34,
					54.77,
					53.5,
					55.06,
					53.07,
					55.16,
					53.03,
					55.24,
					53.11,
					55.31,
					53.54,
					55.64,
					54.02,
					55.84,
					53.56,
					55.95,
					53.53,
					56.32,
					54.23,
					56.52,
					53.93,
					56.53,
					53.77,
					56.74,
					53.7,
					56.91,
					53.82,
					56.87,
					53.98,
					57.01,
					54,
					57.09,
					54.16,
					57.19,
					54.18,
					57.27,
					54.01,
					57.45,
					54.07,
					57.53,
					53.88,
					57.74,
					54.03,
					57.91,
					54,
					58.17,
					53.71,
					58.32,
					53.75,
					58.56,
					53.58,
					58.77,
					53.74,
					58.88,
					53.62,
					59.01,
					53.64,
					59.05,
					53.33,
					59.31,
					53.09,
					59.75,
					53.33,
					59.8,
					53.52,
					59.97,
					53.58,
					60.1,
					53.43,
					60.04,
					52.99,
					60.14,
					52.25,
					60.36,
					52.21,
					60.49,
					51.73,
					60.62,
					51.67,
					60.97,
					51.84,
					60.95,
					52.28,
					61.08,
					52.38,
					61.06,
					52.73,
					61.2,
					52.86,
					61.14,
					53.39,
					60.98,
					53.47,
					60.97,
					53.58,
					60.96,
					53.74,
					61.09,
					53.87,
					60.98,
					54.91,
					61.1,
					54.98,
					61.11,
					55.14,
					61.23,
					55.25,
					61.19,
					55.66,
					61.35,
					55.8,
					61.32,
					56.22,
					61.51,
					56.31,
					61.63,
					56.64,
					61.61,
					58.79,
					61.76,
					59.23,
					61.89,
					59.23,
					62.01,
					59.35,
					62.16,
					59.29,
					62.44,
					59.47,
					62.7,
					59.28,
					62.83,
					59.32,
					62.88,
					59.2,
					63.1,
					59.11,
					63.99,
					59.48,
					64.08,
					59.68,
					64.15,
					59.51,
					64.37,
					59.49,
					64.45,
					59.37,
					64.9,
					59.63,
					65.17,
					60.19,
					65.15,
					60.46,
					65.02,
					60.62,
					65.15,
					60.77,
					65.26,
					61.16,
					65.41,
					61.19,
					65.79,
					61.81,
					65.95,
					62.69,
					66.15,
					62.78,
					66.58,
					63.38,
					66.97,
					64.97,
					67.09,
					64.97,
					67.23,
					65.11,
					67.39,
					65.58,
					67.5,
					65.7,
					67.71,
					65.75,
					67.76,
					65.91,
					67.82,
					65.91,
					67.81,
					65.4,
					67.92,
					65.22,
					68.28,
					65.17,
					68.52,
					65.45,
					68.7,
					65.24,
					68.77,
					64.5,
					69.02,
					64.42,
					69.12,
					64.47,
					69.36,
					64.93,
					69.18,
					66.21,
					69,
					66.6,
					68.88,
					67.43,
					68.69,
					67.5,
					68.45,
					68.28,
					68.31,
					68.38,
					68.78,
					68.92,
					68.87,
					68.42,
					69.15,
					68.03,
					69.37,
					67.92,
					69.47,
					67.48,
					69.32,
					67.37,
					69.23,
					67.16,
					69.35,
					66.87,
					69.49,
					66.75,
					69.87,
					66.72,
					70.11,
					66.89,
					70.08,
					67.21,
					70.21,
					67.01,
					70.42,
					67.17,
					70.55,
					67.1,
					70.69,
					67.19,
					70.65,
					66.65,
					70.83,
					66.53,
					70.95,
					66.59,
					71.03,
					66.55,
					71.36,
					66.93,
					71.6,
					67.91,
					71.85,
					68.36,
					72.74,
					68.87,
					73.04,
					69.3,
					73.01,
					69.81,
					73.47,
					69.92,
					73.57,
					70.41,
					73.55,
					71.2,
					73.25,
					71.71,
					73.15,
					71.75,
					73.07,
					71.67,
					72.98,
					71.01,
					72.99,
					71.56,
					72.79,
					72.84,
					72.71,
					72.93,
					72.55,
					72.86,
					72.2,
					72.91,
					71.98,
					72.65,
					71.81,
					72.57,
					71.77,
					72.44,
					71.62,
					72.41,
					71.45,
					72.02,
					71.2,
					72.69,
					71.05,
					72.71,
					70.89,
					72.93,
					70.56,
					72.82,
					70.33,
					72.85,
					70.22,
					72.64,
					70.01,
					72.62,
					69.8,
					72.79,
					69.63,
					72.67,
					69.46,
					72.8,
					69.1,
					72.61,
					69,
					72.66,
					68.67,
					73.51,
					68.44,
					73.71,
					68.31,
					73.63,
					68.33,
					73.49,
					68.13,
					73.18,
					67.9,
					73.32,
					67.59,
					73.17,
					67.47,
					72.64,
					67.38,
					72.52,
					67.23,
					72.48,
					67.19,
					72.32,
					67.03,
					72.29,
					66.77,
					71.85,
					66.79,
					71.69,
					66.68,
					71.72,
					66.53,
					71.64,
					66.46,
					71.13,
					66.35,
					72.17,
					66.39,
					72.26,
					66.55,
					72.23,
					66.68,
					72.44,
					66.74,
					72.89,
					67.07,
					73.79,
					67.36,
					73.85,
					67.74,
					74.63,
					67.99,
					74.68,
					68.33,
					74.2,
					68.8,
					74.42,
					69.09,
					76.17,
					69.15,
					75.53,
					69.01,
					75.17,
					69.03,
					74.31,
					68.97,
					73.94,
					69.11,
					73.7,
					69.38,
					73.77,
					69.58,
					73.5,
					69.8,
					73.44,
					70,
					73.65,
					70.17,
					73.6,
					70.55,
					74.16,
					70.75,
					73.84,
					70.89,
					73.8,
					71.07,
					73.55,
					71.3,
					72.94,
					71.43,
					72.88,
					71.71,
					73.4,
					71.88,
					73.47,
					72.09,
					74.49,
					72.25,
					74.9,
					72.42,
					74.94,
					72.75,
					74.66,
					72.86,
					74.09,
					72.95,
					73.97,
					73.05,
					73.99,
					73.22,
					74.31,
					73.14,
					74.91,
					73.07,
					74.99,
					72.97,
					74.97,
					72.83,
					75.52,
					72.69,
					75.53,
					72.57,
					75.73,
					72.44,
					75.66,
					72.24,
					75.78,
					72.1,
					75.58,
					71.89,
					75.49,
					71.83,
					75.33,
					71.67,
					75.56,
					71.47,
					75.59,
					71.38,
					75.45,
					71.32,
					75.77,
					71.25,
					77.09,
					71.46,
					76.27,
					71.81,
					75.89,
					71.92,
					75.89,
					72.12,
					76.44,
					72.16,
					76.87,
					72.03,
					77.29,
					72.11,
					77.28,
					72.21,
					76.8,
					72.34,
					76.74,
					72.7,
					77.57,
					72.66,
					78.17,
					72.22,
					78.94,
					72.16,
					79.72,
					71.99,
					80.38,
					71.91,
					80.45,
					71.81,
					80.41,
					71.76,
					80.23,
					71.56,
					80.16,
					71.49,
					79.86,
					71.5,
					79.46,
					71.39,
					79.39,
					71.14,
					80.61,
					70.92,
					80.66,
					70.69,
					80.86,
					70.53,
					80.78,
					70.36,
					80.89,
					70.31,
					80.79,
					70.32,
					80.21,
					70.17,
					79.75,
					69.94,
					79.28,
					69.84,
					79.17,
					69.78,
					79.24,
					69.75,
					79.54,
					69.45,
					79.91,
					69.41,
					80.77,
					69.31,
					80.97,
					69.37,
					81.51,
					69.55,
					81.68,
					69.42,
					82.01,
					69.28,
					82.01,
					69.25,
					82.52,
					68.92,
					82.63,
					68.89,
					82.83,
					68.75,
					83.09,
					68.64,
					83.15,
					68.56,
					83.06,
					68.53,
					82.78,
					68.23,
					82.79,
					68.06,
					82.48,
					67.86,
					82.43,
					67.83,
					82.14,
					67.69,
					82.2,
					67.59,
					82.48,
					67.23,
					82.41,
					66.88,
					83.25,
					66.65,
					83.41,
					66.52,
					83.19,
					66.25,
					83.63,
					66.13,
					83.62,
					66.05,
					83.49,
					65.92,
					83.63,
					65.89,
					84.06,
					65.77,
					84.39,
					65.64,
					84.41,
					65.58,
					84.57,
					65.28,
					84.69,
					65.07,
					84.46,
					65.02,
					84.49,
					65.03,
					84.93,
					64.86,
					85.15,
					64.93,
					85.57,
					64.81,
					85.95,
					64.6,
					86.02,
					64.47,
					85.97,
					64.28,
					86.14,
					64.01,
					86.06,
					63.83,
					85.57,
					63.59,
					85.36,
					63.46,
					85.46,
					63.41,
					85.76,
					63.15,
					85.61,
					62.98,
					85.67,
					62.79,
					85.53,
					62.71,
					85.29,
					62.15,
					84.58,
					61.9,
					84.73,
					61.63,
					86.02,
					61.41,
					86.05,
					61.31,
					85.8,
					61.19,
					85.73,
					60.71,
					84.02,
					60.93,
					83.48,
					60.92,
					83.16,
					60.64,
					82.49,
					60.53,
					82.46,
					60.4,
					82.16,
					60.54,
					81.83,
					60.53,
					81.07,
					60.65,
					80.97,
					60.68,
					80.7,
					60.55,
					80.18,
					60.53,
					79.38,
					60.72,
					79.17,
					60.63,
					77.92,
					60.73,
					77.18,
					60.44,
					77.1,
					60.38,
					76.87,
					60.22,
					76.95,
					60.11,
					76.85,
					59.72,
					76.85,
					59.5,
					76.72,
					59.43,
					76.2,
					59.31,
					75.95,
					59.16,
					75.75,
					58.92,
					75.75,
					58.33,
					74.94,
					58.03,
					74.25,
					58.03,
					73.11,
					57.89,
					72.86,
					57.91,
					72.11,
					58.01,
					71.95,
					57.96,
					71.2,
					58.04,
					71.13,
					58.32,
					71.18,
					58.41,
					70.91,
					57.89,
					70.5,
					57.58,
					70.79,
					57.38,
					70.61,
					57.32,
					70.7,
					57.42,
					70.76,
					57.44,
					71.13,
					57.25,
					71.25,
					57.03,
					71.68,
					56.83,
					71.78,
					56.73,
					71.72,
					56.56,
					71.36,
					56.57,
					71.21,
					56.43,
					71.04,
					56.23,
					70.95,
					56.12,
					71.02,
					55.94,
					70.96,
					55.76,
					70.87,
					55.71,
					70.75,
					55.57,
					70.87,
					55.39,
					70.63,
					55.37,
					70.89,
					55.14,
					71.11,
					54.93,
					71.07,
					54.71,
					71.39,
					54.28,
					71.3,
					54.22,
					71.61,
					54.35,
					71.75,
					54.31,
					71.93,
					54.43,
					71.97,
					54.47,
					72.11,
					54.39,
					72.34,
					54.27,
					72.39,
					54.2,
					72.99,
					54.09,
					73.12,
					54.06,
					73.41,
					54.18,
					73.61,
					54.14,
					73.8,
					54.03,
					73.85,
					53.79,
					73.78,
					53.76,
					73.5,
					53.62,
					73.36,
					53.57,
					73.44,
					53.73,
					73.64,
					53.75,
					73.91,
					53.62,
					74.34,
					53.78,
					74.43,
					53.78,
					74.6,
					53.92,
					74.78,
					53.9,
					75.02,
					54.03,
					75.32,
					54.19,
					75.38,
					54.36,
					76.12,
					54.46,
					76.19,
					54.45,
					76.63,
					54.55,
					76.97,
					54.45,
					77.03,
					54.1,
					76.84,
					54.04,
					76.66,
					53.33,
					78.01,
					52.1,
					79.17,
					50.92,
					80.08,
					51.04,
					80.34,
					51.27,
					80.35,
					51.31,
					80.55,
					51.41,
					80.64,
					51.29,
					81.2,
					51.07,
					81.21,
					51.08,
					81.44,
					50.88,
					81.54,
					50.92,
					81.79,
					50.85,
					82.48,
					51.04,
					82.71,
					51.01,
					82.93,
					51.12,
					83.07,
					51.11,
					83.48,
					50.86,
					84.03,
					50.57,
					84.32,
					50.34,
					84.38,
					50.31,
					84.69,
					50.13,
					85.07,
					49.99,
					85.09,
					49.7,
					85.33,
					49.71,
					85.61,
					49.58,
					86.11,
					49.89,
					86.55,
					49.9,
					86.84,
					49.8,
					86.9,
					49.63,
					86.86,
					49.39,
					87.01,
					49.3,
					87.37,
					49.04,
					87.4,
					49,
					86.9,
					48.79,
					86.91,
					48.44,
					86.64,
					48.27,
					85.8,
					47.92,
					85.65,
					47.21,
					85.8,
					46.95,
					85.57,
					46.94,
					85.25,
					46.71,
					84.79,
					46.77,
					84.6,
					46.88,
					84.6,
					46.85,
					84.01,
					47.08,
					83.09,
					45.61,
					82.41,
					45.4,
					82.73,
					45.03,
					82.55,
					45.11,
					82.24,
					45.04,
					81.93,
					45.24,
					81.66,
					44.93,
					80.32,
					44.76,
					80.58,
					44.6,
					80.47,
					44.17,
					80.51,
					43.51,
					80.84,
					43.17,
					80.9,
					43,
					80.6,
					42.89,
					80.69,
					42.79,
					80.64,
					42.73,
					80.33,
					42.65,
					80.29,
					42.52,
					80.38,
					41.96,
					80.33,
					41.92,
					79.91,
					41.69,
					79.72,
					41.72,
					79.42,
					41.33,
					78.49,
					41.19,
					78.46,
					40.97,
					78.22,
					40.88,
					77.54,
					40.9,
					76.93,
					40.39,
					76.61,
					40.25,
					76.34,
					40.33,
					76.23,
					40.18,
					75.95,
					40.17,
					75.66,
					40.37,
					75.53,
					40.51,
					75.56,
					40.33,
					75.23,
					40.37,
					74.99,
					40.23,
					74.93,
					40.16,
					74.61,
					39.97,
					74.37,
					39.93,
					74.03,
					39.77,
					73.95,
					39.57,
					74.04,
					39.35,
					73.84,
					39.35,
					73.48,
					39.24,
					73.2,
					39.26,
					72.51,
					39.06,
					72.23,
					39.24,
					72.01,
					39.17,
					71.74,
					39.33,
					71.68,
					39.35,
					71.51,
					39.47,
					71.44,
					39.27,
					70.88,
					39.3,
					70.71,
					39.5,
					70.51,
					39.41,
					70.28,
					39.48,
					69.71,
					39.4,
					69.34,
					39.55,
					69.25
				]
			},
			{
				"points": [
					21.6,
					89.4,
					21.55,
					89.17,
					21.74,
					88.94,
					22.12,
					88.97,
					22.52,
					88.82,
					22.8,
					88.85,
					22.96,
					88.75,
					23.12,
					88.82,
					23.2,
					88.63,
					23.44,
					88.67,
					23.61,
					88.46,
					23.9,
					88.49,
					23.99,
					88.63,
					24.21,
					88.62,
					24.42,
					88.07,
					24.67,
					87.91,
					24.99,
					88.04,
					25.04,
					88.29,
					25.28,
					88.37,
					25.29,
					88.76,
					25.41,
					88.71,
					25.41,
					88.49,
					25.7,
					88.21,
					25.77,
					88,
					25.94,
					87.97,
					26.19,
					88.08,
					26.37,
					88.33,
					26.49,
					88.22,
					26.73,
					88.37,
					26.4,
					88.81,
					26.56,
					88.91,
					26.49,
					89.14,
					26.2,
					89.26,
					26.11,
					89.4,
					26.08,
					89.5,
					26.24,
					89.52,
					26.32,
					89.73,
					25.95,
					89.98,
					25.37,
					89.95,
					25.25,
					90.45,
					25.28,
					92.09,
					25.15,
					92.41,
					24.95,
					92.59,
					24.77,
					92.54,
					24.73,
					92.35,
					24.36,
					92.24,
					24.24,
					92.02,
					24.06,
					91.97,
					23.98,
					91.48,
					23.7,
					91.26,
					23.35,
					91.38,
					23.34,
					91.49,
					23.1,
					91.65,
					23.3,
					91.66,
					23.52,
					91.85,
					23.8,
					91.87,
					23.84,
					92.17,
					23.72,
					92.39,
					22.96,
					92.48,
					22.73,
					92.62,
					22.18,
					92.71,
					21.3,
					92.78,
					21.13,
					92.6,
					21.25,
					92.47,
					21.28,
					92.31,
					20.73,
					92.46,
					20.5,
					92.4,
					20.52,
					92.24,
					20.71,
					92.23,
					21.46,
					91.75,
					21.98,
					91.77,
					22.35,
					91.6,
					22.23,
					91.48,
					22.39,
					91.3,
					21.98,
					91.1,
					22.04,
					90.86,
					21.88,
					90.79,
					21.66,
					90.48,
					21.63,
					90.33,
					21.74,
					90.24,
					21.68,
					90.12,
					21.79,
					89.92,
					21.6,
					89.6,
					21.6,
					89.4
				]
			},
			{
				"points": [
					27.29,
					88.75,
					27.35,
					88.88,
					27.62,
					88.92,
					27.92,
					89.25,
					28.05,
					89.28,
					28.25,
					89.55,
					28.43,
					90.02,
					28.34,
					90.43,
					28.18,
					90.48,
					28.08,
					91.09,
					28.19,
					91.31,
					28.02,
					91.73,
					27.59,
					91.74,
					27.52,
					92.1,
					27.29,
					92.23,
					27.1,
					92.14,
					26.9,
					92.22,
					26.75,
					92.12,
					26.69,
					91.92,
					26.74,
					91.45,
					26.66,
					91.33,
					26.66,
					90.69,
					26.78,
					90.41,
					26.64,
					90.11,
					26.61,
					89.65,
					26.7,
					89.51,
					26.7,
					89.09,
					26.87,
					88.8,
					27.1,
					88.65,
					27.29,
					88.75
				]
			},
			{
				"points": [
					73.26,
					75.41,
					73.31,
					75.3,
					73.46,
					75.27,
					73.61,
					75.53,
					73.62,
					76.09,
					73.55,
					76.19,
					73.42,
					76.12,
					73.26,
					75.41
				]
			}
		],
		"transitions": [
			[
				0,
				360,
				[
					"BTT",
					"KGT",
					"IOT",
					"ALMT",
					"BDT",
					"YEKT",
					"QYZT"
				]
			]
		],
		"name": "Asia/Dhaka"
	},
	{
		"hoverRegion": [
			{
				"points": [
					44.71,
					50.21,
					44.81,
					49.94,
					45.13,
					49.95,
					45.16,
					50.4,
					44.86,
					50.46,
					45.07,
					50.59,
					44.97,
					50.81,
					45.13,
					51.13,
					45.26,
					51.16,
					45.46,
					51.37,
					45.55,
					51.75,
					45.53,
					52.48,
					45.86,
					52.72,
					45.9,
					52.59,
					46.1,
					52.49,
					46.17,
					52.6,
					46.14,
					52.71,
					46.39,
					52.85,
					46.43,
					52.72,
					46.69,
					52.62,
					46.74,
					52.42,
					46.63,
					52.28,
					46.72,
					51.86,
					46.61,
					51.77,
					46.62,
					51.62,
					46.85,
					51.43,
					46.89,
					51.26,
					46.75,
					50.96,
					46.81,
					50.86,
					46.64,
					50.57,
					46.71,
					50.45,
					46.57,
					50.18,
					46.46,
					49.99,
					46.11,
					49.87,
					46.12,
					49.68,
					46.01,
					49.57,
					46.14,
					49.42,
					46.08,
					49.26,
					46.23,
					49.14,
					46.58,
					48.4,
					46.68,
					48.37,
					46.87,
					48.53,
					46.81,
					48.81,
					47.31,
					48.52,
					47.33,
					48.33,
					47.65,
					48,
					47.69,
					47.48,
					47.56,
					47.37,
					47.66,
					47.12,
					47.96,
					46.91,
					48.17,
					46.99,
					48.41,
					46.38,
					48.99,
					46.68,
					49.15,
					46.89,
					49.31,
					46.67,
					49.91,
					46.81,
					50.09,
					47.19,
					50.19,
					47.15,
					50.37,
					47.21,
					50.54,
					47.45,
					50.41,
					47.88,
					49.96,
					48.29,
					49.92,
					48.41,
					50.02,
					48.68,
					50.62,
					48.45,
					50.73,
					48.48,
					50.71,
					48.79,
					50.93,
					49.24,
					51.02,
					49.21,
					51.22,
					49.37,
					51.22,
					49.71,
					51.41,
					50.24,
					51.71,
					50.48,
					51.73,
					50.65,
					51.87,
					50.73,
					51.78,
					50.92,
					51.75,
					51.4,
					51.64,
					51.46,
					51.62,
					51.65,
					51.78,
					51.82,
					51.76,
					52.08,
					51.87,
					52.34,
					51.57,
					52.6,
					51.61,
					53.42,
					51.46,
					53.71,
					51.31,
					53.76,
					51.21,
					54.18,
					50.98,
					54.35,
					50.91,
					54.59,
					51,
					54.69,
					51.03,
					55.08,
					50.88,
					55.18,
					50.67,
					55.7,
					50.79,
					56.03,
					50.98,
					56.08,
					51.02,
					56.3,
					51.17,
					56.41,
					51.11,
					56.64,
					51.2,
					56.76,
					51.16,
					56.91,
					51.22,
					57.19,
					50.99,
					57.5,
					51.01,
					57.64,
					51.22,
					57.76,
					51.18,
					58.14,
					51.27,
					58.29,
					51.15,
					58.58,
					50.91,
					58.69,
					50.79,
					58.95,
					50.73,
					59.49,
					50.64,
					59.59,
					50.68,
					59.77,
					50.97,
					60.06,
					50.77,
					60.5,
					50.77,
					60.81,
					50.88,
					61.34,
					51.31,
					61.5,
					51.41,
					61.88,
					51.23,
					62,
					51.21,
					62.24,
					51.04,
					62.32,
					50.92,
					62.51,
					50.77,
					62.47,
					50.53,
					62.59,
					50.02,
					63.04,
					49.81,
					62.98,
					49.82,
					62.75,
					49.63,
					62.57,
					49.44,
					62.52,
					49.23,
					62.65,
					49.16,
					62.59,
					48.97,
					62.85,
					49.02,
					62.96,
					48.96,
					63.14,
					48.75,
					63.2,
					48.52,
					63.83,
					47.86,
					64.39,
					47.02,
					62.86,
					47.1,
					62.58,
					47.27,
					62.5,
					47.71,
					61.89,
					47.71,
					61.43,
					47.11,
					61.02,
					47.13,
					60.48,
					46.84,
					60.43,
					46.8,
					60.14,
					45.91,
					59.11,
					45.81,
					58.78,
					45.35,
					58.64,
					44.84,
					58.32,
					44.63,
					58.4,
					44.42,
					58.35,
					44.19,
					58.69,
					44.34,
					58.74,
					44.6,
					58.67,
					44.78,
					58.8,
					45.44,
					58.78,
					45.53,
					58.92,
					45.29,
					59.45,
					45.2,
					59.51,
					44.12,
					58.97,
					44.04,
					59.34,
					44.07,
					59.91,
					44.16,
					60.16,
					44.69,
					60.74,
					44.45,
					61.16,
					44.32,
					61.22,
					43.6,
					62.04,
					43.78,
					63.36,
					43.71,
					64.5,
					43.85,
					65.2,
					43.62,
					65.37,
					43.37,
					65.73,
					43,
					65.89,
					43.06,
					66.11,
					43,
					66.2,
					42.34,
					66.21,
					42.24,
					66.12,
					42.04,
					66.11,
					41.95,
					66.62,
					41.35,
					66.7,
					41.3,
					68.04,
					41.1,
					68.67,
					41.53,
					69.12,
					41.86,
					69.99,
					42.21,
					70.34,
					42.14,
					70.59,
					42.29,
					70.72,
					42.39,
					71.07,
					42.2,
					71.34,
					42.1,
					71.34,
					41.95,
					70.94,
					41.82,
					70.87,
					41.8,
					70.72,
					41.55,
					70.39,
					41.57,
					70.72,
					41.33,
					70.85,
					41.26,
					71.31,
					41.37,
					71.39,
					41.41,
					71.54,
					41.56,
					71.53,
					41.65,
					71.76,
					41.28,
					72.03,
					41.11,
					72.56,
					40.98,
					72.65,
					40.9,
					73.21,
					40.76,
					73.21,
					40.6,
					72.87,
					40.47,
					72.8,
					40.44,
					72.51,
					40.29,
					72.43,
					40.37,
					72.2,
					40.14,
					72.02,
					40.04,
					71.75,
					40.19,
					71.12,
					40,
					71.31,
					39.8,
					71.23,
					39.81,
					70.98,
					40.05,
					70.86,
					39.99,
					70.77,
					39.9,
					70.82,
					39.73,
					70.73,
					39.69,
					70.63,
					39.49,
					70.88,
					39.71,
					71.53,
					39.55,
					71.63,
					39.54,
					71.83,
					39.42,
					71.89,
					39.46,
					72.07,
					39.34,
					72.21,
					39.48,
					72.49,
					39.46,
					73.18,
					39.56,
					73.38,
					39.54,
					73.72,
					39.36,
					73.77,
					39.25,
					73.71,
					39.01,
					73.94,
					38.83,
					73.83,
					38.69,
					73.87,
					38.66,
					74,
					38.76,
					74.08,
					38.76,
					74.37,
					38.55,
					74.96,
					38.19,
					74.9,
					37.77,
					75.1,
					37.63,
					75.01,
					37.43,
					75.24,
					37.25,
					75.2,
					37.13,
					74.91,
					37.06,
					74.96,
					37.12,
					75.14,
					37.04,
					75.44,
					36.85,
					75.53,
					36.86,
					75.7,
					36.68,
					76,
					36.26,
					76.15,
					36.12,
					76.11,
					35.95,
					76.23,
					36.02,
					76.58,
					35.77,
					76.8,
					35.57,
					77.41,
					35.61,
					77.87,
					35.49,
					77.94,
					34.84,
					77.04,
					34.82,
					76.82,
					34.65,
					76.71,
					34.68,
					76.48,
					34.41,
					75.78,
					34.69,
					74.37,
					34.59,
					74.05,
					34.43,
					73.97,
					34.29,
					74.08,
					34.15,
					74.04,
					34.13,
					74.26,
					33.97,
					74.37,
					33.79,
					74.29,
					33.69,
					74.12,
					33.48,
					74.29,
					33.22,
					74.19,
					33.08,
					74.43,
					32.95,
					74.44,
					32.87,
					74.54,
					32.91,
					74.77,
					32.59,
					74.79,
					32.57,
					75.13,
					32.42,
					75.38,
					32.18,
					75.47,
					31.98,
					75.28,
					31.94,
					74.95,
					31.76,
					74.66,
					31.46,
					74.75,
					31.19,
					74.66,
					31.11,
					74.77,
					30.99,
					74.77,
					30.95,
					74.6,
					30.35,
					74,
					30.11,
					74.04,
					29.85,
					73.48,
					29.49,
					73.36,
					28.97,
					73.03,
					28.69,
					72.47,
					27.87,
					71.96,
					27.59,
					70.85,
					27.62,
					70.69,
					27.9,
					70.5,
					27.9,
					70.4,
					27.47,
					70.09,
					27.1,
					69.67,
					26.8,
					69.62,
					26.58,
					70.27,
					25.97,
					70.2,
					25.81,
					70.33,
					25.74,
					70.75,
					25.43,
					70.77,
					25.19,
					70.98,
					24.73,
					71.18,
					24.56,
					71.1,
					24.44,
					71.22,
					24.33,
					71.2,
					24.11,
					70.73,
					24.16,
					70.5,
					24.27,
					70.46,
					24.05,
					69.97,
					24.07,
					69.68,
					24.17,
					69.55,
					24.14,
					68.93,
					23.87,
					68.81,
					23.85,
					68.37,
					23.58,
					68.12,
					23.62,
					67.97,
					23.73,
					67.89,
					23.68,
					67.62,
					23.89,
					67.31,
					24.56,
					67.13,
					24.7,
					66.96,
					24.76,
					66.56,
					24.89,
					66.48,
					25.14,
					66.62,
					25.31,
					66.45,
					25.35,
					66.27,
					25.23,
					65.64,
					25.21,
					64.81,
					25.11,
					64.78,
					25.04,
					64.61,
					25.16,
					64.48,
					25.27,
					63.68,
					25.09,
					63.52,
					25.15,
					62.6,
					24.99,
					62.41,
					24.95,
					61.65,
					25.09,
					61.63,
					25.2,
					61.5,
					25.81,
					61.58,
					25.9,
					61.68,
					26.28,
					61.75,
					26.48,
					62.19,
					26.6,
					62.23,
					26.67,
					62.39,
					26.74,
					63.08,
					27.1,
					63.19,
					27.15,
					62.7,
					28.15,
					62.69,
					28.15,
					62.55,
					28.31,
					62.37,
					28.57,
					61.71,
					29.06,
					61.32,
					29.29,
					61.27,
					29.86,
					60.77,
					29.96,
					60.89,
					29.5,
					62.46,
					29.6,
					63.58,
					29.49,
					64.08,
					29.65,
					64.32,
					29.64,
					65.05,
					29.96,
					66.2,
					30.07,
					66.12,
					30.96,
					66.28,
					31.08,
					66.5,
					31.3,
					66.67,
					31.42,
					66.96,
					31.32,
					67.27,
					31.37,
					67.5,
					31.61,
					67.48,
					31.73,
					67.91,
					31.93,
					68.13,
					31.87,
					68.3,
					31.93,
					68.59,
					31.72,
					68.9,
					31.79,
					69.04,
					31.96,
					69.2,
					32.49,
					69.13,
					32.68,
					69.31,
					32.8,
					69.28,
					32.91,
					69.41,
					33.1,
					69.43,
					33.36,
					70.16,
					33.62,
					70.04,
					33.64,
					69.93,
					33.86,
					69.77,
					34.09,
					69.8,
					34.05,
					70.49,
					34.15,
					70.98,
					34.31,
					71.04,
					34.39,
					70.91,
					34.59,
					70.89,
					35.18,
					71.52,
					35.27,
					71.44,
					35.43,
					71.51,
					35.59,
					71.39,
					35.69,
					71.41,
					36.08,
					71.09,
					36.57,
					71.62,
					36.71,
					71.46,
					37.05,
					71.31,
					37.81,
					71.45,
					37.87,
					71.14,
					38.2,
					71.23,
					38.36,
					70.97,
					38.31,
					70.74,
					38.05,
					70.59,
					37.89,
					70.32,
					37.66,
					70.41,
					37.45,
					70.25,
					37.48,
					69.58,
					37.38,
					69.49,
					37.18,
					69.55,
					37,
					69.33,
					36.99,
					69.2,
					37.16,
					68.94,
					37.16,
					68.7,
					37.02,
					68.38,
					36.89,
					68.29,
					36.82,
					67.98,
					37.1,
					67.67,
					37.15,
					67.51,
					37.07,
					67.26,
					37.27,
					66.94,
					37.21,
					66.27,
					37.41,
					65.79,
					37.13,
					65.57,
					37.12,
					65.12,
					37.04,
					64.88,
					36.91,
					64.9,
					36.6,
					64.71,
					36.38,
					64.71,
					36.16,
					64.52,
					36.02,
					64.17,
					35.89,
					64.08,
					35.92,
					63.93,
					35.79,
					63.3,
					35.64,
					63.34,
					35.55,
					63.2,
					35.35,
					63.17,
					35.11,
					62.66,
					35.15,
					62.48,
					35.03,
					62.29,
					35.32,
					62.02,
					35.34,
					61.54,
					35.58,
					61.14,
					35.84,
					61.12,
					35.93,
					61.01,
					36.16,
					61.11,
					36.54,
					61.05,
					36.52,
					60.32,
					36.93,
					59.96,
					37.02,
					59.49,
					37.4,
					59.26,
					37.56,
					58.83,
					37.5,
					58.36,
					37.68,
					58.11,
					37.83,
					57.41,
					37.91,
					57.26,
					38.12,
					57.2,
					38.06,
					57.06,
					38.15,
					56.74,
					38.13,
					56.47,
					37.96,
					56.33,
					37.97,
					55.5,
					37.68,
					54.94,
					37.46,
					54.88,
					37.33,
					54.7,
					37.2,
					54.27,
					37.23,
					53.88,
					37.31,
					53.79,
					37.81,
					53.7,
					38.52,
					53.72,
					38.87,
					53.83,
					39.26,
					53.29,
					38.65,
					53.14,
					38.66,
					53,
					38.89,
					52.92,
					39.21,
					53.06,
					39.45,
					52.99,
					39.58,
					53.06,
					39.96,
					52.66,
					40.2,
					52.62,
					40.53,
					52.63,
					40.95,
					52.81,
					41.31,
					52.67,
					41.44,
					52.45,
					41.63,
					52.46,
					41.74,
					52.33,
					42.18,
					52.32,
					42.55,
					52.54,
					42.71,
					52.44,
					42.73,
					51.85,
					43.06,
					51.59,
					43.07,
					51.19,
					43.48,
					51.17,
					43.95,
					50.77,
					44.11,
					50.73,
					44.32,
					50.14,
					44.6,
					50.11,
					44.71,
					50.21
				]
			},
			{
				"points": [
					-49.72,
					69.27,
					-49.82,
					68.91,
					-50.04,
					68.97,
					-50.12,
					68.86,
					-50.07,
					68.77,
					-49.94,
					68.79,
					-49.69,
					68.63,
					-49.48,
					68.73,
					-49.34,
					68.54,
					-49.23,
					68.69,
					-49.07,
					68.62,
					-48.94,
					68.71,
					-48.65,
					68.5,
					-48.54,
					68.55,
					-48.52,
					68.69,
					-48.35,
					68.76,
					-48.4,
					68.91,
					-48.56,
					68.92,
					-48.64,
					69.27,
					-48.79,
					69.31,
					-48.59,
					69.4,
					-48.59,
					69.57,
					-49.13,
					69.8,
					-48.94,
					70.31,
					-49.05,
					70.61,
					-49.25,
					70.65,
					-49.8,
					70.26,
					-49.81,
					69.86,
					-49.72,
					69.27
				]
			},
			{
				"points": [
					4.84,
					73.07,
					4.77,
					72.97,
					4.81,
					72.85,
					5.03,
					72.78,
					5.19,
					72.96,
					5.9,
					72.85,
					5.97,
					72.95,
					6.09,
					72.95,
					6.19,
					73.13,
					6.17,
					72.93,
					6.37,
					72.79,
					6.29,
					72.67,
					6.4,
					72.57,
					6.51,
					72.65,
					6.45,
					72.78,
					6.51,
					72.82,
					6.67,
					72.76,
					6.85,
					72.85,
					7.1,
					72.68,
					7.2,
					72.88,
					7.01,
					73.08,
					7.08,
					73.18,
					7.01,
					73.3,
					6.81,
					73.3,
					6.43,
					73.11,
					6.39,
					73.28,
					6.07,
					73.36,
					6.04,
					73.46,
					5.87,
					73.55,
					5.58,
					73.38,
					5.59,
					73.28,
					5.73,
					73.22,
					5.71,
					73.09,
					5.4,
					73.11,
					5.35,
					73.2,
					5.55,
					73.29,
					5.57,
					73.54,
					5.4,
					73.74,
					5.28,
					73.73,
					5.16,
					73.61,
					5.27,
					73.46,
					5.27,
					73.24,
					5.09,
					73.19,
					4.99,
					73.03,
					4.84,
					73.07
				]
			},
			{
				"points": [
					0.12,
					73.17,
					0.11,
					73.06,
					0.22,
					72.9,
					0.53,
					72.83,
					0.63,
					72.99,
					0.37,
					73.07,
					0.33,
					73.27,
					0.43,
					73.39,
					0.83,
					73.24,
					0.95,
					73.38,
					0.61,
					73.5,
					0.53,
					73.6,
					0.36,
					73.6,
					0.18,
					73.42,
					0.12,
					73.17
				]
			}
		],
		"transitions": [
			[
				0,
				300,
				[
					"AQTT",
					"UZT",
					"TMT",
					"PKT",
					"MVT",
					"TJT",
					"ORAT",
					"TFT"
				]
			]
		],
		"name": "Asia/Tashkent"
	},
	{
		"hoverRegion": [
			{
				"points": [
					51.51,
					-177.83,
					51.59,
					-178.18,
					51.95,
					-178.3,
					52.02,
					-177.93,
					51.91,
					-177.51,
					52.05,
					-177.18,
					51.9,
					-176.93,
					52.05,
					-176.82,
					52.1,
					-176.57,
					51.99,
					-176.29,
					52.12,
					-176.28,
					52.22,
					-176.14,
					52.03,
					-175.55,
					52.18,
					-175.62,
					52.29,
					-175.55,
					52.21,
					-175.38,
					52.08,
					-175.41,
					52.17,
					-175.22,
					52.33,
					-175.15,
					52.25,
					-175,
					52.51,
					-174.25,
					52.44,
					-173.92,
					52.22,
					-173.92,
					52.19,
					-172.94,
					52.09,
					-172.84,
					51.99,
					-172.93,
					51.91,
					-173.47,
					52,
					-174.03,
					51.9,
					-174.47,
					51.92,
					-175.32,
					51.86,
					-175.42,
					51.92,
					-175.54,
					51.82,
					-175.67,
					51.82,
					-175.85,
					51.69,
					-175.96,
					51.55,
					-176.59,
					51.51,
					-176.98,
					51.6,
					-177.09,
					51.54,
					-177.62,
					51.6,
					-177.73,
					51.51,
					-177.83
				]
			},
			{
				"points": [
					52.65,
					-169.22,
					52.78,
					-169.34,
					52.98,
					-169.25,
					52.99,
					-169.09,
					53.57,
					-168.38,
					53.66,
					-168.07,
					53.56,
					-167.69,
					54.04,
					-167.07,
					54.11,
					-166.64,
					54.1,
					-166.32,
					53.89,
					-165.99,
					53.62,
					-166.13,
					53.34,
					-166.7,
					53.14,
					-167.47,
					53.21,
					-167.9,
					52.98,
					-168.34,
					52.87,
					-168.39,
					52.65,
					-169.22
				]
			},
			{
				"points": [
					52.63,
					172.92,
					52.82,
					172.4,
					52.94,
					172.35,
					53.06,
					172.53,
					53.09,
					173.11,
					52.87,
					173.53,
					52.74,
					173.46,
					52.63,
					172.92
				]
			},
			{
				"points": [
					51.11,
					-179.07,
					51.13,
					-179.19,
					51.24,
					-179.24,
					51.46,
					-179.05,
					51.61,
					-179.16,
					51.69,
					-179.07,
					51.67,
					-178.89,
					51.8,
					-178.97,
					51.94,
					-178.81,
					51.84,
					-178.63,
					51.71,
					-178.65,
					51.68,
					-178.49,
					51.53,
					-178.47,
					51.43,
					-178.82,
					51.26,
					-178.82,
					51.11,
					-179.07
				]
			}
		],
		"transitions": [
			[
				1320595200,
				-600,
				[
					"HAST"
				]
			],
			[
				1331481600,
				-540,
				[
					"HADT"
				]
			],
			[
				1352044800,
				-600,
				[
					"HAST"
				]
			],
			[
				1362931200,
				-540,
				[
					"HADT"
				]
			],
			[
				1383494400,
				-600,
				[
					"HAST"
				]
			],
			[
				1394380800,
				-540,
				[
					"HADT"
				]
			],
			[
				1414944000,
				-600,
				[
					"HAST"
				]
			],
			[
				1425830400,
				-540,
				[
					"HADT"
				]
			],
			[
				1446393600,
				-600,
				[
					"HAST"
				]
			],
			[
				1457884800,
				-540,
				[
					"HADT"
				]
			],
			[
				1478448000,
				-600,
				[
					"HAST"
				]
			],
			[
				1489334400,
				-540,
				[
					"HADT"
				]
			],
			[
				1509897600,
				-600,
				[
					"HAST"
				]
			],
			[
				1520784000,
				-540,
				[
					"HADT"
				]
			],
			[
				1541347200,
				-600,
				[
					"HAST"
				]
			],
			[
				1552233600,
				-540,
				[
					"HADT"
				]
			],
			[
				1572796800,
				-600,
				[
					"HAST"
				]
			],
			[
				1583683200,
				-540,
				[
					"HADT"
				]
			],
			[
				1604246400,
				-600,
				[
					"HAST"
				]
			],
			[
				1615737600,
				-540,
				[
					"HADT"
				]
			],
			[
				1636300800,
				-600,
				[
					"HAST"
				]
			],
			[
				1647187200,
				-540,
				[
					"HADT"
				]
			],
			[
				1667750400,
				-600,
				[
					"HAST"
				]
			],
			[
				1678636800,
				-540,
				[
					"HADT"
				]
			],
			[
				1699200000,
				-600,
				[
					"HAST"
				]
			],
			[
				1710086400,
				-540,
				[
					"HADT"
				]
			],
			[
				1730649600,
				-600,
				[
					"HAST"
				]
			],
			[
				1741536000,
				-540,
				[
					"HADT"
				]
			],
			[
				1762099200,
				-600,
				[
					"HAST"
				]
			],
			[
				1772985600,
				-540,
				[
					"HADT"
				]
			],
			[
				1793548800,
				-600,
				[
					"HAST"
				]
			],
			[
				1805040000,
				-540,
				[
					"HADT"
				]
			],
			[
				1825603200,
				-600,
				[
					"HAST"
				]
			],
			[
				1836489600,
				-540,
				[
					"HADT"
				]
			],
			[
				1857052800,
				-600,
				[
					"HAST"
				]
			],
			[
				1867939200,
				-540,
				[
					"HADT"
				]
			],
			[
				1888502400,
				-600,
				[
					"HAST"
				]
			],
			[
				1899388800,
				-540,
				[
					"HADT"
				]
			],
			[
				1919952000,
				-600,
				[
					"HAST"
				]
			],
			[
				1930838400,
				-540,
				[
					"HADT"
				]
			],
			[
				1951401600,
				-600,
				[
					"HAST"
				]
			],
			[
				1962892800,
				-540,
				[
					"HADT"
				]
			],
			[
				1983456000,
				-600,
				[
					"HAST"
				]
			],
			[
				1994342400,
				-540,
				[
					"HADT"
				]
			],
			[
				2014905600,
				-600,
				[
					"HAST"
				]
			],
			[
				2025792000,
				-540,
				[
					"HADT"
				]
			],
			[
				2046355200,
				-600,
				[
					"HAST"
				]
			],
			[
				2057241600,
				-540,
				[
					"HADT"
				]
			],
			[
				2077804800,
				-600,
				[
					"HAST"
				]
			],
			[
				2088691200,
				-540,
				[
					"HADT"
				]
			],
			[
				2109254400,
				-600,
				[
					"HAST"
				]
			],
			[
				2120140800,
				-540,
				[
					"HADT"
				]
			],
			[
				2140704000,
				-600,
				[
					"HAST"
				]
			]
		],
		"name": "America/Adak"
	},
	{
		"hoverRegion": [
			{
				"points": [
					47.4,
					-57.4,
					47.51,
					-57.52,
					47.49,
					-57.71,
					47.59,
					-57.94,
					47.46,
					-59.21,
					47.57,
					-59.41,
					47.92,
					-59.52,
					48.43,
					-58.79,
					48.37,
					-59.31,
					48.46,
					-59.38,
					48.63,
					-59.32,
					48.89,
					-58.81,
					48.84,
					-58.68,
					49.25,
					-58.47,
					49.65,
					-58.07,
					50.61,
					-57.46,
					50.71,
					-57.52,
					50.89,
					-57.41,
					50.93,
					-57.15,
					51.07,
					-57.18,
					51.19,
					-56.9,
					51.34,
					-56.83,
					51.3,
					-57.1,
					51.36,
					-57.2,
					52.69,
					-57.21,
					53,
					-57.59,
					53.42,
					-57.58,
					53.6,
					-57.23,
					53.72,
					-57.16,
					53.69,
					-56.4,
					53.78,
					-56.27,
					53.69,
					-56.15,
					53.78,
					-55.87,
					53.61,
					-55.77,
					53.54,
					-55.62,
					53.22,
					-55.58,
					52.81,
					-55.71,
					52.23,
					-55.46,
					51.88,
					-55.78,
					51.54,
					-56.62,
					51.4,
					-56.74,
					51.72,
					-55.93,
					51.72,
					-55.36,
					51.34,
					-55.38,
					51.09,
					-55.6,
					51.05,
					-55.47,
					50.76,
					-55.36,
					50.59,
					-55.53,
					50.61,
					-55.7,
					50.7,
					-55.78,
					50.89,
					-55.73,
					49.96,
					-56.66,
					49.86,
					-56.67,
					50.26,
					-56.19,
					50.13,
					-55.99,
					50.28,
					-55.96,
					50.33,
					-55.72,
					50.26,
					-55.62,
					50.13,
					-55.64,
					50.08,
					-55.81,
					50.11,
					-55.52,
					49.98,
					-55.37,
					49.88,
					-55.42,
					49.74,
					-55.72,
					49.6,
					-55.47,
					49.65,
					-54.96,
					49.79,
					-54.81,
					49.75,
					-54.68,
					49.85,
					-54.12,
					49.67,
					-53.89,
					49.69,
					-53.73,
					49.6,
					-53.65,
					49.48,
					-53.72,
					49.27,
					-53.36,
					48.96,
					-53.53,
					48.7,
					-53.52,
					48.65,
					-53.29,
					48.8,
					-53.06,
					48.55,
					-52.89,
					48.26,
					-53.13,
					48.2,
					-53.38,
					47.78,
					-53.64,
					48.09,
					-53.37,
					48.27,
					-52.96,
					48.27,
					-52.79,
					48.07,
					-52.69,
					47.86,
					-52.99,
					47.72,
					-53.05,
					47.91,
					-52.78,
					47.5,
					-52.52,
					46.7,
					-52.89,
					46.51,
					-53.15,
					46.61,
					-53.31,
					46.5,
					-53.53,
					46.58,
					-53.72,
					46.86,
					-53.76,
					46.68,
					-54.05,
					46.77,
					-54.3,
					47.26,
					-54.15,
					47.3,
					-54.43,
					47.13,
					-54.8,
					47.15,
					-54.92,
					46.82,
					-55.22,
					46.73,
					-55.79,
					46.87,
					-56.08,
					47.08,
					-56.06,
					47.15,
					-55.86,
					47.21,
					-56.06,
					47.41,
					-56.03,
					47.38,
					-56.26,
					47.51,
					-56.3,
					47.42,
					-56.87,
					47.49,
					-57.24,
					47.4,
					-57.4
				]
			},
			{
				"points": [
					51.78,
					-55.31,
					51.77,
					-55.42,
					51.94,
					-55.52,
					52.11,
					-55.24,
					51.97,
					-55.17,
					51.78,
					-55.31
				]
			},
			{
				"points": [
					49.64,
					-53.16,
					49.7,
					-53.29,
					49.85,
					-53.24,
					49.79,
					-53.08,
					49.64,
					-53.16
				]
			}
		],
		"transitions": [
			[
				1320571800,
				-210,
				[
					"NST"
				]
			],
			[
				1331458200,
				-150,
				[
					"NDT"
				]
			],
			[
				1352021400,
				-210,
				[
					"NST"
				]
			],
			[
				1362907800,
				-150,
				[
					"NDT"
				]
			],
			[
				1383471000,
				-210,
				[
					"NST"
				]
			],
			[
				1394357400,
				-150,
				[
					"NDT"
				]
			],
			[
				1414920600,
				-210,
				[
					"NST"
				]
			],
			[
				1425807000,
				-150,
				[
					"NDT"
				]
			],
			[
				1446370200,
				-210,
				[
					"NST"
				]
			],
			[
				1457861400,
				-150,
				[
					"NDT"
				]
			],
			[
				1478424600,
				-210,
				[
					"NST"
				]
			],
			[
				1489311000,
				-150,
				[
					"NDT"
				]
			],
			[
				1509874200,
				-210,
				[
					"NST"
				]
			],
			[
				1520760600,
				-150,
				[
					"NDT"
				]
			],
			[
				1541323800,
				-210,
				[
					"NST"
				]
			],
			[
				1552210200,
				-150,
				[
					"NDT"
				]
			],
			[
				1572773400,
				-210,
				[
					"NST"
				]
			],
			[
				1583659800,
				-150,
				[
					"NDT"
				]
			],
			[
				1604223000,
				-210,
				[
					"NST"
				]
			],
			[
				1615714200,
				-150,
				[
					"NDT"
				]
			],
			[
				1636277400,
				-210,
				[
					"NST"
				]
			],
			[
				1647163800,
				-150,
				[
					"NDT"
				]
			],
			[
				1667727000,
				-210,
				[
					"NST"
				]
			],
			[
				1678613400,
				-150,
				[
					"NDT"
				]
			],
			[
				1699176600,
				-210,
				[
					"NST"
				]
			],
			[
				1710063000,
				-150,
				[
					"NDT"
				]
			],
			[
				1730626200,
				-210,
				[
					"NST"
				]
			],
			[
				1741512600,
				-150,
				[
					"NDT"
				]
			],
			[
				1762075800,
				-210,
				[
					"NST"
				]
			],
			[
				1772962200,
				-150,
				[
					"NDT"
				]
			],
			[
				1793525400,
				-210,
				[
					"NST"
				]
			],
			[
				1805016600,
				-150,
				[
					"NDT"
				]
			],
			[
				1825579800,
				-210,
				[
					"NST"
				]
			],
			[
				1836466200,
				-150,
				[
					"NDT"
				]
			],
			[
				1857029400,
				-210,
				[
					"NST"
				]
			],
			[
				1867915800,
				-150,
				[
					"NDT"
				]
			],
			[
				1888479000,
				-210,
				[
					"NST"
				]
			],
			[
				1899365400,
				-150,
				[
					"NDT"
				]
			],
			[
				1919928600,
				-210,
				[
					"NST"
				]
			],
			[
				1930815000,
				-150,
				[
					"NDT"
				]
			],
			[
				1951378200,
				-210,
				[
					"NST"
				]
			],
			[
				1962869400,
				-150,
				[
					"NDT"
				]
			],
			[
				1983432600,
				-210,
				[
					"NST"
				]
			],
			[
				1994319000,
				-150,
				[
					"NDT"
				]
			],
			[
				2014882200,
				-210,
				[
					"NST"
				]
			],
			[
				2025768600,
				-150,
				[
					"NDT"
				]
			],
			[
				2046331800,
				-210,
				[
					"NST"
				]
			],
			[
				2057218200,
				-150,
				[
					"NDT"
				]
			],
			[
				2077781400,
				-210,
				[
					"NST"
				]
			],
			[
				2088667800,
				-150,
				[
					"NDT"
				]
			],
			[
				2109231000,
				-210,
				[
					"NST"
				]
			],
			[
				2120117400,
				-150,
				[
					"NDT"
				]
			],
			[
				2140680600,
				-210,
				[
					"NST"
				]
			]
		],
		"name": "America/St_Johns"
	},
	{
		"hoverRegion": [
			{
				"points": [
					40.97,
					43.4,
					41.08,
					43.36,
					41.25,
					43.52,
					41.22,
					43.73,
					41.35,
					44.18,
					41.31,
					44.71,
					41.4,
					44.8,
					41.4,
					45.03,
					41.13,
					45.31,
					41.11,
					45.5,
					40.89,
					45.7,
					40.74,
					45.6,
					40.54,
					45.61,
					40.24,
					46.08,
					39.9,
					45.92,
					39.71,
					46.2,
					39.73,
					46.41,
					39.58,
					46.67,
					39.37,
					46.61,
					39.2,
					46.73,
					39.12,
					46.63,
					38.79,
					46.62,
					38.75,
					46.05,
					39.21,
					45.9,
					39.34,
					45.69,
					39.45,
					45.71,
					39.39,
					45.42,
					39.5,
					45.12,
					39.66,
					45.03,
					39.62,
					44.7,
					39.91,
					44.3,
					39.9,
					43.9,
					40.02,
					43.59,
					40.46,
					43.43,
					40.75,
					43.62,
					40.97,
					43.4
				]
			}
		],
		"transitions": [
			[
				1319940000,
				240,
				[
					"AMT"
				]
			],
			[
				1332640800,
				300,
				[
					"AMST"
				]
			],
			[
				1351389600,
				240,
				[
					"AMT"
				]
			],
			[
				1364695200,
				300,
				[
					"AMST"
				]
			],
			[
				1382839200,
				240,
				[
					"AMT"
				]
			],
			[
				1396144800,
				300,
				[
					"AMST"
				]
			],
			[
				1414288800,
				240,
				[
					"AMT"
				]
			],
			[
				1427594400,
				300,
				[
					"AMST"
				]
			],
			[
				1445738400,
				240,
				[
					"AMT"
				]
			],
			[
				1459044000,
				300,
				[
					"AMST"
				]
			],
			[
				1477792800,
				240,
				[
					"AMT"
				]
			],
			[
				1490493600,
				300,
				[
					"AMST"
				]
			],
			[
				1509242400,
				240,
				[
					"AMT"
				]
			],
			[
				1521943200,
				300,
				[
					"AMST"
				]
			],
			[
				1540692000,
				240,
				[
					"AMT"
				]
			],
			[
				1553997600,
				300,
				[
					"AMST"
				]
			],
			[
				1572141600,
				240,
				[
					"AMT"
				]
			],
			[
				1585447200,
				300,
				[
					"AMST"
				]
			],
			[
				1603591200,
				240,
				[
					"AMT"
				]
			],
			[
				1616896800,
				300,
				[
					"AMST"
				]
			],
			[
				1635645600,
				240,
				[
					"AMT"
				]
			],
			[
				1648346400,
				300,
				[
					"AMST"
				]
			],
			[
				1667095200,
				240,
				[
					"AMT"
				]
			],
			[
				1679796000,
				300,
				[
					"AMST"
				]
			],
			[
				1698544800,
				240,
				[
					"AMT"
				]
			],
			[
				1711850400,
				300,
				[
					"AMST"
				]
			],
			[
				1729994400,
				240,
				[
					"AMT"
				]
			],
			[
				1743300000,
				300,
				[
					"AMST"
				]
			],
			[
				1761444000,
				240,
				[
					"AMT"
				]
			],
			[
				1774749600,
				300,
				[
					"AMST"
				]
			],
			[
				1792893600,
				240,
				[
					"AMT"
				]
			],
			[
				1806199200,
				300,
				[
					"AMST"
				]
			],
			[
				1824948000,
				240,
				[
					"AMT"
				]
			],
			[
				1837648800,
				300,
				[
					"AMST"
				]
			],
			[
				1856397600,
				240,
				[
					"AMT"
				]
			],
			[
				1869098400,
				300,
				[
					"AMST"
				]
			],
			[
				1887847200,
				240,
				[
					"AMT"
				]
			],
			[
				1901152800,
				300,
				[
					"AMST"
				]
			],
			[
				1919296800,
				240,
				[
					"AMT"
				]
			],
			[
				1932602400,
				300,
				[
					"AMST"
				]
			],
			[
				1950746400,
				240,
				[
					"AMT"
				]
			],
			[
				1964052000,
				300,
				[
					"AMST"
				]
			],
			[
				1982800800,
				240,
				[
					"AMT"
				]
			],
			[
				1995501600,
				300,
				[
					"AMST"
				]
			],
			[
				2014250400,
				240,
				[
					"AMT"
				]
			],
			[
				2026951200,
				300,
				[
					"AMST"
				]
			],
			[
				2045700000,
				240,
				[
					"AMT"
				]
			],
			[
				2058400800,
				300,
				[
					"AMST"
				]
			],
			[
				2077149600,
				240,
				[
					"AMT"
				]
			],
			[
				2090455200,
				300,
				[
					"AMST"
				]
			],
			[
				2108599200,
				240,
				[
					"AMT"
				]
			],
			[
				2121904800,
				300,
				[
					"AMST"
				]
			],
			[
				2140048800,
				240,
				[
					"AMT"
				]
			]
		],
		"name": "Asia/Yerevan"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-14.86,
					128.88,
					-14.77,
					128.95,
					-14.82,
					129.12,
					-14.72,
					129.22,
					-14.78,
					129.38,
					-14.67,
					129.48,
					-14.55,
					129.35,
					-14.29,
					129.25,
					-13.97,
					129.39,
					-13.88,
					129.64,
					-13.44,
					129.72,
					-13.33,
					129.87,
					-13.39,
					130,
					-13.32,
					130.08,
					-13.25,
					129.93,
					-13.07,
					129.91,
					-13,
					130.01,
					-12.84,
					130.07,
					-12.8,
					130.22,
					-12.43,
					130.34,
					-12.41,
					130.47,
					-12.29,
					130.55,
					-12.31,
					130.74,
					-12.21,
					130.9,
					-12.04,
					130.89,
					-11.86,
					129.93,
					-11.44,
					130.03,
					-10.98,
					130.28,
					-11.1,
					131.34,
					-11.44,
					131.63,
					-11.67,
					131.55,
					-11.95,
					131.14,
					-11.94,
					131.34,
					-12.16,
					131.48,
					-12.1,
					131.9,
					-12.17,
					132.05,
					-11.98,
					132.29,
					-11.98,
					132.51,
					-11.8,
					132.51,
					-11.69,
					132.36,
					-11.72,
					132.07,
					-11.53,
					131.85,
					-11.44,
					131.84,
					-11.38,
					131.67,
					-11.14,
					131.72,
					-11.02,
					131.93,
					-11.07,
					132.24,
					-10.86,
					132.59,
					-10.99,
					132.7,
					-10.87,
					132.76,
					-10.91,
					132.91,
					-10.8,
					132.96,
					-10.8,
					133.07,
					-10.88,
					133.14,
					-11.1,
					133.11,
					-11.24,
					132.98,
					-11.59,
					133.2,
					-11.4,
					133.31,
					-11.36,
					133.51,
					-11.7,
					133.62,
					-11.61,
					133.76,
					-11.63,
					133.92,
					-11.77,
					134,
					-11.95,
					134.49,
					-11.84,
					134.74,
					-11.93,
					134.94,
					-11.83,
					134.98,
					-11.8,
					135.11,
					-11.67,
					135.04,
					-11.58,
					135.15,
					-11.66,
					135.26,
					-11.81,
					135.19,
					-11.9,
					135.25,
					-12.14,
					135.09,
					-11.98,
					135.32,
					-11.98,
					135.47,
					-11.86,
					135.53,
					-11.68,
					135.84,
					-11.45,
					136.04,
					-11.46,
					136.18,
					-10.92,
					136.69,
					-10.92,
					136.83,
					-11.03,
					136.85,
					-11.42,
					136.68,
					-11.93,
					136.06,
					-11.64,
					136.57,
					-11.66,
					136.7,
					-11.55,
					136.79,
					-11.62,
					136.93,
					-12,
					136.64,
					-12.08,
					136.68,
					-11.98,
					136.76,
					-11.98,
					136.87,
					-12.39,
					137.07,
					-12.8,
					136.72,
					-13.04,
					136.75,
					-13.33,
					136.53,
					-13.4,
					136.35,
					-13.53,
					136.34,
					-13.54,
					137.02,
					-14.29,
					137.08,
					-14.46,
					136.95,
					-14.33,
					136.26,
					-14.23,
					136.21,
					-13.93,
					136.27,
					-13.92,
					136.06,
					-14.26,
					135.98,
					-14.36,
					135.8,
					-14.71,
					135.63,
					-14.78,
					135.51,
					-14.9,
					135.57,
					-14.74,
					135.67,
					-14.74,
					135.78,
					-15.09,
					135.89,
					-15.34,
					136.31,
					-15.52,
					136.4,
					-15.41,
					136.59,
					-15.49,
					136.7,
					-15.42,
					136.95,
					-15.62,
					137.18,
					-15.85,
					137.17,
					-16.16,
					137.81,
					-16.5,
					138.09,
					-26.08,
					138.07,
					-26.07,
					128.91,
					-14.86,
					128.88
				]
			}
		],
		"transitions": [
			[
				0,
				570,
				[
					"CST"
				]
			]
		],
		"name": "Australia/Darwin"
	},
	{
		"hoverRegion": [
			{
				"points": [
					19.33,
					-96.06,
					19.26,
					-95.94,
					18.93,
					-95.8,
					18.82,
					-95.55,
					18.81,
					-95.15,
					18.68,
					-94.98,
					18.63,
					-94.75,
					18.27,
					-94.47,
					18.54,
					-93.5,
					18.55,
					-92.95,
					18.72,
					-92.69,
					18.82,
					-91.98,
					18.74,
					-91.82,
					19.21,
					-91.04,
					19.43,
					-90.82,
					19.77,
					-90.76,
					20.01,
					-90.57,
					20.69,
					-90.56,
					21.06,
					-90.41,
					21.36,
					-89.86,
					21.5,
					-88.88,
					21.64,
					-88.61,
					21.71,
					-88.17,
					21.6,
					-87.53,
					21.71,
					-87.07,
					21.58,
					-86.71,
					21.35,
					-86.7,
					21.23,
					-86.6,
					20.67,
					-86.86,
					20.68,
					-86.67,
					20.54,
					-86.65,
					20.16,
					-86.92,
					20.18,
					-87.04,
					20.38,
					-87.13,
					20.17,
					-87.31,
					19.28,
					-87.34,
					18.08,
					-87.8,
					18.09,
					-87.95,
					18.35,
					-88.02,
					18.44,
					-88.17,
					18.36,
					-88.44,
					17.76,
					-88.81,
					17.87,
					-89.03,
					17.7,
					-89.14,
					17.7,
					-90.87,
					17.21,
					-90.88,
					17.14,
					-91.11,
					16.98,
					-90.99,
					16.8,
					-90.63,
					16.56,
					-90.51,
					16.47,
					-90.29,
					16.04,
					-90.32,
					15.96,
					-91.66,
					15.26,
					-92.07,
					15.06,
					-91.94,
					14.94,
					-92.03,
					14.6,
					-92.05,
					14.42,
					-92.22,
					15.12,
					-92.98,
					15.9,
					-94.01,
					16.06,
					-94.42,
					16.08,
					-95.09,
					15.86,
					-95.4,
					15.56,
					-96.2,
					15.53,
					-96.55,
					15.79,
					-97.2,
					15.85,
					-97.8,
					16.12,
					-98.25,
					16.21,
					-98.59,
					16.44,
					-98.82,
					16.59,
					-99.71,
					16.79,
					-100.01,
					17.16,
					-101.09,
					17.57,
					-101.72,
					17.84,
					-101.99,
					17.8,
					-102.22,
					18.21,
					-103.51,
					18.77,
					-104.03,
					19.24,
					-105.04,
					19.91,
					-105.59,
					20.44,
					-105.8,
					20.62,
					-105.43,
					20.69,
					-105.6,
					20.79,
					-105.65,
					21,
					-105.45,
					20.89,
					-105.25,
					21.12,
					-104.78,
					20.89,
					-104.37,
					21.22,
					-104.32,
					21.34,
					-104.1,
					21.52,
					-104.31,
					21.76,
					-104.22,
					22.03,
					-104.5,
					22.31,
					-104.42,
					22.37,
					-104.66,
					22.53,
					-104.79,
					22.46,
					-105.07,
					22.68,
					-105.1,
					22.83,
					-105,
					22.96,
					-105.43,
					23.19,
					-105.75,
					24.14,
					-106.09,
					24.25,
					-106.25,
					24.17,
					-106.37,
					24.22,
					-106.6,
					24.52,
					-106.74,
					24.87,
					-107.1,
					25.26,
					-107.23,
					25.66,
					-107.17,
					25.73,
					-106.78,
					25.84,
					-106.64,
					26.07,
					-106.61,
					26.18,
					-106.49,
					26.42,
					-106.54,
					26.5,
					-106.32,
					26.81,
					-106.24,
					26.94,
					-106.05,
					26.58,
					-105.32,
					26.65,
					-105.12,
					26.48,
					-104.6,
					26.86,
					-104.22,
					26.8,
					-103.78,
					27.88,
					-104.06,
					28.81,
					-103.52,
					28.81,
					-103.1,
					28.88,
					-102.97,
					29.18,
					-102.7,
					29.58,
					-102.54,
					29.66,
					-102.19,
					29.59,
					-101.53,
					29,
					-100.79,
					28.18,
					-100.41,
					27.94,
					-100.12,
					27.65,
					-99.97,
					27.44,
					-99.67,
					26.93,
					-99.59,
					26.77,
					-99.37,
					26.45,
					-99.31,
					26.26,
					-99.17,
					25.88,
					-98.17,
					25.89,
					-97.81,
					25.69,
					-97.48,
					25.71,
					-97.11,
					24.92,
					-97.44,
					24.21,
					-97.6,
					22.89,
					-97.65,
					22.55,
					-97.74,
					22.02,
					-97.6,
					21.5,
					-97.12,
					21.22,
					-97.3,
					21.09,
					-97.11,
					20.93,
					-97.16,
					20.73,
					-97.07,
					19.93,
					-96.36,
					19.41,
					-96.21,
					19.33,
					-96.06
				]
			},
			{
				"points": [
					18.33,
					-87.46,
					18.39,
					-87.53,
					18.67,
					-87.53,
					18.86,
					-87.4,
					18.87,
					-87.24,
					18.58,
					-87.14,
					18.29,
					-87.3,
					18.33,
					-87.46
				]
			},
			{
				"points": [
					22.29,
					-89.6,
					22.4,
					-89.83,
					22.54,
					-89.89,
					22.66,
					-89.82,
					22.66,
					-89.64,
					22.58,
					-89.52,
					22.36,
					-89.53,
					22.29,
					-89.6
				]
			},
			{
				"points": [
					22.02,
					-91.4,
					22.11,
					-91.51,
					22.24,
					-91.41,
					22.13,
					-91.29,
					22.02,
					-91.4
				]
			}
		],
		"transitions": [
			[
				1319972400,
				-360,
				[
					"CST"
				]
			],
			[
				1333281600,
				-300,
				[
					"CDT"
				]
			],
			[
				1351422000,
				-360,
				[
					"CST"
				]
			],
			[
				1365336000,
				-300,
				[
					"CDT"
				]
			],
			[
				1382871600,
				-360,
				[
					"CST"
				]
			],
			[
				1396785600,
				-300,
				[
					"CDT"
				]
			],
			[
				1414321200,
				-360,
				[
					"CST"
				]
			],
			[
				1428235200,
				-300,
				[
					"CDT"
				]
			],
			[
				1445770800,
				-360,
				[
					"CST"
				]
			],
			[
				1459684800,
				-300,
				[
					"CDT"
				]
			],
			[
				1477825200,
				-360,
				[
					"CST"
				]
			],
			[
				1491134400,
				-300,
				[
					"CDT"
				]
			],
			[
				1509274800,
				-360,
				[
					"CST"
				]
			],
			[
				1522584000,
				-300,
				[
					"CDT"
				]
			],
			[
				1540724400,
				-360,
				[
					"CST"
				]
			],
			[
				1554638400,
				-300,
				[
					"CDT"
				]
			],
			[
				1572174000,
				-360,
				[
					"CST"
				]
			],
			[
				1586088000,
				-300,
				[
					"CDT"
				]
			],
			[
				1603623600,
				-360,
				[
					"CST"
				]
			],
			[
				1617537600,
				-300,
				[
					"CDT"
				]
			],
			[
				1635678000,
				-360,
				[
					"CST"
				]
			],
			[
				1648987200,
				-300,
				[
					"CDT"
				]
			],
			[
				1667127600,
				-360,
				[
					"CST"
				]
			],
			[
				1680436800,
				-300,
				[
					"CDT"
				]
			],
			[
				1698577200,
				-360,
				[
					"CST"
				]
			],
			[
				1712491200,
				-300,
				[
					"CDT"
				]
			],
			[
				1730026800,
				-360,
				[
					"CST"
				]
			],
			[
				1743940800,
				-300,
				[
					"CDT"
				]
			],
			[
				1761476400,
				-360,
				[
					"CST"
				]
			],
			[
				1775390400,
				-300,
				[
					"CDT"
				]
			],
			[
				1792926000,
				-360,
				[
					"CST"
				]
			],
			[
				1806840000,
				-300,
				[
					"CDT"
				]
			],
			[
				1824980400,
				-360,
				[
					"CST"
				]
			],
			[
				1838289600,
				-300,
				[
					"CDT"
				]
			],
			[
				1856430000,
				-360,
				[
					"CST"
				]
			],
			[
				1869739200,
				-300,
				[
					"CDT"
				]
			],
			[
				1887879600,
				-360,
				[
					"CST"
				]
			],
			[
				1901793600,
				-300,
				[
					"CDT"
				]
			],
			[
				1919329200,
				-360,
				[
					"CST"
				]
			],
			[
				1933243200,
				-300,
				[
					"CDT"
				]
			],
			[
				1950778800,
				-360,
				[
					"CST"
				]
			],
			[
				1964692800,
				-300,
				[
					"CDT"
				]
			],
			[
				1982833200,
				-360,
				[
					"CST"
				]
			],
			[
				1996142400,
				-300,
				[
					"CDT"
				]
			],
			[
				2014282800,
				-360,
				[
					"CST"
				]
			],
			[
				2027592000,
				-300,
				[
					"CDT"
				]
			],
			[
				2045732400,
				-360,
				[
					"CST"
				]
			],
			[
				2059041600,
				-300,
				[
					"CDT"
				]
			],
			[
				2077182000,
				-360,
				[
					"CST"
				]
			],
			[
				2091096000,
				-300,
				[
					"CDT"
				]
			],
			[
				2108631600,
				-360,
				[
					"CST"
				]
			],
			[
				2122545600,
				-300,
				[
					"CDT"
				]
			],
			[
				2140081200,
				-360,
				[
					"CST"
				]
			]
		],
		"name": "America/Mexico_City"
	},
	{
		"hoverRegion": [
			{
				"points": [
					70.8,
					-21.51,
					70.74,
					-21.3,
					70.6,
					-21.26,
					70.44,
					-21.42,
					70.3,
					-21.73,
					70.29,
					-22.01,
					70.38,
					-22.08,
					70.34,
					-22.43,
					70.43,
					-22.5,
					70.32,
					-22.62,
					70.33,
					-23.37,
					70.52,
					-24.02,
					70.75,
					-24.26,
					70.93,
					-24.3,
					71.15,
					-24.62,
					72.4,
					-24.49,
					72.45,
					-24.39,
					72.32,
					-23.64,
					72.21,
					-23.55,
					72.2,
					-23.23,
					72.08,
					-22.99,
					71.98,
					-22.42,
					71.81,
					-22.33,
					71.83,
					-21.86,
					71.69,
					-21.81,
					71.58,
					-22.01,
					71.64,
					-21.66,
					71.59,
					-21.55,
					70.8,
					-21.51
				]
			},
			{
				"points": [
					38.27,
					-28.21,
					38.42,
					-28.79,
					38.65,
					-28.92,
					38.74,
					-28.68,
					38.64,
					-28.5,
					38.66,
					-28.37,
					38.79,
					-28.42,
					38.86,
					-28.33,
					38.59,
					-27.65,
					38.45,
					-27.7,
					38.45,
					-27.92,
					38.33,
					-27.96,
					38.27,
					-28.21
				]
			},
			{
				"points": [
					37.59,
					-25.42,
					37.64,
					-25.75,
					37.81,
					-25.95,
					37.91,
					-25.94,
					38.01,
					-25.77,
					37.9,
					-25.05,
					37.64,
					-25.1,
					37.59,
					-25.42
				]
			},
			{
				"points": [
					38.52,
					-27.22,
					38.62,
					-27.44,
					38.86,
					-27.44,
					38.82,
					-26.97,
					38.56,
					-27,
					38.52,
					-27.22
				]
			}
		],
		"transitions": [
			[
				1319950800,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1332651600,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1351400400,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1364706000,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1382850000,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1396155600,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1414299600,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1427605200,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1445749200,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1459054800,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1477803600,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1490504400,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1509253200,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1521954000,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1540702800,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1554008400,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1572152400,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1585458000,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1603602000,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1616907600,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1635656400,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1648357200,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1667106000,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1679806800,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1698555600,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1711861200,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1730005200,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1743310800,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1761454800,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1774760400,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1792904400,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1806210000,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1824958800,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1837659600,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1856408400,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1869109200,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1887858000,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1901163600,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1919307600,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1932613200,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1950757200,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1964062800,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				1982811600,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				1995512400,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				2014261200,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				2026962000,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				2045710800,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				2058411600,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				2077160400,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				2090466000,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				2108610000,
				-60,
				[
					"AZOT",
					"EGT"
				]
			],
			[
				2121915600,
				0,
				[
					"EGST",
					"AZOST"
				]
			],
			[
				2140059600,
				-60,
				[
					"AZOT",
					"EGT"
				]
			]
		],
		"name": "America/Scoresbysund"
	},
	{
		"hoverRegion": [
			{
				"points": [
					32.59,
					35.59,
					32.68,
					35.49,
					33.32,
					35.52,
					33.56,
					35.86,
					33.66,
					35.82,
					33.89,
					35.98,
					33.93,
					36.18,
					34.23,
					36.49,
					34.33,
					36.46,
					34.43,
					36.25,
					34.56,
					36.24,
					34.53,
					35.98,
					34.6,
					35.87,
					34.9,
					35.77,
					35.36,
					35.82,
					35.6,
					35.62,
					35.76,
					35.73,
					35.93,
					35.73,
					36.05,
					36,
					35.99,
					36.11,
					36.08,
					36.27,
					36.3,
					36.31,
					36.33,
					36.52,
					36.53,
					36.44,
					36.93,
					36.61,
					36.86,
					37.01,
					36.73,
					37.14,
					36.74,
					37.46,
					37.02,
					38.27,
					36.94,
					38.59,
					36.81,
					38.77,
					36.77,
					39.22,
					36.86,
					39.81,
					37.23,
					40.78,
					37.19,
					41.54,
					37.26,
					41.93,
					37.42,
					42.2,
					37.28,
					42.45,
					36.98,
					42.44,
					36.54,
					41.94,
					36.42,
					41.46,
					36.31,
					41.38,
					36.07,
					41.36,
					35.62,
					41.47,
					35.23,
					41.32,
					34.75,
					41.33,
					34.29,
					41.02,
					34.13,
					40.51,
					32.21,
					36.88,
					32.4,
					36.04,
					32.6,
					35.87,
					32.59,
					35.59
				]
			}
		],
		"transitions": [
			[
				1319763600,
				120,
				[
					"EET"
				]
			],
			[
				1333677600,
				180,
				[
					"EEST"
				]
			],
			[
				1351213200,
				120,
				[
					"EET"
				]
			],
			[
				1365127200,
				180,
				[
					"EEST"
				]
			],
			[
				1382662800,
				120,
				[
					"EET"
				]
			],
			[
				1396576800,
				180,
				[
					"EEST"
				]
			],
			[
				1414717200,
				120,
				[
					"EET"
				]
			],
			[
				1428026400,
				180,
				[
					"EEST"
				]
			],
			[
				1446166800,
				120,
				[
					"EET"
				]
			],
			[
				1459476000,
				180,
				[
					"EEST"
				]
			],
			[
				1477616400,
				120,
				[
					"EET"
				]
			],
			[
				1491530400,
				180,
				[
					"EEST"
				]
			],
			[
				1509066000,
				120,
				[
					"EET"
				]
			],
			[
				1522980000,
				180,
				[
					"EEST"
				]
			],
			[
				1540515600,
				120,
				[
					"EET"
				]
			],
			[
				1554429600,
				180,
				[
					"EEST"
				]
			],
			[
				1571965200,
				120,
				[
					"EET"
				]
			],
			[
				1585879200,
				180,
				[
					"EEST"
				]
			],
			[
				1604019600,
				120,
				[
					"EET"
				]
			],
			[
				1617328800,
				180,
				[
					"EEST"
				]
			],
			[
				1635469200,
				120,
				[
					"EET"
				]
			],
			[
				1648778400,
				180,
				[
					"EEST"
				]
			],
			[
				1666918800,
				120,
				[
					"EET"
				]
			],
			[
				1680832800,
				180,
				[
					"EEST"
				]
			],
			[
				1698368400,
				120,
				[
					"EET"
				]
			],
			[
				1712282400,
				180,
				[
					"EEST"
				]
			],
			[
				1729818000,
				120,
				[
					"EET"
				]
			],
			[
				1743732000,
				180,
				[
					"EEST"
				]
			],
			[
				1761872400,
				120,
				[
					"EET"
				]
			],
			[
				1775181600,
				180,
				[
					"EEST"
				]
			],
			[
				1793322000,
				120,
				[
					"EET"
				]
			],
			[
				1806631200,
				180,
				[
					"EEST"
				]
			],
			[
				1824771600,
				120,
				[
					"EET"
				]
			],
			[
				1838685600,
				180,
				[
					"EEST"
				]
			],
			[
				1856221200,
				120,
				[
					"EET"
				]
			],
			[
				1870135200,
				180,
				[
					"EEST"
				]
			],
			[
				1887670800,
				120,
				[
					"EET"
				]
			],
			[
				1901584800,
				180,
				[
					"EEST"
				]
			],
			[
				1919120400,
				120,
				[
					"EET"
				]
			],
			[
				1933034400,
				180,
				[
					"EEST"
				]
			],
			[
				1951174800,
				120,
				[
					"EET"
				]
			],
			[
				1964484000,
				180,
				[
					"EEST"
				]
			],
			[
				1982624400,
				120,
				[
					"EET"
				]
			],
			[
				1995933600,
				180,
				[
					"EEST"
				]
			],
			[
				2014074000,
				120,
				[
					"EET"
				]
			],
			[
				2027988000,
				180,
				[
					"EEST"
				]
			],
			[
				2045523600,
				120,
				[
					"EET"
				]
			],
			[
				2059437600,
				180,
				[
					"EEST"
				]
			],
			[
				2076973200,
				120,
				[
					"EET"
				]
			],
			[
				2090887200,
				180,
				[
					"EEST"
				]
			],
			[
				2109027600,
				120,
				[
					"EET"
				]
			],
			[
				2122336800,
				180,
				[
					"EEST"
				]
			],
			[
				2140477200,
				120,
				[
					"EET"
				]
			]
		],
		"name": "Asia/Damascus"
	},
	{
		"hoverRegion": [
			{
				"points": [
					51.05,
					-4.63,
					51.16,
					-4.78,
					51.31,
					-4.69,
					51.27,
					-4.59,
					51.12,
					-4.55,
					51.11,
					-4.35,
					51.29,
					-4.27,
					51.31,
					-3.54,
					51.5,
					-3.89,
					51.45,
					-4.33,
					51.65,
					-4.44,
					51.49,
					-4.91,
					51.59,
					-5.33,
					51.69,
					-5.41,
					51.85,
					-5.45,
					51.99,
					-5.38,
					52.35,
					-4.27,
					52.49,
					-4.18,
					52.79,
					-4.22,
					52.67,
					-4.49,
					52.64,
					-4.8,
					52.69,
					-4.89,
					52.84,
					-4.85,
					53.07,
					-4.53,
					53.23,
					-4.76,
					53.34,
					-4.81,
					53.54,
					-4.43,
					53.4,
					-3.98,
					53.46,
					-3.28,
					53.68,
					-3.13,
					53.96,
					-3.15,
					53.95,
					-3.26,
					54.47,
					-3.74,
					54.75,
					-3.6,
					54.66,
					-3.95,
					54.73,
					-4.25,
					54.56,
					-4.39,
					54.72,
					-4.78,
					54.54,
					-4.79,
					54.56,
					-4.99,
					54.95,
					-5.29,
					55.14,
					-5.12,
					55.22,
					-5.23,
					55.34,
					-5.19,
					55.42,
					-5.39,
					55.17,
					-5.53,
					55.19,
					-5.82,
					55.28,
					-5.9,
					55.56,
					-5.83,
					55.68,
					-5.88,
					55.51,
					-6.1,
					55.47,
					-6.29,
					55.6,
					-6.59,
					55.88,
					-6.56,
					56.02,
					-6.35,
					56.16,
					-6.32,
					56.25,
					-6.53,
					56.48,
					-6.54,
					56.33,
					-6.9,
					56.51,
					-7.1,
					56.61,
					-7.03,
					56.79,
					-6.47,
					56.71,
					-6.34,
					56.84,
					-6.39,
					57.02,
					-6.71,
					57.12,
					-6.68,
					57.16,
					-6.46,
					57.22,
					-6.5,
					57.4,
					-6.89,
					57.68,
					-6.72,
					57.78,
					-6.39,
					57.83,
					-6.46,
					57.66,
					-6.93,
					57.05,
					-7.11,
					56.67,
					-7.61,
					56.81,
					-7.77,
					57.09,
					-7.59,
					57.12,
					-7.49,
					57.4,
					-7.61,
					57.42,
					-7.72,
					57.54,
					-7.78,
					57.88,
					-7.24,
					58.25,
					-7.18,
					58.6,
					-6.21,
					58.54,
					-6.12,
					58.26,
					-6.04,
					57.97,
					-6.25,
					57.81,
					-6.27,
					57.65,
					-6.05,
					57.68,
					-5.92,
					57.93,
					-5.89,
					58.06,
					-5.56,
					58.18,
					-5.44,
					58.34,
					-5.45,
					58.37,
					-5.31,
					58.72,
					-5.06,
					58.62,
					-4.4,
					58.71,
					-4.02,
					58.7,
					-3.5,
					58.75,
					-3.44,
					58.85,
					-3.54,
					59.14,
					-3.46,
					59.28,
					-3.16,
					59.41,
					-3.14,
					59.49,
					-2.85,
					59.35,
					-2.71,
					59.49,
					-2.34,
					59.26,
					-2.29,
					59.13,
					-2.44,
					58.84,
					-2.57,
					58.62,
					-2.92,
					58.53,
					-2.98,
					58.4,
					-2.95,
					58.22,
					-3.14,
					57.95,
					-3.74,
					57.85,
					-3.67,
					57.75,
					-3.74,
					57.83,
					-3.3,
					57.77,
					-3.02,
					57.81,
					-2.01,
					57.68,
					-1.74,
					57.42,
					-1.67,
					57.19,
					-1.94,
					56.79,
					-2.16,
					56.67,
					-2.35,
					56.48,
					-2.48,
					56.42,
					-2.64,
					56.22,
					-2.45,
					56.12,
					-2.47,
					56.02,
					-2.11,
					55.82,
					-1.89,
					55.76,
					-1.7,
					55.56,
					-1.51,
					55.19,
					-1.41,
					54.74,
					-1.1,
					54.58,
					-0.54,
					54.33,
					-0.3,
					54.19,
					0,
					54.08,
					0.01,
					54.01,
					-0.08,
					53.66,
					0.23,
					53.21,
					0.46,
					53.03,
					0.42,
					52.93,
					0.27,
					53.08,
					0.54,
					53.03,
					1.35,
					52.8,
					1.77,
					52.44,
					1.85,
					52.01,
					1.65,
					51.87,
					1.36,
					51.72,
					1.28,
					51.68,
					1.03,
					51.46,
					0.99,
					51.49,
					1.45,
					51.38,
					1.52,
					51.08,
					1.46,
					50.95,
					1.1,
					50.8,
					0.99,
					50.82,
					0.78,
					50.63,
					0.23,
					50.72,
					-0.24,
					50.61,
					-0.77,
					50.67,
					-0.97,
					50.47,
					-1.23,
					50.62,
					-1.72,
					50.47,
					-2.04,
					50.51,
					-2.35,
					50.4,
					-2.45,
					50.62,
					-2.91,
					50.51,
					-3.36,
					50.29,
					-3.42,
					50.09,
					-3.69,
					50.25,
					-4.16,
					50.23,
					-4.65,
					49.85,
					-5.15,
					49.99,
					-5.47,
					49.98,
					-5.79,
					50.24,
					-5.75,
					50.3,
					-5.47,
					50.43,
					-5.23,
					50.64,
					-5.1,
					50.7,
					-4.84,
					50.84,
					-4.66,
					51.05,
					-4.63
				]
			},
			{
				"points": [
					51.64,
					-10.3,
					51.73,
					-10.43,
					51.98,
					-10.48,
					51.97,
					-10.69,
					52.17,
					-10.68,
					52.42,
					-10.04,
					52.62,
					-10.02,
					52.81,
					-9.64,
					52.91,
					-9.57,
					53.05,
					-9.9,
					53.23,
					-9.91,
					53.33,
					-10.27,
					53.48,
					-10.25,
					53.56,
					-10.39,
					53.7,
					-10.35,
					53.82,
					-10.15,
					53.96,
					-10.36,
					54.21,
					-10.3,
					54.34,
					-10.16,
					54.45,
					-9.78,
					54.44,
					-9.33,
					54.34,
					-9.15,
					54.4,
					-9.04,
					54.38,
					-8.78,
					54.54,
					-8.68,
					54.56,
					-8.84,
					54.7,
					-8.88,
					54.82,
					-8.81,
					54.9,
					-8.58,
					55.08,
					-8.64,
					55.2,
					-8.38,
					55.35,
					-8.32,
					55.36,
					-7.59,
					55.54,
					-7.24,
					55.28,
					-6.82,
					55.4,
					-6.14,
					55.27,
					-5.98,
					55.05,
					-5.89,
					54.74,
					-5.44,
					54.46,
					-5.32,
					54.21,
					-5.48,
					54.13,
					-5.78,
					54,
					-5.85,
					53.87,
					-6.13,
					53.73,
					-6.13,
					53.51,
					-5.89,
					53.29,
					-5.98,
					52.94,
					-5.89,
					52.63,
					-6.1,
					52.1,
					-6.27,
					52.08,
					-6.49,
					51.99,
					-6.6,
					52.1,
					-6.77,
					52.01,
					-6.9,
					51.99,
					-7.44,
					51.88,
					-7.55,
					51.69,
					-8.23,
					51.5,
					-8.51,
					51.48,
					-8.85,
					51.31,
					-9.48,
					51.36,
					-9.83,
					51.52,
					-9.96,
					51.47,
					-10.25,
					51.55,
					-10.33,
					51.64,
					-10.3
				]
			},
			{
				"points": [
					41.99,
					-7.99,
					42.01,
					-7.68,
					41.92,
					-7.41,
					42.09,
					-7.15,
					42.07,
					-6.53,
					41.78,
					-6.42,
					41.74,
					-6.21,
					41.54,
					-6.07,
					40.95,
					-6.74,
					40.35,
					-6.66,
					40.17,
					-6.86,
					39.97,
					-6.76,
					39.6,
					-6.92,
					39.56,
					-7.25,
					39.28,
					-7.14,
					39.06,
					-6.85,
					38.79,
					-6.94,
					38.65,
					-7.15,
					38.47,
					-7.19,
					38.29,
					-7.03,
					38.3,
					-6.89,
					38.21,
					-6.82,
					37.95,
					-6.91,
					37.88,
					-7.18,
					37.53,
					-7.39,
					37.12,
					-7.3,
					36.85,
					-7.88,
					36.97,
					-8.19,
					37.01,
					-8.6,
					36.91,
					-9.01,
					37.01,
					-9.09,
					37.52,
					-8.89,
					37.83,
					-8.9,
					37.96,
					-8.99,
					38.3,
					-8.89,
					38.37,
					-8.95,
					38.31,
					-9.26,
					38.58,
					-9.32,
					38.62,
					-9.55,
					38.78,
					-9.6,
					39.24,
					-9.45,
					39.37,
					-9.51,
					39.65,
					-9.16,
					40.96,
					-8.76,
					41.88,
					-8.97,
					42.15,
					-8.65,
					42.25,
					-8.22,
					42.13,
					-8.01,
					41.99,
					-7.99
				]
			},
			{
				"points": [
					61.41,
					-6.59,
					61.28,
					-6.69,
					61.38,
					-6.92,
					61.61,
					-7.1,
					61.71,
					-7.06,
					61.72,
					-6.92,
					61.88,
					-7.03,
					62.01,
					-7.73,
					62.14,
					-7.78,
					62.41,
					-7.22,
					62.5,
					-6.55,
					62.42,
					-6.19,
					62.32,
					-6.15,
					62.18,
					-6.23,
					61.96,
					-6.51,
					61.54,
					-6.63,
					61.41,
					-6.59
				]
			},
			{
				"points": [
					59.77,
					-1.21,
					59.81,
					-1.47,
					60.16,
					-1.78,
					60.37,
					-1.84,
					60.6,
					-1.66,
					60.92,
					-0.72,
					60.38,
					-0.66,
					60.3,
					-0.84,
					60.07,
					-0.93,
					59.77,
					-1.21
				]
			},
			{
				"points": [
					27.94,
					-14.27,
					28.01,
					-14.56,
					28.14,
					-14.57,
					28.77,
					-14.09,
					28.83,
					-13.97,
					29.03,
					-13.93,
					29.35,
					-13.62,
					29.47,
					-13.6,
					29.5,
					-13.44,
					29.2,
					-13.3,
					28.94,
					-13.37,
					28.74,
					-13.7,
					28.17,
					-13.83,
					27.94,
					-14.27
				]
			}
		],
		"transitions": [
			[
				1319950800,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1332651600,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1351400400,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1364706000,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1382850000,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1396155600,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1414299600,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1427605200,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1445749200,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1459054800,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1477803600,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1490504400,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1509253200,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1521954000,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1540702800,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1554008400,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1572152400,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1585458000,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1603602000,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1616907600,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1635656400,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1648357200,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1667106000,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1679806800,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1698555600,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1711861200,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1730005200,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1743310800,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1761454800,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1774760400,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1792904400,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1806210000,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1824958800,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1837659600,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1856408400,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1869109200,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1887858000,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1901163600,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1919307600,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1932613200,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1950757200,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1964062800,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				1982811600,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				1995512400,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				2014261200,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				2026962000,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				2045710800,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				2058411600,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				2077160400,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				2090466000,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				2108610000,
				0,
				[
					"GMT",
					"WET"
				]
			],
			[
				2121915600,
				60,
				[
					"BST",
					"WEST",
					"IST"
				]
			],
			[
				2140059600,
				0,
				[
					"GMT",
					"WET"
				]
			]
		],
		"name": "Atlantic/Canary"
	},
	{
		"hoverRegion": [
			{
				"points": [
					32.98,
					35.14,
					33.11,
					35.05,
					33.93,
					35.37,
					34.06,
					35.54,
					34.37,
					35.59,
					34.58,
					35.87,
					34.75,
					35.94,
					34.71,
					36.54,
					34.55,
					36.51,
					34.46,
					36.65,
					34.19,
					36.73,
					33.91,
					36.45,
					33.76,
					36.47,
					33.71,
					36.12,
					33.51,
					36.15,
					33.13,
					35.63,
					32.98,
					35.54,
					32.98,
					35.14
				]
			}
		],
		"transitions": [
			[
				1319936400,
				120,
				[
					"EET"
				]
			],
			[
				1332640800,
				180,
				[
					"EEST"
				]
			],
			[
				1351386000,
				120,
				[
					"EET"
				]
			],
			[
				1364695200,
				180,
				[
					"EEST"
				]
			],
			[
				1382835600,
				120,
				[
					"EET"
				]
			],
			[
				1396144800,
				180,
				[
					"EEST"
				]
			],
			[
				1414285200,
				120,
				[
					"EET"
				]
			],
			[
				1427594400,
				180,
				[
					"EEST"
				]
			],
			[
				1445734800,
				120,
				[
					"EET"
				]
			],
			[
				1459044000,
				180,
				[
					"EEST"
				]
			],
			[
				1477789200,
				120,
				[
					"EET"
				]
			],
			[
				1490493600,
				180,
				[
					"EEST"
				]
			],
			[
				1509238800,
				120,
				[
					"EET"
				]
			],
			[
				1521943200,
				180,
				[
					"EEST"
				]
			],
			[
				1540688400,
				120,
				[
					"EET"
				]
			],
			[
				1553997600,
				180,
				[
					"EEST"
				]
			],
			[
				1572138000,
				120,
				[
					"EET"
				]
			],
			[
				1585447200,
				180,
				[
					"EEST"
				]
			],
			[
				1603587600,
				120,
				[
					"EET"
				]
			],
			[
				1616896800,
				180,
				[
					"EEST"
				]
			],
			[
				1635642000,
				120,
				[
					"EET"
				]
			],
			[
				1648346400,
				180,
				[
					"EEST"
				]
			],
			[
				1667091600,
				120,
				[
					"EET"
				]
			],
			[
				1679796000,
				180,
				[
					"EEST"
				]
			],
			[
				1698541200,
				120,
				[
					"EET"
				]
			],
			[
				1711850400,
				180,
				[
					"EEST"
				]
			],
			[
				1729990800,
				120,
				[
					"EET"
				]
			],
			[
				1743300000,
				180,
				[
					"EEST"
				]
			],
			[
				1761440400,
				120,
				[
					"EET"
				]
			],
			[
				1774749600,
				180,
				[
					"EEST"
				]
			],
			[
				1792890000,
				120,
				[
					"EET"
				]
			],
			[
				1806199200,
				180,
				[
					"EEST"
				]
			],
			[
				1824944400,
				120,
				[
					"EET"
				]
			],
			[
				1837648800,
				180,
				[
					"EEST"
				]
			],
			[
				1856394000,
				120,
				[
					"EET"
				]
			],
			[
				1869098400,
				180,
				[
					"EEST"
				]
			],
			[
				1887843600,
				120,
				[
					"EET"
				]
			],
			[
				1901152800,
				180,
				[
					"EEST"
				]
			],
			[
				1919293200,
				120,
				[
					"EET"
				]
			],
			[
				1932602400,
				180,
				[
					"EEST"
				]
			],
			[
				1950742800,
				120,
				[
					"EET"
				]
			],
			[
				1964052000,
				180,
				[
					"EEST"
				]
			],
			[
				1982797200,
				120,
				[
					"EET"
				]
			],
			[
				1995501600,
				180,
				[
					"EEST"
				]
			],
			[
				2014246800,
				120,
				[
					"EET"
				]
			],
			[
				2026951200,
				180,
				[
					"EEST"
				]
			],
			[
				2045696400,
				120,
				[
					"EET"
				]
			],
			[
				2058400800,
				180,
				[
					"EEST"
				]
			],
			[
				2077146000,
				120,
				[
					"EET"
				]
			],
			[
				2090455200,
				180,
				[
					"EEST"
				]
			],
			[
				2108595600,
				120,
				[
					"EET"
				]
			],
			[
				2121904800,
				180,
				[
					"EEST"
				]
			],
			[
				2140045200,
				120,
				[
					"EET"
				]
			]
		],
		"name": "Asia/Beirut"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-27.3,
					-109.39,
					-27.23,
					-109.53,
					-26.99,
					-109.48,
					-27.01,
					-109.16,
					-27.2,
					-109.16,
					-27.3,
					-109.39
				]
			}
		],
		"transitions": [
			[
				1313913600,
				-300,
				[
					"EASST"
				]
			],
			[
				1331449200,
				-360,
				[
					"EAST"
				]
			],
			[
				1350201600,
				-300,
				[
					"EASST"
				]
			],
			[
				1362898800,
				-360,
				[
					"EAST"
				]
			],
			[
				1381651200,
				-300,
				[
					"EASST"
				]
			],
			[
				1394348400,
				-360,
				[
					"EAST"
				]
			],
			[
				1413100800,
				-300,
				[
					"EASST"
				]
			],
			[
				1426402800,
				-360,
				[
					"EAST"
				]
			],
			[
				1444550400,
				-300,
				[
					"EASST"
				]
			],
			[
				1457852400,
				-360,
				[
					"EAST"
				]
			],
			[
				1476000000,
				-300,
				[
					"EASST"
				]
			],
			[
				1489302000,
				-360,
				[
					"EAST"
				]
			],
			[
				1508054400,
				-300,
				[
					"EASST"
				]
			],
			[
				1520751600,
				-360,
				[
					"EAST"
				]
			],
			[
				1539504000,
				-300,
				[
					"EASST"
				]
			],
			[
				1552201200,
				-360,
				[
					"EAST"
				]
			],
			[
				1570953600,
				-300,
				[
					"EASST"
				]
			],
			[
				1584255600,
				-360,
				[
					"EAST"
				]
			],
			[
				1602403200,
				-300,
				[
					"EASST"
				]
			],
			[
				1615705200,
				-360,
				[
					"EAST"
				]
			],
			[
				1633852800,
				-300,
				[
					"EASST"
				]
			],
			[
				1647154800,
				-360,
				[
					"EAST"
				]
			],
			[
				1665302400,
				-300,
				[
					"EASST"
				]
			],
			[
				1678604400,
				-360,
				[
					"EAST"
				]
			],
			[
				1697356800,
				-300,
				[
					"EASST"
				]
			],
			[
				1710054000,
				-360,
				[
					"EAST"
				]
			],
			[
				1728806400,
				-300,
				[
					"EASST"
				]
			],
			[
				1741503600,
				-360,
				[
					"EAST"
				]
			],
			[
				1760256000,
				-300,
				[
					"EASST"
				]
			],
			[
				1773558000,
				-360,
				[
					"EAST"
				]
			],
			[
				1791705600,
				-300,
				[
					"EASST"
				]
			],
			[
				1805007600,
				-360,
				[
					"EAST"
				]
			],
			[
				1823155200,
				-300,
				[
					"EASST"
				]
			],
			[
				1836457200,
				-360,
				[
					"EAST"
				]
			],
			[
				1855209600,
				-300,
				[
					"EASST"
				]
			],
			[
				1867906800,
				-360,
				[
					"EAST"
				]
			],
			[
				1886659200,
				-300,
				[
					"EASST"
				]
			],
			[
				1899356400,
				-360,
				[
					"EAST"
				]
			],
			[
				1918108800,
				-300,
				[
					"EASST"
				]
			],
			[
				1930806000,
				-360,
				[
					"EAST"
				]
			],
			[
				1949558400,
				-300,
				[
					"EASST"
				]
			],
			[
				1962860400,
				-360,
				[
					"EAST"
				]
			],
			[
				1981008000,
				-300,
				[
					"EASST"
				]
			],
			[
				1994310000,
				-360,
				[
					"EAST"
				]
			],
			[
				2012457600,
				-300,
				[
					"EASST"
				]
			],
			[
				2025759600,
				-360,
				[
					"EAST"
				]
			],
			[
				2044512000,
				-300,
				[
					"EASST"
				]
			],
			[
				2057209200,
				-360,
				[
					"EAST"
				]
			],
			[
				2075961600,
				-300,
				[
					"EASST"
				]
			],
			[
				2088658800,
				-360,
				[
					"EAST"
				]
			],
			[
				2107411200,
				-300,
				[
					"EASST"
				]
			],
			[
				2120713200,
				-360,
				[
					"EAST"
				]
			],
			[
				2138860800,
				-300,
				[
					"EASST"
				]
			]
		],
		"name": "Pacific/Easter"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-9.99,
					-138.69,
					-10.12,
					-138.74,
					-10.09,
					-138.89,
					-9.98,
					-138.93,
					-10.12,
					-139.13,
					-9.97,
					-139.23,
					-9.86,
					-139.18,
					-9.7,
					-139.24,
					-9.58,
					-138.99,
					-9.66,
					-138.73,
					-9.76,
					-138.69,
					-9.85,
					-138.78,
					-9.99,
					-138.69
				]
			},
			{
				"points": [
					-9.08,
					-140.14,
					-9.02,
					-140.25,
					-8.77,
					-140.31,
					-8.71,
					-139.94,
					-8.99,
					-139.89,
					-9.08,
					-140.14
				]
			},
			{
				"points": [
					-8.12,
					-140.61,
					-8.12,
					-140.77,
					-7.92,
					-140.8,
					-7.73,
					-140.32,
					-7.93,
					-140.29,
					-7.94,
					-140.45,
					-8.12,
					-140.61
				]
			},
			{
				"points": [
					-9.51,
					-139.92,
					-9.58,
					-140.05,
					-9.46,
					-140.21,
					-9.25,
					-140.15,
					-9.3,
					-139.91,
					-9.51,
					-139.92
				]
			}
		],
		"transitions": [
			[
				0,
				-570,
				[
					"MART"
				]
			]
		],
		"name": "Pacific/Marquesas"
	},
	{
		"hoverRegion": [
			{
				"points": [
					40.13,
					49.63,
					39.92,
					49.75,
					39.84,
					49.54,
					39.49,
					49.41,
					39.24,
					49.54,
					39.17,
					49.46,
					39.19,
					49.34,
					38.96,
					49.29,
					38.85,
					49.16,
					38.8,
					48.94,
					38.34,
					48.94,
					38.3,
					48.59,
					38.77,
					47.93,
					38.99,
					47.94,
					39.06,
					48.16,
					39.23,
					48.02,
					39.39,
					48.17,
					39.56,
					47.96,
					39.36,
					47.43,
					38.76,
					46.51,
					39.16,
					46.33,
					39.27,
					46.38,
					39.38,
					46.28,
					39.51,
					46.32,
					39.48,
					46.13,
					39.94,
					45.49,
					40.08,
					45.53,
					40.17,
					45.83,
					40.43,
					45.35,
					40.66,
					45.24,
					40.88,
					45.42,
					40.85,
					45.2,
					40.98,
					44.92,
					41.32,
					44.89,
					41.57,
					45.33,
					41.47,
					45.74,
					41.34,
					45.82,
					41.29,
					45.96,
					41.18,
					46.54,
					41.24,
					46.57,
					41.4,
					46.28,
					41.63,
					46.13,
					41.97,
					46.33,
					42.01,
					46.43,
					41.92,
					46.58,
					41.95,
					46.8,
					41.67,
					47.05,
					41.66,
					47.18,
					41.41,
					47.34,
					41.3,
					47.76,
					41.57,
					47.97,
					41.69,
					48.31,
					41.97,
					48.47,
					41.98,
					48.57,
					41.44,
					49.14,
					41.1,
					49.28,
					40.87,
					49.6,
					40.73,
					49.63,
					40.7,
					50.07,
					40.36,
					50.7,
					40.23,
					50.68,
					40.21,
					50.46,
					40.08,
					50.37,
					40.24,
					50.16,
					40.17,
					50,
					40.23,
					49.82,
					40.13,
					49.63
				]
			},
			{
				"points": [
					38.85,
					46.24,
					38.73,
					46.12,
					38.9,
					45.37,
					39.13,
					45.07,
					39.64,
					44.68,
					39.75,
					44.67,
					39.89,
					45.1,
					39.67,
					45.84,
					39.32,
					46.1,
					38.85,
					46.24
				]
			}
		],
		"transitions": [
			[
				1319947200,
				240,
				[
					"AZT"
				]
			],
			[
				1332648000,
				300,
				[
					"AZST"
				]
			],
			[
				1351396800,
				240,
				[
					"AZT"
				]
			],
			[
				1364702400,
				300,
				[
					"AZST"
				]
			],
			[
				1382846400,
				240,
				[
					"AZT"
				]
			],
			[
				1396152000,
				300,
				[
					"AZST"
				]
			],
			[
				1414296000,
				240,
				[
					"AZT"
				]
			],
			[
				1427601600,
				300,
				[
					"AZST"
				]
			],
			[
				1445745600,
				240,
				[
					"AZT"
				]
			],
			[
				1459051200,
				300,
				[
					"AZST"
				]
			],
			[
				1477800000,
				240,
				[
					"AZT"
				]
			],
			[
				1490500800,
				300,
				[
					"AZST"
				]
			],
			[
				1509249600,
				240,
				[
					"AZT"
				]
			],
			[
				1521950400,
				300,
				[
					"AZST"
				]
			],
			[
				1540699200,
				240,
				[
					"AZT"
				]
			],
			[
				1554004800,
				300,
				[
					"AZST"
				]
			],
			[
				1572148800,
				240,
				[
					"AZT"
				]
			],
			[
				1585454400,
				300,
				[
					"AZST"
				]
			],
			[
				1603598400,
				240,
				[
					"AZT"
				]
			],
			[
				1616904000,
				300,
				[
					"AZST"
				]
			],
			[
				1635652800,
				240,
				[
					"AZT"
				]
			],
			[
				1648353600,
				300,
				[
					"AZST"
				]
			],
			[
				1667102400,
				240,
				[
					"AZT"
				]
			],
			[
				1679803200,
				300,
				[
					"AZST"
				]
			],
			[
				1698552000,
				240,
				[
					"AZT"
				]
			],
			[
				1711857600,
				300,
				[
					"AZST"
				]
			],
			[
				1730001600,
				240,
				[
					"AZT"
				]
			],
			[
				1743307200,
				300,
				[
					"AZST"
				]
			],
			[
				1761451200,
				240,
				[
					"AZT"
				]
			],
			[
				1774756800,
				300,
				[
					"AZST"
				]
			],
			[
				1792900800,
				240,
				[
					"AZT"
				]
			],
			[
				1806206400,
				300,
				[
					"AZST"
				]
			],
			[
				1824955200,
				240,
				[
					"AZT"
				]
			],
			[
				1837656000,
				300,
				[
					"AZST"
				]
			],
			[
				1856404800,
				240,
				[
					"AZT"
				]
			],
			[
				1869105600,
				300,
				[
					"AZST"
				]
			],
			[
				1887854400,
				240,
				[
					"AZT"
				]
			],
			[
				1901160000,
				300,
				[
					"AZST"
				]
			],
			[
				1919304000,
				240,
				[
					"AZT"
				]
			],
			[
				1932609600,
				300,
				[
					"AZST"
				]
			],
			[
				1950753600,
				240,
				[
					"AZT"
				]
			],
			[
				1964059200,
				300,
				[
					"AZST"
				]
			],
			[
				1982808000,
				240,
				[
					"AZT"
				]
			],
			[
				1995508800,
				300,
				[
					"AZST"
				]
			],
			[
				2014257600,
				240,
				[
					"AZT"
				]
			],
			[
				2026958400,
				300,
				[
					"AZST"
				]
			],
			[
				2045707200,
				240,
				[
					"AZT"
				]
			],
			[
				2058408000,
				300,
				[
					"AZST"
				]
			],
			[
				2077156800,
				240,
				[
					"AZT"
				]
			],
			[
				2090462400,
				300,
				[
					"AZST"
				]
			],
			[
				2108606400,
				240,
				[
					"AZT"
				]
			],
			[
				2121912000,
				300,
				[
					"AZST"
				]
			],
			[
				2140056000,
				240,
				[
					"AZT"
				]
			]
		],
		"name": "Asia/Baku"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-53.14,
					-74.44,
					-53,
					-74.71,
					-52.77,
					-74.85,
					-52.61,
					-74.7,
					-52.66,
					-74.54,
					-52.35,
					-75.02,
					-51.84,
					-75.23,
					-51.73,
					-75.2,
					-51.65,
					-75.42,
					-50.89,
					-75.09,
					-50.84,
					-75.22,
					-50.91,
					-75.36,
					-50.71,
					-75.62,
					-49.96,
					-75.48,
					-49.86,
					-75.67,
					-49.63,
					-75.7,
					-49.54,
					-75.6,
					-49.43,
					-75.68,
					-49.34,
					-75.65,
					-49.27,
					-75.79,
					-49.04,
					-75.82,
					-48.95,
					-75.75,
					-48.47,
					-75.77,
					-48.26,
					-75.64,
					-48.05,
					-75.68,
					-47.94,
					-75.59,
					-47.91,
					-75.36,
					-47.86,
					-75.47,
					-47.68,
					-75.49,
					-47.54,
					-75.18,
					-47.59,
					-74.87,
					-47.47,
					-74.79,
					-47.5,
					-74.67,
					-47.26,
					-74.51,
					-47.06,
					-74.58,
					-46.93,
					-74.74,
					-46.82,
					-75.07,
					-47.02,
					-75.32,
					-47.04,
					-75.58,
					-46.72,
					-75.8,
					-46.47,
					-75.69,
					-46.38,
					-75.41,
					-46.15,
					-75.16,
					-45.83,
					-75.18,
					-45.69,
					-75.02,
					-45.55,
					-75.02,
					-45.45,
					-74.85,
					-45.53,
					-74.68,
					-45.43,
					-74.62,
					-45.23,
					-74.75,
					-45.1,
					-74.61,
					-44.94,
					-74.75,
					-44.84,
					-74.68,
					-44.86,
					-74.57,
					-44.77,
					-74.83,
					-44.59,
					-74.92,
					-44.5,
					-74.89,
					-44.44,
					-74.8,
					-44.51,
					-74.65,
					-43.95,
					-74.39,
					-43.75,
					-74.19,
					-43.67,
					-73.81,
					-44.02,
					-73.39,
					-43.84,
					-73.32,
					-43.78,
					-73.14,
					-43.28,
					-73.17,
					-43.16,
					-72.97,
					-42.91,
					-72.92,
					-42.73,
					-73.4,
					-43.06,
					-73.22,
					-43.11,
					-73.34,
					-43.5,
					-73.64,
					-43.48,
					-74.09,
					-43.58,
					-74.23,
					-43.24,
					-74.52,
					-42.83,
					-74.27,
					-42.52,
					-74.31,
					-41.9,
					-74.12,
					-41.77,
					-74.16,
					-41.65,
					-73.88,
					-40.95,
					-74.05,
					-40.5,
					-73.83,
					-39.97,
					-73.81,
					-39.75,
					-73.51,
					-39.35,
					-73.32,
					-38.68,
					-73.59,
					-38.4,
					-73.64,
					-38.12,
					-73.56,
					-37.73,
					-73.77,
					-37.48,
					-73.71,
					-37.32,
					-73.79,
					-36.86,
					-73.56,
					-36.98,
					-73.37,
					-37.12,
					-73.37,
					-37.07,
					-73.27,
					-36.72,
					-73.31,
					-36.23,
					-72.91,
					-35.92,
					-72.88,
					-35.74,
					-72.69,
					-35.51,
					-72.72,
					-35.15,
					-72.47,
					-35.01,
					-72.28,
					-34.32,
					-72.08,
					-34.09,
					-72.11,
					-33.55,
					-71.74,
					-33.06,
					-71.86,
					-32.93,
					-71.65,
					-32.41,
					-71.52,
					-32.21,
					-71.65,
					-31.77,
					-71.61,
					-31.15,
					-71.78,
					-30.57,
					-71.82,
					-30.2,
					-71.74,
					-30.13,
					-71.5,
					-29.97,
					-71.52,
					-29.86,
					-71.41,
					-29.46,
					-71.42,
					-29.35,
					-71.62,
					-29.15,
					-71.61,
					-29.02,
					-71.7,
					-28.32,
					-71.27,
					-28.07,
					-71.28,
					-27.63,
					-71.14,
					-27.55,
					-71.02,
					-27.13,
					-71.07,
					-26.96,
					-70.91,
					-26.83,
					-70.93,
					-26.33,
					-70.74,
					-26.14,
					-70.8,
					-26,
					-70.75,
					-25.82,
					-70.84,
					-25.5,
					-70.75,
					-25.32,
					-70.56,
					-24.53,
					-70.68,
					-23.84,
					-70.62,
					-23.61,
					-70.51,
					-23.54,
					-70.72,
					-23.23,
					-70.7,
					-22.99,
					-70.64,
					-22.87,
					-70.39,
					-21.88,
					-70.3,
					-21.43,
					-70.17,
					-20.83,
					-70.31,
					-19.99,
					-70.23,
					-18.81,
					-70.46,
					-18.47,
					-70.41,
					-18.33,
					-70.48,
					-18.15,
					-70.01,
					-17.95,
					-69.86,
					-17.57,
					-69.88,
					-17.39,
					-69.45,
					-17.87,
					-69.2,
					-18.04,
					-68.96,
					-18.16,
					-69,
					-18.92,
					-68.81,
					-19.35,
					-68.3,
					-19.71,
					-68.52,
					-19.82,
					-68.42,
					-20.08,
					-68.46,
					-20.16,
					-68.62,
					-20.39,
					-68.58,
					-20.58,
					-68.34,
					-20.8,
					-68.43,
					-20.87,
					-68.3,
					-21.23,
					-68.07,
					-21.56,
					-68.06,
					-22.06,
					-67.83,
					-22.74,
					-67.75,
					-22.78,
					-67.57,
					-22.69,
					-67.16,
					-22.99,
					-66.87,
					-24.11,
					-67.25,
					-24.56,
					-68.31,
					-24.74,
					-68.43,
					-25.08,
					-68.22,
					-25.19,
					-68.4,
					-25.4,
					-68.48,
					-26.2,
					-68.28,
					-26.36,
					-68.46,
					-26.47,
					-68.47,
					-26.95,
					-68.17,
					-27.12,
					-68.24,
					-27.16,
					-68.41,
					-27.29,
					-68.51,
					-27.2,
					-68.69,
					-27.68,
					-68.95,
					-27.95,
					-69.01,
					-28.45,
					-69.53,
					-29.16,
					-69.69,
					-29.32,
					-69.89,
					-29.65,
					-69.77,
					-30.04,
					-69.82,
					-30.21,
					-69.7,
					-30.46,
					-69.89,
					-30.49,
					-70.02,
					-30.9,
					-70.18,
					-31.05,
					-70.16,
					-31.27,
					-70.41,
					-31.54,
					-70.44,
					-31.77,
					-70.35,
					-31.93,
					-70.09,
					-32.03,
					-70.12,
					-32.1,
					-70.24,
					-32.44,
					-70.03,
					-32.69,
					-70.03,
					-32.86,
					-69.89,
					-33.14,
					-69.95,
					-33.13,
					-69.82,
					-33.37,
					-69.64,
					-33.69,
					-69.77,
					-34.24,
					-69.7,
					-34.36,
					-69.91,
					-34.75,
					-70.16,
					-35.17,
					-70.25,
					-35.26,
					-70.35,
					-35.78,
					-70.21,
					-35.94,
					-70.31,
					-36.19,
					-70.31,
					-36.23,
					-70.53,
					-36.49,
					-70.62,
					-36.5,
					-70.82,
					-36.82,
					-71.05,
					-37.11,
					-70.98,
					-37.3,
					-71.08,
					-37.46,
					-71,
					-37.67,
					-71.08,
					-38.05,
					-70.89,
					-38.36,
					-70.89,
					-38.59,
					-70.72,
					-38.83,
					-70.88,
					-38.99,
					-71.3,
					-39.3,
					-71.27,
					-39.51,
					-71.4,
					-39.64,
					-71.38,
					-39.71,
					-71.59,
					-39.94,
					-71.48,
					-40.18,
					-71.59,
					-40.2,
					-71.67,
					-40.4,
					-71.55,
					-40.76,
					-71.81,
					-41.05,
					-71.71,
					-41.35,
					-71.79,
					-42.11,
					-71.61,
					-42.2,
					-71.67,
					-42.27,
					-71.98,
					-42.48,
					-71.91,
					-42.63,
					-72.01,
					-42.87,
					-72,
					-43.17,
					-71.62,
					-43.36,
					-71.63,
					-43.42,
					-71.76,
					-43.63,
					-71.47,
					-43.82,
					-71.6,
					-43.95,
					-71.54,
					-44.13,
					-71.71,
					-44.28,
					-71.69,
					-44.32,
					-71.18,
					-44.54,
					-71,
					-44.9,
					-71.24,
					-44.85,
					-71.65,
					-44.9,
					-71.47,
					-45.26,
					-71.19,
					-45.6,
					-71.42,
					-45.64,
					-71.63,
					-45.79,
					-71.63,
					-45.97,
					-71.48,
					-46.14,
					-71.67,
					-46.72,
					-71.54,
					-46.87,
					-71.81,
					-47.28,
					-71.76,
					-47.32,
					-71.96,
					-47.5,
					-72.08,
					-47.53,
					-72.19,
					-47.67,
					-72.18,
					-47.8,
					-72.38,
					-47.87,
					-72.4,
					-48.01,
					-72.24,
					-48.35,
					-72.17,
					-48.59,
					-72.47,
					-48.86,
					-72.46,
					-49.03,
					-72.86,
					-49.23,
					-73.04,
					-49.27,
					-73.36,
					-49.59,
					-73.42,
					-49.8,
					-73.32,
					-50.23,
					-73.44,
					-50.61,
					-73.03,
					-50.5,
					-72.73,
					-50.58,
					-72.19,
					-50.86,
					-72.12,
					-51.13,
					-72.22,
					-51.26,
					-72.15,
					-51.53,
					-72.29,
					-51.86,
					-71.84,
					-51.88,
					-70.01,
					-52.29,
					-68.35,
					-52.4,
					-68.31,
					-52.47,
					-68.39,
					-52.3,
					-69.2,
					-52.36,
					-69.38,
					-52.57,
					-69.11,
					-52.43,
					-68.78,
					-52.62,
					-68.5,
					-54.81,
					-68.5,
					-54.81,
					-67.28,
					-54.95,
					-66.74,
					-55.12,
					-66.69,
					-55.09,
					-66.37,
					-55.21,
					-66.31,
					-55.37,
					-66.44,
					-55.43,
					-66.73,
					-55.45,
					-67.02,
					-55.36,
					-67.12,
					-55.42,
					-67.23,
					-55.34,
					-67.52,
					-55.38,
					-67.6,
					-55.48,
					-67.26,
					-55.72,
					-66.98,
					-55.96,
					-66.93,
					-56.04,
					-67.01,
					-56.08,
					-67.26,
					-55.97,
					-67.46,
					-56,
					-67.63,
					-55.9,
					-67.91,
					-55.78,
					-67.94,
					-55.82,
					-68.1,
					-55.64,
					-68.38,
					-55.73,
					-69.08,
					-55.65,
					-69.34,
					-55.78,
					-69.29,
					-55.86,
					-69.43,
					-55.75,
					-69.56,
					-55.61,
					-69.44,
					-55.55,
					-69.5,
					-55.59,
					-69.67,
					-55.45,
					-69.89,
					-55.43,
					-70.14,
					-55.25,
					-70.28,
					-55.31,
					-70.44,
					-55.26,
					-70.93,
					-55.11,
					-71.11,
					-55.01,
					-71.52,
					-54.87,
					-71.54,
					-54.84,
					-72.05,
					-54.7,
					-72.19,
					-54.56,
					-72.22,
					-54.52,
					-72.51,
					-54.32,
					-72.88,
					-54.26,
					-73.3,
					-54.15,
					-73.53,
					-54.05,
					-73.58,
					-53.85,
					-73.5,
					-53.78,
					-73.81,
					-53.61,
					-74.01,
					-53.33,
					-73.98,
					-53.44,
					-74.23,
					-53.14,
					-74.44
				]
			},
			{
				"points": [
					-43.79,
					-74.72,
					-43.78,
					-74.81,
					-43.58,
					-74.94,
					-43.41,
					-74.76,
					-43.59,
					-74.44,
					-43.7,
					-74.47,
					-43.79,
					-74.72
				]
			},
			{
				"points": [
					-33.81,
					-78.98,
					-33.7,
					-79.1,
					-33.49,
					-78.96,
					-33.58,
					-78.68,
					-33.73,
					-78.69,
					-33.81,
					-78.98
				]
			},
			{
				"points": [
					-45,
					-74.99,
					-45.02,
					-75.12,
					-44.88,
					-75.24,
					-44.68,
					-75.16,
					-44.8,
					-74.91,
					-45,
					-74.99
				]
			}
		],
		"transitions": [
			[
				1313913600,
				-180,
				[
					"CLST"
				]
			],
			[
				1331449200,
				-240,
				[
					"CLT"
				]
			],
			[
				1350201600,
				-180,
				[
					"CLST"
				]
			],
			[
				1362898800,
				-240,
				[
					"CLT"
				]
			],
			[
				1381651200,
				-180,
				[
					"CLST"
				]
			],
			[
				1394348400,
				-240,
				[
					"CLT"
				]
			],
			[
				1413100800,
				-180,
				[
					"CLST"
				]
			],
			[
				1426402800,
				-240,
				[
					"CLT"
				]
			],
			[
				1444550400,
				-180,
				[
					"CLST"
				]
			],
			[
				1457852400,
				-240,
				[
					"CLT"
				]
			],
			[
				1476000000,
				-180,
				[
					"CLST"
				]
			],
			[
				1489302000,
				-240,
				[
					"CLT"
				]
			],
			[
				1508054400,
				-180,
				[
					"CLST"
				]
			],
			[
				1520751600,
				-240,
				[
					"CLT"
				]
			],
			[
				1539504000,
				-180,
				[
					"CLST"
				]
			],
			[
				1552201200,
				-240,
				[
					"CLT"
				]
			],
			[
				1570953600,
				-180,
				[
					"CLST"
				]
			],
			[
				1584255600,
				-240,
				[
					"CLT"
				]
			],
			[
				1602403200,
				-180,
				[
					"CLST"
				]
			],
			[
				1615705200,
				-240,
				[
					"CLT"
				]
			],
			[
				1633852800,
				-180,
				[
					"CLST"
				]
			],
			[
				1647154800,
				-240,
				[
					"CLT"
				]
			],
			[
				1665302400,
				-180,
				[
					"CLST"
				]
			],
			[
				1678604400,
				-240,
				[
					"CLT"
				]
			],
			[
				1697356800,
				-180,
				[
					"CLST"
				]
			],
			[
				1710054000,
				-240,
				[
					"CLT"
				]
			],
			[
				1728806400,
				-180,
				[
					"CLST"
				]
			],
			[
				1741503600,
				-240,
				[
					"CLT"
				]
			],
			[
				1760256000,
				-180,
				[
					"CLST"
				]
			],
			[
				1773558000,
				-240,
				[
					"CLT"
				]
			],
			[
				1791705600,
				-180,
				[
					"CLST"
				]
			],
			[
				1805007600,
				-240,
				[
					"CLT"
				]
			],
			[
				1823155200,
				-180,
				[
					"CLST"
				]
			],
			[
				1836457200,
				-240,
				[
					"CLT"
				]
			],
			[
				1855209600,
				-180,
				[
					"CLST"
				]
			],
			[
				1867906800,
				-240,
				[
					"CLT"
				]
			],
			[
				1886659200,
				-180,
				[
					"CLST"
				]
			],
			[
				1899356400,
				-240,
				[
					"CLT"
				]
			],
			[
				1918108800,
				-180,
				[
					"CLST"
				]
			],
			[
				1930806000,
				-240,
				[
					"CLT"
				]
			],
			[
				1949558400,
				-180,
				[
					"CLST"
				]
			],
			[
				1962860400,
				-240,
				[
					"CLT"
				]
			],
			[
				1981008000,
				-180,
				[
					"CLST"
				]
			],
			[
				1994310000,
				-240,
				[
					"CLT"
				]
			],
			[
				2012457600,
				-180,
				[
					"CLST"
				]
			],
			[
				2025759600,
				-240,
				[
					"CLT"
				]
			],
			[
				2044512000,
				-180,
				[
					"CLST"
				]
			],
			[
				2057209200,
				-240,
				[
					"CLT"
				]
			],
			[
				2075961600,
				-180,
				[
					"CLST"
				]
			],
			[
				2088658800,
				-240,
				[
					"CLT"
				]
			],
			[
				2107411200,
				-180,
				[
					"CLST"
				]
			],
			[
				2120713200,
				-240,
				[
					"CLT"
				]
			],
			[
				2138860800,
				-180,
				[
					"CLST"
				]
			]
		],
		"name": "America/Santiago"
	},
	{
		"hoverRegion": [
			{
				"points": [
					28.5,
					-112.71,
					28,
					-112.66,
					27.89,
					-112.71,
					27.92,
					-114.28,
					28.44,
					-114.16,
					28.56,
					-114.24,
					28.65,
					-114.41,
					29.27,
					-115.01,
					29.33,
					-115.24,
					29.69,
					-115.79,
					29.82,
					-115.8,
					29.91,
					-115.91,
					30.25,
					-115.92,
					30.28,
					-116.07,
					30.44,
					-116.22,
					30.72,
					-116.16,
					30.89,
					-116.42,
					31.18,
					-116.46,
					31.51,
					-116.78,
					31.74,
					-116.75,
					31.79,
					-116.63,
					32.45,
					-116.49,
					32.59,
					-114.73,
					32.49,
					-114.69,
					32.2,
					-114.87,
					31.97,
					-114.87,
					31.69,
					-114.67,
					31.18,
					-114.77,
					30.92,
					-114.59,
					30.5,
					-114.51,
					30.22,
					-114.54,
					30.07,
					-114.3,
					29.88,
					-114.31,
					29.83,
					-114.13,
					29.49,
					-113.7,
					29.63,
					-113.68,
					29.68,
					-113.57,
					29.37,
					-113.12,
					29.01,
					-113.02,
					28.64,
					-112.65,
					28.5,
					-112.71
				]
			},
			{
				"points": [
					28.05,
					-115.06,
					27.93,
					-115.15,
					28.05,
					-115.46,
					28.44,
					-115.34,
					28.43,
					-115.14,
					28.05,
					-115.06
				]
			},
			{
				"points": [
					28.79,
					-118.27,
					28.78,
					-118.42,
					29.1,
					-118.55,
					29.19,
					-118.54,
					29.29,
					-118.39,
					29.26,
					-118.29,
					28.99,
					-118.19,
					28.79,
					-118.27
				]
			},
			{
				"points": [
					28.28,
					-115.42,
					28.18,
					-115.49,
					28.18,
					-115.6,
					28.31,
					-115.7,
					28.4,
					-115.64,
					28.41,
					-115.5,
					28.28,
					-115.42
				]
			}
		],
		"transitions": [
			[
				1319979600,
				-480,
				[
					"PST"
				]
			],
			[
				1333288800,
				-420,
				[
					"PDT"
				]
			],
			[
				1351429200,
				-480,
				[
					"PST"
				]
			],
			[
				1365343200,
				-420,
				[
					"PDT"
				]
			],
			[
				1382878800,
				-480,
				[
					"PST"
				]
			],
			[
				1396792800,
				-420,
				[
					"PDT"
				]
			],
			[
				1414328400,
				-480,
				[
					"PST"
				]
			],
			[
				1428242400,
				-420,
				[
					"PDT"
				]
			],
			[
				1445778000,
				-480,
				[
					"PST"
				]
			],
			[
				1459692000,
				-420,
				[
					"PDT"
				]
			],
			[
				1477832400,
				-480,
				[
					"PST"
				]
			],
			[
				1491141600,
				-420,
				[
					"PDT"
				]
			],
			[
				1509282000,
				-480,
				[
					"PST"
				]
			],
			[
				1522591200,
				-420,
				[
					"PDT"
				]
			],
			[
				1540731600,
				-480,
				[
					"PST"
				]
			],
			[
				1554645600,
				-420,
				[
					"PDT"
				]
			],
			[
				1572181200,
				-480,
				[
					"PST"
				]
			],
			[
				1586095200,
				-420,
				[
					"PDT"
				]
			],
			[
				1603630800,
				-480,
				[
					"PST"
				]
			],
			[
				1617544800,
				-420,
				[
					"PDT"
				]
			],
			[
				1635685200,
				-480,
				[
					"PST"
				]
			],
			[
				1648994400,
				-420,
				[
					"PDT"
				]
			],
			[
				1667134800,
				-480,
				[
					"PST"
				]
			],
			[
				1680444000,
				-420,
				[
					"PDT"
				]
			],
			[
				1698584400,
				-480,
				[
					"PST"
				]
			],
			[
				1712498400,
				-420,
				[
					"PDT"
				]
			],
			[
				1730034000,
				-480,
				[
					"PST"
				]
			],
			[
				1743948000,
				-420,
				[
					"PDT"
				]
			],
			[
				1761483600,
				-480,
				[
					"PST"
				]
			],
			[
				1775397600,
				-420,
				[
					"PDT"
				]
			],
			[
				1792933200,
				-480,
				[
					"PST"
				]
			],
			[
				1806847200,
				-420,
				[
					"PDT"
				]
			],
			[
				1824987600,
				-480,
				[
					"PST"
				]
			],
			[
				1838296800,
				-420,
				[
					"PDT"
				]
			],
			[
				1856437200,
				-480,
				[
					"PST"
				]
			],
			[
				1869746400,
				-420,
				[
					"PDT"
				]
			],
			[
				1887886800,
				-480,
				[
					"PST"
				]
			],
			[
				1901800800,
				-420,
				[
					"PDT"
				]
			],
			[
				1919336400,
				-480,
				[
					"PST"
				]
			],
			[
				1933250400,
				-420,
				[
					"PDT"
				]
			],
			[
				1950786000,
				-480,
				[
					"PST"
				]
			],
			[
				1964700000,
				-420,
				[
					"PDT"
				]
			],
			[
				1982840400,
				-480,
				[
					"PST"
				]
			],
			[
				1996149600,
				-420,
				[
					"PDT"
				]
			],
			[
				2014290000,
				-480,
				[
					"PST"
				]
			],
			[
				2027599200,
				-420,
				[
					"PDT"
				]
			],
			[
				2045739600,
				-480,
				[
					"PST"
				]
			],
			[
				2059048800,
				-420,
				[
					"PDT"
				]
			],
			[
				2077189200,
				-480,
				[
					"PST"
				]
			],
			[
				2091103200,
				-420,
				[
					"PDT"
				]
			],
			[
				2108638800,
				-480,
				[
					"PST"
				]
			],
			[
				2122552800,
				-420,
				[
					"PDT"
				]
			],
			[
				2140088400,
				-480,
				[
					"PST"
				]
			]
		],
		"name": "America/Santa_Isabel"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-27.76,
					-48.4,
					-27.89,
					-48.34,
					-28.04,
					-48.5,
					-28.45,
					-48.54,
					-28.69,
					-48.75,
					-29,
					-49.25,
					-29.53,
					-49.73,
					-30.52,
					-50.21,
					-31.19,
					-50.69,
					-31.62,
					-51.13,
					-32,
					-51.75,
					-32.32,
					-52.13,
					-33.24,
					-52.58,
					-33.85,
					-53.33,
					-33.72,
					-53.62,
					-33.15,
					-53.62,
					-32.76,
					-53.24,
					-32.5,
					-53.67,
					-32.16,
					-53.82,
					-31.75,
					-54.52,
					-31.55,
					-54.65,
					-31.54,
					-54.87,
					-31.39,
					-55.05,
					-31.35,
					-55.29,
					-30.99,
					-55.6,
					-31.18,
					-55.83,
					-31.15,
					-56.07,
					-30.84,
					-56.13,
					-30.2,
					-56.87,
					-30.2,
					-57.02,
					-30.39,
					-57.22,
					-30.38,
					-57.56,
					-30.21,
					-57.72,
					-30.09,
					-57.68,
					-29.92,
					-57.42,
					-29.71,
					-57.32,
					-29.41,
					-56.9,
					-29.03,
					-56.66,
					-28.98,
					-56.5,
					-28.75,
					-56.39,
					-28.54,
					-56.11,
					-28.17,
					-55.85,
					-27.67,
					-55.01,
					-27.44,
					-54.87,
					-27.33,
					-54.34,
					-27.17,
					-54.24,
					-27.05,
					-53.89,
					-26.9,
					-53.79,
					-26.64,
					-53.86,
					-26.28,
					-53.72,
					-26.01,
					-53.93,
					-25.73,
					-53.96,
					-25.71,
					-54.31,
					-25.81,
					-54.44,
					-25.6,
					-54.7,
					-25.43,
					-54.72,
					-25.11,
					-54.54,
					-24.36,
					-54.37,
					-24.07,
					-54.42,
					-23.88,
					-54.17,
					-23.38,
					-54.05,
					-23.22,
					-53.81,
					-22.81,
					-53.65,
					-22.61,
					-53.22,
					-22.38,
					-53.02,
					-22.1,
					-52.53,
					-21.68,
					-52.17,
					-21.5,
					-52.19,
					-21.3,
					-51.97,
					-21.1,
					-51.97,
					-20.82,
					-51.73,
					-20.54,
					-51.67,
					-20.23,
					-51.33,
					-20.15,
					-51.14,
					-19.71,
					-51.13,
					-19.53,
					-51.04,
					-19.38,
					-51.17,
					-19.15,
					-51.87,
					-18.81,
					-52.5,
					-18.75,
					-52.97,
					-18.48,
					-52.91,
					-18.39,
					-53.14,
					-18.07,
					-53.15,
					-17.53,
					-53.33,
					-17.27,
					-53.31,
					-16.8,
					-53.1,
					-16.59,
					-52.8,
					-16.26,
					-52.65,
					-16.2,
					-52.54,
					-16.02,
					-52.52,
					-15.78,
					-52.29,
					-15.7,
					-51.95,
					-15.08,
					-51.7,
					-14.9,
					-51.47,
					-14.82,
					-51.19,
					-14.01,
					-50.96,
					-13.68,
					-50.97,
					-13.25,
					-50.69,
					-12.66,
					-50.55,
					-12.39,
					-50.33,
					-12.36,
					-50.22,
					-12.44,
					-50.15,
					-12.75,
					-50.23,
					-13.01,
					-49.42,
					-12.69,
					-49.3,
					-12.44,
					-49.02,
					-12.69,
					-48.81,
					-12.99,
					-48.73,
					-12.92,
					-48.15,
					-12.98,
					-48.06,
					-13.1,
					-48.05,
					-13.17,
					-47.82,
					-12.99,
					-47.68,
					-13.14,
					-47.51,
					-12.98,
					-47.26,
					-12.71,
					-46.33,
					-12.53,
					-46.28,
					-12.33,
					-46.45,
					-12.04,
					-46.42,
					-11.94,
					-46.29,
					-11.76,
					-46.38,
					-11.64,
					-46.31,
					-11.58,
					-46.5,
					-11.31,
					-46.68,
					-10.85,
					-46.37,
					-10.7,
					-46.4,
					-10.22,
					-45.78,
					-10.25,
					-45.52,
					-10.69,
					-45.25,
					-10.78,
					-45.04,
					-10.76,
					-44.84,
					-10.48,
					-44.44,
					-10.49,
					-44.17,
					-10.36,
					-44,
					-10.03,
					-43.81,
					-9.34,
					-43.89,
					-9.19,
					-43.44,
					-9.3,
					-43.31,
					-9.26,
					-43.1,
					-9.44,
					-42.81,
					-9.45,
					-42.65,
					-9.2,
					-42.35,
					-9.09,
					-42.04,
					-9.13,
					-41.88,
					-8.91,
					-41.82,
					-8.83,
					-41.56,
					-8.6,
					-41.4,
					-8.61,
					-41.06,
					-8.75,
					-40.82,
					-9.07,
					-40.75,
					-9.19,
					-40.59,
					-9.36,
					-40.62,
					-9.28,
					-40.42,
					-8.97,
					-40.29,
					-8.94,
					-40.04,
					-8.73,
					-39.95,
					-8.43,
					-39.45,
					-8.68,
					-38.93,
					-8.68,
					-38.75,
					-8.8,
					-38.64,
					-8.71,
					-38.56,
					-8.76,
					-38.41,
					-8.88,
					-38.36,
					-8.92,
					-38.21,
					-9.33,
					-38.11,
					-9.43,
					-37.91,
					-9.71,
					-37.91,
					-10.08,
					-37.66,
					-10.72,
					-37.7,
					-10.87,
					-38.11,
					-11.17,
					-37.88,
					-11.32,
					-37.88,
					-11.42,
					-37.73,
					-11.35,
					-37.34,
					-11.46,
					-37.25,
					-12.65,
					-37.92,
					-13.1,
					-38.41,
					-13.11,
					-38.57,
					-13.31,
					-38.83,
					-13.65,
					-38.77,
					-13.75,
					-38.84,
					-14.04,
					-38.81,
					-14.71,
					-38.94,
					-15.89,
					-38.75,
					-16.78,
					-39.03,
					-17.31,
					-39.11,
					-17.5,
					-39.06,
					-17.63,
					-38.93,
					-17.81,
					-39.09,
					-17.98,
					-39.03,
					-18.12,
					-39.24,
					-18.05,
					-39.37,
					-18.35,
					-39.55,
					-18.81,
					-39.63,
					-19.4,
					-39.59,
					-19.69,
					-39.7,
					-20.01,
					-40.04,
					-20.68,
					-40.32,
					-20.96,
					-40.68,
					-21.29,
					-40.85,
					-21.53,
					-40.95,
					-22.04,
					-40.88,
					-22.38,
					-41.61,
					-22.59,
					-41.86,
					-22.8,
					-41.67,
					-22.87,
					-41.83,
					-23.11,
					-41.94,
					-23.04,
					-43.12,
					-23.18,
					-43.51,
					-23.32,
					-44.39,
					-23.47,
					-44.56,
					-23.53,
					-44.85,
					-23.49,
					-44.94,
					-23.65,
					-45.01,
					-23.65,
					-45.21,
					-23.79,
					-45,
					-24.04,
					-45.17,
					-24.03,
					-45.48,
					-23.9,
					-45.57,
					-23.92,
					-46.02,
					-24.15,
					-46.21,
					-24.12,
					-46.37,
					-24.21,
					-46.57,
					-24.34,
					-46.65,
					-24.32,
					-46.77,
					-24.96,
					-47.64,
					-25.18,
					-47.75,
					-25.73,
					-48.34,
					-25.99,
					-48.48,
					-26.22,
					-48.38,
					-26.64,
					-48.56,
					-26.74,
					-48.47,
					-26.9,
					-48.51,
					-27.16,
					-48.36,
					-27.25,
					-48.22,
					-27.49,
					-48.24,
					-27.76,
					-48.4
				]
			},
			{
				"points": [
					-18.14,
					-38.62,
					-18.14,
					-38.73,
					-18.05,
					-38.79,
					-17.87,
					-38.7,
					-17.96,
					-38.55,
					-18.14,
					-38.62
				]
			},
			{
				"points": [
					-24.18,
					-45.61,
					-24.16,
					-45.79,
					-23.98,
					-45.73,
					-24.05,
					-45.57,
					-24.18,
					-45.61
				]
			}
		],
		"transitions": [
			[
				1318748400,
				-120,
				[
					"BRST"
				]
			],
			[
				1330239600,
				-180,
				[
					"BRT"
				]
			],
			[
				1350802800,
				-120,
				[
					"BRST"
				]
			],
			[
				1361084400,
				-180,
				[
					"BRT"
				]
			],
			[
				1382252400,
				-120,
				[
					"BRST"
				]
			],
			[
				1392534000,
				-180,
				[
					"BRT"
				]
			],
			[
				1413702000,
				-120,
				[
					"BRST"
				]
			],
			[
				1424588400,
				-180,
				[
					"BRT"
				]
			],
			[
				1445151600,
				-120,
				[
					"BRST"
				]
			],
			[
				1456038000,
				-180,
				[
					"BRT"
				]
			],
			[
				1476601200,
				-120,
				[
					"BRST"
				]
			],
			[
				1487487600,
				-180,
				[
					"BRT"
				]
			],
			[
				1508050800,
				-120,
				[
					"BRST"
				]
			],
			[
				1518937200,
				-180,
				[
					"BRT"
				]
			],
			[
				1540105200,
				-120,
				[
					"BRST"
				]
			],
			[
				1550386800,
				-180,
				[
					"BRT"
				]
			],
			[
				1571554800,
				-120,
				[
					"BRST"
				]
			],
			[
				1581836400,
				-180,
				[
					"BRT"
				]
			],
			[
				1603004400,
				-120,
				[
					"BRST"
				]
			],
			[
				1613890800,
				-180,
				[
					"BRT"
				]
			],
			[
				1634454000,
				-120,
				[
					"BRST"
				]
			],
			[
				1645340400,
				-180,
				[
					"BRT"
				]
			],
			[
				1665903600,
				-120,
				[
					"BRST"
				]
			],
			[
				1677394800,
				-180,
				[
					"BRT"
				]
			],
			[
				1697353200,
				-120,
				[
					"BRST"
				]
			],
			[
				1708239600,
				-180,
				[
					"BRT"
				]
			],
			[
				1729407600,
				-120,
				[
					"BRST"
				]
			],
			[
				1739689200,
				-180,
				[
					"BRT"
				]
			],
			[
				1760857200,
				-120,
				[
					"BRST"
				]
			],
			[
				1771743600,
				-180,
				[
					"BRT"
				]
			],
			[
				1792306800,
				-120,
				[
					"BRST"
				]
			],
			[
				1803193200,
				-180,
				[
					"BRT"
				]
			],
			[
				1823756400,
				-120,
				[
					"BRST"
				]
			],
			[
				1834642800,
				-180,
				[
					"BRT"
				]
			],
			[
				1855206000,
				-120,
				[
					"BRST"
				]
			],
			[
				1866092400,
				-180,
				[
					"BRT"
				]
			],
			[
				1887260400,
				-120,
				[
					"BRST"
				]
			],
			[
				1897542000,
				-180,
				[
					"BRT"
				]
			],
			[
				1918710000,
				-120,
				[
					"BRST"
				]
			],
			[
				1928991600,
				-180,
				[
					"BRT"
				]
			],
			[
				1950159600,
				-120,
				[
					"BRST"
				]
			],
			[
				1960441200,
				-180,
				[
					"BRT"
				]
			],
			[
				1981609200,
				-120,
				[
					"BRST"
				]
			],
			[
				1992495600,
				-180,
				[
					"BRT"
				]
			],
			[
				2013058800,
				-120,
				[
					"BRST"
				]
			],
			[
				2024550000,
				-180,
				[
					"BRT"
				]
			],
			[
				2044508400,
				-120,
				[
					"BRST"
				]
			],
			[
				2055394800,
				-180,
				[
					"BRT"
				]
			],
			[
				2076562800,
				-120,
				[
					"BRST"
				]
			],
			[
				2086844400,
				-180,
				[
					"BRT"
				]
			],
			[
				2108012400,
				-120,
				[
					"BRST"
				]
			],
			[
				2118898800,
				-180,
				[
					"BRT"
				]
			],
			[
				2139462000,
				-120,
				[
					"BRST"
				]
			]
		],
		"name": "America/Sao_Paulo"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-18.52,
					178.16,
					-18.2,
					177.27,
					-17.61,
					176.96,
					-17.48,
					177.02,
					-17.52,
					177.16,
					-17.35,
					177.01,
					-17.18,
					177.03,
					-16.6,
					177.56,
					-16.72,
					177.69,
					-17.27,
					177.26,
					-17.37,
					177.24,
					-17.49,
					177.38,
					-17.27,
					177.78,
					-17.16,
					178.24,
					-17.5,
					178.59,
					-17.47,
					178.71,
					-17.28,
					178.71,
					-17.31,
					178.98,
					-17.39,
					179.08,
					-17.67,
					179.13,
					-17.53,
					179.28,
					-17.78,
					179.53,
					-18.15,
					179.43,
					-18.22,
					179.34,
					-18.07,
					179.14,
					-17.9,
					179.18,
					-17.72,
					178.94,
					-17.89,
					178.77,
					-18.08,
					178.76,
					-18.25,
					178.56,
					-18.34,
					178.26,
					-18.47,
					178.25,
					-18.52,
					178.16
				]
			},
			{
				"points": [
					-17.11,
					179.96,
					-17.06,
					179.83,
					-16.89,
					179.79,
					-17.02,
					179.18,
					-17.15,
					179.21,
					-17.22,
					179.09,
					-17.06,
					179,
					-17.11,
					178.67,
					-16.88,
					178.41,
					-16.94,
					178.33,
					-16.9,
					178.2,
					-16.78,
					178.17,
					-16.65,
					178.41,
					-16.51,
					178.48,
					-16.31,
					179.02,
					-16.19,
					178.98,
					-16.11,
					179.06,
					-16.13,
					179.17,
					-16.23,
					179.21,
					-16.07,
					179.56,
					-16.04,
					180.04,
					-16.14,
					180.1,
					-16.7,
					180.04,
					-16.97,
					180.1,
					-17.11,
					179.96
				]
			},
			{
				"points": [
					-19.31,
					-178.36,
					-19.23,
					-178.67,
					-18.97,
					-178.62,
					-18.95,
					-178.71,
					-19.1,
					-178.79,
					-19.1,
					-178.96,
					-18.94,
					-179.09,
					-18.75,
					-178.9,
					-18.77,
					-178.8,
					-18.88,
					-178.77,
					-18.89,
					-178.76,
					-18.64,
					-178.73,
					-18.53,
					-178.54,
					-18.4,
					-178.59,
					-18.32,
					-178.46,
					-18.46,
					-178.36,
					-18.73,
					-178.41,
					-18.77,
					-178.51,
					-18.89,
					-178.32,
					-19.1,
					-178.29,
					-19.31,
					-178.36
				]
			},
			{
				"points": [
					-17.72,
					-178.7,
					-17.8,
					-178.82,
					-17.7,
					-178.94,
					-17.46,
					-178.8,
					-17.43,
					-179.02,
					-17.58,
					-179.11,
					-17.53,
					-179.25,
					-17.15,
					-179.21,
					-17.05,
					-179.07,
					-17.06,
					-178.87,
					-17.2,
					-178.69,
					-17.32,
					-178.67,
					-17.42,
					-178.77,
					-17.43,
					-178.64,
					-17.52,
					-178.6,
					-17.72,
					-178.7
				]
			}
		],
		"transitions": [
			[
				1319306400,
				780,
				[
					"FJST"
				]
			],
			[
				1327172400,
				720,
				[
					"FJT"
				]
			]
		],
		"name": "Pacific/Fiji"
	},
	{
		"hoverRegion": [
			{
				"points": [
					16.37,
					-24.29,
					16.56,
					-24.48,
					16.49,
					-24.63,
					16.69,
					-24.87,
					16.66,
					-25.01,
					16.83,
					-25.37,
					17.12,
					-25.44,
					17.27,
					-24.97,
					17.02,
					-24.88,
					16.73,
					-24.58,
					16.62,
					-23.92,
					16.45,
					-23.97,
					16.37,
					-24.29
				]
			},
			{
				"points": [
					14.83,
					-23.43,
					14.78,
					-23.5,
					14.83,
					-23.71,
					14.99,
					-23.87,
					15.4,
					-23.84,
					15.4,
					-23.7,
					15.08,
					-23.35,
					14.83,
					-23.43
				]
			},
			{
				"points": [
					14.72,
					-24.63,
					14.69,
					-24.72,
					14.78,
					-24.85,
					15.01,
					-24.8,
					15.13,
					-24.31,
					14.82,
					-24.19,
					14.69,
					-24.38,
					14.83,
					-24.56,
					14.72,
					-24.63
				]
			},
			{
				"points": [
					15.87,
					-22.73,
					15.96,
					-23.05,
					16.31,
					-22.97,
					16.18,
					-22.57,
					16,
					-22.58,
					15.87,
					-22.73
				]
			}
		],
		"transitions": [
			[
				0,
				-60,
				[
					"CVT"
				]
			]
		],
		"name": "Atlantic/Cape_Verde"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-22.33,
					-62.69,
					-22.22,
					-62.73,
					-21.04,
					-62.36,
					-20.53,
					-62.37,
					-20.05,
					-62.03,
					-19.53,
					-61.79,
					-19.18,
					-59.97,
					-19.24,
					-59.07,
					-19.69,
					-58.15,
					-20.19,
					-58.05,
					-20.39,
					-57.89,
					-20.96,
					-57.7,
					-21.25,
					-57.79,
					-21.34,
					-57.74,
					-21.53,
					-57.84,
					-21.67,
					-57.78,
					-22.01,
					-57.85,
					-21.98,
					-57.59,
					-22.07,
					-57.49,
					-22.18,
					-56.85,
					-21.96,
					-56.4,
					-22.17,
					-56.16,
					-22.19,
					-55.78,
					-22.63,
					-55.5,
					-22.96,
					-55.56,
					-23.16,
					-55.41,
					-23.57,
					-55.42,
					-23.86,
					-55.31,
					-23.87,
					-55.07,
					-23.7,
					-54.66,
					-23.82,
					-54.36,
					-24.03,
					-54.18,
					-24.38,
					-54.15,
					-25.18,
					-54.32,
					-25.48,
					-54.5,
					-26.22,
					-54.51,
					-26.68,
					-54.69,
					-26.93,
					-55.03,
					-27.04,
					-55.08,
					-27.09,
					-55.33,
					-27.53,
					-55.66,
					-27.43,
					-56.1,
					-27.71,
					-56.36,
					-27.57,
					-56.6,
					-27.71,
					-56.87,
					-27.57,
					-57.04,
					-27.54,
					-57.54,
					-27.37,
					-58.02,
					-27.4,
					-58.64,
					-27.08,
					-58.74,
					-26.59,
					-58.29,
					-26.12,
					-58.24,
					-25.95,
					-57.98,
					-25.63,
					-57.86,
					-25.51,
					-57.69,
					-25.34,
					-57.76,
					-25.17,
					-57.93,
					-25.05,
					-58.21,
					-25.1,
					-58.35,
					-24.94,
					-58.55,
					-24.71,
					-59.18,
					-24.12,
					-60.07,
					-24.14,
					-60.37,
					-23.89,
					-61.04,
					-23.64,
					-61.24,
					-23.5,
					-61.56,
					-23.1,
					-62.05,
					-22.58,
					-62.34,
					-22.33,
					-62.69
				]
			}
		],
		"transitions": [
			[
				1317542400,
				-180,
				[
					"PYST"
				]
			],
			[
				1333868400,
				-240,
				[
					"PYT"
				]
			],
			[
				1349596800,
				-180,
				[
					"PYST"
				]
			],
			[
				1365922800,
				-240,
				[
					"PYT"
				]
			],
			[
				1381046400,
				-180,
				[
					"PYST"
				]
			],
			[
				1397372400,
				-240,
				[
					"PYT"
				]
			],
			[
				1412496000,
				-180,
				[
					"PYST"
				]
			],
			[
				1428822000,
				-240,
				[
					"PYT"
				]
			],
			[
				1443945600,
				-180,
				[
					"PYST"
				]
			],
			[
				1460271600,
				-240,
				[
					"PYT"
				]
			],
			[
				1475395200,
				-180,
				[
					"PYST"
				]
			],
			[
				1491721200,
				-240,
				[
					"PYT"
				]
			],
			[
				1506844800,
				-180,
				[
					"PYST"
				]
			],
			[
				1523170800,
				-240,
				[
					"PYT"
				]
			],
			[
				1538899200,
				-180,
				[
					"PYST"
				]
			],
			[
				1555225200,
				-240,
				[
					"PYT"
				]
			],
			[
				1570348800,
				-180,
				[
					"PYST"
				]
			],
			[
				1586674800,
				-240,
				[
					"PYT"
				]
			],
			[
				1601798400,
				-180,
				[
					"PYST"
				]
			],
			[
				1618124400,
				-240,
				[
					"PYT"
				]
			],
			[
				1633248000,
				-180,
				[
					"PYST"
				]
			],
			[
				1649574000,
				-240,
				[
					"PYT"
				]
			],
			[
				1664697600,
				-180,
				[
					"PYST"
				]
			],
			[
				1681023600,
				-240,
				[
					"PYT"
				]
			],
			[
				1696147200,
				-180,
				[
					"PYST"
				]
			],
			[
				1713078000,
				-240,
				[
					"PYT"
				]
			],
			[
				1728201600,
				-180,
				[
					"PYST"
				]
			],
			[
				1744527600,
				-240,
				[
					"PYT"
				]
			],
			[
				1759651200,
				-180,
				[
					"PYST"
				]
			],
			[
				1775977200,
				-240,
				[
					"PYT"
				]
			],
			[
				1791100800,
				-180,
				[
					"PYST"
				]
			],
			[
				1807426800,
				-240,
				[
					"PYT"
				]
			],
			[
				1822550400,
				-180,
				[
					"PYST"
				]
			],
			[
				1838876400,
				-240,
				[
					"PYT"
				]
			],
			[
				1854000000,
				-180,
				[
					"PYST"
				]
			],
			[
				1870326000,
				-240,
				[
					"PYT"
				]
			],
			[
				1886054400,
				-180,
				[
					"PYST"
				]
			],
			[
				1902380400,
				-240,
				[
					"PYT"
				]
			],
			[
				1917504000,
				-180,
				[
					"PYST"
				]
			],
			[
				1933830000,
				-240,
				[
					"PYT"
				]
			],
			[
				1948953600,
				-180,
				[
					"PYST"
				]
			],
			[
				1965279600,
				-240,
				[
					"PYT"
				]
			],
			[
				1980403200,
				-180,
				[
					"PYST"
				]
			],
			[
				1996729200,
				-240,
				[
					"PYT"
				]
			],
			[
				2011852800,
				-180,
				[
					"PYST"
				]
			],
			[
				2028178800,
				-240,
				[
					"PYT"
				]
			],
			[
				2043302400,
				-180,
				[
					"PYST"
				]
			],
			[
				2059628400,
				-240,
				[
					"PYT"
				]
			],
			[
				2075356800,
				-180,
				[
					"PYST"
				]
			],
			[
				2091682800,
				-240,
				[
					"PYT"
				]
			],
			[
				2106806400,
				-180,
				[
					"PYST"
				]
			],
			[
				2123132400,
				-240,
				[
					"PYT"
				]
			],
			[
				2138256000,
				-180,
				[
					"PYST"
				]
			]
		],
		"name": "America/Asuncion"
	},
	{
		"hoverRegion": [
			{
				"points": [
					-44.42,
					-175.79,
					-44.44,
					-175.9,
					-44.33,
					-176.04,
					-44.51,
					-176.16,
					-44.53,
					-176.3,
					-44.3,
					-176.5,
					-44.15,
					-176.34,
					-44.22,
					-176.66,
					-43.93,
					-177.02,
					-43.75,
					-176.97,
					-43.67,
					-176.83,
					-43.51,
					-176.9,
					-43.46,
					-176.78,
					-43.6,
					-176.69,
					-43.65,
					-176.12,
					-43.75,
					-176.1,
					-44.12,
					-176.28,
					-44.12,
					-175.95,
					-44.28,
					-175.76,
					-44.42,
					-175.79
				]
			},
			{
				"points": [
					-44.05,
					-175.78,
					-44.01,
					-175.94,
					-43.86,
					-175.89,
					-43.9,
					-175.74,
					-44.05,
					-175.78
				]
			}
		],
		"transitions": [
			[
				1316887200,
				825,
				[
					"CHADT"
				]
			],
			[
				1333216800,
				765,
				[
					"CHAST"
				]
			],
			[
				1348941600,
				825,
				[
					"CHADT"
				]
			],
			[
				1365271200,
				765,
				[
					"CHAST"
				]
			],
			[
				1380391200,
				825,
				[
					"CHADT"
				]
			],
			[
				1396720800,
				765,
				[
					"CHAST"
				]
			],
			[
				1411840800,
				825,
				[
					"CHADT"
				]
			],
			[
				1428170400,
				765,
				[
					"CHAST"
				]
			],
			[
				1443290400,
				825,
				[
					"CHADT"
				]
			],
			[
				1459620000,
				765,
				[
					"CHAST"
				]
			],
			[
				1474740000,
				825,
				[
					"CHADT"
				]
			],
			[
				1491069600,
				765,
				[
					"CHAST"
				]
			],
			[
				1506189600,
				825,
				[
					"CHADT"
				]
			],
			[
				1522519200,
				765,
				[
					"CHAST"
				]
			],
			[
				1538244000,
				825,
				[
					"CHADT"
				]
			],
			[
				1554573600,
				765,
				[
					"CHAST"
				]
			],
			[
				1569693600,
				825,
				[
					"CHADT"
				]
			],
			[
				1586023200,
				765,
				[
					"CHAST"
				]
			],
			[
				1601143200,
				825,
				[
					"CHADT"
				]
			],
			[
				1617472800,
				765,
				[
					"CHAST"
				]
			],
			[
				1632592800,
				825,
				[
					"CHADT"
				]
			],
			[
				1648922400,
				765,
				[
					"CHAST"
				]
			],
			[
				1664042400,
				825,
				[
					"CHADT"
				]
			],
			[
				1680372000,
				765,
				[
					"CHAST"
				]
			],
			[
				1695492000,
				825,
				[
					"CHADT"
				]
			],
			[
				1712426400,
				765,
				[
					"CHAST"
				]
			],
			[
				1727546400,
				825,
				[
					"CHADT"
				]
			],
			[
				1743876000,
				765,
				[
					"CHAST"
				]
			],
			[
				1758996000,
				825,
				[
					"CHADT"
				]
			],
			[
				1775325600,
				765,
				[
					"CHAST"
				]
			],
			[
				1790445600,
				825,
				[
					"CHADT"
				]
			],
			[
				1806775200,
				765,
				[
					"CHAST"
				]
			],
			[
				1821895200,
				825,
				[
					"CHADT"
				]
			],
			[
				1838224800,
				765,
				[
					"CHAST"
				]
			],
			[
				1853344800,
				825,
				[
					"CHADT"
				]
			],
			[
				1869674400,
				765,
				[
					"CHAST"
				]
			],
			[
				1885399200,
				825,
				[
					"CHADT"
				]
			],
			[
				1901728800,
				765,
				[
					"CHAST"
				]
			],
			[
				1916848800,
				825,
				[
					"CHADT"
				]
			],
			[
				1933178400,
				765,
				[
					"CHAST"
				]
			],
			[
				1948298400,
				825,
				[
					"CHADT"
				]
			],
			[
				1964628000,
				765,
				[
					"CHAST"
				]
			],
			[
				1979748000,
				825,
				[
					"CHADT"
				]
			],
			[
				1996077600,
				765,
				[
					"CHAST"
				]
			],
			[
				2011197600,
				825,
				[
					"CHADT"
				]
			],
			[
				2027527200,
				765,
				[
					"CHAST"
				]
			],
			[
				2042647200,
				825,
				[
					"CHADT"
				]
			],
			[
				2058976800,
				765,
				[
					"CHAST"
				]
			],
			[
				2074701600,
				825,
				[
					"CHADT"
				]
			],
			[
				2091031200,
				765,
				[
					"CHAST"
				]
			],
			[
				2106151200,
				825,
				[
					"CHADT"
				]
			],
			[
				2122480800,
				765,
				[
					"CHAST"
				]
			],
			[
				2137600800,
				825,
				[
					"CHADT"
				]
			]
		],
		"name": "Pacific/Chatham"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/hover_regions.json
// module id = 858
// module chunks = 0